export type Maybe<T> = T extends PromiseLike<infer U>
  ? Promise<U | null | undefined>
  : T | null | undefined;
export type InputMaybe<T> = T extends PromiseLike<infer U>
  ? Promise<U | null | undefined>
  : T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt64: BigInt;
  Date: Date;
  DateTime: Date;
  EmailAddress: string;
  GMTOffset:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23;
  GeometryCollection: any;
  JobType: any;
  PhoneNumber: string;
  Polygon: any;
  StringOrInt: string | number;
  Time: Date;
  URL: string;
};

export type AccessDeniedEvent = Event &
  Node & {
    readonly __typename?: "AccessDeniedEvent";
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly subcategory: SupportedEventSubcategoryName;
    readonly userCode?: Maybe<Scalars["String"]>;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

export type AccessDeniedEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export type AccessDoorMutationFailedResponse = {
  readonly __typename?: "AccessDoorMutationFailedResponse";
  readonly error: Error;
  readonly message: Scalars["String"];
};

export type AccessDoorMutationResponse =
  | AccessDoorMutationFailedResponse
  | AccessDoorMutationSuccessResponse;

export type AccessDoorMutationSuccessResponse = {
  readonly __typename?: "AccessDoorMutationSuccessResponse";
  readonly door: Door;
};

export type AccessSiteDoorResponse =
  | FailedToAccessSiteDoorError
  | NotFoundError
  | SiteDoor;

export enum AccessibleType {
  CUSTOMER = "CUSTOMER",
  DEALER = "DEALER",
  SUPERVISOR = "SUPERVISOR",
}

export type ActionSettings = {
  readonly __typename?: "ActionSettings";
  readonly fanMode?: Maybe<ZwaveThermostatFanMode>;
  readonly level?: Maybe<Scalars["Int"]>;
  readonly mode?: Maybe<ZwaveThermostatMode>;
  readonly setpointCooling?: Maybe<Scalars["Float"]>;
  readonly setpointHeating?: Maybe<Scalars["Float"]>;
  readonly status?: Maybe<Scalars["String"]>;
};

export type ActionSettingsInput = {
  readonly fan_mode?: InputMaybe<Scalars["String"]>;
  readonly level?: InputMaybe<Scalars["Int"]>;
  readonly mode?: InputMaybe<Scalars["String"]>;
  readonly setpoint_cooling?: InputMaybe<Scalars["Float"]>;
  readonly setpoint_heating?: InputMaybe<Scalars["Float"]>;
  readonly status?: InputMaybe<Scalars["String"]>;
};

export type ActivateFavoriteErrorResponse = {
  readonly __typename?: "ActivateFavoriteErrorResponse";
  readonly error?: Maybe<Error>;
};

export type ActivateFavoriteResponse =
  | ActivateFavoriteErrorResponse
  | ActivateFavoriteSuccessResponse;

export type ActivateFavoriteSuccessResponse = {
  readonly __typename?: "ActivateFavoriteSuccessResponse";
  readonly system: ControlSystem;
};

export type AddCameraByRtspErrorPayload = {
  readonly __typename?: "AddCameraByRtspErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type AddCameraByRtspInput = {
  readonly hubId: Scalars["Int"];
  readonly make: Scalars["Int"];
  readonly url: Scalars["String"];
};

export type AddCameraByRtspPayload =
  | AddCameraByRtspErrorPayload
  | AddCameraByRtspSuccessPayload;

export type AddCameraByRtspSuccessPayload = {
  readonly __typename?: "AddCameraByRtspSuccessPayload";
  readonly system: ControlSystem;
};

export type AddCardFormatDefaultError = Error & {
  readonly __typename?: "AddCardFormatDefaultError";
  readonly type?: Maybe<ErrorType>;
};

export type AddContactInput = {
  readonly emailAddress?: InputMaybe<Scalars["EmailAddress"]>;
  readonly firstName: Scalars["String"];
  readonly lastName: Scalars["String"];
  readonly phoneNumber?: InputMaybe<Scalars["PhoneNumber"]>;
  readonly userId?: InputMaybe<Scalars["ID"]>;
};

export type AddContactPayload = {
  readonly __typename?: "AddContactPayload";
  readonly contact: Contact;
  readonly contactEdge: ContactEdge;
};

export type AddDealerCentralStationAutomationIntegrationError =
  | InvalidCentralStationCodeError
  | InvalidCredentialsError
  | NotFoundError
  | UnknownError;

export type AddDealerCentralStationAutomationIntegrationErrorResponse = {
  readonly __typename?: "AddDealerCentralStationAutomationIntegrationErrorResponse";
  readonly error: AddDealerCentralStationAutomationIntegrationError;
};

export type AddDealerCentralStationAutomationIntegrationInput = {
  readonly centralStationName: Scalars["String"];
  readonly cmsDealerNumber?: InputMaybe<Scalars["String"]>;
  readonly emergencyContactsEnabled: Scalars["Boolean"];
  readonly password: Scalars["String"];
  readonly systemTestsEnabled: Scalars["Boolean"];
  readonly username: Scalars["String"];
};

export type AddDealerCentralStationAutomationIntegrationResponse =
  | AddDealerCentralStationAutomationIntegrationErrorResponse
  | AddDealerCentralStationAutomationIntegrationSuccessResponse;

export type AddDealerCentralStationAutomationIntegrationSuccessResponse = {
  readonly __typename?: "AddDealerCentralStationAutomationIntegrationSuccessResponse";
  readonly dealer: Dealer;
  readonly integration: CentralStationAutomationIntegration;
};

export type AddHikvisionNvrResponse = {
  readonly __typename?: "AddHikvisionNvrResponse";
  readonly hikvisionNvr: HikvisionNvr;
};

export type AddHolidayDateInput = {
  readonly class: HolidayDateClass;
  readonly date: Scalars["Date"];
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
};

export type AddHolidayDateResponse =
  | FailedToAddHolidayDateError
  | HolidayDateNotPushedToSomeX1sError
  | NotFoundError
  | SiteHolidayDateResponse;

export type AddInstallerMobileCredentialResponse =
  | AddInstallerMobileCredentialSucessResponse
  | FailedToAddInstallerMobileCredentialError;

/** Spelled wrong on purpose to keep the tech app working */
export type AddInstallerMobileCredentialSucessResponse = {
  readonly __typename?: "AddInstallerMobileCredentialSucessResponse";
  readonly customer: Customer;
  readonly myPerson: DealerPerson;
};

export type AddMobileCredentialCardFormatResponse =
  | AddCardFormatDefaultError
  | AddMobileCredentialCardFormatSuccessResponse
  | MaxCardFormatsReachedError
  | NotFoundError
  | UnableToProgram734Error;

export type AddMobileCredentialCardFormatSuccessResponse = {
  readonly __typename?: "AddMobileCredentialCardFormatSuccessResponse";
  readonly cardFormat: CardFormat;
};

export type AddReceiverErrorPayload = {
  readonly __typename?: "AddReceiverErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type AddReceiverInput = {
  readonly automationPrefix: Scalars["String"];
  readonly centralStationAutomationIntegrationId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly ip: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly port: Scalars["Int"];
};

export type AddReceiverPayload =
  | AddReceiverErrorPayload
  | AddReceiverSuccessPayload;

export type AddReceiverSuccessPayload = {
  readonly __typename?: "AddReceiverSuccessPayload";
  readonly dealer?: Maybe<Dealer>;
};

export type AddRuleInput = {
  readonly if: RuleTriggerInput;
  readonly name: Scalars["String"];
  readonly notifications: ReadonlyArray<RuleNotificationRecipientInput>;
  readonly schedule?: InputMaybe<RuleScheduleInput>;
  readonly then: RuleActionInput;
};

export type AddRuleResponse =
  | AlarmPanelIntegrationOutputSelectedError
  | FailedToAddRuleError
  | NotFoundError
  | Rule
  | RuleWouldCauseLoopError;

export type AddSiteCardFormatResponse =
  | AddCardFormatDefaultError
  | AddSiteCardFormatSuccessResponse
  | NotFoundError;

export type AddSiteCardFormatSuccessResponse = {
  readonly __typename?: "AddSiteCardFormatSuccessResponse";
  readonly cardFormat: CardFormat;
  readonly site?: Maybe<Site>;
};

export type AddSiteControlSystemDoorInput = {
  readonly buzzer: Scalars["Boolean"];
  readonly doorForce: Scalars["Boolean"];
  readonly doorPropTime: Scalars["Int"];
  readonly doorSensor: Scalars["Boolean"];
  readonly fireExit: Scalars["Boolean"];
  readonly fireZone: Scalars["Boolean"];
  readonly includeInLockdown: Scalars["Boolean"];
  readonly led: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly osdpOrWiegand: OsdpOrWiegand;
  readonly requestToExit: Scalars["Boolean"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly unlockOnRex: Scalars["Boolean"];
};

export type AddSiteControlSystemDoorResponse =
  | FailedToAddSiteDoorError
  | NotFoundError
  | SiteDoor;

export type AddSiteControlSystemInput = {
  readonly addAsPreProgramming?: InputMaybe<Scalars["Boolean"]>;
  readonly commType?: InputMaybe<ControlSystemCommType>;
  readonly intendedUsage?: InputMaybe<SiteControlSystemIntendedUsage>;
  readonly serialNumber: Scalars["String"];
};

export type AddSiteControlSystemOutputModuleError =
  | FailedToSaveOutputModuleError
  | FailedToSaveOutputsError
  | InvalidInputError
  | NotFoundError
  | UnknownError;

export type AddSiteControlSystemOutputModuleFailureResponse = {
  readonly __typename?: "AddSiteControlSystemOutputModuleFailureResponse";
  readonly error: AddSiteControlSystemOutputModuleError;
};

export type AddSiteControlSystemOutputModuleInput = {
  readonly address: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly outputs: ReadonlyArray<SiteControlOutputInput>;
};

export type AddSiteControlSystemOutputModuleResponse =
  | AddSiteControlSystemOutputModuleFailureResponse
  | AddSiteControlSystemOutputModuleSuccessResponse;

export type AddSiteControlSystemOutputModuleSuccessResponse = {
  readonly __typename?: "AddSiteControlSystemOutputModuleSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly outputModule: SiteOutputModule;
};

export type AddSiteControlSystemResponse =
  | AddSiteControlSystemSuccessResponse
  | ControlSystemHasTooManyDoorsError
  | DuplicateSerialNumberError
  | FailedToAddControlSystemError
  | FailedToSaveOutputsError
  | InitialConnectionFailure
  | NotFoundError
  | PanelNotCheckedInError
  | SerialNumberNotFoundError;

export type AddSiteControlSystemSuccessResponse = {
  readonly __typename?: "AddSiteControlSystemSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly site?: Maybe<Site>;
};

export type AddSiteCredentialInput = {
  readonly active: Scalars["Boolean"];
  readonly deliveryTarget?: InputMaybe<Scalars["String"]>;
  readonly deliveryType?: InputMaybe<DigitalCardDeliveryType>;
  readonly externalNumber: Scalars["String"];
  readonly internalNumber?: InputMaybe<Scalars["String"]>;
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly temporary?: InputMaybe<SitePersonTemporaryInput>;
  readonly type: CredentialType;
};

export type AddSiteDoorScheduleResponse =
  | FailedToCreateScheduleError
  | SiteDoorSchedule
  | SomeDoorsDidNotGetScheduleError;

export type AddSiteGroupInput = {
  readonly areas?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly armablePanelId?: InputMaybe<Scalars["String"]>;
  readonly authenticationType: X1Authorization;
  readonly disarmOnAccess: Scalars["Boolean"];
  readonly doors: ReadonlyArray<Scalars["ID"]>;
  readonly floors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly lockdownOverride: Scalars["Boolean"];
  readonly managerFirst?: InputMaybe<ManagerFirst>;
  readonly name: Scalars["String"];
  readonly swipeToArm: SwipeToArm;
  readonly times?: InputMaybe<ReadonlyArray<SiteGroupTimeInput>>;
};

export type AddSiteGroupResponse = AddSiteGroupSuccessResponse | NotFoundError;

export type AddSiteGroupSuccessResponse = {
  readonly __typename?: "AddSiteGroupSuccessResponse";
  readonly group?: Maybe<SiteGroup>;
  readonly site?: Maybe<Site>;
};

export type AddSiteInput = {
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly cardFormats: ReadonlyArray<NewCardFormatInput>;
  readonly city: Scalars["String"];
  readonly controlSystems: ReadonlyArray<AddSiteControlSystemInput>;
  readonly country: Scalars["String"];
  readonly digitalWatchdogSpectrumEnabled: Scalars["Boolean"];
  readonly dmpDoorbellEnabled: Scalars["Boolean"];
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly hanwhaWaveEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly hikvisionDoorbellEnabled: Scalars["Boolean"];
  readonly hikvisionDoorbellTotal: Scalars["Int"];
  readonly hikvisionNvrEnabled: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly nickname?: InputMaybe<Scalars["String"]>;
  readonly observesDaylightSavingsTime: Scalars["Boolean"];
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly postalCode: Scalars["String"];
  readonly securecomNvrEnabled: Scalars["Boolean"];
  readonly securecomVideoLevel: SecureComVideoLevel;
  readonly showDoors: Scalars["Boolean"];
  readonly showElevators: Scalars["Boolean"];
  readonly showOutputs: Scalars["Boolean"];
  readonly showVideoServices: Scalars["Boolean"];
  readonly state: Scalars["String"];
  readonly timezoneOffset: Scalars["GMTOffset"];
  readonly videoEnabled: Scalars["Boolean"];
  readonly vueDoorbellsCount?: InputMaybe<Scalars["Int"]>;
  readonly vueDoorbellsEnabled?: InputMaybe<Scalars["Boolean"]>;
};

export type AddSiteOutputInput = {
  readonly name: Scalars["String"];
  readonly relayNumber: Scalars["Int"];
};

export type AddSitePersonInput = {
  readonly data: DataInputForAddPerson;
  readonly requestMetaData: RequestMetaData;
  readonly siteId: Scalars["ID"];
  readonly title: Scalars["String"];
};

export type AddSitePersonResponse =
  | AddSitePersonSuccessResponse
  | FailedToAddUserError
  | InvalidInputError
  | NotEnoughMobileCredentialsError
  | NotEnoughtDigitalCredentialsError
  | NotFoundError;

export type AddSitePersonSuccessResponse = {
  readonly __typename?: "AddSitePersonSuccessResponse";
  readonly edge: SitePersonEdge;
  readonly person: CustomerPerson;
};

export type AddSiteReportInput = {
  readonly filters: SiteReportFiltersInput;
  readonly name: Scalars["String"];
  readonly schedule?: InputMaybe<SiteReportScheduleInput>;
};

export type AddSiteReportResponse = AddSiteReportSuccessPayload | NotFoundError;

export type AddSiteReportSuccessPayload = {
  readonly __typename?: "AddSiteReportSuccessPayload";
  readonly report: SiteReport;
  readonly reportEdge: SiteReportEdge;
  readonly site?: Maybe<Site>;
};

export type AddSiteResponse =
  | AddSiteSuccessResponse
  | DuplicateSerialNumberError
  | FailedToAddControlSystemsError
  | FailedToCreateSiteError
  | InitialConnectionFailure
  | InvalidSerialsError
  | NoControlSystemsProvidedError
  | UnsupportedDeviceTypeError;

export type AddSiteScheduleInput = {
  readonly autoUnlockSuppress?: InputMaybe<Scalars["Boolean"]>;
  readonly doors: ReadonlyArray<Scalars["ID"]>;
  readonly endTime: Scalars["String"];
  readonly floors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly friday: Scalars["Boolean"];
  readonly holidayA?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayB?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayC?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly monday: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly temporary?: InputMaybe<SiteDoorScheduleTempInput>;
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type AddSiteSuccessResponse = {
  readonly __typename?: "AddSiteSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly site?: Maybe<Site>;
};

export type AddTagResponse = AddTagSuccessPayload | UnknownError;

export type AddTagSuccessPayload = {
  readonly __typename?: "AddTagSuccessPayload";
  readonly addedTagId: Scalars["ID"];
  readonly status: Scalars["String"];
};

export type AddToVarHubEnabledCamerasListErrorPayload = {
  readonly __typename?: "AddToVarHubEnabledCamerasListErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type AddToVarHubEnabledCamerasListInput = {
  readonly addCamectCameraId?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]>>
  >;
};

export type AddToVarHubEnabledCamerasListPayload =
  | AddToVarHubEnabledCamerasListErrorPayload
  | AddToVarHubEnabledCamerasListSuccessPayload;

export type AddToVarHubEnabledCamerasListSuccessPayload = {
  readonly __typename?: "AddToVarHubEnabledCamerasListSuccessPayload";
  readonly system: ControlSystem;
};

export type AddVarHubErrorPayload = {
  readonly __typename?: "AddVarHubErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type AddVarHubInput = {
  readonly hubName?: InputMaybe<Scalars["String"]>;
  readonly macAddress: Scalars["String"];
  readonly systemId: Scalars["String"];
};

export type AddVarHubPayload = AddVarHubErrorPayload | AddVarHubSuccessPayload;

export type AddVarHubSuccessPayload = {
  readonly __typename?: "AddVarHubSuccessPayload";
  readonly system: ControlSystem;
};

export type AddXvAudioDeviceErrorResponse = {
  readonly __typename?: "AddXvAudioDeviceErrorResponse";
  readonly type: XvAudioDeviceResponseErrors;
};

export type AddXvAudioDeviceInput = {
  readonly deviceType: XvAudioDeviceType;
  readonly ipAddress: Scalars["String"];
  readonly isSiteWide?: InputMaybe<Scalars["Boolean"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly password?: InputMaybe<Scalars["String"]>;
  readonly strobeTimeSeconds?: InputMaybe<Scalars["Int"]>;
  readonly useUdp?: InputMaybe<Scalars["Boolean"]>;
  readonly username?: InputMaybe<Scalars["String"]>;
};

export type AddXvAudioDeviceResponse =
  | AddXvAudioDeviceErrorResponse
  | AddXvAudioDeviceSuccessResponse;

export type AddXvAudioDeviceSuccessResponse = {
  readonly __typename?: "AddXvAudioDeviceSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type AddZwaveNodeFailedResponse = {
  readonly __typename?: "AddZwaveNodeFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type AddZwaveNodeResponse =
  | AddZwaveNodeFailedResponse
  | AddZwaveNodeSuccessResponse;

export type AddZwaveNodeSuccessResponse = {
  readonly __typename?: "AddZwaveNodeSuccessResponse";
  readonly jobNumber: Scalars["String"];
  readonly stage: ZwaveNodeStage;
};

export type AdminEulaInfo = {
  readonly address: Scalars["String"];
  readonly agreement_type: Scalars["String"];
  readonly authorized_representative_name: Scalars["String"];
  readonly authorized_representative_title: Scalars["String"];
  readonly city: Scalars["String"];
  readonly company_name: Scalars["String"];
  readonly duns_number?: InputMaybe<Scalars["String"]>;
  readonly email: Scalars["String"];
  readonly fax_number?: InputMaybe<Scalars["String"]>;
  readonly federal_id_number?: InputMaybe<Scalars["String"]>;
  readonly name_of_designated_point_of_contact: Scalars["String"];
  readonly phone_number: Scalars["String"];
  readonly state_country: Scalars["String"];
  readonly state_country_incorporated_in?: InputMaybe<Scalars["String"]>;
  readonly subscriber: Scalars["String"];
  readonly zip_code: Scalars["String"];
};

export type AlarmPanelIntegrationOutputSelectedError = Error & {
  readonly __typename?: "AlarmPanelIntegrationOutputSelectedError";
  readonly type: ErrorType;
};

export type AllCameras = {
  readonly cameraName?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
};

export enum AllCamerasError {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  RECORD_CLIP_FAILED = "RECORD_CLIP_FAILED",
  UNKNOWN = "UNKNOWN",
}

export type AllCamerasResolveTypes =
  | CamectCamera
  | ScapiCamera
  | ScapiVideoDoorbellCamera
  | VsCamera
  | WebRtcScapiCamera;

export type AllSystemsAppUsersReport = Node & {
  readonly __typename?: "AllSystemsAppUsersReport";
  readonly authorityLevel?: Maybe<Scalars["String"]>;
  readonly email?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly lastLogin?: Maybe<Scalars["String"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly systemNames?: Maybe<Scalars["String"]>;
  readonly userId?: Maybe<Scalars["Int"]>;
};

export type AllSystemsAppUsersReportConnection = {
  readonly __typename?: "AllSystemsAppUsersReportConnection";
  readonly edges: ReadonlyArray<AllSystemsAppUsersReportEdge>;
  readonly nodes: ReadonlyArray<AllSystemsAppUsersReport>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type AllSystemsAppUsersReportEdge = {
  readonly __typename?: "AllSystemsAppUsersReportEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<AllSystemsAppUsersReport>;
};

export type AllSystemsProfilesReport = Node & {
  readonly __typename?: "AllSystemsProfilesReport";
  readonly accessibleAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly accessibleSchedules?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly alarmSilence?: Maybe<Scalars["Boolean"]>;
  readonly antiPassback?: Maybe<Scalars["Boolean"]>;
  readonly arm?: Maybe<Scalars["Boolean"]>;
  readonly armDisarmAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly armedAreas?: Maybe<Scalars["Boolean"]>;
  readonly bypassZones?: Maybe<Scalars["Boolean"]>;
  readonly disarm?: Maybe<Scalars["Boolean"]>;
  readonly displayEvents?: Maybe<Scalars["Boolean"]>;
  readonly doorAccess?: Maybe<Scalars["Boolean"]>;
  readonly doorLockUnlock?: Maybe<Scalars["Boolean"]>;
  readonly easyArmDisarm?: Maybe<Scalars["Boolean"]>;
  readonly extendSchedules?: Maybe<Scalars["Boolean"]>;
  readonly fireDrill?: Maybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly inactiveUserAuditDays?: Maybe<Scalars["String"]>;
  readonly lockdown?: Maybe<Scalars["Boolean"]>;
  readonly lockdownOverride?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly number?: Maybe<Scalars["Int"]>;
  readonly numberOfUsercodes?: Maybe<Scalars["String"]>;
  readonly outputGroup?: Maybe<Scalars["String"]>;
  readonly outputsOnOff?: Maybe<Scalars["Boolean"]>;
  readonly panelId?: Maybe<Scalars["String"]>;
  readonly profiles?: Maybe<Scalars["Boolean"]>;
  readonly rearmDelay?: Maybe<Scalars["String"]>;
  readonly schedules?: Maybe<Scalars["Boolean"]>;
  readonly sensorReset?: Maybe<Scalars["Boolean"]>;
  readonly serviceRequest?: Maybe<Scalars["Boolean"]>;
  readonly setTime?: Maybe<Scalars["Boolean"]>;
  readonly systemName?: Maybe<Scalars["String"]>;
  readonly systemStatus?: Maybe<Scalars["Boolean"]>;
  readonly systemTest?: Maybe<Scalars["Boolean"]>;
  readonly tempCode?: Maybe<Scalars["Boolean"]>;
  readonly useCardPlusPin?: Maybe<Scalars["Boolean"]>;
  readonly useDualAuthority?: Maybe<Scalars["Boolean"]>;
  readonly useSecondLanguage?: Maybe<Scalars["Boolean"]>;
  readonly userCodes?: Maybe<Scalars["Boolean"]>;
  readonly wifiSetup?: Maybe<Scalars["Boolean"]>;
  readonly zoneMonitor?: Maybe<Scalars["Boolean"]>;
  readonly zoneStatus?: Maybe<Scalars["Boolean"]>;
};

export type AllSystemsProfilesReportConnection = {
  readonly __typename?: "AllSystemsProfilesReportConnection";
  readonly edges: ReadonlyArray<AllSystemsProfilesReportEdge>;
  readonly nodes: ReadonlyArray<AllSystemsProfilesReport>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type AllSystemsProfilesReportEdge = {
  readonly __typename?: "AllSystemsProfilesReportEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<AllSystemsProfilesReport>;
};

export enum AllSystemsReportError {
  GENERATE_FAILED = "GENERATE_FAILED",
}

export enum AllowTimeChange {
  NO = "NO",
  SERVER = "SERVER",
  YES = "YES",
}

export type AnalyticalDetectionLine = {
  readonly __typename?: "AnalyticalDetectionLine";
  readonly detectPerson: Scalars["Boolean"];
  readonly detectVehicle: Scalars["Boolean"];
  readonly direction: Scalars["Int"];
  readonly endX: Scalars["Int"];
  readonly endY: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly linkedAlarmZone?: Maybe<Scalars["Int"]>;
  readonly linkedPanelId?: Maybe<Scalars["Int"]>;
  readonly linkedZoneAreaNumber?: Maybe<Scalars["String"]>;
  readonly sensitivity: Scalars["Int"];
  readonly startX: Scalars["Int"];
  readonly startY: Scalars["Int"];
};

export type AnalyticalDetectionLineInput = {
  readonly detectPerson: Scalars["Boolean"];
  readonly detectVehicle: Scalars["Boolean"];
  readonly direction: Scalars["Int"];
  readonly endX: Scalars["Int"];
  readonly endY: Scalars["Int"];
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly linkedAlarmZone?: InputMaybe<Scalars["Int"]>;
  readonly linkedPanelId?: InputMaybe<Scalars["Int"]>;
  readonly linkedZoneAreaNumber?: InputMaybe<Scalars["String"]>;
  readonly sensitivity: Scalars["Int"];
  readonly startX: Scalars["Int"];
  readonly startY: Scalars["Int"];
};

export type AnalyticalDetectionLines = {
  readonly __typename?: "AnalyticalDetectionLines";
  readonly lines: ReadonlyArray<AnalyticalDetectionLine>;
  readonly maxCoordinatesX: Scalars["Int"];
  readonly maxCoordinatesY: Scalars["Int"];
  readonly minCoordinatesX: Scalars["Int"];
  readonly minCoordinatesY: Scalars["Int"];
};

export type AnalyticalDetectionRegion = {
  readonly __typename?: "AnalyticalDetectionRegion";
  readonly coordinates: ReadonlyArray<AnalyticalDetectionRegionCoordinates>;
  readonly detectPackage?: Maybe<Scalars["Boolean"]>;
  readonly detectPerson: Scalars["Boolean"];
  readonly detectVehicle: Scalars["Boolean"];
  readonly direction?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly linkedAlarmZone?: Maybe<Scalars["Int"]>;
  readonly linkedPanelId?: Maybe<Scalars["Int"]>;
  readonly linkedZoneAreaNumber?: Maybe<Scalars["String"]>;
  readonly sensitivity: Scalars["Int"];
};

export type AnalyticalDetectionRegionCoordinates = {
  readonly __typename?: "AnalyticalDetectionRegionCoordinates";
  readonly x: Scalars["Int"];
  readonly y: Scalars["Int"];
};

export type AnalyticalDetectionRegionCoordinatesInput = {
  readonly x: Scalars["Int"];
  readonly y: Scalars["Int"];
};

export type AnalyticalDetectionRegionInput = {
  readonly coordinates: ReadonlyArray<AnalyticalDetectionRegionCoordinatesInput>;
  readonly detectPackage?: InputMaybe<Scalars["Boolean"]>;
  readonly detectPerson: Scalars["Boolean"];
  readonly detectVehicle: Scalars["Boolean"];
  readonly direction?: InputMaybe<Scalars["Int"]>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly linkedAlarmZone?: InputMaybe<Scalars["Int"]>;
  readonly linkedPanelId?: InputMaybe<Scalars["Int"]>;
  readonly linkedZoneAreaNumber?: InputMaybe<Scalars["String"]>;
  readonly sensitivity: Scalars["Int"];
};

export type AnalyticalDetectionRegions = {
  readonly __typename?: "AnalyticalDetectionRegions";
  readonly maxCoordinatesX: Scalars["Int"];
  readonly maxCoordinatesY: Scalars["Int"];
  readonly minCoordinatesX: Scalars["Int"];
  readonly minCoordinatesY: Scalars["Int"];
  readonly regions: ReadonlyArray<AnalyticalDetectionRegion>;
};

export type AppNotification = {
  readonly __typename?: "AppNotification";
  readonly action?: Maybe<Scalars["String"]>;
  readonly autoDismiss?: Maybe<Scalars["Boolean"]>;
  readonly entity?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly link?: Maybe<Scalars["String"]>;
  readonly message?: Maybe<Scalars["String"]>;
  readonly progress?: Maybe<Scalars["Int"]>;
  readonly type: AppNotificationType;
};

export enum AppNotificationType {
  DEFAULT = "DEFAULT",
  ERROR = "ERROR",
  PROGRESS = "PROGRESS",
  SUCCESS = "SUCCESS",
}

export type AppUsersReportRow = {
  readonly __typename?: "AppUsersReportRow";
  readonly authorityLevel?: Maybe<Scalars["String"]>;
  readonly emailAddress?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly lastSignIn?: Maybe<Scalars["String"]>;
  readonly systemNames?: Maybe<Scalars["String"]>;
  readonly userId?: Maybe<Scalars["Int"]>;
};

export type Area = {
  readonly armedStatus: AreaArmedStatusEnum;
  readonly arming: Scalars["Boolean"];
  readonly autoArmEnabled: Scalars["Boolean"];
  readonly autoDisarmEnabled: Scalars["Boolean"];
  readonly badZonesOption: BadZonesOption;
  readonly disarming: Scalars["Boolean"];
  readonly hasChanges: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isArmable: Scalars["Boolean"];
  readonly isDisarmable: Scalars["Boolean"];
  readonly isInAlarm: Scalars["Boolean"];
  readonly isNew: Scalars["Boolean"];
  readonly maxNameLength: Scalars["Int"];
  readonly maxNumber: Scalars["Int"];
  readonly minNumber: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly numberWithName?: Maybe<Scalars["String"]>;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
};

export enum AreaArmedStatusEnum {
  ARMED = "ARMED",
  ARMING = "ARMING",
  DISARMED = "DISARMED",
  DISARMING = "DISARMING",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
}

export type AreaConnection = {
  readonly __typename?: "AreaConnection";
  readonly edges: ReadonlyArray<AreaEdge>;
  readonly maxNumberOfAreas: Scalars["Int"];
  readonly minNumberOfAreas: Scalars["Int"];
  readonly nodes: ReadonlyArray<Area>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type AreaEdge = {
  readonly __typename?: "AreaEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Area>;
};

export type AreaInput = {
  readonly autoArmEnabled: Scalars["Boolean"];
  readonly autoDisarmEnabled: Scalars["Boolean"];
  readonly badZonesOption: BadZonesOption;
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
};

export type AreaProgrammingInput = {
  readonly autoArmEnabled: Scalars["Boolean"];
  readonly autoDisarmEnabled: Scalars["Boolean"];
  readonly badZonesOption: BadZonesOption;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
};

export type ArmMultipleAreasPayload =
  | ArmingError
  | BadZonesError
  | MultipleAreasArmedSuccessPayload;

export type ArmedOrFireZoneError = Error & {
  readonly __typename?: "ArmedOrFireZoneError";
  readonly type?: Maybe<ErrorType>;
};

export enum ArmedStatusEnum {
  ARMED = "ARMED",
  ARMED_ALL = "ARMED_ALL",
  ARMED_AWAY = "ARMED_AWAY",
  ARMED_EVERYTHING = "ARMED_EVERYTHING",
  ARMED_HOME = "ARMED_HOME",
  ARMED_PERIMETER = "ARMED_PERIMETER",
  ARMED_SLEEP = "ARMED_SLEEP",
  ARMED_SOME = "ARMED_SOME",
  ARMING_ALL = "ARMING_ALL",
  ARMING_AWAY = "ARMING_AWAY",
  ARMING_HOME = "ARMING_HOME",
  ARMING_PERIMETER = "ARMING_PERIMETER",
  ARMING_SLEEP = "ARMING_SLEEP",
  DISARMED = "DISARMED",
  DISARMING = "DISARMING",
  DISARMING_ALL = "DISARMING_ALL",
  DISARMING_AWAY = "DISARMING_AWAY",
  DISARMING_EVERYTHING = "DISARMING_EVERYTHING",
  DISARMING_HOME = "DISARMING_HOME",
  DISARMING_PERIMETER = "DISARMING_PERIMETER",
  DISARMING_SLEEP = "DISARMING_SLEEP",
  DISARMING_SOME = "DISARMING_SOME",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
}

export type ArmingError = Error & {
  readonly __typename?: "ArmingError";
  readonly errorCode?: Maybe<Scalars["Int"]>;
  readonly reason?: Maybe<Scalars["String"]>;
  readonly type: ErrorType;
};

export enum ArmingMutationType {
  ALL = "ALL",
  AREA = "AREA",
  AWAY = "AWAY",
  EVERYTHING = "EVERYTHING",
  HOME = "HOME",
  PERIMETER = "PERIMETER",
  SLEEP = "SLEEP",
  STAY = "STAY",
}

export enum AudioTalkDownFilenameType {
  EMERGENCY_WARNING = "EMERGENCY_WARNING",
  GENERIC_INSTRUCTION = "GENERIC_INSTRUCTION",
  LOITERING_WARNING = "LOITERING_WARNING",
  NONE = "NONE",
  TRESPASS_WARNING = "TRESPASS_WARNING",
}

export type AuthenticateError = InvalidLoginCredentialsError | UnknownError;

export type AuthenticateErrorResponse = {
  readonly __typename?: "AuthenticateErrorResponse";
  readonly error: AuthenticateError;
};

export type AuthenticateResponse =
  | AuthenticateErrorResponse
  | AuthenticateSuccessResponse
  | AuthenticateTwoFactorSetupRequiredResponse
  | AuthenticateV4SuccessResponse
  | AuthenticateWithTwoFactorCodeRequiredResponse
  | InitializePasswordChangeSuccessResponse;

export type AuthenticateSuccessResponse = {
  readonly __typename?: "AuthenticateSuccessResponse";
  readonly users: ReadonlyArray<AuthenticateUserPayload>;
};

export type AuthenticateSuccessResponseUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type AuthenticateTwoFactorSetupRequiredResponse = {
  readonly __typename?: "AuthenticateTwoFactorSetupRequiredResponse";
  readonly token?: Maybe<Scalars["String"]>;
};

export type AuthenticateUserPayload = {
  readonly __typename?: "AuthenticateUserPayload";
  readonly authToken: Scalars["String"];
  readonly user: User;
};

export type AuthenticateV4SuccessResponse = {
  readonly __typename?: "AuthenticateV4SuccessResponse";
  readonly rawUser?: Maybe<Scalars["String"]>;
  readonly users: ReadonlyArray<AuthenticatedV4UserPayload>;
};

export type AuthenticateV4SuccessResponseUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type AuthenticateWithTwoFactorCodeRequiredResponse = {
  readonly __typename?: "AuthenticateWithTwoFactorCodeRequiredResponse";
  readonly darkModeLogo: Scalars["String"];
  readonly lightModeLogo: Scalars["String"];
  readonly sanitizedContactInfo: Scalars["String"];
  readonly uuid: Scalars["String"];
  readonly validationMethod: ValidationMethod;
};

export type AuthenticatedV4UserPayload = {
  readonly __typename?: "AuthenticatedV4UserPayload";
  readonly bearerToken: Scalars["String"];
  readonly refreshToken: Scalars["String"];
  readonly user: User;
};

export type AuthorizeDmpUserErrorResponse = {
  readonly __typename?: "AuthorizeDmpUserErrorResponse";
  readonly type?: Maybe<DmpTempUserAuthorizationErrors>;
};

export type AuthorizeDmpUserResponse =
  | AuthorizeDmpUserErrorResponse
  | AuthorizeDmpUserSuccessResponse;

export type AuthorizeDmpUserSuccessResponse = {
  readonly __typename?: "AuthorizeDmpUserSuccessResponse";
  readonly details?: Maybe<DmpTempUserAuthorization>;
};

export type AutoEnrollDefaults = {
  readonly __typename?: "AutoEnrollDefaults";
  readonly activateAtt: Scalars["Boolean"];
  readonly activateVerizon: Scalars["Boolean"];
  readonly firstIpAddress: Scalars["String"];
  readonly firstIpPort?: Maybe<Scalars["Int"]>;
  readonly remoteKey: Scalars["String"];
  readonly secondIpAddress: Scalars["String"];
  readonly secondIpPort?: Maybe<Scalars["Int"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export enum AutoEnrollErrorType {
  FAILED_TO_CHECK_EXISTENCE = "FAILED_TO_CHECK_EXISTENCE",
  FAILED_TO_CREATE = "FAILED_TO_CREATE",
  FAILED_TO_FETCH_DEALER = "FAILED_TO_FETCH_DEALER",
  FAILED_TO_UPDATE = "FAILED_TO_UPDATE",
  UNKNOWN = "UNKNOWN",
}

export type AutoEnrollmentOption = {
  readonly __typename?: "AutoEnrollmentOption";
  readonly blacklisted: Scalars["Boolean"];
  readonly optOut: Scalars["Boolean"];
};

export type AvailableDeviceInformation = {
  readonly __typename?: "AvailableDeviceInformation";
  readonly availableZones: ReadonlyArray<Scalars["Int"]>;
  readonly axNumber: Scalars["String"];
  readonly number: Scalars["Int"];
};

export type AwsCredentials = {
  readonly __typename?: "AwsCredentials";
  readonly awsAccessKey: Scalars["String"];
  readonly awsNetworkStatus: Scalars["String"];
  readonly awsRegion: Scalars["String"];
  readonly awsSecretAccessKey: Scalars["String"];
  readonly awsSessionExpirationTime: Scalars["String"];
  readonly awsSessionToken: Scalars["String"];
  readonly awsSignalingChannelName: Scalars["String"];
};

export type BadPriorityZonesError = Error & {
  readonly __typename?: "BadPriorityZonesError";
  readonly type?: Maybe<ErrorType>;
};

export type BadZone = {
  readonly __typename?: "BadZone";
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
};

export type BadZonesError = Error & {
  readonly __typename?: "BadZonesError";
  readonly badZones: ReadonlyArray<BadZone>;
  readonly reason?: Maybe<Scalars["String"]>;
  readonly type: ErrorType;
};

export enum BadZonesOption {
  BYPASS = "BYPASS",
  FORCE = "FORCE",
  REFUSE = "REFUSE",
}

export enum BadgeOrientation {
  LANDSCAPE = "LANDSCAPE",
  PORTRAIT = "PORTRAIT",
}

export type BadgeTemplate = {
  readonly __typename?: "BadgeTemplate";
  readonly backgroundColor?: Maybe<Scalars["String"]>;
  readonly backgroundImageUrl?: Maybe<Scalars["String"]>;
  readonly baseTemplateType: BaseTemplateType;
  readonly companyImageUrl?: Maybe<Scalars["String"]>;
  readonly customText?: Maybe<Scalars["String"]>;
  readonly databaseId: Scalars["Int"];
  readonly enableBackOfBadge: Scalars["Boolean"];
  readonly field1?: Maybe<FieldName>;
  readonly field1Color?: Maybe<Scalars["String"]>;
  readonly field2?: Maybe<FieldName>;
  readonly field2Color?: Maybe<Scalars["String"]>;
  readonly field3?: Maybe<FieldName>;
  readonly field3Color?: Maybe<Scalars["String"]>;
  readonly field4?: Maybe<FieldName>;
  readonly field4Color?: Maybe<Scalars["String"]>;
  readonly hasSlotPunch: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly includeCompanyLogo: Scalars["Boolean"];
  readonly includeFirstName: Scalars["Boolean"];
  readonly includeLastName: Scalars["Boolean"];
  readonly includeMiddleName: Scalars["Boolean"];
  readonly includePersonPhoto: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly nameColor?: Maybe<Scalars["String"]>;
  readonly orientation: BadgeOrientation;
};

export type BadgeTemplateInput = {
  readonly backgroundColor?: InputMaybe<Scalars["String"]>;
  readonly backgroundImageUrl?: InputMaybe<Scalars["String"]>;
  readonly baseTemplateType: BaseTemplateType;
  readonly companyImageUrl?: InputMaybe<Scalars["String"]>;
  readonly customText?: InputMaybe<Scalars["String"]>;
  readonly databaseId?: InputMaybe<Scalars["Int"]>;
  readonly enableBackOfBadge: Scalars["Boolean"];
  readonly field1?: InputMaybe<FieldName>;
  readonly field1Color?: InputMaybe<Scalars["String"]>;
  readonly field2?: InputMaybe<FieldName>;
  readonly field2Color?: InputMaybe<Scalars["String"]>;
  readonly field3?: InputMaybe<FieldName>;
  readonly field3Color?: InputMaybe<Scalars["String"]>;
  readonly field4?: InputMaybe<FieldName>;
  readonly field4Color?: InputMaybe<Scalars["String"]>;
  readonly hasSlotPunch: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly includeCompanyLogo: Scalars["Boolean"];
  readonly includeFirstName: Scalars["Boolean"];
  readonly includeLastName: Scalars["Boolean"];
  readonly includeMiddleName: Scalars["Boolean"];
  readonly includePersonPhoto: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly nameColor?: InputMaybe<Scalars["String"]>;
  readonly orientation: BadgeOrientation;
};

export type BaseRuleAction = RuleAction & {
  readonly __typename?: "BaseRuleAction";
  readonly type: RuleActionType;
};

export type BaseRuleTrigger = RuleTrigger & {
  readonly __typename?: "BaseRuleTrigger";
  readonly type: RuleTriggerType;
};

export enum BaseTemplateType {
  A = "A",
  B = "B",
}

export type BatchGroupOutputs = {
  readonly __typename?: "BatchGroupOutputs";
  readonly batchJobOutputs?: Maybe<ReadonlyArray<Maybe<BatchJobOutputs>>>;
  readonly groupId?: Maybe<Scalars["Int"]>;
  readonly groupMessage?: Maybe<Scalars["String"]>;
  readonly groupStatus?: Maybe<Scalars["String"]>;
  readonly panelId?: Maybe<Scalars["Int"]>;
  readonly panelName?: Maybe<Scalars["String"]>;
};

export type BatchImportUserCodesSuccessResponse = {
  readonly __typename?: "BatchImportUserCodesSuccessResponse";
  readonly batchGroupId: Scalars["String"];
};

export enum BatchJobGroupStatus {
  ABORT = "ABORT",
  ACQUIRED = "ACQUIRED",
  CREATED = "CREATED",
  DELAYED = "DELAYED",
  FAIL = "FAIL",
  HIJACKED = "HIJACKED",
  NEW = "NEW",
  RUNNING = "RUNNING",
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  UNKNOWN = "UNKNOWN",
}

export type BatchJobOutputs = {
  readonly __typename?: "BatchJobOutputs";
  readonly completedAt?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly jobId?: Maybe<Scalars["Int"]>;
  readonly jobMessage?: Maybe<Scalars["String"]>;
  readonly jobStatus?: Maybe<Scalars["String"]>;
  readonly jobTitle?: Maybe<Scalars["String"]>;
  readonly jobType?: Maybe<Scalars["String"]>;
  readonly jobTypeId?: Maybe<Scalars["Int"]>;
};

export type BatchJobResponse = Node & {
  readonly __typename?: "BatchJobResponse";
  readonly batchGroupId?: Maybe<Scalars["Int"]>;
  readonly batchQueueOutputs?: Maybe<ReadonlyArray<Maybe<BatchQueueOutputs>>>;
  readonly id: Scalars["ID"];
  readonly isComplete?: Maybe<Scalars["Boolean"]>;
  readonly totalBatchQueueOutputs?: Maybe<Scalars["Int"]>;
};

export type BatchQueueMetadata = {
  readonly __typename?: "BatchQueueMetadata";
  readonly batchMessage?: Maybe<Scalars["String"]>;
  readonly batchType?: Maybe<Scalars["String"]>;
  readonly id?: Maybe<Scalars["Int"]>;
  readonly siteFilterIds?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
};

export type BatchQueueOutputs = {
  readonly __typename?: "BatchQueueOutputs";
  readonly batchGroupOutputs?: Maybe<ReadonlyArray<Maybe<BatchGroupOutputs>>>;
  readonly batchQueueId?: Maybe<Scalars["Int"]>;
  readonly batchQueueMetaData?: Maybe<BatchQueueMetadata>;
  readonly batchQueueStatus?: Maybe<Scalars["String"]>;
  readonly errorMessage?: Maybe<Scalars["String"]>;
  readonly isProcessed?: Maybe<Scalars["Boolean"]>;
  readonly siteId?: Maybe<Scalars["Int"]>;
};

export type BeginImportUserCodesResponse =
  | BulkUserCodeImportSystemSnapshot
  | FailedToBeginUserCodeImportBecauseUnknown;

export type BeginX1ImportUserCodesResponse =
  | BatchImportUserCodesSuccessResponse
  | FailedToBeginUserCodeImportBecauseDuplicateInternalNumber
  | FailedToBeginUserCodeImportBecauseExternalNumberAlreadyInUse
  | FailedToBeginUserCodeImportBecauseExternalNumberExceededMaxDigits
  | FailedToBeginUserCodeImportBecauseExternalNumberIsNan
  | FailedToBeginUserCodeImportBecauseGroupNotFound
  | FailedToBeginUserCodeImportBecauseInternalNumberAlreadyInUse
  | FailedToBeginUserCodeImportBecauseInternalNumberExceededMaxDigits
  | FailedToBeginUserCodeImportBecauseInternalNumberInUse
  | FailedToBeginUserCodeImportBecauseInternalNumberIsNan
  | FailedToBeginUserCodeImportBecauseInternalNumberIsNanOrNotMasked
  | FailedToBeginUserCodeImportBecauseInternalNumberNotUnique
  | FailedToBeginUserCodeImportBecauseInternalNumberOutOfRange
  | FailedToBeginUserCodeImportBecauseInvalidCredentialFormat
  | FailedToBeginUserCodeImportBecauseInvalidCredentialValue
  | FailedToBeginUserCodeImportBecauseInvalidCsvTemplate
  | FailedToBeginUserCodeImportBecauseInvalidEmail
  | FailedToBeginUserCodeImportBecauseInvalidEmailAddress
  | FailedToBeginUserCodeImportBecauseInvalidExternalNumber
  | FailedToBeginUserCodeImportBecauseInvalidGroup
  | FailedToBeginUserCodeImportBecauseInvalidGroupName
  | FailedToBeginUserCodeImportBecauseInvalidInternalNumber
  | FailedToBeginUserCodeImportBecauseInvalidPersonId
  | FailedToBeginUserCodeImportBecauseInvalidPin
  | FailedToBeginUserCodeImportBecauseInvalidStatus
  | FailedToBeginUserCodeImportBecauseMaxGroupsExceeded
  | FailedToBeginUserCodeImportBecauseMaxPinLengthExceeded
  | FailedToBeginUserCodeImportBecauseMismatchedNumberCount
  | FailedToBeginUserCodeImportBecauseMissingCredentialValue
  | FailedToBeginUserCodeImportBecauseMissingEmail
  | FailedToBeginUserCodeImportBecauseMissingGroup
  | FailedToBeginUserCodeImportBecauseMissingRequiredField
  | FailedToBeginUserCodeImportBecauseOfflinePanels
  | FailedToBeginUserCodeImportBecauseOperationInvalid
  | FailedToBeginUserCodeImportBecausePersonIdRequiredForOperation
  | FailedToBeginUserCodeImportBecausePersonNotFound
  | FailedToBeginUserCodeImportBecauseTimedOut
  | FailedToBeginUserCodeImportBecauseUnknown;

export enum BellActions {
  NONE = "NONE",
  PULSE = "PULSE",
  STEADY = "STEADY",
  TEMPORAL = "TEMPORAL",
  TEMPORAL_3 = "TEMPORAL_3",
  TEMPORAL_4 = "TEMPORAL_4",
}

export type BellOptions = Node & {
  readonly __typename?: "BellOptions";
  readonly automaticBellTest: Scalars["Boolean"];
  readonly auxiliary1BellAction: BellActions;
  readonly auxiliary2BellAction: BellActions;
  readonly bellCutoffTime: Scalars["Int"];
  readonly bellCutoffTimeMax: Scalars["Int"];
  readonly bellCutoffTimeMin: Scalars["Int"];
  readonly bellOutput: Scalars["String"];
  readonly burglaryBellAction: BellActions;
  readonly carbonMonoxideBellAction: BellActions;
  readonly emergencyBellAction: BellActions;
  readonly fireBellAction: BellActions;
  readonly id: Scalars["ID"];
  readonly nac1SyncProtocol?: Maybe<NacProtocols>;
  readonly nac2SyncProtocol?: Maybe<NacProtocols>;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly panicBellAction: BellActions;
  readonly selectiveSilence?: Maybe<Scalars["Boolean"]>;
  readonly strobe?: Maybe<Scalars["Boolean"]>;
  readonly supervisoryBellAction: BellActions;
  readonly updatedAt: Scalars["String"];
};

export type BellOptionsInput = {
  readonly automaticBellTest: Scalars["Boolean"];
  readonly auxiliary1BellAction: BellActions;
  readonly auxiliary2BellAction: BellActions;
  readonly bellCutoffTime: Scalars["Int"];
  readonly bellOutput: Scalars["String"];
  readonly burglaryBellAction: BellActions;
  readonly carbonMonoxideBellAction: BellActions;
  readonly emergencyBellAction: BellActions;
  readonly fireBellAction: BellActions;
  readonly nac1SyncProtocol?: InputMaybe<NacProtocols>;
  readonly nac2SyncProtocol?: InputMaybe<NacProtocols>;
  readonly panicBellAction: BellActions;
  readonly selectiveSilence?: InputMaybe<Scalars["Boolean"]>;
  readonly strobe?: InputMaybe<Scalars["Boolean"]>;
  readonly supervisoryBellAction: BellActions;
};

export enum BuffErrorTypes {
  FAILED_JOB = "FAILED_JOB",
  FAILED_TO_START_JOB = "FAILED_TO_START_JOB",
  UNKNOWN = "UNKNOWN",
}

export type BulkImportSnapshotToClear = {
  readonly __typename?: "BulkImportSnapshotToClear";
  readonly id: Scalars["ID"];
  readonly snapshotId: Scalars["String"];
};

export type BulkUserCodeImportError = {
  readonly reason: BulkUserCodeImportErrorReason;
};

export type BulkUserCodeImportErrorBecauseDuplicateCode =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseDuplicateCode";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseInvalidAreas =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidAreas";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseInvalidCsv =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidCsv";
    readonly reason: BulkUserCodeImportErrorReason;
  };

export type BulkUserCodeImportErrorBecauseInvalidInternalCode =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidInternalCode";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseInvalidLevel =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidLevel";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseInvalidName =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidName";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseInvalidProfiles =
  BulkUserCodeImportError & {
    readonly __typename?: "BulkUserCodeImportErrorBecauseInvalidProfiles";
    readonly reason: BulkUserCodeImportErrorReason;
    readonly row: Scalars["String"];
  };

export type BulkUserCodeImportErrorBecauseUnknown = BulkUserCodeImportError & {
  readonly __typename?: "BulkUserCodeImportErrorBecauseUnknown";
  readonly reason: BulkUserCodeImportErrorReason;
};

export enum BulkUserCodeImportErrorReason {
  DUPLICATE_CODE = "DUPLICATE_CODE",
  INVALID_AREAS = "INVALID_AREAS",
  INVALID_CSV = "INVALID_CSV",
  INVALID_INTERNAL_NUMBER = "INVALID_INTERNAL_NUMBER",
  INVALID_LEVEL = "INVALID_LEVEL",
  INVALID_NAME = "INVALID_NAME",
  INVALID_PROFILES = "INVALID_PROFILES",
  UNKNOWN = "UNKNOWN",
}

export type BulkUserCodeImportRowFailureResult = {
  readonly __typename?: "BulkUserCodeImportRowFailureResult";
  readonly credential?: Maybe<Scalars["String"]>;
  readonly internalNumber?: Maybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly reason: BulkUserCodeImportRowFailureResultReasons;
  readonly row: Scalars["String"];
};

export enum BulkUserCodeImportRowFailureResultReasons {
  TIMEOUT = "TIMEOUT",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN = "UNKNOWN",
  USER_CODE_IN_USE = "USER_CODE_IN_USE",
}

export type BulkUserCodeImportRowSuccessResult = {
  readonly __typename?: "BulkUserCodeImportRowSuccessResult";
  readonly credential?: Maybe<Scalars["String"]>;
  readonly internalNumber?: Maybe<Scalars["String"]>;
  readonly name: Scalars["String"];
};

export type BulkUserCodeImportSiteSnapshot = BulkUserCodeImportSnapshot &
  Node & {
    readonly __typename?: "BulkUserCodeImportSiteSnapshot";
    readonly error?: Maybe<BulkUserCodeImportError>;
    readonly failures: ReadonlyArray<BulkUserCodeImportRowFailureResult>;
    readonly filename: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly percent: Scalars["Int"];
    readonly site: Site;
    readonly status: BulkUserCodeImportStatus;
    readonly successes: ReadonlyArray<BulkUserCodeImportRowSuccessResult>;
    readonly total: Scalars["Int"];
  };

export type BulkUserCodeImportSnapshot = {
  readonly error?: Maybe<BulkUserCodeImportError>;
  readonly failures: ReadonlyArray<BulkUserCodeImportRowFailureResult>;
  readonly filename: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly percent: Scalars["Int"];
  readonly status: BulkUserCodeImportStatus;
  readonly successes: ReadonlyArray<BulkUserCodeImportRowSuccessResult>;
  readonly total: Scalars["Int"];
};

export enum BulkUserCodeImportStatus {
  /** The import failed. */
  ERROR = "ERROR",
  /** The import is in progress. */
  RUNNING = "RUNNING",
  /** All user codes successfully imported. */
  SUCCESS = "SUCCESS",
  /** The import is complete but one or more user codes failed to import. */
  WARNING = "WARNING",
}

export enum BulkUserCodeImportStatusesIncludedStatusTypes {
  ACTIVE_ONLY = "ACTIVE_ONLY",
  ALL = "ALL",
}

export type BulkUserCodeImportStatusesResponse = {
  readonly __typename?: "BulkUserCodeImportStatusesResponse";
  readonly imports: ReadonlyArray<BulkUserCodeImportSnapshot>;
};

export type BulkUserCodeImportSystemSnapshot = BulkUserCodeImportSnapshot &
  Node & {
    readonly __typename?: "BulkUserCodeImportSystemSnapshot";
    readonly error?: Maybe<BulkUserCodeImportError>;
    readonly failures: ReadonlyArray<BulkUserCodeImportRowFailureResult>;
    readonly filename: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly percent: Scalars["Int"];
    readonly status: BulkUserCodeImportStatus;
    readonly successes: ReadonlyArray<BulkUserCodeImportRowSuccessResult>;
    readonly system: ControlSystem;
    readonly total: Scalars["Int"];
  };

export enum BulkUserCodeImportSystemType {
  DEFAULT = "DEFAULT",
  X1 = "X1",
}

export type BypassZoneFailurePayload = {
  readonly __typename?: "BypassZoneFailurePayload";
  readonly error: UnknownError;
};

export type BypassZonePayload =
  | BypassZoneFailurePayload
  | BypassZoneSuccessPayload;

export type BypassZoneStatusFailurePayload = {
  readonly __typename?: "BypassZoneStatusFailurePayload";
  readonly error: UnknownError;
};

export type BypassZoneStatusPayload =
  | BypassZoneStatusFailurePayload
  | BypassZoneStatusSuccessPayload;

export type BypassZoneStatusSuccessPayload = {
  readonly __typename?: "BypassZoneStatusSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type BypassZoneSuccessPayload = {
  readonly __typename?: "BypassZoneSuccessPayload";
  readonly zone: Zone;
};

export type BypassZonesStatusFailurePayload = {
  readonly __typename?: "BypassZonesStatusFailurePayload";
  readonly error: UnknownError;
};

export type BypassZonesStatusPayload =
  | BypassZonesStatusFailurePayload
  | BypassZonesStatusSuccessPayload;

export type BypassZonesStatusSuccessPayload = {
  readonly __typename?: "BypassZonesStatusSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export enum CidFormat {
  CID = "CID",
  DMP = "DMP",
}

/** In most cases, it is more efficient to get stream details from CamectConnectedCamera rather than the allCameras object. */
export type CamectCamera = AllCameras &
  Node & {
    readonly __typename?: "CamectCamera";
    readonly cameraId?: Maybe<Scalars["String"]>;
    readonly cameraName?: Maybe<Scalars["String"]>;
    readonly cameraStreamUrl?: Maybe<Scalars["String"]>;
    readonly databaseCameraId?: Maybe<Scalars["Int"]>;
    readonly databaseDeviceId?: Maybe<Scalars["Int"]>;
    readonly deviceAuthToken?: Maybe<Scalars["String"]>;
    readonly deviceId?: Maybe<Scalars["String"]>;
    readonly deviceManufacturer?: Maybe<Scalars["String"]>;
    readonly deviceModel?: Maybe<Scalars["String"]>;
    readonly deviceTimeZone?: Maybe<Scalars["String"]>;
    readonly deviceType?: Maybe<Scalars["String"]>;
    readonly generation?: Maybe<Scalars["String"]>;
    readonly hasRedBlueLights: Scalars["Boolean"];
    readonly hasWhiteLights: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isAxis: Scalars["Boolean"];
    readonly panelConnectionEnabled?: Maybe<Scalars["Boolean"]>;
    readonly redBlueLightsOn: Scalars["Boolean"];
    readonly snapshotUrl?: Maybe<Scalars["String"]>;
    readonly streamType?: Maybe<StreamTypeName>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly supportsTalkdown: Scalars["Boolean"];
    readonly whiteLightsOn: Scalars["Boolean"];
  };

export type CamectCameraClipInfo = {
  readonly endTimeStamp?: InputMaybe<Scalars["Int"]>;
  readonly message?: InputMaybe<Scalars["String"]>;
  readonly startTimeStamp?: InputMaybe<Scalars["Int"]>;
};

export type CamectHostPanelIntegrationConfigErrorResponsePayload = {
  readonly __typename?: "CamectHostPanelIntegrationConfigErrorResponsePayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type CamectHostPanelIntegrationConfigResponsePayload =
  | CamectHostPanelIntegrationConfigErrorResponsePayload
  | CamectHostPanelIntegrationConfigSuccessResponsePayload;

export type CamectHostPanelIntegrationConfigSuccessResponsePayload = {
  readonly __typename?: "CamectHostPanelIntegrationConfigSuccessResponsePayload";
  readonly newFormat?: Maybe<Scalars["String"]>;
  readonly oldFormat?: Maybe<Scalars["String"]>;
};

export type CamectPanelIntegrationLogErrorResponsePayload = {
  readonly __typename?: "CamectPanelIntegrationLogErrorResponsePayload";
  readonly message: Scalars["String"];
  readonly type: Scalars["String"];
};

export type CamectPanelIntegrationLogResponsePayload =
  | CamectPanelIntegrationLogErrorResponsePayload
  | CamectPanelIntegrationLogSuccessResponsePayload;

export type CamectPanelIntegrationLogSuccessResponsePayload = {
  readonly __typename?: "CamectPanelIntegrationLogSuccessResponsePayload";
  readonly logLines: ReadonlyArray<Maybe<Scalars["String"]>>;
};

export type CamectPingPanelErrorPayload = {
  readonly __typename?: "CamectPingPanelErrorPayload";
  readonly error?: Maybe<Scalars["String"]>;
};

export type CamectPingPanelResponsePayload =
  | CamectPingPanelErrorPayload
  | CamectPingPanelSuccessPayload;

export type CamectPingPanelSuccessPayload = {
  readonly __typename?: "CamectPingPanelSuccessPayload";
  readonly error?: Maybe<Scalars["String"]>;
  readonly result?: Maybe<Scalars["String"]>;
  readonly success?: Maybe<Scalars["Boolean"]>;
};

export type CameraAndDoorbell = SecureComCamera | VideoDoorbell;

export enum CameraEventsEnabled {
  /** Only record a clip when motion is detected if the panel is armed */
  ARMED = "ARMED",
  /** Never record a clip when motion is detected */
  OFF = "OFF",
  /** Always record a clip when motion is detected */
  ON = "ON",
}

export type CameraOfflineError = Error & {
  readonly __typename?: "CameraOfflineError";
  readonly type?: Maybe<ErrorType>;
};

export type CancelledError = Error & {
  readonly __typename?: "CancelledError";
  readonly type?: Maybe<ErrorType>;
};

export type CannotChangeOutputError = Error & {
  readonly __typename?: "CannotChangeOutputError";
  readonly type?: Maybe<ErrorType>;
};

export type CannotConnectRemotelyError = Error & {
  readonly __typename?: "CannotConnectRemotelyError";
  readonly type?: Maybe<ErrorType>;
};

export type CannotDeleteZonesFromHostPanel = Error & {
  readonly __typename?: "CannotDeleteZonesFromHostPanel";
  readonly type?: Maybe<ErrorType>;
};

export type CannotDisarmError = Error & {
  readonly __typename?: "CannotDisarmError";
  readonly type?: Maybe<ErrorType>;
};

export enum CaptureFormat {
  CID = "CID",
  DD = "DD",
  DMP = "DMP",
  FOUR2 = "FOUR2",
  SIA = "SIA",
}

export type CardFormat = Node & {
  readonly __typename?: "CardFormat";
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly requireSiteCode: Scalars["Boolean"];
  readonly siteCodeLength: Scalars["Int"];
  readonly siteCodePosition: Scalars["Int"];
  readonly siteCodes: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly type: Scalars["Int"];
  readonly updatedAt: Scalars["String"];
  readonly userCodeDigits: Scalars["Int"];
  readonly userCodeLength: Scalars["Int"];
  readonly userCodePosition: Scalars["Int"];
  readonly wiegandLength: Scalars["Int"];
};

export type CardFormatInput = {
  readonly id: Scalars["ID"];
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly number?: InputMaybe<Scalars["String"]>;
  readonly requireSiteCode: Scalars["Boolean"];
  readonly siteCodeLength: Scalars["Int"];
  readonly siteCodePosition: Scalars["Int"];
  readonly siteCodes: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly type?: InputMaybe<Scalars["Int"]>;
  readonly userCodeDigits: Scalars["Int"];
  readonly userCodeLength: Scalars["Int"];
  readonly userCodePosition: Scalars["Int"];
  readonly wiegandLength: Scalars["Int"];
};

export type CentralStationAutomationIntegration = Node & {
  readonly __typename?: "CentralStationAutomationIntegration";
  readonly authorityLevels: ReadonlyArray<ControlSystemCentralStationAutomationIntegrationAuthorityLevel>;
  readonly cmsDealerNumber: Scalars["String"];
  readonly displayedName: Scalars["String"];
  readonly emergencyContactsEnabled: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly phoneTypes: ReadonlyArray<Scalars["String"]>;
  readonly relationships: ReadonlyArray<Scalars["String"]>;
  readonly status: CentralStationAutomationIntegrationStatus;
  readonly systemTestsEnabled: Scalars["Boolean"];
  readonly username: Scalars["String"];
};

export enum CentralStationAutomationIntegrationStatus {
  CONNECTED = "CONNECTED",
  NOT_CONNECTED = "NOT_CONNECTED",
}

export type CentralStationGlobalPasscode = Node & {
  readonly __typename?: "CentralStationGlobalPasscode";
  readonly accessLevel?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isDuress?: Maybe<Scalars["Boolean"]>;
  /** Local store value for validation */
  readonly isValid?: Maybe<Scalars["Boolean"]>;
  readonly order?: Maybe<Scalars["Int"]>;
  readonly passcode: Scalars["String"];
};

export enum CentralStationGlobalPasscodeError {
  BAD_REQUEST = "BAD_REQUEST",
  CONTROL_SYSTEM_NOT_FOUND = "CONTROL_SYSTEM_NOT_FOUND",
  FAILED_TO_SAVE_PASSCODES = "FAILED_TO_SAVE_PASSCODES",
  INTEGRATION_NOT_FOUND = "INTEGRATION_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export type CentralStationIntegrationName = {
  readonly __typename?: "CentralStationIntegrationName";
  readonly displayName: Scalars["String"];
  readonly value: Scalars["String"];
};

export type ChangePasswordError =
  | FailsPasswordStandardsError
  | InvalidPasswordError
  | UnauthorizedError
  | UnknownError;

export type ChangePasswordErrorResponse = {
  readonly __typename?: "ChangePasswordErrorResponse";
  readonly error?: Maybe<ChangePasswordError>;
};

export type ChangePasswordResponse =
  | ChangePasswordErrorResponse
  | ChangePasswordSuccessResponse
  | ChangePasswordSuccessResponseWithBearerToken;

export type ChangePasswordSuccessResponse = {
  readonly __typename?: "ChangePasswordSuccessResponse";
  readonly users: ReadonlyArray<AuthenticateUserPayload>;
};

export type ChangePasswordSuccessResponseUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type ChangePasswordSuccessResponseWithBearerToken = {
  readonly __typename?: "ChangePasswordSuccessResponseWithBearerToken";
  readonly users: ReadonlyArray<AuthenticatedV4UserPayload>;
};

export type ChangePasswordSuccessResponseWithBearerTokenUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type ChangeSiteControlSystemOutputModuleInput = {
  readonly address: Scalars["Int"];
  readonly delete?: InputMaybe<Scalars["Boolean"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly outputs?: InputMaybe<ReadonlyArray<SiteControlOutputInput>>;
};

export type ChangeUniKeyReaderNameResponse =
  | ReaderNameChangeError
  | ReaderNameChangeSuccessResponse;

export type ClaimSystemResponse = {
  readonly __typename?: "ClaimSystemResponse";
  readonly status: Scalars["Int"];
  readonly success: Scalars["Boolean"];
};

export enum ClientApp {
  DEALER_ADMIN = "DEALER_ADMIN",
  TECH_APP = "TECH_APP",
  UNKNOWN = "UNKNOWN",
  VIRTUAL_KEYPAD = "VIRTUAL_KEYPAD",
}

export enum ClientApplication {
  DEALER_ADMIN = "DEALER_ADMIN",
  VIRTUAL_KEYPAD = "VIRTUAL_KEYPAD",
}

export type Clip = Node & {
  readonly __typename?: "Clip";
  readonly contentType?: Maybe<ContentMimeTypes>;
  readonly createdAt: Scalars["String"];
  readonly databaseId: Scalars["Int"];
  readonly downloadUrl?: Maybe<Scalars["String"]>;
  readonly formattedCreatedAt?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly origin?: Maybe<ClipOriginTypes>;
  readonly protected: Scalars["Boolean"];
  readonly thumbnailUrl?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly videoChannelId: Scalars["Int"];
};

export type ClipEdge = {
  readonly __typename?: "ClipEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: Clip;
};

export type ClipInput = {
  readonly databaseId?: InputMaybe<Scalars["Int"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly protected?: InputMaybe<Scalars["Boolean"]>;
  readonly videoChannelId?: InputMaybe<Scalars["Int"]>;
};

export enum ClipOriginTypes {
  MANUAL = "MANUAL",
  MOTION = "MOTION",
  UNKNOWN = "UNKNOWN",
}

export type ClipsConnection = {
  readonly __typename?: "ClipsConnection";
  readonly edges: ReadonlyArray<ClipEdge>;
  readonly nodes: ReadonlyArray<Clip>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export enum ClipsError {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  DELETE_CLIP_FAILED = "DELETE_CLIP_FAILED",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  RECORD_CLIP_FAILED = "RECORD_CLIP_FAILED",
  UNKNOWN = "UNKNOWN",
  UPDATE_CLIP_FAILED = "UPDATE_CLIP_FAILED",
}

export type CloseBarrierOperatorFailedResponse = {
  readonly __typename?: "CloseBarrierOperatorFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type CloseBarrierOperatorResponse =
  | CloseBarrierOperatorFailedResponse
  | CloseBarrierOperatorSuccessResponse;

export type CloseBarrierOperatorSuccessResponse = {
  readonly __typename?: "CloseBarrierOperatorSuccessResponse";
  readonly zwaveBarrierOperator: ZwaveBarrierOperator;
};

export type CombineLoginsError = Error & {
  readonly __typename?: "CombineLoginsError";
  readonly message: Scalars["String"];
  readonly type: ErrorType;
};

export type CombineLoginsPayload = {
  readonly __typename?: "CombineLoginsPayload";
  readonly error?: Maybe<Error>;
  readonly person?: Maybe<Person>;
};

export type CombinedEvent = Event &
  Node & {
    readonly __typename?: "CombinedEvent";
    readonly CorrelatedEvents?: Maybe<ReadonlyArray<Maybe<Event>>>;
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    readonly personId?: Maybe<Scalars["Int"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly subcategory: SupportedEventSubcategoryName;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

export type CombinedEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export type CombinedPersonConnection = {
  readonly __typename?: "CombinedPersonConnection";
  readonly edges: ReadonlyArray<CombinedPersonEdge>;
  readonly nodes: ReadonlyArray<PanelPerson>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type CombinedPersonEdge = {
  readonly __typename?: "CombinedPersonEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<PanelPerson>;
};

export type CommPathProgrammingInput = {
  readonly alarmReports?: InputMaybe<CommunicationPathAlarmReports>;
  readonly alarmSwitchover?: InputMaybe<Scalars["Int"]>;
  readonly apn?: InputMaybe<Scalars["String"]>;
  readonly apn2?: InputMaybe<Scalars["String"]>;
  readonly checkInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly commType: CommunicationPathCommType;
  readonly communicationsUrl?: InputMaybe<Scalars["String"]>;
  readonly doorAccessReports?: InputMaybe<CommunicationPathDoorAccessReports>;
  readonly duplicateAlarms?: InputMaybe<Scalars["Boolean"]>;
  readonly encryptionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly encryptionScheme?: InputMaybe<CommunicationPathEncryptionScheme>;
  readonly failTestHours?: InputMaybe<Scalars["Int"]>;
  readonly failTime?: InputMaybe<Scalars["Int"]>;
  readonly firstPhone?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["Int"];
  readonly openCloseUserReports?: InputMaybe<Scalars["Boolean"]>;
  readonly panicTest?: InputMaybe<Scalars["Boolean"]>;
  readonly protocol?: InputMaybe<CommunicationPathProtocol>;
  readonly receiverPort?: InputMaybe<Scalars["String"]>;
  readonly remoteIP?: InputMaybe<Scalars["String"]>;
  readonly remoteIPv6?: InputMaybe<Scalars["String"]>;
  readonly retryTime?: InputMaybe<Scalars["Int"]>;
  readonly secondLinePrefixFor893A?: InputMaybe<Scalars["String"]>;
  readonly secondPhone?: InputMaybe<Scalars["String"]>;
  readonly sendFail?: InputMaybe<Scalars["Boolean"]>;
  readonly sendPath?: InputMaybe<Scalars["Boolean"]>;
  readonly substitutionCode?: InputMaybe<CommunicationPathSubstitutionCode>;
  readonly supervisoryTroubleReports?: InputMaybe<CommunicationPathSupervisoryTroubleReports>;
  readonly systemInformation?: InputMaybe<Scalars["Boolean"]>;
  readonly testDayOfWeek?: InputMaybe<CommunicationPathDayOfWeek>;
  readonly testFrequencyNumber?: InputMaybe<Scalars["Int"]>;
  readonly testFrequencyUnit?: InputMaybe<CommunicationPathTestFrequencyUnit>;
  readonly testReport?: InputMaybe<CommunicationPathTestReport>;
  readonly testTime?: InputMaybe<Scalars["String"]>;
  readonly transmissionDelay?: InputMaybe<Scalars["Int"]>;
  readonly type: CommunicationPathType;
  readonly use893A?: InputMaybe<Scalars["Boolean"]>;
  readonly useCheckIn?: InputMaybe<CommunicationPathUseCheckIn>;
  readonly useCommUrl?: InputMaybe<Scalars["Boolean"]>;
  readonly useIPv6?: InputMaybe<Scalars["Boolean"]>;
};

export enum CommPathTrouble {
  ALL = "ALL",
  NO = "NO",
  YES = "YES",
}

export type CommandNotExecutedError = Error & {
  readonly __typename?: "CommandNotExecutedError";
  readonly type?: Maybe<ErrorType>;
};

export type Communication = Node & {
  readonly __typename?: "Communication";
  readonly accountNumber: Scalars["String"];
  readonly backupCell: Scalars["Boolean"];
  readonly backupCheckinMinutes?: Maybe<Scalars["Int"]>;
  readonly backupDialer: Scalars["Boolean"];
  readonly backupFailTimeMinutes?: Maybe<Scalars["Int"]>;
  readonly cellApn1: Scalars["String"];
  readonly cellApn2: Scalars["String"];
  readonly cellTestDays: Scalars["Int"];
  readonly cellTestDaysMax: Scalars["Int"];
  readonly cellTestDaysMin: Scalars["Int"];
  readonly checkInMinutes: Scalars["Int"];
  readonly checkInMinutesValidValues: ReadonlyArray<Scalars["Int"]>;
  readonly comType: CommunicationComType;
  readonly dialerTestDays: Scalars["Int"];
  readonly dialerTestDaysMax: Scalars["Int"];
  readonly dialerTestDaysMin: Scalars["Int"];
  readonly encryptionEnabled: Scalars["Boolean"];
  readonly failTime: Scalars["Int"];
  readonly failTimeValidValues: ReadonlyArray<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly netTrouble: Scalars["Boolean"];
  readonly networkTestDays: Scalars["Int"];
  readonly networkTestDaysMax: Scalars["Int"];
  readonly networkTestDaysMin: Scalars["Int"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly receiver1AlarmReports: Scalars["Boolean"];
  readonly receiver1Ip: Scalars["String"];
  readonly receiver1Ip2: Scalars["String"];
  readonly receiver1OpenCloseUserReports: Scalars["Boolean"];
  readonly receiver1Port: Scalars["String"];
  readonly receiver1Port2: Scalars["String"];
  readonly receiver1PrimaryPhoneNumber: Scalars["String"];
  readonly receiver1SecondaryPhoneNumber: Scalars["String"];
  readonly receiver1SupervisoryTroubleReports: Scalars["Boolean"];
  readonly receiver1TestReports: Scalars["Boolean"];
  readonly receiver2AlarmReports: Scalars["Boolean"];
  readonly receiver2Backup: Scalars["Boolean"];
  readonly receiver2Ip: Scalars["String"];
  readonly receiver2Ip2: Scalars["String"];
  readonly receiver2OpenCloseUserReports: Scalars["Boolean"];
  readonly receiver2Port: Scalars["String"];
  readonly receiver2Port2: Scalars["String"];
  readonly receiver2PrimaryPhoneNumber: Scalars["String"];
  readonly receiver2SecondaryPhoneNumber: Scalars["String"];
  readonly receiver2SupervisoryTroubleReports: Scalars["Boolean"];
  readonly receiver2TestReports: Scalars["Boolean"];
  readonly testTime: Scalars["String"];
  readonly transmissionDelay: Scalars["Int"];
  readonly transmissionDelayValidValues: ReadonlyArray<Scalars["Int"]>;
  readonly updatedAt: Scalars["String"];
};

export enum CommunicationComType {
  CELL = "CELL",
  CID = "CID",
  DD = "DD",
  NETWORK = "NETWORK",
  NONE = "NONE",
  WIFI = "WIFI",
}

export type CommunicationInput = {
  readonly accountNumber: Scalars["String"];
  readonly backupCell: Scalars["Boolean"];
  readonly backupCheckinMinutes?: InputMaybe<Scalars["Int"]>;
  readonly backupDialer: Scalars["Boolean"];
  readonly backupFailTimeMinutes?: InputMaybe<Scalars["Int"]>;
  readonly cellApn1?: InputMaybe<Scalars["String"]>;
  readonly cellApn2?: InputMaybe<Scalars["String"]>;
  readonly cellTestDays: Scalars["Int"];
  readonly checkInMinutes: Scalars["Int"];
  readonly comType: CommunicationComType;
  readonly dialerTestDays: Scalars["Int"];
  readonly encryptionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly failTime: Scalars["Int"];
  readonly netTrouble: Scalars["Boolean"];
  readonly networkTestDays: Scalars["Int"];
  readonly receiver1AlarmReports: Scalars["Boolean"];
  readonly receiver1Ip: Scalars["String"];
  readonly receiver1Ip2: Scalars["String"];
  readonly receiver1OpenCloseUserReports: Scalars["Boolean"];
  readonly receiver1Port: Scalars["String"];
  readonly receiver1Port2: Scalars["String"];
  readonly receiver1PrimaryPhoneNumber: Scalars["String"];
  readonly receiver1SecondaryPhoneNumber: Scalars["String"];
  readonly receiver1SupervisoryTroubleReports: Scalars["Boolean"];
  readonly receiver1TestReports: Scalars["Boolean"];
  readonly receiver2AlarmReports: Scalars["Boolean"];
  readonly receiver2Backup: Scalars["Boolean"];
  readonly receiver2Ip: Scalars["String"];
  readonly receiver2Ip2: Scalars["String"];
  readonly receiver2OpenCloseUserReports: Scalars["Boolean"];
  readonly receiver2Port: Scalars["String"];
  readonly receiver2Port2: Scalars["String"];
  readonly receiver2PrimaryPhoneNumber: Scalars["String"];
  readonly receiver2SecondaryPhoneNumber: Scalars["String"];
  readonly receiver2SupervisoryTroubleReports: Scalars["Boolean"];
  readonly receiver2TestReports: Scalars["Boolean"];
  readonly testTime: Scalars["String"];
  readonly transmissionDelay?: InputMaybe<Scalars["Int"]>;
};

export type CommunicationPath = Node & {
  readonly __typename?: "CommunicationPath";
  readonly accountNumber?: Maybe<Scalars["String"]>;
  readonly alarmReports: CommunicationPathAlarmReports;
  readonly alarmSwitchover: Scalars["Int"];
  readonly alarmSwitchoverMax: Scalars["Int"];
  readonly alarmSwitchoverMin: Scalars["Int"];
  readonly apn: Scalars["String"];
  readonly apn2: Scalars["String"];
  readonly checkInMinutes: Scalars["Int"];
  readonly checkInMinutesMax: Scalars["Int"];
  readonly checkInMinutesMin: Scalars["Int"];
  readonly commType: CommunicationPathCommType;
  readonly communicationsUrl?: Maybe<Scalars["String"]>;
  readonly doorAccessReports: CommunicationPathDoorAccessReports;
  readonly duplicateAlarms: Scalars["Boolean"];
  readonly encryptionEnabled: Scalars["Boolean"];
  readonly encryptionScheme: CommunicationPathEncryptionScheme;
  readonly failTestHours: Scalars["Int"];
  readonly failTime: Scalars["Int"];
  readonly failTimeMax: Scalars["Int"];
  readonly failTimeMin: Scalars["Int"];
  readonly firstPhone: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly number: Scalars["Int"];
  readonly openCloseUserReports: Scalars["Boolean"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly panicTest: Scalars["Boolean"];
  readonly protocol: CommunicationPathProtocol;
  readonly receiverPort: Scalars["String"];
  readonly remoteIP: Scalars["String"];
  readonly remoteIPv6: Scalars["String"];
  readonly retryTime: Scalars["Int"];
  readonly retryTimeMax: Scalars["Int"];
  readonly retryTimeMin: Scalars["Int"];
  readonly secondLinePrefixFor893A: Scalars["String"];
  readonly secondPhone: Scalars["String"];
  readonly sendFail: Scalars["Boolean"];
  readonly sendPath: Scalars["Boolean"];
  readonly substitutionCode: CommunicationPathSubstitutionCode;
  readonly supervisoryTroubleReports: CommunicationPathSupervisoryTroubleReports;
  readonly systemInformation?: Maybe<Scalars["Boolean"]>;
  readonly testDayOfWeek: CommunicationPathDayOfWeek;
  readonly testFrequencyNumber: Scalars["Int"];
  readonly testFrequencyNumberMax: Scalars["Int"];
  readonly testFrequencyNumberMin: Scalars["Int"];
  readonly testFrequencyUnit: CommunicationPathTestFrequencyUnit;
  readonly testReport: CommunicationPathTestReport;
  readonly testTime: Scalars["String"];
  readonly transmissionDelay: Scalars["Int"];
  readonly transmissionDelayValidValues: ReadonlyArray<Scalars["Int"]>;
  readonly type: CommunicationPathType;
  readonly updatedAt: Scalars["String"];
  readonly use893A: Scalars["Boolean"];
  readonly useCheckIn: CommunicationPathUseCheckIn;
  readonly useCommUrl?: Maybe<Scalars["Boolean"]>;
  readonly useIPv6: Scalars["Boolean"];
};

export enum CommunicationPathAlarmReports {
  FIRE = "FIRE",
  NO = "NO",
  YES = "YES",
}

export enum CommunicationPathCommType {
  CELL = "CELL",
  CID = "CID",
  DD = "DD",
  NETWORK = "NETWORK",
  WIFI = "WIFI",
}

export enum CommunicationPathDayOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  NONE = "NONE",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum CommunicationPathDoorAccessReports {
  DENY = "DENY",
  NO = "NO",
  YES = "YES",
}

export enum CommunicationPathEncryptionScheme {
  _128_BIT = "_128_BIT",
  _256_BIT = "_256_BIT",
}

export type CommunicationPathInput = {
  readonly alarmReports?: InputMaybe<CommunicationPathAlarmReports>;
  readonly alarmSwitchover?: InputMaybe<Scalars["Int"]>;
  readonly apn?: InputMaybe<Scalars["String"]>;
  readonly apn2?: InputMaybe<Scalars["String"]>;
  readonly checkInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly commType: CommunicationPathCommType;
  readonly communicationsUrl?: InputMaybe<Scalars["String"]>;
  readonly doorAccessReports?: InputMaybe<CommunicationPathDoorAccessReports>;
  readonly duplicateAlarms?: InputMaybe<Scalars["Boolean"]>;
  readonly encryptionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly encryptionScheme?: InputMaybe<CommunicationPathEncryptionScheme>;
  readonly failTestHours?: InputMaybe<Scalars["Int"]>;
  readonly failTime?: InputMaybe<Scalars["Int"]>;
  readonly firstPhone?: InputMaybe<Scalars["String"]>;
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["Int"];
  readonly openCloseUserReports?: InputMaybe<Scalars["Boolean"]>;
  readonly panicTest?: InputMaybe<Scalars["Boolean"]>;
  readonly protocol?: InputMaybe<CommunicationPathProtocol>;
  readonly receiverPort?: InputMaybe<Scalars["String"]>;
  readonly remoteIP?: InputMaybe<Scalars["String"]>;
  readonly remoteIPv6?: InputMaybe<Scalars["String"]>;
  readonly retryTime?: InputMaybe<Scalars["Int"]>;
  readonly secondLinePrefixFor893A?: InputMaybe<Scalars["String"]>;
  readonly secondPhone?: InputMaybe<Scalars["String"]>;
  readonly sendFail?: InputMaybe<Scalars["Boolean"]>;
  readonly sendPath?: InputMaybe<Scalars["Boolean"]>;
  readonly substitutionCode?: InputMaybe<CommunicationPathSubstitutionCode>;
  readonly supervisoryTroubleReports?: InputMaybe<CommunicationPathSupervisoryTroubleReports>;
  readonly systemInformation?: InputMaybe<Scalars["Boolean"]>;
  readonly testDayOfWeek?: InputMaybe<CommunicationPathDayOfWeek>;
  readonly testFrequencyNumber?: InputMaybe<Scalars["Int"]>;
  readonly testFrequencyUnit?: InputMaybe<CommunicationPathTestFrequencyUnit>;
  readonly testReport?: InputMaybe<CommunicationPathTestReport>;
  readonly testTime?: InputMaybe<Scalars["String"]>;
  readonly transmissionDelay?: InputMaybe<Scalars["Int"]>;
  readonly type: CommunicationPathType;
  readonly use893A?: InputMaybe<Scalars["Boolean"]>;
  readonly useCheckIn?: InputMaybe<CommunicationPathUseCheckIn>;
  readonly useCommUrl?: InputMaybe<Scalars["Boolean"]>;
  readonly useIPv6?: InputMaybe<Scalars["Boolean"]>;
};

export enum CommunicationPathProtocol {
  TCP = "TCP",
  UDP = "UDP",
}

export enum CommunicationPathSubstitutionCode {
  NO = "NO",
  SHARED = "SHARED",
  YES = "YES",
}

export enum CommunicationPathSupervisoryTroubleReports {
  FIRE = "FIRE",
  NO = "NO",
  YES = "YES",
}

export enum CommunicationPathTestFrequencyUnit {
  DAYS = "DAYS",
  HOURS = "HOURS",
}

export enum CommunicationPathTestReport {
  DEFER = "DEFER",
  NO = "NO",
  YES = "YES",
}

export enum CommunicationPathType {
  BACKUP = "BACKUP",
  PRIMARY = "PRIMARY",
}

export enum CommunicationPathUseCheckIn {
  ADAPTIVE = "ADAPTIVE",
  ADAPTIVE3 = "ADAPTIVE3",
  NO = "NO",
  RANDOM = "RANDOM",
  YES = "YES",
}

export type ConfigData = {
  readonly __typename?: "ConfigData";
  readonly doorNumbers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly endDate?: Maybe<Scalars["String"]>;
  readonly eventTypes?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
  readonly outputNumbers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly startDate?: Maybe<Scalars["String"]>;
  readonly subcategoryIds?: Maybe<Scalars["String"]>;
  readonly systemIds?: Maybe<ReadonlyArray<Scalars["Int"]>>;
  readonly userNumbers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly zoneNumbers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
};

export type ConfigDataInput = {
  readonly doorNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  readonly endDate: Scalars["String"];
  readonly eventTypes?: InputMaybe<ReadonlyArray<Scalars["String"]>>;
  readonly outputNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  readonly startDate: Scalars["String"];
  readonly subcategoryIds?: InputMaybe<Scalars["String"]>;
  readonly systemIds: ReadonlyArray<Scalars["Int"]>;
  readonly userNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  readonly zoneNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
};

export type ConfigureTwoFactorSettingsError =
  | InvalidPhoneNumberError
  | UnauthorizedError
  | UnknownError;

export type ConfigureTwoFactorSettingsErrorResponse = {
  readonly __typename?: "ConfigureTwoFactorSettingsErrorResponse";
  readonly error: ConfigureTwoFactorSettingsError;
};

export type ConfigureTwoFactorSettingsNoActionRequiredResponse = {
  readonly __typename?: "ConfigureTwoFactorSettingsNoActionRequiredResponse";
  readonly twoFactorSettings: TwoFactorSettings;
};

export type ConfigureTwoFactorSettingsResponse =
  | ConfigureTwoFactorSettingsErrorResponse
  | ConfigureTwoFactorSettingsNoActionRequiredResponse
  | ConfigureTwoFactorSettingsTwoFactorCodeRequiredResponse;

export type ConfigureTwoFactorSettingsTwoFactorCodeRequiredResponse = {
  readonly __typename?: "ConfigureTwoFactorSettingsTwoFactorCodeRequiredResponse";
  readonly darkModeLogo: Scalars["String"];
  readonly lightModeLogo: Scalars["String"];
  readonly sanitizedContactInfo: Scalars["String"];
  readonly uuid: Scalars["String"];
  readonly validationMethod: ValidationMethod;
};

export type ConfirmJobFailedResponse = {
  readonly __typename?: "ConfirmJobFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type ConfirmJobResponse =
  | ConfirmJobFailedResponse
  | ConfirmJobSuccessResponse;

export type ConfirmJobSuccessResponse = {
  readonly __typename?: "ConfirmJobSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly stage: ZwaveNodeStage;
};

export enum ConnectionStatus {
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
}

export type ConnectionTimeoutError = Error & {
  readonly __typename?: "ConnectionTimeoutError";
  readonly type?: Maybe<ErrorType>;
};

export type ConnectionUnsupportedError = Error & {
  readonly __typename?: "ConnectionUnsupportedError";
  readonly type?: Maybe<ErrorType>;
};

export type Contact = Node & {
  readonly __typename?: "Contact";
  readonly emailAddress: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly fullName: Scalars["String"];
  readonly hasUnsubscribedFromEmails: Scalars["Boolean"];
  readonly hasUnsubscribedFromTexts: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly lastName: Scalars["String"];
  readonly phoneNumber: Scalars["PhoneNumber"];
  readonly resubscribePhoneNumber?: Maybe<Scalars["PhoneNumber"]>;
  readonly user?: Maybe<User>;
};

export type ContactConnection = {
  readonly __typename?: "ContactConnection";
  readonly edges: ReadonlyArray<ContactEdge>;
  readonly nodes: ReadonlyArray<Contact>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ContactEdge = {
  readonly __typename?: "ContactEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Contact>;
};

export enum ContentMimeTypes {
  AAC = "AAC",
  AVI = "AVI",
  AVIF = "AVIF",
  BIN = "BIN",
  BMP = "BMP",
  CSS = "CSS",
  CSV = "CSV",
  DOC = "DOC",
  GIF = "GIF",
  GZ = "GZ",
  HTML = "HTML",
  JPEG = "JPEG",
  JS = "JS",
  JSON = "JSON",
  MP3 = "MP3",
  MP4 = "MP4",
  MPEG = "MPEG",
  OGA = "OGA",
  OGV = "OGV",
  OGX = "OGX",
  PDF = "PDF",
  PNG = "PNG",
  RTF = "RTF",
  SVG = "SVG",
  TIFF = "TIFF",
  TS = "TS",
  TXT = "TXT",
  UNKNOWN = "UNKNOWN",
  WAV = "WAV",
  WEBA = "WEBA",
  WEBM = "WEBM",
  WEBP = "WEBP",
  XHTML = "XHTML",
  XLS = "XLS",
  XLSX = "XLSX",
  XML = "XML",
}

export type ControlSystem = Node & {
  readonly __typename?: "ControlSystem";
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly allCameras: ReadonlyArray<AllCameras>;
  readonly allPanels: ReadonlyArray<Panel>;
  readonly analyticsVideoEnabled: Scalars["Boolean"];
  readonly areas: AreaConnection;
  readonly armedStatus: ArmedStatusEnum;
  readonly armingAll: Scalars["Boolean"];
  readonly armingAllAreas: Scalars["Boolean"];
  readonly armingAway: Scalars["Boolean"];
  readonly armingHome: Scalars["Boolean"];
  readonly armingPerimeter: Scalars["Boolean"];
  readonly armingSleep: Scalars["Boolean"];
  readonly badgeTemplates: ReadonlyArray<Maybe<BadgeTemplate>>;
  readonly billingInformation?: Maybe<Scalars["String"]>;
  readonly capabilities: PanelCapabilities;
  readonly centralStationAutomationIntegration?: Maybe<ControlSystemCentralStationAutomationIntegration>;
  readonly city: Scalars["String"];
  readonly closingCheckEnabled: Scalars["Boolean"];
  readonly combinedHistoryConnection: ControlSystemCombinedHistoryConnection;
  /** @deprecated Prefer panelPersonsListConnection instead */
  readonly combinedPersonsConnection: CombinedPersonConnection;
  readonly commType?: Maybe<Scalars["String"]>;
  readonly controlSystemGroups: ReadonlyArray<ControlSystemGroup>;
  readonly country: Scalars["String"];
  readonly currentPersonCan: PersonCan;
  readonly customer: Customer;
  readonly customerDatabaseId: Scalars["Int"];
  readonly databaseId: Scalars["Int"];
  readonly dealerAccess?: Maybe<DealerAccess>;
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly digitalWatchdogCameras: ReadonlyArray<DigitalWatchdogCamera>;
  readonly disarmingAllAreas: Scalars["Boolean"];
  readonly dmpTempUserAuthorization?: Maybe<DmpTempUserAuthorization>;
  readonly doorsConnection?: Maybe<ControlSystemDoorsConnection>;
  readonly eagleEyeBridge?: Maybe<EagleEyeBridge>;
  readonly eagleEyeBridgeVideoChannel?: Maybe<EagleEyeBridgeVideoChannel>;
  readonly eagleEyeBridges: ReadonlyArray<EagleEyeBridge>;
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly eventBufferReports: ReadonlyArray<PanelEventBufferReport>;
  readonly fetchingArmingStatus: Scalars["Boolean"];
  readonly groupsConnection: GroupsConnection;
  readonly hanwhaNvrs: ReadonlyArray<HanwhaNvr>;
  readonly hasDisarmInactivity: Scalars["Boolean"];
  readonly hasDoorAccessDeniedSempros: Scalars["Boolean"];
  readonly hasDoorAccessGrantedSempros: Scalars["Boolean"];
  readonly hasDoors: Scalars["Boolean"];
  readonly hasLegacyTempUser: Scalars["Boolean"];
  readonly hasZoneInactivity: Scalars["Boolean"];
  readonly hikvisionNvr?: Maybe<HikvisionNvr>;
  readonly hikvisionNvrVideoChannel?: Maybe<HikvisionNvrVideoChannel>;
  readonly hikvisionNvrs: ReadonlyArray<HikvisionNvr>;
  readonly holidayDates: ReadonlyArray<Maybe<HolidayDate>>;
  readonly id: Scalars["ID"];
  readonly initialConnectionStatus: InitialConnectionStatus;
  readonly installationType?: Maybe<Scalars["String"]>;
  readonly installedAt: Scalars["String"];
  readonly invalidCodeResolvedEventIds?: Maybe<
    ReadonlyArray<Maybe<Scalars["String"]>>
  >;
  readonly isAPSystem: Scalars["Boolean"];
  readonly isAreaSystem: Scalars["Boolean"];
  readonly isArmed: Scalars["Boolean"];
  readonly isBillingControlSystem: Scalars["Boolean"];
  readonly isCellComEx: Scalars["Boolean"];
  readonly isCellComSl: Scalars["Boolean"];
  readonly isDSC: Scalars["Boolean"];
  readonly isDualCom: Scalars["Boolean"];
  readonly isDualComSerial: Scalars["Boolean"];
  readonly isECP: Scalars["Boolean"];
  readonly isHASystem: Scalars["Boolean"];
  readonly isHSAGSystem: Scalars["Boolean"];
  readonly isHSASystem: Scalars["Boolean"];
  readonly isIComSl: Scalars["Boolean"];
  readonly isInAlarm: Scalars["Boolean"];
  readonly isMiniCellCom: Scalars["Boolean"];
  readonly isSingleAreaSystem: Scalars["Boolean"];
  readonly isTMSentry: Scalars["Boolean"];
  readonly isTakeoverPanel: Scalars["Boolean"];
  readonly isVideoOnly: Scalars["Boolean"];
  readonly isX1: Scalars["Boolean"];
  readonly isX1AlarmPanel?: Maybe<Scalars["Boolean"]>;
  readonly isXf: Scalars["Boolean"];
  readonly isXf6_100: Scalars["Boolean"];
  readonly isXf6_500: Scalars["Boolean"];
  readonly isXr: Scalars["Boolean"];
  readonly isXr150: Scalars["Boolean"];
  readonly isXr350: Scalars["Boolean"];
  readonly isXr550: Scalars["Boolean"];
  readonly isXt: Scalars["Boolean"];
  readonly isXt30: Scalars["Boolean"];
  readonly isXt30L: Scalars["Boolean"];
  readonly isXt50: Scalars["Boolean"];
  readonly isXt50L: Scalars["Boolean"];
  readonly isXt75: Scalars["Boolean"];
  readonly isXtl: Scalars["Boolean"];
  readonly isXtlN: Scalars["Boolean"];
  readonly isXtlPlus: Scalars["Boolean"];
  readonly isXtlW: Scalars["Boolean"];
  readonly maxAreas: Scalars["Int"];
  readonly maxProfiles: Scalars["Int"];
  readonly maxSchedulesPerDoor: Scalars["Int"];
  readonly maxTimeSchedules: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly newProfile?: Maybe<Profile>;
  readonly newServiceRequest?: Maybe<NewServiceRequest>;
  readonly nickname?: Maybe<Scalars["String"]>;
  readonly observesDaylightSavingsTime: Scalars["Boolean"];
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly openEyeNvr?: Maybe<OpenEyeNvr>;
  readonly openEyeNvrVideoChannel?: Maybe<OpenEyeNvrVideoChannel>;
  readonly openEyeNvrs: ReadonlyArray<OpenEyeNvr>;
  readonly originalProfile?: Maybe<Profile>;
  /** Tracked outputs only */
  readonly outputsConnection: ControlSystemOutputsConnection;
  readonly panel: Panel;
  readonly panelPersonsListConnection: PanelPersonsListConnection;
  /** @deprecated Prefer using combinedPersonsConnection */
  readonly personsConnection: ControlSystemPersonConnection;
  readonly postalCode: Scalars["String"];
  readonly preProgramStatus?: Maybe<PreProgramStatus>;
  readonly primaryInstallerEmailAddress?: Maybe<Scalars["String"]>;
  readonly primaryInstallerFirstName?: Maybe<Scalars["String"]>;
  readonly primaryInstallerLastName?: Maybe<Scalars["String"]>;
  readonly profilesConnection: ProfilesConnection;
  readonly quickDoorbells: QuickDoorbell;
  readonly realTimeEventsEnabled: Scalars["Boolean"];
  readonly requiresUserCode: Scalars["Boolean"];
  readonly salesPersonEmailAddress?: Maybe<Scalars["String"]>;
  readonly salesPersonFirstName?: Maybe<Scalars["String"]>;
  readonly salesPersonLastName?: Maybe<Scalars["String"]>;
  readonly schedules: ReadonlyArray<Schedule>;
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly secureComCameras: ReadonlyArray<SecureComCamera>;
  readonly secureComNvr?: Maybe<SecureComNvr>;
  readonly secureComNvrVideoChannel?: Maybe<SecureComNvrVideoChannel>;
  readonly secureComNvrs: ReadonlyArray<SecureComNvr>;
  readonly securityPanelPersonsListConnection: SecurityPanelPersonsListConnection;
  readonly sendCodesToLocks: SendCodesToLocks;
  readonly sensorActivityEnabled: Scalars["Boolean"];
  readonly sensorActivityZones: ReadonlyArray<Zone>;
  readonly servicesManager: ServicesManager;
  readonly sharedClientConfiguration?: Maybe<SharedClientConfiguration>;
  readonly sim1Carrier?: Maybe<Scalars["String"]>;
  readonly sim1CommAddress?: Maybe<Scalars["String"]>;
  readonly sim1Identifier?: Maybe<Scalars["String"]>;
  readonly sim2Carrier?: Maybe<Scalars["String"]>;
  readonly sim2CommAddress?: Maybe<Scalars["String"]>;
  readonly sim2Identifier?: Maybe<Scalars["String"]>;
  readonly singlePersonConnection: SingleCombinedPersonConnection;
  readonly site?: Maybe<Site>;
  readonly state: Scalars["String"];
  readonly supportedEventTypes: ReadonlyArray<SupportedEventType>;
  readonly supportsActiveUserCodes: Scalars["Boolean"];
  readonly supportsArming: Scalars["Boolean"];
  readonly supportsBurglaryBellOutput: Scalars["Boolean"];
  readonly supportsCardPlusPin: Scalars["Boolean"];
  readonly supportsDualAuthority: Scalars["Boolean"];
  readonly supportsEditingEcpMasterUser: Scalars["Boolean"];
  readonly supportsOpenClosingReports: Scalars["Boolean"];
  readonly supportsPrivateDoors: Scalars["Boolean"];
  readonly supportsPushNotifications: Scalars["Boolean"];
  readonly supportsSchedules: Scalars["Boolean"];
  readonly supportsSempro: Scalars["Boolean"];
  readonly supportsSendCodesToLocks: Scalars["Boolean"];
  readonly supportsTwoManRule: Scalars["Boolean"];
  readonly supportsZwave: Scalars["Boolean"];
  readonly systemStatuses?: Maybe<SystemStatuses>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly templatePreProgrammingJobStatus?: Maybe<Scalars["String"]>;
  readonly thirdPartyVideoEnabled: Scalars["Boolean"];
  readonly timezoneOffset: Scalars["String"];
  readonly trackedOutputsConnection: ControlSystemOutputsConnection;
  readonly trafficCountEnabled: Scalars["Boolean"];
  readonly univiewEnabled?: Maybe<Scalars["Boolean"]>;
  readonly userCanBypassZones: Scalars["Boolean"];
  readonly userCodeDigits: UserNumberRange;
  readonly varConnectedCameras: ReadonlyArray<VarConnectedCamera>;
  readonly varEnabled?: Maybe<Scalars["Boolean"]>;
  readonly varHubDetectionRegionZoneNumberMax?: Maybe<Scalars["Int"]>;
  readonly varHubDetectionRegionZoneNumberMin?: Maybe<Scalars["Int"]>;
  readonly varHubs: ReadonlyArray<VarHub>;
  /** @deprecated Replaced with VideoAction */
  readonly varVideoActions: ReadonlyArray<VarVideoAction>;
  /** @deprecated Replaced with VideoAction */
  readonly varVideoActionsConnection?: Maybe<ControlSystemVarVideoActionsConnection>;
  readonly videoActions: ReadonlyArray<Maybe<VideoAction>>;
  readonly videoActionsConnection?: Maybe<ControlSystemVideoActionsConnection>;
  readonly videoChannel?: Maybe<VideoChannel>;
  readonly videoChannelsConnection: ControlSystemVideoChannelConnection;
  readonly videoDoorbells: ReadonlyArray<Maybe<VideoDoorbell>>;
  readonly videoEnabled: Scalars["Boolean"];
  readonly videoVerificationUrl?: Maybe<Scalars["String"]>;
  readonly vkSystemDisplayName: Scalars["String"];
  readonly vkSystemUserListConnection: VkSystemUserListConnection;
  readonly vueCamerasCount: Scalars["Int"];
  readonly vueCamerasEnabled: Scalars["Boolean"];
  readonly vueDoorbellsCount: Scalars["Int"];
  readonly vueDoorbellsEnabled: Scalars["Boolean"];
  readonly wifiSetupEnabled: Scalars["Boolean"];
  readonly xvAudioDevices: ReadonlyArray<Maybe<XvAudioDevice>>;
  readonly zoneStatuses: ReadonlyArray<CurrentZoneStatus>;
  readonly zones: ReadonlyArray<Zone>;
  readonly zwaveNodesConnection: ControlSystemZwaveNodesConnection;
};

export type ControlSystemAreasArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemCombinedHistoryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  animalDetected?: InputMaybe<Scalars["Boolean"]>;
  before?: InputMaybe<Scalars["ID"]>;
  cameraNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  doorNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]>>>;
  endDate?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  includeClips?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  motionDetected?: InputMaybe<Scalars["Boolean"]>;
  objectDetected?: InputMaybe<Scalars["Boolean"]>;
  packageDetected?: InputMaybe<Scalars["Boolean"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  pageSize?: InputMaybe<Scalars["Int"]>;
  personDetected?: InputMaybe<Scalars["Boolean"]>;
  personId?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  searchText?: InputMaybe<Scalars["String"]>;
  sort?: InputMaybe<SortInput>;
  startDate?: InputMaybe<Scalars["String"]>;
  subcategoryIds?: InputMaybe<
    ReadonlyArray<InputMaybe<SupportedEventSubcategoryName>>
  >;
  vehicleDetected?: InputMaybe<Scalars["Boolean"]>;
};

export type ControlSystemCombinedPersonsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemDigitalWatchdogCameraArgs = {
  id: Scalars["ID"];
};

export type ControlSystemDoorsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
  trackedOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type ControlSystemEagleEyeBridgeArgs = {
  id: Scalars["ID"];
};

export type ControlSystemEagleEyeBridgeVideoChannelArgs = {
  id: Scalars["ID"];
};

export type ControlSystemGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemHikvisionNvrArgs = {
  id: Scalars["ID"];
};

export type ControlSystemHikvisionNvrVideoChannelArgs = {
  id: Scalars["ID"];
};

export type ControlSystemNewServiceRequestArgs = {
  dealerId: Scalars["ID"];
};

export type ControlSystemOpenEyeNvrArgs = {
  id: Scalars["ID"];
};

export type ControlSystemOpenEyeNvrVideoChannelArgs = {
  id: Scalars["ID"];
};

export type ControlSystemOutputsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemPanelPersonsListConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemPersonsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  excludeManagedInAdmin?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemSecureComCameraArgs = {
  id: Scalars["ID"];
};

export type ControlSystemSecureComNvrArgs = {
  id: Scalars["ID"];
};

export type ControlSystemSecureComNvrVideoChannelArgs = {
  id: Scalars["ID"];
};

export type ControlSystemSecurityPanelPersonsListConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemSinglePersonConnectionArgs = {
  globalSystemId: Scalars["ID"];
  id?: InputMaybe<Scalars["Int"]>;
  userType?: InputMaybe<SinglePersonUserType>;
};

export type ControlSystemTrackedOutputsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemVarVideoActionsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemVideoActionsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemVideoChannelArgs = {
  id: Scalars["ID"];
};

export type ControlSystemVideoChannelsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemVideoVerificationUrlArgs = {
  dealerId: Scalars["ID"];
  location?: InputMaybe<VvLocation>;
};

export type ControlSystemVkSystemUserListConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ControlSystemZwaveNodesConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
  types?: InputMaybe<ReadonlyArray<ZwaveNodesTypes>>;
};

export type ControlSystemCellStatus = {
  readonly __typename?: "ControlSystemCellStatus";
  readonly bestSignal?: Maybe<Scalars["Int"]>;
  readonly createdAt: Scalars["String"];
  readonly currentSignal?: Maybe<Scalars["Int"]>;
  readonly lastCheckIn?: Maybe<Scalars["String"]>;
  readonly status: ConnectionStatus;
  readonly updatedAt: Scalars["String"];
  readonly worstSignal?: Maybe<Scalars["Int"]>;
};

export type ControlSystemCentralStationAutomationIntegration = Node & {
  readonly __typename?: "ControlSystemCentralStationAutomationIntegration";
  readonly authorityLevels: ReadonlyArray<ControlSystemCentralStationAutomationIntegrationAuthorityLevel>;
  readonly displayedName: Scalars["String"];
  readonly emailAddress: Scalars["String"];
  readonly emergencyContacts: ReadonlyArray<EmergencyContact>;
  readonly emergencyContactsEnabled: Scalars["Boolean"];
  readonly globalPasscodes: ReadonlyArray<Maybe<CentralStationGlobalPasscode>>;
  readonly id: Scalars["ID"];
  readonly isCOPS: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly phoneNumber: Scalars["String"];
  readonly phoneTypes: ReadonlyArray<Scalars["String"]>;
  readonly relationships: ReadonlyArray<Scalars["String"]>;
  readonly supportsAuthorityLevels: Scalars["Boolean"];
  readonly supportsContactBeforeDispatch: Scalars["Boolean"];
  readonly supportsKeyholder: Scalars["Boolean"];
  readonly supportsPhoneTypes: Scalars["Boolean"];
  readonly supportsRelationships: Scalars["Boolean"];
  readonly systemTestExpiresAt?: Maybe<Scalars["DateTime"]>;
  readonly systemTestsEnabled: Scalars["Boolean"];
};

export type ControlSystemCentralStationAutomationIntegrationAuthorityLevel =
  Node & {
    readonly __typename?: "ControlSystemCentralStationAutomationIntegrationAuthorityLevel";
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
  };

export type ControlSystemCombinedEventEdge = {
  readonly __typename?: "ControlSystemCombinedEventEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<CombinedEvent>;
};

export type ControlSystemCombinedHistoryConnection = {
  readonly __typename?: "ControlSystemCombinedHistoryConnection";
  readonly edges: ReadonlyArray<ControlSystemCombinedEventEdge>;
  readonly nodes: ReadonlyArray<CombinedEvent>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export enum ControlSystemCommType {
  CELL = "CELL",
  NETWORK = "NETWORK",
  PERSISTENT = "PERSISTENT",
  PERSISTENT_WITH_CELL_BACKUP = "PERSISTENT_WITH_CELL_BACKUP",
  UNKNOWN = "UNKNOWN",
}

export type ControlSystemConnection = {
  readonly __typename?: "ControlSystemConnection";
  readonly edges: ReadonlyArray<ControlSystemEdge>;
  readonly nodes: ReadonlyArray<ControlSystem>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemDoorEdge = {
  readonly __typename?: "ControlSystemDoorEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Door>;
};

export type ControlSystemDoorsConnection = {
  readonly __typename?: "ControlSystemDoorsConnection";
  readonly edges: ReadonlyArray<ControlSystemDoorEdge>;
  readonly nodes: ReadonlyArray<Door>;
  readonly pageInfo: PageInfo;
  readonly searchCount: Scalars["Int"];
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemEasyConnectStatus = {
  readonly __typename?: "ControlSystemEasyConnectStatus";
  readonly lastCheckIn?: Maybe<Scalars["String"]>;
  readonly status: ConnectionStatus;
};

export type ControlSystemEdge = {
  readonly __typename?: "ControlSystemEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<ControlSystem>;
};

export type ControlSystemGroup = Node & {
  readonly __typename?: "ControlSystemGroup";
  readonly controlSystemIds: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly controlSystems: ReadonlyArray<Maybe<ControlSystem>>;
  readonly createdAt: Scalars["DateTime"];
  readonly hasChanges?: Maybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly isNew?: Maybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly saveStatus?: Maybe<SaveStatus>;
  readonly updatedAt: Scalars["DateTime"];
};

export type ControlSystemGroupInput = {
  readonly controlSystemIds: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly name: Scalars["String"];
};

export type ControlSystemGroupsConnection = {
  readonly __typename?: "ControlSystemGroupsConnection";
  readonly edges: ReadonlyArray<ControlSystemGroupsEdge>;
  readonly nodes: ReadonlyArray<ControlSystemGroup>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemGroupsEdge = {
  readonly __typename?: "ControlSystemGroupsEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: ControlSystemGroup;
};

export type ControlSystemHasTooManyDoorsError = Error & {
  readonly __typename?: "ControlSystemHasTooManyDoorsError";
  readonly type?: Maybe<ErrorType>;
};

export type ControlSystemOutputsConnection = {
  readonly __typename?: "ControlSystemOutputsConnection";
  readonly edges: ReadonlyArray<ControlSystemOutputsConnectionEdge>;
  readonly nodes: ReadonlyArray<Output>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemOutputsConnectionEdge = {
  readonly __typename?: "ControlSystemOutputsConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: Output;
};

export type ControlSystemPersonConnection = {
  readonly __typename?: "ControlSystemPersonConnection";
  readonly edges: ReadonlyArray<ControlSystemPersonEdge>;
  readonly nodes: ReadonlyArray<Person>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemPersonEdge = {
  readonly __typename?: "ControlSystemPersonEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Person>;
};

export type ControlSystemVarVideoActionsConnection = {
  readonly __typename?: "ControlSystemVarVideoActionsConnection";
  readonly edges: ReadonlyArray<Maybe<ControlSystemVarVideoActionsEdge>>;
  readonly nodes: ReadonlyArray<Maybe<VarVideoAction>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount?: Maybe<Scalars["Int"]>;
};

export type ControlSystemVarVideoActionsEdge = {
  readonly __typename?: "ControlSystemVarVideoActionsEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<VarVideoAction>;
};

export type ControlSystemVideoActionsConnection = {
  readonly __typename?: "ControlSystemVideoActionsConnection";
  readonly edges?: Maybe<ReadonlyArray<Maybe<ControlSystemVideoActionsEdge>>>;
  readonly nodes?: Maybe<ReadonlyArray<Maybe<VideoAction>>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount?: Maybe<Scalars["Int"]>;
};

export type ControlSystemVideoActionsEdge = {
  readonly __typename?: "ControlSystemVideoActionsEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<VideoAction>;
};

export type ControlSystemVideoChannelConnection = {
  readonly __typename?: "ControlSystemVideoChannelConnection";
  readonly edges: ReadonlyArray<ControlSystemVideoChannelEdge>;
  readonly nodes: ReadonlyArray<VideoChannel>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ControlSystemVideoChannelEdge = {
  readonly __typename?: "ControlSystemVideoChannelEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<VideoChannel>;
  readonly searchScore?: Maybe<Scalars["Float"]>;
};

export type ControlSystemZwaveNodeEdge = {
  readonly __typename?: "ControlSystemZwaveNodeEdge";
  readonly cursor: Scalars["ID"];
  readonly node: ZwaveNode;
};

export type ControlSystemZwaveNodesConnection = {
  readonly __typename?: "ControlSystemZwaveNodesConnection";
  readonly edges: ReadonlyArray<ControlSystemZwaveNodeEdge>;
  readonly nodes: ReadonlyArray<ZwaveNode>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type CreateAlarmVisionDeviceErrorPayload = {
  readonly __typename?: "CreateAlarmVisionDeviceErrorPayload";
  readonly error: ErrorType;
  readonly message?: Maybe<Scalars["String"]>;
};

export type CreateAlarmVisionDevicePayload =
  | CreateAlarmVisionDeviceErrorPayload
  | CreateAlarmVisionDeviceSuccessPayload;

export type CreateAlarmVisionDeviceSuccessPayload = {
  readonly __typename?: "CreateAlarmVisionDeviceSuccessPayload";
  readonly deviceNumber: Scalars["Int"];
};

export type CreateControlSystemGroupErrorResponse = {
  readonly __typename?: "CreateControlSystemGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreateControlSystemGroupResponse =
  | CreateControlSystemGroupErrorResponse
  | CreateControlSystemGroupSuccessResponse;

export type CreateControlSystemGroupSuccessResponse = {
  readonly __typename?: "CreateControlSystemGroupSuccessResponse";
  readonly customer?: Maybe<Customer>;
  readonly groupId: Scalars["Int"];
};

export type CreateFavoriteErrorResponse = {
  readonly __typename?: "CreateFavoriteErrorResponse";
  readonly error?: Maybe<Error>;
};

export type CreateFavoriteResponse =
  | CreateFavoriteErrorResponse
  | CreateFavoriteSuccessResponse;

export type CreateFavoriteSuccessResponse = {
  readonly __typename?: "CreateFavoriteSuccessResponse";
  readonly system: ControlSystem;
};

export type CreateGlobalHolidayDateErrorResponse = {
  readonly __typename?: "CreateGlobalHolidayDateErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: GlobalHolidayDatesErrors;
};

export type CreateGlobalHolidayDateInput = {
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["String"];
  readonly dealerId: Scalars["Int"];
  readonly description: Scalars["String"];
  readonly name: Scalars["String"];
  readonly panelAssociation: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
};

export type CreateGlobalHolidayDateResponse =
  | CreateGlobalHolidayDateErrorResponse
  | CreateGlobalHolidayDateSuccessResponse;

export type CreateGlobalHolidayDateSuccessResponse = {
  readonly __typename?: "CreateGlobalHolidayDateSuccessResponse";
  readonly dealer?: Maybe<Dealer>;
};

export type CreateGroupErrorResponse = {
  readonly __typename?: "CreateGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GroupsError;
};

export type CreateGroupResponse =
  | CreateGroupErrorResponse
  | CreateGroupSuccessResponse;

export type CreateGroupSuccessResponse = {
  readonly __typename?: "CreateGroupSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type CreateHolidayDateErrorResponse = {
  readonly __typename?: "CreateHolidayDateErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: HolidayDatesErrors;
};

export type CreateHolidayDateInput = {
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["String"];
  readonly dealerId?: InputMaybe<Scalars["Int"]>;
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly globalHolidayId?: InputMaybe<Scalars["Int"]>;
  readonly name: Scalars["String"];
  readonly panelId: Scalars["Int"];
};

export type CreateHolidayDateResponse =
  | CreateHolidayDateErrorResponse
  | CreateHolidayDateSuccessResponse;

export type CreateHolidayDateSuccessResponse = {
  readonly __typename?: "CreateHolidayDateSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type CreatePanelEventBufferJobErrorPayload = {
  readonly __typename?: "CreatePanelEventBufferJobErrorPayload";
  readonly message: Scalars["String"];
  readonly type: BuffErrorTypes;
};

export type CreatePanelEventBufferJobInput = {
  readonly doorAccess: Scalars["Boolean"];
  readonly endDate?: InputMaybe<Scalars["String"]>;
  readonly standardEvents: Scalars["Boolean"];
  readonly startDate?: InputMaybe<Scalars["String"]>;
  readonly systemId: Scalars["String"];
  readonly userComputerTime?: InputMaybe<Scalars["String"]>;
};

export type CreatePanelEventBufferJobResponse =
  | CreatePanelEventBufferJobErrorPayload
  | CreatePanelEventBufferJobSuccessPayload;

export type CreatePanelEventBufferJobSuccessPayload = {
  readonly __typename?: "CreatePanelEventBufferJobSuccessPayload";
  readonly controlSystem: ControlSystem;
  readonly jobId: Scalars["Int"];
};

export type CreatePanelPersonErrorResponse = {
  readonly __typename?: "CreatePanelPersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreatePanelPersonResponse =
  | CreatePanelPersonErrorResponse
  | CreatePanelPersonSuccessResponse;

export type CreatePanelPersonSuccessResponse = {
  readonly __typename?: "CreatePanelPersonSuccessResponse";
  readonly person?: Maybe<PanelPerson>;
  readonly system?: Maybe<ControlSystem>;
};

export type CreatePersonErrorResponse = {
  readonly __typename?: "CreatePersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreatePersonResponse =
  | CreatePersonErrorResponse
  | CreatePersonSuccessResponse;

export type CreatePersonSuccessResponse = {
  readonly __typename?: "CreatePersonSuccessResponse";
  readonly person?: Maybe<Person>;
  readonly system?: Maybe<ControlSystem>;
};

export type CreateProfileErrorResponse = {
  readonly __typename?: "CreateProfileErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreateProfileResponse =
  | CreateProfileErrorResponse
  | CreateProfileSuccessResponse;

export type CreateProfileSuccessResponse = {
  readonly __typename?: "CreateProfileSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type CreateSavedReportResponse =
  | CreateSavedReportSuccessPayload
  | UnknownError;

export type CreateSavedReportSuccessPayload = {
  readonly __typename?: "CreateSavedReportSuccessPayload";
  readonly savedReport: Report;
};

export type CreateServiceRequestErrorResponse = {
  readonly __typename?: "CreateServiceRequestErrorResponse";
  readonly type: CreateServiceRequestResponseErrors;
};

export type CreateServiceRequestResponse =
  | CreateServiceRequestErrorResponse
  | CreateServiceRequestSuccessResponse;

export enum CreateServiceRequestResponseErrors {
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  FAILED_TO_CREATE_SERVICE_REQUEST = "FAILED_TO_CREATE_SERVICE_REQUEST",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export type CreateServiceRequestSuccessResponse = {
  readonly __typename?: "CreateServiceRequestSuccessResponse";
  readonly customer?: Maybe<Customer>;
};

export type CreateTagResponse = CreateTagSuccessPayload | UnknownError;

export type CreateTagSuccessPayload = {
  readonly __typename?: "CreateTagSuccessPayload";
  readonly dealer: Dealer;
  readonly newTagId: Scalars["ID"];
  readonly status: Scalars["String"];
};

export type CreateUserCodeErrorResponse = {
  readonly __typename?: "CreateUserCodeErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreateUserCodeResponse =
  | CreateUserCodeErrorResponse
  | CreateUserCodeSuccessResponse;

export type CreateUserCodeSuccessResponse = {
  readonly __typename?: "CreateUserCodeSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly userCode?: Maybe<UserCode>;
};

export type CreateVarVideoActionErrorResponse = {
  readonly __typename?: "CreateVarVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreateVarVideoActionInput = {
  readonly areaNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraId: Scalars["Int"];
  readonly deviceNumber?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly type: VarVideoActionType;
  readonly zoneNumber?: InputMaybe<Scalars["String"]>;
};

export type CreateVarVideoActionResponse =
  | CreateVarVideoActionErrorResponse
  | CreateVarVideoActionSuccessResponse;

export type CreateVarVideoActionSuccessResponse = {
  readonly __typename?: "CreateVarVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
  readonly varVideoAction?: Maybe<VarVideoAction>;
};

export type CreateVideoActionErrorResponse = {
  readonly __typename?: "CreateVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type CreateVideoActionInput = {
  readonly areaNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraId: Scalars["Int"];
  readonly deviceNumber?: InputMaybe<Scalars["String"]>;
  readonly deviceType?: InputMaybe<VideoDeviceTypeName>;
  readonly name: Scalars["String"];
  readonly type: VideoActionType;
  readonly zoneNumber?: InputMaybe<Scalars["String"]>;
};

export type CreateVideoActionResponse =
  | CreateVideoActionErrorResponse
  | CreateVideoActionSuccessResponse;

export type CreateVideoActionSuccessResponse = {
  readonly __typename?: "CreateVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
  readonly videoAction?: Maybe<VideoAction>;
};

export type CreateX1AutoProgrammingJobPayload =
  | CreateX1AutoProgrammingJobSuccessPayload
  | NotFoundError;

export type CreateX1AutoProgrammingJobSuccessPayload = {
  readonly __typename?: "CreateX1AutoProgrammingJobSuccessPayload";
  readonly controlSystem?: Maybe<SiteControlSystem>;
};

export type CreateXfUserCodeInput = {
  readonly armOnly: Scalars["Boolean"];
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly temp: Scalars["Boolean"];
  readonly userLevel: UserCodeLevel;
};

export type Credential = Node & {
  readonly __typename?: "Credential";
  readonly active: Scalars["Boolean"];
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly deliveryEmail?: Maybe<Scalars["String"]>;
  readonly deliveryText?: Maybe<Scalars["String"]>;
  readonly deliveryType?: Maybe<DigitalCardDeliveryType>;
  readonly externalNumber: Scalars["String"];
  readonly hotStamp?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly parentEntity?: Maybe<Scalars["String"]>;
  readonly person?: Maybe<Person>;
  readonly personId?: Maybe<Scalars["Int"]>;
  readonly serialNumber?: Maybe<Scalars["String"]>;
  readonly temporary?: Maybe<CredentialTemporary>;
  readonly type: CredentialType;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly userCodes: ReadonlyArray<UserCode>;
};

export type CredentialInput = {
  readonly cardNumber?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly personId?: InputMaybe<Scalars["Int"]>;
  readonly type?: InputMaybe<CredentialType>;
};

export type CredentialSummary = Node & {
  readonly __typename?: "CredentialSummary";
  readonly availableCredits: Scalars["Int"];
  readonly customer?: Maybe<Customer>;
  readonly id: Scalars["ID"];
  readonly totalMobileCredentials: Scalars["Int"];
  readonly totalPurchased: Scalars["Int"];
};

export type CredentialTemporary = {
  readonly __typename?: "CredentialTemporary";
  readonly endDate: Scalars["Date"];
  readonly startDate: Scalars["Date"];
};

export enum CredentialType {
  BADGE = "BADGE",
  DIGITAL_CARD = "DIGITAL_CARD",
  MOBILE = "MOBILE",
  PIN = "PIN",
  UNKNOWN = "UNKNOWN",
}

export enum CrudType {
  CREATE = "CREATE",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
}

export type CurrentZoneStatus = Node & {
  readonly __typename?: "CurrentZoneStatus";
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly status?: Maybe<ZoneStatus>;
  readonly type: Scalars["String"];
  readonly zoneType: ZoneType;
};

export type CustomRequestData = {
  readonly __typename?: "CustomRequestData";
  readonly emails: ReadonlyArray<Maybe<Scalars["String"]>>;
  readonly panelId: Scalars["Int"];
  readonly type: Scalars["String"];
};

export type CustomRequestInput = {
  readonly emails: ReadonlyArray<InputMaybe<Scalars["String"]>>;
  readonly panelId: Scalars["Int"];
  readonly type: Scalars["String"];
};

export type Customer = Node & {
  readonly __typename?: "Customer";
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly allSystemsAppUsersReportConnection?: Maybe<AllSystemsAppUsersReportConnection>;
  readonly allSystemsProfilesReportConnection?: Maybe<AllSystemsProfilesReportConnection>;
  readonly appUsersWithPersons: ReadonlyArray<Maybe<DealerAppUserWithPerson>>;
  readonly availableMobileCredentials: Scalars["Int"];
  readonly badgeTemplates: ReadonlyArray<Maybe<BadgeTemplate>>;
  readonly centralStationIntegrationDisabled: Scalars["Boolean"];
  readonly city: Scalars["String"];
  readonly contact?: Maybe<Contact>;
  readonly contactsConnection: ContactConnection;
  readonly controlSystemGroupsConnection: ControlSystemGroupsConnection;
  readonly controlSystems: ControlSystemConnection;
  readonly country: Scalars["String"];
  readonly dSyncEnabled: Scalars["Boolean"];
  readonly databaseId: Scalars["Int"];
  readonly dealer: Dealer;
  readonly enterpriseBadgePrintingEnabled: Scalars["Boolean"];
  readonly filteredControlSystems: ControlSystemConnection;
  readonly historyConnection: CustomerHistoryConnection;
  readonly id: Scalars["ID"];
  readonly idpGroups: ReadonlyArray<Maybe<IdpGroup>>;
  readonly linkedPersonNoAccessCount: Scalars["Int"];
  readonly linkedProfilesConnection: CustomerLinkedProfilesConnection;
  readonly mobileCredentialsSummary?: Maybe<CredentialSummary>;
  readonly mobileWalletCredentialPoolEnabled: Scalars["Boolean"];
  readonly mobileWalletCredentialPoolLevel: Scalars["Int"];
  readonly mobileWalletCredentialsSummary?: Maybe<WalletCredentialSummary>;
  readonly name: Scalars["String"];
  readonly newControlSystemGroup?: Maybe<ControlSystemGroup>;
  readonly originalControlSystemGroup?: Maybe<ControlSystemGroup>;
  readonly personEmails?: Maybe<ReadonlyArray<Maybe<QuickCustomerPerson>>>;
  readonly postalCode: Scalars["String"];
  readonly programmingTemplates: ProgrammingTemplatesConnection;
  readonly sites: ReadonlyArray<Site>;
  readonly ssoEnabled: Scalars["Boolean"];
  readonly state: Scalars["String"];
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly twoFactorRequired: Scalars["Boolean"];
  readonly unikeyEnabled: Scalars["Boolean"];
  readonly unikeyOrganizationId?: Maybe<Scalars["String"]>;
};

export type CustomerAllSystemsAppUsersReportConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerAllSystemsProfilesReportConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerContactArgs = {
  id: Scalars["ID"];
};

export type CustomerContactsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerControlSystemGroupsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerControlSystemsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  ids?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerFilteredControlSystemsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  ids?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerHistoryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  latestEventDate?: InputMaybe<Scalars["String"]>;
  searchTerm?: InputMaybe<Scalars["String"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortKey?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CustomerLinkedProfilesConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type CustomerProgrammingTemplatesArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  hardwareModels?: InputMaybe<ReadonlyArray<PanelHardwareModel>>;
  isInternational: Scalars["Boolean"];
  sort?: InputMaybe<SortInput>;
};

export type CustomerAppDetails = {
  readonly __typename?: "CustomerAppDetails";
  readonly androidPackageId: Scalars["String"];
  readonly androidUriProtocol: Scalars["String"];
  readonly appNameCodified: Scalars["String"];
  readonly appNamePretty: Scalars["String"];
  readonly appleStoreUrl: Scalars["String"];
  readonly emailLogoUrl: Scalars["String"];
  readonly emailSendFrom: Scalars["String"];
  readonly googlePlayStoreUrl: Scalars["String"];
  readonly id: Scalars["Int"];
  readonly iosPackageId: Scalars["String"];
  readonly iosUriProtocol: Scalars["String"];
  readonly websiteUrl: Scalars["String"];
};

export enum CustomerError {
  FAILED_TO_DELETE = "FAILED_TO_DELETE",
  FAILED_TO_RESET_PASSWORD = "FAILED_TO_RESET_PASSWORD",
}

export type CustomerEventEdge = {
  readonly __typename?: "CustomerEventEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Event>;
};

export enum CustomerFeatureTableConcepts {
  BADGE_PRINTING = "BADGE_PRINTING",
  DIGITAL_KEY_CREDENTIALS = "DIGITAL_KEY_CREDENTIALS",
  DIRECTORY_SYNC = "DIRECTORY_SYNC",
  SINGLE_SIGN_ON = "SINGLE_SIGN_ON",
}

export type CustomerHistoryConnection = {
  readonly __typename?: "CustomerHistoryConnection";
  readonly edges: ReadonlyArray<CustomerEventEdge>;
  readonly nodes: ReadonlyArray<Event>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type CustomerLinkedProfilesConnection = {
  readonly __typename?: "CustomerLinkedProfilesConnection";
  readonly edges: ReadonlyArray<CustomerLinkedProfilesConnectionEdge>;
  readonly nodes: ReadonlyArray<LinkedProfile>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type CustomerLinkedProfilesConnectionEdge = {
  readonly __typename?: "CustomerLinkedProfilesConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: LinkedProfile;
};

export type CustomerListEntry = {
  readonly __typename?: "CustomerListEntry";
  readonly controlSystemId?: Maybe<Scalars["Int"]>;
  readonly controlSystemName?: Maybe<Scalars["String"]>;
  readonly customerId: Scalars["Int"];
  readonly customerName: Scalars["String"];
  readonly siteId?: Maybe<Scalars["Int"]>;
};

export type CustomerPerson = Node &
  Person & {
    readonly __typename?: "CustomerPerson";
    readonly activeControlSystem?: Maybe<ControlSystem>;
    readonly appUser?: Maybe<CustomerUser>;
    readonly appUsers: ReadonlyArray<CustomerUser>;
    readonly company?: Maybe<Scalars["String"]>;
    readonly controlSystems: ControlSystemConnection;
    readonly credentials: ReadonlyArray<Credential>;
    readonly customer: Customer;
    readonly departmentId?: Maybe<Scalars["String"]>;
    readonly departmentTitle?: Maybe<Scalars["String"]>;
    readonly emailAddress: Scalars["String"];
    readonly firstName: Scalars["String"];
    readonly groups: ReadonlyArray<SiteGroup>;
    readonly hasCardPlusPin: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly idpPersonStatus: IdpPersonStatus;
    readonly isManagedInAdmin: Scalars["Boolean"];
    readonly isMe: Scalars["Boolean"];
    readonly isMobileCredentialOnly: Scalars["Boolean"];
    readonly isSiteCredentialsManagedInAdmin: Scalars["Boolean"];
    readonly isTempDealerUser: Scalars["Boolean"];
    readonly lastName: Scalars["String"];
    readonly middleName?: Maybe<Scalars["String"]>;
    readonly note?: Maybe<Scalars["String"]>;
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly photoUrl?: Maybe<Scalars["String"]>;
    readonly systemAppUser?: Maybe<CustomerUser>;
    readonly userEmployeeId?: Maybe<Scalars["String"]>;
    readonly userTitle?: Maybe<Scalars["String"]>;
    readonly visibleLogin?: Maybe<Scalars["String"]>;
  };

export type CustomerPersonControlSystemsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  filterOnlyAppEnabled?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  ids?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  offset?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
  usersAuthData: ReadonlyArray<UsersAuthDataInput>;
};

export type CustomerPersonCredentialsArgs = {
  siteId?: InputMaybe<Scalars["ID"]>;
};

export type CustomerPersonGroupsArgs = {
  siteId: Scalars["ID"];
};

export type CustomerPersonIsManagedInAdminArgs = {
  systemId: Scalars["ID"];
};

export type CustomerPersonIsMobileCredentialOnlyArgs = {
  id: Scalars["ID"];
};

export type CustomerPersonIsSiteCredentialsManagedInAdminArgs = {
  siteId: Scalars["ID"];
};

export type CustomerPersonSystemAppUserArgs = {
  systemId: Scalars["ID"];
};

export type CustomerSelectListEntry = {
  readonly __typename?: "CustomerSelectListEntry";
  readonly customerId: Scalars["Int"];
  readonly customerName: Scalars["String"];
};

export type CustomerUser = Node &
  User & {
    readonly __typename?: "CustomerUser";
    readonly accessibleId: Scalars["Int"];
    readonly accessibleType: AccessibleType;
    readonly authToken?: Maybe<Scalars["String"]>;
    readonly customer: Customer;
    readonly customerId: Scalars["Int"];
    readonly email: Scalars["EmailAddress"];
    readonly emailClips: Scalars["Boolean"];
    readonly firstName: Scalars["String"];
    readonly hasPermissionsForAllPanels: Scalars["Boolean"];
    readonly hidden: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isAdmin: Scalars["Boolean"];
    readonly lastName: Scalars["String"];
    readonly lastSignInAt?: Maybe<Scalars["DateTime"]>;
    readonly lockedAt?: Maybe<Scalars["DateTime"]>;
    readonly person: Person;
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly role: UserRole;
    readonly ssoOnly: Scalars["Boolean"];
    readonly twoFactorSettings?: Maybe<TwoFactorSettings>;
    readonly userPermissions: ReadonlyArray<UserPermissions>;
  };

export type DailyReportNotEnabledError = Error & {
  readonly __typename?: "DailyReportNotEnabledError";
  readonly type?: Maybe<ErrorType>;
};

export type DataInputForAddPerson = {
  readonly appUser?: InputMaybe<SiteAppUserInput>;
  readonly company?: InputMaybe<Scalars["String"]>;
  readonly credentials: ReadonlyArray<AddSiteCredentialInput>;
  readonly departmentId?: InputMaybe<Scalars["String"]>;
  readonly departmentTitle?: InputMaybe<Scalars["String"]>;
  readonly emailAddress: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly fromHistory?: InputMaybe<Scalars["Boolean"]>;
  readonly groups: ReadonlyArray<Scalars["ID"]>;
  readonly isMobileCredentialOnly: Scalars["Boolean"];
  readonly lastName: Scalars["String"];
  readonly middleName?: InputMaybe<Scalars["String"]>;
  readonly note?: InputMaybe<Scalars["String"]>;
  readonly phoneNumber?: InputMaybe<Scalars["String"]>;
  readonly photo?: InputMaybe<Scalars["String"]>;
  readonly pin?: InputMaybe<Scalars["String"]>;
  readonly siteId: Scalars["ID"];
  readonly userEmployeeId?: InputMaybe<Scalars["String"]>;
  readonly userTitle?: InputMaybe<Scalars["String"]>;
};

export type DataInputForDeletePerson = {
  readonly appUser?: InputMaybe<SiteAppUserInput>;
  readonly credentials: ReadonlyArray<UpdateSiteCredentialInput>;
  readonly emailAddress: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly groups: ReadonlyArray<Scalars["ID"]>;
  readonly id: Scalars["ID"];
  readonly isMobileCredentialOnly: Scalars["Boolean"];
  readonly lastName: Scalars["String"];
  readonly note?: InputMaybe<Scalars["String"]>;
  readonly phoneNumber?: InputMaybe<Scalars["String"]>;
  readonly photo?: InputMaybe<Scalars["String"]>;
  readonly pin?: InputMaybe<Scalars["String"]>;
  readonly siteId: Scalars["ID"];
};

export type DataInputForUpdatePerson = {
  readonly appUser?: InputMaybe<SiteAppUserInput>;
  readonly company?: InputMaybe<Scalars["String"]>;
  readonly credentials: ReadonlyArray<UpdateSiteCredentialInput>;
  readonly departmentId?: InputMaybe<Scalars["String"]>;
  readonly departmentTitle?: InputMaybe<Scalars["String"]>;
  readonly emailAddress: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly groups: ReadonlyArray<Scalars["ID"]>;
  readonly id: Scalars["ID"];
  readonly isMobileCredentialOnly: Scalars["Boolean"];
  readonly lastName: Scalars["String"];
  readonly middleName?: InputMaybe<Scalars["String"]>;
  readonly note?: InputMaybe<Scalars["String"]>;
  readonly phoneNumber?: InputMaybe<Scalars["String"]>;
  readonly photo?: InputMaybe<Scalars["String"]>;
  readonly pin?: InputMaybe<Scalars["String"]>;
  readonly siteId: Scalars["ID"];
  readonly userEmployeeId?: InputMaybe<Scalars["String"]>;
  readonly userTitle?: InputMaybe<Scalars["String"]>;
};

export type DeactivateSiteDoorResponse =
  | FailedToDeactivateSiteDoorError
  | NotFoundError
  | SiteDoor;

export type Dealer = Node & {
  readonly __typename?: "Dealer";
  readonly accountOverview: ReadonlyArray<Maybe<DealerAccountOverview>>;
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly allowBilling: Scalars["Boolean"];
  readonly allowLogInAsCustomer: Scalars["Boolean"];
  readonly allowMiniCellcom: Scalars["Boolean"];
  readonly allowSupercell: Scalars["Boolean"];
  readonly allowTechSupportLogInAs: Scalars["Boolean"];
  readonly allowXtlUpgradeProgram: Scalars["Boolean"];
  readonly apiAccess: Scalars["Boolean"];
  readonly appAccess: Scalars["Boolean"];
  readonly appKey: Scalars["String"];
  readonly autoEnrollDefaults: AutoEnrollDefaults;
  readonly autoEnrolledControlSystems: ControlSystemConnection;
  readonly autoEnrollmentOption?: Maybe<AutoEnrollmentOption>;
  readonly cellularOverview: ReadonlyArray<Maybe<DealerCellularOverview>>;
  readonly centralStationAutomationIntegrations: ReadonlyArray<CentralStationAutomationIntegration>;
  readonly city: Scalars["String"];
  readonly companyStore: Scalars["Boolean"];
  readonly country: Scalars["String"];
  readonly credentialsSummaryConnection: DealerCredentialsSummaryConnection;
  readonly customApp: Scalars["Boolean"];
  readonly customerAppDetails?: Maybe<ReadonlyArray<Maybe<CustomerAppDetails>>>;
  readonly customerFeatureDataConnection: OpportunityDashboardCustomersDataConnection;
  readonly customerReferral: Scalars["Boolean"];
  readonly customersConnection: DealerCustomersConnection;
  readonly databaseId: Scalars["Int"];
  readonly dealerCharges?: Maybe<DealerCharges>;
  readonly dealerKeypadContactInfo?: Maybe<DealerKeypadContactInfo>;
  readonly dealerPersonnelConnection: DealerPersonnelConnection;
  readonly distributionSubscriber: Scalars["Boolean"];
  readonly downloadableFiles: DownloadableFileConnection;
  readonly email: Scalars["String"];
  readonly emailLogoUrl: Scalars["String"];
  readonly emailSendFrom: Scalars["String"];
  readonly facebook: Scalars["String"];
  readonly globalHolidayDateJobs: ReadonlyArray<Maybe<SchedulerJob>>;
  readonly globalHolidayDates: ReadonlyArray<GlobalHolidayDate>;
  readonly id: Scalars["ID"];
  readonly ipWhitelistEnabled: Scalars["Boolean"];
  readonly logoUrl: Scalars["String"];
  readonly marketingCentral: Scalars["Boolean"];
  readonly masterIdentifiers: ReadonlyArray<Maybe<DealerMasterIdentifier>>;
  readonly mobileCredentialCost: Scalars["Float"];
  readonly mobileCredentialsHistoryConnection: DealerMobileCredentialsHistoryConnection;
  readonly name: Scalars["String"];
  readonly onDemandAllowed: Scalars["Boolean"];
  readonly opportunityDashboardMetrics: OpportunityDashboardMetrics;
  readonly ordersRequireApproval: Scalars["Boolean"];
  readonly persons?: Maybe<ReadonlyArray<Person>>;
  readonly phone1: Scalars["String"];
  readonly phone2: Scalars["String"];
  readonly postalCode: Scalars["String"];
  readonly programmingTemplates: ProgrammingTemplatesConnection;
  readonly receiverConfigurations: ReadonlyArray<Maybe<ReceiverConfiguration>>;
  readonly receivers: ReceiverConnection;
  readonly securecomLicense: Scalars["String"];
  readonly securityCommand?: Maybe<Scalars["Boolean"]>;
  readonly serviceRequestsConnection: ServiceRequestConnection;
  readonly skippedPaymentMethod: Scalars["Boolean"];
  readonly state: Scalars["String"];
  readonly storeUserCodes: Scalars["Boolean"];
  readonly systemFeatureDataConnection: OpportunityDashboardSystemsDataConnection;
  readonly systemsOverview: ReadonlyArray<Maybe<DealerSystemsOverview>>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly techLocations: Scalars["Boolean"];
  readonly timeZones: ReadonlyArray<TimeZone>;
  readonly twitter: Scalars["String"];
  /** This is the list of account prefixes that have been used, but not had a receiver created for them. */
  readonly uninitializedReceiverNumbers: ReadonlyArray<Scalars["Int"]>;
  readonly validPaymentSource: Scalars["Boolean"];
  readonly vernaculars: ReadonlyArray<Maybe<Vernacular>>;
  readonly videoVerification: Scalars["Boolean"];
  readonly videoVerificationDuration: Scalars["Int"];
  readonly videoVerificationStrategy: Scalars["String"];
  readonly vkOverview: ReadonlyArray<Maybe<DealerVkOverview>>;
  readonly websiteLogo: Scalars["String"];
  readonly websiteLogoUrl: Scalars["String"];
};

export type DealerAutoEnrolledControlSystemsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  cmsAccountNumber?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerCredentialsSummaryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerCustomerFeatureDataConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  feature: CustomerFeatureTableConcepts;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<Scalars["String"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<SortInput>;
  top?: InputMaybe<Scalars["Int"]>;
  variant?: InputMaybe<OpportunityFeatureVariant>;
};

export type DealerCustomersConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerDealerPersonnelConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerDownloadableFilesArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  downloadableFileTypes: ReadonlyArray<DownloadableFileType>;
  first?: InputMaybe<Scalars["Int"]>;
  publicOnly?: InputMaybe<Scalars["Boolean"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerMobileCredentialsHistoryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerProgrammingTemplatesArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  hardwareModels?: InputMaybe<ReadonlyArray<PanelHardwareModel>>;
  sort?: InputMaybe<SortInput>;
};

export type DealerReceiversArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerServiceRequestsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type DealerSystemFeatureDataConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  feature: SystemFeatureTableConcepts;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<Scalars["String"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<SortInput>;
  top?: InputMaybe<Scalars["Int"]>;
  variant?: InputMaybe<OpportunityFeatureVariant>;
};

export type DealerAccess = {
  readonly __typename?: "DealerAccess";
  readonly accessType: Scalars["String"];
  readonly endTime?: Maybe<Scalars["String"]>;
  readonly startTime?: Maybe<Scalars["String"]>;
};

export type DealerAccountOverview = {
  readonly __typename?: "DealerAccountOverview";
  readonly cameras: Scalars["Int"];
  readonly cellularDevices: Scalars["Int"];
  readonly customers: Scalars["Int"];
  readonly month: Scalars["Int"];
  readonly systems: Scalars["Int"];
  readonly systemsDeleted: Scalars["Int"];
  readonly systemsWithApps: Scalars["Int"];
  readonly systemsWithCell: Scalars["Int"];
  readonly virtualKeypadApps: Scalars["Int"];
  readonly year: Scalars["Int"];
};

export type DealerActivity = Node & {
  readonly __typename?: "DealerActivity";
  readonly advancedReports: Scalars["Int"];
  readonly apps: Scalars["Int"];
  readonly autoProgrammed: Scalars["Int"];
  readonly cellular: Scalars["Int"];
  readonly dealerId: Scalars["Int"];
  readonly doorsOfAccess: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly mtdSystems: Scalars["Int"];
  readonly mtdVarianceSystems: Scalars["Float"];
  readonly name: Scalars["String"];
  readonly systems: Scalars["Int"];
  readonly videoVerification: Scalars["Int"];
  readonly ytdSales: Scalars["Float"];
  readonly ytdSalesVariance: Scalars["Float"];
  readonly ytdSystems: Scalars["Int"];
  readonly ytdVarianceSystems: Scalars["Float"];
};

export type DealerApiVideoAction = Node &
  VideoAction & {
    readonly __typename?: "DealerApiVideoAction";
    readonly areaNumber?: Maybe<Scalars["String"]>;
    readonly cameraId: Scalars["String"];
    readonly cameraType?: Maybe<VideoActionCameraType>;
    readonly deviceNumber?: Maybe<Scalars["String"]>;
    readonly groupId?: Maybe<Scalars["String"]>;
    readonly id: Scalars["ID"];
    readonly name?: Maybe<Scalars["String"]>;
    readonly type: VideoActionType;
    readonly zoneNumber?: Maybe<Scalars["String"]>;
  };

export type DealerAppUserWithPerson = {
  readonly __typename?: "DealerAppUserWithPerson";
  readonly authorityLevel?: Maybe<Scalars["String"]>;
  readonly customerId: Scalars["Int"];
  readonly customerName?: Maybe<Scalars["String"]>;
  readonly dealerId: Scalars["Int"];
  readonly emailAddress?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly hidden: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isTempDealerUser?: Maybe<Scalars["Boolean"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly lastSignInAt?: Maybe<Scalars["String"]>;
  readonly loginLocked?: Maybe<Scalars["Boolean"]>;
  readonly personId?: Maybe<Scalars["Int"]>;
  readonly tempDealerUserExpiresAt?: Maybe<Scalars["String"]>;
  readonly totalCustomerAppUsers?: Maybe<Scalars["Int"]>;
  readonly userId: Scalars["Int"];
};

export type DealerCellularOverview = {
  readonly __typename?: "DealerCellularOverview";
  readonly activations: Scalars["Int"];
  readonly attLTEActivations: Scalars["Int"];
  readonly month: Scalars["Int"];
  readonly verizonLTEActivations: Scalars["Int"];
  readonly year: Scalars["Int"];
};

export type DealerCharges = {
  readonly __typename?: "DealerCharges";
  readonly Active: Scalars["Boolean"];
  readonly AlarmVisionChannel: Scalars["Float"];
  readonly Billed: Scalars["Boolean"];
  readonly BillingCycle: Scalars["Int"];
  readonly Charge8Video: Scalars["Float"];
  readonly Charge12Video: Scalars["Float"];
  readonly Charge16Video: Scalars["Float"];
  readonly ChargeActivation: Scalars["Float"];
  readonly ChargeAdvancedReportsCell: Scalars["Float"];
  readonly ChargeAdvancedReportsNetwork: Scalars["Float"];
  readonly ChargeArmingAppCell: Scalars["Float"];
  readonly ChargeArmingAppNetwork: Scalars["Float"];
  readonly ChargeBadgePrint: Scalars["Float"];
  readonly ChargeCustomerBadgePrint: Scalars["Float"];
  readonly ChargeFullAppCell: Scalars["Float"];
  readonly ChargeFullAppCellOther: Scalars["Float"];
  readonly ChargeFullAppNetwork: Scalars["Float"];
  readonly ChargeFullAppNetworkCellBackup: Scalars["Float"];
  readonly ChargeFullAppNetworkCellOther: Scalars["Float"];
  readonly ChargeSensorActivity: Scalars["Float"];
  readonly ChargeTrafficCount: Scalars["Float"];
  /** @deprecated Use V6000Analytics instead */
  readonly ChargeVideoAnalytics: Scalars["Float"];
  readonly ChargeVideoDoorbell: Scalars["Float"];
  readonly ChargeVideoVerification: Scalars["Float"];
  readonly ChargeVueDoorbell: Scalars["Float"];
  readonly ChargeVuePlusAlarmVision: Scalars["Float"];
  readonly ChargeZWave8Video: Scalars["Float"];
  readonly ChargeZWave12Video: Scalars["Float"];
  readonly ChargeZWave16Video: Scalars["Float"];
  readonly ChargeZWaveOnly: Scalars["Float"];
  readonly ChargeZWaveVideo: Scalars["Float"];
  readonly CreatedAt: Scalars["String"];
  readonly DealerCode: Scalars["Int"];
  readonly Id: Scalars["Int"];
  readonly Name: Scalars["String"];
  readonly PooledUsage: Scalars["Boolean"];
  readonly PricingTier: Scalars["String"];
  readonly RatePlan406: Scalars["Float"];
  readonly RatePlan408: Scalars["Float"];
  readonly RatePlan416: Scalars["Float"];
  readonly RatePlan425: Scalars["Float"];
  readonly RatePlan435: Scalars["Float"];
  readonly RatePlan445: Scalars["Float"];
  readonly RatePlanBackup: Scalars["Float"];
  readonly RatePlanCellComSL: Scalars["Float"];
  readonly RatePlanFire: Scalars["Float"];
  readonly RatePlanFirstNet: Scalars["Float"];
  readonly RatePlanFirstNetBackup: Scalars["Float"];
  readonly RatePlanFirstNetFire: Scalars["Float"];
  readonly RatePlanText100: Scalars["Float"];
  readonly RatePlanText200: Scalars["Float"];
  readonly RatePlanTextUnlimited: Scalars["Float"];
  readonly RatePlanXR: Scalars["Float"];
  readonly RatePlanXT: Scalars["Float"];
  readonly RatePlanXTL: Scalars["Float"];
  readonly UpdatedAt: Scalars["String"];
  readonly UsageExempt: Scalars["Boolean"];
  readonly V6000Analytics: Scalars["Float"];
};

export type DealerChargesResponse = DealerCharges | UnknownError;

export type DealerCredentialSummaryEdge = {
  readonly __typename?: "DealerCredentialSummaryEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<CredentialSummary>;
};

export type DealerCredentialsSummaryConnection = {
  readonly __typename?: "DealerCredentialsSummaryConnection";
  readonly edges: ReadonlyArray<DealerCredentialSummaryEdge>;
  readonly nodes: ReadonlyArray<CredentialSummary>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type DealerCustomerEdge = {
  readonly __typename?: "DealerCustomerEdge";
  readonly cursor: Scalars["ID"];
  readonly node: Customer;
};

export type DealerCustomersConnection = {
  readonly __typename?: "DealerCustomersConnection";
  readonly edges: ReadonlyArray<DealerCustomerEdge>;
  readonly nodes: ReadonlyArray<Customer>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type DealerHolidayDate = {
  readonly __typename?: "DealerHolidayDate";
  readonly clazz?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly dealerId?: Maybe<Scalars["Int"]>;
  readonly description?: Maybe<Scalars["String"]>;
  readonly holidayDate?: Maybe<Scalars["String"]>;
  readonly holidayId?: Maybe<Scalars["Int"]>;
  readonly holidayName?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export type DealerKeypadContactInfo = {
  readonly __typename?: "DealerKeypadContactInfo";
  readonly contactInfoId: Scalars["Int"];
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly dealerId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly line1?: Maybe<Scalars["String"]>;
  readonly line2?: Maybe<Scalars["String"]>;
  readonly line3?: Maybe<Scalars["String"]>;
  readonly line4?: Maybe<Scalars["String"]>;
  readonly line5?: Maybe<Scalars["String"]>;
  readonly line6?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export type DealerKeypadContactInfoInput = {
  readonly DealerId?: InputMaybe<Scalars["Int"]>;
  readonly Id?: InputMaybe<Scalars["String"]>;
  readonly Line1?: InputMaybe<Scalars["String"]>;
  readonly Line2?: InputMaybe<Scalars["String"]>;
  readonly Line3?: InputMaybe<Scalars["String"]>;
  readonly Line4?: InputMaybe<Scalars["String"]>;
  readonly Line5?: InputMaybe<Scalars["String"]>;
  readonly Line6?: InputMaybe<Scalars["String"]>;
  readonly createdAt?: InputMaybe<Scalars["String"]>;
  readonly updatedAt?: InputMaybe<Scalars["String"]>;
};

export type DealerListEntry = {
  readonly __typename?: "DealerListEntry";
  readonly cmsAccountNumber: Scalars["String"];
  readonly companyName: Scalars["String"];
  readonly databaseId: Scalars["Int"];
  readonly dealerCode: Scalars["String"];
  readonly name: Scalars["String"];
  readonly securityCommand?: Maybe<Scalars["Boolean"]>;
};

export type DealerMasterIdentifier = {
  readonly __typename?: "DealerMasterIdentifier";
  readonly active: Scalars["Boolean"];
  readonly authenticationToken: Scalars["String"];
  readonly id: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly primary: Scalars["Boolean"];
};

export type DealerMobileCredentialsHistoryConnection = {
  readonly __typename?: "DealerMobileCredentialsHistoryConnection";
  readonly edges: ReadonlyArray<MobileCredentialsHistoryEdge>;
  readonly nodes: ReadonlyArray<MobileCredentialHistoryEvent>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type DealerPerson = Node &
  Person & {
    readonly __typename?: "DealerPerson";
    readonly appUser?: Maybe<DealerUser>;
    readonly appUsers: ReadonlyArray<DealerUser>;
    readonly dealer: Dealer;
    readonly emailAddress: Scalars["String"];
    readonly firstName: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly idpPersonStatus: IdpPersonStatus;
    readonly isMe: Scalars["Boolean"];
    readonly lastName: Scalars["String"];
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly unikeyInstallerToken?: Maybe<Scalars["String"]>;
    readonly visibleLogin?: Maybe<Scalars["String"]>;
  };

export type DealerPersonnel = Node & {
  readonly __typename?: "DealerPersonnel";
  readonly accessibleId?: Maybe<Scalars["Int"]>;
  readonly accessibleType?: Maybe<AccessibleType>;
  readonly active: Scalars["Boolean"];
  readonly appType?: Maybe<Scalars["String"]>;
  readonly appUsedAt?: Maybe<Scalars["String"]>;
  readonly autoGenerated: Scalars["Boolean"];
  readonly contactType?: Maybe<UserContactType>;
  readonly controlSystemOnboardings: ReadonlyArray<Maybe<Scalars["String"]>>;
  readonly currentSignInAt?: Maybe<Scalars["String"]>;
  readonly customerRole?: Maybe<UserRole>;
  readonly customerRoleId?: Maybe<Scalars["Int"]>;
  readonly dealerTempExpires?: Maybe<Scalars["String"]>;
  readonly diy: Scalars["Boolean"];
  readonly email: Scalars["String"];
  readonly emailClips: Scalars["Boolean"];
  readonly failedAttempts?: Maybe<Scalars["Int"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly hidden: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly lastSignInAt?: Maybe<Scalars["String"]>;
  readonly lockedAt?: Maybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly role?: Maybe<DealerRole>;
  readonly signInCount?: Maybe<Scalars["Int"]>;
  readonly techLocation: Scalars["Boolean"];
  readonly technicianId?: Maybe<Scalars["Int"]>;
  readonly temporary: Scalars["Boolean"];
  readonly temporaryEndDate?: Maybe<Scalars["String"]>;
  readonly temporaryStartDate?: Maybe<Scalars["String"]>;
  readonly temporaryTimeZone?: Maybe<Scalars["String"]>;
  readonly temporaryUseDst?: Maybe<Scalars["Boolean"]>;
  readonly userAgreementId?: Maybe<Scalars["Int"]>;
  readonly userAuthId?: Maybe<Scalars["Int"]>;
  readonly userImageUrl?: Maybe<Scalars["String"]>;
  readonly userPermissions: ReadonlyArray<Maybe<UserPermissions>>;
  readonly userPermissionsAll?: Maybe<Scalars["Boolean"]>;
  readonly videoAccessExpires?: Maybe<Scalars["String"]>;
};

export type DealerPersonnelCan = {
  readonly __typename?: "DealerPersonnelCan";
  readonly accessUserManagement: Scalars["Boolean"];
  readonly activateCellular: Scalars["Boolean"];
  readonly addCameras: Scalars["Boolean"];
  readonly addCustomers: Scalars["Boolean"];
  readonly addProgramming: Scalars["Boolean"];
  readonly addSystems: Scalars["Boolean"];
  readonly armSystem: Scalars["Boolean"];
  readonly authorizeLoginAsCustomer: Scalars["Boolean"];
  readonly cancelSimOnDelete: Scalars["Boolean"];
  readonly changeOwnPassword: Scalars["Boolean"];
  readonly createAppUsers: Scalars["Boolean"];
  readonly createPersonnel: Scalars["Boolean"];
  readonly createTempDealerCustomerUser: Scalars["Boolean"];
  readonly createTempDealerCustomerUserViaPermission: Scalars["Boolean"];
  readonly createVideoDevice: Scalars["Boolean"];
  readonly deactivateCellular: Scalars["Boolean"];
  readonly deleteAppUsers: Scalars["Boolean"];
  readonly deleteCustomers: Scalars["Boolean"];
  readonly deleteDealerSettings: Scalars["Boolean"];
  readonly deletePersonnel: Scalars["Boolean"];
  readonly deleteProgramming: Scalars["Boolean"];
  readonly deleteSystems: Scalars["Boolean"];
  readonly deleteVideoDevice: Scalars["Boolean"];
  readonly editAddOnFeatures: Scalars["Boolean"];
  readonly editAppUsers: Scalars["Boolean"];
  readonly editCustomers: Scalars["Boolean"];
  readonly editDealerSettings: Scalars["Boolean"];
  readonly editGroups: Scalars["Boolean"];
  readonly editIncludedFeatures: Scalars["Boolean"];
  readonly editNewsItems: Scalars["Boolean"];
  readonly editOnDemandPricing: Scalars["Boolean"];
  readonly editPersonnel: Scalars["Boolean"];
  readonly editProfiles: Scalars["Boolean"];
  readonly editProgramming: Scalars["Boolean"];
  readonly editSystemNotesImages: Scalars["Boolean"];
  readonly editSystems: Scalars["Boolean"];
  readonly editTags: Scalars["Boolean"];
  readonly editUserCodes: Scalars["Boolean"];
  readonly editVideoDevice: Scalars["Boolean"];
  readonly editXrSchedules: Scalars["Boolean"];
  readonly editXtSchedules: Scalars["Boolean"];
  readonly enabledAllowTechSupportLogInAsCustomer: Scalars["Boolean"];
  readonly enabledCustomApp: Scalars["Boolean"];
  readonly enabledCustomerReferral: Scalars["Boolean"];
  readonly enabledDistributionSubscriber: Scalars["Boolean"];
  readonly enabledIntegrations: Scalars["Boolean"];
  readonly enabledIpWhitelist: Scalars["Boolean"];
  readonly enabledLoginAsCustomer: Scalars["Boolean"];
  readonly enabledOnDemand: Scalars["Boolean"];
  readonly enabledSecurityCommand: Scalars["Boolean"];
  readonly enforceDistributionSubscriberValidPaymentMethod: Scalars["Boolean"];
  readonly enforceIpWhitelist: Scalars["Boolean"];
  readonly fastProgramPanel: Scalars["Boolean"];
  readonly formatSdCard: Scalars["Boolean"];
  readonly isAccountant: Scalars["Boolean"];
  readonly isAdmin: Scalars["Boolean"];
  readonly isCustomer: Scalars["Boolean"];
  readonly isCustomerSupport: Scalars["Boolean"];
  readonly isDealerAccessible: Scalars["Boolean"];
  readonly isDealerAdmin: Scalars["Boolean"];
  readonly isDealerOperator: Scalars["Boolean"];
  readonly isDealerTechnician: Scalars["Boolean"];
  readonly isSalesManager: Scalars["Boolean"];
  readonly isSupervisor: Scalars["Boolean"];
  readonly isSupervisorAccessible: Scalars["Boolean"];
  readonly isTechSupport: Scalars["Boolean"];
  readonly isTempUser: Scalars["Boolean"];
  readonly isVideoVerifier: Scalars["Boolean"];
  readonly issueMobileCredentials: Scalars["Boolean"];
  readonly loginToDealerAdmin: Scalars["Boolean"];
  readonly makeDealerPayments: Scalars["Boolean"];
  readonly manageBusinessAnalytics: Scalars["Boolean"];
  readonly mergeUsers: Scalars["Boolean"];
  readonly monitorOnDemand: Scalars["Boolean"];
  readonly moveSystems: Scalars["Boolean"];
  readonly programFullPanel: Scalars["Boolean"];
  readonly readMonitoringReceiverSettingsOnly: Scalars["Boolean"];
  readonly receiveNewsItems: Scalars["Boolean"];
  readonly report: Scalars["Boolean"];
  readonly resetAccess: Scalars["Boolean"];
  readonly resetPersonnelPassword: Scalars["Boolean"];
  readonly revealUserCodes: Scalars["Boolean"];
  readonly runPanelTests: Scalars["Boolean"];
  readonly saveBillingTags: Scalars["Boolean"];
  readonly sendClearBayAlarmBanner: Scalars["Boolean"];
  readonly tempUserExpireTime?: Maybe<Scalars["String"]>;
  readonly testCameras: Scalars["Boolean"];
  readonly updateHikDoorbellFirmware: Scalars["Boolean"];
  readonly updateModemFirmware: Scalars["Boolean"];
  readonly updatePanel: Scalars["Boolean"];
  readonly utilizeTechTools: Scalars["Boolean"];
  readonly viewAccountingReports: Scalars["Boolean"];
  readonly viewAddOnFeatures: Scalars["Boolean"];
  readonly viewAppUsers: Scalars["Boolean"];
  readonly viewAutomation: Scalars["Boolean"];
  readonly viewBulkUpdate: Scalars["Boolean"];
  readonly viewBusinessAnalytics: Scalars["Boolean"];
  readonly viewCellular: Scalars["Boolean"];
  readonly viewCustomBranding: Scalars["Boolean"];
  readonly viewCustomerCampaignEmailTab: Scalars["Boolean"];
  readonly viewCustomerReferralDashboard: Scalars["Boolean"];
  readonly viewCustomerReferralTab: Scalars["Boolean"];
  readonly viewCustomers: Scalars["Boolean"];
  readonly viewCustomersList: Scalars["Boolean"];
  readonly viewDealerInvoices: Scalars["Boolean"];
  readonly viewDealerSettings: Scalars["Boolean"];
  readonly viewDefaultProgramming: Scalars["Boolean"];
  readonly viewGroups: Scalars["Boolean"];
  readonly viewIncludedFeatures: Scalars["Boolean"];
  readonly viewIntegrations: Scalars["Boolean"];
  readonly viewMarketingCentral: Scalars["Boolean"];
  readonly viewMassProgramming: Scalars["Boolean"];
  readonly viewMobileCredentials: Scalars["Boolean"];
  readonly viewOnDemandPricing: Scalars["Boolean"];
  readonly viewPersonnel: Scalars["Boolean"];
  readonly viewPrintProgramming: Scalars["Boolean"];
  readonly viewProfiles: Scalars["Boolean"];
  readonly viewProgramming: Scalars["Boolean"];
  readonly viewReceivers: Scalars["Boolean"];
  readonly viewRemoteUpdate: Scalars["Boolean"];
  readonly viewRemoteUpdateDashboard: Scalars["Boolean"];
  readonly viewReportingAnalytics: Scalars["Boolean"];
  readonly viewSecureComPricing: Scalars["Boolean"];
  readonly viewSecureComStats: Scalars["Boolean"];
  readonly viewSendAllUsersButton: Scalars["Boolean"];
  readonly viewSensorReset: Scalars["Boolean"];
  readonly viewServiceRequests: Scalars["Boolean"];
  readonly viewSystemAnalytics: Scalars["Boolean"];
  readonly viewSystemNotesImages: Scalars["Boolean"];
  readonly viewSystemStatus: Scalars["Boolean"];
  readonly viewSystems: Scalars["Boolean"];
  readonly viewUserCodes: Scalars["Boolean"];
  readonly viewUserSettingsPage: Scalars["Boolean"];
  readonly viewVideoDevice: Scalars["Boolean"];
  readonly viewXrSchedules: Scalars["Boolean"];
  readonly viewXtSchedules: Scalars["Boolean"];
};

export type DealerPersonnelConnection = {
  readonly __typename?: "DealerPersonnelConnection";
  readonly edges: ReadonlyArray<DealerPersonnelEdge>;
  readonly nodes: ReadonlyArray<DealerPersonnel>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type DealerPersonnelEdge = {
  readonly __typename?: "DealerPersonnelEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<DealerPersonnel>;
};

export type DealerPersonnelItem = {
  readonly __typename?: "DealerPersonnelItem";
  readonly customRoleId?: Maybe<Scalars["String"]>;
  readonly customRoleName?: Maybe<Scalars["String"]>;
  readonly dealer_id: Scalars["String"];
  readonly email: Scalars["String"];
  readonly id: Scalars["String"];
  readonly person_email: Scalars["String"];
  readonly role: Scalars["String"];
};

export enum DealerRole {
  ACCOUNTANT = "ACCOUNTANT",
  ADMIN = "ADMIN",
  OPERATOR = "OPERATOR",
  SALES_MANAGER = "SALES_MANAGER",
  SALES_PERSON = "SALES_PERSON",
  TECHNICIAN = "TECHNICIAN",
  VIDEO_VERIFIER = "VIDEO_VERIFIER",
}

export type DealerSystemsOverview = {
  readonly __typename?: "DealerSystemsOverview";
  readonly cellcom: Scalars["Int"];
  readonly dualcom: Scalars["Int"];
  readonly icom: Scalars["Int"];
  readonly month: Scalars["Int"];
  readonly total: Scalars["Int"];
  readonly totalWithApp: Scalars["Int"];
  readonly totalWithCell: Scalars["Int"];
  readonly xr150: Scalars["Int"];
  readonly xr550: Scalars["Int"];
  readonly xt30: Scalars["Int"];
  readonly xt50: Scalars["Int"];
  readonly xtlplus: Scalars["Int"];
  readonly xtltouch: Scalars["Int"];
  readonly year: Scalars["Int"];
};

export type DealerUser = Node &
  User & {
    readonly __typename?: "DealerUser";
    readonly DealerPersonnelCan: DealerPersonnelCan;
    readonly accessibleId: Scalars["Int"];
    readonly accessibleType: AccessibleType;
    readonly active: Scalars["Boolean"];
    readonly customRole?: Maybe<PersonnelCustomRole>;
    readonly dealer: Dealer;
    readonly email: Scalars["EmailAddress"];
    readonly firstName: Scalars["String"];
    readonly hidden: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly lastName: Scalars["String"];
    readonly lastSignInAt?: Maybe<Scalars["DateTime"]>;
    readonly lockedAt?: Maybe<Scalars["DateTime"]>;
    readonly person: Person;
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly role: DealerRole;
    readonly ssoOnly?: Maybe<Scalars["Boolean"]>;
    readonly twoFactorSettings?: Maybe<TwoFactorSettings>;
    readonly userSettings: DealerUserSettings;
  };

export type DealerUserSettings = Node & {
  readonly __typename?: "DealerUserSettings";
  readonly allOthers: Scalars["Boolean"];
  readonly hasUserSettings: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly lightStyle: Scalars["Boolean"];
  readonly mapFilters: DealerUserSettingsMapFilters;
  readonly numOfRecords: Scalars["Boolean"];
  readonly pagination: DealerUserSettingsPagination;
  readonly searchFilter: Scalars["String"];
  readonly showMap: Scalars["Boolean"];
  readonly tableColumns: DealerUserSettingsTableColumns;
  readonly tryNewProgramming: Scalars["Boolean"];
};

export type DealerUserSettingsInput = {
  readonly allOthers?: InputMaybe<Scalars["Boolean"]>;
  readonly hasUserSettings?: InputMaybe<Scalars["Boolean"]>;
  readonly lightStyle?: InputMaybe<Scalars["Boolean"]>;
  readonly mapFilters?: InputMaybe<DealerUserSettingsMapFiltersInput>;
  readonly numOfRecords?: InputMaybe<Scalars["Boolean"]>;
  readonly pagination?: InputMaybe<DealerUserSettingsPaginationInput>;
  readonly searchFilter?: InputMaybe<Scalars["String"]>;
  readonly showMap?: InputMaybe<Scalars["Boolean"]>;
  readonly tableColumns?: InputMaybe<DealerUserSettingsTableColumnsInput>;
  readonly tryNewProgramming?: InputMaybe<Scalars["Boolean"]>;
};

export type DealerUserSettingsMapFilters = {
  readonly __typename?: "DealerUserSettingsMapFilters";
  readonly acTrouble: Scalars["Boolean"];
  readonly alarm: Scalars["Boolean"];
  readonly armInactivity: Scalars["Boolean"];
  readonly carrier: ReadonlyArray<Scalars["String"]>;
  readonly cellSignal: Scalars["Boolean"];
  readonly commType: ReadonlyArray<ControlSystemCommType>;
  readonly hardwareModel: ReadonlyArray<Scalars["String"]>;
  readonly lowBattery: Scalars["Boolean"];
  readonly trouble: Scalars["Boolean"];
};

export type DealerUserSettingsMapFiltersInput = {
  readonly acTrouble?: InputMaybe<Scalars["Boolean"]>;
  readonly alarm?: InputMaybe<Scalars["Boolean"]>;
  readonly armInactivity?: InputMaybe<Scalars["Boolean"]>;
  readonly carrier?: InputMaybe<ReadonlyArray<Scalars["String"]>>;
  readonly cellSignal?: InputMaybe<Scalars["Boolean"]>;
  readonly commType?: InputMaybe<ReadonlyArray<ControlSystemCommType>>;
  readonly hardwareModel?: InputMaybe<ReadonlyArray<Scalars["String"]>>;
  readonly lowBattery?: InputMaybe<Scalars["Boolean"]>;
  readonly trouble?: InputMaybe<Scalars["Boolean"]>;
};

export type DealerUserSettingsPagination = {
  readonly __typename?: "DealerUserSettingsPagination";
  readonly currentPage: Scalars["Int"];
  readonly itemsPerPage: Scalars["Int"];
};

export type DealerUserSettingsPaginationInput = {
  readonly currentPage?: InputMaybe<Scalars["Int"]>;
  readonly itemsPerPage?: InputMaybe<Scalars["Int"]>;
};

export type DealerUserSettingsTableColumns = {
  readonly __typename?: "DealerUserSettingsTableColumns";
  readonly acctNum: Scalars["Boolean"];
  readonly app: Scalars["Boolean"];
  readonly armType: Scalars["Boolean"];
  readonly carrier: Scalars["Boolean"];
  readonly cellNum: Scalars["Boolean"];
  readonly conType: Scalars["Boolean"];
  readonly custAcc: Scalars["Boolean"];
  readonly custName: Scalars["Boolean"];
  readonly lastCon: Scalars["Boolean"];
  readonly netAdd: Scalars["Boolean"];
  readonly noAddrsData: Scalars["Boolean"];
  readonly serNum: Scalars["Boolean"];
  readonly sofDate: Scalars["Boolean"];
  readonly sysName: Scalars["Boolean"];
  readonly sysType: Scalars["Boolean"];
  readonly sysVer: Scalars["Boolean"];
};

export type DealerUserSettingsTableColumnsInput = {
  readonly acctNum?: InputMaybe<Scalars["Boolean"]>;
  readonly app?: InputMaybe<Scalars["Boolean"]>;
  readonly armType?: InputMaybe<Scalars["Boolean"]>;
  readonly carrier?: InputMaybe<Scalars["Boolean"]>;
  readonly cellNum?: InputMaybe<Scalars["Boolean"]>;
  readonly conType?: InputMaybe<Scalars["Boolean"]>;
  readonly custAcc?: InputMaybe<Scalars["Boolean"]>;
  readonly custName?: InputMaybe<Scalars["Boolean"]>;
  readonly lastCon?: InputMaybe<Scalars["Boolean"]>;
  readonly netAdd?: InputMaybe<Scalars["Boolean"]>;
  readonly noAddrsData?: InputMaybe<Scalars["Boolean"]>;
  readonly serNum?: InputMaybe<Scalars["Boolean"]>;
  readonly sofDate?: InputMaybe<Scalars["Boolean"]>;
  readonly sysName?: InputMaybe<Scalars["Boolean"]>;
  readonly sysType?: InputMaybe<Scalars["Boolean"]>;
  readonly sysVer?: InputMaybe<Scalars["Boolean"]>;
};

export type DealerVkOverview = {
  readonly __typename?: "DealerVkOverview";
  readonly advancedReports: Scalars["Int"];
  readonly armOnlyApp: Scalars["Int"];
  readonly cameras: Scalars["Int"];
  readonly doorAccess: Scalars["Int"];
  readonly doorbell: Scalars["Int"];
  readonly fullApp: Scalars["Int"];
  readonly geofencing: Scalars["Int"];
  readonly loginRate: Scalars["Int"];
  readonly month: Scalars["Int"];
  readonly nvr: Scalars["Int"];
  readonly openeye: Scalars["Int"];
  readonly trafficCount: Scalars["Int"];
  readonly videoVerification: Scalars["Int"];
  readonly year: Scalars["Int"];
  readonly zwaveLights: Scalars["Int"];
  readonly zwaveLocks: Scalars["Int"];
  readonly zwaveTherms: Scalars["Int"];
};

export type DeleteAdminBadgeTemplateFailedResponse = {
  readonly __typename?: "DeleteAdminBadgeTemplateFailedResponse";
  readonly message: Scalars["String"];
  readonly type: GenericError;
};

export type DeleteAdminBadgeTemplateResponse =
  | DeleteAdminBadgeTemplateFailedResponse
  | DeleteAdminBadgeTemplateSuccessResponse;

export type DeleteAdminBadgeTemplateSuccessResponse = {
  readonly __typename?: "DeleteAdminBadgeTemplateSuccessResponse";
  readonly customer: Customer;
};

export type DeleteAlarmVisionDeviceErrorPayload = {
  readonly __typename?: "DeleteAlarmVisionDeviceErrorPayload";
  readonly error: ErrorType;
  readonly message?: Maybe<Scalars["String"]>;
};

export type DeleteAlarmVisionDevicePayload =
  | DeleteAlarmVisionDeviceErrorPayload
  | DeleteAlarmVisionDeviceSuccessPayload;

export type DeleteAlarmVisionDeviceSuccessPayload = {
  readonly __typename?: "DeleteAlarmVisionDeviceSuccessPayload";
  readonly deviceNumber: Scalars["Int"];
  readonly jobId?: Maybe<Scalars["String"]>;
};

export type DeleteAreaInformationPayload =
  | DeleteAreaInformationSuccessPayload
  | FailedToRemoveAreaErrorPayload;

export type DeleteAreaInformationSuccessPayload = {
  readonly __typename?: "DeleteAreaInformationSuccessPayload";
  readonly deletedAreaId: Scalars["ID"];
};

export type DeleteAutoEnrolledControlSystemErrorResponse = {
  readonly __typename?: "DeleteAutoEnrolledControlSystemErrorResponse";
  readonly type: DeleteAutoEnrolledControlSystemResponseErrors;
};

export type DeleteAutoEnrolledControlSystemResponse =
  | DeleteAutoEnrolledControlSystemErrorResponse
  | DeleteAutoEnrolledControlSystemSuccessResponse;

export enum DeleteAutoEnrolledControlSystemResponseErrors {
  FAILED_TO_DELETE = "FAILED_TO_DELETE",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
}

export type DeleteAutoEnrolledControlSystemSuccessResponse = {
  readonly __typename?: "DeleteAutoEnrolledControlSystemSuccessResponse";
  readonly dealer?: Maybe<Dealer>;
};

export type DeleteCameraFromHubErrorPayload = {
  readonly __typename?: "DeleteCameraFromHubErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type DeleteCameraFromHubPayload =
  | DeleteCameraFromHubErrorPayload
  | DeleteCameraFromHubSuccessPayload;

export type DeleteCameraFromHubSuccessPayload = {
  readonly __typename?: "DeleteCameraFromHubSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type DeleteClipErrorPayload = {
  readonly __typename?: "DeleteClipErrorPayload";
  readonly error?: Maybe<Error>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type DeleteClipPayload =
  | DeleteClipErrorPayload
  | DeleteClipSuccessPayload;

export type DeleteClipSuccessPayload = {
  readonly __typename?: "DeleteClipSuccessPayload";
  readonly camera: ScapiV3CameraDetails;
};

export type DeleteCommunicationPathPayload =
  | DeleteCommunicationPathSuccessPayload
  | FailedToRemoveCommunicationPathErrorPayload;

export type DeleteCommunicationPathSuccessPayload = {
  readonly __typename?: "DeleteCommunicationPathSuccessPayload";
  readonly deletedCommunicationPathId: Scalars["ID"];
};

export type DeleteControlSystemErrorResponse = {
  readonly __typename?: "DeleteControlSystemErrorResponse";
  readonly type: DeleteControlSystemResponseErrors;
};

export type DeleteControlSystemGroupErrorResponse = {
  readonly __typename?: "DeleteControlSystemGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeleteControlSystemGroupResponse =
  | DeleteControlSystemGroupErrorResponse
  | DeleteControlSystemGroupSuccessResponse;

export type DeleteControlSystemGroupSuccessResponse = {
  readonly __typename?: "DeleteControlSystemGroupSuccessResponse";
  readonly customer?: Maybe<Customer>;
};

export type DeleteControlSystemResponse =
  | DeleteControlSystemErrorResponse
  | DeleteControlSystemSuccessResponse;

export enum DeleteControlSystemResponseErrors {
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  FAILED_TO_DEACTIVATE_SIM = "FAILED_TO_DEACTIVATE_SIM",
  FAILED_TO_DELETE_CONTROL_SYSTEM = "FAILED_TO_DELETE_CONTROL_SYSTEM",
  FAILED_TO_DELETE_PRE_PROGRAMMING = "FAILED_TO_DELETE_PRE_PROGRAMMING",
  FAILED_TO_DELETE_PRE_PROGRAMMING_BACKUPS = "FAILED_TO_DELETE_PRE_PROGRAMMING_BACKUPS",
  FAILED_TO_DELETE_SYSTEM_LOGOS = "FAILED_TO_DELETE_SYSTEM_LOGOS",
  FAILED_TO_DELETE_VIDEO_DEVICES = "FAILED_TO_DELETE_VIDEO_DEVICES",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export type DeleteControlSystemSuccessResponse = {
  readonly __typename?: "DeleteControlSystemSuccessResponse";
  readonly customer?: Maybe<Customer>;
};

export type DeleteCustomerAppUserErrorResponse = {
  readonly __typename?: "DeleteCustomerAppUserErrorResponse";
  readonly type: CustomerError;
};

export type DeleteCustomerAppUserResponse =
  | DeleteCustomerAppUserErrorResponse
  | DeleteCustomerAppUserSuccessResponse;

export type DeleteCustomerAppUserSuccessResponse = {
  readonly __typename?: "DeleteCustomerAppUserSuccessResponse";
  readonly customer?: Maybe<Customer>;
};

export type DeleteDeviceInformationPayload =
  | DeleteDeviceInformationSuccessPayload
  | FailedToRemoveDeviceErrorPayload;

export type DeleteDeviceInformationSuccessPayload = {
  readonly __typename?: "DeleteDeviceInformationSuccessPayload";
  readonly deletedDeviceId: Scalars["ID"];
  readonly deletedZoneNumbers: ReadonlyArray<Scalars["Int"]>;
};

export type DeleteDownloadableFileErrorResponse = {
  readonly __typename?: "DeleteDownloadableFileErrorResponse";
  readonly errorType: ErrorType;
};

export type DeleteDownloadableFileResponse =
  | DeleteDownloadableFileErrorResponse
  | DeleteDownloadableFileSuccessResponse;

export type DeleteDownloadableFileSuccessResponse = {
  readonly __typename?: "DeleteDownloadableFileSuccessResponse";
  readonly dealer: Dealer;
};

export type DeleteFavoriteErrorResponse = {
  readonly __typename?: "DeleteFavoriteErrorResponse";
  readonly error?: Maybe<Error>;
};

export type DeleteFavoriteResponse =
  | DeleteFavoriteErrorResponse
  | DeleteFavoriteSuccessResponse;

export type DeleteFavoriteSuccessResponse = {
  readonly __typename?: "DeleteFavoriteSuccessResponse";
  readonly system: ControlSystem;
};

export type DeleteFromVarHubEnabledCamerasListErrorPayload = {
  readonly __typename?: "DeleteFromVarHubEnabledCamerasListErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type DeleteFromVarHubEnabledCamerasListInput = {
  readonly deleteCamectCameraId?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]>>
  >;
};

export type DeleteFromVarHubEnabledCamerasListPayload =
  | DeleteFromVarHubEnabledCamerasListErrorPayload
  | DeleteFromVarHubEnabledCamerasListSuccessPayload;

export type DeleteFromVarHubEnabledCamerasListSuccessPayload = {
  readonly __typename?: "DeleteFromVarHubEnabledCamerasListSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type DeleteGlobalHolidayDateErrorResponse = {
  readonly __typename?: "DeleteGlobalHolidayDateErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: GlobalHolidayDatesErrors;
};

export type DeleteGlobalHolidayDateResponse =
  | DeleteGlobalHolidayDateErrorResponse
  | DeleteGlobalHolidayDateSuccessResponse;

export type DeleteGlobalHolidayDateSuccessResponse = {
  readonly __typename?: "DeleteGlobalHolidayDateSuccessResponse";
  readonly dealer?: Maybe<Dealer>;
};

export type DeleteGroupErrorResponse = {
  readonly __typename?: "DeleteGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GroupsError;
};

export type DeleteGroupResponse =
  | DeleteGroupErrorResponse
  | DeleteGroupSuccessResponse;

export type DeleteGroupSuccessResponse = {
  readonly __typename?: "DeleteGroupSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteHolidayDateErrorResponse = {
  readonly __typename?: "DeleteHolidayDateErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: HolidayDatesErrors;
};

export type DeleteHolidayDateResponse =
  | DeleteHolidayDateErrorResponse
  | DeleteHolidayDateSuccessResponse;

export type DeleteHolidayDateSuccessResponse = {
  readonly __typename?: "DeleteHolidayDateSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type DeleteKeyfobPayload =
  | DeleteKeyfobSuccessPayload
  | FailedToRemoveKeyfobErrorPayload;

export type DeleteKeyfobSuccessPayload = {
  readonly __typename?: "DeleteKeyfobSuccessPayload";
  readonly deletedKeyfobId: Scalars["ID"];
};

export type DeleteNumberedZwaveNodeFailedResponse = {
  readonly __typename?: "DeleteNumberedZwaveNodeFailedResponse";
  readonly error: Error;
};

export type DeleteNumberedZwaveNodeResponse =
  | DeleteNumberedZwaveNodeFailedResponse
  | DeleteNumberedZwaveNodeSuccessResponse;

export type DeleteNumberedZwaveNodeSuccessResponse = {
  readonly __typename?: "DeleteNumberedZwaveNodeSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type DeleteOutputGroupPayload =
  | DeleteOutputGroupSuccessPayload
  | FailedToRemoveOutputGroupErrorPayload;

export type DeleteOutputGroupSuccessPayload = {
  readonly __typename?: "DeleteOutputGroupSuccessPayload";
  readonly deletedOutputGroupId: Scalars["ID"];
};

export type DeletePanelPersonErrorResponse = {
  readonly __typename?: "DeletePanelPersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeletePanelPersonResponse =
  | DeletePanelPersonErrorResponse
  | DeletePanelPersonSuccessResponse;

export type DeletePanelPersonSuccessResponse = {
  readonly __typename?: "DeletePanelPersonSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type DeletePersonErrorResponse = {
  readonly __typename?: "DeletePersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeletePersonResponse =
  | DeletePersonErrorResponse
  | DeletePersonSuccessResponse;

export type DeletePersonSuccessResponse = {
  readonly __typename?: "DeletePersonSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteProfileErrorResponse = {
  readonly __typename?: "DeleteProfileErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeleteProfileResponse =
  | DeleteProfileErrorResponse
  | DeleteProfileSuccessResponse;

export type DeleteProfileSuccessResponse = {
  readonly __typename?: "DeleteProfileSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteProgrammingTemplateErrorResult = {
  readonly __typename?: "DeleteProgrammingTemplateErrorResult";
  readonly error?: Maybe<ErrorType>;
  readonly messages?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
};

export type DeleteProgrammingTemplateResult =
  | DeleteProgrammingTemplateErrorResult
  | DeleteProgrammingTemplateSuccessResult;

export type DeleteProgrammingTemplateSuccessResult = {
  readonly __typename?: "DeleteProgrammingTemplateSuccessResult";
  readonly deletedTemplateId: Scalars["ID"];
};

export type DeleteReceiverErrorPayload = {
  readonly __typename?: "DeleteReceiverErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type DeleteReceiverPayload =
  | DeleteReceiverErrorPayload
  | DeleteReceiverSuccessPayload;

export type DeleteReceiverSuccessPayload = {
  readonly __typename?: "DeleteReceiverSuccessPayload";
  readonly dealer?: Maybe<Dealer>;
};

export type DeleteSavedReportsResponse =
  | DeleteSavedReportsSuccessPayload
  | UnknownError;

export type DeleteSavedReportsSuccessPayload = {
  readonly __typename?: "DeleteSavedReportsSuccessPayload";
  readonly deletedReports: ReadonlyArray<Report>;
};

export type DeleteSecureComDoorbellPayload = {
  readonly __typename?: "DeleteSecureComDoorbellPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type DeleteSecureComDoorbellResponse =
  | DeleteSecureComDoorbellPayload
  | FailedToDeleteSecureComDoorbellError;

export type DeleteSystemBadgeTemplateFailedResponse = {
  readonly __typename?: "DeleteSystemBadgeTemplateFailedResponse";
  readonly message: Scalars["String"];
  readonly type: GenericError;
};

export type DeleteSystemBadgeTemplateResponse =
  | DeleteSystemBadgeTemplateFailedResponse
  | DeleteSystemBadgeTemplateSuccessResponse;

export type DeleteSystemBadgeTemplateSuccessResponse = {
  readonly __typename?: "DeleteSystemBadgeTemplateSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type DeleteSystemOutputSuccessPayload = {
  readonly __typename?: "DeleteSystemOutputSuccessPayload";
  readonly deletedOutputId: Scalars["ID"];
};

export type DeleteSystemOutputsPayload =
  | DeleteSystemOutputSuccessPayload
  | FailedToRemoveOutputErrorPayload;

export type DeleteTagResponse = DeleteTagSuccessPayload | UnknownError;

export type DeleteTagSuccessPayload = {
  readonly __typename?: "DeleteTagSuccessPayload";
  readonly dealer: Dealer;
  readonly deletedTagId: Scalars["ID"];
  readonly status: Scalars["String"];
};

export type DeleteUniKeyReaderResponse =
  | ReaderDeleteError
  | ReaderDeleteSuccessResponse;

export type DeleteUserCodeErrorResponse = {
  readonly __typename?: "DeleteUserCodeErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeleteUserCodeResponse =
  | DeleteUserCodeErrorResponse
  | DeleteUserCodeSuccessResponse;

export type DeleteUserCodeSuccessResponse = {
  readonly __typename?: "DeleteUserCodeSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly userCode?: Maybe<UserCode>;
};

export type DeleteVarHubErrorPayload = {
  readonly __typename?: "DeleteVarHubErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type DeleteVarHubPayload =
  | DeleteVarHubErrorPayload
  | DeleteVarHubSuccessPayload;

export type DeleteVarHubSuccessPayload = {
  readonly __typename?: "DeleteVarHubSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type DeleteVarVideoActionErrorResponse = {
  readonly __typename?: "DeleteVarVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeleteVarVideoActionResponse =
  | DeleteVarVideoActionErrorResponse
  | DeleteVarVideoActionSuccessResponse;

export type DeleteVarVideoActionSuccessResponse = {
  readonly __typename?: "DeleteVarVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteVideoActionErrorResponse = {
  readonly __typename?: "DeleteVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type DeleteVideoActionResponse =
  | DeleteVideoActionErrorResponse
  | DeleteVideoActionSuccessResponse;

export type DeleteVideoActionSuccessResponse = {
  readonly __typename?: "DeleteVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteX1BackupResponse =
  | DeleteX1BackupSuccessResponse
  | NotFoundError;

export type DeleteX1BackupSuccessResponse = {
  readonly __typename?: "DeleteX1BackupSuccessResponse";
  readonly status: Scalars["String"];
};

export type DeleteXvAudioDeviceErrorResponse = {
  readonly __typename?: "DeleteXvAudioDeviceErrorResponse";
  readonly type: XvAudioDeviceResponseErrors;
};

export type DeleteXvAudioDeviceResponse =
  | DeleteXvAudioDeviceErrorResponse
  | DeleteXvAudioDeviceSuccessResponse;

export type DeleteXvAudioDeviceSuccessResponse = {
  readonly __typename?: "DeleteXvAudioDeviceSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type DeleteZoneInformationPayload =
  | DeleteZoneInformationSuccessPayload
  | FailedToRemoveZoneErrorPayload;

export type DeleteZoneInformationSuccessPayload = {
  readonly __typename?: "DeleteZoneInformationSuccessPayload";
  readonly deletedZoneId: Scalars["ID"];
};

export type DeleteZwaveNodeFailedResponse = {
  readonly __typename?: "DeleteZwaveNodeFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type DeleteZwaveNodeResponse =
  | DeleteZwaveNodeFailedResponse
  | DeleteZwaveNodeSuccessResponse;

export type DeleteZwaveNodeSuccessResponse = {
  readonly __typename?: "DeleteZwaveNodeSuccessResponse";
  readonly jobNumber: Scalars["String"];
  readonly stage: ZwaveNodeStage;
};

export type DestroyAllHlsStreamsErrorPayload = {
  readonly __typename?: "DestroyAllHlsStreamsErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type DestroyAllHlsStreamsPayload =
  | DestroyAllHlsStreamsErrorPayload
  | DestroyAllHlsStreamsSuccessPayload;

export type DestroyAllHlsStreamsSuccessPayload = {
  readonly __typename?: "DestroyAllHlsStreamsSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type DestroyHlsStreamErrorPayload = {
  readonly __typename?: "DestroyHlsStreamErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type DestroyHlsStreamPayload =
  | DestroyHlsStreamErrorPayload
  | DestroyHlsStreamSuccessPayload;

export type DestroyHlsStreamSuccessPayload = {
  readonly __typename?: "DestroyHlsStreamSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type Device734 = Node & {
  readonly __typename?: "Device734";
  readonly armedLockedLedColor?: Maybe<Device734LedColors>;
  readonly buzzerControl?: Maybe<Scalars["Boolean"]>;
  readonly cardFormatOptions?: Maybe<Device734CardOptions>;
  readonly disarmedLockedLedColor?: Maybe<Device734LedColors>;
  readonly enableOnboardSpeaker?: Maybe<Scalars["Boolean"]>;
  readonly enableZone3RequestToExit?: Maybe<Scalars["Boolean"]>;
  readonly enforceSiteCode?: Maybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly ledControl?: Maybe<Scalars["Boolean"]>;
  readonly noCommWithPanelRelayAction?: Maybe<Device734NoCommWithPanelRelayAction>;
  readonly number?: Maybe<Scalars["Int"]>;
  readonly numberOfUserCodeDigits?: Maybe<Scalars["Int"]>;
  readonly osdpPassphrase?: Maybe<Scalars["String"]>;
  readonly proxControl?: Maybe<Scalars["Boolean"]>;
  readonly readerInfo?: Maybe<ReaderInfo>;
  readonly readerInfos?: Maybe<ReadonlyArray<ReaderInfo>>;
  readonly readerProtocol?: Maybe<Device734ReaderProtocol>;
  readonly siteCode1?: Maybe<Scalars["String"]>;
  readonly siteCode2?: Maybe<Scalars["String"]>;
  readonly siteCode3?: Maybe<Scalars["String"]>;
  readonly siteCode4?: Maybe<Scalars["String"]>;
  readonly siteCode5?: Maybe<Scalars["String"]>;
  readonly siteCode6?: Maybe<Scalars["String"]>;
  readonly siteCode7?: Maybe<Scalars["String"]>;
  readonly siteCode8?: Maybe<Scalars["String"]>;
  readonly siteCodeBitLength?: Maybe<Scalars["Int"]>;
  readonly siteCodeStartBitPosition?: Maybe<Scalars["Int"]>;
  readonly tamperControl?: Maybe<Scalars["Boolean"]>;
  readonly unlockedLedColor?: Maybe<Device734LedColors>;
  readonly userCodeBitLength?: Maybe<Scalars["Int"]>;
  readonly userCodeStartBitPosition?: Maybe<Scalars["Int"]>;
  readonly wiegandBitLength?: Maybe<Scalars["Int"]>;
  readonly zone2BypassOnRequestToExit?: Maybe<Scalars["Boolean"]>;
  readonly zone2BypassTime?: Maybe<Scalars["Int"]>;
  readonly zone2RelockOnStateChange?: Maybe<Scalars["Boolean"]>;
  readonly zone3RequestToExitTime?: Maybe<Scalars["Int"]>;
};

export enum Device734CardOptions {
  ANY = "ANY",
  CUSTOM = "CUSTOM",
  DMP = "DMP",
  NONE = "NONE",
}

export type Device734Input = {
  readonly armedLockedLedColor?: InputMaybe<Device734LedColors>;
  readonly buzzerControl?: InputMaybe<Scalars["Boolean"]>;
  readonly cardFormatOptions?: InputMaybe<Device734CardOptions>;
  readonly disarmedLockedLedColor?: InputMaybe<Device734LedColors>;
  readonly enableOnboardSpeaker?: InputMaybe<Scalars["Boolean"]>;
  readonly enableZone3RequestToExit?: InputMaybe<Scalars["Boolean"]>;
  readonly enforceSiteCode?: InputMaybe<Scalars["Boolean"]>;
  readonly ledControl?: InputMaybe<Scalars["Boolean"]>;
  readonly noCommWithPanelRelayAction?: InputMaybe<Device734NoCommWithPanelRelayAction>;
  readonly number?: InputMaybe<Scalars["Int"]>;
  readonly numberOfUserCodeDigits?: InputMaybe<Scalars["Int"]>;
  readonly osdpPassphrase?: InputMaybe<Scalars["String"]>;
  readonly proxControl?: InputMaybe<Scalars["Boolean"]>;
  readonly readerInfos?: InputMaybe<ReadonlyArray<ReaderInfoInput>>;
  readonly readerProtocol?: InputMaybe<Device734ReaderProtocol>;
  readonly siteCode1?: InputMaybe<Scalars["String"]>;
  readonly siteCode2?: InputMaybe<Scalars["String"]>;
  readonly siteCode3?: InputMaybe<Scalars["String"]>;
  readonly siteCode4?: InputMaybe<Scalars["String"]>;
  readonly siteCode5?: InputMaybe<Scalars["String"]>;
  readonly siteCode6?: InputMaybe<Scalars["String"]>;
  readonly siteCode7?: InputMaybe<Scalars["String"]>;
  readonly siteCode8?: InputMaybe<Scalars["String"]>;
  readonly siteCodeBitLength?: InputMaybe<Scalars["Int"]>;
  readonly siteCodeStartBitPosition?: InputMaybe<Scalars["Int"]>;
  readonly tamperControl?: InputMaybe<Scalars["Boolean"]>;
  readonly unlockedLedColor?: InputMaybe<Device734LedColors>;
  readonly userCodeBitLength?: InputMaybe<Scalars["Int"]>;
  readonly userCodeStartBitPosition?: InputMaybe<Scalars["Int"]>;
  readonly wiegandBitLength?: InputMaybe<Scalars["Int"]>;
  readonly zone2BypassOnRequestToExit?: InputMaybe<Scalars["Boolean"]>;
  readonly zone2BypassTime?: InputMaybe<Scalars["Int"]>;
  readonly zone2RelockOnStateChange?: InputMaybe<Scalars["Boolean"]>;
  readonly zone3RequestToExitTime?: InputMaybe<Scalars["Int"]>;
};

export enum Device734LedColors {
  AMBER = "AMBER",
  BLUE = "BLUE",
  CYAN = "CYAN",
  GREEN = "GREEN",
  MAGENTA = "MAGENTA",
  OFF = "OFF",
  RED = "RED",
  WHITE = "WHITE",
}

export enum Device734NoCommWithPanelRelayAction {
  ANY = "ANY",
  LAST = "LAST",
  OFF = "OFF",
  ON = "ON",
  SITE = "SITE",
}

export enum Device734ReaderProtocol {
  NONE = "NONE",
  OSDP = "OSDP",
  WIEGAND = "WIEGAND",
}

export type DeviceInformation = {
  readonly axNumber: Scalars["String"];
  readonly door: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime?: Maybe<DeviceInformationWirelessSupervisionTime>;
  readonly tipe: Scalars["String"];
  readonly tracked: Scalars["Boolean"];
};

export enum DeviceInformation1100TWirelessFrequencyType {
  DSC = "DSC",
  HONEYWELL = "HONEYWELL",
  INTERLOGIX = "INTERLOGIX",
  NONE = "NONE",
  _2GIG = "_2GIG",
}

export enum DeviceInformationCameraDeviceManufacturer {
  AXIS = "AXIS",
  EVOLON = "EVOLON",
  NONE = "NONE",
  SUNELL = "SUNELL",
}

export enum DeviceInformationCommType {
  KEYPAD_BUS = "KEYPAD_BUS",
  NETWORK = "NETWORK",
  NONE = "NONE",
  WIRELESS = "WIRELESS",
}

export enum DeviceInformationType {
  CAMERA = "CAMERA",
  DOOR = "DOOR",
  FIRE = "FIRE",
  KEYPAD = "KEYPAD",
  NONE = "NONE",
  VPLEX = "VPLEX",
  XR550 = "XR550",
  ZONE_EXPANDER = "ZONE_EXPANDER",
  _1100T = "_1100T",
}

export enum DeviceInformationWirelessSupervisionTime {
  NONE = "NONE",
  _60_MIN = "_60_MIN",
  _240_MIN = "_240_MIN",
}

export enum DigitalCardDeliveryType {
  EMAIL = "EMAIL",
  TEXT = "TEXT",
}

export type DigitalWatchdogCamera = Node &
  VideoDevice & {
    readonly __typename?: "DigitalWatchdogCamera";
    readonly ceilingMount: Scalars["Boolean"];
    readonly daylightSavings: Scalars["Boolean"];
    readonly deviceType: VideoDeviceType;
    /** Configuration for if a camera should record a clip if it detects motion */
    readonly eventsEnabled: CameraEventsEnabled;
    /** The live stream URL in HLS format */
    readonly hlsStream?: Maybe<HlsStreamPayload>;
    readonly id: Scalars["ID"];
    /** Configuration where the camera detects motion in its field of view and triggers a clip recording */
    readonly motionDetectionRegions?: Maybe<MotionDetectionRegions>;
    readonly name: Scalars["String"];
    readonly networkStatus: VideoChannelNetworkStatus;
    readonly provider: Scalars["String"];
    /** Configuration for if a camera should record a clip when the panel goes into alarm */
    readonly recordOnAlarm: Scalars["Boolean"];
    /** The most recent still shot of the camera's view */
    readonly snapshot?: Maybe<Scalars["URL"]>;
    readonly timeZone: Scalars["String"];
  };

export type DigitalWatchdogCameraInput = {
  readonly ceilingMount?: InputMaybe<Scalars["Boolean"]>;
  readonly eventsEnabled?: InputMaybe<CameraEventsEnabled>;
  readonly id: Scalars["ID"];
  readonly motionDetectionRegions?: InputMaybe<
    ReadonlyArray<MotionDetectionRegionInput>
  >;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly recordOnAlarm?: InputMaybe<Scalars["Boolean"]>;
};

export type DigitalWatchdogSpectrumNvr = Node &
  VideoDevice & {
    readonly __typename?: "DigitalWatchdogSpectrumNvr";
    readonly channels: ReadonlyArray<DigitalWatchdogSpectrumNvrVideoChannel>;
    readonly createdAt: Scalars["String"];
    readonly deviceType: VideoDeviceType;
    readonly host: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly installerEmail?: Maybe<Scalars["EmailAddress"]>;
    readonly managementPort: Scalars["Int"];
    readonly name: Scalars["String"];
    readonly provider: Scalars["String"];
    readonly serialNumber: Scalars["String"];
    readonly spectrumType: DigitalWatchdogSpectrumType;
    readonly updatedAt: Scalars["String"];
  };

export type DigitalWatchdogSpectrumNvrVideoChannel = Node & {
  readonly __typename?: "DigitalWatchdogSpectrumNvrVideoChannel";
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
};

export enum DigitalWatchdogSpectrumType {
  BLACKJACK = "BLACKJACK",
  CLOUD = "CLOUD",
}

export enum DirectionOfTravel {
  CROSS = "CROSS",
  IN = "IN",
  OFF = "OFF",
  OUT = "OUT",
}

export type DisableCameraErrorPayload = {
  readonly __typename?: "DisableCameraErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type DisableCameraPayload =
  | DisableCameraErrorPayload
  | DisableCameraSuccessPayload;

export type DisableCameraSuccessPayload = {
  readonly __typename?: "DisableCameraSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type DisableTwoFactorAuthenticationError =
  | InvalidPhoneNumberError
  | UnauthorizedError
  | UnknownError;

export type DisableTwoFactorAuthenticationErrorResponse = {
  readonly __typename?: "DisableTwoFactorAuthenticationErrorResponse";
  readonly error: DisableTwoFactorAuthenticationError;
};

export type DisableTwoFactorAuthenticationResponse =
  | DisableTwoFactorAuthenticationErrorResponse
  | DisableTwoFactorAuthenticationSuccessResponse;

export type DisableTwoFactorAuthenticationSuccessResponse = {
  readonly __typename?: "DisableTwoFactorAuthenticationSuccessResponse";
  readonly twoFactorSettings: TwoFactorSettings;
};

export type DisarmMultipleAreasPayload =
  | ArmingError
  | MultipleAreasDisarmedSuccessPayload;

export type DisconnectPanelErrorResponse = {
  readonly __typename?: "DisconnectPanelErrorResponse";
  readonly error: DisconnectPanelErrors;
};

export enum DisconnectPanelErrors {
  FAILED_TO_DISCONNECT = "FAILED_TO_DISCONNECT",
  JOB_FAILED = "JOB_FAILED",
  PANEL_NEVER_CONNECTED = "PANEL_NEVER_CONNECTED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export type DisconnectPanelResponse =
  | DisconnectPanelErrorResponse
  | DisconnectPanelSuccessResponse;

export type DisconnectPanelSuccessResponse = {
  readonly __typename?: "DisconnectPanelSuccessResponse";
  readonly panel: Panel;
};

export type DmpTempUserAuthorization = Node & {
  readonly __typename?: "DmpTempUserAuthorization";
  readonly controlSystemId: Scalars["Int"];
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly expiresAt?: Maybe<Scalars["String"]>;
  readonly grantorEmail: Scalars["String"];
  readonly grantorName?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export enum DmpTempUserAuthorizationErrors {
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  FAILED_TO_AUTHORIZE_DMP_USER = "FAILED_TO_AUTHORIZE_DMP_USER",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export type Door = Node & {
  readonly __typename?: "Door";
  readonly accessible: Scalars["Boolean"];
  readonly deviceNumber: Scalars["String"];
  readonly doorPropTime: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly is734: Scalars["Boolean"];
  readonly isPrivate: Scalars["Boolean"];
  readonly isPublic: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly numberWithName?: Maybe<Scalars["String"]>;
  readonly override: Scalars["Boolean"];
  readonly realTimeStatus: Scalars["Boolean"];
  readonly status: DoorStatus;
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly tracked: Scalars["Boolean"];
};

export enum DoorStatus {
  LOCKED = "LOCKED",
  UNKNOWN = "UNKNOWN",
  UNLOCKED = "UNLOCKED",
}

export enum DoorbellChime {
  MECHANICAL_CHIME = "MECHANICAL_CHIME",
  NO_CHIME = "NO_CHIME",
}

export enum DoorbellConnectionStatus {
  ACTIVATING = "ACTIVATING",
  ACTIVE = "ACTIVE",
  ERROR = "ERROR",
  INACCESSIBLE = "INACCESSIBLE",
}

export type DownloadCamectClipErrorPayload = {
  readonly __typename?: "DownloadCamectClipErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type DownloadCamectClipPayload =
  | DownloadCamectClipErrorPayload
  | DownloadCamectClipSuccessPayload;

export type DownloadCamectClipSuccessPayload = {
  readonly __typename?: "DownloadCamectClipSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
  readonly url?: Maybe<Scalars["String"]>;
};

export type DownloadClipErrorPayload = {
  readonly __typename?: "DownloadClipErrorPayload";
  readonly error?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type DownloadClipPayload =
  | DownloadClipErrorPayload
  | DownloadClipSuccessPayload;

export type DownloadClipSuccessPayload = {
  readonly __typename?: "DownloadClipSuccessPayload";
  readonly uri?: Maybe<Scalars["String"]>;
};

export type DownloadSnapshotErrorPayload = {
  readonly __typename?: "DownloadSnapshotErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type DownloadSnapshotPayload =
  | DownloadSnapshotErrorPayload
  | DownloadSnapshotSuccessPayload;

export type DownloadSnapshotSuccessPayload = {
  readonly __typename?: "DownloadSnapshotSuccessPayload";
  readonly image_url?: Maybe<Scalars["String"]>;
  readonly upload_successful?: Maybe<Scalars["Boolean"]>;
};

export type DownloadableFile = Node & {
  readonly __typename?: "DownloadableFile";
  readonly createdAt: Scalars["DateTime"];
  readonly downloadUrl: Scalars["String"];
  readonly fileName: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly infoUrl: Scalars["String"];
  readonly isPublic: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly type?: Maybe<DownloadableFileType>;
};

export type DownloadableFileConnection = {
  readonly __typename?: "DownloadableFileConnection";
  readonly edges: ReadonlyArray<DownloadableFileEdge>;
  readonly nodes: ReadonlyArray<DownloadableFile>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type DownloadableFileEdge = {
  readonly __typename?: "DownloadableFileEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<DownloadableFile>;
};

export enum DownloadableFileType {
  REMOTE_LINK = "REMOTE_LINK",
}

export enum DualAuthorityEnum {
  ALL = "ALL",
  ARM = "ARM",
  DISARM = "DISARM",
  NO = "NO",
}

export type DuplicateSerialNumberError = Error & {
  readonly __typename?: "DuplicateSerialNumberError";
  readonly type?: Maybe<ErrorType>;
};

export type EagleEyeBridge = Node &
  VideoDevice & {
    readonly __typename?: "EagleEyeBridge";
    readonly channels: ReadonlyArray<EagleEyeBridgeVideoChannel>;
    readonly deviceType: VideoDeviceType;
    readonly id: Scalars["ID"];
    readonly installerEmail?: Maybe<Scalars["EmailAddress"]>;
    readonly name: Scalars["String"];
    readonly serialNumber: Scalars["String"];
    readonly timeZone: Scalars["String"];
  };

export type EagleEyeBridgeVideoChannel = Node & {
  readonly __typename?: "EagleEyeBridgeVideoChannel";
  /** Provides a stream url in HLS format */
  readonly hlsStream?: Maybe<HlsStreamPayload>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  /** The most recent still shot of the camera's view */
  readonly snapshot?: Maybe<Scalars["URL"]>;
  readonly videoCaptureMode: EagleEyeVideoChannelCaptureMode;
  readonly videoDevice: EagleEyeBridge;
};

export type EagleEyeBridgeVideoChannelHlsStreamArgs = {
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export enum EagleEyeVideoChannelCaptureMode {
  ALWAYS = "ALWAYS",
  EVENT = "EVENT",
}

export type EditProgrammingTemplateErrorResult = {
  readonly __typename?: "EditProgrammingTemplateErrorResult";
  readonly error?: Maybe<ErrorType>;
  readonly messages?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
};

export type EditProgrammingTemplateResult =
  | EditProgrammingTemplateErrorResult
  | EditProgrammingTemplateSuccessResult;

export type EditProgrammingTemplateSuccessResult = {
  readonly __typename?: "EditProgrammingTemplateSuccessResult";
  readonly programmingTemplate?: Maybe<ProgrammingTemplate>;
  readonly programmingTemplateEdge?: Maybe<ProgrammingTemplateEdge>;
};

export type EditReceiverErrorPayload = {
  readonly __typename?: "EditReceiverErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type EditReceiverInput = {
  readonly automationPrefix: Scalars["String"];
  readonly centralStationAutomationIntegrationId?: InputMaybe<Scalars["ID"]>;
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly ip: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly port: Scalars["Int"];
  readonly receiverId: Scalars["ID"];
};

export type EditReceiverPayload =
  | EditReceiverErrorPayload
  | EditReceiverSuccessPayload;

export type EditReceiverSuccessPayload = {
  readonly __typename?: "EditReceiverSuccessPayload";
  readonly dealer?: Maybe<Dealer>;
};

export type EmergencyContact = Node & {
  readonly __typename?: "EmergencyContact";
  readonly authorityLevel?: Maybe<ControlSystemCentralStationAutomationIntegrationAuthorityLevel>;
  readonly emailAddress: Scalars["String"];
  readonly firstName: Scalars["String"];
  readonly hasKey?: Maybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly lastName: Scalars["String"];
  readonly order: Scalars["Int"];
  readonly phoneNumber: Scalars["String"];
  readonly phoneType?: Maybe<Scalars["String"]>;
  readonly relationship?: Maybe<Scalars["String"]>;
  readonly shouldContactBeforeDispatch: Scalars["Boolean"];
  readonly verbalPasscode: Scalars["String"];
};

export enum EolResistorValue {
  FOUR_POINT_SEVEN_THOUSAND = "FOUR_POINT_SEVEN_THOUSAND",
  ONE_THOUSAND = "ONE_THOUSAND",
  THREE_POINT_THREE_THOUSAND = "THREE_POINT_THREE_THOUSAND",
  TWO_POINT_TWO_THOUSAND = "TWO_POINT_TWO_THOUSAND",
}

export type Error = {
  readonly type?: Maybe<ErrorType>;
};

export enum ErrorType {
  ALARM_PANEL_INTEGRATION_OUTPUT_SELECTED = "ALARM_PANEL_INTEGRATION_OUTPUT_SELECTED",
  ARMED_OR_FIRE_ZONE = "ARMED_OR_FIRE_ZONE",
  BAD_PRIORITY_ZONES = "BAD_PRIORITY_ZONES",
  BAD_ZONES = "BAD_ZONES",
  CAMERA_OFFLINE = "CAMERA_OFFLINE",
  CANCELLED = "CANCELLED",
  CANNOT_CHANGE_OUTPUT = "CANNOT_CHANGE_OUTPUT",
  CANNOT_CONNECT_REMOTELY = "CANNOT_CONNECT_REMOTELY",
  CANNOT_DELETE_ZONES_FROM_HOST_PANEL = "CANNOT_DELETE_ZONES_FROM_HOST_PANEL",
  CANNOT_DISARM = "CANNOT_DISARM",
  COMBINE_LOGINS_ERROR = "COMBINE_LOGINS_ERROR",
  COMMAND_NOT_EXECUTED = "COMMAND_NOT_EXECUTED",
  CONNECTION_TIMEOUT = "CONNECTION_TIMEOUT",
  CONNECTION_UNSUPPORTED = "CONNECTION_UNSUPPORTED",
  CONTROL_SYSTEM_HAS_TOO_MANY_DOORS = "CONTROL_SYSTEM_HAS_TOO_MANY_DOORS",
  DAILY_REPORT_NOT_ENABLED = "DAILY_REPORT_NOT_ENABLED",
  DUPLICATE_SERIAL_NUMBER = "DUPLICATE_SERIAL_NUMBER",
  FAILED_TO_ACCESS_DOOR = "FAILED_TO_ACCESS_DOOR",
  FAILED_TO_ACCESS_SITE_DOOR = "FAILED_TO_ACCESS_SITE_DOOR",
  FAILED_TO_ADD_CARD_FORMAT = "FAILED_TO_ADD_CARD_FORMAT",
  FAILED_TO_ADD_CONTROL_SYSTEM = "FAILED_TO_ADD_CONTROL_SYSTEM",
  FAILED_TO_ADD_CONTROL_SYSTEMS = "FAILED_TO_ADD_CONTROL_SYSTEMS",
  FAILED_TO_ADD_HOLIDAY_DATE = "FAILED_TO_ADD_HOLIDAY_DATE",
  FAILED_TO_ADD_INSTALLER_MOBILE_CREDENTIAL = "FAILED_TO_ADD_INSTALLER_MOBILE_CREDENTIAL",
  FAILED_TO_ADD_RULE = "FAILED_TO_ADD_RULE",
  FAILED_TO_ADD_SITE_DOOR = "FAILED_TO_ADD_SITE_DOOR",
  FAILED_TO_ADD_USER = "FAILED_TO_ADD_USER",
  FAILED_TO_CHANGE_UNIKEY_READER_NAME = "FAILED_TO_CHANGE_UNIKEY_READER_NAME",
  FAILED_TO_CREATE_SCHEDULE = "FAILED_TO_CREATE_SCHEDULE",
  FAILED_TO_CREATE_SITE = "FAILED_TO_CREATE_SITE",
  FAILED_TO_DEACTIVATE_SITE_DOOR = "FAILED_TO_DEACTIVATE_SITE_DOOR",
  FAILED_TO_DELETE_SECURE_COM_DOORBELL = "FAILED_TO_DELETE_SECURE_COM_DOORBELL",
  FAILED_TO_DELETE_UNIKEY_READER = "FAILED_TO_DELETE_UNIKEY_READER",
  FAILED_TO_FORMAT_SD_CARD = "FAILED_TO_FORMAT_SD_CARD",
  FAILED_TO_ISSUE_MOBILE_CREDENTIALS_TO_CUSTOMER = "FAILED_TO_ISSUE_MOBILE_CREDENTIALS_TO_CUSTOMER",
  FAILED_TO_LOCKDOWN_SYSTEM = "FAILED_TO_LOCKDOWN_SYSTEM",
  FAILED_TO_LOCK_DOOR = "FAILED_TO_LOCK_DOOR",
  FAILED_TO_LOCK_SITE_DOOR = "FAILED_TO_LOCK_SITE_DOOR",
  FAILED_TO_REFRESH_DOORS = "FAILED_TO_REFRESH_DOORS",
  FAILED_TO_REMOVE_CARD_FORMAT = "FAILED_TO_REMOVE_CARD_FORMAT",
  FAILED_TO_REMOVE_HOLIDAY_DATE = "FAILED_TO_REMOVE_HOLIDAY_DATE",
  FAILED_TO_REMOVE_RULE = "FAILED_TO_REMOVE_RULE",
  FAILED_TO_REMOVE_SCHEDULE = "FAILED_TO_REMOVE_SCHEDULE",
  FAILED_TO_REMOVE_SHARED_CLIENT_CONFIGURATION = "FAILED_TO_REMOVE_SHARED_CLIENT_CONFIGURATION",
  FAILED_TO_REMOVE_USER = "FAILED_TO_REMOVE_USER",
  FAILED_TO_RESET_PASSWORD = "FAILED_TO_RESET_PASSWORD",
  FAILED_TO_SAVE_OUTPUTS = "FAILED_TO_SAVE_OUTPUTS",
  FAILED_TO_SAVE_OUTPUT_MODULE = "FAILED_TO_SAVE_OUTPUT_MODULE",
  FAILED_TO_SAVE_SHARED_CLIENT_CONFIGURATION = "FAILED_TO_SAVE_SHARED_CLIENT_CONFIGURATION",
  FAILED_TO_UNLOCK_DOOR = "FAILED_TO_UNLOCK_DOOR",
  FAILED_TO_UNLOCK_SITE_DOOR = "FAILED_TO_UNLOCK_SITE_DOOR",
  FAILED_TO_UPDATE_CARD_FORMAT = "FAILED_TO_UPDATE_CARD_FORMAT",
  FAILED_TO_UPDATE_CONTROL_SYSTEM = "FAILED_TO_UPDATE_CONTROL_SYSTEM",
  FAILED_TO_UPDATE_HOLIDAY_DATE = "FAILED_TO_UPDATE_HOLIDAY_DATE",
  FAILED_TO_UPDATE_RULE = "FAILED_TO_UPDATE_RULE",
  FAILED_TO_UPDATE_SCHEDULE = "FAILED_TO_UPDATE_SCHEDULE",
  FAILED_TO_UPDATE_SECURE_COM_DOORBELL = "FAILED_TO_UPDATE_SECURE_COM_DOORBELL",
  FAILED_TO_UPDATE_SHARED_CLIENT_CONFIGURATION = "FAILED_TO_UPDATE_SHARED_CLIENT_CONFIGURATION",
  FAILED_TO_UPDATE_SITE_DOOR = "FAILED_TO_UPDATE_SITE_DOOR",
  FAILED_TO_UPDATE_USER = "FAILED_TO_UPDATE_USER",
  FAILS_PASSWORD_STANDARDS = "FAILS_PASSWORD_STANDARDS",
  FORBIDDEN = "FORBIDDEN",
  GENERIC = "GENERIC",
  GENERIC_NAK = "GENERIC_NAK",
  HIKVISION_DOORBELL_NOT_ENABLED = "HIKVISION_DOORBELL_NOT_ENABLED",
  HOLIDAY_DATE_NOT_PUSHED_TO_SOME_X1S = "HOLIDAY_DATE_NOT_PUSHED_TO_SOME_X1S",
  INCORRECT_REMOTE_STRING_VERSION = "INCORRECT_REMOTE_STRING_VERSION",
  INITIAL_CONNECT_FAILED = "INITIAL_CONNECT_FAILED",
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  INVALID_AREA_SELECTION = "INVALID_AREA_SELECTION",
  INVALID_CENTRAL_STATION_CODE = "INVALID_CENTRAL_STATION_CODE",
  INVALID_CODE = "INVALID_CODE",
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  INVALID_INPUT = "INVALID_INPUT",
  INVALID_LOGIN_CREDENTIALS = "INVALID_LOGIN_CREDENTIALS",
  INVALID_PASSWORD = "INVALID_PASSWORD",
  INVALID_PHONE_NUMBER = "INVALID_PHONE_NUMBER",
  INVALID_REMOTE_KEY = "INVALID_REMOTE_KEY",
  INVALID_SERIALS = "INVALID_SERIALS",
  MAX_CARD_FORMATS_REACHED = "MAX_CARD_FORMATS_REACHED",
  NOT_ENOUGH_DIGITAL_CREDENTIALS = "NOT_ENOUGH_DIGITAL_CREDENTIALS",
  NOT_ENOUGH_MOBILE_CREDENTIALS = "NOT_ENOUGH_MOBILE_CREDENTIALS",
  NOT_FOUND = "NOT_FOUND",
  NOT_UNIVIEW_CAMERA = "NOT_UNIVIEW_CAMERA",
  NO_BUFFERS = "NO_BUFFERS",
  NO_COMMUNICATION_TYPE_PROVIDED = "NO_COMMUNICATION_TYPE_PROVIDED",
  NO_CONTROL_SYSTEMS_PROVIDED = "NO_CONTROL_SYSTEMS_PROVIDED",
  NO_PRINTER = "NO_PRINTER",
  OFFLINE_PANEL = "OFFLINE_PANEL",
  PANEL_BUSY = "PANEL_BUSY",
  PANEL_NOT_CHECKED_IN = "PANEL_NOT_CHECKED_IN",
  PANEL_PROGRAMMING_FAILED = "PANEL_PROGRAMMING_FAILED",
  POTTER_CONNECTION_BUSY = "POTTER_CONNECTION_BUSY",
  POTTER_CONNECTION_FAILED = "POTTER_CONNECTION_FAILED",
  PRIORITY_ZONE = "PRIORITY_ZONE",
  REMOTE_DISARM_UNSUPPORTED = "REMOTE_DISARM_UNSUPPORTED",
  REQUIRES_ENCRYPTION = "REQUIRES_ENCRYPTION",
  RULE_WOULD_CAUSE_LOOP_ERROR = "RULE_WOULD_CAUSE_LOOP_ERROR",
  SECURECOM_NVR_NOT_ENABLED = "SECURECOM_NVR_NOT_ENABLED",
  SERIAL_NUMBER_NOT_FOUND = "SERIAL_NUMBER_NOT_FOUND",
  SOME_CONTROL_SYSTEMS_HAVE_TOO_MANY_DOORS = "SOME_CONTROL_SYSTEMS_HAVE_TOO_MANY_DOORS",
  SOME_DOORS_DID_NOT_GET_SCHEDULE = "SOME_DOORS_DID_NOT_GET_SCHEDULE",
  STILL_WORKING = "STILL_WORKING",
  TWO_FACTOR_INVALID_CODE = "TWO_FACTOR_INVALID_CODE",
  TWO_FACTOR_MAX_ATTEMPTS_REACHED = "TWO_FACTOR_MAX_ATTEMPTS_REACHED",
  TWO_FACTOR_SESSION_EXPIRED = "TWO_FACTOR_SESSION_EXPIRED",
  TWO_FACTOR_SESSION_FAILURE = "TWO_FACTOR_SESSION_FAILURE",
  UNABLE_TO_PROGRAM_734 = "UNABLE_TO_PROGRAM_734",
  UNABLE_TO_REFRESH_AREA_INFORMATION = "UNABLE_TO_REFRESH_AREA_INFORMATION",
  UNABLE_TO_REFRESH_BELL_OPTIONS = "UNABLE_TO_REFRESH_BELL_OPTIONS",
  UNABLE_TO_REFRESH_COMMUNICATION = "UNABLE_TO_REFRESH_COMMUNICATION",
  UNABLE_TO_REFRESH_DEVICE_SETUP = "UNABLE_TO_REFRESH_DEVICE_SETUP",
  UNABLE_TO_REFRESH_KEYFOBS = "UNABLE_TO_REFRESH_KEYFOBS",
  UNABLE_TO_REFRESH_LOCKOUT_CODE = "UNABLE_TO_REFRESH_LOCKOUT_CODE",
  UNABLE_TO_REFRESH_MESSAGING_SETUP = "UNABLE_TO_REFRESH_MESSAGING_SETUP",
  UNABLE_TO_REFRESH_NETWORK_OPTIONS = "UNABLE_TO_REFRESH_NETWORK_OPTIONS",
  UNABLE_TO_REFRESH_REMOTE_OPTIONS = "UNABLE_TO_REFRESH_REMOTE_OPTIONS",
  UNABLE_TO_REFRESH_SYSTEM_REPORTS = "UNABLE_TO_REFRESH_SYSTEM_REPORTS",
  UNABLE_TO_REFRESH_ZONE_INFORMATION = "UNABLE_TO_REFRESH_ZONE_INFORMATION",
  UNABLE_TO_REFRESH_ZONE_STATUSES = "UNABLE_TO_REFRESH_ZONE_STATUSES",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNAUTHORIZED_BYPASS_ARM = "UNAUTHORIZED_BYPASS_ARM",
  UNAUTHORIZED_DISARM = "UNAUTHORIZED_DISARM",
  UNAUTHORIZED_FORCE_ARM = "UNAUTHORIZED_FORCE_ARM",
  UNAUTHORIZED_REFUSE_ARM = "UNAUTHORIZED_REFUSE_ARM",
  UNAUTHORIZED_UNSCHEDULED_DISARM = "UNAUTHORIZED_UNSCHEDULED_DISARM",
  UNAUTHORIZED_ZONE_BYPASS = "UNAUTHORIZED_ZONE_BYPASS",
  UNKNOWN = "UNKNOWN",
  UNSUPPORTED_DEVICE_TYPE = "UNSUPPORTED_DEVICE_TYPE",
  UNUSED_ZONE = "UNUSED_ZONE",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  ZONE_MONITOR_NAK = "ZONE_MONITOR_NAK",
}

export type EulaStatus = {
  readonly __typename?: "EulaStatus";
  readonly hasAgreed: Scalars["Boolean"];
};

export type Event = {
  readonly animalDetected?: Maybe<Scalars["Boolean"]>;
  readonly cameraNumber?: Maybe<Scalars["Int"]>;
  readonly category: SupportedEventTypeName;
  readonly createdAt: Scalars["DateTime"];
  readonly databaseId: Scalars["String"];
  readonly deviceNumber?: Maybe<Scalars["Int"]>;
  readonly eventAt: Scalars["DateTime"];
  readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
  readonly eventSource: EventSourceType;
  readonly externalActionNumber?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly includeClips?: Maybe<Scalars["Boolean"]>;
  readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
  readonly message: Scalars["String"];
  readonly motionDetected?: Maybe<Scalars["Boolean"]>;
  readonly objectDetected?: Maybe<Scalars["Boolean"]>;
  readonly packageDetected?: Maybe<Scalars["Boolean"]>;
  readonly panelId: Scalars["Int"];
  readonly panelTime: Scalars["String"];
  readonly personDetected?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Use photoUrls instead */
  readonly photo?: Maybe<Scalars["String"]>;
  readonly photoUrls?: Maybe<EventPhotoUrls>;
  readonly subcategory: SupportedEventSubcategoryName;
  readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
  readonly wealth?: Maybe<WealthAttributeTypes>;
};

export type EventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export enum EventPhotoSize {
  LARGE = "LARGE",
  MOBILE_LARGE = "MOBILE_LARGE",
  MOBILE_MEDIUM = "MOBILE_MEDIUM",
  MOBILE_SMALL = "MOBILE_SMALL",
  TABLET = "TABLET",
  THUMB = "THUMB",
  XL = "XL",
}

export type EventPhotoUrls = {
  readonly __typename?: "EventPhotoUrls";
  /** 824 x 535 */
  readonly keypadZoom?: Maybe<Scalars["String"]>;
  /** 425 x 239 */
  readonly mobileLarge?: Maybe<Scalars["String"]>;
  /** Native device size */
  readonly original?: Maybe<Scalars["String"]>;
  /** 100 x 100 */
  readonly thumb?: Maybe<Scalars["String"]>;
};

export enum EventSourceType {
  CAMERA = "CAMERA",
  KEYPAD = "KEYPAD",
  MALMOSET_CAMERA = "MALMOSET_CAMERA",
  PANEL = "PANEL",
  SUNELL_CAMERA = "SUNELL_CAMERA",
  SUNELL_DOORBELL = "SUNELL_DOORBELL",
  UNKNOWN = "UNKNOWN",
  V_6000 = "V_6000",
  XV_24 = "XV_24",
}

export type FailedControlSystem = {
  readonly __typename?: "FailedControlSystem";
  readonly reason?: Maybe<FailedControlSystemReason>;
  readonly serialNumber: Scalars["String"];
};

export enum FailedControlSystemReason {
  COULD_NOT_CONNECT_TO_SYSTEM = "COULD_NOT_CONNECT_TO_SYSTEM",
  DUPLICATE_SERIAL_NUMBER = "DUPLICATE_SERIAL_NUMBER",
}

export type FailedToAccessDoorError = Error & {
  readonly __typename?: "FailedToAccessDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToAccessSiteDoorError = Error & {
  readonly __typename?: "FailedToAccessSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToAddControlSystemError = Error & {
  readonly __typename?: "FailedToAddControlSystemError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToAddControlSystemsError = Error & {
  readonly __typename?: "FailedToAddControlSystemsError";
  readonly failedControlSystems: ReadonlyArray<FailedControlSystem>;
  readonly type?: Maybe<ErrorType>;
};

export type FailedToAddHolidayDateError = Error & {
  readonly __typename?: "FailedToAddHolidayDateError";
  readonly type: ErrorType;
};

export type FailedToAddInstallerMobileCredentialError = Error & {
  readonly __typename?: "FailedToAddInstallerMobileCredentialError";
  readonly type: ErrorType;
};

export type FailedToAddRuleError = Error & {
  readonly __typename?: "FailedToAddRuleError";
  readonly type: ErrorType;
};

export type FailedToAddSiteDoorError = Error & {
  readonly __typename?: "FailedToAddSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToAddUserError = Error & {
  readonly __typename?: "FailedToAddUserError";
  readonly reason?: Maybe<SitePersonMutationFailedReason>;
  readonly type: ErrorType;
};

export type FailedToBeginUserCodeImportBecauseDuplicateInternalNumber =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseDuplicateInternalNumber";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseExternalNumberAlreadyInUse =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseExternalNumberAlreadyInUse";
    readonly externalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseExternalNumberExceededMaxDigits =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseExternalNumberExceededMaxDigits";
    readonly externalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseExternalNumberIsNan =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseExternalNumberIsNan";
    readonly externalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseGroupNotFound =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseGroupNotFound";
    readonly group: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberAlreadyInUse =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberAlreadyInUse";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberExceededMaxDigits =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberExceededMaxDigits";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberInUse =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberInUse";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberIsNan =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberIsNan";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberIsNanOrNotMasked =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberIsNanOrNotMasked";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberNotUnique =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberNotUnique";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInternalNumberOutOfRange =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInternalNumberOutOfRange";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidCredentialFormat =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidCredentialFormat";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidCredentialValue =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidCredentialValue";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidCsvTemplate =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidCsvTemplate";
    readonly reason: FailedToBeginUserCodeImportReasons;
  };

export type FailedToBeginUserCodeImportBecauseInvalidEmail =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidEmail";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidEmailAddress =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidEmailAddress";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidExternalNumber =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidExternalNumber";
    readonly externalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidGroup =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidGroup";
    readonly group: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidGroupName =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidGroupName";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidInternalNumber =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidInternalNumber";
    readonly internalNumber: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidPersonId =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidPersonId";
    readonly personId: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidPin =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidPin";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseInvalidStatus =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseInvalidStatus";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMaxGroupsExceeded =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMaxGroupsExceeded";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMaxPinLengthExceeded =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMaxPinLengthExceeded";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMismatchedNumberCount =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMismatchedNumberCount";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMissingCredentialValue =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMissingCredentialValue";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMissingEmail =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMissingEmail";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMissingGroup =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMissingGroup";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseMissingRequiredField =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseMissingRequiredField";
    readonly field: UserCodeImportMissingFieldNames;
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseOfflinePanels =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseOfflinePanels";
    readonly panelNames: ReadonlyArray<Scalars["String"]>;
    readonly reason: FailedToBeginUserCodeImportReasons;
  };

export type FailedToBeginUserCodeImportBecauseOperationInvalid =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseOperationInvalid";
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecausePersonIdRequiredForOperation =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecausePersonIdRequiredForOperation";
    readonly operation: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecausePersonNotFound =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecausePersonNotFound";
    readonly operation: Scalars["String"];
    readonly personId: Scalars["String"];
    readonly reason: FailedToBeginUserCodeImportReasons;
    readonly row: Scalars["String"];
  };

export type FailedToBeginUserCodeImportBecauseTimedOut =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseTimedOut";
    readonly reason: FailedToBeginUserCodeImportReasons;
  };

export type FailedToBeginUserCodeImportBecauseUnknown =
  FailedToBeginUserCodeImportError & {
    readonly __typename?: "FailedToBeginUserCodeImportBecauseUnknown";
    readonly reason: FailedToBeginUserCodeImportReasons;
  };

export type FailedToBeginUserCodeImportError = {
  readonly reason: FailedToBeginUserCodeImportReasons;
};

export enum FailedToBeginUserCodeImportReasons {
  /** @deprecated Response replaced */
  DUPLICATE_INTERNAL_NUMBER = "DUPLICATE_INTERNAL_NUMBER",
  EXTERNAL_NUMBER_ALREADY_IN_USE = "EXTERNAL_NUMBER_ALREADY_IN_USE",
  EXTERNAL_NUMBER_EXCEEDED_MAX_DIGITS = "EXTERNAL_NUMBER_EXCEEDED_MAX_DIGITS",
  EXTERNAL_NUMBER_IS_NAN = "EXTERNAL_NUMBER_IS_NAN",
  GROUP_NOT_FOUND = "GROUP_NOT_FOUND",
  INTERNAL_NUMBER_ALREADY_IN_USE = "INTERNAL_NUMBER_ALREADY_IN_USE",
  INTERNAL_NUMBER_EXCEEDED_MAX_DIGITS = "INTERNAL_NUMBER_EXCEEDED_MAX_DIGITS",
  /** @deprecated Response replaced */
  INTERNAL_NUMBER_IN_USE = "INTERNAL_NUMBER_IN_USE",
  INTERNAL_NUMBER_IS_NAN = "INTERNAL_NUMBER_IS_NAN",
  INTERNAL_NUMBER_IS_NAN_OR_NOT_MASKED = "INTERNAL_NUMBER_IS_NAN_OR_NOT_MASKED",
  INTERNAL_NUMBER_NOT_UNIQUE = "INTERNAL_NUMBER_NOT_UNIQUE",
  INTERNAL_NUMBER_OUT_OF_RANGE = "INTERNAL_NUMBER_OUT_OF_RANGE",
  INVALID_CREDENTIAL_FORMAT = "INVALID_CREDENTIAL_FORMAT",
  INVALID_CREDENTIAL_VALUE = "INVALID_CREDENTIAL_VALUE",
  INVALID_CSV_TEMPLATE = "INVALID_CSV_TEMPLATE",
  /** @deprecated Response replaced */
  INVALID_EMAIL = "INVALID_EMAIL",
  INVALID_EMAIL_ADDRESS = "INVALID_EMAIL_ADDRESS",
  /** @deprecated Response replaced */
  INVALID_EXTERNAL_NUMBER = "INVALID_EXTERNAL_NUMBER",
  /** @deprecated Response replaced */
  INVALID_GROUP = "INVALID_GROUP",
  INVALID_GROUP_NAME = "INVALID_GROUP_NAME",
  /** @deprecated Response replaced */
  INVALID_INTERNAL_NUMBER = "INVALID_INTERNAL_NUMBER",
  INVALID_OPERATION = "INVALID_OPERATION",
  INVALID_PERSON_ID = "INVALID_PERSON_ID",
  INVALID_PIN = "INVALID_PIN",
  INVALID_STATUS = "INVALID_STATUS",
  MAX_GROUPS_EXCEEDED = "MAX_GROUPS_EXCEEDED",
  MAX_PIN_LENGTH_EXCEEDED = "MAX_PIN_LENGTH_EXCEEDED",
  /** @deprecated Response replaced */
  MISMATCHED_NUMBER_COUNT = "MISMATCHED_NUMBER_COUNT",
  MISSING_CREDENTIAL = "MISSING_CREDENTIAL",
  MISSING_EMAIL = "MISSING_EMAIL",
  MISSING_FIELD = "MISSING_FIELD",
  MISSING_GROUP = "MISSING_GROUP",
  /** @deprecated Response replaced */
  OFFLINE_PANELS = "OFFLINE_PANELS",
  OPERATION_MISSING_PERSON_ID = "OPERATION_MISSING_PERSON_ID",
  PERSON_NOT_FOUND = "PERSON_NOT_FOUND",
  TIMED_OUT = "TIMED_OUT",
  UNKNOWN = "UNKNOWN",
}

export type FailedToCreateScheduleError = Error & {
  readonly __typename?: "FailedToCreateScheduleError";
  readonly type: ErrorType;
};

export type FailedToCreateSiteError = Error & {
  readonly __typename?: "FailedToCreateSiteError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToDeactivateSiteDoorError = Error & {
  readonly __typename?: "FailedToDeactivateSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToDeleteSecureComDoorbellError = Error & {
  readonly __typename?: "FailedToDeleteSecureComDoorbellError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToFormatSdCardError = Error & {
  readonly __typename?: "FailedToFormatSdCardError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToIssueMobileCredentialError = Error & {
  readonly __typename?: "FailedToIssueMobileCredentialError";
  readonly type: ErrorType;
};

export type FailedToIssueMobileCredentialsToCustomerError = Error & {
  readonly __typename?: "FailedToIssueMobileCredentialsToCustomerError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToLockDoorError = Error & {
  readonly __typename?: "FailedToLockDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToLockSiteDoorError = Error & {
  readonly __typename?: "FailedToLockSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToLockdownSystemError = Error & {
  readonly __typename?: "FailedToLockdownSystemError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRefreshDoorsError = Error & {
  readonly __typename?: "FailedToRefreshDoorsError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRefreshOutputOptionsError = Error & {
  readonly __typename?: "FailedToRefreshOutputOptionsError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveAreaErrorPayload = {
  readonly __typename?: "FailedToRemoveAreaErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveCommunicationPathErrorPayload = {
  readonly __typename?: "FailedToRemoveCommunicationPathErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveDeviceErrorPayload = {
  readonly __typename?: "FailedToRemoveDeviceErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveHolidayDateError = Error & {
  readonly __typename?: "FailedToRemoveHolidayDateError";
  readonly type: ErrorType;
};

export type FailedToRemoveKeyfobErrorPayload = {
  readonly __typename?: "FailedToRemoveKeyfobErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveOutputErrorPayload = {
  readonly __typename?: "FailedToRemoveOutputErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveOutputGroupErrorPayload = {
  readonly __typename?: "FailedToRemoveOutputGroupErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveRuleError = Error & {
  readonly __typename?: "FailedToRemoveRuleError";
  readonly type: ErrorType;
};

export type FailedToRemoveScheduleError = Error & {
  readonly __typename?: "FailedToRemoveScheduleError";
  readonly type: ErrorType;
};

export type FailedToRemoveSharedClientConfigurationError = Error & {
  readonly __typename?: "FailedToRemoveSharedClientConfigurationError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToRemoveUserError = Error & {
  readonly __typename?: "FailedToRemoveUserError";
  readonly type: ErrorType;
};

export type FailedToRemoveZoneErrorPayload = {
  readonly __typename?: "FailedToRemoveZoneErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToResetPassword = Error & {
  readonly __typename?: "FailedToResetPassword";
  readonly type: ErrorType;
};

export type FailedToSaveOutputModuleError = Error & {
  readonly __typename?: "FailedToSaveOutputModuleError";
  readonly type: ErrorType;
};

export type FailedToSaveOutputsError = Error & {
  readonly __typename?: "FailedToSaveOutputsError";
  readonly type: ErrorType;
};

export type FailedToSaveSharedClientConfigurationError = Error & {
  readonly __typename?: "FailedToSaveSharedClientConfigurationError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUnlockDoorError = Error & {
  readonly __typename?: "FailedToUnlockDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUnlockSiteDoorError = Error & {
  readonly __typename?: "FailedToUnlockSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateControlSystemError = Error & {
  readonly __typename?: "FailedToUpdateControlSystemError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateHolidayDateError = Error & {
  readonly __typename?: "FailedToUpdateHolidayDateError";
  readonly type: ErrorType;
};

export type FailedToUpdateMessagingSetupError = Error & {
  readonly __typename?: "FailedToUpdateMessagingSetupError";
  readonly type: ErrorType;
};

export type FailedToUpdateOutputOptionsError = Error & {
  readonly __typename?: "FailedToUpdateOutputOptionsError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateRuleError = Error & {
  readonly __typename?: "FailedToUpdateRuleError";
  readonly type: ErrorType;
};

export type FailedToUpdateScheduleError = Error & {
  readonly __typename?: "FailedToUpdateScheduleError";
  readonly type: ErrorType;
};

export type FailedToUpdateSecureComDoorbellError = Error & {
  readonly __typename?: "FailedToUpdateSecureComDoorbellError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateSharedClientConfigurationError = Error & {
  readonly __typename?: "FailedToUpdateSharedClientConfigurationError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateSiteDoorError = Error & {
  readonly __typename?: "FailedToUpdateSiteDoorError";
  readonly type?: Maybe<ErrorType>;
};

export type FailedToUpdateUserError = Error & {
  readonly __typename?: "FailedToUpdateUserError";
  readonly reason?: Maybe<SitePersonMutationFailedReason>;
  readonly type: ErrorType;
};

export type FailsPasswordStandardsError = Error & {
  readonly __typename?: "FailsPasswordStandardsError";
  readonly type: ErrorType;
};

export type Favorite = Node &
  OutputOption & {
    readonly __typename?: "Favorite";
    readonly actions: ReadonlyArray<FavoriteAction>;
    readonly appIcon: Scalars["String"];
    readonly formattedNumber: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
  };

export type FavoriteAction = {
  readonly __typename?: "FavoriteAction";
  readonly id: Scalars["String"];
  readonly nodeNumber: Scalars["Int"];
  readonly settings: ActionSettings;
};

export type FavoriteActionInput = {
  readonly _destroy?: InputMaybe<Scalars["Boolean"]>;
  readonly id?: InputMaybe<Scalars["Int"]>;
  readonly node_number: Scalars["Int"];
  readonly settings: ActionSettingsInput;
};

export type FavoriteInput = {
  readonly actions: ReadonlyArray<FavoriteActionInput>;
  readonly appIcon: Scalars["String"];
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly name: Scalars["String"];
  readonly number?: InputMaybe<Scalars["Int"]>;
};

export type FeatureKey = {
  readonly __typename?: "FeatureKey";
  readonly key: FeatureKeyEnum;
};

export enum FeatureKeyEnum {
  ALL_NO_YES_OPTION = "ALL_NO_YES_OPTION",
  ALL_USER_CODE_CHANGE = "ALL_USER_CODE_CHANGE",
  BANAMEX_MANTRAP = "BANAMEX_MANTRAP",
  BANK_OF_AMERICA = "BANK_OF_AMERICA",
  CANADIAN = "CANADIAN",
  DOOR_ADD_ON_A = "DOOR_ADD_ON_A",
  DOOR_ADD_ON_B = "DOOR_ADD_ON_B",
  DUAL_NETWORK_PATH = "DUAL_NETWORK_PATH",
  DURESS_PLUS_2 = "DURESS_PLUS_2",
  EMAIL_MESSAGING = "EMAIL_MESSAGING",
  ENCRYPTION = "ENCRYPTION",
  EUROPEAN_FEATURES = "EUROPEAN_FEATURES",
  EXPANDED_USERS = "EXPANDED_USERS",
  FE_MORAN = "FE_MORAN",
  IGNORE_BROADCAST = "IGNORE_BROADCAST",
  MINIMUM_USER_NAME = "MINIMUM_USER_NAME",
  NATIONAL_ACCOUNT = "NATIONAL_ACCOUNT",
  PRINTER = "PRINTER",
  RESTRICT_PROFILES = "RESTRICT_PROFILES",
  SERVICE_USER_AUTHENTICATION = "SERVICE_USER_AUTHENTICATION",
  SMITH_SOUTHERN = "SMITH_SOUTHERN",
  SMITH_WESSON = "SMITH_WESSON",
  STARBUCKS = "STARBUCKS",
  SUPPORT_200_KEY_FOBS = "SUPPORT_200_KEY_FOBS",
  WELLS_FARGO = "WELLS_FARGO",
  XR150 = "XR150",
  XR350 = "XR350",
}

export enum FieldName {
  COMPANY = "COMPANY",
  CUSTOM_TEXT = "CUSTOM_TEXT",
  DEPARTMENT_NUMBER = "DEPARTMENT_NUMBER",
  DEPARTMENT_TITLE = "DEPARTMENT_TITLE",
  EMAIL = "EMAIL",
  EMPLOYEE_NUMBER = "EMPLOYEE_NUMBER",
  PHONE_NUMBER = "PHONE_NUMBER",
  USER_TITLE = "USER_TITLE",
}

export type FileTransferCommandInput = {
  readonly deviceNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  readonly readers?: InputMaybe<ReadonlyArray<OsdpReaderInput>>;
  readonly systemId: Scalars["ID"];
};

export type FilterCombinedEventsErrorPayload = {
  readonly __typename?: "FilterCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type FilterCombinedEventsPayload =
  | FilterCombinedEventsErrorPayload
  | FilterCombinedEventsSuccessPayload;

export type FilterCombinedEventsSuccessPayload = {
  readonly __typename?: "FilterCombinedEventsSuccessPayload";
  readonly system?: Maybe<ControlSystem>;
};

export type FindZwaveNodeFailedResponse = {
  readonly __typename?: "FindZwaveNodeFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type FindZwaveNodeResponse =
  | FindZwaveNodeFailedResponse
  | FindZwaveNodeSuccessResponse;

export type FindZwaveNodeSuccessResponse = {
  readonly __typename?: "FindZwaveNodeSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly jobNumber?: Maybe<Scalars["String"]>;
  readonly stage: ZwaveNodeStage;
};

export type ForbiddenError = Error & {
  readonly __typename?: "ForbiddenError";
  readonly type?: Maybe<ErrorType>;
};

export type ForgiveUserError = Error & {
  readonly __typename?: "ForgiveUserError";
  readonly type?: Maybe<ErrorType>;
};

export type ForgiveUserPayload = ForgiveUserError | ForgiveUserSuccessPayload;

export type ForgiveUserSuccessPayload = {
  readonly __typename?: "ForgiveUserSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type FormatSdCardPayload = {
  readonly __typename?: "FormatSdCardPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly success: Scalars["Boolean"];
};

export type GenerateAllSystemsJobReportInput = {
  readonly AppUserEmailAddress: Scalars["String"];
  readonly DesiredReportFormat: GenerateAllSystemsReportFormat;
  readonly ReportType: GenerateAllSystemsJobTypeFormat;
  readonly Title: Scalars["String"];
};

export enum GenerateAllSystemsJobTypeFormat {
  PROFILES = "PROFILES",
  UNKNOWN = "UNKNOWN",
  USER_CODES = "USER_CODES",
}

export type GenerateAllSystemsReportErrorPayload = {
  readonly __typename?: "GenerateAllSystemsReportErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export enum GenerateAllSystemsReportFormat {
  PDF = "PDF",
  UNKNOWN = "UNKNOWN",
  XLSX = "XLSX",
}

export type GenerateAllSystemsReportInput = {
  readonly Data: ReadonlyArray<ReadonlyArray<InputMaybe<Scalars["String"]>>>;
  readonly Format: GenerateAllSystemsReportFormat;
  readonly Headers: ReadonlyArray<InputMaybe<Scalars["String"]>>;
  readonly Recipient: Scalars["String"];
  readonly Title: Scalars["String"];
};

export type GenerateAllSystemsReportResponse =
  | GenerateAllSystemsReportErrorPayload
  | GenerateAllSystemsReportSuccessPayload;

export type GenerateAllSystemsReportSuccessPayload = {
  readonly __typename?: "GenerateAllSystemsReportSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type GenerateReportInput = {
  readonly Data: Scalars["String"];
  readonly Format: GenerateAllSystemsReportFormat;
  readonly Headers: ReadonlyArray<InputMaybe<Scalars["String"]>>;
  readonly Recipient: Scalars["String"];
  readonly Title: Scalars["String"];
};

export type GenerateReportResponse =
  | GenerateReportSuccessPayload
  | UnknownError;

export type GenerateReportSuccessPayload = {
  readonly __typename?: "GenerateReportSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type GenericArea = Area &
  Node & {
    readonly __typename?: "GenericArea";
    readonly armedStatus: AreaArmedStatusEnum;
    readonly arming: Scalars["Boolean"];
    readonly autoArmEnabled: Scalars["Boolean"];
    readonly autoDisarmEnabled: Scalars["Boolean"];
    readonly badZonesOption: BadZonesOption;
    readonly disarming: Scalars["Boolean"];
    readonly hasChanges: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isArmable: Scalars["Boolean"];
    readonly isDisarmable: Scalars["Boolean"];
    readonly isInAlarm: Scalars["Boolean"];
    readonly isNew: Scalars["Boolean"];
    readonly maxNameLength: Scalars["Int"];
    readonly maxNumber: Scalars["Int"];
    readonly minNumber: Scalars["Int"];
    readonly name: Scalars["String"];
    readonly number: Scalars["String"];
    readonly numberWithName?: Maybe<Scalars["String"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  };

export enum GenericError {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export type GenericNakError = Error & {
  readonly __typename?: "GenericNakError";
  readonly type?: Maybe<ErrorType>;
};

export type GenericUnknownError = Error & {
  readonly __typename?: "GenericUnknownError";
  readonly type?: Maybe<ErrorType>;
};

export enum GeoJsonType {
  FEATURE = "FEATURE",
  FEATURECOLLECTION = "FEATURECOLLECTION",
  GEOMETRYCOLLECTION = "GEOMETRYCOLLECTION",
  LINESTRING = "LINESTRING",
  MULTILINESTRING = "MULTILINESTRING",
  MULTIPOINT = "MULTIPOINT",
  MULTIPOLYGON = "MULTIPOLYGON",
  POINT = "POINT",
  POLYGON = "POLYGON",
}

export type GetCustomerUsersByPersonIdsErrorResponse = {
  readonly __typename?: "GetCustomerUsersByPersonIdsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type GetCustomerUsersByPersonIdsResponse =
  | GetCustomerUsersByPersonIdsErrorResponse
  | GetCustomerUsersByPersonIdsSuccessResponse;

export type GetCustomerUsersByPersonIdsSuccessResponse = {
  readonly __typename?: "GetCustomerUsersByPersonIdsSuccessResponse";
  readonly customerUsers: ReadonlyArray<Maybe<CustomerPerson>>;
};

export type GetHlsEventPlaybackErrorPayload = {
  readonly __typename?: "GetHlsEventPlaybackErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type GetHlsEventPlaybackPayload =
  | GetHlsEventPlaybackErrorPayload
  | GetHlsEventPlaybackSuccessPayload;

export type GetHlsEventPlaybackSuccessPayload = {
  readonly __typename?: "GetHlsEventPlaybackSuccessPayload";
  readonly url?: Maybe<Scalars["String"]>;
};

export type GetHlsObjectErrorPayload = {
  readonly __typename?: "GetHlsObjectErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type GetHlsObjectPayload =
  | GetHlsObjectErrorPayload
  | GetHlsObjectSuccessPayload;

export type GetHlsObjectSuccessPayload = {
  readonly __typename?: "GetHlsObjectSuccessPayload";
  readonly end_ts_ms?: Maybe<Scalars["Int"]>;
  readonly hls_url?: Maybe<Scalars["String"]>;
  readonly start_ts_ms?: Maybe<Scalars["Int"]>;
  readonly stream_type?: Maybe<Scalars["String"]>;
  readonly stream_url?: Maybe<Scalars["String"]>;
};

export type GetHlsStreamErrorPayload = {
  readonly __typename?: "GetHlsStreamErrorPayload";
  readonly details?: Maybe<Scalars["String"]>;
  readonly error?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type GetHlsStreamPayload =
  | GetHlsStreamErrorPayload
  | GetHlsStreamSuccessPayload;

export type GetHlsStreamSuccessPayload = {
  readonly __typename?: "GetHlsStreamSuccessPayload";
  readonly url?: Maybe<Scalars["String"]>;
};

export type GetLightStatusErrorPayload = {
  readonly __typename?: "GetLightStatusErrorPayload";
  readonly error?: Maybe<Error>;
};

export type GetLightStatusPayload =
  | GetLightStatusErrorPayload
  | GetLightStatusSuccessPayload;

export type GetLightStatusSuccessPayload = {
  readonly __typename?: "GetLightStatusSuccessPayload";
  readonly redBlueLightStatus: Scalars["Boolean"];
  readonly whiteLightStatus: Scalars["Boolean"];
};

export type GetNodeConnectionStatusFailedResponse = {
  readonly __typename?: "GetNodeConnectionStatusFailedResponse";
  readonly error?: Maybe<Error>;
};

export type GetNodeConnectionStatusResponse =
  | GetNodeConnectionStatusFailedResponse
  | GetNodeConnectionStatusSuccessResponse;

export type GetNodeConnectionStatusSuccessResponse = {
  readonly __typename?: "GetNodeConnectionStatusSuccessResponse";
  readonly connectionFailed: Scalars["Boolean"];
};

export type GetOpportunityDashboardCustomerFeatureExportDataErrorResponse = {
  readonly __typename?: "GetOpportunityDashboardCustomerFeatureExportDataErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type GetOpportunityDashboardCustomerFeatureExportDataResponse =
  | GetOpportunityDashboardCustomerFeatureExportDataErrorResponse
  | GetOpportunityDashboardCustomerFeatureExportDataSuccessResponse;

export type GetOpportunityDashboardCustomerFeatureExportDataSuccessResponse = {
  readonly __typename?: "GetOpportunityDashboardCustomerFeatureExportDataSuccessResponse";
  readonly data: ReadonlyArray<
    Maybe<OpportunityDashboardCustomerFeatureExportData>
  >;
};

export type GetOpportunityDashboardSystemFeatureExportDataErrorResponse = {
  readonly __typename?: "GetOpportunityDashboardSystemFeatureExportDataErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type GetOpportunityDashboardSystemFeatureExportDataResponse =
  | GetOpportunityDashboardSystemFeatureExportDataErrorResponse
  | GetOpportunityDashboardSystemFeatureExportDataSuccessResponse;

export type GetOpportunityDashboardSystemFeatureExportDataSuccessResponse = {
  readonly __typename?: "GetOpportunityDashboardSystemFeatureExportDataSuccessResponse";
  readonly data: ReadonlyArray<
    Maybe<OpportunityDashboardSystemFeatureExportData>
  >;
};

export type GetPanelPersonCredentialsErrorResponse = {
  readonly __typename?: "GetPanelPersonCredentialsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type GetPanelPersonCredentialsResponse =
  | GetPanelPersonCredentialsErrorResponse
  | GetPanelPersonCredentialsSuccessResponse;

export type GetPanelPersonCredentialsSuccessResponse = {
  readonly __typename?: "GetPanelPersonCredentialsSuccessResponse";
  readonly credentials?: Maybe<ReadonlyArray<Maybe<PanelPersonCredential>>>;
};

export type GetPanelUserSecurityCodeErrorResponse = {
  readonly __typename?: "GetPanelUserSecurityCodeErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type GetPanelUserSecurityCodeResponse =
  | GetPanelUserSecurityCodeErrorResponse
  | GetPanelUserSecurityCodeSuccessResponse;

export type GetPanelUserSecurityCodeSuccessResponse = {
  readonly __typename?: "GetPanelUserSecurityCodeSuccessResponse";
  readonly codeDetails?: Maybe<
    ReadonlyArray<Maybe<PanelUserSecurityCodeDetails>>
  >;
};

export type GetVarHubErrorPayload = {
  readonly __typename?: "GetVarHubErrorPayload";
  readonly message: Scalars["String"];
  readonly type: Scalars["String"];
};

export type GetVarHubPayload = GetVarHubErrorPayload | GetVarHubSuccessPayload;

export type GetVarHubSettingsErrorPayload = {
  readonly __typename?: "GetVarHubSettingsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type GetVarHubSettingsPayload =
  | GetVarHubSettingsErrorPayload
  | GetVarHubSettingsSuccessPayload;

export type GetVarHubSettingsSuccessPayload = {
  readonly __typename?: "GetVarHubSettingsSuccessPayload";
  readonly settings: VarHubSettings;
};

export type GetVarHubSuccessPayload = {
  readonly __typename?: "GetVarHubSuccessPayload";
  readonly hub: VarHub;
};

export type GetWebRtcEventObjectErrorPayload = {
  readonly __typename?: "GetWebRTCEventObjectErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type GetWebRtcEventObjectPayload =
  | GetWebRtcEventObjectErrorPayload
  | GetWebRtcEventObjectSuccessPayload;

export type GetWebRtcEventObjectSuccessPayload = {
  readonly __typename?: "GetWebRTCEventObjectSuccessPayload";
  readonly expires: Scalars["String"];
  readonly streamType: Scalars["String"];
  readonly traceId: Scalars["String"];
  readonly webrtcDetails: WebRtcEventDetails;
};

/** The panel association is an extremely taxing query for the API, so do NOT ask for it unless you absolutely need it. I REPEAT, DO NOT ASK FOR PANEL ASSOCIATION UNLESS YOU REALLY NEED IT! */
export type GlobalHolidayDate = Node & {
  readonly __typename?: "GlobalHolidayDate";
  /** Clazz is spelled clazz because there is sometimes a problem with using class because it's a key word in JS */
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["Date"];
  readonly description: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  /** The panel association is an extremely taxing query for the API, so do NOT ask for it unless you absolutely need it. I REPEAT, DO NOT ASK FOR PANEL ASSOCIATION UNLESS YOU REALLY NEED IT! */
  readonly panelAssociation: ReadonlyArray<Scalars["Int"]>;
  readonly scapiId: Scalars["Int"];
};

export type GlobalHolidayDateSingle = Node & {
  readonly __typename?: "GlobalHolidayDateSingle";
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["Date"];
  readonly description: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly panelAssociation: ReadonlyArray<Scalars["Int"]>;
  readonly scapiId: Scalars["Int"];
};

export enum GlobalHolidayDatesErrors {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  CONFLICT = "CONFLICT",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export enum Grades {
  GRADE_0 = "GRADE_0",
  GRADE_2 = "GRADE_2",
  GRADE_3 = "GRADE_3",
}

export type GraphQlLogInfo = {
  readonly __typename?: "GraphQLLogInfo";
  readonly body?: Maybe<Scalars["String"]>;
  readonly headers?: Maybe<Scalars["String"]>;
  readonly method: HttpMethod;
  readonly response?: Maybe<Scalars["String"]>;
  readonly startTime: Scalars["DateTime"];
  readonly status: Scalars["Int"];
  readonly timeElapsed: Scalars["Int"];
  readonly url: Scalars["URL"];
};

export type Group = Node & {
  readonly __typename?: "Group";
  readonly accessibleAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly areas?: Maybe<ReadonlyArray<Maybe<Area>>>;
  readonly armableAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly doors?: Maybe<ReadonlyArray<Maybe<Door>>>;
  readonly id: Scalars["ID"];
  readonly name?: Maybe<Scalars["String"]>;
  readonly number?: Maybe<Scalars["String"]>;
  readonly options?: Maybe<Options>;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly schedules?: Maybe<ReadonlyArray<Maybe<Schedule>>>;
};

export type GroupEdge = {
  readonly __typename?: "GroupEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: Group;
};

export type GroupInput = {
  readonly areas?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  readonly doors?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly number: Scalars["String"];
  readonly options?: InputMaybe<OptionsInput>;
  readonly schedules?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
};

export type GroupsConnection = {
  readonly __typename?: "GroupsConnection";
  readonly edges: ReadonlyArray<GroupEdge>;
  readonly nodes: ReadonlyArray<Group>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export enum GroupsError {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  CONNECTION_TIMEOUT = "CONNECTION_TIMEOUT",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export type HanwhaNvr = Node &
  VideoDevice & {
    readonly __typename?: "HanwhaNvr";
    readonly channels: ReadonlyArray<HanwhaNvrVideoChannel>;
    readonly deviceType: VideoDeviceType;
    readonly host: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly installerEmail?: Maybe<Scalars["EmailAddress"]>;
    readonly managementPort: Scalars["Int"];
    readonly model: Scalars["String"];
    readonly name: Scalars["String"];
    readonly serialNumber: Scalars["String"];
    readonly status: Scalars["String"];
    readonly streamingPort: Scalars["Int"];
    readonly timeZone: Scalars["String"];
  };

export type HanwhaNvrVideoChannel = Node & {
  readonly __typename?: "HanwhaNvrVideoChannel";
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly videoDevice: HanwhaNvr;
};

export type HelpFileUrls = {
  readonly __typename?: "HelpFileUrls";
  readonly appHelpFileUrl: Scalars["String"];
  readonly hardwareModel: PanelHardwareModel;
  readonly installGuideUrl: Scalars["String"];
  readonly programmingGuideUrl: Scalars["String"];
};

export type HelpFileUrlsAppHelpFileUrlArgs = {
  app: ClientApp;
};

export type HideFromVarHubEnabledCamerasListErrorPayload = {
  readonly __typename?: "HideFromVarHubEnabledCamerasListErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type HideFromVarHubEnabledCamerasListInput = {
  readonly hideCamectCameraId?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]>>
  >;
};

export type HideFromVarHubEnabledCamerasListPayload =
  | HideFromVarHubEnabledCamerasListErrorPayload
  | HideFromVarHubEnabledCamerasListSuccessPayload;

export type HideFromVarHubEnabledCamerasListSuccessPayload = {
  readonly __typename?: "HideFromVarHubEnabledCamerasListSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type HikvisionDoorbellNotEnabledError = Error & {
  readonly __typename?: "HikvisionDoorbellNotEnabledError";
  readonly type?: Maybe<ErrorType>;
};

export type HikvisionNvr = Node &
  VideoDevice & {
    readonly __typename?: "HikvisionNvr";
    readonly channels: ReadonlyArray<HikvisionNvrVideoChannel>;
    readonly deviceType: VideoDeviceType;
    readonly host: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly managementPort: Scalars["Int"];
    readonly model: Scalars["String"];
    readonly name: Scalars["String"];
    readonly serialNumber: Scalars["String"];
    readonly status: Scalars["String"];
    readonly streamingPort: Scalars["Int"];
    readonly timeZone: Scalars["String"];
  };

export type HikvisionNvrInput = {
  readonly password: Scalars["String"];
  readonly username: Scalars["String"];
};

export enum HikvisionNvrQuality {
  HIGH = "HIGH",
  LOW = "LOW",
}

export type HikvisionNvrVideoChannel = Node & {
  readonly __typename?: "HikvisionNvrVideoChannel";
  /**
   * Provides a stream url in HLS format.
   * Note: "quality" will be ignored if a "startTime" is provided because Hikvision Nvr's only support high res playback.
   */
  readonly hlsStream?: Maybe<HlsStreamPayload>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  /** The most recent still shot of the camera's view */
  readonly snapshot?: Maybe<Scalars["URL"]>;
  readonly videoDevice: HikvisionNvr;
};

export type HikvisionNvrVideoChannelHlsStreamArgs = {
  quality?: InputMaybe<HikvisionNvrQuality>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type HlsStreamPayload = {
  readonly __typename?: "HlsStreamPayload";
  readonly hlsUrl: Scalars["URL"];
  readonly token: Scalars["String"];
};

export type HolidayDate = Node & {
  readonly __typename?: "HolidayDate";
  readonly class: HolidayDateClass;
  readonly date: Scalars["Date"];
  readonly description: Scalars["String"];
  readonly globalHolidayId?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly isGlobalHoliday: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
};

export enum HolidayDateClass {
  A = "A",
  B = "B",
  C = "C",
}

export type HolidayDateNotPushedToSomeX1sError = Error & {
  readonly __typename?: "HolidayDateNotPushedToSomeX1sError";
  readonly holidayDate: HolidayDate;
  readonly type: ErrorType;
};

export type HolidayDateSchedule = {
  readonly __typename?: "HolidayDateSchedule";
  readonly endTime?: Maybe<Scalars["String"]>;
  readonly startTime?: Maybe<Scalars["String"]>;
};

export enum HolidayDatesErrors {
  BAD_INPUT = "BAD_INPUT",
  DUPLICATE = "DUPLICATE",
  JOB_FAILURE = "JOB_FAILURE",
  LIMIT = "LIMIT",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  UNKNOWN = "UNKNOWN",
  VALIDATION_FAILED = "VALIDATION_FAILED",
}

export enum HostCommFormat {
  CID = "CID",
  DD = "DD",
  FOUR2 = "FOUR2",
  SIA = "SIA",
}

export enum HttpMethod {
  DELETE = "DELETE",
  GET = "GET",
  OTHER = "OTHER",
  PATCH = "PATCH",
  POST = "POST",
  PUT = "PUT",
}

export type IdpGroup = Node & {
  readonly __typename?: "IdpGroup";
  readonly id: Scalars["ID"];
  readonly linkedProfileIds: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly name: Scalars["String"];
};

export type IdpGroupInput = {
  readonly id: Scalars["ID"];
  readonly linkedProfileIds: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
};

export enum IdpPersonStatus {
  /** Raw: 1 */
  IDP_PERSON_PENDING_CREDENTIALS = "IDP_PERSON_PENDING_CREDENTIALS",
  /** Raw: 2 */
  IDP_PERSON_SYNCED = "IDP_PERSON_SYNCED",
  /** Raw: 0 */
  NON_IDP_PERSON = "NON_IDP_PERSON",
  /** Null value */
  UNKNOWN = "UNKNOWN",
}

export type IncorrectRemoteStringVersionError = Error & {
  readonly __typename?: "IncorrectRemoteStringVersionError";
  readonly type?: Maybe<ErrorType>;
};

export type InitialConnectionFailure = Error & {
  readonly __typename?: "InitialConnectionFailure";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly site?: Maybe<Site>;
  readonly type?: Maybe<ErrorType>;
};

export enum InitialConnectionStatus {
  COMPLETE = "COMPLETE",
  NONE = "NONE",
  PENDING = "PENDING",
}

export type InitializePasswordChangeSuccessResponse = {
  readonly __typename?: "InitializePasswordChangeSuccessResponse";
  readonly passwordChangeToken: Scalars["String"];
};

export enum InspectionReminder {
  NONE = "NONE",
  ONE_YEAR = "ONE_YEAR",
  SIX_MONTHS = "SIX_MONTHS",
  THREE_MONTHS = "THREE_MONTHS",
}

export type InvalidAccountNumberError = Error & {
  readonly __typename?: "InvalidAccountNumberError";
  readonly type?: Maybe<ErrorType>;
};

export type InvalidAreaSelectionError = Error & {
  readonly __typename?: "InvalidAreaSelectionError";
  readonly type?: Maybe<ErrorType>;
};

export type InvalidCentralStationCodeError = Error & {
  readonly __typename?: "InvalidCentralStationCodeError";
  readonly type: ErrorType;
};

export type InvalidCodeError = Error & {
  readonly __typename?: "InvalidCodeError";
  readonly type?: Maybe<ErrorType>;
};

export type InvalidCredentialsError = Error & {
  readonly __typename?: "InvalidCredentialsError";
  readonly type: ErrorType;
};

export type InvalidField = {
  readonly __typename?: "InvalidField";
  readonly fieldName: Scalars["String"];
  readonly reason?: Maybe<Scalars["String"]>;
};

export type InvalidInputError = Error & {
  readonly __typename?: "InvalidInputError";
  readonly invalidField?: Maybe<InvalidField>;
  readonly type?: Maybe<ErrorType>;
};

export type InvalidLoginCredentialsError = Error & {
  readonly __typename?: "InvalidLoginCredentialsError";
  readonly type: ErrorType;
};

export type InvalidPasswordError = Error & {
  readonly __typename?: "InvalidPasswordError";
  readonly type: ErrorType;
};

export type InvalidPhoneNumberError = Error & {
  readonly __typename?: "InvalidPhoneNumberError";
  readonly type: ErrorType;
};

export type InvalidRemoteKeyError = Error & {
  readonly __typename?: "InvalidRemoteKeyError";
  readonly type?: Maybe<ErrorType>;
};

export type InvalidSerialsError = Error & {
  readonly __typename?: "InvalidSerialsError";
  readonly controlSystemSerialNumbers: ReadonlyArray<Scalars["String"]>;
  readonly type?: Maybe<ErrorType>;
};

export type IssueMobileCredentialResponse =
  | FailedToIssueMobileCredentialError
  | IssueMobileCredentialSuccessResponse;

export type IssueMobileCredentialSuccessResponse = {
  readonly __typename?: "IssueMobileCredentialSuccessResponse";
  readonly customer: Customer;
};

export type IssueMobileCredentialsToCustomerInput = {
  readonly amount: Scalars["Int"];
  readonly notes: Scalars["String"];
};

export type JobDataType = {
  readonly __typename?: "JobDataType";
  readonly operation?: Maybe<Scalars["String"]>;
};

export type JobOutputDetail = {
  readonly __typename?: "JobOutputDetail";
  readonly customerName?: Maybe<Scalars["String"]>;
  readonly message?: Maybe<Scalars["String"]>;
  readonly panelId?: Maybe<Scalars["Int"]>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly systemName?: Maybe<Scalars["String"]>;
  readonly systemType?: Maybe<Scalars["String"]>;
};

export type JobProgressArgs = {
  readonly jobId?: Maybe<Scalars["String"]>;
};

export type KeepHlsStreamAliveErrorPayload = {
  readonly __typename?: "KeepHlsStreamAliveErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type KeepHlsStreamAlivePayload =
  | KeepHlsStreamAliveErrorPayload
  | KeepHlsStreamAliveSuccessPayload;

export type KeepHlsStreamAliveSuccessPayload = {
  readonly __typename?: "KeepHlsStreamAliveSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type KeyValuePairInput = {
  readonly key: Scalars["String"];
  readonly value: Scalars["StringOrInt"];
};

export type Keyfob = Node & {
  readonly __typename?: "Keyfob";
  readonly buttonFourAction: KeyfobButtonType;
  readonly buttonFourAreas: Scalars["String"];
  readonly buttonFourOutput: Scalars["String"];
  readonly buttonFourOutputAction: KeyfobOutputAction;
  readonly buttonFourPressTime: KeyfobPressTime;
  readonly buttonOneAction: KeyfobButtonType;
  readonly buttonOneAreas: Scalars["String"];
  readonly buttonOneOutput: Scalars["String"];
  readonly buttonOneOutputAction: KeyfobOutputAction;
  readonly buttonOnePressTime: KeyfobPressTime;
  readonly buttonThreeAction: KeyfobButtonType;
  readonly buttonThreeAreas: Scalars["String"];
  readonly buttonThreeOutput: Scalars["String"];
  readonly buttonThreeOutputAction: KeyfobOutputAction;
  readonly buttonThreePressTime: KeyfobPressTime;
  readonly buttonTwoAction: KeyfobButtonType;
  readonly buttonTwoAreas: Scalars["String"];
  readonly buttonTwoOutput: Scalars["String"];
  readonly buttonTwoOutputAction: KeyfobOutputAction;
  readonly buttonTwoPressTime: KeyfobPressTime;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly keyfobName: Scalars["String"];
  readonly keyfobSerialNumber: Scalars["String"];
  readonly keyfobSupervisionTime: KeyfobSupervisionTime;
  readonly number: Scalars["Int"];
  readonly numberOfButtons: KeyfobNumberOfButtons;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly user?: Maybe<UserCode>;
};

export enum KeyfobButtonType {
  ARMING = "ARMING",
  DISARMING = "DISARMING",
  EMERGENCY = "EMERGENCY",
  EMERGENCY_TWO_BUTTON = "EMERGENCY_TWO_BUTTON",
  HOLDUP = "HOLDUP",
  HOLDUP_TWO_BUTTON = "HOLDUP_TWO_BUTTON",
  OUTPUT = "OUTPUT",
  PANIC = "PANIC",
  PANIC_TWO_BUTTON = "PANIC_TWO_BUTTON",
  SENSOR_RESET = "SENSOR_RESET",
  STATUS = "STATUS",
  TOGGLE_ARM_DISARM = "TOGGLE_ARM_DISARM",
  UNUSED = "UNUSED",
}

export type KeyfobInput = {
  readonly buttonFourAction: KeyfobButtonType;
  readonly buttonFourAreas: Scalars["String"];
  readonly buttonFourOutput: Scalars["String"];
  readonly buttonFourOutputAction: KeyfobOutputAction;
  readonly buttonFourPressTime: KeyfobPressTime;
  readonly buttonOneAction: KeyfobButtonType;
  readonly buttonOneAreas: Scalars["String"];
  readonly buttonOneOutput: Scalars["String"];
  readonly buttonOneOutputAction: KeyfobOutputAction;
  readonly buttonOnePressTime: KeyfobPressTime;
  readonly buttonThreeAction: KeyfobButtonType;
  readonly buttonThreeAreas: Scalars["String"];
  readonly buttonThreeOutput: Scalars["String"];
  readonly buttonThreeOutputAction: KeyfobOutputAction;
  readonly buttonThreePressTime: KeyfobPressTime;
  readonly buttonTwoAction: KeyfobButtonType;
  readonly buttonTwoAreas: Scalars["String"];
  readonly buttonTwoOutput: Scalars["String"];
  readonly buttonTwoOutputAction: KeyfobOutputAction;
  readonly buttonTwoPressTime: KeyfobPressTime;
  readonly isNew: Scalars["Boolean"];
  readonly keyfobName?: InputMaybe<Scalars["String"]>;
  readonly keyfobSerialNumber: Scalars["String"];
  readonly keyfobSupervisionTime: KeyfobSupervisionTime;
  readonly number: Scalars["Int"];
  readonly numberOfButtons: KeyfobNumberOfButtons;
  readonly userNumber: Scalars["Int"];
};

export enum KeyfobNumberOfButtons {
  FOUR = "FOUR",
  ONE = "ONE",
  TWO = "TWO",
  ZERO = "ZERO",
}

export enum KeyfobOutputAction {
  MOMENTARY = "MOMENTARY",
  OFF = "OFF",
  PULSE = "PULSE",
  STEADY = "STEADY",
  TOGGLE = "TOGGLE",
}

export enum KeyfobPressTime {
  LONG = "LONG",
  SHORT = "SHORT",
}

export type KeyfobProgrammingInput = {
  readonly buttonFourAction: KeyfobButtonType;
  readonly buttonFourAreas: Scalars["String"];
  readonly buttonFourOutput: Scalars["String"];
  readonly buttonFourOutputAction: KeyfobOutputAction;
  readonly buttonFourPressTime: KeyfobPressTime;
  readonly buttonOneAction: KeyfobButtonType;
  readonly buttonOneAreas: Scalars["String"];
  readonly buttonOneOutput: Scalars["String"];
  readonly buttonOneOutputAction: KeyfobOutputAction;
  readonly buttonOnePressTime: KeyfobPressTime;
  readonly buttonThreeAction: KeyfobButtonType;
  readonly buttonThreeAreas: Scalars["String"];
  readonly buttonThreeOutput: Scalars["String"];
  readonly buttonThreeOutputAction: KeyfobOutputAction;
  readonly buttonThreePressTime: KeyfobPressTime;
  readonly buttonTwoAction: KeyfobButtonType;
  readonly buttonTwoAreas: Scalars["String"];
  readonly buttonTwoOutput: Scalars["String"];
  readonly buttonTwoOutputAction: KeyfobOutputAction;
  readonly buttonTwoPressTime: KeyfobPressTime;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly keyfobName?: InputMaybe<Scalars["String"]>;
  readonly keyfobSerialNumber: Scalars["String"];
  readonly keyfobSupervisionTime: KeyfobSupervisionTime;
  readonly number: Scalars["Int"];
  readonly numberOfButtons: KeyfobNumberOfButtons;
  readonly userNumber: Scalars["Int"];
};

export enum KeyfobSupervisionTime {
  NONE = "NONE",
  _60_MIN = "_60_MIN",
  _240_MIN = "_240_MIN",
}

export enum KeypadArmedLed {
  ALL = "ALL",
  ANY = "ANY",
}

export enum KeypadInput {
  DSC = "DSC",
  ECP = "ECP",
  NONE = "NONE",
}

export type KeypadProgramming = {
  readonly __typename?: "KeypadProgramming";
  readonly details?: Maybe<ScapiV2JobErrorDetails>;
  readonly status: Scalars["String"];
  readonly uuid: Scalars["String"];
};

export type KeypadsOverview = Node & {
  readonly __typename?: "KeypadsOverview";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly controlSystemId: Scalars["Int"];
  readonly customerName: Scalars["String"];
  readonly firmwareVersion: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly keypadSerial: Scalars["String"];
  readonly model: Scalars["String"];
  readonly panelCommType: Scalars["String"];
  readonly panelId: Scalars["Int"];
  readonly panelName: Scalars["String"];
  readonly recordNumber: Scalars["Int"];
  readonly remoteUpdateTimestamp?: Maybe<Scalars["String"]>;
  readonly updateAvailable?: Maybe<Scalars["Boolean"]>;
};

export type LightSchedule = {
  readonly __typename?: "LightSchedule";
  readonly day?: Maybe<Scalars["String"]>;
  readonly endAmPm?: Maybe<Scalars["String"]>;
  readonly endHour?: Maybe<Scalars["Int"]>;
  readonly endMinute?: Maybe<Scalars["Int"]>;
  readonly lightColor?: Maybe<Scalars["String"]>;
  readonly startAmPm?: Maybe<Scalars["String"]>;
  readonly startHour?: Maybe<Scalars["Int"]>;
  readonly startMinute?: Maybe<Scalars["Int"]>;
};

export type LightScheduleInput = {
  readonly day?: InputMaybe<Scalars["String"]>;
  readonly endAmPm?: InputMaybe<Scalars["String"]>;
  readonly endHour?: InputMaybe<Scalars["Int"]>;
  readonly endMinute?: InputMaybe<Scalars["Int"]>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly lightColor?: InputMaybe<Scalars["String"]>;
  readonly startAmPm?: InputMaybe<Scalars["String"]>;
  readonly startHour?: InputMaybe<Scalars["Int"]>;
  readonly startMinute?: InputMaybe<Scalars["Int"]>;
};

export type LightSchedules = {
  readonly __typename?: "LightSchedules";
  readonly schedule?: Maybe<ReadonlyArray<LightSchedule>>;
};

export type LinkAnalyticalDetectionLineToZoneErrorPayload = {
  readonly __typename?: "LinkAnalyticalDetectionLineToZoneErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type LinkAnalyticalDetectionLineToZonePayload =
  | LinkAnalyticalDetectionLineToZoneErrorPayload
  | LinkAnalyticalDetectionLineToZoneSuccessPayload;

export type LinkAnalyticalDetectionLineToZoneSuccessPayload = {
  readonly __typename?: "LinkAnalyticalDetectionLineToZoneSuccessPayload";
  readonly analyticalDetectionLine?: Maybe<AnalyticalDetectionLine>;
};

export type LinkAnalyticalDetectionRegionToZoneErrorPayload = {
  readonly __typename?: "LinkAnalyticalDetectionRegionToZoneErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type LinkAnalyticalDetectionRegionToZonePayload =
  | LinkAnalyticalDetectionRegionToZoneErrorPayload
  | LinkAnalyticalDetectionRegionToZoneSuccessPayload;

export type LinkAnalyticalDetectionRegionToZoneSuccessPayload = {
  readonly __typename?: "LinkAnalyticalDetectionRegionToZoneSuccessPayload";
  readonly analyticalDetectionRegion?: Maybe<AnalyticalDetectionRegion>;
};

export type LinkedProfile = Node & {
  readonly __typename?: "LinkedProfile";
  readonly customerId: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly profileIds: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly siteId?: Maybe<Scalars["Int"]>;
};

export type LoadMoreCombinedEventsErrorPayload = {
  readonly __typename?: "LoadMoreCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type LoadMoreCombinedEventsPayload =
  | LoadMoreCombinedEventsErrorPayload
  | LoadMoreCombinedEventsSuccessPayload;

/** The CombinedEvents API uses offset pagination, while Relay only allows cursor-based pagination. Rather than trying to use a pagination fragment to load more, we use this mutation to get the next page of events and add them to the store. */
export type LoadMoreCombinedEventsSuccessPayload = {
  readonly __typename?: "LoadMoreCombinedEventsSuccessPayload";
  readonly system?: Maybe<ControlSystem>;
};

export type LoadMoreEventsErrorPayload = {
  readonly __typename?: "LoadMoreEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type LoadMoreEventsPayload =
  | LoadMoreEventsErrorPayload
  | LoadMoreEventsSuccessPayload;

/** Relay does not allow plural pagination queries, which is a capability we need on the admin events page. So, we use this mutation to get the next page of events and add them to the store. */
export type LoadMoreEventsSuccessPayload = {
  readonly __typename?: "LoadMoreEventsSuccessPayload";
  readonly customer?: Maybe<Customer>;
};

export type LockDoorMutationFailedResponse = {
  readonly __typename?: "LockDoorMutationFailedResponse";
  readonly error: Error;
  readonly message: Scalars["String"];
};

export type LockDoorMutationResponse =
  | LockDoorMutationFailedResponse
  | LockDoorMutationSuccessResponse;

export type LockDoorMutationSuccessResponse = {
  readonly __typename?: "LockDoorMutationSuccessResponse";
  readonly door: Door;
};

export type LockSiteDoorResponse =
  | FailedToLockSiteDoorError
  | NotFoundError
  | SiteDoor;

export type LockZwaveLockFailedResponse = {
  readonly __typename?: "LockZwaveLockFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type LockZwaveLockResponse =
  | LockZwaveLockFailedResponse
  | LockZwaveLockSuccessResponse;

export type LockZwaveLockSuccessResponse = {
  readonly __typename?: "LockZwaveLockSuccessResponse";
  readonly zwaveLock: ZwaveLock;
};

export type LockdownMutationFailedResponse = {
  readonly __typename?: "LockdownMutationFailedResponse";
  readonly error: Error;
};

export type LockdownMutationResponse =
  | LockdownMutationFailedResponse
  | LockdownMutationSuccessResponse;

export type LockdownMutationSuccessResponse = {
  readonly __typename?: "LockdownMutationSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type LockdownSiteResponse = {
  readonly __typename?: "LockdownSiteResponse";
  readonly site?: Maybe<Site>;
};

export type LockoutCode = Node & {
  readonly __typename?: "LockoutCode";
  readonly code: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
};

export type LxBusDiagnostic = {
  readonly __typename?: "LxBusDiagnostic";
  readonly lx_diagnostic?: Maybe<LxDiagnostic>;
};

export type LxDiagnostic = {
  readonly __typename?: "LxDiagnostic";
  readonly number: Scalars["String"];
  readonly status: Scalars["String"];
};

export enum ManagerFirst {
  IS_MANAGER = "IS_MANAGER",
  OFF = "OFF",
  REQUIRES_MANAGER = "REQUIRES_MANAGER",
}

export type MassProgramPanelQuickDetailedCustomer =
  MassProgramPanelQuickDetailedCustomersBase & {
    readonly __typename?: "MassProgramPanelQuickDetailedCustomer";
    readonly controlSystemId?: Maybe<Scalars["String"]>;
    readonly controlSystemName?: Maybe<Scalars["String"]>;
    readonly customerId?: Maybe<Scalars["Int"]>;
    readonly customerName?: Maybe<Scalars["String"]>;
    readonly panelHardwareModel?: Maybe<Scalars["String"]>;
  };

export type MassProgramPanelQuickDetailedCustomersBase = {
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly customerName?: Maybe<Scalars["String"]>;
};

export type MassProgramPanelQuickDetailedErrorResponse = {
  readonly __typename?: "MassProgramPanelQuickDetailedErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly errorType: Scalars["String"];
};

export enum MassProgramPanelQuickDetailedErrors {
  NOT_FOUND = "NOT_FOUND",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN = "UNKNOWN",
}

export type MassProgramPanelQuickDetailedResponse =
  | MassProgramPanelQuickDetailedErrorResponse
  | MassProgramPanelQuickDetailedSuccessResponse;

export type MassProgramPanelQuickDetailedSuccessResponse = {
  readonly __typename?: "MassProgramPanelQuickDetailedSuccessResponse";
  readonly customers: ReadonlyArray<
    Maybe<MassProgramPanelQuickDetailedCustomer>
  >;
};

export type MaxCardFormatsReachedError = Error & {
  readonly __typename?: "MaxCardFormatsReachedError";
  readonly type?: Maybe<ErrorType>;
};

export type MediaProfile = {
  readonly __typename?: "MediaProfile";
  readonly codec?: Maybe<Scalars["String"]>;
  readonly height?: Maybe<Scalars["Int"]>;
  readonly name: Scalars["String"];
  readonly width?: Maybe<Scalars["Int"]>;
};

export type MediaProfileInput = {
  readonly codec?: InputMaybe<Scalars["String"]>;
  readonly height?: InputMaybe<Scalars["Int"]>;
  readonly name: Scalars["String"];
  readonly width?: InputMaybe<Scalars["Int"]>;
};

export type MenuDisplay = Node & {
  readonly __typename?: "MenuDisplay";
  readonly armDisarmDisplayKeypads: Scalars["String"];
  readonly armedStatusDisplayKeypads: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly timeDisplayKeypads: Scalars["String"];
};

export type MenuDisplayInput = {
  readonly armDisarmDisplayKeypads: Scalars["String"];
  readonly armedStatusDisplayKeypads: Scalars["String"];
  readonly timeDisplayKeypads: Scalars["String"];
};

export type MessagingSetup = Node & {
  readonly __typename?: "MessagingSetup";
  readonly enableMessaging: Scalars["Boolean"];
  readonly firstEmailOrPhoneNumber: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly secondEmailOrPhoneNumber: Scalars["String"];
  readonly sendSmsOnOpeningAndClosing: Scalars["Boolean"];
  readonly systemName: Scalars["String"];
  readonly thirdEmailOrPhoneNumber: Scalars["String"];
  readonly userNumberForFirstContact: Scalars["String"];
  readonly userNumberForSecondContact: Scalars["String"];
  readonly userNumberForThirdContact: Scalars["String"];
};

export type MessagingSetupInput = {
  readonly enableMessaging: Scalars["Boolean"];
  readonly firstEmailOrPhoneNumber: Scalars["String"];
  readonly secondEmailOrPhoneNumber: Scalars["String"];
  readonly sendSmsOnOpeningAndClosing: Scalars["Boolean"];
  readonly systemName: Scalars["String"];
  readonly thirdEmailOrPhoneNumber: Scalars["String"];
  readonly userNumberForFirstContact: Scalars["String"];
  readonly userNumberForSecondContact: Scalars["String"];
  readonly userNumberForThirdContact: Scalars["String"];
};

export type MetaGraphQlNetworkLogsConnection = {
  readonly __typename?: "MetaGraphQLNetworkLogsConnection";
  readonly edges: ReadonlyArray<MetaGraphQlNetworkLogsConnectionEdge>;
  readonly nodes: ReadonlyArray<GraphQlLogInfo>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type MetaGraphQlNetworkLogsConnectionEdge = {
  readonly __typename?: "MetaGraphQLNetworkLogsConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: GraphQlLogInfo;
};

export type MobileCredentialHistoryEvent = Node & {
  readonly __typename?: "MobileCredentialHistoryEvent";
  readonly amount: Scalars["Int"];
  readonly by: Scalars["String"];
  readonly cost: Scalars["Float"];
  readonly customer?: Maybe<Customer>;
  readonly customerName: Scalars["String"];
  readonly date: Scalars["DateTime"];
  readonly id: Scalars["ID"];
  readonly notes: Scalars["String"];
};

export type MobileCredentialsHistoryEdge = {
  readonly __typename?: "MobileCredentialsHistoryEdge";
  readonly cursor: Scalars["ID"];
  readonly node: MobileCredentialHistoryEvent;
};

export type MotionDetectionRegion = {
  readonly __typename?: "MotionDetectionRegion";
  readonly coordinates: ReadonlyArray<MotionDetectionRegionCoordinates>;
  readonly dayObjectSize?: Maybe<Scalars["Int"]>;
  readonly daySensitivityLevel?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly linkedAlarmZone?: Maybe<Scalars["Int"]>;
  readonly linkedPanelId?: Maybe<Scalars["Int"]>;
  readonly linkedZoneAreaNumber?: Maybe<Scalars["String"]>;
  readonly nightObjectSize?: Maybe<Scalars["Int"]>;
  readonly nightSensitivityLevel?: Maybe<Scalars["Int"]>;
};

export type MotionDetectionRegionCoordinates = {
  readonly __typename?: "MotionDetectionRegionCoordinates";
  readonly x: Scalars["Int"];
  readonly y: Scalars["Int"];
};

export type MotionDetectionRegionCoordinatesInput = {
  readonly x: Scalars["Int"];
  readonly y: Scalars["Int"];
};

export type MotionDetectionRegionInput = {
  readonly coordinates: ReadonlyArray<MotionDetectionRegionCoordinatesInput>;
  readonly dayObjectSize?: InputMaybe<Scalars["Int"]>;
  readonly daySensitivityLevel?: InputMaybe<Scalars["Int"]>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly nightObjectSize?: InputMaybe<Scalars["Int"]>;
  readonly nightSensitivityLevel?: InputMaybe<Scalars["Int"]>;
};

export type MotionDetectionRegions = {
  readonly __typename?: "MotionDetectionRegions";
  readonly maxCoordinatesX: Scalars["Int"];
  readonly maxCoordinatesY: Scalars["Int"];
  readonly minCoordinatesX: Scalars["Int"];
  readonly minCoordinatesY: Scalars["Int"];
  readonly regions: ReadonlyArray<MotionDetectionRegion>;
};

export type MoveDigitalWatchdogCameraPayload = {
  readonly __typename?: "MoveDigitalWatchdogCameraPayload";
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type MoveDigitalWatchdogCameraToPresetPayload = {
  readonly __typename?: "MoveDigitalWatchdogCameraToPresetPayload";
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type MovePtCameraErrorPayload = {
  readonly __typename?: "MovePTCameraErrorPayload";
  readonly error?: Maybe<PanTiltError>;
};

export type MovePtCameraPayload =
  | MovePtCameraErrorPayload
  | MovePtCameraSuccessPayload;

export type MovePtCameraSuccessPayload = {
  readonly __typename?: "MovePTCameraSuccessPayload";
  readonly camera?: Maybe<ScapiV3CameraDetails>;
};

export type MovePtCameraToPresetErrorPayload = {
  readonly __typename?: "MovePTCameraToPresetErrorPayload";
  readonly error?: Maybe<PanTiltError>;
};

export type MovePtCameraToPresetPayload =
  | MovePtCameraToPresetErrorPayload
  | MovePtCameraToPresetSuccessPayload;

export type MovePtCameraToPresetSuccessPayload = {
  readonly __typename?: "MovePTCameraToPresetSuccessPayload";
  readonly camera?: Maybe<ScapiV3CameraDetails>;
};

export type MoveSecureComCameraPayload = {
  readonly __typename?: "MoveSecureComCameraPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type MoveSecureComCameraToPresetPayload = {
  readonly __typename?: "MoveSecureComCameraToPresetPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type MultipleAreasArmedSuccessPayload = {
  readonly __typename?: "MultipleAreasArmedSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type MultipleAreasDisarmedSuccessPayload = {
  readonly __typename?: "MultipleAreasDisarmedSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type MutateCentralStationGlobalPasscodesErrorResponse = {
  readonly __typename?: "MutateCentralStationGlobalPasscodesErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: CentralStationGlobalPasscodeError;
};

export type MutateCentralStationGlobalPasscodesSuccessResponse = {
  readonly __typename?: "MutateCentralStationGlobalPasscodesSuccessResponse";
  readonly integration: ControlSystemCentralStationAutomationIntegration;
};

export type Mutation = {
  readonly __typename?: "Mutation";
  readonly SendDealerKeypadContactInfo: SendDealerKeypadContactInfoResponse;
  readonly accessDoor: AccessDoorMutationResponse;
  readonly accessSiteDoor: AccessSiteDoorResponse;
  readonly activateFavorite: ActivateFavoriteResponse;
  readonly addCameraByRtsp?: Maybe<AddCameraByRtspPayload>;
  readonly addContact: AddContactPayload;
  readonly addDealerCentralStationAutomationIntegration: AddDealerCentralStationAutomationIntegrationResponse;
  readonly addHikvisionNvr: AddHikvisionNvrResponse;
  readonly addInstallerMobileCredential: AddInstallerMobileCredentialResponse;
  readonly addMobileCredentialCardFormat: AddMobileCredentialCardFormatResponse;
  readonly addReceiver: AddReceiverPayload;
  readonly addRule: AddRuleResponse;
  readonly addSite: AddSiteResponse;
  readonly addSiteCardFormat: AddSiteCardFormatResponse;
  readonly addSiteControlSystem: AddSiteControlSystemResponse;
  readonly addSiteControlSystemOutputModule: AddSiteControlSystemOutputModuleResponse;
  readonly addSiteDoorSchedule: AddSiteDoorScheduleResponse;
  readonly addSiteGroup: AddSiteGroupResponse;
  readonly addSiteHolidayDate: AddHolidayDateResponse;
  readonly addSitePerson: AddSitePersonResponse;
  readonly addSiteReport: AddSiteReportResponse;
  readonly addTag: AddTagResponse;
  readonly addToVarHubEnabledCamerasList: AddToVarHubEnabledCamerasListPayload;
  readonly addVarHub: AddVarHubPayload;
  readonly addXvAudioDevice: AddXvAudioDeviceResponse;
  readonly addZwaveNode: AddZwaveNodeResponse;
  readonly agreeToAdminEula: EulaStatus;
  readonly agreeToEula: EulaStatus;
  readonly armAll: ArmMultipleAreasPayload;
  readonly armAllAreas: ArmMultipleAreasPayload;
  readonly armArea: ArmMultipleAreasPayload;
  readonly armAway: ArmMultipleAreasPayload;
  readonly armHome: ArmMultipleAreasPayload;
  readonly armPerimeter: ArmMultipleAreasPayload;
  readonly armSleep: ArmMultipleAreasPayload;
  readonly armStay: ArmMultipleAreasPayload;
  readonly authenticate: AuthenticateResponse;
  readonly authorizeDmpUser: AuthorizeDmpUserResponse;
  readonly beginImportUserCodes: BeginImportUserCodesResponse;
  readonly beginImportX1UserCodes: ReadonlyArray<
    Maybe<BeginX1ImportUserCodesResponse>
  >;
  readonly bypassZone: BypassZonePayload;
  readonly bypassZoneStatus: BypassZoneStatusPayload;
  readonly bypassZonesStatus: BypassZonesStatusPayload;
  readonly cancelOperation?: Maybe<Scalars["Boolean"]>;
  readonly changePassword: ChangePasswordResponse;
  readonly changeUniKeyReaderName: ChangeUniKeyReaderNameResponse;
  readonly claimSystem: ClaimSystemResponse;
  readonly closeBarrierOperator: CloseBarrierOperatorResponse;
  readonly combineLogins: CombineLoginsPayload;
  readonly configureTwoFactorSettings: ConfigureTwoFactorSettingsResponse;
  readonly confirmJob: ConfirmJobResponse;
  readonly createAlarmVisionDevice: CreateAlarmVisionDevicePayload;
  readonly createAlarmZoneAndLinkToAnalyticalDetectionLine: LinkAnalyticalDetectionLineToZonePayload;
  readonly createAlarmZoneAndLinkToAnalyticalDetectionRegion: LinkAnalyticalDetectionRegionToZonePayload;
  readonly createControlSystemGroup: CreateControlSystemGroupResponse;
  readonly createFavorite: CreateFavoriteResponse;
  readonly createGlobalHolidayDate: CreateGlobalHolidayDateResponse;
  readonly createGroup: CreateGroupResponse;
  readonly createHolidayDate: CreateHolidayDateResponse;
  readonly createPanelEventBufferJob: CreatePanelEventBufferJobResponse;
  readonly createPanelPerson: CreatePanelPersonResponse;
  readonly createProfile: CreateProfileResponse;
  readonly createSavedReport: CreateSavedReportResponse;
  readonly createServiceRequest: CreateServiceRequestResponse;
  readonly createTag: CreateTagResponse;
  readonly createVarVideoAction: CreateVarVideoActionResponse;
  readonly createVideoAction: CreateVideoActionResponse;
  readonly createX1AutoProgrammingJob: CreateX1AutoProgrammingJobPayload;
  /** @deprecated Prefer using createPanelPerson */
  readonly createXfPerson: CreatePersonResponse;
  /** @deprecated Prefer sendXfUserCodes */
  readonly createXfUserCode: CreateUserCodeResponse;
  readonly customerFeatureCustomerExportData: GetOpportunityDashboardCustomerFeatureExportDataResponse;
  readonly deactivateSiteDoor: DeactivateSiteDoorResponse;
  readonly deleteAdminBadgeTemplate: DeleteAdminBadgeTemplateResponse;
  readonly deleteAlarmVisionDevice: DeleteAlarmVisionDevicePayload;
  readonly deleteAlarmZoneAndUnlinkFromAnalyticalDetectionLine: LinkAnalyticalDetectionLineToZonePayload;
  readonly deleteAlarmZoneAndUnlinkFromAnalyticalDetectionRegion: LinkAnalyticalDetectionRegionToZonePayload;
  readonly deleteAreaInformation: DeleteAreaInformationPayload;
  readonly deleteAutoEnrolledControlSystem: DeleteAutoEnrolledControlSystemResponse;
  readonly deleteCameraFromHub?: Maybe<DeleteCameraFromHubPayload>;
  readonly deleteCommunicationPath: DeleteCommunicationPathPayload;
  readonly deleteControlSystem: DeleteControlSystemResponse;
  readonly deleteControlSystemGroup: DeleteControlSystemGroupResponse;
  readonly deleteCustomerAppUser: DeleteCustomerAppUserResponse;
  readonly deleteDeviceInformation: DeleteDeviceInformationPayload;
  readonly deleteDownloadableFile: DeleteDownloadableFileResponse;
  readonly deleteFavorite: DeleteFavoriteResponse;
  readonly deleteFromVarHubEnabledCamerasList: DeleteFromVarHubEnabledCamerasListPayload;
  readonly deleteGlobalHolidayDate: DeleteGlobalHolidayDateResponse;
  readonly deleteGroup: DeleteGroupResponse;
  readonly deleteHolidayDate: DeleteHolidayDateResponse;
  readonly deleteKeyfob: DeleteKeyfobPayload;
  readonly deleteNumberedZwaveNode: DeleteNumberedZwaveNodeResponse;
  readonly deleteOutputGroup: DeleteOutputGroupPayload;
  readonly deleteProfile: DeleteProfileResponse;
  readonly deleteProgrammingTemplate?: Maybe<DeleteProgrammingTemplateResult>;
  readonly deleteReceiver: DeleteReceiverPayload;
  readonly deleteSavedReports: DeleteSavedReportsResponse;
  readonly deleteSecureComDoorbell: DeleteSecureComDoorbellResponse;
  readonly deleteSystemBadgeTemplate: DeleteSystemBadgeTemplateResponse;
  readonly deleteSystemOutput: DeleteSystemOutputsPayload;
  readonly deleteTag: DeleteTagResponse;
  readonly deleteUniKeyReader: DeleteUniKeyReaderResponse;
  readonly deleteVarHub: DeleteVarHubPayload;
  readonly deleteVarVideoAction: DeleteVarVideoActionResponse;
  readonly deleteVideoAction: DeleteVideoActionResponse;
  readonly deleteVideoClip: DeleteClipPayload;
  readonly deleteX1Backup: DeleteX1BackupResponse;
  /** @deprecated Prefer sendXfUserCodes */
  readonly deleteXfUserCode: DeleteUserCodeResponse;
  readonly deleteXvAudioDevice: DeleteXvAudioDeviceResponse;
  readonly deleteZoneInformation: DeleteZoneInformationPayload;
  readonly deleteZwaveNode: DeleteZwaveNodeResponse;
  /** @deprecated Use WebRTC instead */
  readonly destroyAllHlsStreams: DestroyAllHlsStreamsPayload;
  /** @deprecated Use WebRTC instead */
  readonly destroyHlsStream: DestroyHlsStreamPayload;
  readonly disableCamera?: Maybe<DisableCameraPayload>;
  readonly disableTwoFactorAuthentication: DisableTwoFactorAuthenticationResponse;
  readonly disarmAll: DisarmMultipleAreasPayload;
  readonly disarmAllAreas: DisarmMultipleAreasPayload;
  readonly disarmArea: DisarmMultipleAreasPayload;
  readonly disarmAreas: DisarmMultipleAreasPayload;
  readonly disarmByType: DisarmMultipleAreasPayload;
  readonly disconnectPanel: DisconnectPanelResponse;
  readonly downloadCamectClip: DownloadCamectClipPayload;
  readonly downloadEventClip: DownloadClipPayload;
  readonly downloadSnapshot: DownloadSnapshotPayload;
  readonly editReceiver: EditReceiverPayload;
  readonly fetchBatchJobsByGroupId?: Maybe<BatchJobResponse>;
  readonly fetchSiteBatchJobs?: Maybe<BatchJobResponse>;
  readonly filterCombinedEvents?: Maybe<FilterCombinedEventsPayload>;
  readonly findZwaveNode: FindZwaveNodeResponse;
  readonly forgiveUser: ForgiveUserPayload;
  readonly formatSdCard: FormatSdCardPayload;
  readonly generateAllSystemsJobReport: GenerateAllSystemsReportResponse;
  readonly generateAllSystemsReport: GenerateAllSystemsReportResponse;
  readonly generateReport: GenerateReportResponse;
  readonly getCustomerUsersByPersonIds: GetCustomerUsersByPersonIdsResponse;
  /** @deprecated Prefer WebRTC */
  readonly getHlsEventObject: GetHlsObjectPayload;
  readonly getHlsEventPlayback: GetHlsEventPlaybackPayload;
  /** @deprecated Use WebRTC instead */
  readonly getHlsStream: GetHlsStreamPayload;
  readonly getLightStatus: GetLightStatusPayload;
  readonly getNodeConnectionStatus: GetNodeConnectionStatusResponse;
  readonly getPanelPersonCredentials: GetPanelPersonCredentialsResponse;
  readonly getPanelUserSecurityCodes: GetPanelUserSecurityCodeResponse;
  readonly getWebRTCEventObject: GetWebRtcEventObjectPayload;
  readonly hideFromVarHubEnabledCamerasList: HideFromVarHubEnabledCamerasListPayload;
  readonly initializePasswordChange: AuthenticateResponse;
  readonly issueMobileCredentialsToCustomer: IssueMobileCredentialResponse;
  /** @deprecated Use WebRTC instead */
  readonly keepHlsStreamAlive: KeepHlsStreamAlivePayload;
  readonly keypadUpdate?: Maybe<KeypadProgramming>;
  readonly loadMoreCombinedEvents?: Maybe<LoadMoreCombinedEventsPayload>;
  readonly loadMoreEvents?: Maybe<LoadMoreEventsPayload>;
  readonly lockDoor: LockDoorMutationResponse;
  readonly lockSiteDoor: LockSiteDoorResponse;
  readonly lockZwaveLock: LockZwaveLockResponse;
  readonly lockdown: LockdownMutationResponse;
  readonly lockdownSite: LockdownSiteResponse;
  readonly moveDigitalWatchdogCamera: MoveDigitalWatchdogCameraPayload;
  readonly moveDigitalWatchdogCameraToPreset: MoveDigitalWatchdogCameraToPresetPayload;
  readonly movePTCamera: MovePtCameraPayload;
  readonly movePTCameraToPreset?: Maybe<MovePtCameraToPresetPayload>;
  readonly moveSecureComCamera: MoveSecureComCameraPayload;
  readonly moveSecureComCameraToPreset: MoveSecureComCameraToPresetPayload;
  readonly mutateGlobalPasscodes: UpdateCentralStationGlobalPasscodesResponse;
  readonly noop?: Maybe<Scalars["String"]>;
  readonly openBarrierOperator: OpenBarrierOperatorResponse;
  readonly pollZwaveBarrierOperator: PollZwaveBarrierOperatorResponse;
  readonly putSystemOnTest: PutSystemOnTestResponse;
  readonly reactivateSecureComCamera: ReactivateSecureComCameraResponse;
  readonly reactivateVideoDevice: ReactivateVideoDeviceResponse;
  readonly recordSecureComCameraClip: RecordSecureComCameraClipPayload;
  readonly recordVideoClip: RecordClipPayload;
  readonly refreshAllCameras: RefreshAllCamerasPayload;
  readonly refreshAllSystemOutputs: RefreshAllSystemOutputsResponse;
  readonly refreshAreaArmedStatuses: RefreshAreaArmedStatusesPayload;
  readonly refreshAreaInformations: RefreshAreaInformationsPayload;
  readonly refreshAreaInformationsAndArmedStatus: RefreshAreaInformationsAndArmedStatusPayload;
  readonly refreshBellOptions: RefreshBellOptionsPayload;
  readonly refreshCardFormats: RefreshCardFormatsResponse;
  readonly refreshCombinedEvents?: Maybe<RefreshCombinedEventsPayload>;
  readonly refreshCommunication: RefreshCommunicationPayload;
  readonly refreshCommunicationPaths: RefreshCommunicationPathsPayload;
  readonly refreshDeviceInformations: RefreshDeviceInformationsPayload;
  readonly refreshDoors: RefreshDoorsMutationResponse;
  readonly refreshEvents?: Maybe<RefreshEventsPayload>;
  readonly refreshFavorites: RefreshFavoritesResponse;
  readonly refreshFeatureKeys: RefreshFeatureKeysPayload;
  readonly refreshGroups: RefreshGroupsResponse;
  readonly refreshKeyfobs: RefreshKeyfobsPayload;
  readonly refreshLockoutCode: RefreshLockoutCodePayload;
  readonly refreshLxBus: RefreshLxBusPayload;
  readonly refreshMenuDisplay: RefreshMenuDisplayResponse;
  readonly refreshMessagingSetup: RefreshMessagingSetupPayload;
  readonly refreshNetworkOptions: RefreshNetworkOptionsPayload;
  readonly refreshOnlyVarHub: RefreshOnlyVarHubPayload;
  readonly refreshOutputGroups: RefreshOutputGroupsPayload;
  readonly refreshOutputOptions: RefreshOutputOptionsResponse;
  readonly refreshPanelMacAndSerial: RefreshPanelMacAndSerialResponse;
  readonly refreshPanelPersons: RefreshPanelPersonResponse;
  readonly refreshPanelPersonsList: RefreshPanelPersonsListResponse;
  readonly refreshPcLogReports: RefreshPcLogReportsResponse;
  readonly refreshProfiles: RefreshProfilesResponse;
  readonly refreshProgress: RefreshProgressResponse;
  readonly refreshRemoteOptions: RefreshRemoteOptionsPayload;
  readonly refreshSecureComCamera: RefreshSecureComCameraResponse;
  readonly refreshSecurityGrade: RefreshSecurityGradePayload;
  readonly refreshSession: AuthenticateResponse;
  readonly refreshStatusListDisplay: RefreshStatusListDisplayResponse;
  readonly refreshSystemOptions: RefreshSystemOptionsResponse;
  readonly refreshSystemReports: RefreshSystemReportsPayload;
  readonly refreshSystemStatuses: RefreshSystemStatusesResponse;
  readonly refreshTrackedOutputs: RefreshAllSystemOutputsResponse;
  readonly refreshUserCodes: RefreshUserCodeResponse;
  readonly refreshVarHub: RefreshVarHubPayload;
  readonly refreshVarVideoActions: RefreshVarVideoActionsResponse;
  readonly refreshVideoActions: RefreshVideoActionsResponse;
  readonly refreshVideoDevice: RefreshVideoDeviceResponse;
  readonly refreshVideoDoorbells: RefreshVideoDoorbellsPayload;
  /** @deprecated Prefer using refreshPanelPersons */
  readonly refreshXfPersons: RefreshPersonResponse;
  readonly refreshXvAudioDevices: RefreshXvAudioDevicesResponse;
  readonly refreshZoneInformation: RefreshZoneInformationPayload;
  readonly refreshZoneStatuses: RefreshZoneStatusesPayload;
  readonly refreshZonesStatus: RefreshZonesStatusPayload;
  readonly refreshZwaveAppliance: RefreshZwaveApplianceResponse;
  readonly refreshZwaveBarrierOperator: RefreshZwaveBarrierOperatorResponse;
  readonly refreshZwaveLight: RefreshZwaveLightResponse;
  readonly refreshZwaveLock: RefreshZwaveLockResponse;
  readonly refreshZwaveNodes: RefreshZwaveNodesResponse;
  readonly refreshZwaveThermostat: RefreshZwaveThermostatResponse;
  readonly removeCardFormat: RemoveCardFormatResponse;
  readonly removeContact?: Maybe<RemoveContactPayload>;
  readonly removeDealerAccess: RemoveDealerAccessPayload;
  readonly removeDealerCentralStationAutomationIntegration: RemoveDealerCentralStationAutomationIntegrationResponse;
  readonly removeFromVarHubEnabledCamerasList: RemoveFromVarHubEnabledCamerasListPayload;
  readonly removeRule: RemoveRuleResponse;
  readonly removeSecureComCamera: RemoveSecureComCameraResponse;
  readonly removeSite: RemoveSiteResponse;
  readonly removeSiteCardFormat: RemoveSiteCardFormatResponse;
  readonly removeSiteControlSystem: RemoveSiteControlSystemResponse;
  readonly removeSiteControlSystemOutputModule: RemoveSiteControlSystemOutputModuleResponse;
  readonly removeSiteDoorSchedule: RemoveSiteDoorScheduleResponse;
  readonly removeSiteGroup: RemoveSiteGroupResponse;
  readonly removeSiteHolidayDate: RemoveHolidayDateResponse;
  readonly removeSitePerson: RemoveSitePersonResponse;
  readonly removeSiteReport: RemoveSiteReportResponse;
  readonly removeTag: RemoveTagResponse;
  readonly renameXvAudioDevice: RenameXvAudioDeviceResponse;
  readonly renameZwaveNode: RenameZwaveNodeResponse;
  readonly replaceX1: ReplaceX1Response;
  readonly resetAppUserPassword: ResetAppUserPasswordResponse;
  readonly resetBypassZone?: Maybe<ResetBypassZonePayload>;
  readonly resetBypassZoneStatus: ResetBypassZoneStatusPayload;
  readonly resetCustomerAppUserPassword: ResetCustomerAppUserPasswordResponse;
  readonly resetLockdownSite: ResetLockdownSiteResponse;
  readonly resetSensors: ResetSensorsPayload;
  readonly restartVarHub: RestartVarHubPayload;
  readonly runAllAppUsersReport: RunAllAppUsersReportResponse;
  readonly runAllSystemProfilesReport: RunAllSystemProfilesReportResponse;
  readonly runAllSystemUsersReport: RunAllSystemUsersReportResponse;
  readonly runReport: RunReportResponse;
  readonly saveAdminBadgeTemplate: SaveAdminBadgeTemplateResponse;
  readonly saveFavoriteSiteDoorIds?: Maybe<SaveFavoriteSiteDoorIdsResponse>;
  readonly saveSystemBadgeTemplate: SaveSystemBadgeTemplateResponse;
  readonly saveSystemNickname: SaveSystemNicknameResponse;
  readonly saveTag: SaveTagResponse;
  readonly saveTakeoverProgrammingTemplate?: Maybe<SaveProgrammingTemplateResult>;
  readonly saveXfProgrammingTemplate?: Maybe<SaveProgrammingTemplateResult>;
  readonly saveXrProgrammingTemplate?: Maybe<SaveProgrammingTemplateResult>;
  readonly saveXt75ProgrammingTemplate?: Maybe<SaveProgrammingTemplateResult>;
  readonly saveXtProgrammingTemplate?: Maybe<SaveProgrammingTemplateResult>;
  readonly scanForNewCameras?: Maybe<ScanForNewCamerasPayload>;
  readonly searchCustomerAppUsers?: Maybe<SearchCustomerAppUsersResponse>;
  readonly searchCustomerControlSystems?: Maybe<SearchCustomerControlSystemsResponse>;
  readonly searchCustomerUsers: SearchCustomerUsersResponse;
  readonly searchPanelPersonsList?: Maybe<SearchPanelPersonsListResponse>;
  readonly searchPersonControlSystems?: Maybe<SearchPersonControlSystemsResponse>;
  readonly searchSecurityPanelPersonsList?: Maybe<SearchSecurityPanelPersonsListResponse>;
  readonly searchSitePersons: ReadonlyArray<QuickSitePerson>;
  /** @deprecated Prefer searchPanelPersonsList instead */
  readonly searchVkSystemUsers?: Maybe<SearchVkSystemUsersResponse>;
  readonly sendAllUserCodes: SendAllUserCodesResponse;
  readonly sendBellOptionsProgramming: SendBellOptionsProgrammingPayload;
  readonly sendCardFormatsProgramming: SendCardFormatsProgrammingPayload;
  readonly sendCommunication: SendCommunicationPayload;
  readonly sendCommunicationPathsProgramming: SendCommunicationPathsProgrammingPayload;
  readonly sendContactMeEmailForCentralStationAutomationIntegration: SendContactMeEmailForCentralStationAutomationIntegrationResponse;
  readonly sendDateTime: Scalars["String"];
  readonly sendFileTransferCommand: SendFileTransferCommandPayload;
  readonly sendKeyfobsProgramming: SendKeyfobsProgrammingPayload;
  readonly sendLockoutCodeProgramming: SendLockoutCodeProgrammingPayload;
  readonly sendMessagingSetupProgramming: SendMessagingSetupProgrammingPayload;
  readonly sendNetworkOptions: SendNetworkOptionsPayload;
  readonly sendOutputGroupsProgramming: SendOutputGroupsProgrammingPayload;
  readonly sendOutputOptions: SendOutputOptionsPayload;
  readonly sendOutputsProgramming: SendOutputsProgrammingPayload;
  readonly sendPreProgramming?: Maybe<ControlSystem>;
  readonly sendPreProgrammingBackup?: Maybe<ControlSystem>;
  readonly sendProgrammingConfirmation: SendProgrammingConfirmationResponse;
  readonly sendSecurityGrade: SendSecurityGradePayload;
  readonly sendSystemAreaInformation: SendSystemAreaInformationPayload;
  readonly sendSystemReports: SendSystemReportsPayload;
  readonly sendTMSentryRemoteOptionsProgramming: SendRemoteOptionsProgrammingPayload;
  readonly sendXfDeviceProgramming: SendDeviceProgrammingPayload;
  readonly sendXfRemoteOptionsProgramming: SendRemoteOptionsProgrammingPayload;
  readonly sendXfSystemOptionsProgramming: SendSystemOptionsProgrammingPayload;
  readonly sendXfUserCodes: SendUserCodesResponse;
  readonly sendXrAreaProgramming: SendAreasProgrammingPayload;
  readonly sendXrDeviceProgramming: SendDeviceProgrammingPayload;
  readonly sendXrRemoteOptionsProgramming: SendRemoteOptionsProgrammingPayload;
  readonly sendXrSystemOptionsProgramming: SendSystemOptionsProgrammingPayload;
  readonly sendXrUserCodes: SendUserCodesResponse;
  readonly sendXt75AreaProgramming: SendAreasProgrammingPayload;
  readonly sendXt75DeviceProgramming: SendDeviceProgrammingPayload;
  readonly sendXt75RemoteOptionsProgramming: SendRemoteOptionsProgrammingPayload;
  readonly sendXt75SystemOptionsProgramming: SendSystemOptionsProgrammingPayload;
  readonly sendXt75UserCodes: SendUserCodesResponse;
  readonly sendXtAreaProgramming: SendAreasProgrammingPayload;
  readonly sendXtDeviceProgramming: SendDeviceProgrammingPayload;
  readonly sendXtRemoteOptionsProgramming: SendRemoteOptionsProgrammingPayload;
  readonly sendXtSystemOptionsProgramming: SendSystemOptionsProgrammingPayload;
  readonly sendXtUserCodes: SendUserCodesResponse;
  readonly sendZoneProgramming: SendZoneProgrammingPayload;
  readonly setDealerAccess: SetDealerAccessPayload;
  readonly setDigitalWatchdogCameraPreset: SetDigitalWatchdogCameraPresetPayload;
  readonly setPTCameraPreset?: Maybe<SetPtCameraPresetPayload>;
  readonly setSecureComCameraPreset: SetSecureComCameraPresetPayload;
  readonly setSecureComDoorbellTotalForSite: SetSecureComDoorbellTotalForSiteResponse;
  readonly setSecureComVideoLevelForSite: SetSecureComNvrsTotalForSiteResponse;
  readonly setTwoFactorForCustomer: SetTwoFactorForCustomerResponse;
  readonly setZwaveApplianceLevel: SetZwaveApplianceLevelResponse;
  readonly setZwaveLightLevel: SetZwaveLightLevelResponse;
  readonly setZwaveThermostatAutoPoint: SetZwaveThermostatAutoPointResponse;
  readonly setZwaveThermostatCoolPoint: SetZwaveThermostatCoolPointResponse;
  readonly setZwaveThermostatFanMode: SetZwaveThermostatFanModeResponse;
  readonly setZwaveThermostatHeatPoint: SetZwaveThermostatHeatPointResponse;
  readonly setZwaveThermostatMode: SetZwaveThermostatModeResponse;
  readonly setupSiteControlSystem: SetupSiteControlSystemPayload;
  /** Start setup process to takeover panel. */
  readonly setupTakeoverPanel: TakeoverPanelSetupResponse;
  readonly shareCamectVideoClip: ShareCamectVideoClipPayload;
  readonly silenceAlarm: SilenceAlarmPayload;
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteFilterCombinedEvents?: Maybe<SiteFilterCombinedEventsPayload>;
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteGetHlsEventObject: SiteGetHlsObjectPayload;
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteGetHlsEventPlayback: SiteGetHlsEventPlaybackPayload;
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteLoadMoreCombinedEvents?: Maybe<SiteLoadMoreCombinedEventsPayload>;
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteRefreshCombinedEvents?: Maybe<SiteRefreshCombinedEventsPayload>;
  readonly stopDigitalWatchdogCameraStream: StopDigitalWatchdogCameraStreamPayload;
  readonly stopEagleEyeBridgeStream: StopEagleEyeBridgeStreamPayload;
  readonly stopHikvisionNvrStream: StopHikvisionNvrStreamPayload;
  readonly stopSecureComNvrStream: StopSecureComNvrStreamPayload;
  readonly syncBilling: SyncBillingResponse;
  readonly systemFeatureCustomerExportData: GetOpportunityDashboardSystemFeatureExportDataResponse;
  readonly takeCameraSnapshot: TakeCameraSnapshotPayload;
  readonly takePanelOffline?: Maybe<ControlSystem>;
  readonly takeSystemOffTest: TakeSystemOffTestResponse;
  readonly takeVarCameraSnapshot: TakeVarCameraSnapshotPayload;
  readonly takeoverPanelGetZones: TakeoverPanelGetZonesResponse;
  /**
   * Although this is a query, the server hides the event when it is accessed for the first time.
   * This mutation is intended to be safely called multiple times.
   */
  readonly takeoverPanelGetZonesEvent: TakeoverPanelGetZonesEventResult;
  /**
   * Although this is a query, the server hides the event when it is accessed for the first time.
   * This mutation is intended to be safely called multiple times.
   */
  readonly takeoverPanelSetupEvent: TakeoverPanelSetupEventResult;
  readonly testCameraConnection: TestCameraConnectionResponse;
  readonly testSiteConnection: TestSiteConnectionResponse;
  readonly toggleProx: ToggleProxPayload;
  readonly toggleRedBlueLight: ToggleRedBlueLightPayload;
  readonly toggleWhiteLight: ToggleWhiteLightPayload;
  readonly turnAllSystemOutputsOff: TurnAllSystemOutputsOffResponse;
  readonly turnAllSystemOutputsOn: TurnAllSystemOutputsOnResponse;
  readonly turnOutputOff: TurnOutputOffResponse;
  readonly turnOutputOn: TurnOutputOnResponse;
  readonly turnSecureComCameraLightOff: TurnSecureComCameraLightOffPayload;
  readonly turnSecureComCameraLightOn: TurnSecureComCameraLightOnPayload;
  readonly unhideFromVarHubEnabledCamerasList: UnhideFromVarHubEnabledCamerasListPayload;
  readonly unlockDoor: UnlockDoorMutationResponse;
  readonly unlockSiteDoor: UnlockSiteDoorResponse;
  readonly unlockZwaveLock: UnlockZwaveLockResponse;
  readonly updateAlarmZone: UpdateAlarmZonePayload;
  readonly updateAutoEnrollDefaults: UpdateAutoEnrollDefaultsResult;
  readonly updateContact?: Maybe<UpdateContactPayload>;
  readonly updateControlSystemGroup: UpdateControlSystemGroupResponse;
  readonly updateDealerCentralStationAutomationIntegration: UpdateDealerCentralStationAutomationIntegrationResponse;
  readonly updateDealerUserSettings?: Maybe<DealerUserSettings>;
  readonly updateDigitalWatchdogCamera: UpdateDigitalWatchdogCameraPayload;
  readonly updateDoorbellFirmware: UpdateDoorbellFirmwarePayload;
  readonly updateEmergencyContacts: UpdateEmergencyContactsResponse;
  readonly updateFavorite: UpdateFavoriteResponse;
  readonly updateFeatureKey: UpdateFeatureKeyPayload;
  readonly updateGlobalHolidayDateForMassPanels: UpdateGlobalHolidayDateForMassPanelsResponse;
  readonly updateGlobalHolidayDateForSinglePanel: UpdateGlobalHolidayDateForSinglePanelResponse;
  readonly updateGroup: UpdateGroupResponse;
  readonly updateHolidayDate: UpdatePanelHolidayDateResponse;
  readonly updateIdpGroups: UpdateIdpGroupsResult;
  readonly updateMenuDisplay: UpdateMenuDisplayResponse;
  readonly updateOutputOptions: UpdateOutputOptionsResponse;
  readonly updatePanelIntegration: UpdatePanelIntegrationPayload;
  readonly updatePanelModemFirmware: UpdatePanelModemFirmwareResponse;
  readonly updatePanelPerson: UpdatePanelPersonResponse;
  readonly updatePcLogReports: UpdatePcLogReportsResponse;
  readonly updateProfile: UpdateProfileResponse;
  readonly updateRule: UpdateRuleResponse;
  readonly updateSavedReport: UpdateSavedReportResponse;
  readonly updateSecureComCamera: UpdateSecureComCameraPayload;
  readonly updateSecureComCameraFirmware: UpdateSecureComCameraFirmwarePayload;
  readonly updateSecureComDoorbell: UpdateSecureComDoorbellResponse;
  readonly updateSiteCardFormat: UpdateSiteCardFormatResponse;
  readonly updateSiteControlSystem: UpdateSiteControlSystemResponse;
  readonly updateSiteControlSystemOutputModule: UpdateSiteControlSystemOutputModuleResponse;
  readonly updateSiteDetails: UpdateSiteDetailsResponse;
  readonly updateSiteDoorSchedule: UpdateSiteDoorScheduleResponse;
  readonly updateSiteFirmwares: UpdateSiteFirmwaresPayload;
  readonly updateSiteGroup: UpdateSiteGroupResponse;
  readonly updateSiteHolidayDate: UpdateHolidayDateResponse;
  readonly updateSitePerson: UpdateSitePersonResponse;
  readonly updateSiteReport: UpdateSiteReportResponse;
  readonly updateSiteVideoIntegrations: UpdateSiteVideoIntegrationsResponse;
  readonly updateStatusListDisplay: UpdateStatusListDisplayResponse;
  readonly updateVarHub: UpdateVarHubPayload;
  readonly updateVarHubCamera: UpdateVarHubCameraPayload;
  readonly updateVarHubCameraCredentials?: Maybe<UpdateVarHubCameraCredentialsPayload>;
  readonly updateVarHubSettings: UpdateVarHubSettingsPayload;
  readonly updateVarVideoAction: UpdateVarVideoActionResponse;
  readonly updateVideoAction: UpdateVideoActionResponse;
  readonly updateVideoClip: UpdateClipPayload;
  readonly updateVideoDoorbell: UpdateVideoDoorbellPayload;
  readonly updateVueCamera: UpdateVueCameraPayload;
  /** @deprecated Prefer using updatePanelPerson */
  readonly updateXfPerson: UpdatePersonResponse;
  /** @deprecated Prefer sendXfUserCodes */
  readonly updateXfUserCode: UpdateUserCodeResponse;
  readonly updateXvAudioDeviceCredentials: UpdateXvAudioDeviceCredentialsResponse;
  readonly uploadOSDPConfig: UploadOsdpConfigPayload;
  readonly validateTwoFactorCode: ValidateTwoFactorCodeResponse;
  readonly vernacularSuperMutation: VernacularSuperMutationResponse;
};

export type MutationSendDealerKeypadContactInfoArgs = {
  dealerId: Scalars["Int"];
  dealerKeypadContactInfoInput: DealerKeypadContactInfoInput;
};

export type MutationAccessDoorArgs = {
  id: Scalars["ID"];
};

export type MutationAccessSiteDoorArgs = {
  id: Scalars["ID"];
};

export type MutationActivateFavoriteArgs = {
  favoriteId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationAddCameraByRtspArgs = {
  newCamera: AddCameraByRtspInput;
  systemId: Scalars["String"];
};

export type MutationAddContactArgs = {
  contact: AddContactInput;
};

export type MutationAddDealerCentralStationAutomationIntegrationArgs = {
  dealer: Scalars["ID"];
  integration: AddDealerCentralStationAutomationIntegrationInput;
};

export type MutationAddHikvisionNvrArgs = {
  nvr: HikvisionNvrInput;
};

export type MutationAddInstallerMobileCredentialArgs = {
  customerId: Scalars["ID"];
};

export type MutationAddMobileCredentialCardFormatArgs = {
  systemId: Scalars["ID"];
};

export type MutationAddReceiverArgs = {
  receiver: AddReceiverInput;
};

export type MutationAddRuleArgs = {
  rule: AddRuleInput;
  siteId: Scalars["ID"];
};

export type MutationAddSiteArgs = {
  customerId: Scalars["ID"];
  site: AddSiteInput;
};

export type MutationAddSiteCardFormatArgs = {
  cardFormat: NewCardFormatInput;
  siteId: Scalars["ID"];
};

export type MutationAddSiteControlSystemArgs = {
  addAsPreProgramming?: InputMaybe<Scalars["Boolean"]>;
  commType?: InputMaybe<ControlSystemCommType>;
  controlSystemType?: InputMaybe<SiteControlSystemType>;
  elevatorOutputModules?: InputMaybe<
    ReadonlyArray<AddSiteControlSystemOutputModuleInput>
  >;
  serialNumber: Scalars["String"];
  siteId: Scalars["ID"];
};

export type MutationAddSiteControlSystemOutputModuleArgs = {
  address: Scalars["Int"];
  controlSystemId: Scalars["ID"];
  name: Scalars["String"];
  outputs: ReadonlyArray<AddSiteOutputInput>;
};

export type MutationAddSiteDoorScheduleArgs = {
  schedule: AddSiteScheduleInput;
  siteId: Scalars["ID"];
};

export type MutationAddSiteGroupArgs = {
  group: AddSiteGroupInput;
  siteId: Scalars["ID"];
  title: Scalars["String"];
};

export type MutationAddSiteHolidayDateArgs = {
  holidayDate: AddHolidayDateInput;
  siteId: Scalars["ID"];
};

export type MutationAddSitePersonArgs = {
  data: DataInputForAddPerson;
  requestMetaData: RequestMetaData;
  siteId: Scalars["ID"];
  title: Scalars["String"];
};

export type MutationAddSiteReportArgs = {
  report: AddSiteReportInput;
  siteId: Scalars["ID"];
};

export type MutationAddTagArgs = {
  encodedTagId: Scalars["ID"];
  tagType: Scalars["String"];
  typeId: Scalars["Int"];
};

export type MutationAddToVarHubEnabledCamerasListArgs = {
  addition: AddToVarHubEnabledCamerasListInput;
  camectCameraId?: InputMaybe<Scalars["String"]>;
  hubId: Scalars["String"];
  isScapiCamera: Scalars["Boolean"];
  macAddress?: InputMaybe<Scalars["String"]>;
  scapiCameraId?: InputMaybe<Scalars["String"]>;
  systemId: Scalars["String"];
};

export type MutationAddVarHubArgs = {
  hub: AddVarHubInput;
};

export type MutationAddXvAudioDeviceArgs = {
  input: AddXvAudioDeviceInput;
  systemId: Scalars["ID"];
};

export type MutationAddZwaveNodeArgs = {
  name: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationAgreeToAdminEulaArgs = {
  user_agreement: AdminEulaInfo;
};

export type MutationArmAllArgs = {
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationArmAllAreasArgs = {
  badZonesOption?: InputMaybe<BadZonesOption>;
  isTMSentry?: InputMaybe<Scalars["Boolean"]>;
  systemId: Scalars["ID"];
};

export type MutationArmAreaArgs = {
  areaId: Scalars["ID"];
  badZonesOption?: InputMaybe<BadZonesOption>;
};

export type MutationArmAwayArgs = {
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationArmHomeArgs = {
  armInstant?: InputMaybe<Scalars["Boolean"]>;
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationArmPerimeterArgs = {
  armInstant?: InputMaybe<Scalars["Boolean"]>;
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationArmSleepArgs = {
  armInstant?: InputMaybe<Scalars["Boolean"]>;
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationArmStayArgs = {
  armInstant?: InputMaybe<Scalars["Boolean"]>;
  badZonesOption?: InputMaybe<BadZonesOption>;
  systemId: Scalars["ID"];
};

export type MutationAuthenticateArgs = {
  clientApplication: ClientApplication;
  email?: InputMaybe<Scalars["String"]>;
  forceSendToEmail?: InputMaybe<Scalars["Boolean"]>;
  isV4Login?: InputMaybe<Scalars["Boolean"]>;
  password?: InputMaybe<Scalars["String"]>;
  ssoInfo?: InputMaybe<SsoInput>;
};

export type MutationAuthorizeDmpUserArgs = {
  systemId: Scalars["ID"];
};

export type MutationBeginImportUserCodesArgs = {
  base64EncodedCSV: Scalars["String"];
  filename: Scalars["String"];
  systemID: Scalars["ID"];
};

export type MutationBeginImportX1UserCodesArgs = {
  base64EncodedCSV: Scalars["String"];
  filename: Scalars["String"];
  isTemplateValid: Scalars["Boolean"];
  siteID: Scalars["ID"];
};

export type MutationBypassZoneArgs = {
  id: Scalars["ID"];
};

export type MutationBypassZoneStatusArgs = {
  id: Scalars["ID"];
};

export type MutationBypassZonesStatusArgs = {
  ids: ReadonlyArray<Scalars["ID"]>;
};

export type MutationCancelOperationArgs = {
  systemId: Scalars["ID"];
};

export type MutationChangePasswordArgs = {
  clientApplication: ClientApplication;
  forceSendToEmail?: InputMaybe<Scalars["Boolean"]>;
  isV4Login?: InputMaybe<Scalars["Boolean"]>;
  newPassword: Scalars["String"];
  oldPassword?: InputMaybe<Scalars["String"]>;
  tempAuthToken?: InputMaybe<Scalars["String"]>;
};

export type MutationChangeUniKeyReaderNameArgs = {
  customerId: Scalars["ID"];
  name: Scalars["String"];
  readerUUID: Scalars["String"];
};

export type MutationClaimSystemArgs = {
  customer_id: Scalars["String"];
  dealer_id: Scalars["String"];
  panel_id: Scalars["String"];
};

export type MutationCloseBarrierOperatorArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationCombineLoginsArgs = {
  jwt: Scalars["String"];
};

export type MutationConfigureTwoFactorSettingsArgs = {
  clientApplication: ClientApplication;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  tempAuthToken?: InputMaybe<Scalars["String"]>;
  validationMethod: ValidationMethod;
};

export type MutationConfirmJobArgs = {
  deviceType?: InputMaybe<ZwaveNodesTypes>;
  jobNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationCreateAlarmVisionDeviceArgs = {
  deviceName: Scalars["String"];
  deviceNumber: Scalars["Int"];
  serialNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationCreateAlarmZoneAndLinkToAnalyticalDetectionLineArgs = {
  areaId: Scalars["String"];
  id: Scalars["ID"];
  systemId: Scalars["ID"];
  zoneName: Scalars["String"];
  zoneNumber: Scalars["Int"];
};

export type MutationCreateAlarmZoneAndLinkToAnalyticalDetectionRegionArgs = {
  areaId: Scalars["String"];
  id: Scalars["ID"];
  systemId: Scalars["ID"];
  zoneName: Scalars["String"];
  zoneNumber: Scalars["Int"];
};

export type MutationCreateControlSystemGroupArgs = {
  customerId: Scalars["ID"];
  group: ControlSystemGroupInput;
};

export type MutationCreateFavoriteArgs = {
  favorite: FavoriteInput;
  systemId: Scalars["ID"];
};

export type MutationCreateGlobalHolidayDateArgs = {
  input: CreateGlobalHolidayDateInput;
};

export type MutationCreateGroupArgs = {
  profile: GroupInput;
  systemId: Scalars["ID"];
};

export type MutationCreateHolidayDateArgs = {
  input: CreateHolidayDateInput;
};

export type MutationCreatePanelEventBufferJobArgs = {
  input: CreatePanelEventBufferJobInput;
};

export type MutationCreatePanelPersonArgs = {
  credentialId: Scalars["String"];
  customerId: Scalars["String"];
  input: PanelPersonInput;
  systemId: Scalars["ID"];
};

export type MutationCreateProfileArgs = {
  profile: ProfileInput;
  systemId: Scalars["ID"];
};

export type MutationCreateSavedReportArgs = {
  report: ReportInput;
};

export type MutationCreateServiceRequestArgs = {
  serviceRequest: ServiceRequestInput;
  systemId: Scalars["ID"];
};

export type MutationCreateTagArgs = {
  dealerId: Scalars["String"];
  name: Scalars["String"];
  tagType: Scalars["String"];
  typeId: Scalars["Int"];
};

export type MutationCreateVarVideoActionArgs = {
  systemId: Scalars["ID"];
  varVideoAction: CreateVarVideoActionInput;
};

export type MutationCreateVideoActionArgs = {
  cameraType: VideoActionCameraType;
  systemId: Scalars["ID"];
  videoAction: CreateVideoActionInput;
};

export type MutationCreateX1AutoProgrammingJobArgs = {
  controlSystemId: Scalars["ID"];
};

export type MutationCreateXfPersonArgs = {
  credentialId: Scalars["String"];
  customerId: Scalars["String"];
  input: XfPersonInput;
  systemId: Scalars["ID"];
};

export type MutationCreateXfUserCodeArgs = {
  input: CreateXfUserCodeInput;
  systemId: Scalars["ID"];
};

export type MutationCustomerFeatureCustomerExportDataArgs = {
  dealerId: Scalars["ID"];
  feature: CustomerFeatureTableConcepts;
  variant?: InputMaybe<OpportunityFeatureVariant>;
};

export type MutationDeactivateSiteDoorArgs = {
  doorId: Scalars["ID"];
};

export type MutationDeleteAdminBadgeTemplateArgs = {
  badgeTemplateId: Scalars["ID"];
  customerId: Scalars["ID"];
};

export type MutationDeleteAlarmVisionDeviceArgs = {
  deviceNumber: Scalars["Int"];
  systemId: Scalars["ID"];
};

export type MutationDeleteAlarmZoneAndUnlinkFromAnalyticalDetectionLineArgs = {
  id: Scalars["ID"];
  systemId: Scalars["ID"];
  zoneNumber: Scalars["Int"];
};

export type MutationDeleteAlarmZoneAndUnlinkFromAnalyticalDetectionRegionArgs =
  {
    id: Scalars["ID"];
    systemId: Scalars["ID"];
    zoneNumber: Scalars["Int"];
  };

export type MutationDeleteAreaInformationArgs = {
  areaId: Scalars["ID"];
};

export type MutationDeleteAutoEnrolledControlSystemArgs = {
  dealerId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationDeleteCameraFromHubArgs = {
  cameraId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationDeleteCommunicationPathArgs = {
  communicationPathId: Scalars["ID"];
};

export type MutationDeleteControlSystemArgs = {
  systemId: Scalars["ID"];
};

export type MutationDeleteControlSystemGroupArgs = {
  customerId: Scalars["ID"];
  groupId: Scalars["ID"];
};

export type MutationDeleteCustomerAppUserArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteDeviceInformationArgs = {
  deviceId: Scalars["ID"];
};

export type MutationDeleteDownloadableFileArgs = {
  downloadableFileId: Scalars["ID"];
};

export type MutationDeleteFavoriteArgs = {
  favoriteNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationDeleteFromVarHubEnabledCamerasListArgs = {
  deletes: DeleteFromVarHubEnabledCamerasListInput;
  hubId: Scalars["String"];
  macAddress?: InputMaybe<Scalars["String"]>;
  systemId: Scalars["String"];
};

export type MutationDeleteGlobalHolidayDateArgs = {
  dealerId: Scalars["Int"];
  holidayId: Scalars["Int"];
};

export type MutationDeleteGroupArgs = {
  profileNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationDeleteHolidayDateArgs = {
  encodedHolidayId: Scalars["ID"];
};

export type MutationDeleteKeyfobArgs = {
  keyfobId: Scalars["ID"];
};

export type MutationDeleteNumberedZwaveNodeArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationDeleteOutputGroupArgs = {
  outputGroupId: Scalars["ID"];
};

export type MutationDeleteProfileArgs = {
  profileNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationDeleteProgrammingTemplateArgs = {
  templateId: Scalars["ID"];
};

export type MutationDeleteReceiverArgs = {
  receiverId: Scalars["ID"];
};

export type MutationDeleteSavedReportsArgs = {
  ids: ReadonlyArray<Scalars["Int"]>;
};

export type MutationDeleteSecureComDoorbellArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteSystemBadgeTemplateArgs = {
  badgeTemplateId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationDeleteSystemOutputArgs = {
  outputId: Scalars["ID"];
};

export type MutationDeleteTagArgs = {
  encodedTagId: Scalars["ID"];
};

export type MutationDeleteUniKeyReaderArgs = {
  customerId: Scalars["ID"];
  readerUUID: Scalars["String"];
};

export type MutationDeleteVarHubArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationDeleteVarVideoActionArgs = {
  systemId: Scalars["String"];
  videoActionId: Scalars["ID"];
};

export type MutationDeleteVideoActionArgs = {
  cameraType: VideoActionCameraType;
  groupId: Scalars["String"];
  systemId: Scalars["String"];
  videoActionId: Scalars["ID"];
};

export type MutationDeleteVideoClipArgs = {
  clipId: Scalars["ID"];
  systemId: Scalars["ID"];
  videoChannelId: Scalars["Int"];
};

export type MutationDeleteX1BackupArgs = {
  siteId: Scalars["ID"];
};

export type MutationDeleteXfUserCodeArgs = {
  systemId: Scalars["ID"];
  userCodeNumber: Scalars["Int"];
};

export type MutationDeleteXvAudioDeviceArgs = {
  audioDeviceId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationDeleteZoneInformationArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteZwaveNodeArgs = {
  systemId: Scalars["ID"];
};

export type MutationDestroyAllHlsStreamsArgs = {
  databaseCameraId: Scalars["Int"];
};

export type MutationDestroyHlsStreamArgs = {
  vidproxUrl: Scalars["String"];
};

export type MutationDisableCameraArgs = {
  cameraId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationDisarmAllArgs = {
  systemId: Scalars["ID"];
};

export type MutationDisarmAllAreasArgs = {
  isTMSentry?: InputMaybe<Scalars["Boolean"]>;
  systemId: Scalars["ID"];
};

export type MutationDisarmAreaArgs = {
  areaId: Scalars["ID"];
};

export type MutationDisarmAreasArgs = {
  areaIds: ReadonlyArray<Scalars["ID"]>;
};

export type MutationDisarmByTypeArgs = {
  disarmingType?: InputMaybe<ArmingMutationType>;
  systemId: Scalars["ID"];
};

export type MutationDisconnectPanelArgs = {
  systemId: Scalars["ID"];
};

export type MutationDownloadCamectClipArgs = {
  cameraId: Scalars["Int"];
  endTime: Scalars["BigInt64"];
  startTime: Scalars["BigInt64"];
  systemId: Scalars["ID"];
};

export type MutationDownloadEventClipArgs = {
  channelId: Scalars["String"];
  mp4Url?: InputMaybe<Scalars["String"]>;
  startTsMs: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationDownloadSnapshotArgs = {
  cameraId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationEditReceiverArgs = {
  receiver: EditReceiverInput;
};

export type MutationFetchBatchJobsByGroupIdArgs = {
  batchGroupId: Scalars["String"];
  customerId: Scalars["String"];
};

export type MutationFetchSiteBatchJobsArgs = {
  customerId: Scalars["String"];
  siteId: Scalars["String"];
};

export type MutationFilterCombinedEventsArgs = {
  systemId: Scalars["ID"];
};

export type MutationFindZwaveNodeArgs = {
  deviceType?: InputMaybe<ZwaveNodesTypes>;
  jobNumber: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationForgiveUserArgs = {
  id: Scalars["String"];
  userCode: Scalars["String"];
};

export type MutationFormatSdCardArgs = {
  deviceId: Scalars["ID"];
};

export type MutationGenerateAllSystemsJobReportArgs = {
  body: GenerateAllSystemsJobReportInput;
};

export type MutationGenerateAllSystemsReportArgs = {
  fileInput: GenerateAllSystemsReportInput;
};

export type MutationGenerateReportArgs = {
  fileInput: GenerateReportInput;
};

export type MutationGetCustomerUsersByPersonIdsArgs = {
  customerId: Scalars["ID"];
  personIds: ReadonlyArray<Scalars["Int"]>;
};

export type MutationGetHlsEventObjectArgs = {
  eventPlaybackUrl: Scalars["String"];
};

export type MutationGetHlsEventPlaybackArgs = {
  playbackUrl: Scalars["String"];
};

export type MutationGetHlsStreamArgs = {
  vidproxUrl: Scalars["String"];
};

export type MutationGetLightStatusArgs = {
  cameraId: Scalars["String"];
};

export type MutationGetNodeConnectionStatusArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationGetPanelPersonCredentialsArgs = {
  systemId: Scalars["ID"];
};

export type MutationGetPanelUserSecurityCodesArgs = {
  systemId: Scalars["ID"];
};

export type MutationGetWebRtcEventObjectArgs = {
  vidproxUrl: Scalars["String"];
};

export type MutationHideFromVarHubEnabledCamerasListArgs = {
  hide: HideFromVarHubEnabledCamerasListInput;
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationInitializePasswordChangeArgs = {
  clientApplication: ClientApplication;
  tempAuthToken: Scalars["String"];
};

export type MutationIssueMobileCredentialsToCustomerArgs = {
  customerId: Scalars["ID"];
  info: IssueMobileCredentialsToCustomerInput;
};

export type MutationKeepHlsStreamAliveArgs = {
  channelId: Scalars["String"];
};

export type MutationKeypadUpdateArgs = {
  keypadId: Scalars["ID"];
};

export type MutationLoadMoreCombinedEventsArgs = {
  systemId: Scalars["ID"];
};

export type MutationLoadMoreEventsArgs = {
  customerId: Scalars["ID"];
};

export type MutationLockDoorArgs = {
  id: Scalars["ID"];
};

export type MutationLockSiteDoorArgs = {
  id: Scalars["ID"];
};

export type MutationLockZwaveLockArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationLockdownArgs = {
  systemId: Scalars["ID"];
};

export type MutationLockdownSiteArgs = {
  siteId: Scalars["ID"];
};

export type MutationMoveDigitalWatchdogCameraArgs = {
  id: Scalars["ID"];
  pan: Scalars["Int"];
  tilt: Scalars["Int"];
};

export type MutationMoveDigitalWatchdogCameraToPresetArgs = {
  id: Scalars["ID"];
  preset: Scalars["String"];
};

export type MutationMovePtCameraArgs = {
  id: Scalars["ID"];
  pan?: InputMaybe<Scalars["Int"]>;
  tilt?: InputMaybe<Scalars["Int"]>;
};

export type MutationMovePtCameraToPresetArgs = {
  id: Scalars["ID"];
  presetNumber: Scalars["String"];
};

export type MutationMoveSecureComCameraArgs = {
  id: Scalars["ID"];
  pan: Scalars["Int"];
  tilt: Scalars["Int"];
};

export type MutationMoveSecureComCameraToPresetArgs = {
  id: Scalars["ID"];
  preset: Scalars["String"];
};

export type MutationMutateGlobalPasscodesArgs = {
  globalPasscodes: ReadonlyArray<UpdateCentralStationGlobalPasscodesInput>;
  systemId: Scalars["ID"];
};

export type MutationNoopArgs = {
  x?: InputMaybe<Scalars["String"]>;
};

export type MutationOpenBarrierOperatorArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationPollZwaveBarrierOperatorArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationPutSystemOnTestArgs = {
  minutes: Scalars["Int"];
  systemId: Scalars["ID"];
};

export type MutationReactivateSecureComCameraArgs = {
  id: Scalars["ID"];
};

export type MutationReactivateVideoDeviceArgs = {
  id: Scalars["ID"];
};

export type MutationRecordSecureComCameraClipArgs = {
  id: Scalars["ID"];
};

export type MutationRecordVideoClipArgs = {
  globalVideoChannelId: Scalars["ID"];
};

export type MutationRefreshAllCamerasArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshAllSystemOutputsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshAreaArmedStatusesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshAreaInformationsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshAreaInformationsAndArmedStatusArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshBellOptionsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshCardFormatsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshCombinedEventsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshCommunicationArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshCommunicationPathsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshDeviceInformationsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshDoorsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshEventsArgs = {
  customerId: Scalars["ID"];
};

export type MutationRefreshFavoritesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshFeatureKeysArgs = {
  controlSystemId: Scalars["ID"];
};

export type MutationRefreshGroupsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshKeyfobsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshLockoutCodeArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshLxBusArgs = {
  id: Scalars["String"];
};

export type MutationRefreshMenuDisplayArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshMessagingSetupArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshNetworkOptionsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshOnlyVarHubArgs = {
  systemId: Scalars["String"];
};

export type MutationRefreshOutputGroupsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshOutputOptionsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshPanelMacAndSerialArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshPanelPersonsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshPanelPersonsListArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshPcLogReportsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshProfilesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshProgressArgs = {
  jobId: Scalars["Int"];
};

export type MutationRefreshRemoteOptionsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshSecureComCameraArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshSecurityGradeArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshSessionArgs = {
  clientApplication: ClientApplication;
  refreshToken: Scalars["String"];
};

export type MutationRefreshStatusListDisplayArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshSystemOptionsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshSystemReportsArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshSystemStatusesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshTrackedOutputsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshUserCodesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshVarHubArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshVarVideoActionsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshVideoActionsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshVideoDeviceArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshVideoDoorbellsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshXfPersonsArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshXvAudioDevicesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshZoneInformationArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshZoneStatusesArgs = {
  id: Scalars["ID"];
};

export type MutationRefreshZonesStatusArgs = {
  systemId: Scalars["String"];
};

export type MutationRefreshZwaveApplianceArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationRefreshZwaveBarrierOperatorArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationRefreshZwaveLightArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationRefreshZwaveLockArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationRefreshZwaveNodesArgs = {
  systemId: Scalars["ID"];
};

export type MutationRefreshZwaveThermostatArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationRemoveCardFormatArgs = {
  cardFormatNumber: Scalars["String"];
  id: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationRemoveContactArgs = {
  id: Scalars["ID"];
};

export type MutationRemoveDealerAccessArgs = {
  systemId: Scalars["ID"];
};

export type MutationRemoveDealerCentralStationAutomationIntegrationArgs = {
  integrationId: Scalars["ID"];
};

export type MutationRemoveFromVarHubEnabledCamerasListArgs = {
  hubId: Scalars["String"];
  removal: RemoveFromVarHubEnabledCamerasListInput;
  systemId: Scalars["String"];
};

export type MutationRemoveRuleArgs = {
  ruleId: Scalars["ID"];
};

export type MutationRemoveSecureComCameraArgs = {
  force?: InputMaybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
};

export type MutationRemoveSiteArgs = {
  siteId: Scalars["ID"];
};

export type MutationRemoveSiteCardFormatArgs = {
  cardFormatId: Scalars["ID"];
  siteId: Scalars["ID"];
};

export type MutationRemoveSiteControlSystemArgs = {
  controlSystemId: Scalars["ID"];
};

export type MutationRemoveSiteControlSystemOutputModuleArgs = {
  outputModule: Scalars["ID"];
};

export type MutationRemoveSiteDoorScheduleArgs = {
  scheduleId: Scalars["ID"];
};

export type MutationRemoveSiteGroupArgs = {
  groupId: Scalars["ID"];
  title: Scalars["String"];
};

export type MutationRemoveSiteHolidayDateArgs = {
  holidayDateId: Scalars["ID"];
};

export type MutationRemoveSitePersonArgs = {
  data: DataInputForUpdatePerson;
  requestMetaData: RequestMetaData;
  siteId: Scalars["ID"];
  title: Scalars["String"];
};

export type MutationRemoveSiteReportArgs = {
  reportId: Scalars["ID"];
  siteId: Scalars["ID"];
};

export type MutationRemoveTagArgs = {
  encodedTagId: Scalars["ID"];
  tagType: Scalars["String"];
  typeId: Scalars["Int"];
};

export type MutationRenameXvAudioDeviceArgs = {
  input: RenameXvAudioDeviceInput;
  systemId: Scalars["ID"];
};

export type MutationRenameZwaveNodeArgs = {
  name: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationReplaceX1Args = {
  newSerialNumber: Scalars["String"];
  siteId: Scalars["ID"];
};

export type MutationResetAppUserPasswordArgs = {
  personId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationResetBypassZoneArgs = {
  id: Scalars["ID"];
};

export type MutationResetBypassZoneStatusArgs = {
  id: Scalars["ID"];
};

export type MutationResetCustomerAppUserPasswordArgs = {
  customerId: Scalars["String"];
  emailAddress: Scalars["String"];
  id: Scalars["String"];
};

export type MutationResetLockdownSiteArgs = {
  siteId: Scalars["ID"];
};

export type MutationResetSensorsArgs = {
  id: Scalars["String"];
};

export type MutationRestartVarHubArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationRunAllAppUsersReportArgs = {
  systemId: Scalars["Int"];
};

export type MutationRunAllSystemProfilesReportArgs = {
  systemId: Scalars["Int"];
};

export type MutationRunAllSystemUsersReportArgs = {
  systemId: Scalars["Int"];
};

export type MutationRunReportArgs = {
  configData: ConfigDataInput;
  customerId: Scalars["Int"];
};

export type MutationSaveAdminBadgeTemplateArgs = {
  badgeTemplate: BadgeTemplateInput;
  customerId: Scalars["ID"];
};

export type MutationSaveFavoriteSiteDoorIdsArgs = {
  saveFavoriteSiteDoorIdsInput: SaveFavoriteSiteDoorIdsInput;
};

export type MutationSaveSystemBadgeTemplateArgs = {
  badgeTemplate: BadgeTemplateInput;
  systemId: Scalars["ID"];
};

export type MutationSaveSystemNicknameArgs = {
  customerId: Scalars["ID"];
  nickname: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationSaveTagArgs = {
  tag: TagInput;
};

export type MutationSaveTakeoverProgrammingTemplateArgs = {
  dealerId: Scalars["ID"];
  templateData: TakeoverProgrammingTemplateInput;
};

export type MutationSaveXfProgrammingTemplateArgs = {
  dealerId: Scalars["ID"];
  templateData: XfProgrammingTemplateInput;
};

export type MutationSaveXrProgrammingTemplateArgs = {
  dealerId: Scalars["ID"];
  isInternational: Scalars["Boolean"];
  templateData: XrProgrammingTemplateInput;
};

export type MutationSaveXt75ProgrammingTemplateArgs = {
  dealerId: Scalars["ID"];
  templateData: Xt75ProgrammingTemplateInput;
};

export type MutationSaveXtProgrammingTemplateArgs = {
  dealerId: Scalars["ID"];
  isInternational: Scalars["Boolean"];
  templateData: XtProgrammingTemplateInput;
};

export type MutationScanForNewCamerasArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationSearchCustomerAppUsersArgs = {
  customerId: Scalars["ID"];
  search: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationSearchCustomerControlSystemsArgs = {
  customerId: Scalars["ID"];
  search: KeyValuePairInput;
};

export type MutationSearchCustomerUsersArgs = {
  customerId: Scalars["ID"];
  search: Scalars["String"];
};

export type MutationSearchPanelPersonsListArgs = {
  databaseSystemId: Scalars["String"];
  isXf: Scalars["Boolean"];
  search: Scalars["String"];
};

export type MutationSearchPersonControlSystemsArgs = {
  connections?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["ID"]>>>;
  filterOnlyAppEnabled?: InputMaybe<Scalars["Boolean"]>;
  search: KeyValuePairInput;
  searchTwo?: InputMaybe<KeyValuePairInput>;
  usersAuthData: ReadonlyArray<UsersAuthDataInput>;
};

export type MutationSearchSecurityPanelPersonsListArgs = {
  databaseSystemId: Scalars["String"];
  isXf: Scalars["Boolean"];
  search: Scalars["String"];
};

export type MutationSearchSitePersonsArgs = {
  search: Scalars["String"];
  siteId: Scalars["ID"];
};

export type MutationSearchVkSystemUsersArgs = {
  databaseSystemId: Scalars["String"];
  search: Scalars["String"];
};

export type MutationSendAllUserCodesArgs = {
  systemId: Scalars["ID"];
};

export type MutationSendBellOptionsProgrammingArgs = {
  bellOptions: BellOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendCardFormatsProgrammingArgs = {
  cardFormats: ReadonlyArray<CardFormatInput>;
  systemId: Scalars["ID"];
};

export type MutationSendCommunicationArgs = {
  communication: CommunicationInput;
  systemId: Scalars["ID"];
};

export type MutationSendCommunicationPathsProgrammingArgs = {
  communicationPaths: ReadonlyArray<CommPathProgrammingInput>;
  systemId: Scalars["ID"];
};

export type MutationSendDateTimeArgs = {
  dateTime: Scalars["String"];
  panelId: Scalars["String"];
};

export type MutationSendFileTransferCommandArgs = {
  input: FileTransferCommandInput;
};

export type MutationSendKeyfobsProgrammingArgs = {
  keyfobs: ReadonlyArray<KeyfobProgrammingInput>;
  systemId: Scalars["ID"];
};

export type MutationSendLockoutCodeProgrammingArgs = {
  code: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationSendMessagingSetupProgrammingArgs = {
  messagingSetup: MessagingSetupInput;
  systemId: Scalars["ID"];
};

export type MutationSendNetworkOptionsArgs = {
  networkOptions: NetworkOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendOutputGroupsProgrammingArgs = {
  outputGroups: ReadonlyArray<OutputGroupProgrammingInput>;
  systemId: Scalars["ID"];
};

export type MutationSendOutputOptionsArgs = {
  outputOptions: OutputOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendOutputsProgrammingArgs = {
  outputInformations: ReadonlyArray<OutputProgrammingInput>;
  systemId: Scalars["ID"];
};

export type MutationSendPreProgrammingArgs = {
  systemId: Scalars["ID"];
};

export type MutationSendPreProgrammingBackupArgs = {
  systemId: Scalars["ID"];
};

export type MutationSendProgrammingConfirmationArgs = {
  concepts: ReadonlyArray<PanelConcepts>;
  systemId: Scalars["ID"];
};

export type MutationSendSecurityGradeArgs = {
  grade: Grades;
  systemId: Scalars["ID"];
};

export type MutationSendSystemAreaInformationArgs = {
  systemAreaInformation: SystemAreaInformationInput;
  systemId: Scalars["ID"];
};

export type MutationSendSystemReportsArgs = {
  systemId: Scalars["ID"];
  systemReports: SystemReportsInput;
};

export type MutationSendTmSentryRemoteOptionsProgrammingArgs = {
  remoteOptions: TmSentryRemoteOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendXfDeviceProgrammingArgs = {
  deviceInformations: ReadonlyArray<XfDeviceInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXfRemoteOptionsProgrammingArgs = {
  remoteOptions: XfRemoteOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendXfSystemOptionsProgrammingArgs = {
  systemId: Scalars["ID"];
  xfSystemOptionsInput: XfSystemOptionsInput;
};

export type MutationSendXfUserCodesArgs = {
  input: ReadonlyArray<XfUserCodeInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXrAreaProgrammingArgs = {
  areas: ReadonlyArray<XrAreaInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXrDeviceProgrammingArgs = {
  deviceInformations: ReadonlyArray<XrDeviceInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXrRemoteOptionsProgrammingArgs = {
  remoteOptions: XrRemoteOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendXrSystemOptionsProgrammingArgs = {
  systemId: Scalars["ID"];
  xrSystemOptionsInput: XrSystemOptionsInput;
};

export type MutationSendXrUserCodesArgs = {
  input: ReadonlyArray<XrUserCodeInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXt75AreaProgrammingArgs = {
  areas: ReadonlyArray<Xt75AreaInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXt75DeviceProgrammingArgs = {
  deviceInformations: ReadonlyArray<Xt75DeviceInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXt75RemoteOptionsProgrammingArgs = {
  remoteOptions: Xt75RemoteOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendXt75SystemOptionsProgrammingArgs = {
  systemId: Scalars["ID"];
  xt75SystemOptionsInput: Xt75SystemOptionsInput;
};

export type MutationSendXt75UserCodesArgs = {
  input: ReadonlyArray<Xt75UserCodeInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXtAreaProgrammingArgs = {
  areas: ReadonlyArray<AreaProgrammingInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXtDeviceProgrammingArgs = {
  deviceInformations: ReadonlyArray<XtDeviceInput>;
  systemId: Scalars["ID"];
};

export type MutationSendXtRemoteOptionsProgrammingArgs = {
  remoteOptions: XtRemoteOptionsInput;
  systemId: Scalars["ID"];
};

export type MutationSendXtSystemOptionsProgrammingArgs = {
  systemId: Scalars["ID"];
  xtSystemOptionsInput: XtSystemOptionsInput;
};

export type MutationSendXtUserCodesArgs = {
  input: ReadonlyArray<XtUserCodeInput>;
  systemId: Scalars["ID"];
};

export type MutationSendZoneProgrammingArgs = {
  systemId: Scalars["ID"];
  zones: ReadonlyArray<ZoneProgrammingInput>;
};

export type MutationSetDealerAccessArgs = {
  input: SetDealerAccessInput;
  systemId: Scalars["ID"];
};

export type MutationSetDigitalWatchdogCameraPresetArgs = {
  id: Scalars["ID"];
  preset: Scalars["String"];
};

export type MutationSetPtCameraPresetArgs = {
  id: Scalars["ID"];
  presetNumber: Scalars["String"];
};

export type MutationSetSecureComCameraPresetArgs = {
  id: Scalars["ID"];
  preset: Scalars["String"];
};

export type MutationSetSecureComDoorbellTotalForSiteArgs = {
  siteId: Scalars["ID"];
  total: Scalars["Int"];
};

export type MutationSetSecureComVideoLevelForSiteArgs = {
  siteId: Scalars["ID"];
  videoLevel: SecureComVideoLevel;
};

export type MutationSetTwoFactorForCustomerArgs = {
  clientApplication: ClientApplication;
  customerId: Scalars["ID"];
  requireTwoFactor: Scalars["Boolean"];
};

export type MutationSetZwaveApplianceLevelArgs = {
  level: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveLightLevelArgs = {
  level: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveThermostatAutoPointArgs = {
  setpointCooling: Scalars["String"];
  setpointHeating: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveThermostatCoolPointArgs = {
  setpointCooling: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveThermostatFanModeArgs = {
  fanMode: ZwaveThermostatFanMode;
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveThermostatHeatPointArgs = {
  setpointHeating: Scalars["String"];
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetZwaveThermostatModeArgs = {
  mode: ZwaveThermostatMode;
  zwaveNodeId: Scalars["ID"];
};

export type MutationSetupSiteControlSystemArgs = {
  controlSystemId: Scalars["ID"];
};

export type MutationSetupTakeoverPanelArgs = {
  installerCode: Scalars["String"];
  panelType: TakeoverPanelType;
  systemId: Scalars["ID"];
  vistaPanel: Scalars["Boolean"];
};

export type MutationShareCamectVideoClipArgs = {
  cameraId: Scalars["String"];
  clipInfo: CamectCameraClipInfo;
  systemId: Scalars["ID"];
};

export type MutationSilenceAlarmArgs = {
  id: Scalars["String"];
};

export type MutationSiteFilterCombinedEventsArgs = {
  siteId: Scalars["ID"];
};

export type MutationSiteGetHlsEventObjectArgs = {
  eventPlaybackUrl: Scalars["String"];
};

export type MutationSiteGetHlsEventPlaybackArgs = {
  playbackUrl: Scalars["String"];
};

export type MutationSiteLoadMoreCombinedEventsArgs = {
  siteId: Scalars["ID"];
};

export type MutationSiteRefreshCombinedEventsArgs = {
  siteId: Scalars["ID"];
};

export type MutationStopDigitalWatchdogCameraStreamArgs = {
  token: Scalars["String"];
};

export type MutationStopEagleEyeBridgeStreamArgs = {
  token: Scalars["String"];
};

export type MutationStopHikvisionNvrStreamArgs = {
  token: Scalars["String"];
};

export type MutationStopSecureComNvrStreamArgs = {
  token: Scalars["String"];
};

export type MutationSyncBillingArgs = {
  systemId: Scalars["ID"];
};

export type MutationSystemFeatureCustomerExportDataArgs = {
  dealerId: Scalars["ID"];
  feature: SystemFeatureTableConcepts;
  variant?: InputMaybe<OpportunityFeatureVariant>;
};

export type MutationTakeCameraSnapshotArgs = {
  cameraId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationTakePanelOfflineArgs = {
  systemId: Scalars["ID"];
};

export type MutationTakeSystemOffTestArgs = {
  systemId: Scalars["ID"];
};

export type MutationTakeVarCameraSnapshotArgs = {
  cameraId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationTakeoverPanelGetZonesArgs = {
  installerCode: Scalars["String"];
  panelType: TakeoverPanelType;
  systemId: Scalars["ID"];
};

export type MutationTakeoverPanelGetZonesEventArgs = {
  systemId: Scalars["ID"];
};

export type MutationTakeoverPanelSetupEventArgs = {
  systemId: Scalars["ID"];
};

export type MutationTestCameraConnectionArgs = {
  id: Scalars["ID"];
};

export type MutationTestSiteConnectionArgs = {
  siteControlSystemId: Scalars["ID"];
};

export type MutationToggleProxArgs = {
  input: ToggleProxInput;
};

export type MutationToggleRedBlueLightArgs = {
  cameraId: Scalars["String"];
  isOn: Scalars["Boolean"];
  systemId: Scalars["ID"];
};

export type MutationToggleWhiteLightArgs = {
  cameraId: Scalars["String"];
  isOn: Scalars["Boolean"];
  systemId: Scalars["ID"];
};

export type MutationTurnAllSystemOutputsOffArgs = {
  systemId: Scalars["ID"];
};

export type MutationTurnAllSystemOutputsOnArgs = {
  systemId: Scalars["ID"];
};

export type MutationTurnOutputOffArgs = {
  outputId: Scalars["ID"];
};

export type MutationTurnOutputOnArgs = {
  outputId: Scalars["ID"];
};

export type MutationTurnSecureComCameraLightOffArgs = {
  id: Scalars["ID"];
};

export type MutationTurnSecureComCameraLightOnArgs = {
  id: Scalars["ID"];
};

export type MutationUnhideFromVarHubEnabledCamerasListArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
  unhide: UnhideFromVarHubEnabledCamerasListInput;
};

export type MutationUnlockDoorArgs = {
  id: Scalars["ID"];
};

export type MutationUnlockSiteDoorArgs = {
  id: Scalars["ID"];
};

export type MutationUnlockZwaveLockArgs = {
  zwaveNodeId: Scalars["ID"];
};

export type MutationUpdateAlarmZoneArgs = {
  areaId?: InputMaybe<Scalars["String"]>;
  systemId: Scalars["ID"];
  zoneName?: InputMaybe<Scalars["String"]>;
  zoneNumber: Scalars["Int"];
};

export type MutationUpdateAutoEnrollDefaultsArgs = {
  input: UpdateAutoEnrollDefaultsInput;
};

export type MutationUpdateContactArgs = {
  contact: UpdateContactInput;
};

export type MutationUpdateControlSystemGroupArgs = {
  customerId: Scalars["ID"];
  group: ControlSystemGroupInput;
};

export type MutationUpdateDealerCentralStationAutomationIntegrationArgs = {
  integration: UpdateDealerCentralStationAutomationIntegrationInput;
};

export type MutationUpdateDealerUserSettingsArgs = {
  settings: DealerUserSettingsInput;
};

export type MutationUpdateDigitalWatchdogCameraArgs = {
  digitalWatchdogCamera: DigitalWatchdogCameraInput;
};

export type MutationUpdateDoorbellFirmwareArgs = {
  deviceId: Scalars["String"];
};

export type MutationUpdateEmergencyContactsArgs = {
  contacts: ReadonlyArray<UpdateEmergencyContactInput>;
  systemId: Scalars["ID"];
};

export type MutationUpdateFavoriteArgs = {
  favorite: FavoriteInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateFeatureKeyArgs = {
  controlSystemId: Scalars["ID"];
  featureKeyCode: Scalars["String"];
};

export type MutationUpdateGlobalHolidayDateForMassPanelsArgs = {
  input: UpdateGlobalHolidayDateForMassPanelsInput;
};

export type MutationUpdateGlobalHolidayDateForSinglePanelArgs = {
  input: UpdateGlobalHolidayDateForSinglePanelInput;
};

export type MutationUpdateGroupArgs = {
  profile: GroupInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateHolidayDateArgs = {
  input: UpdatePanelHolidayDateInput;
};

export type MutationUpdateIdpGroupsArgs = {
  IdpGroups: ReadonlyArray<InputMaybe<IdpGroupInput>>;
  customerId: Scalars["ID"];
};

export type MutationUpdateMenuDisplayArgs = {
  menuDisplay: MenuDisplayInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateOutputOptionsArgs = {
  action: SystemAction;
  option: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationUpdatePanelIntegrationArgs = {
  enabled: Scalars["Boolean"];
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationUpdatePanelModemFirmwareArgs = {
  systemId: Scalars["ID"];
};

export type MutationUpdatePanelPersonArgs = {
  customerId: Scalars["String"];
  input: PanelPersonInput;
  personId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationUpdatePcLogReportsArgs = {
  pcLogReports: PcLogReportsInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateProfileArgs = {
  profile: ProfileInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateRuleArgs = {
  rule: UpdateRuleInput;
};

export type MutationUpdateSavedReportArgs = {
  report: ReportInput;
};

export type MutationUpdateSecureComCameraArgs = {
  secureComCamera: SecureComCameraInput;
};

export type MutationUpdateSecureComCameraFirmwareArgs = {
  deviceId: Scalars["String"];
};

export type MutationUpdateSecureComDoorbellArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateSiteCardFormatArgs = {
  cardFormat: CardFormatInput;
  siteId: Scalars["ID"];
};

export type MutationUpdateSiteControlSystemArgs = {
  controlSystem: UpdateSiteControlSystemInput;
  elevatorOutputModules?: InputMaybe<
    ReadonlyArray<ChangeSiteControlSystemOutputModuleInput>
  >;
};

export type MutationUpdateSiteControlSystemOutputModuleArgs = {
  name: Scalars["String"];
  outputModule: Scalars["ID"];
  outputs: ReadonlyArray<UpdateSiteOutputInput>;
};

export type MutationUpdateSiteDetailsArgs = {
  site: UpdateSiteDetailsInput;
};

export type MutationUpdateSiteDoorScheduleArgs = {
  schedule: UpdateSiteScheduleInput;
};

export type MutationUpdateSiteFirmwaresArgs = {
  siteId: Scalars["ID"];
};

export type MutationUpdateSiteGroupArgs = {
  group: UpdateSiteGroupInput;
  title: Scalars["String"];
};

export type MutationUpdateSiteHolidayDateArgs = {
  holidayDate: UpdateHolidayDateInput;
};

export type MutationUpdateSitePersonArgs = {
  data: DataInputForUpdatePerson;
  requestMetaData: RequestMetaData;
  siteId: Scalars["ID"];
  title: Scalars["String"];
};

export type MutationUpdateSiteReportArgs = {
  report: UpdateSiteReportInput;
  siteId: Scalars["ID"];
};

export type MutationUpdateSiteVideoIntegrationsArgs = {
  siteId: Scalars["ID"];
  videoIntegrations: SiteVideoIntegrations;
};

export type MutationUpdateStatusListDisplayArgs = {
  statusListDisplay: StatusListDisplayInput;
  systemId: Scalars["ID"];
};

export type MutationUpdateVarHubArgs = {
  hub: UpdateVarHubInput;
};

export type MutationUpdateVarHubCameraArgs = {
  input: UpdateVarHubCameraInput;
  removedDetectionLineIds?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  removedDetectionRegionIds?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
};

export type MutationUpdateVarHubCameraCredentialsArgs = {
  credentials: UpdateVarHubCameraCredentialsInput;
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type MutationUpdateVarHubSettingsArgs = {
  hubId: Scalars["String"];
  hubSettings: UpdateVarHubSettingsInput;
  systemId: Scalars["String"];
};

export type MutationUpdateVarVideoActionArgs = {
  systemId: Scalars["ID"];
  varVideoAction: UpdateVarVideoActionInput;
};

export type MutationUpdateVideoActionArgs = {
  cameraType: VideoActionCameraType;
  systemId: Scalars["ID"];
  videoAction: UpdateVideoActionInput;
};

export type MutationUpdateVideoClipArgs = {
  clip: ClipInput;
  clipId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type MutationUpdateVideoDoorbellArgs = {
  videoDoorbell: VideoDoorbellInput;
};

export type MutationUpdateVueCameraArgs = {
  camera: VueCameraInput;
};

export type MutationUpdateXfPersonArgs = {
  customerId: Scalars["String"];
  input: XfPersonInput;
  personId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type MutationUpdateXfUserCodeArgs = {
  input: UpdateXfUserCodeInput;
  systemId: Scalars["ID"];
  userCodeNumber: Scalars["Int"];
};

export type MutationUpdateXvAudioDeviceCredentialsArgs = {
  input: UpdateXvAudioDeviceCredentialsInput;
  systemId: Scalars["ID"];
};

export type MutationUploadOsdpConfigArgs = {
  input: UploadOsdpConfigInput;
};

export type MutationValidateTwoFactorCodeArgs = {
  clientApplication: ClientApplication;
  code: Scalars["String"];
  isV4Login?: InputMaybe<Scalars["Boolean"]>;
  uuid: Scalars["String"];
};

export type MutationVernacularSuperMutationArgs = {
  dealerId: Scalars["String"];
  inputArray: ReadonlyArray<VernacularSuperMutationInputs>;
};

export enum NacProtocols {
  DMP = "DMP",
  GENTEX = "GENTEX",
  SYSTEM_SENSOR = "SYSTEM_SENSOR",
  UNKNOWN = "UNKNOWN",
  WHEELOCK = "WHEELOCK",
}

export type NetworkOptions = Node & {
  readonly __typename?: "NetworkOptions";
  readonly ddpPassphrase: Scalars["String"];
  readonly dhcpEnabled: Scalars["Boolean"];
  readonly dnsServer: Scalars["String"];
  readonly enableDdp: Scalars["Boolean"];
  readonly gatewayAddress: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly ipv6Address: Scalars["String"];
  readonly ipv6Dns: Scalars["String"];
  readonly ipv6Enabled: Scalars["Boolean"];
  readonly ipv6Gateway: Scalars["String"];
  readonly ipv6Prefix: Scalars["String"];
  readonly listenPort734N: Scalars["String"];
  readonly listenPort734NMax: Scalars["Int"];
  readonly listenPort734NMin: Scalars["Int"];
  readonly localIpAddress: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly passphrase: Scalars["String"];
  readonly passphrase734N: Scalars["String"];
  readonly programmingPort: Scalars["String"];
  readonly subnetMask: Scalars["String"];
  readonly wifiPassphrase: Scalars["String"];
  readonly wifiPassphraseMaxLength: Scalars["Int"];
  readonly wifiSecurity: NetworkOptionsWifiSecurity;
  readonly wifiSsid: Scalars["String"];
};

export type NetworkOptionsInput = {
  readonly ddpPassphrase: Scalars["String"];
  readonly dhcpEnabled: Scalars["Boolean"];
  readonly dnsServer: Scalars["String"];
  readonly enableDdp: Scalars["Boolean"];
  readonly gatewayAddress: Scalars["String"];
  readonly ipv6Address: Scalars["String"];
  readonly ipv6Dns: Scalars["String"];
  readonly ipv6Enabled: Scalars["Boolean"];
  readonly ipv6Gateway: Scalars["String"];
  readonly ipv6Prefix: Scalars["String"];
  readonly listenPort734N: Scalars["String"];
  readonly localIpAddress: Scalars["String"];
  readonly passphrase?: InputMaybe<Scalars["String"]>;
  readonly passphrase734N: Scalars["String"];
  readonly programmingPort: Scalars["String"];
  readonly subnetMask: Scalars["String"];
  readonly wifiPassphrase: Scalars["String"];
  readonly wifiSecurity: NetworkOptionsWifiSecurity;
  readonly wifiSsid: Scalars["String"];
};

export enum NetworkOptionsWifiSecurity {
  NONE = "NONE",
  UNSUPPORTED = "UNSUPPORTED",
  WEP = "WEP",
  WPA = "WPA",
}

export type NewCardFormatInput = {
  readonly name: Scalars["String"];
  readonly requireSiteCode: Scalars["Boolean"];
  readonly siteCodeLength: Scalars["Int"];
  readonly siteCodePosition: Scalars["Int"];
  readonly siteCodes: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly type?: InputMaybe<Scalars["Int"]>;
  readonly userCodeDigits: Scalars["Int"];
  readonly userCodeLength: Scalars["Int"];
  readonly userCodePosition: Scalars["Int"];
  readonly wiegandLength: Scalars["Int"];
};

export type NewOrExistingCardFormatInput = {
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly name: Scalars["String"];
  readonly requireSiteCode: Scalars["Boolean"];
  readonly siteCodeLength: Scalars["Int"];
  readonly siteCodePosition: Scalars["Int"];
  readonly siteCodes: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly type?: InputMaybe<Scalars["Int"]>;
  readonly userCodeDigits: Scalars["Int"];
  readonly userCodeLength: Scalars["Int"];
  readonly userCodePosition: Scalars["Int"];
  readonly wiegandLength: Scalars["Int"];
};

export type NewServiceRequest = {
  readonly __typename?: "NewServiceRequest";
  readonly controlSystemId?: Maybe<Scalars["Int"]>;
  readonly dealerId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly notes?: Maybe<Scalars["String"]>;
  readonly startDate?: Maybe<Scalars["String"]>;
  readonly technicianId?: Maybe<Scalars["Int"]>;
  readonly type?: Maybe<ServiceRequestTypes>;
};

export type NoBuffersError = Error & {
  readonly __typename?: "NoBuffersError";
  readonly type?: Maybe<ErrorType>;
};

export type NoCommunictaionTypeProvidedError = Error & {
  readonly __typename?: "NoCommunictaionTypeProvidedError";
  readonly type?: Maybe<ErrorType>;
};

export type NoControlSystemsProvidedError = Error & {
  readonly __typename?: "NoControlSystemsProvidedError";
  readonly type?: Maybe<ErrorType>;
};

export type NoPrinterError = Error & {
  readonly __typename?: "NoPrinterError";
  readonly type?: Maybe<ErrorType>;
};

export type Node = {
  readonly id: Scalars["ID"];
};

export type NotEnoughMobileCredentialsError = Error & {
  readonly __typename?: "NotEnoughMobileCredentialsError";
  readonly type: ErrorType;
};

export type NotEnoughtDigitalCredentialsError = Error & {
  readonly __typename?: "NotEnoughtDigitalCredentialsError";
  readonly type: ErrorType;
};

export type NotFoundError = Error & {
  readonly __typename?: "NotFoundError";
  readonly type?: Maybe<ErrorType>;
};

export type NotUniviewCameraError = Error & {
  readonly __typename?: "NotUniviewCameraError";
  readonly type?: Maybe<ErrorType>;
};

export type NotificationRecipient = {
  readonly __typename?: "NotificationRecipient";
  readonly contact: Contact;
  readonly emailEnabled: Scalars["Boolean"];
  readonly pushEnabled: Scalars["Boolean"];
  readonly textEnabled: Scalars["Boolean"];
};

export type OsdpConfigStatus = Node & {
  readonly __typename?: "OSDPConfigStatus";
  readonly configStatus: Scalars["String"];
  readonly deviceNumber: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly panelId: Scalars["Int"];
  readonly readerAddress?: Maybe<Scalars["String"]>;
  readonly utcUpdatedAt: Scalars["String"];
};

export type OsdpConfigStatusConnection = {
  readonly __typename?: "OSDPConfigStatusConnection";
  readonly edges: ReadonlyArray<OsdpConfigStatusEdge>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type OsdpConfigStatusEdge = {
  readonly __typename?: "OSDPConfigStatusEdge";
  readonly cursor: Scalars["String"];
  readonly node: OsdpConfigStatus;
};

export type OsdpReaderInput = {
  readonly address: Scalars["String"];
  readonly deviceNumber: Scalars["Int"];
};

export type OfflinePanelError = Error & {
  readonly __typename?: "OfflinePanelError";
  readonly type?: Maybe<ErrorType>;
};

export type OpenBarrierOperatorFailedResponse = {
  readonly __typename?: "OpenBarrierOperatorFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type OpenBarrierOperatorResponse =
  | OpenBarrierOperatorFailedResponse
  | OpenBarrierOperatorSuccessResponse;

export type OpenBarrierOperatorSuccessResponse = {
  readonly __typename?: "OpenBarrierOperatorSuccessResponse";
  readonly zwaveBarrierOperator: ZwaveBarrierOperator;
};

export type OpenEyeNvr = Node &
  VideoDevice & {
    readonly __typename?: "OpenEyeNvr";
    readonly channels: ReadonlyArray<OpenEyeNvrVideoChannel>;
    readonly deviceType: VideoDeviceType;
    readonly id: Scalars["ID"];
    readonly installerEmail?: Maybe<Scalars["EmailAddress"]>;
    readonly name: Scalars["String"];
    readonly serialNumber: Scalars["String"];
    readonly timeZone: Scalars["String"];
  };

export type OpenEyeNvrVideoChannel = Node & {
  readonly __typename?: "OpenEyeNvrVideoChannel";
  readonly id: Scalars["ID"];
  /** Provides a stream url in MP4 format */
  readonly mp4Stream?: Maybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  /** The most recent still shot of the camera's view */
  readonly snapshot?: Maybe<Scalars["URL"]>;
  readonly videoDevice: OpenEyeNvr;
};

export type OpenEyeNvrVideoChannelMp4StreamArgs = {
  quality?: InputMaybe<OpenEyeStreamQuality>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export enum OpenEyeStreamQuality {
  HIGH = "HIGH",
  LOW = "LOW",
}

export enum OpportunityActivationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  UNKNOWN = "UNKNOWN",
}

export type OpportunityDashboardCustomerFeatureExportData = {
  readonly __typename?: "OpportunityDashboardCustomerFeatureExportData";
  readonly customerId: Scalars["Int"];
  readonly email: Scalars["String"];
  readonly name: Scalars["String"];
  readonly phoneNumber: Scalars["String"];
};

export type OpportunityDashboardCustomersData = Node & {
  readonly __typename?: "OpportunityDashboardCustomersData";
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly customerName?: Maybe<Scalars["String"]>;
  readonly email?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly phoneNumber?: Maybe<Scalars["String"]>;
};

export type OpportunityDashboardCustomersDataConnection = {
  readonly __typename?: "OpportunityDashboardCustomersDataConnection";
  readonly edges: ReadonlyArray<Maybe<OpportunityDashboardCustomersDataEdge>>;
  readonly nodes: ReadonlyArray<Maybe<OpportunityDashboardCustomersData>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type OpportunityDashboardCustomersDataEdge = {
  readonly __typename?: "OpportunityDashboardCustomersDataEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<OpportunityDashboardCustomersData>;
};

export type OpportunityDashboardMetrics = Node & {
  readonly __typename?: "OpportunityDashboardMetrics";
  readonly databaseDealerId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly metric: OpportunityDashboardStatisticDetails;
};

export type OpportunityDashboardMetricsMetricArgs = {
  dealerCharge: Scalars["String"];
  feature: OpportunityFeature;
  variant?: InputMaybe<OpportunityFeatureVariant>;
};

export type OpportunityDashboardStatisticDetails = {
  readonly __typename?: "OpportunityDashboardStatisticDetails";
  /** Active means the concept (like system or customer) has a feature enabled */
  readonly active: Scalars["BigInt64"];
  readonly activePercent: Scalars["String"];
  readonly currentCost: Scalars["String"];
  readonly currentProfit: Scalars["String"];
  readonly currentRevenue: Scalars["String"];
  readonly featureCost: Scalars["Float"];
  /** Inactive means the concept (like system or customer) does not have a feature enabled */
  readonly inactive: Scalars["BigInt64"];
  readonly inactivePercent: Scalars["String"];
  readonly potentialCost: Scalars["String"];
  readonly potentialProfit: Scalars["String"];
  readonly potentialRevenue: Scalars["String"];
  readonly rawMonthlyCost: Scalars["Float"];
  readonly rawMonthlyPotentialCost: Scalars["Float"];
  readonly rawMonthlyPotentialProfit: Scalars["Float"];
  readonly rawMonthlyProfit: Scalars["Float"];
  readonly rawYearlyCost: Scalars["Float"];
  readonly rawYearlyPotentialCost: Scalars["Float"];
  readonly rawYearlyPotentialProfit: Scalars["Float"];
  readonly rawYearlyProfit: Scalars["Float"];
  readonly total: Scalars["BigInt64"];
  readonly yearlyCost: Scalars["String"];
  readonly yearlyPotentialCost: Scalars["String"];
  readonly yearlyPotentialProfit: Scalars["String"];
  readonly yearlyPotentialRevenue: Scalars["String"];
  readonly yearlyProfit: Scalars["String"];
  readonly yearlyRevenue: Scalars["String"];
};

export type OpportunityDashboardSystemFeatureExportData = {
  readonly __typename?: "OpportunityDashboardSystemFeatureExportData";
  readonly customerId: Scalars["Int"];
  readonly email: Scalars["String"];
  readonly name: Scalars["String"];
  readonly phoneNumber: Scalars["String"];
};

export type OpportunityDashboardSystemsData = Node & {
  readonly __typename?: "OpportunityDashboardSystemsData";
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly customerName?: Maybe<Scalars["String"]>;
  readonly email?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly systemId?: Maybe<Scalars["Int"]>;
  readonly systemName?: Maybe<Scalars["String"]>;
  /** Normalized Panel Hardware Model for display to users */
  readonly systemType?: Maybe<Scalars["String"]>;
};

export type OpportunityDashboardSystemsDataConnection = {
  readonly __typename?: "OpportunityDashboardSystemsDataConnection";
  readonly edges: ReadonlyArray<Maybe<OpportunityDashboardSystemsDataEdge>>;
  readonly nodes: ReadonlyArray<Maybe<OpportunityDashboardSystemsData>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type OpportunityDashboardSystemsDataEdge = {
  readonly __typename?: "OpportunityDashboardSystemsDataEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<OpportunityDashboardSystemsData>;
};

export enum OpportunityFeature {
  CUSTOMER_BADGE_PRINTING = "CUSTOMER_BADGE_PRINTING",
  CUSTOMER_DIGITAL_KEY_CREDENTIALS = "CUSTOMER_DIGITAL_KEY_CREDENTIALS",
  CUSTOMER_DIRECTORY_SYNC = "CUSTOMER_DIRECTORY_SYNC",
  CUSTOMER_SINGLE_SIGN_ON = "CUSTOMER_SINGLE_SIGN_ON",
  SYSTEM_ADVANCED_REPORTS = "SYSTEM_ADVANCED_REPORTS",
  SYSTEM_BADGE_PRINTING = "SYSTEM_BADGE_PRINTING",
  SYSTEM_TRAFFIC_COUNT = "SYSTEM_TRAFFIC_COUNT",
  SYSTEM_VIDEO_VERIFICATION = "SYSTEM_VIDEO_VERIFICATION",
  SYSTEM_VIRTUAL_KEYPAD_APP = "SYSTEM_VIRTUAL_KEYPAD_APP",
  SYSTEM_ZWAVE = "SYSTEM_ZWAVE",
}

export enum OpportunityFeatureVariant {
  ADVANCED_REPORTS_CELL = "ADVANCED_REPORTS_CELL",
  ADVANCED_REPORTS_NETWORK = "ADVANCED_REPORTS_NETWORK",
  VK_FULL_APP_CELL = "VK_FULL_APP_CELL",
  VK_FULL_APP_NETWORK = "VK_FULL_APP_NETWORK",
  VK_FULL_APP_NETWORK_WITH_CELL = "VK_FULL_APP_NETWORK_WITH_CELL",
}

export type Options = {
  readonly __typename?: "Options";
  readonly armAuthority?: Maybe<Scalars["Boolean"]>;
  readonly auditDaysEnabled?: Maybe<Scalars["Boolean"]>;
  readonly auditDaysValue?: Maybe<Scalars["String"]>;
  readonly disarmAuthority?: Maybe<Scalars["Boolean"]>;
  readonly groupsProgramming?: Maybe<Scalars["Boolean"]>;
  readonly lockdown?: Maybe<Scalars["Boolean"]>;
  readonly schedules?: Maybe<Scalars["Boolean"]>;
  readonly swipeTwiceToArm?: Maybe<Scalars["Boolean"]>;
  readonly userProgramming?: Maybe<Scalars["Boolean"]>;
};

export type OptionsInput = {
  readonly armAuthority?: InputMaybe<Scalars["Boolean"]>;
  readonly auditDaysEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly auditDaysValue?: InputMaybe<Scalars["String"]>;
  readonly disarmAuthority?: InputMaybe<Scalars["Boolean"]>;
  readonly groupsProgramming?: InputMaybe<Scalars["Boolean"]>;
  readonly lockdown?: InputMaybe<Scalars["Boolean"]>;
  readonly schedules?: InputMaybe<Scalars["Boolean"]>;
  readonly swipeTwiceToArm?: InputMaybe<Scalars["Boolean"]>;
  readonly userProgramming?: InputMaybe<Scalars["Boolean"]>;
};

export enum OsdpOrWiegand {
  OSDP = "OSDP",
  WIEGAND = "WIEGAND",
}

export type OsdpReaderDetails = {
  readonly __typename?: "OsdpReaderDetails";
  readonly firmware?: Maybe<Scalars["String"]>;
  readonly highFrequency13_56MHzEnabled?: Maybe<Scalars["Boolean"]>;
  readonly lowFrequency125kHzEnabled?: Maybe<Scalars["Boolean"]>;
  readonly mobileBleNfcEnabled?: Maybe<Scalars["Boolean"]>;
  readonly model?: Maybe<Scalars["String"]>;
};

export enum OsdpReaderProgrammingStatus {
  CONFIRMED = "CONFIRMED",
  ERROR = "ERROR",
  UNCONFIRMED = "UNCONFIRMED",
}

export type Output = Node &
  OutputOption & {
    readonly __typename?: "Output";
    readonly action?: Maybe<Scalars["String"]>;
    readonly formattedNumber: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly isNew: Scalars["Boolean"];
    readonly isWireless: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly numberWithName?: Maybe<Scalars["String"]>;
    readonly outputSupervision?: Maybe<OutputSupervision>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly realTimeStatus?: Maybe<Scalars["Boolean"]>;
    readonly serialNumber?: Maybe<Scalars["String"]>;
    readonly status: OutputStatus;
    readonly tripWithPanelBell: Scalars["Boolean"];
  };

export type OutputGroup = Node & {
  readonly __typename?: "OutputGroup";
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly outputNumber1: Scalars["String"];
  readonly outputNumber2: Scalars["String"];
  readonly outputNumber3: Scalars["String"];
  readonly outputNumber4: Scalars["String"];
  readonly outputNumber5: Scalars["String"];
  readonly outputNumber6: Scalars["String"];
  readonly outputNumber7: Scalars["String"];
  readonly outputNumber8: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
};

export type OutputGroupInput = {
  readonly hasChanges: Scalars["Boolean"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly outputNumber1: Scalars["String"];
  readonly outputNumber2: Scalars["String"];
  readonly outputNumber3: Scalars["String"];
  readonly outputNumber4: Scalars["String"];
  readonly outputNumber5: Scalars["String"];
  readonly outputNumber6: Scalars["String"];
  readonly outputNumber7: Scalars["String"];
  readonly outputNumber8: Scalars["String"];
};

export type OutputGroupProgrammingInput = {
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly outputNumber1: Scalars["String"];
  readonly outputNumber2: Scalars["String"];
  readonly outputNumber3: Scalars["String"];
  readonly outputNumber4: Scalars["String"];
  readonly outputNumber5: Scalars["String"];
  readonly outputNumber6: Scalars["String"];
  readonly outputNumber7: Scalars["String"];
  readonly outputNumber8: Scalars["String"];
};

export type OutputInput = {
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly outputSupervision?: InputMaybe<OutputSupervision>;
  readonly realTimeStatus?: InputMaybe<Scalars["Boolean"]>;
  readonly serialNumber?: InputMaybe<Scalars["String"]>;
  readonly tripWithPanelBell?: InputMaybe<Scalars["Boolean"]>;
};

export type OutputOption = {
  readonly formattedNumber: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly number: Scalars["Int"];
};

export type OutputOptions = Node & {
  readonly __typename?: "OutputOptions";
  readonly acFailOutput: OutputOption;
  readonly ambushOutput: OutputOption;
  readonly armAlarmOutput: OutputOption;
  readonly armedAllOrAwayOutput: OutputOption;
  readonly armedHomeOrPerimeterOutput: OutputOption;
  readonly armedOutput: OutputOption;
  readonly armedSleepOutput: OutputOption;
  readonly beginExitOutput: OutputOption;
  readonly burglaryOutput: OutputOption;
  readonly carbonMonoxideOutput: OutputOption;
  readonly closingWaitOutput: OutputOption;
  readonly communicationFailOutput: OutputOption;
  readonly coolSaverTemperature: Scalars["String"];
  readonly cutoffOutputs: Scalars["String"];
  readonly deviceFailOutput: OutputOption;
  readonly disarmedOutput: OutputOption;
  readonly endExitOutput: OutputOption;
  readonly entryDelayOutput: OutputOption;
  readonly fireAlarmOutput: OutputOption;
  readonly fireTroubleOutput: OutputOption;
  readonly heatSaverTemperature: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly lateToCloseOutput: OutputOption;
  readonly lockdownOutput: OutputOption;
  readonly outputCutoffTime: Scalars["Int"];
  readonly outputCutoffTimeMax: Scalars["Int"];
  readonly outputCutoffTimeMin: Scalars["Int"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly panicAlarmOutput: OutputOption;
  readonly readyOutput: OutputOption;
  readonly remoteArmingOutput: OutputOption;
  readonly sensorResetOutput: OutputOption;
  readonly supervisoryAlarmOutput: OutputOption;
  readonly telephoneTroubleOutput: OutputOption;
  readonly zoneMonitorOutput: OutputOption;
};

export type OutputOptionsInput = {
  readonly acFailOutput?: InputMaybe<Scalars["String"]>;
  readonly ambushOutput?: InputMaybe<Scalars["String"]>;
  readonly armAlarmOutput?: InputMaybe<Scalars["String"]>;
  readonly armedAllOrAwayOutput?: InputMaybe<Scalars["String"]>;
  readonly armedHomeOrPerimeterOutput?: InputMaybe<Scalars["String"]>;
  readonly armedOutput?: InputMaybe<Scalars["String"]>;
  readonly armedSleepOutput?: InputMaybe<Scalars["String"]>;
  readonly beginExitOutput?: InputMaybe<Scalars["String"]>;
  readonly burglaryOutput?: InputMaybe<Scalars["String"]>;
  readonly carbonMonoxideOutput?: InputMaybe<Scalars["String"]>;
  readonly closingWaitOutput?: InputMaybe<Scalars["String"]>;
  readonly communicationFailOutput?: InputMaybe<Scalars["String"]>;
  readonly coolSaverTemperature?: InputMaybe<Scalars["String"]>;
  readonly cutoffOutputs?: InputMaybe<Scalars["String"]>;
  readonly deviceFailOutput?: InputMaybe<Scalars["String"]>;
  readonly disarmedOutput?: InputMaybe<Scalars["String"]>;
  readonly endExitOutput?: InputMaybe<Scalars["String"]>;
  readonly entryDelayOutput?: InputMaybe<Scalars["String"]>;
  readonly fireAlarmOutput?: InputMaybe<Scalars["String"]>;
  readonly fireTroubleOutput?: InputMaybe<Scalars["String"]>;
  readonly heatSaverTemperature?: InputMaybe<Scalars["String"]>;
  readonly lateToCloseOutput?: InputMaybe<Scalars["String"]>;
  readonly lockdownOutput?: InputMaybe<Scalars["String"]>;
  readonly outputCutoffTime?: InputMaybe<Scalars["String"]>;
  readonly panicAlarmOutput?: InputMaybe<Scalars["String"]>;
  readonly readyOutput?: InputMaybe<Scalars["String"]>;
  readonly remoteArmingOutput?: InputMaybe<Scalars["String"]>;
  readonly sensorResetOutput?: InputMaybe<Scalars["String"]>;
  readonly supervisoryAlarmOutput?: InputMaybe<Scalars["String"]>;
  readonly telephoneTroubleOutput?: InputMaybe<Scalars["String"]>;
  readonly zoneMonitorOutput?: InputMaybe<Scalars["String"]>;
};

export type OutputProgrammingInput = {
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly outputSupervision?: InputMaybe<OutputSupervision>;
  readonly realTimeStatus?: InputMaybe<Scalars["Boolean"]>;
  readonly serialNumber?: InputMaybe<Scalars["String"]>;
  readonly tripWithPanelBell?: InputMaybe<Scalars["Boolean"]>;
};

export enum OutputStatus {
  OFF = "OFF",
  ON = "ON",
  UNKNOWN = "UNKNOWN",
}

export enum OutputSupervision {
  FOUR_HOURS = "FOUR_HOURS",
  NONE = "NONE",
  ONE_HOUR = "ONE_HOUR",
  THREE_MINUTES = "THREE_MINUTES",
}

export enum OwnerType {
  CONTROL_SYSTEM = "CONTROL_SYSTEM",
  CUSTOMER = "CUSTOMER",
}

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars["ID"]>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars["Boolean"];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars["Boolean"];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars["ID"]>;
};

export type PanTiltDetails = {
  readonly __typename?: "PanTiltDetails";
  readonly panMax?: Maybe<Scalars["Int"]>;
  readonly panMin?: Maybe<Scalars["Int"]>;
  readonly panPosition?: Maybe<Scalars["Int"]>;
  readonly tiltMax?: Maybe<Scalars["Int"]>;
  readonly tiltMin?: Maybe<Scalars["Int"]>;
  readonly tiltPosition?: Maybe<Scalars["Int"]>;
};

export enum PanTiltError {
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  MOVE_CAMERA_FAILED = "MOVE_CAMERA_FAILED",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export type Panel = Node & {
  readonly __typename?: "Panel";
  readonly accountNumber: Scalars["String"];
  readonly accountPrefix: Scalars["String"];
  readonly areas: AreaConnection;
  readonly armingSystem: PanelArmingSystem;
  readonly autoProgramming: Scalars["Boolean"];
  readonly availableDeviceInformations: ReadonlyArray<AvailableDeviceInformation>;
  readonly axBusDoorDevicesMax: Scalars["Int"];
  readonly bellOptions?: Maybe<BellOptions>;
  readonly cardFormats: ReadonlyArray<CardFormat>;
  readonly commAddress: Scalars["String"];
  readonly commType: Scalars["String"];
  /** Will be null for XR panels */
  readonly communication?: Maybe<Communication>;
  /** Will be empty for XT panels */
  readonly communicationPaths: ReadonlyArray<CommunicationPath>;
  readonly countryCode: Scalars["String"];
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly deviceInformations: ReadonlyArray<DeviceInformation>;
  readonly deviceNumberRange: ReadonlyArray<Scalars["Int"]>;
  readonly ecpDscZoneNumberRange: ReadonlyArray<Scalars["Int"]>;
  readonly favorites: ReadonlyArray<Favorite>;
  readonly featureKeys: ReadonlyArray<FeatureKey>;
  readonly firmwareStatus: PanelFirmwareStatus;
  /** A percentage of the firmware update progress, if it is in progress. `null` otherwise. */
  readonly firmwareUpdateProgress?: Maybe<Scalars["Int"]>;
  readonly hardwareModel: PanelHardwareModel;
  readonly hardwareModelName: Scalars["String"];
  readonly helpFiles: HelpFileUrls;
  readonly id: Scalars["ID"];
  readonly internalReadersSupported: Scalars["Boolean"];
  readonly keyfobs: ReadonlyArray<Keyfob>;
  readonly keyfobsRange?: Maybe<ReadonlyArray<Scalars["Int"]>>;
  readonly keypadBusDevicesMax: Scalars["Int"];
  readonly legacyPanelId: Scalars["String"];
  readonly lockoutCode?: Maybe<LockoutCode>;
  readonly macAddress?: Maybe<Scalars["String"]>;
  readonly maxCommunicationPaths: Scalars["Int"];
  readonly maxKeyfobs?: Maybe<Scalars["Int"]>;
  readonly maxOutputGroups: Scalars["Int"];
  readonly maxOutputs: Scalars["Int"];
  readonly menuDisplay?: Maybe<MenuDisplay>;
  readonly messagingSetup?: Maybe<MessagingSetup>;
  readonly minCommunicationPathNumber: Scalars["Int"];
  readonly networkOptions?: Maybe<NetworkOptions>;
  readonly newArea?: Maybe<Area>;
  readonly newBellOptions?: Maybe<BellOptions>;
  readonly newCardFormat?: Maybe<CardFormat>;
  /** Will be null for XT panels */
  readonly newCommunicationPath?: Maybe<CommunicationPath>;
  readonly newDevice?: Maybe<DeviceInformation>;
  readonly newKeyfob?: Maybe<Keyfob>;
  readonly newNetworkOptions?: Maybe<NetworkOptions>;
  readonly newOutputGroup?: Maybe<OutputGroup>;
  readonly newOutputInformation?: Maybe<Output>;
  readonly newSystemReports?: Maybe<SystemReports>;
  readonly newZone?: Maybe<Zone>;
  readonly online: Scalars["Boolean"];
  readonly outputGroups: ReadonlyArray<OutputGroup>;
  readonly outputGroupsRange: ReadonlyArray<Scalars["Int"]>;
  readonly outputInformations: ReadonlyArray<Output>;
  readonly outputOptions?: Maybe<OutputOptions>;
  readonly pcLogReports?: Maybe<PcLogReports>;
  readonly programmingTemplate?: Maybe<ProgrammingTemplate>;
  readonly rawArmingSystem?: Maybe<Scalars["String"]>;
  readonly remoteKey?: Maybe<Scalars["String"]>;
  readonly remoteOptions?: Maybe<RemoteOptions>;
  readonly securityGrade?: Maybe<SecurityGrade>;
  readonly serialNumber?: Maybe<Scalars["String"]>;
  readonly simIdentifier?: Maybe<Scalars["BigInt64"]>;
  readonly softwareDate: Scalars["String"];
  readonly softwareVersion: Scalars["String"];
  readonly softwareVersionModifier?: Maybe<Scalars["String"]>;
  readonly statusListDisplay?: Maybe<StatusListDisplay>;
  readonly supports1100T: Scalars["Boolean"];
  readonly supportsAxBus: Scalars["Boolean"];
  readonly supportsCustomCardFormats: Scalars["Boolean"];
  readonly supportsDscZones: Scalars["Boolean"];
  readonly supportsEcpZones: Scalars["Boolean"];
  readonly supportsNetworkExpander: Scalars["Boolean"];
  readonly supportsPrivateDoor: Scalars["Boolean"];
  readonly supportsVplex: Scalars["Boolean"];
  readonly supportsXR550: Scalars["Boolean"];
  readonly supportsZoneExpanderSerialNumber: Scalars["Boolean"];
  readonly systemAreaInformation?: Maybe<SystemAreaInformation>;
  readonly systemOptions: SystemOptions;
  readonly systemReports?: Maybe<SystemReports>;
  readonly totalDevicesMax: Scalars["Int"];
  readonly totalWirelessZoneMax: Scalars["Int"];
  readonly totalZonesMax: Scalars["Int"];
  readonly userCodes: ReadonlyArray<Maybe<UserCode>>;
  readonly zoneInformations: ReadonlyArray<Zone>;
  readonly zoneNumberRange: ReadonlyArray<Scalars["Int"]>;
};

export type PanelAreasArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type PanelNewCommunicationPathArgs = {
  numberOverride?: InputMaybe<Scalars["Int"]>;
};

export type PanelNewDeviceArgs = {
  numberOverride?: InputMaybe<Scalars["Int"]>;
};

export type PanelNewKeyfobArgs = {
  numberOverride?: InputMaybe<Scalars["Int"]>;
};

export type PanelNewOutputGroupArgs = {
  numberOverride?: InputMaybe<Scalars["Int"]>;
};

export type PanelNewZoneArgs = {
  numberOverride?: InputMaybe<Scalars["Int"]>;
};

export enum PanelArmingSystem {
  AP = "AP",
  AREA = "AREA",
  HA = "HA",
  HSA = "HSA",
  HSAWG = "HSAWG",
}

export type PanelBusyError = Error & {
  readonly __typename?: "PanelBusyError";
  readonly type?: Maybe<ErrorType>;
};

export type PanelCapabilities = Node & {
  readonly __typename?: "PanelCapabilities";
  readonly areasMax: Scalars["Int"];
  readonly areasMin: Scalars["Int"];
  readonly cancelAlarms: Scalars["Boolean"];
  readonly customActionMessage: Scalars["Boolean"];
  readonly defaultUserCode: Scalars["Int"];
  readonly dualAuthority: Scalars["Boolean"];
  readonly emailMaxLength: Scalars["Int"];
  readonly enhancedAppSupport: Scalars["Boolean"];
  readonly expandedXt75CodesAndProfiles: Scalars["Boolean"];
  readonly generalTwilightScheduling: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly inactiveUser: Scalars["Boolean"];
  readonly inactiveUserAuditDaysMax: Scalars["Int"];
  readonly inactiveUserAuditDaysMin: Scalars["Int"];
  readonly instantArming: Scalars["Boolean"];
  readonly lockdownOverride: Scalars["Boolean"];
  readonly maxCodeNumber: Scalars["Int"];
  readonly maxNameLength: Scalars["Int"];
  readonly minCodeNumber: Scalars["Int"];
  readonly notesMaxLength: Scalars["Int"];
  readonly outputGroupsMax: Scalars["Int"];
  readonly outputGroupsMin: Scalars["Int"];
  readonly privateDoorsMax: Scalars["Int"];
  readonly privateDoorsMin: Scalars["Int"];
  readonly profilesMax: Scalars["Int"];
  readonly profilesMin: Scalars["Int"];
  readonly profilesPanelMax: Scalars["Int"];
  readonly profilesPanelMin: Scalars["Int"];
  readonly profilesProgramming?: Maybe<Scalars["Boolean"]>;
  readonly pushNotificationsEnabled: Scalars["Boolean"];
  readonly pushNotificationsSupported: Scalars["Boolean"];
  readonly rearmDelayMax: Scalars["Int"];
  readonly rearmDelayMin: Scalars["Int"];
  readonly remotePanic: Scalars["Boolean"];
  readonly schedulesMax: Scalars["Int"];
  readonly schedulesMin: Scalars["Int"];
  readonly schedulesProgramming: Scalars["Boolean"];
  readonly semproMessagingSupported: Scalars["Boolean"];
  readonly sendCodesToLocksCapable: Scalars["Boolean"];
  readonly sendCodesToLocksNumberMax: Scalars["Int"];
  readonly sendCodesToLocksNumberMin: Scalars["Int"];
  readonly singleAreaSystem: Scalars["Boolean"];
  readonly temporaryScheduling: Scalars["Boolean"];
  readonly userActions: Scalars["Boolean"];
  readonly userCodeDigitsMax: Scalars["Int"];
  readonly userCodeDigitsMin: Scalars["Int"];
  readonly userCodeRequired: Scalars["Boolean"];
  readonly userCodesProgramming: Scalars["Boolean"];
  readonly userPinDigitsMax: Scalars["Int"];
  readonly userPinDigitsMin: Scalars["Int"];
  readonly validUserCodeRange: ReadonlyArray<Scalars["Int"]>;
  readonly verifyAlarms: Scalars["Boolean"];
  readonly zoneBypass: Scalars["Boolean"];
  readonly zwaveOptimize: Scalars["Boolean"];
};

export enum PanelConcepts {
  AREA_INFORMATIONS = "AREA_INFORMATIONS",
  BELL_OPTIONS = "BELL_OPTIONS",
  CARD_FORMATS = "CARD_FORMATS",
  COMMUNICATION = "COMMUNICATION",
  COMMUNICATION_PATHS = "COMMUNICATION_PATHS",
  DEVICE_INFORMATIONS = "DEVICE_INFORMATIONS",
  FEATURE_KEYS = "FEATURE_KEYS",
  KEYFOBS = "KEYFOBS",
  LOCKOUT_CODE = "LOCKOUT_CODE",
  MENU_DISPLAY = "MENU_DISPLAY",
  NETWORK_OPTIONS = "NETWORK_OPTIONS",
  OUTPUT_GROUPS = "OUTPUT_GROUPS",
  OUTPUT_INFORMATIONS = "OUTPUT_INFORMATIONS",
  OUTPUT_OPTIONS = "OUTPUT_OPTIONS",
  PC_LOG_REPORTS = "PC_LOG_REPORTS",
  PROFILES = "PROFILES",
  REMOTE_OPTIONS = "REMOTE_OPTIONS",
  SECURITY_GRADE = "SECURITY_GRADE",
  STATUS_LIST = "STATUS_LIST",
  SYSTEM_AREA_INFORMATION = "SYSTEM_AREA_INFORMATION",
  SYSTEM_OPTIONS = "SYSTEM_OPTIONS",
  SYSTEM_REPORTS = "SYSTEM_REPORTS",
  ZONE_INFORMATIONS = "ZONE_INFORMATIONS",
}

export enum PanelConfirmationEnum {
  NAK = "NAK",
  PENDING = "PENDING",
  RETRIEVED = "RETRIEVED",
  SENT = "SENT",
  TIMEOUT = "TIMEOUT",
}

export type PanelEventBufferReport = {
  readonly __typename?: "PanelEventBufferReport";
  readonly createdAt: Scalars["String"];
  readonly doorAccessEvents: Scalars["Boolean"];
  readonly endDate?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly reportId: Scalars["Int"];
  readonly standardEvents: Scalars["Boolean"];
  readonly startDate?: Maybe<Scalars["String"]>;
  readonly systemId: Scalars["Int"];
  readonly type: Scalars["String"];
};

export type PanelFavorite = Node & {
  readonly __typename?: "PanelFavorite";
  readonly id: Scalars["ID"];
  readonly name?: Maybe<Scalars["String"]>;
  readonly number?: Maybe<Scalars["String"]>;
  readonly numberWithName?: Maybe<Scalars["String"]>;
};

export enum PanelFirmwareStatus {
  UPDATES_AVAILABLE = "UPDATES_AVAILABLE",
  UPDATES_FAILED = "UPDATES_FAILED",
  UPDATES_IN_PROGRESS = "UPDATES_IN_PROGRESS",
  UPDATES_SUCCESSFUL = "UPDATES_SUCCESSFUL",
  UP_TO_DATE = "UP_TO_DATE",
}

export enum PanelHardwareModel {
  CELLCOM = "CELLCOM",
  CELLCOM_EX = "CELLCOM_EX",
  CELLCOM_SL = "CELLCOM_SL",
  DUALCOM = "DUALCOM",
  DUALCOM_SERIAL = "DUALCOM_SERIAL",
  EPAD = "EPAD",
  ICOM = "ICOM",
  ICOM_E = "ICOM_E",
  ICOM_LNC = "ICOM_LNC",
  ICOM_NRL = "ICOM_NRL",
  ICOM_SL = "ICOM_SL",
  MINI_CELLCOM = "MINI_CELLCOM",
  NOTIFYI = "NOTIFYI",
  SCS101 = "SCS101",
  SCS150 = "SCS150",
  TMS6 = "TMS6",
  VIDEO_ONLY = "VIDEO_ONLY",
  X001 = "X001",
  XF6_100 = "XF6_100",
  XF6_500 = "XF6_500",
  XR5 = "XR5",
  XR6 = "XR6",
  XR10 = "XR10",
  XR20 = "XR20",
  XR40 = "XR40",
  XR100 = "XR100",
  XR100N = "XR100N",
  XR150 = "XR150",
  XR200 = "XR200",
  XR350 = "XR350",
  XR500 = "XR500",
  XR500N = "XR500N",
  XR550 = "XR550",
  XR2400F = "XR2400F",
  XRSUPER6 = "XRSuper6",
  XT30 = "XT30",
  XT30L = "XT30L",
  XT50 = "XT50",
  XT50L = "XT50L",
  XT75 = "XT75",
  XTL = "XTL",
  XTLN = "XTLN",
  XTLP = "XTLP",
  XTLW = "XTLW",
}

export type PanelNotCheckedInError = Error & {
  readonly __typename?: "PanelNotCheckedInError";
  readonly type?: Maybe<ErrorType>;
};

export type PanelPerson = Node & {
  readonly __typename?: "PanelPerson";
  readonly appUser?: Maybe<PanelPersonAppUser>;
  readonly company?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly creatorId?: Maybe<Scalars["String"]>;
  readonly credentials: ReadonlyArray<Maybe<PanelPersonCredential>>;
  readonly customer?: Maybe<Customer>;
  readonly customerId?: Maybe<Scalars["String"]>;
  readonly departmentId?: Maybe<Scalars["String"]>;
  readonly departmentTitle?: Maybe<Scalars["String"]>;
  readonly emailAddress?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly hasAppUser: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isManagedInAdmin?: Maybe<Scalars["Boolean"]>;
  /** Input id: ControlSystem | Site */
  readonly isMobileCredentialOnly?: Maybe<Scalars["Boolean"]>;
  readonly isTempDealerUser?: Maybe<Scalars["Boolean"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly middleName?: Maybe<Scalars["String"]>;
  readonly notes: ReadonlyArray<Maybe<PanelPersonNote>>;
  readonly personId?: Maybe<Scalars["String"]>;
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly photoUrl?: Maybe<Scalars["String"]>;
  readonly primaryLoginLocked?: Maybe<Scalars["Boolean"]>;
  readonly profiles: ReadonlyArray<Maybe<PanelPersonProfile>>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly userEmployeeId?: Maybe<Scalars["String"]>;
  readonly userTitle?: Maybe<Scalars["String"]>;
  readonly visibleLogin?: Maybe<Scalars["String"]>;
};

export type PanelPersonIsMobileCredentialOnlyArgs = {
  id: Scalars["ID"];
};

export type PanelPersonAppUser = {
  readonly __typename?: "PanelPersonAppUser";
  readonly accessibleId?: Maybe<Scalars["Int"]>;
  readonly accessibleType?: Maybe<Scalars["String"]>;
  readonly dealerTempExpires?: Maybe<Scalars["Boolean"]>;
  readonly email?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly hidden?: Maybe<Scalars["Boolean"]>;
  readonly id?: Maybe<Scalars["String"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly personId?: Maybe<Scalars["Int"]>;
  readonly role?: Maybe<Scalars["String"]>;
  readonly ssoOnly?: Maybe<Scalars["Boolean"]>;
  readonly userAuthId?: Maybe<Scalars["String"]>;
  readonly userImageUuid?: Maybe<Scalars["String"]>;
};

export type PanelPersonAppUserInput = {
  readonly email: Scalars["String"];
  readonly role?: InputMaybe<UserRole>;
};

export type PanelPersonCredential = {
  readonly __typename?: "PanelPersonCredential";
  readonly cardNumber?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly creatorId?: Maybe<Scalars["String"]>;
  readonly hotStamp?: Maybe<Scalars["String"]>;
  readonly id?: Maybe<Scalars["String"]>;
  readonly nextManUp?: Maybe<Scalars["Boolean"]>;
  readonly parentEntityId?: Maybe<Scalars["Int"]>;
  readonly parentEntityType?: Maybe<Scalars["String"]>;
  readonly personId?: Maybe<Scalars["Int"]>;
  readonly serialNumber?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly userCodes: ReadonlyArray<Maybe<PanelPersonUserCode>>;
};

export type PanelPersonCredentialInput = {
  readonly credentialType?: InputMaybe<ReadableCredentialType>;
  readonly externalNumber?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["String"];
};

export type PanelPersonInput = {
  readonly appUser?: InputMaybe<PanelPersonAppUserInput>;
  readonly company?: InputMaybe<Scalars["String"]>;
  readonly credentials: ReadonlyArray<PanelPersonCredentialInput>;
  readonly departmentId?: InputMaybe<Scalars["String"]>;
  readonly departmentTitle?: InputMaybe<Scalars["String"]>;
  readonly email?: InputMaybe<Scalars["String"]>;
  readonly firstName: Scalars["String"];
  readonly hasAppUser: Scalars["Boolean"];
  readonly lastName?: InputMaybe<Scalars["String"]>;
  readonly middleName?: InputMaybe<Scalars["String"]>;
  readonly mobileCredentialOnly: Scalars["Boolean"];
  readonly note?: InputMaybe<Scalars["String"]>;
  readonly phoneNumber?: InputMaybe<Scalars["String"]>;
  readonly photoUrl?: InputMaybe<Scalars["String"]>;
  readonly useSingleSignOn?: InputMaybe<Scalars["Boolean"]>;
  readonly userEmployeeId?: InputMaybe<Scalars["String"]>;
  readonly userTitle?: InputMaybe<Scalars["String"]>;
};

export type PanelPersonNote = {
  readonly __typename?: "PanelPersonNote";
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly id?: Maybe<Scalars["String"]>;
  readonly note?: Maybe<Scalars["String"]>;
  readonly personId?: Maybe<Scalars["Int"]>;
};

export enum PanelPersonParentEntityType {
  CONTROL_SYSTEM = "CONTROL_SYSTEM",
  SITE = "SITE",
}

export type PanelPersonProfile = {
  readonly __typename?: "PanelPersonProfile";
  readonly cardPlusPin?: Maybe<Scalars["Boolean"]>;
  readonly id?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly number?: Maybe<Scalars["String"]>;
  readonly panelId?: Maybe<Scalars["Int"]>;
  readonly recordNumber?: Maybe<Scalars["Int"]>;
};

export type PanelPersonUserCode = {
  readonly __typename?: "PanelPersonUserCode";
  readonly active?: Maybe<Scalars["Boolean"]>;
  readonly areas?: Maybe<ReadonlyArray<Maybe<Area>>>;
  readonly armOnly?: Maybe<Scalars["Boolean"]>;
  readonly code: Scalars["String"];
  readonly credentialId?: Maybe<Scalars["Int"]>;
  readonly del?: Maybe<Scalars["Boolean"]>;
  readonly deliveryEmail?: Maybe<Scalars["String"]>;
  readonly deliveryText?: Maybe<Scalars["String"]>;
  readonly deliveryType?: Maybe<DigitalCardDeliveryType>;
  readonly externalNumber?: Maybe<Scalars["String"]>;
  readonly id?: Maybe<Scalars["String"]>;
  readonly inactiveUserAuditDays?: Maybe<Scalars["String"]>;
  readonly isTempUser?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly number: Scalars["String"];
  readonly panelId?: Maybe<Scalars["Int"]>;
  readonly profile1?: Maybe<Scalars["String"]>;
  readonly profile2?: Maybe<Scalars["String"]>;
  readonly profile3?: Maybe<Scalars["String"]>;
  readonly profile4?: Maybe<Scalars["String"]>;
  readonly recordNumber?: Maybe<Scalars["Int"]>;
  readonly sendToLocks?: Maybe<Scalars["Boolean"]>;
  readonly tempEndDate?: Maybe<Scalars["String"]>;
  readonly tempStartDate?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
  readonly userLevel?: Maybe<UserCodeLevel>;
  readonly userPin?: Maybe<Scalars["String"]>;
  readonly xtUserLevel?: Maybe<UserCodeLevel>;
};

export type PanelPersonsList = {
  readonly __typename?: "PanelPersonsList";
  readonly hasMore: Scalars["Boolean"];
  readonly nextPageQueryParam?: Maybe<Scalars["String"]>;
  readonly people?: Maybe<ReadonlyArray<Maybe<QuickPanelPerson>>>;
  readonly peopleCount: Scalars["Int"];
};

export type PanelPersonsListConnection = {
  readonly __typename?: "PanelPersonsListConnection";
  readonly edges: ReadonlyArray<PanelPersonsListEdge>;
  readonly hasMore: Scalars["Boolean"];
  readonly nextPageQueryParam?: Maybe<Scalars["String"]>;
  readonly nodes: ReadonlyArray<QuickPanelPerson>;
  readonly pageInfo: PageInfo;
  readonly peopleCount: Scalars["Int"];
  readonly totalCount: Scalars["Int"];
};

export type PanelPersonsListEdge = {
  readonly __typename?: "PanelPersonsListEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<QuickPanelPerson>;
};

export type PanelProgrammingFailedError = Error & {
  readonly __typename?: "PanelProgrammingFailedError";
  readonly type?: Maybe<ErrorType>;
};

export enum PanelProgrammingLanguage {
  CZECH = "CZECH",
  DUTCH = "DUTCH",
  ENGLISH = "ENGLISH",
  FRENCH = "FRENCH",
  GREEK = "GREEK",
  NONE = "NONE",
  SPANISH = "SPANISH",
}

export type PanelResetInformation = Node & {
  readonly __typename?: "PanelResetInformation";
  readonly amount: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly panelStatisticsConnection: PanelResetStatisticsConnection;
};

export type PanelResetInformationPanelStatisticsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type PanelResetStatistic = Node & {
  readonly __typename?: "PanelResetStatistic";
  readonly amountOfResets: Scalars["Int"];
  readonly connectionType: PanelResetStatisticConnectionType;
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly dealer?: Maybe<Dealer>;
  readonly dealerName: Scalars["String"];
  readonly hardwareType: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly serial: Scalars["String"];
  readonly version: Scalars["String"];
};

export enum PanelResetStatisticConnectionType {
  CELL = "CELL",
  EASY_CONNECT = "EASY_CONNECT",
  EASY_CONNECT_WITH_CELL_BACKUP = "EASY_CONNECT_WITH_CELL_BACKUP",
  NETWORK = "NETWORK",
  UNKNOWN = "UNKNOWN",
}

export type PanelResetStatisticEdge = {
  readonly __typename?: "PanelResetStatisticEdge";
  readonly cursor: Scalars["ID"];
  readonly node: PanelResetStatistic;
};

export type PanelResetStatisticsConnection = {
  readonly __typename?: "PanelResetStatisticsConnection";
  readonly edges: ReadonlyArray<PanelResetStatisticEdge>;
  readonly nodes: ReadonlyArray<PanelResetStatistic>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type PanelUserSecurityCodeDetails = {
  readonly __typename?: "PanelUserSecurityCodeDetails";
  readonly appUserId?: Maybe<Scalars["String"]>;
  readonly code: Scalars["String"];
  readonly credentialId?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly number: Scalars["Int"];
  readonly pin: Scalars["String"];
};

export type PcLogReports = Node & {
  readonly __typename?: "PcLogReports";
  readonly armDisarmReportsEnabled: Scalars["Boolean"];
  readonly doorAccessReportsEnabled: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly logRealTimeStatusEnabled: Scalars["Boolean"];
  readonly networkIpAddress: Scalars["String"];
  readonly networkPort: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly supervisoryReportsEnabled: Scalars["Boolean"];
  readonly url?: Maybe<Scalars["String"]>;
  readonly useUrl?: Maybe<Scalars["Boolean"]>;
  readonly userCommandReportsEnabled: Scalars["Boolean"];
  readonly zonesReportsEnabled: Scalars["Boolean"];
};

export type PcLogReportsInput = {
  readonly armDisarmReportsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly doorAccessReportsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly logRealTimeStatusEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly networkIpAddress?: InputMaybe<Scalars["String"]>;
  readonly networkPort?: InputMaybe<Scalars["String"]>;
  readonly supervisoryReportsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly url?: InputMaybe<Scalars["String"]>;
  readonly useUrl?: InputMaybe<Scalars["Boolean"]>;
  readonly userCommandReportsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly zonesReportsEnabled?: InputMaybe<Scalars["Boolean"]>;
};

export type PerformantAppUser = Node & {
  readonly __typename?: "PerformantAppUser";
  readonly databaseId: Scalars["Int"];
  readonly email: Scalars["String"];
  readonly hidden: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly permissions: ReadonlyArray<Maybe<PerformantAppUserPermissions>>;
  readonly personId: Scalars["Int"];
  readonly photoUrl?: Maybe<Scalars["String"]>;
  readonly role: UserRole;
  readonly tempExpire?: Maybe<Scalars["String"]>;
};

export type PerformantAppUserPermissions = {
  readonly __typename?: "PerformantAppUserPermissions";
  readonly canHaveMultiPanelCodes: Scalars["Boolean"];
  readonly canViewCodes: Scalars["Boolean"];
  readonly databaseId: Scalars["Int"];
  readonly panelId: Scalars["Int"];
};

export type Person = {
  readonly appUser?: Maybe<User>;
  readonly appUsers: ReadonlyArray<User>;
  readonly emailAddress: Scalars["String"];
  readonly firstName: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly idpPersonStatus: IdpPersonStatus;
  readonly isMe: Scalars["Boolean"];
  readonly lastName: Scalars["String"];
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly visibleLogin?: Maybe<Scalars["String"]>;
};

export type PersonCan = {
  readonly __typename?: "PersonCan";
  readonly adminArming: Scalars["Boolean"];
  readonly doorAccess: Scalars["Boolean"];
  readonly doorLockUnlock: Scalars["Boolean"];
  readonly editEmergencyContacts: Scalars["Boolean"];
  readonly lockdown: Scalars["Boolean"];
  readonly manageReports: Scalars["Boolean"];
  readonly manageZwaveDevices: Scalars["Boolean"];
  readonly placeSystemOnTest: Scalars["Boolean"];
  readonly viewUserCodes: Scalars["Boolean"];
};

export type PersonWhoStartedJob = {
  readonly __typename?: "PersonWhoStartedJob";
  readonly email?: Maybe<Scalars["String"]>;
  readonly firstName?: Maybe<Scalars["String"]>;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly userId?: Maybe<Scalars["Int"]>;
};

export type PersonnelCustomRole = {
  readonly __typename?: "PersonnelCustomRole";
  readonly appUserAuthPermissions?: Maybe<
    ReadonlyArray<Maybe<UserPermissions>>
  >;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly dealerId?: Maybe<Scalars["Int"]>;
  readonly description?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly limitEntity?: Maybe<Scalars["Boolean"]>;
  readonly manageTags?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly parentUserAuthId?: Maybe<Scalars["Int"]>;
  readonly scheduleTime?: Maybe<Scalars["Boolean"]>;
  readonly timeZone?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly useDst?: Maybe<Scalars["Boolean"]>;
  readonly userAuthPermissions?: Maybe<PersonnelCustomRolePermissions>;
  readonly userAuthTimes?: Maybe<ReadonlyArray<Maybe<PersonnelSchedule>>>;
  readonly viewAllCustomers?: Maybe<Scalars["Boolean"]>;
};

export type PersonnelCustomRolePermissions = {
  readonly __typename?: "PersonnelCustomRolePermissions";
  readonly addOnFeaturesEdit: Scalars["Boolean"];
  readonly addOnFeaturesView: Scalars["Boolean"];
  readonly appUsersAdd: Scalars["Boolean"];
  readonly appUsersDelete: Scalars["Boolean"];
  readonly appUsersEdit: Scalars["Boolean"];
  readonly appUsersView: Scalars["Boolean"];
  readonly arming: Scalars["Boolean"];
  readonly automationView: Scalars["Boolean"];
  readonly billingView: Scalars["Boolean"];
  readonly bulkUpdateView: Scalars["Boolean"];
  readonly businessAnalyticsView: Scalars["Boolean"];
  readonly cellularActivate: Scalars["Boolean"];
  readonly cellularDeactivate: Scalars["Boolean"];
  readonly cellularSunsetView: Scalars["Boolean"];
  readonly cellularView: Scalars["Boolean"];
  readonly customersAdd: Scalars["Boolean"];
  readonly customersDelete: Scalars["Boolean"];
  readonly customersEdit: Scalars["Boolean"];
  readonly customersListView: Scalars["Boolean"];
  readonly customersView: Scalars["Boolean"];
  readonly dealerAdmin: Scalars["Boolean"];
  readonly dealerSettingsView: Scalars["Boolean"];
  readonly defaultProgrammingView: Scalars["Boolean"];
  readonly disarming: Scalars["Boolean"];
  readonly enforceIpWhitelist: Scalars["Boolean"];
  readonly globalHolidayDatesView: Scalars["Boolean"];
  readonly includedFeaturesEdit: Scalars["Boolean"];
  readonly includedFeaturesView: Scalars["Boolean"];
  readonly marketingCentralView: Scalars["Boolean"];
  readonly massProgrammingView: Scalars["Boolean"];
  readonly mobileCredentialsAllocate: Scalars["Boolean"];
  readonly mobileCredentialsPurchase: Scalars["Boolean"];
  readonly mobileCredentialsView: Scalars["Boolean"];
  readonly moveSystems: Scalars["Boolean"];
  readonly personnelDelete: Scalars["Boolean"];
  readonly personnelEdit: Scalars["Boolean"];
  readonly personnelView: Scalars["Boolean"];
  readonly printProgrammingView: Scalars["Boolean"];
  readonly profilesDelete: Scalars["Boolean"];
  readonly profilesEdit: Scalars["Boolean"];
  readonly profilesView: Scalars["Boolean"];
  readonly programmingAdd: Scalars["Boolean"];
  readonly programmingDelete: Scalars["Boolean"];
  readonly programmingEdit: Scalars["Boolean"];
  readonly programmingView: Scalars["Boolean"];
  readonly receiversView: Scalars["Boolean"];
  readonly remoteUpdateDashboardView: Scalars["Boolean"];
  readonly remoteUpdateView: Scalars["Boolean"];
  readonly reportingAnalyticsView: Scalars["Boolean"];
  readonly require2fa: Scalars["Boolean"];
  readonly schedulesDelete: Scalars["Boolean"];
  readonly schedulesEdit: Scalars["Boolean"];
  readonly schedulesView: Scalars["Boolean"];
  readonly sensorResetView: Scalars["Boolean"];
  readonly serviceRequestDashboardView: Scalars["Boolean"];
  readonly systemAnalyticsView: Scalars["Boolean"];
  readonly systemsAdd: Scalars["Boolean"];
  readonly systemsDelete: Scalars["Boolean"];
  readonly systemsEdit: Scalars["Boolean"];
  readonly systemsView: Scalars["Boolean"];
  readonly techApp: Scalars["Boolean"];
  readonly techTools: Scalars["Boolean"];
  readonly tempCustomerUserView: Scalars["Boolean"];
  readonly userCodesDelete: Scalars["Boolean"];
  readonly userCodesEdit: Scalars["Boolean"];
  readonly userCodesReveal: Scalars["Boolean"];
  readonly userCodesView: Scalars["Boolean"];
  readonly userManagementView: Scalars["Boolean"];
  readonly usersDelete: Scalars["Boolean"];
  readonly usersEdit: Scalars["Boolean"];
  readonly usersView: Scalars["Boolean"];
};

export type PersonnelSchedule = {
  readonly __typename?: "PersonnelSchedule";
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly dayOfWeek?: Maybe<Scalars["Int"]>;
  readonly endTime?: Maybe<Scalars["String"]>;
  readonly startTime?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly userAuthId?: Maybe<Scalars["Int"]>;
};

export type PollZwaveBarrierOperatorFailedResponse = {
  readonly __typename?: "PollZwaveBarrierOperatorFailedResponse";
  readonly error?: Maybe<Error>;
};

export type PollZwaveBarrierOperatorResponse =
  | PollZwaveBarrierOperatorFailedResponse
  | PollZwaveBarrierOperatorSuccessResponse;

export type PollZwaveBarrierOperatorSuccessResponse = {
  readonly __typename?: "PollZwaveBarrierOperatorSuccessResponse";
  readonly zwaveBarrierOperator: ZwaveBarrierOperator;
};

export type PotterConnectionBusyError = Error & {
  readonly __typename?: "PotterConnectionBusyError";
  readonly type?: Maybe<ErrorType>;
};

export type PotterConnectionFailedError = Error & {
  readonly __typename?: "PotterConnectionFailedError";
  readonly type?: Maybe<ErrorType>;
};

export type PreProgramStatus = {
  readonly __typename?: "PreProgramStatus";
  readonly job?: Maybe<Scalars["String"]>;
  readonly status: PreProgramStatusType;
};

export enum PreProgramStatusType {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  PRE_PROGRAMMING = "PRE_PROGRAMMING",
}

export type PriorityZoneError = Error & {
  readonly __typename?: "PriorityZoneError";
  readonly type?: Maybe<ErrorType>;
};

export type Profile = Node & {
  readonly __typename?: "Profile";
  readonly accessibleAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly accessibleSchedules?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly areas?: Maybe<ReadonlyArray<Maybe<Area>>>;
  readonly armableAreas?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly doors?: Maybe<ReadonlyArray<Maybe<Door>>>;
  readonly hasChanges?: Maybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly inactiveUserAuditDays?: Maybe<Scalars["String"]>;
  readonly isManagedInAdmin: Scalars["Boolean"];
  readonly isNew?: Maybe<Scalars["Boolean"]>;
  readonly isTechnicianUser?: Maybe<Scalars["Boolean"]>;
  readonly linkedProfileId?: Maybe<Scalars["Int"]>;
  readonly linkedProfileIds?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly options?: Maybe<ProfileOptions>;
  readonly outputGroup?: Maybe<Scalars["String"]>;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly privateDoors?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly rearmDelay?: Maybe<Scalars["String"]>;
  readonly recordNumber: Scalars["Int"];
  readonly saveStatus?: Maybe<SaveStatus>;
  readonly schedules?: Maybe<ReadonlyArray<Maybe<Schedule>>>;
  readonly timeSchedules?: Maybe<ReadonlyArray<Maybe<Schedule>>>;
};

export type ProfileEdge = {
  readonly __typename?: "ProfileEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Profile>;
};

export type ProfileInput = {
  readonly accessibleAreas?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]>>
  >;
  readonly accessibleSchedules?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]>>
  >;
  readonly armableAreas?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly inactiveUserAuditDays?: InputMaybe<Scalars["String"]>;
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly isTechnicianUser?: InputMaybe<Scalars["Boolean"]>;
  readonly linkedProfileId?: InputMaybe<Scalars["Int"]>;
  readonly linkedProfileIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]>>
  >;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly number: Scalars["String"];
  readonly options?: InputMaybe<ProfileOptionsInput>;
  readonly outputGroup?: InputMaybe<Scalars["String"]>;
  readonly privateDoors?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  readonly rearmDelay?: InputMaybe<Scalars["String"]>;
  readonly recordNumber?: InputMaybe<Scalars["Int"]>;
  readonly saveStatus?: InputMaybe<SaveStatus>;
};

export type ProfileOptions = {
  readonly __typename?: "ProfileOptions";
  readonly alarmSilence?: Maybe<Scalars["Boolean"]>;
  readonly arm?: Maybe<Scalars["Boolean"]>;
  readonly bypassZones?: Maybe<Scalars["Boolean"]>;
  readonly disarm?: Maybe<Scalars["Boolean"]>;
  readonly displayEvents?: Maybe<Scalars["Boolean"]>;
  readonly doorAccess?: Maybe<Scalars["Boolean"]>;
  readonly doorLockUnlock?: Maybe<Scalars["Boolean"]>;
  readonly easyArmDisarm?: Maybe<Scalars["Boolean"]>;
  readonly editProfiles?: Maybe<Scalars["Boolean"]>;
  readonly editSchedules?: Maybe<Scalars["Boolean"]>;
  readonly editUserCodes?: Maybe<Scalars["Boolean"]>;
  readonly extendSchedules?: Maybe<Scalars["Boolean"]>;
  readonly fireDrill?: Maybe<Scalars["Boolean"]>;
  readonly isTechnicianUser?: Maybe<Scalars["Boolean"]>;
  readonly legacyTempCode?: Maybe<Scalars["Boolean"]>;
  readonly lockdown?: Maybe<Scalars["Boolean"]>;
  readonly lockdownOverride?: Maybe<Scalars["Boolean"]>;
  readonly outputsOnOff?: Maybe<Scalars["Boolean"]>;
  readonly requireAntiPassback?: Maybe<Scalars["Boolean"]>;
  readonly requireCardPlusPin?: Maybe<Scalars["Boolean"]>;
  readonly requireDualAuthority?: Maybe<Scalars["Boolean"]>;
  readonly sensorReset?: Maybe<Scalars["Boolean"]>;
  readonly serviceRequest?: Maybe<Scalars["Boolean"]>;
  readonly setTime?: Maybe<Scalars["Boolean"]>;
  readonly systemTest?: Maybe<Scalars["Boolean"]>;
  readonly useSecondaryLanguage?: Maybe<Scalars["Boolean"]>;
  readonly viewArmedAreas?: Maybe<Scalars["Boolean"]>;
  readonly viewSystemStatus?: Maybe<Scalars["Boolean"]>;
  readonly viewZoneStatus?: Maybe<Scalars["Boolean"]>;
  readonly wifiSetup?: Maybe<Scalars["Boolean"]>;
  readonly zoneMonitor?: Maybe<Scalars["Boolean"]>;
};

export type ProfileOptionsInput = {
  readonly alarmSilence?: InputMaybe<Scalars["Boolean"]>;
  readonly arm?: InputMaybe<Scalars["Boolean"]>;
  readonly bypassZones?: InputMaybe<Scalars["Boolean"]>;
  readonly disarm?: InputMaybe<Scalars["Boolean"]>;
  readonly displayEvents?: InputMaybe<Scalars["Boolean"]>;
  readonly doorAccess?: InputMaybe<Scalars["Boolean"]>;
  readonly doorLockUnlock?: InputMaybe<Scalars["Boolean"]>;
  readonly easyArmDisarm?: InputMaybe<Scalars["Boolean"]>;
  readonly editProfiles?: InputMaybe<Scalars["Boolean"]>;
  readonly editSchedules?: InputMaybe<Scalars["Boolean"]>;
  readonly editUserCodes?: InputMaybe<Scalars["Boolean"]>;
  readonly extendSchedules?: InputMaybe<Scalars["Boolean"]>;
  readonly fireDrill?: InputMaybe<Scalars["Boolean"]>;
  readonly isTechnicianUser?: InputMaybe<Scalars["Boolean"]>;
  readonly legacyTempCode?: InputMaybe<Scalars["Boolean"]>;
  readonly lockdown?: InputMaybe<Scalars["Boolean"]>;
  readonly lockdownOverride?: InputMaybe<Scalars["Boolean"]>;
  readonly outputsOnOff?: InputMaybe<Scalars["Boolean"]>;
  readonly requireAntiPassback?: InputMaybe<Scalars["Boolean"]>;
  readonly requireCardPlusPin?: InputMaybe<Scalars["Boolean"]>;
  readonly requireDualAuthority?: InputMaybe<Scalars["Boolean"]>;
  readonly sensorReset?: InputMaybe<Scalars["Boolean"]>;
  readonly serviceRequest?: InputMaybe<Scalars["Boolean"]>;
  readonly setTime?: InputMaybe<Scalars["Boolean"]>;
  readonly systemTest?: InputMaybe<Scalars["Boolean"]>;
  readonly useSecondaryLanguage?: InputMaybe<Scalars["Boolean"]>;
  readonly viewArmedAreas?: InputMaybe<Scalars["Boolean"]>;
  readonly viewSystemStatus?: InputMaybe<Scalars["Boolean"]>;
  readonly viewZoneStatus?: InputMaybe<Scalars["Boolean"]>;
  readonly wifiSetup?: InputMaybe<Scalars["Boolean"]>;
  readonly zoneMonitor?: InputMaybe<Scalars["Boolean"]>;
};

export type ProfilesConnection = {
  readonly __typename?: "ProfilesConnection";
  readonly edges: ReadonlyArray<ProfileEdge>;
  readonly nodes: ReadonlyArray<Profile>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ProgrammingTemplate = Node & {
  readonly __typename?: "ProgrammingTemplate";
  readonly concepts: ProgrammingTemplateConcepts;
  readonly customer?: Maybe<Customer>;
  readonly dealer: Dealer;
  readonly hardwareModel: PanelHardwareModel;
  readonly id: Scalars["ID"];
  readonly isDefaultTemplate: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly ratePlan?: Maybe<Scalars["String"]>;
  readonly receiverCommType: Scalars["String"];
};

export type ProgrammingTemplateBellOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateBellOptions";
    readonly automaticBellTest?: Maybe<TemplateFieldBoolean>;
    readonly auxiliary1BellAction?: Maybe<TemplateFieldBellActions>;
    readonly auxiliary2BellAction?: Maybe<TemplateFieldBellActions>;
    readonly bellCutoffTime?: Maybe<TemplateFieldInt>;
    readonly bellOutput?: Maybe<TemplateFieldString>;
    readonly burglaryBellAction?: Maybe<TemplateFieldBellActions>;
    readonly carbonMonoxideBellAction?: Maybe<TemplateFieldBellActions>;
    readonly emergencyBellAction?: Maybe<TemplateFieldBellActions>;
    readonly fireBellAction?: Maybe<TemplateFieldBellActions>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly nac1SyncProtocol?: Maybe<TemplateFieldNacProtocol>;
    readonly nac2SyncProtocol?: Maybe<TemplateFieldNacProtocol>;
    readonly panicBellAction?: Maybe<TemplateFieldBellActions>;
    readonly selectiveSilence?: Maybe<TemplateFieldBoolean>;
    readonly supervisoryBellAction?: Maybe<TemplateFieldBellActions>;
  };

export type ProgrammingTemplateBellOptionsInput = {
  readonly automaticBellTest?: InputMaybe<TemplateFieldBooleanInput>;
  readonly auxiliary1BellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly auxiliary2BellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly bellCutoffTime?: InputMaybe<TemplateFieldIntInput>;
  readonly bellOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly burglaryBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly carbonMonoxideBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly emergencyBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly fireBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly included: Scalars["Boolean"];
  readonly nac1SyncProtocol?: InputMaybe<TemplateFieldNacProtocolInput>;
  readonly nac2SyncProtocol?: InputMaybe<TemplateFieldNacProtocolInput>;
  readonly panicBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
  readonly selectiveSilence?: InputMaybe<TemplateFieldBooleanInput>;
  readonly supervisoryBellAction?: InputMaybe<TemplateFieldBellActionsInput>;
};

export type ProgrammingTemplateConcept = {
  readonly id: Scalars["ID"];
  readonly included: Scalars["Boolean"];
};

export type ProgrammingTemplateConcepts =
  | TakeoverProgrammingTemplateConcepts
  | XfProgrammingTemplateConcepts
  | XrProgrammingTemplateConcepts
  | Xt75ProgrammingTemplateConcepts
  | XtProgrammingTemplateConcepts;

export type ProgrammingTemplateDevice734 = {
  readonly __typename?: "ProgrammingTemplateDevice734";
  readonly armedLockedLedColor?: Maybe<TemplateFieldDevice734LedColors>;
  readonly buzzerControl?: Maybe<TemplateFieldBoolean>;
  readonly cardFormatOptions?: Maybe<TemplateFieldDevice734CardOptions>;
  readonly disarmedLockedLedColor?: Maybe<TemplateFieldDevice734LedColors>;
  readonly enableOnboardSpeaker?: Maybe<TemplateFieldBoolean>;
  readonly enableZone3RequestToExit?: Maybe<TemplateFieldBoolean>;
  readonly enforceSiteCode?: Maybe<TemplateFieldBoolean>;
  readonly ledControl?: Maybe<TemplateFieldBoolean>;
  readonly noCommWithPanelRelayAction?: Maybe<TemplateFieldDevice734NoCommWithPanelRelayAction>;
  readonly number: Scalars["Int"];
  readonly numberOfUserCodeDigits?: Maybe<TemplateFieldInt>;
  readonly osdpPassphrase?: Maybe<TemplateFieldString>;
  readonly proxControl?: Maybe<TemplateFieldBoolean>;
  readonly readerProtocol?: Maybe<TemplateFieldDevice734ReaderProtocol>;
  readonly siteCode1?: Maybe<TemplateFieldString>;
  readonly siteCode2?: Maybe<TemplateFieldString>;
  readonly siteCode3?: Maybe<TemplateFieldString>;
  readonly siteCode4?: Maybe<TemplateFieldString>;
  readonly siteCode5?: Maybe<TemplateFieldString>;
  readonly siteCode6?: Maybe<TemplateFieldString>;
  readonly siteCode7?: Maybe<TemplateFieldString>;
  readonly siteCode8?: Maybe<TemplateFieldString>;
  readonly siteCodeBitLength?: Maybe<TemplateFieldInt>;
  readonly siteCodeStartBitPosition?: Maybe<TemplateFieldInt>;
  readonly tamperControl?: Maybe<TemplateFieldBoolean>;
  readonly unlockedLedColor?: Maybe<TemplateFieldDevice734LedColors>;
  readonly userCodeBitLength?: Maybe<TemplateFieldInt>;
  readonly userCodeStartBitPosition?: Maybe<TemplateFieldInt>;
  readonly wiegandBitLength?: Maybe<TemplateFieldInt>;
  readonly zone2BypassOnRequestToExit?: Maybe<TemplateFieldBoolean>;
  readonly zone2BypassTime?: Maybe<TemplateFieldInt>;
  readonly zone2RelockOnStateChange?: Maybe<TemplateFieldBoolean>;
  readonly zone3RequestToExitTime?: Maybe<TemplateFieldInt>;
};

export type ProgrammingTemplateDevice734Input = {
  readonly armedLockedLedColor?: InputMaybe<TemplateFieldDevice734LedColorsInput>;
  readonly buzzerControl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly cardFormatOptions?: InputMaybe<TemplateFieldDevice734CardOptionsInput>;
  readonly disarmedLockedLedColor?: InputMaybe<TemplateFieldDevice734LedColorsInput>;
  readonly enableOnboardSpeaker?: InputMaybe<TemplateFieldBooleanInput>;
  readonly enableZone3RequestToExit?: InputMaybe<TemplateFieldBooleanInput>;
  readonly enforceSiteCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly ledControl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly noCommWithPanelRelayAction?: InputMaybe<TemplateFieldDevice734NoCommWithPanelRelayActionInput>;
  readonly number: Scalars["Int"];
  readonly numberOfUserCodeDigits?: InputMaybe<TemplateFieldIntInput>;
  readonly osdpPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly proxControl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly readerProtocol?: InputMaybe<TemplateFieldDevice734ReaderProtocolInput>;
  readonly siteCode1?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode2?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode3?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode4?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode5?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode6?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode7?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCode8?: InputMaybe<TemplateFieldStringInput>;
  readonly siteCodeBitLength?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCodeStartBitPosition?: InputMaybe<TemplateFieldIntInput>;
  readonly tamperControl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly unlockedLedColor?: InputMaybe<TemplateFieldDevice734LedColorsInput>;
  readonly userCodeBitLength?: InputMaybe<TemplateFieldIntInput>;
  readonly userCodeStartBitPosition?: InputMaybe<TemplateFieldIntInput>;
  readonly wiegandBitLength?: InputMaybe<TemplateFieldIntInput>;
  readonly zone2BypassOnRequestToExit?: InputMaybe<TemplateFieldBooleanInput>;
  readonly zone2BypassTime?: InputMaybe<TemplateFieldIntInput>;
  readonly zone2RelockOnStateChange?: InputMaybe<TemplateFieldBooleanInput>;
  readonly zone3RequestToExitTime?: InputMaybe<TemplateFieldIntInput>;
};

export type ProgrammingTemplateEdge = {
  readonly __typename?: "ProgrammingTemplateEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<ProgrammingTemplate>;
};

export type ProgrammingTemplateKeyfob = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateKeyfob";
    readonly buttonFourAction?: Maybe<TemplateFieldKeyfobButtonType>;
    readonly buttonFourAreas?: Maybe<TemplateFieldString>;
    readonly buttonFourOutput?: Maybe<TemplateFieldString>;
    readonly buttonFourOutputAction?: Maybe<TemplateFieldKeyfobOutputAction>;
    readonly buttonFourPressTime?: Maybe<TemplateFieldKeyfobPressTime>;
    readonly buttonOneAction?: Maybe<TemplateFieldKeyfobButtonType>;
    readonly buttonOneAreas?: Maybe<TemplateFieldString>;
    readonly buttonOneOutput?: Maybe<TemplateFieldString>;
    readonly buttonOneOutputAction?: Maybe<TemplateFieldKeyfobOutputAction>;
    readonly buttonOnePressTime?: Maybe<TemplateFieldKeyfobPressTime>;
    readonly buttonThreeAction?: Maybe<TemplateFieldKeyfobButtonType>;
    readonly buttonThreeAreas?: Maybe<TemplateFieldString>;
    readonly buttonThreeOutput?: Maybe<TemplateFieldString>;
    readonly buttonThreeOutputAction?: Maybe<TemplateFieldKeyfobOutputAction>;
    readonly buttonThreePressTime?: Maybe<TemplateFieldKeyfobPressTime>;
    readonly buttonTwoAction?: Maybe<TemplateFieldKeyfobButtonType>;
    readonly buttonTwoAreas?: Maybe<TemplateFieldString>;
    readonly buttonTwoOutput?: Maybe<TemplateFieldString>;
    readonly buttonTwoOutputAction?: Maybe<TemplateFieldKeyfobOutputAction>;
    readonly buttonTwoPressTime?: Maybe<TemplateFieldKeyfobPressTime>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly keyfobName?: Maybe<TemplateFieldString>;
    readonly keyfobSupervisionTime?: Maybe<TemplateFieldKeyfobSupervisionTime>;
    readonly number: Scalars["Int"];
    readonly numberOfButtons?: Maybe<TemplateFieldKeyfobNumberOfButtons>;
    readonly userNumber?: Maybe<TemplateFieldInt>;
  };

export type ProgrammingTemplateKeyfobInput = {
  readonly buttonFourAction?: InputMaybe<TemplateFieldKeyfobButtonTypeInput>;
  readonly buttonFourAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonFourOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonFourOutputAction?: InputMaybe<TemplateFieldKeyfobOutputActionInput>;
  readonly buttonFourPressTime?: InputMaybe<TemplateFieldKeyfobPressTimeInput>;
  readonly buttonOneAction?: InputMaybe<TemplateFieldKeyfobButtonTypeInput>;
  readonly buttonOneAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonOneOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonOneOutputAction?: InputMaybe<TemplateFieldKeyfobOutputActionInput>;
  readonly buttonOnePressTime?: InputMaybe<TemplateFieldKeyfobPressTimeInput>;
  readonly buttonThreeAction?: InputMaybe<TemplateFieldKeyfobButtonTypeInput>;
  readonly buttonThreeAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonThreeOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonThreeOutputAction?: InputMaybe<TemplateFieldKeyfobOutputActionInput>;
  readonly buttonThreePressTime?: InputMaybe<TemplateFieldKeyfobPressTimeInput>;
  readonly buttonTwoAction?: InputMaybe<TemplateFieldKeyfobButtonTypeInput>;
  readonly buttonTwoAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonTwoOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly buttonTwoOutputAction?: InputMaybe<TemplateFieldKeyfobOutputActionInput>;
  readonly buttonTwoPressTime?: InputMaybe<TemplateFieldKeyfobPressTimeInput>;
  readonly included: Scalars["Boolean"];
  readonly keyfobName?: InputMaybe<TemplateFieldStringInput>;
  readonly keyfobSupervisionTime?: InputMaybe<TemplateFieldKeyfobSupervisionTimeInput>;
  readonly number: Scalars["Int"];
  readonly numberOfButtons?: InputMaybe<TemplateFieldKeyfobNumberOfButtonsInput>;
  readonly userNumber?: InputMaybe<TemplateFieldIntInput>;
};

export type ProgrammingTemplateLockoutCode = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateLockoutCode";
    readonly code?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
  };

export type ProgrammingTemplateLockoutCodeInput = {
  readonly code?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
};

export type ProgrammingTemplateNetworkOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateNetworkOptions";
    readonly ddpPassphrase?: Maybe<TemplateFieldString>;
    readonly dhcpEnabled?: Maybe<TemplateFieldBoolean>;
    readonly dnsServer?: Maybe<TemplateFieldString>;
    readonly enableDdp?: Maybe<TemplateFieldBoolean>;
    readonly gatewayAddress?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly ipv6Address?: Maybe<TemplateFieldString>;
    readonly ipv6Dns?: Maybe<TemplateFieldString>;
    readonly ipv6Enabled?: Maybe<TemplateFieldBoolean>;
    readonly ipv6Gateway?: Maybe<TemplateFieldString>;
    readonly ipv6Prefix?: Maybe<TemplateFieldString>;
    readonly listenPort734N?: Maybe<TemplateFieldString>;
    readonly localIpAddress?: Maybe<TemplateFieldString>;
    readonly passphrase?: Maybe<TemplateFieldString>;
    readonly passphrase734N?: Maybe<TemplateFieldString>;
    readonly programmingPort?: Maybe<TemplateFieldString>;
    readonly subnetMask?: Maybe<TemplateFieldString>;
    readonly wifiPassphrase?: Maybe<TemplateFieldString>;
    readonly wifiSecurity?: Maybe<TemplateFieldNetworkOptionsWifiSecurity>;
    readonly wifiSsid?: Maybe<TemplateFieldString>;
  };

export type ProgrammingTemplateNetworkOptionsInput = {
  readonly ddpPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly dhcpEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly dnsServer?: InputMaybe<TemplateFieldStringInput>;
  readonly enableDdp?: InputMaybe<TemplateFieldBooleanInput>;
  readonly gatewayAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly ipv6Address?: InputMaybe<TemplateFieldStringInput>;
  readonly ipv6Dns?: InputMaybe<TemplateFieldStringInput>;
  readonly ipv6Enabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly ipv6Gateway?: InputMaybe<TemplateFieldStringInput>;
  readonly ipv6Prefix?: InputMaybe<TemplateFieldStringInput>;
  readonly listenPort734N?: InputMaybe<TemplateFieldStringInput>;
  readonly localIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly passphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly passphrase734N?: InputMaybe<TemplateFieldStringInput>;
  readonly programmingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly subnetMask?: InputMaybe<TemplateFieldStringInput>;
  readonly wifiPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly wifiSecurity?: InputMaybe<TemplateFieldNetworkOptionsWifiSecurityInput>;
  readonly wifiSsid?: InputMaybe<TemplateFieldStringInput>;
};

export type ProgrammingTemplateOutputInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateOutputInformation";
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly outputSupervision?: Maybe<TemplateFieldOutputSupervision>;
    readonly realTimeStatus?: Maybe<TemplateFieldBoolean>;
    readonly tripWithPanelBell?: Maybe<TemplateFieldBoolean>;
  };

export type ProgrammingTemplateOutputInformationInput = {
  readonly included: Scalars["Boolean"];
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly outputSupervision?: InputMaybe<TemplateFieldOutputSupervisionInput>;
  readonly realTimeStatus?: InputMaybe<TemplateFieldBooleanInput>;
  readonly tripWithPanelBell?: InputMaybe<TemplateFieldBooleanInput>;
};

export type ProgrammingTemplateOutputOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateOutputOptions";
    readonly acFailOutput?: Maybe<TemplateFieldString>;
    readonly ambushOutput?: Maybe<TemplateFieldString>;
    readonly armAlarmOutput?: Maybe<TemplateFieldString>;
    readonly armedAllOrAwayOutput?: Maybe<TemplateFieldString>;
    readonly armedHomeOrPerimeterOutput?: Maybe<TemplateFieldString>;
    readonly armedOutput?: Maybe<TemplateFieldString>;
    readonly armedSleepOutput?: Maybe<TemplateFieldString>;
    readonly beginExitOutput?: Maybe<TemplateFieldString>;
    readonly burglaryOutput?: Maybe<TemplateFieldString>;
    readonly carbonMonoxideOutput?: Maybe<TemplateFieldString>;
    readonly closingWaitOutput?: Maybe<TemplateFieldString>;
    readonly communicationFailOutput?: Maybe<TemplateFieldString>;
    readonly coolSaverTemperature?: Maybe<TemplateFieldString>;
    readonly cutoffOutputs?: Maybe<TemplateFieldString>;
    readonly deviceFailOutput?: Maybe<TemplateFieldString>;
    readonly disarmedOutput?: Maybe<TemplateFieldString>;
    readonly endExitOutput?: Maybe<TemplateFieldString>;
    readonly entryDelayOutput?: Maybe<TemplateFieldString>;
    readonly fireAlarmOutput?: Maybe<TemplateFieldString>;
    readonly fireTroubleOutput?: Maybe<TemplateFieldString>;
    readonly heatSaverTemperature?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lateToCloseOutput?: Maybe<TemplateFieldString>;
    readonly lockdownOutput?: Maybe<TemplateFieldString>;
    readonly outputCutoffTime?: Maybe<TemplateFieldInt>;
    readonly panicAlarmOutput?: Maybe<TemplateFieldString>;
    readonly readyOutput?: Maybe<TemplateFieldString>;
    readonly remoteArmingOutput?: Maybe<TemplateFieldString>;
    readonly sensorResetOutput?: Maybe<TemplateFieldString>;
    readonly supervisoryAlarmOutput?: Maybe<TemplateFieldString>;
    readonly telephoneTroubleOutput?: Maybe<TemplateFieldString>;
    readonly zoneMonitorOutput?: Maybe<TemplateFieldString>;
  };

export type ProgrammingTemplateOutputOptionsInput = {
  readonly acFailOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly ambushOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly armAlarmOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly armedAllOrAwayOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly armedHomeOrPerimeterOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly armedOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly armedSleepOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly beginExitOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly burglaryOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly carbonMonoxideOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly closingWaitOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly communicationFailOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly coolSaverTemperature?: InputMaybe<TemplateFieldStringInput>;
  readonly cutoffOutputs?: InputMaybe<TemplateFieldStringInput>;
  readonly deviceFailOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly disarmedOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly endExitOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly entryDelayOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly fireAlarmOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly fireTroubleOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly heatSaverTemperature?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly lateToCloseOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly lockdownOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly outputCutoffTime?: InputMaybe<TemplateFieldIntInput>;
  readonly panicAlarmOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly readyOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteArmingOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly sensorResetOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly supervisoryAlarmOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly telephoneTroubleOutput?: InputMaybe<TemplateFieldStringInput>;
  readonly zoneMonitorOutput?: InputMaybe<TemplateFieldStringInput>;
};

export type ProgrammingTemplateSecurityGrade = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateSecurityGrade";
    readonly grade?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
  };

export type ProgrammingTemplateSecurityGradeInput = {
  readonly grade?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
};

export type ProgrammingTemplateSystemReports = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateSystemReports";
    readonly abortReports?: Maybe<TemplateFieldBoolean>;
    readonly accessKeypads?: Maybe<TemplateFieldString>;
    readonly ambushReports?: Maybe<TemplateFieldBoolean>;
    readonly bypassReports?: Maybe<TemplateFieldBoolean>;
    readonly codeChangeReports?: Maybe<TemplateFieldBoolean>;
    readonly earlyToClose?: Maybe<TemplateFieldInt>;
    readonly entryCheckinProtection?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lateToOpen?: Maybe<TemplateFieldInt>;
    readonly openCloseEnable?: Maybe<TemplateFieldBoolean>;
    readonly scheduleChangeReports?: Maybe<TemplateFieldBoolean>;
    readonly sendStoredMessage?: Maybe<TemplateFieldBoolean>;
    readonly systemInformation?: Maybe<TemplateFieldBoolean>;
    readonly videoSystemReports?: Maybe<TemplateFieldBoolean>;
    readonly zoneRestoralReports?: Maybe<TemplateFieldSystemReportsZoneRestoralReports>;
  };

export type ProgrammingTemplateSystemReportsInput = {
  readonly abortReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly accessKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly ambushReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly bypassReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly codeChangeReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly earlyToClose?: InputMaybe<TemplateFieldIntInput>;
  readonly entryCheckinProtection?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly lateToOpen?: InputMaybe<TemplateFieldIntInput>;
  readonly openCloseEnable?: InputMaybe<TemplateFieldBooleanInput>;
  readonly scheduleChangeReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly sendStoredMessage?: InputMaybe<TemplateFieldBooleanInput>;
  readonly systemInformation?: InputMaybe<TemplateFieldBooleanInput>;
  readonly videoSystemReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly zoneRestoralReports?: InputMaybe<TemplateFieldSystemReportsZoneRestoralReportsInput>;
};

export type ProgrammingTemplateZoneInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "ProgrammingTemplateZoneInformation";
    readonly area?: Maybe<TemplateFieldString>;
    readonly armedAreasForArmingZone?: Maybe<TemplateFieldString>;
    readonly armedOpenActionMessage?: Maybe<TemplateFieldZoneMessage>;
    readonly armedOpenOutputAction?: Maybe<TemplateFieldZoneOutputAction>;
    readonly armedOpenOutputNumber?: Maybe<TemplateFieldString>;
    readonly armedShortActionMessage?: Maybe<TemplateFieldZoneMessage>;
    readonly armedShortOutputAction?: Maybe<TemplateFieldZoneOutputAction>;
    readonly armedShortOutputNumber?: Maybe<TemplateFieldString>;
    readonly armingStyle?: Maybe<TemplateFieldZoneArmingStyle>;
    readonly chimeSound?: Maybe<TemplateFieldZoneChimeSound>;
    readonly competitorWireless?: Maybe<TemplateFieldBoolean>;
    readonly contactNumber?: Maybe<TemplateFieldZoneTransmitterContact>;
    readonly crossZoneEnabled?: Maybe<TemplateFieldBoolean>;
    readonly disarmedOpenActionMessage?: Maybe<TemplateFieldZoneMessage>;
    readonly disarmedOpenOutputAction?: Maybe<TemplateFieldZoneOutputAction>;
    readonly disarmedOpenOutputNumber?: Maybe<TemplateFieldString>;
    readonly disarmedShortActionMessage?: Maybe<TemplateFieldZoneMessage>;
    readonly disarmedShortOutputAction?: Maybe<TemplateFieldZoneOutputAction>;
    readonly disarmedShortOutputNumber?: Maybe<TemplateFieldString>;
    readonly entryDelayNumber?: Maybe<TemplateFieldZoneEntryDelayNumber>;
    readonly fastResponseEnabled?: Maybe<TemplateFieldBoolean>;
    readonly fireBellOutputNumber?: Maybe<TemplateFieldString>;
    readonly firePanelSlaveInput?: Maybe<TemplateFieldBoolean>;
    readonly followArea?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly location?: Maybe<TemplateFieldString>;
    readonly lockdownEnabled?: Maybe<TemplateFieldBoolean>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly normallyClosed?: Maybe<TemplateFieldBoolean>;
    readonly number: Scalars["Int"];
    readonly presignalKeypads?: Maybe<TemplateFieldString>;
    readonly prewarnKeypads?: Maybe<TemplateFieldString>;
    readonly priorityZone?: Maybe<TemplateFieldBoolean>;
    readonly realTimeStatusEnabled?: Maybe<TemplateFieldBoolean>;
    readonly receiverRouting?: Maybe<TemplateFieldZoneReceiverRoute>;
    readonly remoteZoneType?: Maybe<TemplateZoneRemoteZoneType>;
    readonly reportWithAccountNumberForArea?: Maybe<TemplateFieldString>;
    readonly retardDelayEnabled?: Maybe<TemplateFieldBoolean>;
    readonly sensorType?: Maybe<TemplateFieldZoneSensorType>;
    readonly supervisionTime?: Maybe<TemplateFieldZoneSupervisionTime>;
    readonly swingerBypassEnabled?: Maybe<TemplateFieldBoolean>;
    readonly trafficCountEnabled?: Maybe<TemplateFieldBoolean>;
    readonly type?: Maybe<TemplateFieldZoneType>;
    readonly wireless?: Maybe<TemplateFieldBoolean>;
    readonly wirelessContactNormallyOpen?: Maybe<TemplateFieldBoolean>;
    readonly wirelessDisarmDisableEnabled?: Maybe<TemplateFieldBoolean>;
    readonly wirelessLedEnabled?: Maybe<TemplateFieldBoolean>;
    readonly wirelessPetImmunity?: Maybe<TemplateFieldZonePetImmunity>;
    readonly wirelessPirPulseCount?: Maybe<TemplateFieldZonePirPulseCount>;
    readonly wirelessPirSensitivity?: Maybe<TemplateFieldZonePirSensitivity>;
    readonly zoneAuditDays?: Maybe<TemplateFieldString>;
  };

export type ProgrammingTemplateZoneInformationInput = {
  readonly area?: InputMaybe<TemplateFieldStringInput>;
  readonly armedAreasForArmingZone?: InputMaybe<TemplateFieldStringInput>;
  readonly armedOpenActionMessage?: InputMaybe<TemplateFieldZoneMessageInput>;
  readonly armedOpenOutputAction?: InputMaybe<TemplateFieldZoneOutputActionInput>;
  readonly armedOpenOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly armedShortActionMessage?: InputMaybe<TemplateFieldZoneMessageInput>;
  readonly armedShortOutputAction?: InputMaybe<TemplateFieldZoneOutputActionInput>;
  readonly armedShortOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly armingStyle?: InputMaybe<TemplateFieldZoneArmingStyleInput>;
  readonly chimeSound?: InputMaybe<TemplateFieldZoneChimeSoundInput>;
  readonly competitorWireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly contactNumber?: InputMaybe<TemplateFieldZoneTransmitterContactInput>;
  readonly crossZoneEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly disarmedOpenActionMessage?: InputMaybe<TemplateFieldZoneMessageInput>;
  readonly disarmedOpenOutputAction?: InputMaybe<TemplateFieldZoneOutputActionInput>;
  readonly disarmedOpenOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly disarmedShortActionMessage?: InputMaybe<TemplateFieldZoneMessageInput>;
  readonly disarmedShortOutputAction?: InputMaybe<TemplateFieldZoneOutputActionInput>;
  readonly disarmedShortOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly entryDelayNumber?: InputMaybe<TemplateFieldZoneEntryDelayNumberInput>;
  readonly fastResponseEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly fireBellOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly firePanelSlaveInput?: InputMaybe<TemplateFieldBooleanInput>;
  readonly followArea?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly keyfobZone?: InputMaybe<TemplateFieldBooleanInput>;
  readonly location?: InputMaybe<TemplateFieldStringInput>;
  readonly lockdownEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly normallyClosed?: InputMaybe<TemplateFieldBooleanInput>;
  readonly number: Scalars["Int"];
  readonly presignalKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly prewarnKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly priorityZone?: InputMaybe<TemplateFieldBooleanInput>;
  readonly realTimeStatusEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiverRouting?: InputMaybe<TemplateFieldZoneReceiverRouteInput>;
  readonly remoteZoneType?: InputMaybe<TemplateZoneRemoteZoneTypeInput>;
  readonly reportWithAccountNumberForArea?: InputMaybe<TemplateFieldStringInput>;
  readonly retardDelayEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly sensorType?: InputMaybe<TemplateFieldZoneSensorTypeInput>;
  readonly supervisionTime?: InputMaybe<TemplateFieldZoneSupervisionTimeInput>;
  readonly swingerBypassEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly trafficCountEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly twoButtonPanic?: InputMaybe<TemplateFieldStringInput>;
  readonly type?: InputMaybe<TemplateFieldZoneTypeInput>;
  readonly wireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessContactNormallyOpen?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessDisarmDisableEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessLedEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessPetImmunity?: InputMaybe<TemplateFieldZonePetImmunityInput>;
  readonly wirelessPirPulseCount?: InputMaybe<TemplateFieldZonePirPulseCountInput>;
  readonly wirelessPirSensitivity?: InputMaybe<TemplateFieldZonePirSensitivityInput>;
  readonly zoneAuditDays?: InputMaybe<TemplateFieldStringInput>;
};

export type ProgrammingTemplatesConnection = {
  readonly __typename?: "ProgrammingTemplatesConnection";
  readonly edges: ReadonlyArray<ProgrammingTemplateEdge>;
  readonly nodes: ReadonlyArray<ProgrammingTemplate>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ProgressToastJobErrorResponse = {
  readonly __typename?: "ProgressToastJobErrorResponse";
  readonly error?: Maybe<Scalars["String"]>;
};

export type ProgressToastJobResponse =
  | ProgressToastJobErrorResponse
  | ProgressToastJobSuccessResponse;

export type ProgressToastJobSuccessResponse = {
  readonly __typename?: "ProgressToastJobSuccessResponse";
  readonly completionPercentage?: Maybe<Scalars["String"]>;
  readonly message?: Maybe<Scalars["String"]>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly uuid?: Maybe<Scalars["String"]>;
};

export type PutSystemOnTestErrorResponse = {
  readonly __typename?: "PutSystemOnTestErrorResponse";
  readonly error: Error;
};

export type PutSystemOnTestResponse =
  | PutSystemOnTestErrorResponse
  | PutSystemOnTestSuccessResponse;

export type PutSystemOnTestSuccessResponse = {
  readonly __typename?: "PutSystemOnTestSuccessResponse";
  readonly integration: ControlSystemCentralStationAutomationIntegration;
};

export type Query = {
  readonly __typename?: "Query";
  readonly appHelpFileUrl: Scalars["String"];
  readonly appNotifications: ReadonlyArray<AppNotification>;
  readonly appUsersByCustomerId?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly appUsersBySystemId?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly bulkImportSnapshotsToClear: ReadonlyArray<BulkImportSnapshotToClear>;
  readonly bulkUserCodeImportStatus?: Maybe<BulkUserCodeImportSnapshot>;
  readonly bulkUserCodeImportStatuses: ReadonlyArray<BulkUserCodeImportSnapshot>;
  readonly centralStationIntegrationNames: ReadonlyArray<CentralStationIntegrationName>;
  readonly controlSystemByDatabaseId?: Maybe<ControlSystem>;
  readonly controlSystemKeypadsAPI?: Maybe<
    ReadonlyArray<Maybe<KeypadsOverview>>
  >;
  readonly credential?: Maybe<Credential>;
  readonly customer?: Maybe<Customer>;
  readonly customerByDatabaseId?: Maybe<Customer>;
  readonly dealer?: Maybe<Dealer>;
  readonly dealerChargesQuery?: Maybe<DealerChargesResponse>;
  readonly dealerCustomRolePersonnel?: Maybe<
    ReadonlyArray<Maybe<DealerPersonnelItem>>
  >;
  readonly defaultControlSystem?: Maybe<ControlSystem>;
  readonly favoriteById?: Maybe<Favorite>;
  readonly getCamectHostPanelIntegrationConfig?: Maybe<CamectHostPanelIntegrationConfigResponsePayload>;
  readonly getCamectIntegrationLogs?: Maybe<CamectPanelIntegrationLogResponsePayload>;
  readonly getCamectPingPanel?: Maybe<CamectPingPanelResponsePayload>;
  readonly getCustomerList: ReadonlyArray<Maybe<CustomerListEntry>>;
  readonly getCustomerSelectList: ReadonlyArray<Maybe<CustomerSelectListEntry>>;
  readonly getDealerList: ReadonlyArray<Maybe<DealerListEntry>>;
  readonly getDealerTagsRelationsCounts: ReadonlyArray<
    Maybe<TagRelationsCounts>
  >;
  readonly getEulaStatus: EulaStatus;
  readonly getExistingBufferJob: Scalars["Int"];
  readonly getSavedReport: Report;
  readonly getSavedReports: ReadonlyArray<Report>;
  readonly getScheduleUse: ScheduleUse;
  readonly getTagById: Tag;
  readonly getTagRelationsById: TagRelations;
  readonly getTagsByType: TagFieldValue;
  readonly getTimeZones: ReadonlyArray<TimeZone>;
  readonly getVarHubFromId?: Maybe<GetVarHubPayload>;
  readonly getVarHubSettings: GetVarHubSettingsPayload;
  readonly getWsDiscoveryProbe?: Maybe<WsDiscoveryOnDemandProbeResponsePayload>;
  readonly getX1TypeFromSerialNumber: X1TypeResponse;
  readonly globalHolidayDateQuery: GlobalHolidayDateSingle;
  readonly holidayDateJobQuery: SchedulerJob;
  readonly idpGroups: ReadonlyArray<Maybe<IdpGroup>>;
  readonly keypadsAPI?: Maybe<ReadonlyArray<Maybe<KeypadsOverview>>>;
  readonly lxBusDiagnostic: ReadonlyArray<Maybe<LxBusDiagnostic>>;
  readonly massProgrammingQuickDetailedCustomersList: MassProgramPanelQuickDetailedResponse;
  readonly metaGraphQLNetworkLogsConnection: MetaGraphQlNetworkLogsConnection;
  readonly myPerson?: Maybe<Person>;
  readonly myUser?: Maybe<User>;
  readonly node?: Maybe<Node>;
  /** Get OSDP configuration status for a specific device */
  readonly osdpConfigStatus?: Maybe<OsdpConfigStatus>;
  /** Get all OSDP configuration statuses for a control system */
  readonly osdpConfigStatuses: ReadonlyArray<OsdpConfigStatus>;
  readonly person?: Maybe<Person>;
  readonly pollingBulkUserCodeImport?: Maybe<BulkUserCodeImportSnapshot>;
  readonly scapiCameraByDatabaseId: ScapiCameraDetails;
  readonly searchAvailableVideoDevice?: Maybe<VideoDevice>;
  readonly searchDealerActivity: ReadonlyArray<DealerActivity>;
  readonly site?: Maybe<Site>;
  readonly siteBatchJobs?: Maybe<BatchJobResponse>;
  /** Tracks the progress of an active X1 setup job and resolves when complete */
  readonly siteControlSystemSetupTracked: SiteControlSystemSetupTrackedPayload;
  readonly systemDiagnostic: SystemDiagnostic;
  readonly systemDiagnosticsGetPanel?: Maybe<SystemDiagnosticsPanel>;
  readonly systemDiagnosticsJobDepth: SystemDiagnosticsPanelJobDepth;
  readonly systemDiagnosticsJobListFromGroup: ReadonlyArray<SystemDiagnosticsPanelJob>;
  readonly systemDiagnosticsPanelJobGroups: ReadonlyArray<SystemDiagnosticsPanelJobGroup>;
  readonly systemDiagnosticsPanelSearch: ReadonlyArray<SystemDiagnosticsPanel>;
  readonly systemDiagnosticsPanelStatistics: ReadonlyArray<SystemDiagnosticsPanelStatistics>;
  readonly systemHasUnconfirmedProgramming: SystemHasUnconfirmedProgrammingResponse;
  readonly trackScapiJob?: Maybe<ProgressToastJobResponse>;
  readonly trackToastJob?: Maybe<ProgressToastJobResponse>;
  readonly userCodeByDatabaseId?: Maybe<UserCode>;
  readonly varConnectedCameraByDatabaseId: VarConnectedCamera;
  readonly videoDoorbellByDatabaseId?: Maybe<VideoDoorbell>;
  readonly vsCameraByDatabaseId: VsCameraDetails;
  readonly webRtcCameraByDatabaseId: ScapiV3CameraDetails;
};

export type QueryAppHelpFileUrlArgs = {
  app: ClientApp;
};

export type QueryAppUsersByCustomerIdArgs = {
  customerId: Scalars["ID"];
};

export type QueryAppUsersBySystemIdArgs = {
  customerId: Scalars["ID"];
  systemId: Scalars["ID"];
};

export type QueryBulkUserCodeImportStatusArgs = {
  id: Scalars["ID"];
};

export type QueryBulkUserCodeImportStatusesArgs = {
  customerId: Scalars["ID"];
  includedStatuses?: InputMaybe<BulkUserCodeImportStatusesIncludedStatusTypes>;
};

export type QueryControlSystemByDatabaseIdArgs = {
  databaseId: Scalars["Int"];
};

export type QueryControlSystemKeypadsApiArgs = {
  controlSystemId: Scalars["String"];
};

export type QueryCredentialArgs = {
  id: Scalars["ID"];
};

export type QueryCustomerArgs = {
  id: Scalars["ID"];
};

export type QueryCustomerByDatabaseIdArgs = {
  databaseId: Scalars["Int"];
};

export type QueryDealerArgs = {
  id: Scalars["ID"];
};

export type QueryDealerChargesQueryArgs = {
  dealerId: Scalars["String"];
};

export type QueryDealerCustomRolePersonnelArgs = {
  dealer_id: Scalars["String"];
};

export type QueryDefaultControlSystemArgs = {
  dealerId: Scalars["ID"];
  hardwareModel: PanelHardwareModel;
  softwareVersion: Scalars["String"];
};

export type QueryFavoriteByIdArgs = {
  favoriteId: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetCamectHostPanelIntegrationConfigArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetCamectIntegrationLogsArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetCamectPingPanelArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetCustomerListArgs = {
  id: Scalars["ID"];
};

export type QueryGetCustomerSelectListArgs = {
  id: Scalars["ID"];
};

export type QueryGetDealerTagsRelationsCountsArgs = {
  id: Scalars["ID"];
};

export type QueryGetExistingBufferJobArgs = {
  systemId: Scalars["String"];
};

export type QueryGetSavedReportArgs = {
  id: Scalars["String"];
};

export type QueryGetSavedReportsArgs = {
  dealerId: Scalars["Int"];
  userId: Scalars["Int"];
};

export type QueryGetScheduleUseArgs = {
  scheduleNumber: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetTagByIdArgs = {
  id: Scalars["ID"];
};

export type QueryGetTagRelationsByIdArgs = {
  id: Scalars["ID"];
};

export type QueryGetTagsByTypeArgs = {
  id: Scalars["ID"];
};

export type QueryGetTimeZonesArgs = {
  dealerId: Scalars["Int"];
};

export type QueryGetVarHubFromIdArgs = {
  id: Scalars["ID"];
};

export type QueryGetVarHubSettingsArgs = {
  id: Scalars["ID"];
};

export type QueryGetWsDiscoveryProbeArgs = {
  hubId: Scalars["String"];
  systemId: Scalars["String"];
};

export type QueryGetX1TypeFromSerialNumberArgs = {
  customerId: Scalars["ID"];
  serialNumber: Scalars["String"];
};

export type QueryGlobalHolidayDateQueryArgs = {
  id: Scalars["ID"];
};

export type QueryHolidayDateJobQueryArgs = {
  id: Scalars["ID"];
};

export type QueryIdpGroupsArgs = {
  customerId: Scalars["ID"];
};

export type QueryKeypadsApiArgs = {
  dealerId: Scalars["String"];
};

export type QueryLxBusDiagnosticArgs = {
  id: Scalars["String"];
};

export type QueryMassProgrammingQuickDetailedCustomersListArgs = {
  id: Scalars["ID"];
};

export type QueryMetaGraphQlNetworkLogsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryNodeArgs = {
  id: Scalars["ID"];
};

export type QueryOsdpConfigStatusArgs = {
  deviceNumber: Scalars["Int"];
  systemId: Scalars["ID"];
};

export type QueryOsdpConfigStatusesArgs = {
  systemId: Scalars["ID"];
};

export type QueryPersonArgs = {
  id: Scalars["ID"];
};

export type QueryPollingBulkUserCodeImportArgs = {
  id: Scalars["ID"];
};

export type QueryScapiCameraByDatabaseIdArgs = {
  databaseCameraId: Scalars["Int"];
};

export type QuerySearchAvailableVideoDeviceArgs = {
  identifier: Scalars["String"];
};

export type QuerySearchDealerActivityArgs = {
  queryString: Scalars["String"];
};

export type QuerySiteArgs = {
  id: Scalars["ID"];
};

export type QuerySiteBatchJobsArgs = {
  customerId: Scalars["String"];
  siteId: Scalars["String"];
};

export type QuerySiteControlSystemSetupTrackedArgs = {
  controlSystemId: Scalars["ID"];
};

export type QuerySystemDiagnosticsGetPanelArgs = {
  panelId: Scalars["String"];
};

export type QuerySystemDiagnosticsJobDepthArgs = {
  jobId: Scalars["Int"];
  panelId: Scalars["Int"];
};

export type QuerySystemDiagnosticsJobListFromGroupArgs = {
  groupId: Scalars["Int"];
  panelId: Scalars["Int"];
};

export type QuerySystemDiagnosticsPanelJobGroupsArgs = {
  panelId: Scalars["Int"];
};

export type QuerySystemDiagnosticsPanelSearchArgs = {
  queryString: Scalars["String"];
  useWildCard: Scalars["String"];
};

export type QuerySystemDiagnosticsPanelStatisticsArgs = {
  panelId: Scalars["Int"];
};

export type QuerySystemHasUnconfirmedProgrammingArgs = {
  concepts?: InputMaybe<ReadonlyArray<PanelConcepts>>;
  systemId: Scalars["ID"];
};

export type QueryTrackScapiJobArgs = {
  jobId: Scalars["String"];
};

export type QueryTrackToastJobArgs = {
  jobId: Scalars["String"];
};

export type QueryUserCodeByDatabaseIdArgs = {
  databaseId: Scalars["String"];
  systemId: Scalars["ID"];
};

export type QueryVarConnectedCameraByDatabaseIdArgs = {
  databaseCameraId: Scalars["Int"];
  systemId: Scalars["ID"];
};

export type QueryVideoDoorbellByDatabaseIdArgs = {
  databaseDoorbellId: Scalars["Int"];
};

export type QueryVsCameraByDatabaseIdArgs = {
  databaseCameraId: Scalars["Int"];
};

export type QueryWebRtcCameraByDatabaseIdArgs = {
  databaseCameraId: Scalars["Int"];
};

export type QuickCustomerPerson = Node & {
  readonly __typename?: "QuickCustomerPerson";
  readonly cardNumber?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly name?: Maybe<Scalars["String"]>;
  readonly note?: Maybe<Scalars["String"]>;
  readonly panelProfileId?: Maybe<Scalars["String"]>;
  readonly personId: Scalars["Int"];
  readonly personUpdatedAt?: Maybe<Scalars["String"]>;
  readonly photoUUID?: Maybe<Scalars["String"]>;
  readonly profilesPanelConfirmation?: Maybe<Scalars["String"]>;
  readonly rawEmail?: Maybe<Scalars["String"]>;
  readonly userCodesPanelConfirmation?: Maybe<Scalars["String"]>;
  readonly userHidden?: Maybe<Scalars["Boolean"]>;
  readonly userId?: Maybe<Scalars["String"]>;
  readonly userRole?: Maybe<Scalars["String"]>;
  readonly visibleLogin?: Maybe<Scalars["String"]>;
  readonly xf6MasterProfilePanels?: Maybe<Scalars["String"]>;
  readonly xf6StandardProfilePanels?: Maybe<Scalars["String"]>;
};

export type QuickDoorbell = Node & {
  readonly __typename?: "QuickDoorbell";
  readonly count: Scalars["Int"];
  readonly doorbellIds: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly id: Scalars["ID"];
};

export type QuickPanelPerson = Node & {
  readonly __typename?: "QuickPanelPerson";
  readonly active: Scalars["Boolean"];
  readonly databaseId?: Maybe<Scalars["String"]>;
  readonly firstName: Scalars["String"];
  readonly hasUnconfirmedData: Scalars["Boolean"];
  readonly icons: ReadonlyArray<Maybe<ReadableCredentialType>>;
  readonly id: Scalars["ID"];
  readonly idpPersonStatus: IdpPersonStatus;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly personPathId?: Maybe<Scalars["String"]>;
  readonly photoUrl?: Maybe<Scalars["String"]>;
  readonly recordNumbers: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly saveStatus?: Maybe<UserSaveStatus>;
};

export type QuickSecurityPanelPerson = Node & {
  readonly __typename?: "QuickSecurityPanelPerson";
  readonly active: Scalars["Boolean"];
  readonly databaseId?: Maybe<Scalars["String"]>;
  readonly firstName: Scalars["String"];
  readonly hasUnconfirmedData: Scalars["Boolean"];
  readonly icons: ReadonlyArray<Maybe<ReadableCredentialType>>;
  readonly id: Scalars["ID"];
  readonly idpPersonStatus: IdpPersonStatus;
  readonly lastName?: Maybe<Scalars["String"]>;
  readonly personPathId?: Maybe<Scalars["String"]>;
  readonly photoUrl?: Maybe<Scalars["String"]>;
  readonly saveStatus?: Maybe<UserSaveStatus>;
  readonly userCodes: ReadonlyArray<Maybe<QuickUserCode>>;
};

export type QuickSitePerson = Node & {
  readonly __typename?: "QuickSitePerson";
  readonly active: Scalars["Boolean"];
  readonly firstName: Scalars["String"];
  readonly hasBadge: Scalars["Boolean"];
  readonly hasMobile: Scalars["Boolean"];
  readonly hasUnconfirmedData: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly idpPersonStatus: IdpPersonStatus;
  readonly lastName: Scalars["String"];
  readonly photoUrl?: Maybe<Scalars["String"]>;
};

export type QuickSitePersonEdge = {
  readonly __typename?: "QuickSitePersonEdge";
  readonly cursor: Scalars["ID"];
  readonly node: QuickSitePerson;
};

export type QuickSitePersonsConnection = {
  readonly __typename?: "QuickSitePersonsConnection";
  readonly edges: ReadonlyArray<QuickSitePersonEdge>;
  readonly maxGroupsPerUser: Scalars["Int"];
  readonly nodes: ReadonlyArray<QuickSitePerson>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type QuickUserCode = {
  readonly __typename?: "QuickUserCode";
  readonly code?: Maybe<Scalars["String"]>;
  readonly credentialType?: Maybe<Scalars["Int"]>;
  readonly recordNumber?: Maybe<Scalars["Int"]>;
};

export type RawScapiV4AuthenticateResponse = {
  readonly __typename?: "RawScapiV4AuthenticateResponse";
  readonly accessible_id?: Maybe<Scalars["Int"]>;
  readonly accessible_type?: Maybe<Scalars["String"]>;
  readonly email?: Maybe<Scalars["String"]>;
  readonly exp?: Maybe<Scalars["String"]>;
  readonly id: Scalars["Int"];
  readonly jwt: Scalars["String"];
  readonly refresh_token: Scalars["String"];
  readonly role?: Maybe<Scalars["String"]>;
  readonly sso_users?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
};

export type ReactivateSecureComCameraErrorPayload = {
  readonly __typename?: "ReactivateSecureComCameraErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type ReactivateSecureComCameraResponse =
  | ReactivateSecureComCameraErrorPayload
  | ReactivateSecureComCameraSuccessPayload;

export type ReactivateSecureComCameraSuccessPayload = {
  readonly __typename?: "ReactivateSecureComCameraSuccessPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly secureComCamera?: Maybe<SecureComCamera>;
};

export type ReactivateVideoDeviceErrorPayload = {
  readonly __typename?: "ReactivateVideoDeviceErrorPayload";
  readonly error: ErrorType;
  readonly message: Scalars["String"];
};

export type ReactivateVideoDeviceResponse =
  | ReactivateVideoDeviceErrorPayload
  | ReactivateVideoDeviceSuccessPayload;

export type ReactivateVideoDeviceSuccessPayload = {
  readonly __typename?: "ReactivateVideoDeviceSuccessPayload";
  readonly message: Scalars["String"];
  readonly videoDevice: VideoDevice;
};

export enum ReadableCredentialType {
  CODE = "CODE",
  CREDENTIAL = "CREDENTIAL",
  DIGITAL_CARD = "DIGITAL_CARD",
  MOBILE = "MOBILE",
  UNKNOWN = "UNKNOWN",
}

export type ReaderDeleteError = Error & {
  readonly __typename?: "ReaderDeleteError";
  readonly type?: Maybe<ErrorType>;
};

export type ReaderDeleteSuccessResponse = {
  readonly __typename?: "ReaderDeleteSuccessResponse";
  readonly readerUUID: Scalars["String"];
};

export type ReaderInfo = {
  readonly __typename?: "ReaderInfo";
  readonly number?: Maybe<Scalars["String"]>;
  readonly readerAddress?: Maybe<Scalars["String"]>;
  readonly readerFirmwareBuild?: Maybe<Scalars["String"]>;
  readonly readerFirmwareMajor?: Maybe<Scalars["String"]>;
  readonly readerFirmwareMinor?: Maybe<Scalars["String"]>;
  readonly readerModelNumber?: Maybe<Scalars["String"]>;
  readonly readerVendorCode?: Maybe<Scalars["String"]>;
  readonly readerVersionNumber?: Maybe<Scalars["String"]>;
  readonly technologySetting125Khz?: Maybe<Scalars["Boolean"]>;
  readonly technologySetting1356Mhz?: Maybe<Scalars["Boolean"]>;
  readonly technologySettingMobile?: Maybe<Scalars["Boolean"]>;
};

export type ReaderInfoInput = {
  readonly number?: InputMaybe<Scalars["String"]>;
  readonly readerAddress?: InputMaybe<Scalars["String"]>;
  readonly readerFirmwareBuild?: InputMaybe<Scalars["String"]>;
  readonly readerFirmwareMajor?: InputMaybe<Scalars["String"]>;
  readonly readerFirmwareMinor?: InputMaybe<Scalars["String"]>;
  readonly readerModelNumber?: InputMaybe<Scalars["String"]>;
  readonly readerVendorCode?: InputMaybe<Scalars["String"]>;
  readonly readerVersionNumber?: InputMaybe<Scalars["String"]>;
  readonly technologySetting125Khz?: InputMaybe<Scalars["Boolean"]>;
  readonly technologySetting1356Mhz?: InputMaybe<Scalars["Boolean"]>;
  readonly technologySettingMobile?: InputMaybe<Scalars["Boolean"]>;
};

export type ReaderNameChangeError = Error & {
  readonly __typename?: "ReaderNameChangeError";
  readonly type?: Maybe<ErrorType>;
};

export type ReaderNameChangeSuccessResponse = {
  readonly __typename?: "ReaderNameChangeSuccessResponse";
  readonly name: Scalars["String"];
};

export type Receiver = Node & {
  readonly __typename?: "Receiver";
  readonly automationPrefix: Scalars["String"];
  readonly centralStationAutomationIntegration?: Maybe<CentralStationAutomationIntegration>;
  readonly dealer?: Maybe<Dealer>;
  readonly description?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly ip: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly port: Scalars["Int"];
};

export type ReceiverConfiguration = {
  readonly __typename?: "ReceiverConfiguration";
  readonly alarm: Scalars["Boolean"];
  readonly communicationTrouble: Scalars["Boolean"];
  readonly id: Scalars["Int"];
  readonly number: Scalars["Int"];
  readonly openClose: Scalars["Boolean"];
  readonly primaryIp: Scalars["String"];
  readonly primaryPort: Scalars["Int"];
  readonly secondaryIp: Scalars["String"];
  readonly secondaryPort: Scalars["String"];
  readonly supervisoryTrouble: Scalars["Boolean"];
  readonly testDays: Scalars["Int"];
  readonly testReport: Scalars["Boolean"];
};

export type ReceiverConnection = {
  readonly __typename?: "ReceiverConnection";
  readonly edges: ReadonlyArray<ReceiverEdge>;
  readonly nodes: ReadonlyArray<Receiver>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ReceiverEdge = {
  readonly __typename?: "ReceiverEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<Receiver>;
};

export type RecordClipErrorPayload = {
  readonly __typename?: "RecordClipErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RecordClipPayload =
  | RecordClipErrorPayload
  | RecordClipSuccessPayload;

export type RecordClipSuccessPayload = {
  readonly __typename?: "RecordClipSuccessPayload";
  readonly camera?: Maybe<ScapiV3CameraDetails>;
};

export type RecordSecureComCameraClipPayload = {
  readonly __typename?: "RecordSecureComCameraClipPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type RefreshAllCamerasErrorPayload = {
  readonly __typename?: "RefreshAllCamerasErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RefreshAllCamerasPayload =
  | RefreshAllCamerasErrorPayload
  | RefreshAllCamerasSuccessPayload;

export type RefreshAllCamerasSuccessPayload = {
  readonly __typename?: "RefreshAllCamerasSuccessPayload";
  readonly system: ControlSystem;
};

export type RefreshAllSystemOutputsErrorResponse = {
  readonly __typename?: "RefreshAllSystemOutputsErrorResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshAllSystemOutputsResponse =
  | RefreshAllSystemOutputsErrorResponse
  | RefreshAllSystemOutputsSuccessResponse;

export type RefreshAllSystemOutputsSuccessResponse = {
  readonly __typename?: "RefreshAllSystemOutputsSuccessResponse";
  readonly system: ControlSystem;
};

export type RefreshAreaArmedStatusesPayload =
  | RefreshAreaArmedStatusesSuccessPayload
  | UnknownError;

export type RefreshAreaArmedStatusesSuccessPayload = {
  readonly __typename?: "RefreshAreaArmedStatusesSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshAreaInformationsAndArmedStatusPayload =
  | ArmingError
  | RefreshAreaInformationsAndArmedStatusSuccessPayload;

export type RefreshAreaInformationsAndArmedStatusSuccessPayload = {
  readonly __typename?: "RefreshAreaInformationsAndArmedStatusSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshAreaInformationsError = Error & {
  readonly __typename?: "RefreshAreaInformationsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshAreaInformationsPayload =
  | RefreshAreaInformationsError
  | RefreshAreaInformationsSuccessPayload;

export type RefreshAreaInformationsSuccessPayload = {
  readonly __typename?: "RefreshAreaInformationsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshBellOptionsError = Error & {
  readonly __typename?: "RefreshBellOptionsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshBellOptionsPayload =
  | RefreshBellOptionsError
  | RefreshBellOptionsSuccessPayload;

export type RefreshBellOptionsSuccessPayload = {
  readonly __typename?: "RefreshBellOptionsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshCardFormatsErrorResponse = Error & {
  readonly __typename?: "RefreshCardFormatsErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshCardFormatsResponse =
  | RefreshCardFormatsErrorResponse
  | RefreshCardFormatsSuccessPayload;

export type RefreshCardFormatsSuccessPayload = {
  readonly __typename?: "RefreshCardFormatsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshCombinedEventsErrorPayload = {
  readonly __typename?: "RefreshCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type RefreshCombinedEventsPayload =
  | RefreshCombinedEventsErrorPayload
  | RefreshCombinedEventsSuccessPayload;

export type RefreshCombinedEventsSuccessPayload = {
  readonly __typename?: "RefreshCombinedEventsSuccessPayload";
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshCommunicationError = Error & {
  readonly __typename?: "RefreshCommunicationError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshCommunicationPathsError = Error & {
  readonly __typename?: "RefreshCommunicationPathsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshCommunicationPathsPayload =
  | RefreshCommunicationPathsError
  | RefreshCommunicationPathsSuccessPayload;

export type RefreshCommunicationPathsSuccessPayload = {
  readonly __typename?: "RefreshCommunicationPathsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshCommunicationPayload =
  | RefreshCommunicationError
  | RefreshCommunicationSuccessPayload;

export type RefreshCommunicationSuccessPayload = {
  readonly __typename?: "RefreshCommunicationSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshDeviceInformationsError = Error & {
  readonly __typename?: "RefreshDeviceInformationsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshDeviceInformationsPayload =
  | RefreshDeviceInformationsError
  | RefreshDeviceInformationsSuccessPayload;

export type RefreshDeviceInformationsSuccessPayload = {
  readonly __typename?: "RefreshDeviceInformationsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshDoorsMutationFailedResponse = {
  readonly __typename?: "RefreshDoorsMutationFailedResponse";
  readonly error: Error;
};

export type RefreshDoorsMutationResponse =
  | RefreshDoorsMutationFailedResponse
  | RefreshDoorsMutationSuccessResponse;

export type RefreshDoorsMutationSuccessResponse = {
  readonly __typename?: "RefreshDoorsMutationSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshEventsErrorPayload = {
  readonly __typename?: "RefreshEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type RefreshEventsPayload =
  | RefreshEventsErrorPayload
  | RefreshEventsSuccessPayload;

export type RefreshEventsSuccessPayload = {
  readonly __typename?: "RefreshEventsSuccessPayload";
  readonly customer?: Maybe<Customer>;
};

export type RefreshFavoritesErrorResponse = {
  readonly __typename?: "RefreshFavoritesErrorResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshFavoritesResponse =
  | RefreshFavoritesErrorResponse
  | RefreshFavoritesSuccessResponse;

export type RefreshFavoritesSuccessResponse = {
  readonly __typename?: "RefreshFavoritesSuccessResponse";
  readonly system: ControlSystem;
};

export type RefreshFeatureKeysError = {
  readonly __typename?: "RefreshFeatureKeysError";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly error: ErrorType;
};

export type RefreshFeatureKeysPayload =
  | RefreshFeatureKeysError
  | RefreshFeatureKeysSuccessPayload;

export type RefreshFeatureKeysSuccessPayload = {
  readonly __typename?: "RefreshFeatureKeysSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshGroupsErrorResponse = {
  readonly __typename?: "RefreshGroupsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GroupsError;
};

export type RefreshGroupsResponse =
  | RefreshGroupsErrorResponse
  | RefreshGroupsSuccessResponse;

export type RefreshGroupsSuccessResponse = {
  readonly __typename?: "RefreshGroupsSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshKeyfobsError = Error & {
  readonly __typename?: "RefreshKeyfobsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshKeyfobsPayload =
  | RefreshKeyfobsError
  | RefreshKeyfobsSuccessPayload;

export type RefreshKeyfobsSuccessPayload = {
  readonly __typename?: "RefreshKeyfobsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshLockoutCodeError = Error & {
  readonly __typename?: "RefreshLockoutCodeError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshLockoutCodePayload =
  | RefreshLockoutCodeError
  | RefreshLockoutCodeSuccessPayload;

export type RefreshLockoutCodeSuccessPayload = {
  readonly __typename?: "RefreshLockoutCodeSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshLxBusError = Error & {
  readonly __typename?: "RefreshLxBusError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshLxBusPayload =
  | RefreshLxBusError
  | RefreshLxBusSuccessPayload;

export type RefreshLxBusSuccessPayload = {
  readonly __typename?: "RefreshLxBusSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type RefreshMenuDisplayErrorResponse = {
  readonly __typename?: "RefreshMenuDisplayErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshMenuDisplayResponse =
  | RefreshMenuDisplayErrorResponse
  | RefreshMenuDisplaySuccessResponse;

export type RefreshMenuDisplaySuccessResponse = {
  readonly __typename?: "RefreshMenuDisplaySuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type RefreshMessagingSetupError = Error & {
  readonly __typename?: "RefreshMessagingSetupError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshMessagingSetupPayload =
  | RefreshMessagingSetupError
  | RefreshMessagingSetupSuccessPayload;

export type RefreshMessagingSetupSuccessPayload = {
  readonly __typename?: "RefreshMessagingSetupSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshNetworkOptionsError = Error & {
  readonly __typename?: "RefreshNetworkOptionsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshNetworkOptionsPayload =
  | RefreshNetworkOptionsError
  | RefreshNetworkOptionsSuccessPayload;

export type RefreshNetworkOptionsSuccessPayload = {
  readonly __typename?: "RefreshNetworkOptionsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshOnlyVarHubErrorPayload = {
  readonly __typename?: "RefreshOnlyVarHubErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RefreshOnlyVarHubPayload =
  | RefreshOnlyVarHubErrorPayload
  | RefreshOnlyVarHubSuccessPayload;

export type RefreshOnlyVarHubSuccessPayload = {
  readonly __typename?: "RefreshOnlyVarHubSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type RefreshOutputGroupsError = Error & {
  readonly __typename?: "RefreshOutputGroupsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshOutputGroupsPayload =
  | RefreshOutputGroupsError
  | RefreshOutputGroupsSuccessPayload;

export type RefreshOutputGroupsSuccessPayload = {
  readonly __typename?: "RefreshOutputGroupsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshOutputOptionsErrorResponse = {
  readonly __typename?: "RefreshOutputOptionsErrorResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshOutputOptionsResponse =
  | RefreshOutputOptionsErrorResponse
  | RefreshOutputOptionsSuccessResponse;

export type RefreshOutputOptionsSuccessResponse = {
  readonly __typename?: "RefreshOutputOptionsSuccessResponse";
  readonly system: ControlSystem;
};

export type RefreshPanelMacAndSerialErrorResponse = {
  readonly __typename?: "RefreshPanelMacAndSerialErrorResponse";
  readonly error: RefreshPanelMacAndSerialErrors;
};

export enum RefreshPanelMacAndSerialErrors {
  FAILED_TO_REFRESH = "FAILED_TO_REFRESH",
  JOB_FAILED = "JOB_FAILED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export type RefreshPanelMacAndSerialResponse =
  | RefreshPanelMacAndSerialErrorResponse
  | RefreshPanelMacAndSerialSuccessResponse;

export type RefreshPanelMacAndSerialSuccessResponse = {
  readonly __typename?: "RefreshPanelMacAndSerialSuccessResponse";
  readonly panel: Panel;
};

export type RefreshPanelPersonErrorResponse = {
  readonly __typename?: "RefreshPanelPersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshPanelPersonResponse =
  | RefreshPanelPersonErrorResponse
  | RefreshPanelPersonSuccessResponse;

export type RefreshPanelPersonSuccessResponse = {
  readonly __typename?: "RefreshPanelPersonSuccessResponse";
  readonly persons?: Maybe<ReadonlyArray<Maybe<PanelPerson>>>;
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshPanelPersonsListErrorResponse = {
  readonly __typename?: "RefreshPanelPersonsListErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshPanelPersonsListResponse =
  | RefreshPanelPersonsListErrorResponse
  | RefreshPanelPersonsListSuccessResponse;

export type RefreshPanelPersonsListSuccessResponse = {
  readonly __typename?: "RefreshPanelPersonsListSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshPcLogReportsErrorResponse = {
  readonly __typename?: "RefreshPcLogReportsErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshPcLogReportsResponse =
  | RefreshPcLogReportsErrorResponse
  | RefreshPcLogReportsSuccessResponse;

export type RefreshPcLogReportsSuccessResponse = {
  readonly __typename?: "RefreshPcLogReportsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type RefreshPersonErrorResponse = {
  readonly __typename?: "RefreshPersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshPersonResponse =
  | RefreshPersonErrorResponse
  | RefreshPersonSuccessResponse;

export type RefreshPersonSuccessResponse = {
  readonly __typename?: "RefreshPersonSuccessResponse";
  readonly persons?: Maybe<ReadonlyArray<Maybe<Person>>>;
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshProfilesErrorResponse = {
  readonly __typename?: "RefreshProfilesErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshProfilesResponse =
  | RefreshProfilesErrorResponse
  | RefreshProfilesSuccessResponse;

export type RefreshProfilesSuccessResponse = {
  readonly __typename?: "RefreshProfilesSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshProgressResponse =
  | NotFoundError
  | RefreshProgressSuccessResponse;

export type RefreshProgressSuccessResponse = {
  readonly __typename?: "RefreshProgressSuccessResponse";
  readonly jobGroupStatus: Scalars["String"];
  readonly jobOutput?: Maybe<Scalars["String"]>;
  readonly jobStatus?: Maybe<Scalars["String"]>;
};

export type RefreshRemoteOptionsError = Error & {
  readonly __typename?: "RefreshRemoteOptionsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshRemoteOptionsPayload =
  | RefreshRemoteOptionsError
  | RefreshRemoteOptionsSuccessPayload;

export type RefreshRemoteOptionsSuccessPayload = {
  readonly __typename?: "RefreshRemoteOptionsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshSecureComCameraErrorPayload = {
  readonly __typename?: "RefreshSecureComCameraErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type RefreshSecureComCameraResponse =
  | RefreshSecureComCameraErrorPayload
  | RefreshSecureComCameraSuccessPayload;

export type RefreshSecureComCameraSuccessPayload = {
  readonly __typename?: "RefreshSecureComCameraSuccessPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly secureComCamera?: Maybe<SecureComCamera>;
};

export type RefreshSecurityGradeError = Error & {
  readonly __typename?: "RefreshSecurityGradeError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshSecurityGradePayload =
  | RefreshSecurityGradeError
  | RefreshSecurityGradeSuccessPayload;

export type RefreshSecurityGradeSuccessPayload = {
  readonly __typename?: "RefreshSecurityGradeSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshStatusListDisplayErrorResponse = {
  readonly __typename?: "RefreshStatusListDisplayErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshStatusListDisplayResponse =
  | RefreshStatusListDisplayErrorResponse
  | RefreshStatusListDisplaySuccessResponse;

export type RefreshStatusListDisplaySuccessResponse = {
  readonly __typename?: "RefreshStatusListDisplaySuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type RefreshSystemOptionsResponse =
  | ConnectionTimeoutError
  | RefreshSystemOptionsSuccessResponse
  | UnknownError;

export type RefreshSystemOptionsSuccessResponse = {
  readonly __typename?: "RefreshSystemOptionsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type RefreshSystemReportsError = Error & {
  readonly __typename?: "RefreshSystemReportsError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshSystemReportsPayload =
  | RefreshSystemReportsError
  | RefreshSystemReportsSuccessPayload;

export type RefreshSystemReportsSuccessPayload = {
  readonly __typename?: "RefreshSystemReportsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshSystemStatusesErrorPayload = {
  readonly __typename?: "RefreshSystemStatusesErrorPayload";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshSystemStatusesResponse =
  | RefreshSystemStatusesErrorPayload
  | RefreshSystemStatusesSuccessPayload;

export type RefreshSystemStatusesSuccessPayload = {
  readonly __typename?: "RefreshSystemStatusesSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshUserCodeErrorResponse = {
  readonly __typename?: "RefreshUserCodeErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshUserCodeResponse =
  | RefreshUserCodeErrorResponse
  | RefreshUserCodeSuccessResponse;

export type RefreshUserCodeSuccessResponse = {
  readonly __typename?: "RefreshUserCodeSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshVarHubErrorPayload = {
  readonly __typename?: "RefreshVarHubErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RefreshVarHubPayload =
  | RefreshVarHubErrorPayload
  | RefreshVarHubSuccessPayload;

export type RefreshVarHubSuccessPayload = {
  readonly __typename?: "RefreshVarHubSuccessPayload";
  readonly system: ControlSystem;
};

export type RefreshVarVideoActionsErrorResponse = {
  readonly __typename?: "RefreshVarVideoActionsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshVarVideoActionsResponse =
  | RefreshVarVideoActionsErrorResponse
  | RefreshVarVideoActionsSuccessResponse;

export type RefreshVarVideoActionsSuccessResponse = {
  readonly __typename?: "RefreshVarVideoActionsSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type RefreshVideoActionsErrorResponse = {
  readonly __typename?: "RefreshVideoActionsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type RefreshVideoActionsResponse =
  | RefreshVideoActionsErrorResponse
  | RefreshVideoActionsSuccessResponse;

export type RefreshVideoActionsSuccessResponse = {
  readonly __typename?: "RefreshVideoActionsSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
  readonly videoActions: ReadonlyArray<Maybe<VideoAction>>;
};

export type RefreshVideoDeviceErrorPayload = {
  readonly __typename?: "RefreshVideoDeviceErrorPayload";
  readonly error: ErrorType;
  readonly message: Scalars["String"];
};

export type RefreshVideoDeviceResponse =
  | RefreshVideoDeviceErrorPayload
  | RefreshVideoDeviceSuccessPayload;

export type RefreshVideoDeviceSuccessPayload = {
  readonly __typename?: "RefreshVideoDeviceSuccessPayload";
  readonly message: Scalars["String"];
  readonly videoDevice: VideoDevice;
};

export type RefreshVideoDoorbellsErrorPayload = {
  readonly __typename?: "RefreshVideoDoorbellsErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RefreshVideoDoorbellsPayload =
  | RefreshVideoDoorbellsErrorPayload
  | RefreshVideoDoorbellsSuccessPayload;

export type RefreshVideoDoorbellsSuccessPayload = {
  readonly __typename?: "RefreshVideoDoorbellsSuccessPayload";
  readonly system: ControlSystem;
};

export type RefreshXvAudioDevicesErrorResponse = {
  readonly __typename?: "RefreshXvAudioDevicesErrorResponse";
  readonly type: XvAudioDeviceResponseErrors;
};

export type RefreshXvAudioDevicesResponse =
  | RefreshXvAudioDevicesErrorResponse
  | RefreshXvAudioDevicesSuccessResponse;

export type RefreshXvAudioDevicesSuccessResponse = {
  readonly __typename?: "RefreshXvAudioDevicesSuccessResponse";
  readonly audioDevices: ReadonlyArray<Maybe<XvAudioDevice>>;
};

export type RefreshZoneInformationError = Error & {
  readonly __typename?: "RefreshZoneInformationError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshZoneInformationPayload =
  | RefreshZoneInformationError
  | RefreshZoneInformationSuccessPayload;

export type RefreshZoneInformationSuccessPayload = {
  readonly __typename?: "RefreshZoneInformationSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshZoneStatusesError = Error & {
  readonly __typename?: "RefreshZoneStatusesError";
  readonly type?: Maybe<ErrorType>;
};

export type RefreshZoneStatusesPayload =
  | RefreshZoneStatusesError
  | RefreshZoneStatusesSuccessPayload;

export type RefreshZoneStatusesSuccessPayload = {
  readonly __typename?: "RefreshZoneStatusesSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshZonesStatusFailurePayload = {
  readonly __typename?: "RefreshZonesStatusFailurePayload";
  readonly error: UnknownError;
};

export type RefreshZonesStatusPayload =
  | RefreshZonesStatusFailurePayload
  | RefreshZonesStatusSuccessPayload;

export type RefreshZonesStatusSuccessPayload = {
  readonly __typename?: "RefreshZonesStatusSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type RefreshZwaveApplianceFailedResponse = {
  readonly __typename?: "RefreshZwaveApplianceFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveApplianceResponse =
  | RefreshZwaveApplianceFailedResponse
  | RefreshZwaveApplianceSuccessResponse;

export type RefreshZwaveApplianceSuccessResponse = {
  readonly __typename?: "RefreshZwaveApplianceSuccessResponse";
  readonly zwaveAppliance: ZwaveAppliance;
};

export type RefreshZwaveBarrierOperatorFailedResponse = {
  readonly __typename?: "RefreshZwaveBarrierOperatorFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveBarrierOperatorResponse =
  | RefreshZwaveBarrierOperatorFailedResponse
  | RefreshZwaveBarrierOperatorSuccessResponse;

export type RefreshZwaveBarrierOperatorSuccessResponse = {
  readonly __typename?: "RefreshZwaveBarrierOperatorSuccessResponse";
  readonly zwaveBarrierOperator: ZwaveBarrierOperator;
};

export type RefreshZwaveLightFailedResponse = {
  readonly __typename?: "RefreshZwaveLightFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveLightResponse =
  | RefreshZwaveLightFailedResponse
  | RefreshZwaveLightSuccessResponse;

export type RefreshZwaveLightSuccessResponse = {
  readonly __typename?: "RefreshZwaveLightSuccessResponse";
  readonly zwaveLight: ZwaveLight;
};

export type RefreshZwaveLockFailedResponse = {
  readonly __typename?: "RefreshZwaveLockFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveLockResponse =
  | RefreshZwaveLockFailedResponse
  | RefreshZwaveLockSuccessResponse;

export type RefreshZwaveLockSuccessResponse = {
  readonly __typename?: "RefreshZwaveLockSuccessResponse";
  readonly zwaveLock: ZwaveLock;
};

export type RefreshZwaveNodesFailedResponse = {
  readonly __typename?: "RefreshZwaveNodesFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveNodesResponse =
  | RefreshZwaveNodesFailedResponse
  | RefreshZwaveNodesSuccessResponse;

export type RefreshZwaveNodesSuccessResponse = {
  readonly __typename?: "RefreshZwaveNodesSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RefreshZwaveThermostatFailedResponse = {
  readonly __typename?: "RefreshZwaveThermostatFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RefreshZwaveThermostatResponse =
  | RefreshZwaveThermostatFailedResponse
  | RefreshZwaveThermostatSuccessResponse;

export type RefreshZwaveThermostatSuccessResponse = {
  readonly __typename?: "RefreshZwaveThermostatSuccessResponse";
  readonly zwaveThermostat: ZwaveThermostat;
};

export type RemoteDisarmUnsupportedError = Error & {
  readonly __typename?: "RemoteDisarmUnsupportedError";
  readonly type?: Maybe<ErrorType>;
};

export type RemoteOptions = {
  readonly appKey?: Maybe<Scalars["String"]>;
  readonly appKeyMaxLength: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly remoteKey: Scalars["String"];
  readonly remoteKeyMaxLength: Scalars["Int"];
};

export enum RemoteOptionsConnectionType {
  CELL = "CELL",
  NETWORK = "NETWORK",
  NONE = "NONE",
}

export type RemoveCardFormatDefaultError = Error & {
  readonly __typename?: "RemoveCardFormatDefaultError";
  readonly type?: Maybe<ErrorType>;
};

export type RemoveCardFormatResponse =
  | NotFoundError
  | RemoveCardFormatDefaultError
  | RemoveCardFormatSuccessResponse;

export type RemoveCardFormatSuccessResponse = {
  readonly __typename?: "RemoveCardFormatSuccessResponse";
  readonly cardFormat: CardFormat;
  readonly deletedCardFormatId: Scalars["ID"];
};

export type RemoveContactPayload = {
  readonly __typename?: "RemoveContactPayload";
  readonly contact: Contact;
  readonly contactEdge: ContactEdge;
};

export type RemoveDealerAccessErrorPayload = {
  readonly __typename?: "RemoveDealerAccessErrorPayload";
  readonly error?: Maybe<Error>;
};

export type RemoveDealerAccessPayload =
  | RemoveDealerAccessErrorPayload
  | RemoveDealerAccessSuccessPayload;

export type RemoveDealerAccessSuccessPayload = {
  readonly __typename?: "RemoveDealerAccessSuccessPayload";
  readonly system: ControlSystem;
};

export type RemoveDealerCentralStationAutomationIntegrationErrorResponse = {
  readonly __typename?: "RemoveDealerCentralStationAutomationIntegrationErrorResponse";
  readonly error: Error;
};

export type RemoveDealerCentralStationAutomationIntegrationResponse =
  | RemoveDealerCentralStationAutomationIntegrationErrorResponse
  | RemoveDealerCentralStationAutomationIntegrationSuccessResponse;

export type RemoveDealerCentralStationAutomationIntegrationSuccessResponse = {
  readonly __typename?: "RemoveDealerCentralStationAutomationIntegrationSuccessResponse";
  readonly dealer: Dealer;
  readonly integration: CentralStationAutomationIntegration;
};

export type RemoveFromVarHubEnabledCamerasListErrorPayload = {
  readonly __typename?: "RemoveFromVarHubEnabledCamerasListErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type RemoveFromVarHubEnabledCamerasListInput = {
  readonly removeCamectCameraId?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]>>
  >;
};

export type RemoveFromVarHubEnabledCamerasListPayload =
  | RemoveFromVarHubEnabledCamerasListErrorPayload
  | RemoveFromVarHubEnabledCamerasListSuccessPayload;

export type RemoveFromVarHubEnabledCamerasListSuccessPayload = {
  readonly __typename?: "RemoveFromVarHubEnabledCamerasListSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type RemoveHolidayDateResponse =
  | FailedToRemoveHolidayDateError
  | NotFoundError
  | SiteHolidayDateResponse;

export type RemoveRuleResponse = FailedToRemoveRuleError | NotFoundError | Rule;

export type RemoveSecureComCameraResponse =
  | NotFoundError
  | RemoveSecureComCameraSuccessPayload;

export type RemoveSecureComCameraSuccessPayload = {
  readonly __typename?: "RemoveSecureComCameraSuccessPayload";
  readonly deletedId?: Maybe<Scalars["ID"]>;
  readonly status?: Maybe<Scalars["String"]>;
};

export type RemoveSiteCardFormatResponse =
  | ConnectionTimeoutError
  | NotFoundError
  | RemoveSiteCardFormatSuccessResponse;

export type RemoveSiteCardFormatSuccessResponse = {
  readonly __typename?: "RemoveSiteCardFormatSuccessResponse";
  readonly removedCardFormatId?: Maybe<Scalars["ID"]>;
  readonly site?: Maybe<Site>;
};

export type RemoveSiteControlSystemOutputModuleError =
  | NotFoundError
  | UnknownError;

export type RemoveSiteControlSystemOutputModuleFailureResponse = {
  readonly __typename?: "RemoveSiteControlSystemOutputModuleFailureResponse";
  readonly error: RemoveSiteControlSystemOutputModuleError;
};

export type RemoveSiteControlSystemOutputModuleResponse =
  | RemoveSiteControlSystemOutputModuleFailureResponse
  | RemoveSiteControlSystemOutputModuleSuccessResponse;

export type RemoveSiteControlSystemOutputModuleSuccessResponse = {
  readonly __typename?: "RemoveSiteControlSystemOutputModuleSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly outputModule: SiteOutputModule;
};

export type RemoveSiteControlSystemResponse = NotFoundError | Site;

export type RemoveSiteDoorScheduleResponse =
  | FailedToRemoveScheduleError
  | NotFoundError
  | SiteDoorSchedule;

export type RemoveSiteGroupResponse =
  | NotFoundError
  | RemoveSiteGroupSuccessResponse;

export type RemoveSiteGroupSuccessResponse = {
  readonly __typename?: "RemoveSiteGroupSuccessResponse";
  readonly group?: Maybe<SiteGroup>;
  readonly site?: Maybe<Site>;
};

export type RemoveSitePersonResponse =
  | FailedToRemoveUserError
  | NotFoundError
  | RemoveSitePersonSuccessResponse;

export type RemoveSitePersonSuccessResponse = {
  readonly __typename?: "RemoveSitePersonSuccessResponse";
  readonly edge: SitePersonEdge;
  readonly person: CustomerPerson;
};

export type RemoveSiteReportResponse =
  | NotFoundError
  | RemoveSiteReportSuccessPayload;

export type RemoveSiteReportSuccessPayload = {
  readonly __typename?: "RemoveSiteReportSuccessPayload";
  readonly deletedReportId: Scalars["ID"];
  readonly site?: Maybe<Site>;
};

export type RemoveSiteResponse = NotFoundError | Site;

export type RemoveTagResponse = RemoveTagSuccessPayload | UnknownError;

export type RemoveTagSuccessPayload = {
  readonly __typename?: "RemoveTagSuccessPayload";
  readonly removedTagId: Scalars["ID"];
  readonly status: Scalars["String"];
};

export type RenameXvAudioDeviceErrorResponse = {
  readonly __typename?: "RenameXvAudioDeviceErrorResponse";
  readonly type: XvAudioDeviceResponseErrors;
};

export type RenameXvAudioDeviceInput = {
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
};

export type RenameXvAudioDeviceResponse =
  | RenameXvAudioDeviceErrorResponse
  | RenameXvAudioDeviceSuccessResponse;

export type RenameXvAudioDeviceSuccessResponse = {
  readonly __typename?: "RenameXvAudioDeviceSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type RenameZwaveNodeFailedResponse = {
  readonly __typename?: "RenameZwaveNodeFailedResponse";
  readonly error?: Maybe<Error>;
};

export type RenameZwaveNodeResponse =
  | RenameZwaveNodeFailedResponse
  | RenameZwaveNodeSuccessResponse;

export type RenameZwaveNodeSuccessResponse = {
  readonly __typename?: "RenameZwaveNodeSuccessResponse";
  readonly zwaveNode: ZwaveNode;
};

export type ReplaceX1Response =
  | NotFoundError
  | PanelNotCheckedInError
  | ReplaceX1SuccessResponse
  | SerialNumberNotFoundError;

export type ReplaceX1SuccessResponse = {
  readonly __typename?: "ReplaceX1SuccessResponse";
  readonly jobGroupId: Scalars["Int"];
  readonly status: Scalars["String"];
};

export type Report = {
  readonly __typename?: "Report";
  readonly configData: ConfigData;
  readonly cronExpression?: Maybe<Scalars["String"]>;
  readonly custom: Scalars["Boolean"];
  readonly customRequest?: Maybe<CustomRequestData>;
  readonly customerId: Scalars["Int"];
  readonly dealerId: Scalars["Int"];
  readonly emailList: Scalars["String"];
  readonly format: ScheduledReportFormat;
  readonly id: Scalars["ID"];
  readonly isAllPlusVideoReport: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly odataQuery?: Maybe<Scalars["String"]>;
  readonly reportId: Scalars["Int"];
  readonly scheduled: Scalars["Boolean"];
  readonly siteId?: Maybe<Scalars["Int"]>;
  readonly timeZone: TimeZone;
  readonly userId: Scalars["Int"];
};

export enum ReportEventSubcategory {
  ALARMS_ALARM_CANCELLED = "ALARMS_ALARM_CANCELLED",
  ALARMS_ALARM_VERIFIED = "ALARMS_ALARM_VERIFIED",
  ALARMS_AMBUSH = "ALARMS_AMBUSH",
  ALARMS_BASE = "ALARMS_BASE",
  ALARMS_BURG = "ALARMS_BURG",
  ALARMS_CO = "ALARMS_CO",
  ALARMS_EMERGENCY = "ALARMS_EMERGENCY",
  ALARMS_FIRE = "ALARMS_FIRE",
  ALARMS_PANIC = "ALARMS_PANIC",
  ALARMS_SUPERVISORY = "ALARMS_SUPERVISORY",
  DOOR_ACCESS_DENIED = "DOOR_ACCESS_DENIED",
  DOOR_ACCESS_GRANTED = "DOOR_ACCESS_GRANTED",
  TROUBLES_AC_POWER_FAILURE = "TROUBLES_AC_POWER_FAILURE",
  TROUBLES_AC_POWER_RESTORE = "TROUBLES_AC_POWER_RESTORE",
  TROUBLES_SYSTEM_LOW_BATTERY = "TROUBLES_SYSTEM_LOW_BATTERY",
  TROUBLES_SYSTEM_TEST = "TROUBLES_SYSTEM_TEST",
  TROUBLES_ZONE_INACTIVITY = "TROUBLES_ZONE_INACTIVITY",
  TROUBLES_ZONE_OR_DEVICE = "TROUBLES_ZONE_OR_DEVICE",
  TROUBLES_ZWAVE_DEVICE_LOW_BATTERY = "TROUBLES_ZWAVE_DEVICE_LOW_BATTERY",
}

export enum ReportEventTypes {
  ALARMS = "ALARMS",
  ALL = "ALL",
  ARMING_DISARMING = "ARMING_DISARMING",
  ARMING_EXCEPTIONS = "ARMING_EXCEPTIONS",
  DOOR_ACCESS = "DOOR_ACCESS",
  DOOR_STATUS = "DOOR_STATUS",
  OUTPUT_STATUS = "OUTPUT_STATUS",
  SENSOR_ACTIVITY = "SENSOR_ACTIVITY",
  TRAFFIC_COUNT = "TRAFFIC_COUNT",
  TROUBLES = "TROUBLES",
}

export type ReportInput = {
  readonly configData: ConfigDataInput;
  readonly cronExpression: Scalars["String"];
  readonly custom?: InputMaybe<Scalars["Boolean"]>;
  readonly customRequestInput?: InputMaybe<CustomRequestInput>;
  readonly customerId: Scalars["Int"];
  readonly dealerId: Scalars["Int"];
  readonly emailList: Scalars["String"];
  readonly format: ScheduledReportFormat;
  readonly name: Scalars["String"];
  readonly reportId: Scalars["Int"];
  readonly scheduled: Scalars["Boolean"];
  readonly timeZone: TimeZone;
  readonly userId: Scalars["Int"];
};

export type ReportProfileOptions = {
  readonly __typename?: "ReportProfileOptions";
  readonly AccessAreasList?: Maybe<ReadonlyArray<Scalars["Int"]>>;
  readonly AntiPass?: Maybe<Scalars["Boolean"]>;
  readonly ArmDisarmAreas?: Maybe<ReadonlyArray<Scalars["Int"]>>;
  readonly CanArm?: Maybe<Scalars["Boolean"]>;
  readonly CanArmAreas?: Maybe<Scalars["Boolean"]>;
  readonly CanBypassZone?: Maybe<Scalars["Boolean"]>;
  readonly CanCheckSystemStatus?: Maybe<Scalars["Boolean"]>;
  readonly CanCheckSystemTest?: Maybe<Scalars["Boolean"]>;
  readonly CanDisarm?: Maybe<Scalars["Boolean"]>;
  readonly CanEnterLockdown?: Maybe<Scalars["Boolean"]>;
  readonly CanMakeProfiles?: Maybe<Scalars["Boolean"]>;
  readonly CanMakeSchedules?: Maybe<Scalars["Boolean"]>;
  readonly CanMakeUserCodes?: Maybe<Scalars["Boolean"]>;
  readonly CanRequestService?: Maybe<Scalars["Boolean"]>;
  readonly CanResetSensor?: Maybe<Scalars["Boolean"]>;
  readonly CanSeeEvents?: Maybe<Scalars["Boolean"]>;
  readonly CanSetFireDrill?: Maybe<Scalars["Boolean"]>;
  readonly CanSetTime?: Maybe<Scalars["Boolean"]>;
  readonly CanSilenceAlarm?: Maybe<Scalars["Boolean"]>;
  readonly CardPlusPin?: Maybe<Scalars["Boolean"]>;
  readonly Extend?: Maybe<Scalars["Boolean"]>;
  readonly HasDoorAccess?: Maybe<Scalars["Boolean"]>;
  readonly HasDoorLockUnlock?: Maybe<Scalars["Boolean"]>;
  readonly HasDualAuth?: Maybe<Scalars["Boolean"]>;
  readonly HasLockdownOverride?: Maybe<Scalars["Boolean"]>;
  readonly HasSecondaryLanguage?: Maybe<Scalars["Boolean"]>;
  readonly HasTemporaryCode?: Maybe<Scalars["Boolean"]>;
  readonly HasZoneMonitoring?: Maybe<Scalars["Boolean"]>;
  readonly IsEasyArm?: Maybe<Scalars["Boolean"]>;
  readonly OutputGroup?: Maybe<Scalars["String"]>;
  readonly OutputsOnOff?: Maybe<Scalars["Boolean"]>;
  readonly RearmDelay?: Maybe<Scalars["String"]>;
  readonly Schedule1?: Maybe<Scalars["String"]>;
  readonly Schedule2?: Maybe<Scalars["String"]>;
  readonly Schedule3?: Maybe<Scalars["String"]>;
  readonly Schedule4?: Maybe<Scalars["String"]>;
  readonly Schedule5?: Maybe<Scalars["String"]>;
  readonly Schedule6?: Maybe<Scalars["String"]>;
  readonly Schedule7?: Maybe<Scalars["String"]>;
  readonly Schedule8?: Maybe<Scalars["String"]>;
  readonly WifiSetup?: Maybe<Scalars["Boolean"]>;
  readonly ZoneStatus?: Maybe<Scalars["Boolean"]>;
};

export type ReportResultRow = {
  readonly __typename?: "ReportResultRow";
  readonly controlSystemName: Scalars["String"];
  readonly dealerId: Scalars["Int"];
  readonly eventAt: Scalars["String"];
  readonly eventDetailAreaName?: Maybe<Scalars["String"]>;
  readonly eventDetailAreaNumber?: Maybe<Scalars["Int"]>;
  readonly eventDetailDeviceName?: Maybe<Scalars["String"]>;
  readonly eventDetailDeviceNumber?: Maybe<Scalars["Int"]>;
  readonly eventDetailOutputName?: Maybe<Scalars["String"]>;
  readonly eventDetailOutputNumber?: Maybe<Scalars["Int"]>;
  readonly eventDetailUserName?: Maybe<Scalars["String"]>;
  readonly eventDetailUserNumber?: Maybe<Scalars["Int"]>;
  readonly eventDetailZoneName?: Maybe<Scalars["String"]>;
  readonly eventDetailZoneNumber?: Maybe<Scalars["Int"]>;
  readonly eventHistoryMessage?: Maybe<Scalars["String"]>;
  readonly eventId: Scalars["BigInt64"];
  readonly panelId: Scalars["Int"];
  readonly subcategoryDisplayName: Scalars["String"];
  readonly subcategoryId: Scalars["Int"];
};

export enum ReportTimeFrame {
  CUSTOM = "CUSTOM",
  LAST_7_DAYS = "LAST_7_DAYS",
  LAST_NINETY_DAYS = "LAST_NINETY_DAYS",
  LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS",
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
}

export type RequestMetaData = {
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly title: Scalars["String"];
};

export type RequiresEncryptionError = Error & {
  readonly __typename?: "RequiresEncryptionError";
  readonly type?: Maybe<ErrorType>;
};

export type ResetAppUserPasswordErrorResponse = {
  readonly __typename?: "ResetAppUserPasswordErrorResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly type: ErrorType;
};

export type ResetAppUserPasswordResponse =
  | ResetAppUserPasswordErrorResponse
  | ResetAppUserPasswordSuccessResponse;

export type ResetAppUserPasswordSuccessResponse = {
  readonly __typename?: "ResetAppUserPasswordSuccessResponse";
  readonly personId?: Maybe<Scalars["String"]>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type ResetBypassZoneFailurePayload = {
  readonly __typename?: "ResetBypassZoneFailurePayload";
  readonly error: UnknownError;
};

export type ResetBypassZonePayload =
  | ResetBypassZoneFailurePayload
  | ResetBypassZoneSuccessPayload;

export type ResetBypassZoneStatusFailurePayload = {
  readonly __typename?: "ResetBypassZoneStatusFailurePayload";
  readonly error: UnknownError;
};

export type ResetBypassZoneStatusPayload =
  | ResetBypassZoneStatusFailurePayload
  | ResetBypassZoneStatusSuccessPayload;

export type ResetBypassZoneStatusSuccessPayload = {
  readonly __typename?: "ResetBypassZoneStatusSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type ResetBypassZoneSuccessPayload = {
  readonly __typename?: "ResetBypassZoneSuccessPayload";
  readonly zone: Zone;
};

export type ResetCustomerAppUserPasswordErrorResponse = {
  readonly __typename?: "ResetCustomerAppUserPasswordErrorResponse";
  readonly type: CustomerError;
};

export type ResetCustomerAppUserPasswordResponse =
  | ResetCustomerAppUserPasswordErrorResponse
  | ResetCustomerAppUserPasswordSuccessResponse;

export type ResetCustomerAppUserPasswordSuccessResponse = {
  readonly __typename?: "ResetCustomerAppUserPasswordSuccessResponse";
  readonly customer?: Maybe<Customer>;
};

export type ResetLockdownSiteResponse = {
  readonly __typename?: "ResetLockdownSiteResponse";
  readonly site?: Maybe<Site>;
};

export type ResetSensorsError = Error & {
  readonly __typename?: "ResetSensorsError";
  readonly type?: Maybe<ErrorType>;
};

export type ResetSensorsPayload =
  | ResetSensorsError
  | ResetSensorsSuccessPayload;

export type ResetSensorsSuccessPayload = {
  readonly __typename?: "ResetSensorsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type RestartVarHubErrorPayload = {
  readonly __typename?: "RestartVarHubErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type RestartVarHubPayload =
  | RestartVarHubErrorPayload
  | RestartVarHubSuccessPayload;

export type RestartVarHubSuccessPayload = {
  readonly __typename?: "RestartVarHubSuccessPayload";
  readonly status?: Maybe<Scalars["String"]>;
};

export type Rule = Node & {
  readonly __typename?: "Rule";
  readonly id: Scalars["ID"];
  readonly if: RuleTrigger;
  readonly name: Scalars["String"];
  readonly notifications: ReadonlyArray<RuleNotificationRecipient>;
  readonly schedule?: Maybe<RuleSchedule>;
  readonly site: Site;
  readonly then: RuleAction;
};

export type RuleAction = {
  readonly type: RuleActionType;
};

export type RuleActionInput = {
  readonly camera?: InputMaybe<Scalars["ID"]>;
  readonly duration?: InputMaybe<Scalars["Int"]>;
  readonly output?: InputMaybe<Scalars["ID"]>;
  readonly outputStatus?: InputMaybe<RuleActionOutputStatus>;
  readonly type: RuleActionType;
};

export enum RuleActionOutputStatus {
  OFF = "OFF",
  ON = "ON",
}

export enum RuleActionType {
  LOCKDOWN = "LOCKDOWN",
  LOCKDOWN_RESET = "LOCKDOWN_RESET",
  ONLY_SEND_NOTIFICATION = "ONLY_SEND_NOTIFICATION",
  PANIC = "PANIC",
  RECORD_CAMERA = "RECORD_CAMERA",
  TURN_OUTPUT_OFF = "TURN_OUTPUT_OFF",
  TURN_OUTPUT_ON = "TURN_OUTPUT_ON",
}

export type RuleActionWithCamera = RuleAction & {
  readonly __typename?: "RuleActionWithCamera";
  readonly camera?: Maybe<SecureComCamera>;
  readonly type: RuleActionType;
};

export type RuleActionWithOutput = RuleAction & {
  readonly __typename?: "RuleActionWithOutput";
  readonly duration?: Maybe<Scalars["Int"]>;
  readonly output: SiteOutput;
  readonly type: RuleActionType;
};

export type RuleNotificationRecipient = {
  readonly __typename?: "RuleNotificationRecipient";
  readonly contact: Contact;
  readonly email: Scalars["Boolean"];
  readonly push: Scalars["Boolean"];
  readonly text: Scalars["Boolean"];
};

export type RuleNotificationRecipientInput = {
  readonly contact: Scalars["ID"];
  readonly email: Scalars["Boolean"];
  readonly push: Scalars["Boolean"];
  readonly text: Scalars["Boolean"];
};

export type RuleSchedule = {
  readonly __typename?: "RuleSchedule";
  readonly endTime: Scalars["String"];
  readonly friday: Scalars["Boolean"];
  readonly monday: Scalars["Boolean"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type RuleScheduleInput = {
  readonly endTime: Scalars["String"];
  readonly friday: Scalars["Boolean"];
  readonly monday: Scalars["Boolean"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type RuleTrigger = {
  readonly type: RuleTriggerType;
};

export enum RuleTriggerDoorStatus {
  CLOSED = "CLOSED",
  OPENED = "OPENED",
}

export type RuleTriggerInput = {
  readonly door?: InputMaybe<Scalars["ID"]>;
  readonly person?: InputMaybe<Scalars["ID"]>;
  readonly status?: InputMaybe<RuleTriggerDoorStatus>;
  readonly type: RuleTriggerType;
};

export enum RuleTriggerType {
  ACCESS_DENIED = "ACCESS_DENIED",
  ACCESS_GRANTED = "ACCESS_GRANTED",
  ALARM_SYSTEM_ARMED = "ALARM_SYSTEM_ARMED",
  ALARM_SYSTEM_DISARMED = "ALARM_SYSTEM_DISARMED",
  DOOR_FORCED = "DOOR_FORCED",
  DOOR_INPUT = "DOOR_INPUT",
  DOOR_PROPPED = "DOOR_PROPPED",
  DOOR_STATUS = "DOOR_STATUS",
  FIRE_ALARM_ACTIVATE = "FIRE_ALARM_ACTIVATE",
  FIRE_ALARM_RESTORED = "FIRE_ALARM_RESTORED",
  LOCKDOWN = "LOCKDOWN",
  LOCKDOWN_RESET = "LOCKDOWN_RESET",
  PANIC = "PANIC",
}

export type RuleTriggerWithDoor = RuleTrigger & {
  readonly __typename?: "RuleTriggerWithDoor";
  readonly door?: Maybe<SiteDoor>;
  readonly type: RuleTriggerType;
};

export type RuleTriggerWithDoorAndDoorState = RuleTrigger & {
  readonly __typename?: "RuleTriggerWithDoorAndDoorState";
  readonly door?: Maybe<SiteDoor>;
  readonly status: RuleTriggerDoorStatus;
  readonly type: RuleTriggerType;
};

export type RuleTriggerWithDoorAndPerson = RuleTrigger & {
  readonly __typename?: "RuleTriggerWithDoorAndPerson";
  readonly door?: Maybe<SiteDoor>;
  readonly person?: Maybe<CustomerPerson>;
  readonly type: RuleTriggerType;
};

export type RuleWouldCauseLoopError = Error & {
  readonly __typename?: "RuleWouldCauseLoopError";
  readonly type: ErrorType;
};

export type RunAllAppUsersReportResponse =
  | RunAllAppUsersReportSuccessPayload
  | UnknownError;

export type RunAllAppUsersReportSuccessPayload = {
  readonly __typename?: "RunAllAppUsersReportSuccessPayload";
  readonly results: ReadonlyArray<AppUsersReportRow>;
};

export type RunAllSystemProfilesReportResponse =
  | RunAllSystemProfilesReportSuccessPayload
  | UnknownError;

export type RunAllSystemProfilesReportSuccessPayload = {
  readonly __typename?: "RunAllSystemProfilesReportSuccessPayload";
  readonly results: ReadonlyArray<SystemProfilesReportRow>;
};

export type RunAllSystemUsersReportResponse =
  | RunAllSystemUsersReportSuccessPayload
  | UnknownError;

export type RunAllSystemUsersReportSuccessPayload = {
  readonly __typename?: "RunAllSystemUsersReportSuccessPayload";
  readonly results: ReadonlyArray<SystemUsersReportRow>;
};

export type RunReportResponse = RunReportSuccessPayload | UnknownError;

export type RunReportSuccessPayload = {
  readonly __typename?: "RunReportSuccessPayload";
  readonly results: ReadonlyArray<ReportResultRow>;
};

export type SaveAdminBadgeTemplateFailedResponse = {
  readonly __typename?: "SaveAdminBadgeTemplateFailedResponse";
  readonly message: Scalars["String"];
  readonly type: GenericError;
};

export type SaveAdminBadgeTemplateResponse =
  | SaveAdminBadgeTemplateFailedResponse
  | SaveAdminBadgeTemplateSuccessResponse;

export type SaveAdminBadgeTemplateSuccessResponse = {
  readonly __typename?: "SaveAdminBadgeTemplateSuccessResponse";
  readonly customer: Customer;
  readonly templateId: Scalars["String"];
};

export type SaveFavoriteSiteDoorIdsErrorResponse = {
  readonly __typename?: "SaveFavoriteSiteDoorIdsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<ErrorType>;
};

export type SaveFavoriteSiteDoorIdsInput = {
  readonly favoriteSiteDoorIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["ID"]>>
  >;
  readonly siteId?: InputMaybe<Scalars["Int"]>;
};

export type SaveFavoriteSiteDoorIdsResponse =
  | SaveFavoriteSiteDoorIdsErrorResponse
  | SaveFavoriteSiteDoorIdsSuccessResponse;

export type SaveFavoriteSiteDoorIdsSuccessResponse = {
  readonly __typename?: "SaveFavoriteSiteDoorIdsSuccessResponse";
  readonly sharedClientConfiguration?: Maybe<SharedClientConfiguration>;
};

export type SaveProgrammingTemplateErrorResult = {
  readonly __typename?: "SaveProgrammingTemplateErrorResult";
  readonly error?: Maybe<ErrorType>;
  readonly messages?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
};

export type SaveProgrammingTemplateResult =
  | SaveProgrammingTemplateErrorResult
  | SaveProgrammingTemplateSuccessResult;

export type SaveProgrammingTemplateSuccessResult = {
  readonly __typename?: "SaveProgrammingTemplateSuccessResult";
  readonly programmingTemplate?: Maybe<ProgrammingTemplate>;
  readonly programmingTemplateEdge?: Maybe<ProgrammingTemplateEdge>;
};

export enum SaveStatus {
  DELETED = "DELETED",
  DELETING = "DELETING",
  ERROR = "ERROR",
  IDLE = "IDLE",
  LOADING = "LOADING",
  SAVED = "SAVED",
  SAVING = "SAVING",
}

export type SaveSystemBadgeTemplateFailedResponse = {
  readonly __typename?: "SaveSystemBadgeTemplateFailedResponse";
  readonly message: Scalars["String"];
  readonly type: GenericError;
};

export type SaveSystemBadgeTemplateResponse =
  | SaveSystemBadgeTemplateFailedResponse
  | SaveSystemBadgeTemplateSuccessResponse;

export type SaveSystemBadgeTemplateSuccessResponse = {
  readonly __typename?: "SaveSystemBadgeTemplateSuccessResponse";
  readonly controlSystem: ControlSystem;
  readonly templateId: Scalars["String"];
};

export type SaveSystemNicknameErrorResponse = {
  readonly __typename?: "SaveSystemNicknameErrorResponse";
  readonly error: SaveSystemNicknameResponseErrors;
};

export type SaveSystemNicknameResponse =
  | SaveSystemNicknameErrorResponse
  | SaveSystemNicknameSuccessResponse;

export enum SaveSystemNicknameResponseErrors {
  SAVE_FAILED = "SAVE_FAILED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
}

export type SaveSystemNicknameSuccessResponse = {
  readonly __typename?: "SaveSystemNicknameSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type SaveTagResponse = SaveTagSuccessPayload | UnknownError;

export type SaveTagSuccessPayload = {
  readonly __typename?: "SaveTagSuccessPayload";
  readonly status: Scalars["String"];
  readonly tag: Tag;
};

export type SavedReportHeaderMapItem = {
  readonly __typename?: "SavedReportHeaderMapItem";
  readonly field?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
  readonly visible?: Maybe<Scalars["Boolean"]>;
};

export type ScanForNewCamerasErrorPayload = {
  readonly __typename?: "ScanForNewCamerasErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type ScanForNewCamerasPayload =
  | ScanForNewCamerasErrorPayload
  | ScanForNewCamerasSuccessPayload;

export type ScanForNewCamerasSuccessPayload = {
  readonly __typename?: "ScanForNewCamerasSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

/** In most cases, it is more efficient to get stream details from scapiCameraByDatabaseId rather than the allCameras object. */
export type ScapiCamera = AllCameras &
  Node & {
    readonly __typename?: "ScapiCamera";
    readonly cameraName?: Maybe<Scalars["String"]>;
    readonly cameraStreamUrl?: Maybe<Scalars["String"]>;
    readonly databaseCameraId?: Maybe<Scalars["Int"]>;
    readonly databaseDeviceId?: Maybe<Scalars["Int"]>;
    readonly deviceAuthToken?: Maybe<Scalars["String"]>;
    readonly deviceManufacturer?: Maybe<Scalars["String"]>;
    readonly deviceModel?: Maybe<Scalars["String"]>;
    readonly deviceTimeZone?: Maybe<Scalars["String"]>;
    readonly deviceType?: Maybe<Scalars["String"]>;
    readonly generation?: Maybe<Scalars["String"]>;
    readonly hasRedBlueLights: Scalars["Boolean"];
    readonly hasWhiteLights: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isAxis: Scalars["Boolean"];
    readonly redBlueLightsOn: Scalars["Boolean"];
    readonly snapshotUrl?: Maybe<Scalars["String"]>;
    readonly streamType?: Maybe<StreamTypeName>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly supportsTalkdown: Scalars["Boolean"];
    readonly whiteLightsOn: Scalars["Boolean"];
  };

export type ScapiCameraDetails = Node & {
  readonly __typename?: "ScapiCameraDetails";
  readonly adminPassword?: Maybe<Scalars["String"]>;
  readonly adminUsername?: Maybe<Scalars["String"]>;
  readonly allowCustomerEdit?: Maybe<Scalars["Boolean"]>;
  readonly audioEnabled: Scalars["Boolean"];
  readonly audioOutEnabled: Scalars["Boolean"];
  readonly awsAccessKey?: Maybe<Scalars["String"]>;
  readonly awsRegion?: Maybe<Scalars["String"]>;
  readonly awsSecretAccessKey?: Maybe<Scalars["String"]>;
  readonly awsSessionExpirationTime?: Maybe<Scalars["String"]>;
  readonly awsSessionToken?: Maybe<Scalars["String"]>;
  readonly awsSignalingChannelName?: Maybe<Scalars["String"]>;
  readonly ceilingMount?: Maybe<Scalars["Boolean"]>;
  readonly deviceType?: Maybe<Scalars["String"]>;
  readonly deviceType2?: Maybe<Scalars["String"]>;
  readonly hdVideoStreamUrl?: Maybe<Scalars["String"]>;
  readonly hlsHdUrl?: Maybe<Scalars["String"]>;
  readonly hlsSubUrl?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isVueFisheye: Scalars["Boolean"];
  readonly lightUrl?: Maybe<Scalars["String"]>;
  readonly manufacturer?: Maybe<Scalars["String"]>;
  readonly mjpegUrl?: Maybe<Scalars["String"]>;
  readonly model?: Maybe<Scalars["String"]>;
  readonly movementUrl?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly networkStatus?: Maybe<Scalars["String"]>;
  readonly nvrLowResolutionUrl?: Maybe<Scalars["String"]>;
  readonly oldCameraId?: Maybe<Scalars["Int"]>;
  readonly panRange?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly peripheralStatusUrl?: Maybe<Scalars["String"]>;
  readonly playbackUrl?: Maybe<Scalars["String"]>;
  readonly proxyUrl?: Maybe<Scalars["String"]>;
  readonly ptPosition?: Maybe<Scalars["String"]>;
  readonly redBlueLedActiveDeterrence: Scalars["Boolean"];
  readonly redBlueLightsOn: Scalars["Boolean"];
  readonly rtspUrl?: Maybe<Scalars["String"]>;
  readonly settingConfirmation?: Maybe<VideoDeviceSettingConfirmation>;
  readonly snapshotUrl?: Maybe<Scalars["String"]>;
  readonly streamExpiration?: Maybe<Scalars["String"]>;
  readonly streamUuid?: Maybe<Scalars["String"]>;
  readonly subVideoStreamUrl?: Maybe<Scalars["String"]>;
  readonly supportsMicrophone: Scalars["Boolean"];
  readonly tiltRange?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly videoDeviceId?: Maybe<Scalars["Int"]>;
  readonly whiteLedActiveDeterrence: Scalars["Boolean"];
  readonly whiteLightsOn: Scalars["Boolean"];
};

export type ScapiV2JobErrorDetails = {
  readonly __typename?: "ScapiV2JobErrorDetails";
  readonly code?: Maybe<Scalars["String"]>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type ScapiV3CameraDetails = Node & {
  readonly __typename?: "ScapiV3CameraDetails";
  readonly adminPassword?: Maybe<Scalars["String"]>;
  readonly adminUsername?: Maybe<Scalars["String"]>;
  readonly allowCustomerEdit?: Maybe<Scalars["Boolean"]>;
  readonly ceilingMount?: Maybe<Scalars["Boolean"]>;
  readonly clipsConnection: ClipsConnection;
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly deviceType?: Maybe<Scalars["String"]>;
  readonly deviceType2?: Maybe<Scalars["String"]>;
  readonly hasLight: Scalars["Boolean"];
  readonly hdVideoStreamUrl?: Maybe<Scalars["String"]>;
  readonly hlsHdUrl?: Maybe<Scalars["String"]>;
  readonly hlsSubUrl?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isPanTilt: Scalars["Boolean"];
  readonly isV4000Series: Scalars["Boolean"];
  readonly isV5000Series: Scalars["Boolean"];
  readonly isV6000Series: Scalars["Boolean"];
  readonly lightOn: Scalars["Boolean"];
  readonly lightUrl?: Maybe<Scalars["String"]>;
  readonly manufacturer?: Maybe<Scalars["String"]>;
  readonly mjpegUrl?: Maybe<Scalars["String"]>;
  readonly model?: Maybe<Scalars["String"]>;
  readonly movementUrl?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly networkStatus?: Maybe<Scalars["String"]>;
  readonly nvrLowResolutionUrl?: Maybe<Scalars["String"]>;
  readonly oldCameraId?: Maybe<Scalars["Int"]>;
  readonly panRange?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly panTilt?: Maybe<PanTiltDetails>;
  readonly peripheralStatusUrl?: Maybe<Scalars["String"]>;
  readonly playbackUrl?: Maybe<Scalars["String"]>;
  readonly proxyUrl?: Maybe<Scalars["String"]>;
  readonly ptPosition?: Maybe<Scalars["String"]>;
  readonly rtspUrl?: Maybe<Scalars["String"]>;
  readonly settingConfirmation?: Maybe<VideoDeviceSettingConfirmation>;
  readonly snapshotUrl?: Maybe<Scalars["String"]>;
  readonly streamExpiration?: Maybe<Scalars["String"]>;
  readonly streamUuid?: Maybe<Scalars["String"]>;
  readonly subVideoStreamUrl?: Maybe<Scalars["String"]>;
  readonly supportsMicrophone: Scalars["Boolean"];
  readonly tiltRange?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly videoDeviceId?: Maybe<Scalars["Int"]>;
  readonly webRTCDetails?: Maybe<WebRtcDetails>;
};

export type ScapiV3CameraDetailsClipsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type ScapiVideoDoorbellCamera = AllCameras &
  Node & {
    readonly __typename?: "ScapiVideoDoorbellCamera";
    readonly cameraName?: Maybe<Scalars["String"]>;
    readonly cameraStreamUrl?: Maybe<Scalars["String"]>;
    readonly databaseCameraId?: Maybe<Scalars["Int"]>;
    readonly databaseDeviceId?: Maybe<Scalars["Int"]>;
    readonly deviceAuthToken?: Maybe<Scalars["String"]>;
    readonly deviceManufacturer?: Maybe<Scalars["String"]>;
    readonly deviceModel?: Maybe<Scalars["String"]>;
    readonly deviceTimeZone?: Maybe<Scalars["String"]>;
    readonly deviceType?: Maybe<Scalars["String"]>;
    readonly generation?: Maybe<Scalars["String"]>;
    readonly hasRedBlueLights: Scalars["Boolean"];
    readonly hasWhiteLights: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly redBlueLightsOn: Scalars["Boolean"];
    readonly snapshotUrl?: Maybe<Scalars["String"]>;
    readonly streamType?: Maybe<StreamTypeName>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly supportsTalkdown: Scalars["Boolean"];
    readonly whiteLightsOn: Scalars["Boolean"];
  };

export type Schedule = Node & {
  readonly __typename?: "Schedule";
  readonly areaNumbers: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly doorNumbers: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly favoriteNumbers: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly hasFriday?: Maybe<Scalars["Boolean"]>;
  readonly hasMonday?: Maybe<Scalars["Boolean"]>;
  readonly hasSaturday?: Maybe<Scalars["Boolean"]>;
  readonly hasSunday?: Maybe<Scalars["Boolean"]>;
  readonly hasThursday?: Maybe<Scalars["Boolean"]>;
  readonly hasTuesday?: Maybe<Scalars["Boolean"]>;
  readonly hasWednesday?: Maybe<Scalars["Boolean"]>;
  readonly holidayA?: Maybe<HolidayDateSchedule>;
  readonly holidayB?: Maybe<HolidayDateSchedule>;
  readonly holidayC?: Maybe<HolidayDateSchedule>;
  readonly id: Scalars["ID"];
  readonly isTempSchedule?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly number: Scalars["String"];
  readonly outputNumbers: ReadonlyArray<Maybe<Scalars["Int"]>>;
  readonly tempEndDate?: Maybe<Scalars["String"]>;
  readonly tempStartDate?: Maybe<Scalars["String"]>;
};

export type ScheduleUse = {
  readonly __typename?: "ScheduleUse";
  readonly areas: ReadonlyArray<Maybe<ScheduleUseItem>>;
  readonly doors: ReadonlyArray<Maybe<ScheduleUseItem>>;
  readonly favorites: ReadonlyArray<Maybe<ScheduleUseItem>>;
  readonly outputs: ReadonlyArray<Maybe<ScheduleUseItem>>;
  readonly profiles: ReadonlyArray<Maybe<ScheduleUseItem>>;
  readonly scheduleNumber: Scalars["String"];
};

export type ScheduleUseItem = {
  readonly __typename?: "ScheduleUseItem";
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
};

export enum ScheduledReportFormat {
  HTML = "HTML",
  PDF = "PDF",
  XLSX = "XLSX",
}

export type SchedulerJob = Node & {
  readonly __typename?: "SchedulerJob";
  readonly completedAt: Scalars["String"];
  readonly createdAt: Scalars["String"];
  readonly dealerHolidayDate?: Maybe<DealerHolidayDate>;
  readonly failedToUpdate: Scalars["Int"];
  readonly groupStatus: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly jobData?: Maybe<JobDataType>;
  readonly jobOutputDetails?: Maybe<ReadonlyArray<Maybe<JobOutputDetail>>>;
  readonly jobStatus: Scalars["String"];
  readonly personWhoStartedJob?: Maybe<PersonWhoStartedJob>;
  readonly scapiId: Scalars["Int"];
  readonly schedulerJobTypeId: Scalars["Int"];
  readonly successfullyUpdated: Scalars["Int"];
  readonly totalSystems: Scalars["Int"];
  readonly updateInProgress: Scalars["Int"];
  readonly waitingForUpdate: Scalars["Int"];
};

export type SearchCustomerAppUsersErrorResponse = {
  readonly __typename?: "SearchCustomerAppUsersErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchCustomerAppUsersResponse =
  | SearchCustomerAppUsersErrorResponse
  | SearchCustomerAppUsersSuccessResponse;

export type SearchCustomerAppUsersSuccessResponse = {
  readonly __typename?: "SearchCustomerAppUsersSuccessResponse";
  readonly personEmails?: Maybe<ReadonlyArray<Maybe<QuickCustomerPerson>>>;
};

export type SearchCustomerControlSystemsErrorResponse = {
  readonly __typename?: "SearchCustomerControlSystemsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchCustomerControlSystemsResponse =
  | SearchCustomerControlSystemsErrorResponse
  | SearchCustomerControlSystemsSuccessResponse;

export type SearchCustomerControlSystemsSuccessResponse = {
  readonly __typename?: "SearchCustomerControlSystemsSuccessResponse";
  readonly controlSystems?: Maybe<ReadonlyArray<Maybe<ControlSystem>>>;
};

export type SearchCustomerUsersErrorResponse = {
  readonly __typename?: "SearchCustomerUsersErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchCustomerUsersResponse =
  | SearchCustomerUsersErrorResponse
  | SearchCustomerUsersSuccessResponse;

export type SearchCustomerUsersSuccessResponse = {
  readonly __typename?: "SearchCustomerUsersSuccessResponse";
  readonly customerUsers: ReadonlyArray<Maybe<QuickCustomerPerson>>;
};

export type SearchInput = {
  readonly keys?: InputMaybe<ReadonlyArray<Scalars["String"]>>;
  readonly sortByScore?: InputMaybe<Scalars["Boolean"]>;
  readonly term: Scalars["String"];
};

export type SearchPanelPersonsListErrorResponse = {
  readonly __typename?: "SearchPanelPersonsListErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchPanelPersonsListResponse =
  | SearchPanelPersonsListErrorResponse
  | SearchPanelPersonsListSuccessResponse;

export type SearchPanelPersonsListSuccessResponse = {
  readonly __typename?: "SearchPanelPersonsListSuccessResponse";
  readonly panelPersonsListConnection: PanelPersonsListConnection;
};

export type SearchPanelPersonsListSuccessResponsePanelPersonsListConnectionArgs =
  {
    after?: InputMaybe<Scalars["ID"]>;
    before?: InputMaybe<Scalars["ID"]>;
    first?: InputMaybe<Scalars["Int"]>;
    last?: InputMaybe<Scalars["Int"]>;
    search?: InputMaybe<SearchInput>;
    sort?: InputMaybe<SortInput>;
  };

export type SearchPersonControlSystemsErrorResponse = {
  readonly __typename?: "SearchPersonControlSystemsErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchPersonControlSystemsResponse =
  | SearchPersonControlSystemsErrorResponse
  | SearchPersonControlSystemsSuccessResponse;

export type SearchPersonControlSystemsSuccessResponse = {
  readonly __typename?: "SearchPersonControlSystemsSuccessResponse";
  readonly controlSystems: ControlSystemConnection;
};

export type SearchPersonControlSystemsSuccessResponseControlSystemsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  filterOnlyAppEnabled?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  ids?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
  usersAuthData: ReadonlyArray<UsersAuthDataInput>;
};

export type SearchSecurityPanelPersonsListErrorResponse = {
  readonly __typename?: "SearchSecurityPanelPersonsListErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchSecurityPanelPersonsListResponse =
  | SearchSecurityPanelPersonsListErrorResponse
  | SearchSecurityPanelPersonsListSuccessResponse;

export type SearchSecurityPanelPersonsListSuccessResponse = {
  readonly __typename?: "SearchSecurityPanelPersonsListSuccessResponse";
  readonly securityPanelPersonsListConnection: SecurityPanelPersonsListConnection;
};

export type SearchSecurityPanelPersonsListSuccessResponseSecurityPanelPersonsListConnectionArgs =
  {
    after?: InputMaybe<Scalars["ID"]>;
    before?: InputMaybe<Scalars["ID"]>;
    first?: InputMaybe<Scalars["Int"]>;
    last?: InputMaybe<Scalars["Int"]>;
    search?: InputMaybe<SearchInput>;
    sort?: InputMaybe<SortInput>;
  };

export type SearchVkSystemUsersErrorResponse = {
  readonly __typename?: "SearchVkSystemUsersErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SearchVkSystemUsersResponse =
  | SearchVkSystemUsersErrorResponse
  | SearchVkSystemUsersSuccessResponse;

export type SearchVkSystemUsersSuccessResponse = {
  readonly __typename?: "SearchVkSystemUsersSuccessResponse";
  /** @deprecated Prefer panelPersonsListConnection instead */
  readonly vkSystemUserListConnection: VkSystemUserListConnection;
};

export type SearchVkSystemUsersSuccessResponseVkSystemUserListConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SecureComCamera = Node &
  VideoDevice & {
    readonly __typename?: "SecureComCamera";
    readonly adminPassword?: Maybe<Scalars["String"]>;
    readonly adminUsername?: Maybe<Scalars["String"]>;
    readonly alarmvisionCapable: Scalars["Boolean"];
    readonly alarmvisionDeviceRecordNumber?: Maybe<Scalars["Int"]>;
    readonly alarmvisionEnabled: Scalars["Boolean"];
    readonly allowCustomerEdit: Scalars["Boolean"];
    readonly analyticalDetectionLines: AnalyticalDetectionLines;
    readonly analyticalDetectionRegions: AnalyticalDetectionRegions;
    readonly audioEnabled: Scalars["Boolean"];
    readonly audioOutEnabled: Scalars["Boolean"];
    readonly awsCredentials?: Maybe<AwsCredentials>;
    readonly ceilingMount: Scalars["Boolean"];
    readonly channelId: Scalars["Int"];
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly daylightSaving: Scalars["Boolean"];
    readonly deviceType: VideoDeviceType;
    /** Configuration for if a camera should record a clip if it detects motion */
    readonly eventsEnabled: CameraEventsEnabled;
    readonly firmwareUpdateAvailable: Scalars["Boolean"];
    readonly firmwareUpdateProgress?: Maybe<Scalars["Int"]>;
    readonly firmwareUpdateStatus: Scalars["String"];
    readonly firmwareVersion?: Maybe<Scalars["String"]>;
    readonly formFactor?: Maybe<Scalars["String"]>;
    readonly generation: Scalars["String"];
    readonly hasLight: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly imageSize?: Maybe<Scalars["String"]>;
    readonly includeInVerification: Scalars["Boolean"];
    readonly integration: Scalars["String"];
    readonly integrationModel: Scalars["String"];
    readonly ipAddress?: Maybe<Scalars["String"]>;
    /** Axis cameras come in as V-6000 but with a generation of 100 and an integration of "axis". Axis cameras do not fully support all V-6000 features. */
    readonly isAxis: Scalars["Boolean"];
    readonly isOnline: Scalars["Boolean"];
    readonly isV4000Series: Scalars["Boolean"];
    readonly isV5000Series: Scalars["Boolean"];
    readonly isV6000Series: Scalars["Boolean"];
    readonly keypadVisible: Scalars["Boolean"];
    readonly lastCheckIn?: Maybe<Scalars["String"]>;
    readonly lightOn: Scalars["Boolean"];
    readonly lightSchedules: LightSchedules;
    readonly macAddress: Scalars["String"];
    readonly manufacturer: Scalars["String"];
    readonly maxAnalyticalDetectionLines: Scalars["Int"];
    readonly maxAnalyticalDetectionRegionPoints: Scalars["Int"];
    readonly maxAnalyticalDetectionRegions: Scalars["Int"];
    readonly maxMotionDetectionRegions: Scalars["Int"];
    readonly microphoneLevel: Scalars["Int"];
    readonly minAnalyticalDetectionRegionPoints: Scalars["Int"];
    /** The live stream URL in MJPEG format */
    readonly mjpegStream?: Maybe<Scalars["String"]>;
    readonly model: Scalars["String"];
    /** Configuration where the camera detects motion in its field of view and triggers a clip recording */
    readonly motionDetectionRegions: MotionDetectionRegions;
    readonly motionSensitivity?: Maybe<Scalars["Int"]>;
    readonly name: Scalars["String"];
    readonly networkReady?: Maybe<Scalars["Boolean"]>;
    readonly networkStatus: VideoChannelNetworkStatus;
    /** Only available for pan/tilt cameras */
    readonly panTilt?: Maybe<SecureComCameraPanTiltParams>;
    readonly panelIp?: Maybe<Scalars["String"]>;
    /** Configuration for if a camera should record a clip when the panel goes into alarm */
    readonly recordOnAlarm: Scalars["Boolean"];
    readonly redBlueLedActiveDeterrence?: Maybe<Scalars["Boolean"]>;
    readonly redBlueLightDetectionEnabled?: Maybe<Scalars["Boolean"]>;
    readonly redBlueLightDetectionTimeout?: Maybe<Scalars["Int"]>;
    readonly redBlueLightSupported: Scalars["Boolean"];
    readonly scapiFirmwareUpdateStatus?: Maybe<Scalars["String"]>;
    /** Available for v6000 cameras */
    readonly sdCardStatus?: Maybe<Scalars["String"]>;
    readonly serialNumber?: Maybe<Scalars["String"]>;
    readonly settingConfirmation?: Maybe<VideoDeviceSettingConfirmation>;
    /** The most recent still shot of the camera's view */
    readonly snapshot?: Maybe<Scalars["URL"]>;
    readonly speakerSupported: Scalars["Boolean"];
    readonly speakerVolume: Scalars["Int"];
    readonly status: VideoDeviceStatus;
    readonly stitchingDistance?: Maybe<Scalars["Int"]>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsFlip: Scalars["Boolean"];
    readonly supportsMicrophone: Scalars["Boolean"];
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly timeZone: Scalars["String"];
    readonly timeZones: ReadonlyArray<Scalars["String"]>;
    readonly videoAnalyticsEnabled: Scalars["Boolean"];
    readonly videoAnalyticsSupported: Scalars["Boolean"];
    readonly videoQuality: Scalars["String"];
    readonly whiteLedActiveDeterrence?: Maybe<Scalars["Boolean"]>;
    readonly whiteLightDetectionEnabled?: Maybe<Scalars["Boolean"]>;
    readonly whiteLightDetectionTimeout?: Maybe<Scalars["Int"]>;
    readonly whiteLightMode?: Maybe<Scalars["String"]>;
    readonly whiteLightSupported: Scalars["Boolean"];
    readonly wirelessSignalStrength?: Maybe<Scalars["Int"]>;
    readonly wsDiscovery?: Maybe<Scalars["Boolean"]>;
  };

export type SecureComCameraInput = {
  readonly accessControlDoor?: InputMaybe<Scalars["String"]>;
  readonly alarmvisionDeviceRecordNumber?: InputMaybe<Scalars["Int"]>;
  readonly alarmvisionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly allowCustomerEdit?: InputMaybe<Scalars["Boolean"]>;
  readonly analyticalDetectionLines?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionLineInput>
  >;
  readonly analyticalDetectionRegions?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionRegionInput>
  >;
  readonly audioEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly audioOutEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly ceilingMount?: InputMaybe<Scalars["Boolean"]>;
  readonly chime?: InputMaybe<DoorbellChime>;
  readonly daylightSaving?: InputMaybe<Scalars["Boolean"]>;
  readonly detectTamper?: InputMaybe<Scalars["Boolean"]>;
  readonly eventsEnabled?: InputMaybe<CameraEventsEnabled>;
  readonly firmwareUpdateProgress?: InputMaybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly includeInVerification?: InputMaybe<Scalars["Boolean"]>;
  readonly isDoorbell?: InputMaybe<Scalars["Boolean"]>;
  readonly keypadVisible?: InputMaybe<Scalars["Boolean"]>;
  readonly lightSchedules?: InputMaybe<ReadonlyArray<LightScheduleInput>>;
  readonly microphoneLevel?: InputMaybe<Scalars["Int"]>;
  readonly motionDetectionRegions?: InputMaybe<
    ReadonlyArray<MotionDetectionRegionInput>
  >;
  readonly motionSensitivity?: InputMaybe<Scalars["Int"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly panelIp?: InputMaybe<Scalars["String"]>;
  readonly recordOnAlarm?: InputMaybe<Scalars["Boolean"]>;
  readonly redBlueLedActiveDeterrence?: InputMaybe<Scalars["Boolean"]>;
  readonly redBlueLightDetectionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly redBlueLightDetectionTimeout?: InputMaybe<Scalars["Int"]>;
  readonly speakerVolume?: InputMaybe<Scalars["Int"]>;
  readonly stitchingDistance?: InputMaybe<Scalars["Int"]>;
  readonly timeZone?: InputMaybe<Scalars["String"]>;
  readonly videoAnalyticsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly videoQuality?: InputMaybe<Scalars["String"]>;
  readonly whiteLedActiveDeterrence?: InputMaybe<Scalars["Boolean"]>;
  readonly whiteLightDetectionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly whiteLightDetectionTimeout?: InputMaybe<Scalars["Int"]>;
  readonly whiteLightMode?: InputMaybe<Scalars["String"]>;
  readonly wsDiscovery?: InputMaybe<Scalars["Boolean"]>;
};

export type SecureComCameraPanTiltParams = {
  readonly __typename?: "SecureComCameraPanTiltParams";
  readonly panMax?: Maybe<Scalars["Int"]>;
  readonly panMin?: Maybe<Scalars["Int"]>;
  readonly panPosition?: Maybe<Scalars["Int"]>;
  readonly tiltMax?: Maybe<Scalars["Int"]>;
  readonly tiltMin?: Maybe<Scalars["Int"]>;
  readonly tiltPosition?: Maybe<Scalars["Int"]>;
};

/**
 * The SecureComDoorbell is a specific implementation of a Hikvision Doorbell branded as SecureCom.
 * Resolvers likely will call "Hikvision" apis to get the data. All UI labels use SecureCom Doorbell
 * this typename is intended to reflect the UI.
 */
export type SecureComDoorbell = Node & {
  readonly __typename?: "SecureComDoorbell";
  readonly controlSystemId: Scalars["Int"];
  readonly deviceType: Scalars["String"];
  readonly firmwareVersion: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly isUpdating: Scalars["Boolean"];
  readonly latestFirmwareVersion: Scalars["String"];
  readonly manufacturer: Scalars["String"];
  readonly model: Scalars["String"];
  readonly name: Scalars["String"];
  readonly serialNumber: Scalars["String"];
  readonly status: Scalars["String"];
  readonly timeZone: Scalars["String"];
  readonly updateAvailable: Scalars["Boolean"];
  readonly updateProgress: Scalars["Int"];
  readonly updateStatus: SecureComDoorbellFirmwareStatus;
  readonly verificationCode: Scalars["String"];
};

export enum SecureComDoorbellFirmwareStatus {
  DEVICE_REBOOT = "DEVICE_REBOOT",
  ERROR_UNKNOWN = "ERROR_UNKNOWN",
  FAILED = "FAILED",
  UPGRADED = "UPGRADED",
  UPGRADING = "UPGRADING",
}

export type SecureComNvr = Node &
  VideoDevice & {
    readonly __typename?: "SecureComNvr";
    readonly channels: ReadonlyArray<SecureComNvrVideoChannel>;
    readonly daylightSavings: Scalars["Boolean"];
    readonly deviceType: VideoDeviceType;
    readonly generation: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly isRefreshable: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly serialNumber?: Maybe<Scalars["String"]>;
    readonly status: VideoDeviceStatus;
    readonly timeZone: Scalars["String"];
  };

export type SecureComNvrNotEnabledError = Error & {
  readonly __typename?: "SecureComNvrNotEnabledError";
  readonly type?: Maybe<ErrorType>;
};

export enum SecureComNvrQuality {
  HIGH = "HIGH",
  LOW = "LOW",
}

export type SecureComNvrVideoChannel = Node & {
  readonly __typename?: "SecureComNvrVideoChannel";
  /** The live stream URL in HLS format */
  readonly hlsStream?: Maybe<HlsStreamPayload>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly networkStatus: VideoChannelNetworkStatus;
  readonly number: Scalars["Int"];
  readonly online: Scalars["Boolean"];
  /** The most recent still shot of the camera's view */
  readonly snapshot?: Maybe<Scalars["URL"]>;
  readonly videoDevice: SecureComNvr;
};

export type SecureComNvrVideoChannelHlsStreamArgs = {
  quality?: InputMaybe<SecureComNvrQuality>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export enum SecureComVideoLevel {
  NONE = "NONE",
  STANDARD = "STANDARD",
  STANDARD_PLUS_EIGHT = "STANDARD_PLUS_EIGHT",
  STANDARD_PLUS_FOUR = "STANDARD_PLUS_FOUR",
}

export type SecurityGrade = Node & {
  readonly __typename?: "SecurityGrade";
  readonly grade: Grades;
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly updatedAt: Scalars["String"];
};

export type SecurityPanelPersonsListConnection = {
  readonly __typename?: "SecurityPanelPersonsListConnection";
  readonly edges: ReadonlyArray<SecurityPanelPersonsListEdge>;
  readonly hasMore: Scalars["Boolean"];
  readonly nextPageQueryParam?: Maybe<Scalars["String"]>;
  readonly nodes: ReadonlyArray<QuickSecurityPanelPerson>;
  readonly pageInfo: PageInfo;
  readonly peopleCount: Scalars["Int"];
  readonly totalCount: Scalars["Int"];
};

export type SecurityPanelPersonsListEdge = {
  readonly __typename?: "SecurityPanelPersonsListEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<QuickSecurityPanelPerson>;
};

export type SendAllUserCodesErrorResponse = {
  readonly __typename?: "SendAllUserCodesErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
};

export type SendAllUserCodesResponse =
  | SendAllUserCodesErrorResponse
  | SendAllUserCodesSuccessResponse;

export type SendAllUserCodesSuccessResponse = {
  readonly __typename?: "SendAllUserCodesSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
};

export type SendAreaInformationsErrorPayload = {
  readonly __typename?: "SendAreaInformationsErrorPayload";
  readonly error: ErrorType;
};

export type SendAreaInformationsPayload =
  | SendAreaInformationsErrorPayload
  | SendAreaInformationsSuccessPayload;

export type SendAreaInformationsSuccessPayload = {
  readonly __typename?: "SendAreaInformationsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendAreasProgrammingAreaPayload =
  | SendAreasProgrammingAreaSuccessPayload
  | SendListItemsErrorPayload;

export type SendAreasProgrammingAreaSuccessPayload = {
  readonly __typename?: "SendAreasProgrammingAreaSuccessPayload";
  readonly area: Area;
};

export type SendAreasProgrammingPayload =
  | NotFoundError
  | SendAreasProgrammingSuccessPayload;

export type SendAreasProgrammingSuccessPayload = {
  readonly __typename?: "SendAreasProgrammingSuccessPayload";
  readonly controlSystem: ControlSystem;
  readonly results: ReadonlyArray<SendAreasProgrammingAreaPayload>;
};

export type SendBellOptionsErrorPayload = {
  readonly __typename?: "SendBellOptionsErrorPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly type: ErrorType;
};

export type SendBellOptionsPayload =
  | SendBellOptionsErrorPayload
  | SendBellOptionsSuccessPayload;

export type SendBellOptionsProgrammingErrorPayload = {
  readonly __typename?: "SendBellOptionsProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendBellOptionsProgrammingPayload =
  | SendBellOptionsProgrammingErrorPayload
  | SendBellOptionsProgrammingSuccessPayload;

export type SendBellOptionsProgrammingSuccessPayload = {
  readonly __typename?: "SendBellOptionsProgrammingSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendBellOptionsSuccessPayload = {
  readonly __typename?: "SendBellOptionsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendCardFormatsErrorResponse = Error & {
  readonly __typename?: "SendCardFormatsErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type SendCardFormatsProgrammingCardFormatPayload =
  | SendCardFormatsProgrammingCardFormatSuccessPayload
  | SendListItemsErrorPayload;

export type SendCardFormatsProgrammingCardFormatSuccessPayload = {
  readonly __typename?: "SendCardFormatsProgrammingCardFormatSuccessPayload";
  readonly cardFormat: CardFormat;
};

export type SendCardFormatsProgrammingPayload =
  | NotFoundError
  | SendCardFormatsProgrammingSuccessPayload;

export type SendCardFormatsProgrammingSuccessPayload = {
  readonly __typename?: "SendCardFormatsProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendCardFormatsProgrammingCardFormatPayload>;
};

export type SendCardFormatsResponse =
  | SendCardFormatsErrorResponse
  | SendCardFormatsSuccessPayload;

export type SendCardFormatsSuccessPayload = {
  readonly __typename?: "SendCardFormatsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendCodesToLocks = {
  readonly __typename?: "SendCodesToLocks";
  readonly capable: Scalars["Boolean"];
  readonly userNumberRange: UserNumberRange;
};

export type SendCommunicationErrorPayload = {
  readonly __typename?: "SendCommunicationErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendCommunicationPathProgrammingComPathPayload =
  | SendCommunicationPathProgrammingComPathSuccessPayload
  | SendListItemsErrorPayload;

export type SendCommunicationPathProgrammingComPathSuccessPayload = {
  readonly __typename?: "SendCommunicationPathProgrammingComPathSuccessPayload";
  readonly communicationPath: CommunicationPath;
};

export type SendCommunicationPathsErrorPayload = {
  readonly __typename?: "SendCommunicationPathsErrorPayload";
  readonly error?: Maybe<ErrorType>;
};

export type SendCommunicationPathsPayload =
  | SendCommunicationPathsErrorPayload
  | SendCommunicationPathsSuccessPayload;

export type SendCommunicationPathsProgrammingPayload =
  | NotFoundError
  | SendCommunicationPathsProgrammingSuccessPayload;

export type SendCommunicationPathsProgrammingSuccessPayload = {
  readonly __typename?: "SendCommunicationPathsProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendCommunicationPathProgrammingComPathPayload>;
};

export type SendCommunicationPathsSuccessPayload = {
  readonly __typename?: "SendCommunicationPathsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendCommunicationPayload =
  | SendCommunicationErrorPayload
  | SendCommunicationSuccessPayload;

export type SendCommunicationSuccessPayload = {
  readonly __typename?: "SendCommunicationSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendContactMeEmailForCentralStationAutomationIntegrationErrorResponse =
  {
    readonly __typename?: "SendContactMeEmailForCentralStationAutomationIntegrationErrorResponse";
    readonly error: Error;
  };

export type SendContactMeEmailForCentralStationAutomationIntegrationResponse =
  | SendContactMeEmailForCentralStationAutomationIntegrationErrorResponse
  | SendContactMeEmailForCentralStationAutomationIntegrationSuccessResponse;

export type SendContactMeEmailForCentralStationAutomationIntegrationSuccessResponse =
  {
    readonly __typename?: "SendContactMeEmailForCentralStationAutomationIntegrationSuccessResponse";
    readonly dealer: Dealer;
  };

export type SendDealerKeypadContactInfoErrorResponse = Error & {
  readonly __typename?: "SendDealerKeypadContactInfoErrorResponse";
  readonly type?: Maybe<ErrorType>;
};

export type SendDealerKeypadContactInfoResponse =
  | SendDealerKeypadContactInfoErrorResponse
  | SendDealerKeypadContactInfoSuccessPayload;

export type SendDealerKeypadContactInfoSuccessPayload = {
  readonly __typename?: "SendDealerKeypadContactInfoSuccessPayload";
  readonly dealer?: Maybe<Dealer>;
};

export type SendDeviceInformationsErrorPayload = {
  readonly __typename?: "SendDeviceInformationsErrorPayload";
  readonly error: ErrorType;
};

export type SendDeviceInformationsPayload =
  | SendDeviceInformationsErrorPayload
  | SendDeviceInformationsSuccessPayload;

export type SendDeviceInformationsSuccessPayload = {
  readonly __typename?: "SendDeviceInformationsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendDeviceProgrammingDevicePayload =
  | SendDeviceProgrammingDeviceSuccessPayload
  | SendListItemsErrorPayload;

export type SendDeviceProgrammingDeviceSuccessPayload = {
  readonly __typename?: "SendDeviceProgrammingDeviceSuccessPayload";
  readonly deviceInformation: DeviceInformation;
};

export type SendDeviceProgrammingPayload =
  | NotFoundError
  | SendDeviceProgrammingSuccessPayload;

export type SendDeviceProgrammingSuccessPayload = {
  readonly __typename?: "SendDeviceProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendDeviceProgrammingDevicePayload>;
};

export type SendError =
  | ConnectionTimeoutError
  | InvalidInputError
  | NotFoundError
  | PanelBusyError
  | UnknownError;

export type SendFileTransferCommandErrorPayload = {
  readonly __typename?: "SendFileTransferCommandErrorPayload";
  readonly Error?: Maybe<Scalars["String"]>;
};

export type SendFileTransferCommandPayload =
  | SendFileTransferCommandErrorPayload
  | SendFileTransferCommandSuccessPayload;

export type SendFileTransferCommandSuccessPayload = {
  readonly __typename?: "SendFileTransferCommandSuccessPayload";
  readonly accepted: Scalars["Boolean"];
  readonly highFrequency13_56MHzEnabled?: Maybe<Scalars["Boolean"]>;
  readonly jobCompleted: Scalars["Boolean"];
  readonly jobId: Scalars["String"];
  readonly lowFrequency125kHzEnabled?: Maybe<Scalars["Boolean"]>;
  readonly mobileBleNfcEnabled?: Maybe<Scalars["Boolean"]>;
};

export type SendKeyfobsErrorPayload = {
  readonly __typename?: "SendKeyfobsErrorPayload";
  readonly error: ErrorType;
};

export type SendKeyfobsPayload =
  | SendKeyfobsErrorPayload
  | SendKeyfobsSuccessPayload;

export type SendKeyfobsProgrammingKeyfobPayload =
  | SendKeyfobsProgrammingKeyfobSuccessPayload
  | SendListItemsErrorPayload;

export type SendKeyfobsProgrammingKeyfobSuccessPayload = {
  readonly __typename?: "SendKeyfobsProgrammingKeyfobSuccessPayload";
  readonly keyfob: Keyfob;
};

export type SendKeyfobsProgrammingPayload =
  | NotFoundError
  | SendKeyfobsProgrammingSuccessPayload;

export type SendKeyfobsProgrammingSuccessPayload = {
  readonly __typename?: "SendKeyfobsProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendKeyfobsProgrammingKeyfobPayload>;
};

export type SendKeyfobsSuccessPayload = {
  readonly __typename?: "SendKeyfobsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendListItemsErrorPayload = {
  readonly __typename?: "SendListItemsErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
  readonly number: Scalars["String"];
};

export enum SendLocalChangesType {
  DIGITAL_DIALER = "DIGITAL_DIALER",
  NETWORK = "NETWORK",
  NONE = "NONE",
}

export type SendLockoutCodeErrorPayload = {
  readonly __typename?: "SendLockoutCodeErrorPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly type: ErrorType;
};

export type SendLockoutCodePayload =
  | SendLockoutCodeErrorPayload
  | SendLockoutCodeSuccessPayload;

export type SendLockoutCodeProgrammingErrorPayload = {
  readonly __typename?: "SendLockoutCodeProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendLockoutCodeProgrammingPayload =
  | SendLockoutCodeProgrammingErrorPayload
  | SendLockoutCodeProgrammingSuccessPayload;

export type SendLockoutCodeProgrammingSuccessPayload = {
  readonly __typename?: "SendLockoutCodeProgrammingSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendLockoutCodeSuccessPayload = {
  readonly __typename?: "SendLockoutCodeSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendMenuDisplayProgrammingErrorPayload = {
  readonly __typename?: "SendMenuDisplayProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendMessagingSetupPayload =
  | ConnectionTimeoutError
  | InvalidInputError
  | NotFoundError
  | SendMessagingSetupSuccessPayload
  | UnknownError;

export type SendMessagingSetupProgrammingErrorPayload = {
  readonly __typename?: "SendMessagingSetupProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendMessagingSetupProgrammingPayload =
  | SendMessagingSetupProgrammingErrorPayload
  | SendMessagingSetupProgrammingSuccessPayload;

export type SendMessagingSetupProgrammingSuccessPayload = {
  readonly __typename?: "SendMessagingSetupProgrammingSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendMessagingSetupSuccessPayload = {
  readonly __typename?: "SendMessagingSetupSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendNetworkOptionsErrorPayload = {
  readonly __typename?: "SendNetworkOptionsErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendNetworkOptionsPayload =
  | SendNetworkOptionsErrorPayload
  | SendNetworkOptionsSuccessPayload;

export type SendNetworkOptionsSuccessPayload = {
  readonly __typename?: "SendNetworkOptionsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendOutputGroupsErrorPayload = {
  readonly __typename?: "SendOutputGroupsErrorPayload";
  readonly error: ErrorType;
};

export type SendOutputGroupsPayload =
  | SendOutputGroupsErrorPayload
  | SendOutputGroupsSuccessPayload;

export type SendOutputGroupsProgrammingOutputGroupPayload =
  | SendListItemsErrorPayload
  | SendOutputGroupsProgrammingOutputGroupSuccessPayload;

export type SendOutputGroupsProgrammingOutputGroupSuccessPayload = {
  readonly __typename?: "SendOutputGroupsProgrammingOutputGroupSuccessPayload";
  readonly outputGroup: OutputGroup;
};

export type SendOutputGroupsProgrammingPayload =
  | NotFoundError
  | SendOutputGroupsProgrammingSuccessPayload;

export type SendOutputGroupsProgrammingSuccessPayload = {
  readonly __typename?: "SendOutputGroupsProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendOutputGroupsProgrammingOutputGroupPayload>;
};

export type SendOutputGroupsSuccessPayload = {
  readonly __typename?: "SendOutputGroupsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendOutputOptionsErrorPayload = {
  readonly __typename?: "SendOutputOptionsErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendOutputOptionsPayload =
  | SendOutputOptionsErrorPayload
  | SendOutputOptionsSuccessPayload;

export type SendOutputOptionsSuccessPayload = {
  readonly __typename?: "SendOutputOptionsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendOutputsProgrammingOutputPayload =
  | SendListItemsErrorPayload
  | SendOutputsProgrammingOutputSuccessPayload;

export type SendOutputsProgrammingOutputSuccessPayload = {
  readonly __typename?: "SendOutputsProgrammingOutputSuccessPayload";
  readonly output: Output;
};

export type SendOutputsProgrammingPayload =
  | NotFoundError
  | SendOutputsProgrammingSuccessPayload;

export type SendOutputsProgrammingSuccessPayload = {
  readonly __typename?: "SendOutputsProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendOutputsProgrammingOutputPayload>;
};

export type SendProgrammingConfirmationErrorResponse = {
  readonly __typename?: "SendProgrammingConfirmationErrorResponse";
  readonly error: SendProgrammingConfirmationErrors;
};

export enum SendProgrammingConfirmationErrors {
  FAILED_TO_CONFIRM = "FAILED_TO_CONFIRM",
  FAILED_TO_FETCH = "FAILED_TO_FETCH",
  JOB_FAILED = "JOB_FAILED",
  SEND_FAILED = "SEND_FAILED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export type SendProgrammingConfirmationResponse =
  | SendProgrammingConfirmationErrorResponse
  | SendProgrammingConfirmationSuccessResponse;

export type SendProgrammingConfirmationSuccessResponse = {
  readonly __typename?: "SendProgrammingConfirmationSuccessResponse";
  readonly controlSystem: ControlSystem;
  readonly hasUnconfirmed: Scalars["Boolean"];
};

export type SendRemoteOptionsErrorPayload = {
  readonly __typename?: "SendRemoteOptionsErrorPayload";
  readonly error: ErrorType;
};

export type SendRemoteOptionsPayload =
  | SendRemoteOptionsErrorPayload
  | SendRemoteOptionsSuccessPayload;

export type SendRemoteOptionsProgrammingErrorPayload = {
  readonly __typename?: "SendRemoteOptionsProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendRemoteOptionsProgrammingPayload =
  | SendRemoteOptionsProgrammingErrorPayload
  | SendRemoteOptionsProgrammingSuccessPayload;

export type SendRemoteOptionsProgrammingSuccessPayload = {
  readonly __typename?: "SendRemoteOptionsProgrammingSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendRemoteOptionsSuccessPayload = {
  readonly __typename?: "SendRemoteOptionsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendSecurityGradeErrorPayload = {
  readonly __typename?: "SendSecurityGradeErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendSecurityGradePayload =
  | SendSecurityGradeErrorPayload
  | SendSecurityGradeSuccessPayload;

export type SendSecurityGradeSuccessPayload = {
  readonly __typename?: "SendSecurityGradeSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendSystemAreaInformationErrorPayload = {
  readonly __typename?: "SendSystemAreaInformationErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendSystemAreaInformationPayload =
  | SendSystemAreaInformationErrorPayload
  | SendSystemAreaInformationSuccessPayload;

export type SendSystemAreaInformationSuccessPayload = {
  readonly __typename?: "SendSystemAreaInformationSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendSystemOptionsProgrammingErrorPayload = {
  readonly __typename?: "SendSystemOptionsProgrammingErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendSystemOptionsProgrammingPayload =
  | SendSystemOptionsProgrammingErrorPayload
  | SendSystemOptionsProgrammingSuccessPayload;

export type SendSystemOptionsProgrammingSuccessPayload = {
  readonly __typename?: "SendSystemOptionsProgrammingSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendSystemOutputsErrorPayload = SendSystemOutputsPayload & {
  readonly __typename?: "SendSystemOutputsErrorPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly error: ErrorType;
};

export type SendSystemOutputsPayload = {
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendSystemOutputsSuccessPayload = SendSystemOutputsPayload & {
  readonly __typename?: "SendSystemOutputsSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SendSystemReportsErrorPayload = {
  readonly __typename?: "SendSystemReportsErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendSystemReportsPayload =
  | SendSystemReportsErrorPayload
  | SendSystemReportsSuccessPayload;

export type SendSystemReportsSuccessPayload = {
  readonly __typename?: "SendSystemReportsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendUserCodesErrorResponse = {
  readonly __typename?: "SendUserCodesErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type SendUserCodesResponse =
  | SendUserCodesErrorResponse
  | SendUserCodesSuccessResponse;

export type SendUserCodesSuccessResponse = {
  readonly __typename?: "SendUserCodesSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
  readonly userCodes?: Maybe<ReadonlyArray<Maybe<UserCode>>>;
};

export type SendXfSystemOptionsResponse =
  | ConnectionTimeoutError
  | SendXfSystemOptionsSuccessResponse
  | UnknownError;

export type SendXfSystemOptionsSuccessResponse = {
  readonly __typename?: "SendXfSystemOptionsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type SendXrSystemOptionsResponse =
  | ConnectionTimeoutError
  | SendXrSystemOptionsSuccessResponse
  | UnknownError;

export type SendXrSystemOptionsSuccessResponse = {
  readonly __typename?: "SendXrSystemOptionsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type SendXt75SystemOptionsResponse =
  | ConnectionTimeoutError
  | SendXt75SystemOptionsSuccessResponse
  | UnknownError;

export type SendXt75SystemOptionsSuccessResponse = {
  readonly __typename?: "SendXt75SystemOptionsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type SendXtSystemOptionsResponse =
  | ConnectionTimeoutError
  | SendXtSystemOptionsSuccessResponse
  | UnknownError;

export type SendXtSystemOptionsSuccessResponse = {
  readonly __typename?: "SendXtSystemOptionsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type SendZoneInformationsErrorPayload = {
  readonly __typename?: "SendZoneInformationsErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type SendZoneInformationsPayload =
  | SendZoneInformationsErrorPayload
  | SendZoneInformationsSuccessPayload;

export type SendZoneInformationsSuccessPayload = {
  readonly __typename?: "SendZoneInformationsSuccessPayload";
  readonly controlSystem: ControlSystem;
};

export type SendZoneProgrammingPayload =
  | NotFoundError
  | SendZoneProgrammingSuccessPayload;

export type SendZoneProgrammingSuccessPayload = {
  readonly __typename?: "SendZoneProgrammingSuccessPayload";
  readonly results: ReadonlyArray<SendZoneProgrammingZonePayload>;
};

export type SendZoneProgrammingZonePayload =
  | SendListItemsErrorPayload
  | SendZoneProgrammingZoneSuccessPayload;

export type SendZoneProgrammingZoneSuccessPayload = {
  readonly __typename?: "SendZoneProgrammingZoneSuccessPayload";
  readonly zone: Zone;
};

export type SerialNumberNotFoundError = Error & {
  readonly __typename?: "SerialNumberNotFoundError";
  readonly type?: Maybe<ErrorType>;
};

export type ServiceRequest = Node & {
  readonly __typename?: "ServiceRequest";
  readonly closedDate?: Maybe<Scalars["String"]>;
  readonly completedDate?: Maybe<Scalars["String"]>;
  readonly controlSystemAddress1?: Maybe<Scalars["String"]>;
  readonly controlSystemAddress2?: Maybe<Scalars["String"]>;
  readonly controlSystemCity?: Maybe<Scalars["String"]>;
  readonly controlSystemId?: Maybe<Scalars["Int"]>;
  readonly controlSystemName?: Maybe<Scalars["String"]>;
  readonly controlSystemState?: Maybe<Scalars["String"]>;
  readonly controlSystemZip?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly createdById?: Maybe<Scalars["Int"]>;
  readonly createdByTechnicianName?: Maybe<Scalars["String"]>;
  readonly customerAddress?: Maybe<Scalars["String"]>;
  readonly customerEmail?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly customerName?: Maybe<Scalars["String"]>;
  readonly customerPhoneNumber?: Maybe<Scalars["String"]>;
  readonly dealerId?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly notes?: Maybe<Scalars["String"]>;
  readonly panelAccountNumber?: Maybe<Scalars["Int"]>;
  readonly panelHardwareModel?: Maybe<Scalars["String"]>;
  readonly panelSoftwareVersion?: Maybe<Scalars["String"]>;
  readonly startDate?: Maybe<Scalars["String"]>;
  readonly status?: Maybe<ServiceRequestStatuses>;
  readonly technicianEmail?: Maybe<Scalars["String"]>;
  readonly technicianId?: Maybe<Scalars["Int"]>;
  readonly technicianName?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<ServiceRequestTypes>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly updatedBy?: Maybe<Scalars["Int"]>;
};

export type ServiceRequestConnection = {
  readonly __typename?: "ServiceRequestConnection";
  readonly edges: ReadonlyArray<ServiceRequestEdge>;
  readonly nodes: ReadonlyArray<ServiceRequest>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type ServiceRequestEdge = {
  readonly __typename?: "ServiceRequestEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<ServiceRequest>;
};

export type ServiceRequestInput = {
  readonly controlSystemId: Scalars["Int"];
  readonly dealerId: Scalars["Int"];
  readonly isNew: Scalars["Boolean"];
  readonly notes?: InputMaybe<Scalars["String"]>;
  readonly startDate: Scalars["String"];
  readonly technicianId: Scalars["Int"];
  readonly type: ServiceRequestTypes;
};

export enum ServiceRequestStatuses {
  CLOSED = "CLOSED",
  COMPLETED = "COMPLETED",
  OPEN = "OPEN",
}

export enum ServiceRequestTypes {
  INSTALL = "INSTALL",
  SERVICE = "SERVICE",
}

export type ServicesManager = {
  readonly __typename?: "ServicesManager";
  readonly armingAppEnabled: Scalars["Boolean"];
  readonly axisAlarmvisionPluginEnabled: Scalars["Boolean"];
  readonly badgePrintingEnabled?: Maybe<Scalars["Boolean"]>;
  readonly digitalWatchdogSpectrumEnabled: Scalars["Boolean"];
  readonly dmpVideoEnabled: Scalars["Boolean"];
  readonly doorAccessLevel: ServicesManagerDoorAccessLevel;
  readonly doorsEditingEnabled: Scalars["Boolean"];
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly favoriteEditingEnabled: Scalars["Boolean"];
  readonly fullAppEnabled: Scalars["Boolean"];
  readonly genericDoorbellAttached?: Maybe<Scalars["Boolean"]>;
  readonly geofencingEnabled?: Maybe<Scalars["Boolean"]>;
  readonly hikvisionDoorbellEnabled: Scalars["Boolean"];
  readonly hikvisionDoorbellTotal: Scalars["Int"];
  readonly hikvisionNvrEnabled: Scalars["Boolean"];
  readonly lightControlEnabled: Scalars["Boolean"];
  readonly lockControlEnabled: Scalars["Boolean"];
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly outputOptionEditingEnabled?: Maybe<Scalars["Boolean"]>;
  readonly outputOptionsEditingEnabled: Scalars["Boolean"];
  readonly realTimeEventsEnabled: Scalars["Boolean"];
  readonly ringDoorbellEnabled: Scalars["Boolean"];
  readonly scheduleEditEnabled: Scalars["Boolean"];
  readonly securecomNvrEnabled: Scalars["Boolean"];
  readonly securecomVideoLevel: SecureComVideoLevel;
  readonly sensorActivityEnabled: Scalars["Boolean"];
  readonly storeUserCodes: Scalars["Boolean"];
  readonly thermostatControlEnabled: Scalars["Boolean"];
  readonly totalNumberOfVars?: Maybe<Scalars["Int"]>;
  readonly trafficCountEnabled: Scalars["Boolean"];
  readonly univiewEnabled?: Maybe<Scalars["Boolean"]>;
  readonly userCodeEditingEnabled: Scalars["Boolean"];
  readonly varEnabled?: Maybe<Scalars["Boolean"]>;
  readonly videoVerificationEnabled: Scalars["Boolean"];
  readonly vueAlarmvisionPluginEnabled: Scalars["Boolean"];
  readonly vueCamerasCount?: Maybe<Scalars["Int"]>;
  readonly vueCamerasEnabled?: Maybe<Scalars["Boolean"]>;
  readonly vueDoorbellsCount?: Maybe<Scalars["Int"]>;
  readonly vueDoorbellsEnabled?: Maybe<Scalars["Boolean"]>;
  readonly zwaveNodeEditingEnabled: Scalars["Boolean"];
  readonly zwaveSensorEnabled?: Maybe<Scalars["Boolean"]>;
};

export enum ServicesManagerDoorAccessLevel {
  ALL = "ALL",
  DENIALS_ONLY = "DENIALS_ONLY",
  NONE = "NONE",
}

export type SetDealerAccessErrorPayload = {
  readonly __typename?: "SetDealerAccessErrorPayload";
  readonly error?: Maybe<Error>;
};

export type SetDealerAccessInput = {
  readonly access_type: Scalars["String"];
  readonly minutes?: InputMaybe<Scalars["Int"]>;
};

export type SetDealerAccessPayload =
  | SetDealerAccessErrorPayload
  | SetDealerAccessSuccessPayload;

export type SetDealerAccessSuccessPayload = {
  readonly __typename?: "SetDealerAccessSuccessPayload";
  readonly system: ControlSystem;
};

export type SetDigitalWatchdogCameraPresetPayload = {
  readonly __typename?: "SetDigitalWatchdogCameraPresetPayload";
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type SetPtCameraPresetErrorPayload = {
  readonly __typename?: "SetPTCameraPresetErrorPayload";
  readonly error?: Maybe<PanTiltError>;
};

export type SetPtCameraPresetPayload =
  | SetPtCameraPresetErrorPayload
  | SetPtCameraPresetSuccessPayload;

export type SetPtCameraPresetSuccessPayload = {
  readonly __typename?: "SetPTCameraPresetSuccessPayload";
  readonly camera?: Maybe<ScapiV3CameraDetails>;
};

export type SetSecureComCameraPresetPayload = {
  readonly __typename?: "SetSecureComCameraPresetPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type SetSecureComDoorbellTotalForSiteResponse =
  | HikvisionDoorbellNotEnabledError
  | NotFoundError
  | Site;

export type SetSecureComNvrsTotalForSiteResponse = NotFoundError | Site;

export type SetTwoFactorForCustomerError =
  | UnauthorizedError
  | UnknownError
  | ValidationError;

export type SetTwoFactorForCustomerErrorResponse = {
  readonly __typename?: "SetTwoFactorForCustomerErrorResponse";
  readonly error: SetTwoFactorForCustomerError;
};

export type SetTwoFactorForCustomerResponse =
  | SetTwoFactorForCustomerErrorResponse
  | SetTwoFactorForCustomerSuccessResponse;

export type SetTwoFactorForCustomerSuccessResponse = {
  readonly __typename?: "SetTwoFactorForCustomerSuccessResponse";
  readonly customer?: Maybe<Customer>;
  readonly twoFactorSettings: TwoFactorSettings;
};

export type SetZwaveApplianceLevelFailedResponse = {
  readonly __typename?: "SetZwaveApplianceLevelFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveApplianceLevelResponse =
  | SetZwaveApplianceLevelFailedResponse
  | SetZwaveApplianceLevelSuccessResponse;

export type SetZwaveApplianceLevelSuccessResponse = {
  readonly __typename?: "SetZwaveApplianceLevelSuccessResponse";
  readonly appliance: ZwaveAppliance;
};

export type SetZwaveLightLevelFailedResponse = {
  readonly __typename?: "SetZwaveLightLevelFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveLightLevelResponse =
  | SetZwaveLightLevelFailedResponse
  | SetZwaveLightLevelSuccessResponse;

export type SetZwaveLightLevelSuccessResponse = {
  readonly __typename?: "SetZwaveLightLevelSuccessResponse";
  readonly light: ZwaveLight;
};

export type SetZwaveThermostatAutoPointFailedResponse = {
  readonly __typename?: "SetZwaveThermostatAutoPointFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveThermostatAutoPointResponse =
  | SetZwaveThermostatAutoPointFailedResponse
  | SetZwaveThermostatAutoPointSuccessResponse;

export type SetZwaveThermostatAutoPointSuccessResponse = {
  readonly __typename?: "SetZwaveThermostatAutoPointSuccessResponse";
  readonly thermostat: ZwaveThermostat;
};

export type SetZwaveThermostatCoolPointFailedResponse = {
  readonly __typename?: "SetZwaveThermostatCoolPointFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveThermostatCoolPointResponse =
  | SetZwaveThermostatCoolPointFailedResponse
  | SetZwaveThermostatCoolPointSuccessResponse;

export type SetZwaveThermostatCoolPointSuccessResponse = {
  readonly __typename?: "SetZwaveThermostatCoolPointSuccessResponse";
  readonly thermostat: ZwaveThermostat;
};

export type SetZwaveThermostatFanModeFailedResponse = {
  readonly __typename?: "SetZwaveThermostatFanModeFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveThermostatFanModeResponse =
  | SetZwaveThermostatFanModeFailedResponse
  | SetZwaveThermostatFanModeSuccessResponse;

export type SetZwaveThermostatFanModeSuccessResponse = {
  readonly __typename?: "SetZwaveThermostatFanModeSuccessResponse";
  readonly thermostat: ZwaveThermostat;
};

export type SetZwaveThermostatHeatPointFailedResponse = {
  readonly __typename?: "SetZwaveThermostatHeatPointFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveThermostatHeatPointResponse =
  | SetZwaveThermostatHeatPointFailedResponse
  | SetZwaveThermostatHeatPointSuccessResponse;

export type SetZwaveThermostatHeatPointSuccessResponse = {
  readonly __typename?: "SetZwaveThermostatHeatPointSuccessResponse";
  readonly thermostat: ZwaveThermostat;
};

export type SetZwaveThermostatModeFailedResponse = {
  readonly __typename?: "SetZwaveThermostatModeFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type SetZwaveThermostatModeResponse =
  | SetZwaveThermostatModeFailedResponse
  | SetZwaveThermostatModeSuccessResponse;

export type SetZwaveThermostatModeSuccessResponse = {
  readonly __typename?: "SetZwaveThermostatModeSuccessResponse";
  readonly thermostat: ZwaveThermostat;
};

export type SetupSiteControlSystemPayload =
  | InitialConnectionFailure
  | NotFoundError
  | SetupSiteControlSystemSuccessPayload;

export type SetupSiteControlSystemSuccessPayload = {
  readonly __typename?: "SetupSiteControlSystemSuccessPayload";
  readonly controlSystem?: Maybe<SiteControlSystem>;
};

export type ShareCamectVideoClipErrorPayload = {
  readonly __typename?: "ShareCamectVideoClipErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type ShareCamectVideoClipPayload =
  | ShareCamectVideoClipErrorPayload
  | ShareCamectVideoClipSuccessPayload;

export type ShareCamectVideoClipSuccessPayload = {
  readonly __typename?: "ShareCamectVideoClipSuccessPayload";
  readonly status: Scalars["String"];
};

export type SharedClientConfiguration = Node & {
  readonly __typename?: "SharedClientConfiguration";
  readonly favoriteSiteDoorIds: ReadonlyArray<Maybe<Scalars["ID"]>>;
  readonly id: Scalars["ID"];
};

export type SilenceAlarmError = Error & {
  readonly __typename?: "SilenceAlarmError";
  readonly type?: Maybe<ErrorType>;
};

export type SilenceAlarmPayload =
  | SilenceAlarmError
  | SilenceAlarmSuccessPayload;

export type SilenceAlarmSuccessPayload = {
  readonly __typename?: "SilenceAlarmSuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type SingleCombinedPersonConnection = {
  readonly __typename?: "SingleCombinedPersonConnection";
  readonly person: PanelPerson;
};

export enum SinglePersonUserType {
  CREDENTIAL = "CREDENTIAL",
  PERSON = "PERSON",
  USER_CODE = "USER_CODE",
}

export type Site = Node & {
  readonly __typename?: "Site";
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly alarmPanelX1Integration: Scalars["Boolean"];
  readonly allCameras: ReadonlyArray<AllCameras>;
  readonly allReportsCount: Scalars["Int"];
  readonly analyticsVideoEnabled: Scalars["Boolean"];
  readonly armablePanel?: Maybe<ControlSystem>;
  readonly armablePanelId?: Maybe<Scalars["String"]>;
  readonly armablePanelSerialNumber?: Maybe<Scalars["String"]>;
  readonly badgePrintingEnabled: Scalars["Boolean"];
  readonly billingControlSystemId: Scalars["String"];
  readonly canManagerFirst: Scalars["Boolean"];
  readonly cardFormats: ReadonlyArray<CardFormat>;
  readonly city: Scalars["String"];
  readonly controlSystems: ReadonlyArray<SiteControlSystem>;
  readonly country: Scalars["String"];
  readonly credentialExternalNumberMaxLength: Scalars["Int"];
  readonly credentialInternalNumberMaxLength: Scalars["Int"];
  readonly customer: Customer;
  readonly databaseId: Scalars["Int"];
  readonly digitalWatchdogSpectrumEnabled: Scalars["Boolean"];
  readonly digitalWatchdogSpectrumNvrs: ReadonlyArray<DigitalWatchdogSpectrumNvr>;
  readonly digitalWatchdogSpectrumType: DigitalWatchdogSpectrumType;
  readonly dmpDoorbellEnabled: Scalars["Boolean"];
  readonly doorSchedules: ReadonlyArray<SiteDoorSchedule>;
  readonly doors: ReadonlyArray<SiteDoor>;
  readonly eagleEyeBridge?: Maybe<EagleEyeBridge>;
  readonly eagleEyeBridgeVideoChannel?: Maybe<EagleEyeBridgeVideoChannel>;
  readonly eagleEyeBridges: ReadonlyArray<EagleEyeBridge>;
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly groupSchedules: ReadonlyArray<SiteGroupSchedule>;
  readonly groups: ReadonlyArray<SiteGroup>;
  readonly hanwhaNvrs: ReadonlyArray<HanwhaNvr>;
  readonly hanwhaWaveEnabled: Scalars["Boolean"];
  readonly hasFireZone: Scalars["Boolean"];
  readonly hikvisionDoorbellEnabled: Scalars["Boolean"];
  readonly hikvisionDoorbellTotal: Scalars["Int"];
  readonly hikvisionNvrEnabled: Scalars["Boolean"];
  readonly hikvisionNvrs: ReadonlyArray<HikvisionNvr>;
  readonly holidayDates: ReadonlyArray<HolidayDate>;
  readonly id: Scalars["ID"];
  readonly invalidCodeResolvedEventIds?: Maybe<
    ReadonlyArray<Maybe<Scalars["String"]>>
  >;
  readonly lockdownInitiated: Scalars["Boolean"];
  readonly maxGroupNameLength: Scalars["Int"];
  readonly maxTimesCountForNewGroup: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly nickname?: Maybe<Scalars["String"]>;
  readonly notifications: ReadonlyArray<SiteNotification>;
  readonly observesDaylightSavingsTime: Scalars["Boolean"];
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly openEyeNvrs: ReadonlyArray<OpenEyeNvr>;
  readonly outputModulesConnection: SiteOutputModulesConnection;
  readonly outputsConnection: SiteOutputsConnection;
  /** @deprecated Use quickPersonsConnection instead. This endpoint is too data intensive. This will be removed in a future release. */
  readonly personsConnection: SitePersonsConnection;
  readonly postalCode: Scalars["String"];
  readonly quickPersonsConnection: QuickSitePersonsConnection;
  readonly reportEvents: SiteReportEventsConnection;
  readonly reports: SiteReportsConnection;
  readonly rules: ReadonlyArray<Rule>;
  readonly securecomCameras: ReadonlyArray<SecureComCamera>;
  readonly securecomDoorbells: ReadonlyArray<SecureComDoorbell>;
  readonly securecomNvrEnabled: Scalars["Boolean"];
  readonly securecomNvrs: ReadonlyArray<SecureComNvr>;
  readonly securecomVideoLevel: SecureComVideoLevel;
  readonly sharedClientConfiguration?: Maybe<SharedClientConfiguration>;
  readonly showDoors: Scalars["Boolean"];
  readonly showElevators: Scalars["Boolean"];
  readonly showOutputs: Scalars["Boolean"];
  readonly showVideoServices: Scalars["Boolean"];
  /** @deprecated Replaced with CombinedEvent schema */
  readonly siteCombinedHistoryConnection: SiteCombinedHistoryConnection;
  readonly siteDoorsConnection?: Maybe<SiteControlSystemDoorsConnection>;
  readonly siteHistoryConnection: SiteHistoryConnection;
  readonly sitePassphrase: Scalars["String"];
  readonly siteUniviewEventsConnection: SiteHistoryConnection;
  readonly state: Scalars["String"];
  readonly supportedEventTypes: ReadonlyArray<SupportedSiteEventType>;
  readonly supportsXrCommunication: Scalars["Boolean"];
  readonly thirdPartyVideoEnabled: Scalars["Boolean"];
  readonly timezoneOffset: Scalars["GMTOffset"];
  readonly totalControlSystems: Scalars["Int"];
  readonly totalUsersCount: Scalars["Int"];
  readonly univiewEnabled?: Maybe<Scalars["Boolean"]>;
  readonly userPermissions: SiteUserPermissions;
  readonly varEnabled?: Maybe<Scalars["Boolean"]>;
  readonly videoEnabled: Scalars["Boolean"];
  readonly vkSystemDisplayName: Scalars["String"];
  readonly vueDoorbellsCount?: Maybe<Scalars["Int"]>;
  readonly vueDoorbellsEnabled?: Maybe<Scalars["Boolean"]>;
  readonly xrCommunicationEnabled: Scalars["Boolean"];
};

export type SiteControlSystemsArgs = {
  include?: InputMaybe<ReadonlyArray<SiteControlSystemIntendedUsage>>;
};

export type SiteDoorsArgs = {
  includeUnauthorizedDoors?: InputMaybe<Scalars["Boolean"]>;
  includeUntrackedDoors?: InputMaybe<Scalars["Boolean"]>;
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteEagleEyeBridgeArgs = {
  id: Scalars["ID"];
};

export type SiteEagleEyeBridgeVideoChannelArgs = {
  id: Scalars["ID"];
};

export type SiteOutputModulesConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  include?: InputMaybe<ReadonlyArray<SiteOutputModuleIntendedUsage>>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SiteOutputsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  include?: InputMaybe<ReadonlyArray<SiteOutputType>>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SitePersonsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SiteQuickPersonsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SiteReportEventsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  doors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  endDate: Scalars["DateTime"];
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchTerms?: InputMaybe<ReadonlyArray<Scalars["String"]>>;
  sortKey?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate: Scalars["DateTime"];
  subcategories?: InputMaybe<ReadonlyArray<SupportedEventSubcategoryName>>;
  users?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
};

export type SiteReportsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SiteReportsSortInput>;
};

export type SiteSiteCombinedHistoryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  animalDetected?: InputMaybe<Scalars["Boolean"]>;
  before?: InputMaybe<Scalars["ID"]>;
  cameraNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  doorNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  endDate?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  includeClips?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  motionDetected?: InputMaybe<Scalars["Boolean"]>;
  objectDetected?: InputMaybe<Scalars["Boolean"]>;
  packageDetected?: InputMaybe<Scalars["Boolean"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  pageSize?: InputMaybe<Scalars["Int"]>;
  personDetected?: InputMaybe<Scalars["Boolean"]>;
  personId?: InputMaybe<Scalars["String"]>;
  search?: InputMaybe<SearchInput>;
  searchText?: InputMaybe<Scalars["String"]>;
  sort?: InputMaybe<SortInput>;
  startDate?: InputMaybe<Scalars["String"]>;
  subcategoryIds?: InputMaybe<
    ReadonlyArray<InputMaybe<SupportedEventSubcategoryName>>
  >;
  vehicleDetected?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteSiteDoorsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SiteSiteHistoryConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  cameraNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  doors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  person?: InputMaybe<Scalars["String"]>;
  searchTerm?: InputMaybe<Scalars["String"]>;
  sortKey?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SiteSiteUniviewEventsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  cameraNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  doors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchTerm?: InputMaybe<Scalars["String"]>;
  sortKey?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SiteAppUserInput = {
  readonly role: UserRole;
  readonly ssoOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteBatchImportUserCodesResponse =
  | BatchJobResponse
  | FailedToBeginUserCodeImportBecauseDuplicateInternalNumber
  | FailedToBeginUserCodeImportBecauseExternalNumberAlreadyInUse
  | FailedToBeginUserCodeImportBecauseExternalNumberExceededMaxDigits
  | FailedToBeginUserCodeImportBecauseExternalNumberIsNan
  | FailedToBeginUserCodeImportBecauseGroupNotFound
  | FailedToBeginUserCodeImportBecauseInternalNumberAlreadyInUse
  | FailedToBeginUserCodeImportBecauseInternalNumberExceededMaxDigits
  | FailedToBeginUserCodeImportBecauseInternalNumberInUse
  | FailedToBeginUserCodeImportBecauseInternalNumberIsNan
  | FailedToBeginUserCodeImportBecauseInternalNumberIsNanOrNotMasked
  | FailedToBeginUserCodeImportBecauseInternalNumberNotUnique
  | FailedToBeginUserCodeImportBecauseInternalNumberOutOfRange
  | FailedToBeginUserCodeImportBecauseInvalidCredentialFormat
  | FailedToBeginUserCodeImportBecauseInvalidCredentialValue
  | FailedToBeginUserCodeImportBecauseInvalidCsvTemplate
  | FailedToBeginUserCodeImportBecauseInvalidEmail
  | FailedToBeginUserCodeImportBecauseInvalidEmailAddress
  | FailedToBeginUserCodeImportBecauseInvalidExternalNumber
  | FailedToBeginUserCodeImportBecauseInvalidGroup
  | FailedToBeginUserCodeImportBecauseInvalidGroupName
  | FailedToBeginUserCodeImportBecauseInvalidInternalNumber
  | FailedToBeginUserCodeImportBecauseInvalidPersonId
  | FailedToBeginUserCodeImportBecauseInvalidPin
  | FailedToBeginUserCodeImportBecauseInvalidStatus
  | FailedToBeginUserCodeImportBecauseMaxGroupsExceeded
  | FailedToBeginUserCodeImportBecauseMaxPinLengthExceeded
  | FailedToBeginUserCodeImportBecauseMismatchedNumberCount
  | FailedToBeginUserCodeImportBecauseMissingCredentialValue
  | FailedToBeginUserCodeImportBecauseMissingEmail
  | FailedToBeginUserCodeImportBecauseMissingGroup
  | FailedToBeginUserCodeImportBecauseMissingRequiredField
  | FailedToBeginUserCodeImportBecauseOfflinePanels
  | FailedToBeginUserCodeImportBecauseOperationInvalid
  | FailedToBeginUserCodeImportBecausePersonIdRequiredForOperation
  | FailedToBeginUserCodeImportBecausePersonNotFound
  | FailedToBeginUserCodeImportBecauseUnknown;

/** @deprecated (reason: "Replaced with CombinedEvent") */
export type SiteCombinedEvent = Event &
  Node & {
    readonly __typename?: "SiteCombinedEvent";
    readonly CorrelatedEvents?: Maybe<ReadonlyArray<Maybe<Event>>>;
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly isInvalidCodeEventResolved?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    readonly personId?: Maybe<Scalars["Int"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly subcategory: SupportedEventSubcategoryName;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

/** @deprecated (reason: "Replaced with CombinedEvent") */
export type SiteCombinedEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteCombinedEventEdge = {
  readonly __typename?: "SiteCombinedEventEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<SiteCombinedEvent>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteCombinedHistoryConnection = {
  readonly __typename?: "SiteCombinedHistoryConnection";
  readonly edges: ReadonlyArray<SiteCombinedEventEdge>;
  readonly nodes: ReadonlyArray<SiteCombinedEvent>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteControlOutputInput = {
  readonly name: Scalars["String"];
  readonly relayNumber: Scalars["Int"];
};

export type SiteControlSystem = Node & {
  readonly __typename?: "SiteControlSystem";
  readonly alarmPanelIntegrationOutput?: Maybe<SiteOutput>;
  readonly availableOutputModulesCount: Scalars["Int"];
  readonly canConnectRightNow?: Maybe<Scalars["Boolean"]>;
  readonly cellStatus?: Maybe<ControlSystemCellStatus>;
  readonly commType: ControlSystemCommType;
  readonly doors: ReadonlyArray<SiteDoor>;
  readonly easyConnectStatus?: Maybe<ControlSystemEasyConnectStatus>;
  readonly firmwareStatus: PanelFirmwareStatus;
  /** A percentage of the firmware update progress, if it is in progress. `null` otherwise. */
  readonly firmwareUpdateProgress?: Maybe<Scalars["Int"]>;
  readonly hasCell: Scalars["Boolean"];
  readonly hasEasyConnect: Scalars["Boolean"];
  readonly hasFailedPreProgrammingJob: Scalars["Boolean"];
  readonly hasPendingChanges: Scalars["Boolean"];
  readonly hasReplaceX1Backup: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly initialConnectionStatus: InitialConnectionStatus;
  readonly intendedUsage: SiteControlSystemType;
  readonly isBillingControlSystem: Scalars["Boolean"];
  readonly isX1: Scalars["Boolean"];
  readonly isX8: Scalars["Boolean"];
  readonly maxOutputModules: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly nickname?: Maybe<Scalars["String"]>;
  readonly onboardOutput1?: Maybe<SiteOutput>;
  readonly onboardOutput2?: Maybe<SiteOutput>;
  readonly online: Scalars["Boolean"];
  readonly outputModulesConnection: SiteOutputModulesConnection;
  readonly outputs: ReadonlyArray<SiteOutput>;
  readonly replacingPanelJobGroupId?: Maybe<Scalars["Int"]>;
  readonly serialNumber: Scalars["String"];
  readonly site?: Maybe<Site>;
  readonly softwareDate: Scalars["String"];
  readonly softwareDisplayName: Scalars["String"];
  readonly softwareVersion: Scalars["String"];
  readonly softwareVersionModifier: Scalars["String"];
  readonly statistics?: Maybe<SiteControlSystemStatistics>;
  readonly supportsOutputModules: Scalars["Boolean"];
  readonly type: X1Type;
  readonly vkSystemDisplayName: Scalars["String"];
};

export type SiteControlSystemDoorsArgs = {
  includeUnprogrammedDoors?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteControlSystemOutputModulesConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type SiteControlSystemOutputsArgs = {
  include?: InputMaybe<ReadonlyArray<SiteOutputType>>;
};

export type SiteControlSystemDoorEdge = {
  readonly __typename?: "SiteControlSystemDoorEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<SiteDoor>;
};

export type SiteControlSystemDoorsConnection = {
  readonly __typename?: "SiteControlSystemDoorsConnection";
  readonly edges: ReadonlyArray<SiteControlSystemDoorEdge>;
  readonly nodes: ReadonlyArray<SiteDoor>;
  readonly pageInfo: PageInfo;
  readonly searchCount: Scalars["Int"];
  readonly totalCount: Scalars["Int"];
};

export enum SiteControlSystemIntendedUsage {
  DOOR_ACCESS = "DOOR_ACCESS",
  ELEVATOR = "ELEVATOR",
}

export type SiteControlSystemSetupTrackedPayload =
  | InitialConnectionFailure
  | NotFoundError
  | SiteControlSystem;

export type SiteControlSystemStatistics = {
  readonly __typename?: "SiteControlSystemStatistics";
  readonly acVoltage: Scalars["Float"];
  readonly acVoltageStatus: VoltageStatus;
  readonly cellRetries?: Maybe<Scalars["Int"]>;
  readonly cellRoaming: Scalars["Boolean"];
  readonly createdAt: Scalars["String"];
  readonly currentCellSignal?: Maybe<Scalars["Int"]>;
  readonly dcVoltage: Scalars["Float"];
  readonly dcVoltageStatus: VoltageStatus;
  readonly networkRetries?: Maybe<Scalars["Int"]>;
  readonly strongestCellSignal?: Maybe<Scalars["Int"]>;
  readonly updatedAt: Scalars["String"];
  readonly weakestCellSignal?: Maybe<Scalars["Int"]>;
};

export enum SiteControlSystemType {
  DOOR_ACCESS = "DOOR_ACCESS",
  ELEVATOR = "ELEVATOR",
}

export type SiteDoor = Node & {
  readonly __typename?: "SiteDoor";
  readonly accessible: Scalars["Boolean"];
  readonly active: Scalars["Boolean"];
  readonly buzzer: Scalars["Boolean"];
  readonly connectionStatus: ConnectionStatus;
  /** **WARNING:** This is an expensive call if a site has many doors. Prefer getting control systems on parent site object and filtering results by door's panel id. */
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly doorForce: Scalars["Boolean"];
  readonly doorPropTime: Scalars["Int"];
  readonly doorSensor: Scalars["Boolean"];
  readonly events: SiteHistoryConnection;
  readonly fireExit: Scalars["Boolean"];
  readonly fireZone: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly includeInLockdown: Scalars["Boolean"];
  readonly isPublic: Scalars["Boolean"];
  readonly led: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly osdpOrWiegand: OsdpOrWiegand;
  readonly override: Scalars["Boolean"];
  readonly panelId?: Maybe<Scalars["String"]>;
  readonly realTimeStatus: Scalars["Boolean"];
  readonly requestToExit: Scalars["Boolean"];
  readonly sensorStatus: SiteDoorSensorStatus;
  /** **WARNING:** This is an expensive call if a site has many doors. Prefer getting site information from parent site object. */
  readonly site?: Maybe<Site>;
  readonly siteDoorNumber?: Maybe<Scalars["Int"]>;
  readonly status: DoorStatus;
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly tracked: Scalars["Boolean"];
  readonly unlockOnRex: Scalars["Boolean"];
};

export type SiteDoorEventsArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["ID"]>;
  doors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchTerm?: InputMaybe<Scalars["String"]>;
  sortKey?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SiteDoorSchedule = Node &
  SiteSchedule & {
    readonly __typename?: "SiteDoorSchedule";
    readonly autoUnlockSuppress?: Maybe<Scalars["Boolean"]>;
    readonly doors: ReadonlyArray<SiteDoor>;
    readonly endTime: Scalars["String"];
    readonly floors: ReadonlyArray<SiteOutput>;
    readonly friday: Scalars["Boolean"];
    readonly holidayA?: Maybe<SiteHolidayDateSchedule>;
    readonly holidayB?: Maybe<SiteHolidayDateSchedule>;
    readonly holidayC?: Maybe<SiteHolidayDateSchedule>;
    readonly id: Scalars["ID"];
    readonly monday: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly saturday: Scalars["Boolean"];
    readonly saveStatus?: Maybe<SiteDoorScheduleSaveStatus>;
    readonly startTime: Scalars["String"];
    readonly sunday: Scalars["Boolean"];
    readonly temporary?: Maybe<SiteDoorScheduleTemp>;
    readonly thursday: Scalars["Boolean"];
    readonly tuesday: Scalars["Boolean"];
    readonly wednesday: Scalars["Boolean"];
  };

export type SiteDoorScheduleDoorsArgs = {
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteDoorScheduleRemovingStatus = SiteDoorScheduleSaveStatus & {
  readonly __typename?: "SiteDoorScheduleRemovingStatus";
  readonly status: SiteDoorScheduleSaveStatusValue;
};

export type SiteDoorScheduleSaveErroredStatus = SiteDoorScheduleSaveStatus & {
  readonly __typename?: "SiteDoorScheduleSaveErroredStatus";
  readonly error: Error;
  readonly status: SiteDoorScheduleSaveStatusValue;
};

export type SiteDoorScheduleSaveStatus = {
  readonly status: SiteDoorScheduleSaveStatusValue;
};

export type SiteDoorScheduleSaveStatusResponse = {
  readonly __typename?: "SiteDoorScheduleSaveStatusResponse";
  readonly schedule: SiteDoorSchedule;
};

export enum SiteDoorScheduleSaveStatusValue {
  ERRORED = "ERRORED",
  REMOVING = "REMOVING",
  SAVED = "SAVED",
  SAVING = "SAVING",
}

export type SiteDoorScheduleSaveSucceededStatus = SiteDoorScheduleSaveStatus & {
  readonly __typename?: "SiteDoorScheduleSaveSucceededStatus";
  readonly status: SiteDoorScheduleSaveStatusValue;
};

export type SiteDoorScheduleSavingStatus = SiteDoorScheduleSaveStatus & {
  readonly __typename?: "SiteDoorScheduleSavingStatus";
  readonly status: SiteDoorScheduleSaveStatusValue;
};

export type SiteDoorScheduleTemp = {
  readonly __typename?: "SiteDoorScheduleTemp";
  readonly endDate: Scalars["Date"];
  readonly startDate: Scalars["Date"];
};

export type SiteDoorScheduleTempInput = {
  readonly endDate: Scalars["Date"];
  readonly startDate: Scalars["Date"];
};

export enum SiteDoorSensorStatus {
  BYPASSED = "BYPASSED",
  FORCED = "FORCED",
  NORMAL = "NORMAL",
  OPEN = "OPEN",
  PROPPED = "PROPPED",
  SHORT = "SHORT",
  UNKNOWN = "UNKNOWN",
}

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteFilterCombinedEventsErrorPayload = {
  readonly __typename?: "SiteFilterCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteFilterCombinedEventsPayload =
  | SiteFilterCombinedEventsErrorPayload
  | SiteFilterCombinedEventsSuccessPayload;

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteFilterCombinedEventsSuccessPayload = {
  readonly __typename?: "SiteFilterCombinedEventsSuccessPayload";
  readonly system?: Maybe<Site>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsEventPlaybackErrorPayload = {
  readonly __typename?: "SiteGetHlsEventPlaybackErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsEventPlaybackPayload =
  | SiteGetHlsEventPlaybackErrorPayload
  | SiteGetHlsEventPlaybackSuccessPayload;

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsEventPlaybackSuccessPayload = {
  readonly __typename?: "SiteGetHlsEventPlaybackSuccessPayload";
  readonly url?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsObjectErrorPayload = {
  readonly __typename?: "SiteGetHlsObjectErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsObjectPayload =
  | SiteGetHlsObjectErrorPayload
  | SiteGetHlsObjectSuccessPayload;

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteGetHlsObjectSuccessPayload = {
  readonly __typename?: "SiteGetHlsObjectSuccessPayload";
  readonly end_ts_ms?: Maybe<Scalars["Int"]>;
  readonly hls_url?: Maybe<Scalars["String"]>;
  readonly start_ts_ms?: Maybe<Scalars["Int"]>;
  readonly stream_type?: Maybe<Scalars["String"]>;
  readonly stream_url?: Maybe<Scalars["String"]>;
};

export type SiteGroup = Node & {
  readonly __typename?: "SiteGroup";
  readonly areas: ReadonlyArray<Maybe<Area>>;
  readonly authenticationType: X1Authorization;
  readonly disarm: Scalars["Boolean"];
  readonly doors: ReadonlyArray<SiteDoor>;
  readonly floors: ReadonlyArray<SiteOutput>;
  readonly id: Scalars["ID"];
  readonly lockdownOverride: Scalars["Boolean"];
  readonly managerFirst?: Maybe<ManagerFirst>;
  readonly maxTimesCount: Scalars["Int"];
  readonly name: Scalars["String"];
  readonly persons: ReadonlyArray<Person>;
  readonly saveStatus?: Maybe<SiteGroupSaveStatus>;
  readonly swipeToArm: SwipeToArm;
  readonly times: ReadonlyArray<SiteGroupSchedule>;
};

export type SiteGroupDoorsArgs = {
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteGroupRemovingStatus = SiteGroupSaveStatus & {
  readonly __typename?: "SiteGroupRemovingStatus";
  readonly status: SiteGroupSaveStatusValue;
};

export type SiteGroupSaveErroredStatus = SiteGroupSaveStatus & {
  readonly __typename?: "SiteGroupSaveErroredStatus";
  readonly error: Error;
  readonly status: SiteGroupSaveStatusValue;
};

export type SiteGroupSaveStatus = {
  readonly status: SiteGroupSaveStatusValue;
};

export type SiteGroupSaveStatusResponse = {
  readonly __typename?: "SiteGroupSaveStatusResponse";
  readonly group: SiteGroup;
};

export enum SiteGroupSaveStatusValue {
  ERRORED = "ERRORED",
  REMOVING = "REMOVING",
  SAVED = "SAVED",
  SAVING = "SAVING",
}

export type SiteGroupSaveSucceededStatus = SiteGroupSaveStatus & {
  readonly __typename?: "SiteGroupSaveSucceededStatus";
  readonly status: SiteGroupSaveStatusValue;
};

export type SiteGroupSavingStatus = SiteGroupSaveStatus & {
  readonly __typename?: "SiteGroupSavingStatus";
  readonly status: SiteGroupSaveStatusValue;
};

export type SiteGroupSchedule = Node &
  SiteSchedule & {
    readonly __typename?: "SiteGroupSchedule";
    readonly endTime: Scalars["String"];
    readonly friday: Scalars["Boolean"];
    readonly holidayA?: Maybe<SiteHolidayDateSchedule>;
    readonly holidayB?: Maybe<SiteHolidayDateSchedule>;
    readonly holidayC?: Maybe<SiteHolidayDateSchedule>;
    readonly id: Scalars["ID"];
    readonly monday: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly saturday: Scalars["Boolean"];
    readonly startTime: Scalars["String"];
    readonly sunday: Scalars["Boolean"];
    readonly thursday: Scalars["Boolean"];
    readonly tuesday: Scalars["Boolean"];
    readonly wednesday: Scalars["Boolean"];
  };

export type SiteGroupTimeInput = {
  readonly endTime: Scalars["String"];
  readonly friday: Scalars["Boolean"];
  readonly holidayA?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayB?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayC?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly monday: Scalars["Boolean"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type SiteHistoryConnection = {
  readonly __typename?: "SiteHistoryConnection";
  readonly edges: ReadonlyArray<SiteHistoryEventEdge>;
  readonly nodes: ReadonlyArray<SiteHistoryEvent>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteHistoryEvent = Event &
  Node & {
    readonly __typename?: "SiteHistoryEvent";
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly doorNumber?: Maybe<Scalars["Int"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly resolved: Scalars["Boolean"];
    readonly subcategory: SupportedEventSubcategoryName;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

export type SiteHistoryEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export type SiteHistoryEventEdge = {
  readonly __typename?: "SiteHistoryEventEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: SiteHistoryEvent;
};

export type SiteHolidayDateResponse = {
  readonly __typename?: "SiteHolidayDateResponse";
  readonly holidayDate: HolidayDate;
};

export type SiteHolidayDateSchedule = {
  readonly __typename?: "SiteHolidayDateSchedule";
  readonly endTime: Scalars["String"];
  readonly startTime: Scalars["String"];
};

export type SiteHolidayDateScheduleInput = {
  readonly endTime: Scalars["String"];
  readonly startTime: Scalars["String"];
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteLoadMoreCombinedEventsErrorPayload = {
  readonly __typename?: "SiteLoadMoreCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteLoadMoreCombinedEventsPayload =
  | SiteLoadMoreCombinedEventsErrorPayload
  | SiteLoadMoreCombinedEventsSuccessPayload;

/**
 * The CombinedEvents API uses offset pagination, while Relay only allows cursor-based pagination. Rather than trying to use a pagination fragment to load more, we use this mutation to get the next page of events and add them to the store.
 *   @deprecated (reason: "Replaced with CombinedEvent schema")
 */
export type SiteLoadMoreCombinedEventsSuccessPayload = {
  readonly __typename?: "SiteLoadMoreCombinedEventsSuccessPayload";
  readonly system?: Maybe<Site>;
};

export type SiteNotification = {
  readonly eventCategory: SupportedEventTypeName;
  readonly eventSubcategory: SupportedEventSubcategoryName;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly recipients: ReadonlyArray<NotificationRecipient>;
  readonly schedule: SiteNotificationSchedule;
};

export type SiteNotificationSchedule = {
  readonly __typename?: "SiteNotificationSchedule";
  readonly endTime: Scalars["String"];
  readonly friday: Scalars["Boolean"];
  readonly monday: Scalars["Boolean"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  /** Each of these strings are in the format `"0000"`-`"2359"` */
  readonly sunday: Scalars["Boolean"];
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type SiteNotificationWithDoors = Node &
  SiteNotification & {
    readonly __typename?: "SiteNotificationWithDoors";
    /**
     * `null` - do not filter this category
     * `[]` - do not include any of this category
     */
    readonly doors?: Maybe<ReadonlyArray<SiteDoor>>;
    readonly eventCategory: SupportedEventTypeName;
    readonly eventSubcategory: SupportedEventSubcategoryName;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly recipients: ReadonlyArray<NotificationRecipient>;
    readonly schedule: SiteNotificationSchedule;
  };

export type SiteNotificationWithDoorsDoorsArgs = {
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteNotificationWithDoorsAndPersons = Node &
  SiteNotification & {
    readonly __typename?: "SiteNotificationWithDoorsAndPersons";
    /**
     * `null` - do not filter this category
     * `[]` - do not include any of this category
     */
    readonly doors?: Maybe<ReadonlyArray<SiteDoor>>;
    readonly eventCategory: SupportedEventTypeName;
    readonly eventSubcategory: SupportedEventSubcategoryName;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    /**
     * `null` - do not filter this category
     * `[]` - do not include any of this category
     */
    readonly persons?: Maybe<ReadonlyArray<CustomerPerson>>;
    readonly recipients: ReadonlyArray<NotificationRecipient>;
    readonly schedule: SiteNotificationSchedule;
  };

export type SiteNotificationWithDoorsAndPersonsDoorsArgs = {
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteNotificationWithNothing = Node &
  SiteNotification & {
    readonly __typename?: "SiteNotificationWithNothing";
    readonly eventCategory: SupportedEventTypeName;
    readonly eventSubcategory: SupportedEventSubcategoryName;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly recipients: ReadonlyArray<NotificationRecipient>;
    readonly schedule: SiteNotificationSchedule;
  };

export type SiteNotificationWithPersons = Node &
  SiteNotification & {
    readonly __typename?: "SiteNotificationWithPersons";
    readonly eventCategory: SupportedEventTypeName;
    readonly eventSubcategory: SupportedEventSubcategoryName;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    /**
     * `null` - do not filter this category
     * `[]` - do not include any of this category
     */
    readonly persons?: Maybe<ReadonlyArray<CustomerPerson>>;
    readonly recipients: ReadonlyArray<NotificationRecipient>;
    readonly schedule: SiteNotificationSchedule;
  };

export type SiteOutput = Node & {
  readonly __typename?: "SiteOutput";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly id: Scalars["ID"];
  readonly isAvailableForAlarmIntegration: Scalars["Boolean"];
  readonly isOnboardOutput1: Scalars["Boolean"];
  readonly isOnboardOutput2: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly outputIntendedUsage: SiteOutputIntendedUsage;
  readonly panelId?: Maybe<Scalars["String"]>;
  readonly relayNumber?: Maybe<Scalars["Int"]>;
  readonly type: SiteOutputType;
};

export enum SiteOutputIntendedUsage {
  ALARM = "ALARM",
  GENERIC = "GENERIC",
}

export type SiteOutputModule = Node & {
  readonly __typename?: "SiteOutputModule";
  readonly address: Scalars["Int"];
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly id: Scalars["ID"];
  readonly intendedUsage: SiteOutputModuleIntendedUsage;
  readonly name: Scalars["String"];
  readonly outputsConnection: SiteOutputModuleOutputsConnection;
};

export type SiteOutputModuleOutputsConnectionArgs = {
  after?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export enum SiteOutputModuleIntendedUsage {
  FLOORS = "FLOORS",
  OUTPUTS = "OUTPUTS",
}

export type SiteOutputModuleOutputsConnection = {
  readonly __typename?: "SiteOutputModuleOutputsConnection";
  readonly edges: ReadonlyArray<SiteOutputModuleOutputsConnectionEdge>;
  readonly nodes: ReadonlyArray<SiteOutput>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteOutputModuleOutputsConnectionEdge = {
  readonly __typename?: "SiteOutputModuleOutputsConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: SiteOutput;
};

export type SiteOutputModulesConnection = {
  readonly __typename?: "SiteOutputModulesConnection";
  readonly edges: ReadonlyArray<SiteOutputModulesConnectionEdge>;
  readonly nodes: ReadonlyArray<SiteOutputModule>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteOutputModulesConnectionEdge = {
  readonly __typename?: "SiteOutputModulesConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: SiteOutputModule;
};

export enum SiteOutputType {
  FLOORS = "FLOORS",
  OUTPUTS = "OUTPUTS",
}

export type SiteOutputsConnection = {
  readonly __typename?: "SiteOutputsConnection";
  readonly edges: ReadonlyArray<SiteOutputsConnectionEdge>;
  readonly nodes: ReadonlyArray<SiteOutput>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteOutputsConnectionEdge = {
  readonly __typename?: "SiteOutputsConnectionEdge";
  readonly cursor: Scalars["ID"];
  readonly node: SiteOutput;
};

export type SitePersonEdge = {
  readonly __typename?: "SitePersonEdge";
  readonly cursor: Scalars["ID"];
  readonly node: CustomerPerson;
};

export enum SitePersonMutationFailedReason {
  EMAIL_ALREADY_IN_USE = "EMAIL_ALREADY_IN_USE",
  INTERNAL_NUMBER_ALREADY_TAKEN = "INTERNAL_NUMBER_ALREADY_TAKEN",
}

export type SitePersonTemporaryInput = {
  readonly endDate: Scalars["Date"];
  readonly startDate: Scalars["Date"];
};

export type SitePersonsConnection = {
  readonly __typename?: "SitePersonsConnection";
  readonly edges: ReadonlyArray<SitePersonEdge>;
  readonly maxGroupsPerUser: Scalars["Int"];
  readonly nodes: ReadonlyArray<CustomerPerson>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteRefreshCombinedEventsErrorPayload = {
  readonly __typename?: "SiteRefreshCombinedEventsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteRefreshCombinedEventsPayload =
  | SiteRefreshCombinedEventsErrorPayload
  | SiteRefreshCombinedEventsSuccessPayload;

/** @deprecated (reason: "Replaced with CombinedEvent schema") */
export type SiteRefreshCombinedEventsSuccessPayload = {
  readonly __typename?: "SiteRefreshCombinedEventsSuccessPayload";
  readonly system?: Maybe<Site>;
};

export type SiteReport = Node & {
  readonly __typename?: "SiteReport";
  readonly filters: SiteReportFilters;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly schedule?: Maybe<SiteReportSchedule>;
};

export type SiteReportEdge = {
  readonly __typename?: "SiteReportEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: SiteReport;
};

export type SiteReportEvent = Event &
  Node & {
    readonly __typename?: "SiteReportEvent";
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly doorName?: Maybe<Scalars["String"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly subcategory: SupportedEventSubcategoryName;
    readonly userName?: Maybe<Scalars["String"]>;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

export type SiteReportEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export type SiteReportEventEdge = {
  readonly __typename?: "SiteReportEventEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node: SiteReportEvent;
};

export enum SiteReportEventSubcategory {
  ACCESS_GRANTED = "ACCESS_GRANTED",
  AC_POWER_FAILURE = "AC_POWER_FAILURE",
  AC_POWER_RESTORED = "AC_POWER_RESTORED",
  CHECKIN_RESTORED_CELL = "CHECKIN_RESTORED_CELL",
  CHECKIN_RESTORED_NETWORK = "CHECKIN_RESTORED_NETWORK",
  DOOR_FORCED_OPEN = "DOOR_FORCED_OPEN",
  DOOR_PROPPED = "DOOR_PROPPED",
  FAILED_TO_EXIT = "FAILED_TO_EXIT",
  FIRE = "FIRE",
  INACTIVE_CODE = "INACTIVE_CODE",
  INVALID_AREA = "INVALID_AREA",
  INVALID_CODE = "INVALID_CODE",
  INVALID_LEVEL = "INVALID_LEVEL",
  INVALID_TIME = "INVALID_TIME",
  LOCKDOWN = "LOCKDOWN",
  LOCKDOWN_RESET = "LOCKDOWN_RESET",
  LOCKED = "LOCKED",
  LOW_BATTERY = "LOW_BATTERY",
  MISSED_CHECKIN_CELL = "MISSED_CHECKIN_CELL",
  MISSED_CHECKIN_NETWORK = "MISSED_CHECKIN_NETWORK",
  PANIC = "PANIC",
  UNLOCKED = "UNLOCKED",
  ZONE_CLOSED = "ZONE_CLOSED",
  ZONE_OPENED = "ZONE_OPENED",
}

export enum SiteReportEventType {
  ALARMS = "ALARMS",
  ALL = "ALL",
  DOOR_ACCESS = "DOOR_ACCESS",
  DOOR_STATUS = "DOOR_STATUS",
  OUTPUT_STATUS = "OUTPUT_STATUS",
  TROUBLES = "TROUBLES",
}

export type SiteReportEventsConnection = {
  readonly __typename?: "SiteReportEventsConnection";
  readonly edges: ReadonlyArray<SiteReportEventEdge>;
  readonly nodes: ReadonlyArray<SiteReportEvent>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteReportFilters = {
  readonly __typename?: "SiteReportFilters";
  readonly doors?: Maybe<ReadonlyArray<SiteDoor>>;
  /** Only used for CUSTOM timeFrame */
  readonly endDate?: Maybe<Scalars["DateTime"]>;
  readonly eventTypes: ReadonlyArray<SiteReportEventType>;
  readonly persons?: Maybe<ReadonlyArray<CustomerPerson>>;
  /** Only used for CUSTOM timeFrame */
  readonly startDate?: Maybe<Scalars["DateTime"]>;
  readonly subcategories?: Maybe<
    ReadonlyArray<Maybe<SiteReportEventSubcategory>>
  >;
  readonly timeFrame: ReportTimeFrame;
};

export type SiteReportFiltersDoorsArgs = {
  performant?: InputMaybe<Scalars["Boolean"]>;
};

export type SiteReportFiltersInput = {
  readonly doors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  /** Only used for CUSTOM timeFrame */
  readonly endDate?: InputMaybe<Scalars["DateTime"]>;
  readonly eventTypes: ReadonlyArray<SiteReportEventType>;
  /** Only used for CUSTOM timeFrame */
  readonly startDate?: InputMaybe<Scalars["DateTime"]>;
  readonly subcategories?: InputMaybe<
    ReadonlyArray<SiteReportEventSubcategory>
  >;
  readonly timeFrame: ReportTimeFrame;
  readonly users?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
};

export type SiteReportSchedule = {
  readonly __typename?: "SiteReportSchedule";
  readonly cronExpression: Scalars["String"];
  readonly emailList: ReadonlyArray<Scalars["String"]>;
  readonly format: ScheduledReportFormat;
  readonly headerMap: ReadonlyArray<SavedReportHeaderMapItem>;
  readonly timeZone: TimeZone;
};

export type SiteReportScheduleInput = {
  readonly cronExpression: Scalars["String"];
  readonly emailList: ReadonlyArray<Scalars["String"]>;
  readonly format: ScheduledReportFormat;
  readonly timeZone: TimeZone;
};

export enum SiteReportSortKey {
  NAME = "NAME",
}

export type SiteReportsConnection = {
  readonly __typename?: "SiteReportsConnection";
  readonly edges: ReadonlyArray<SiteReportEdge>;
  readonly nodes: ReadonlyArray<SiteReport>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type SiteReportsSortInput = {
  readonly keys: ReadonlyArray<SiteReportSortKey>;
  readonly order?: InputMaybe<SortOrder>;
};

export type SiteSchedule = {
  readonly endTime: Scalars["String"];
  readonly friday: Scalars["Boolean"];
  readonly holidayA?: Maybe<SiteHolidayDateSchedule>;
  readonly holidayB?: Maybe<SiteHolidayDateSchedule>;
  readonly holidayC?: Maybe<SiteHolidayDateSchedule>;
  readonly id: Scalars["ID"];
  readonly monday: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type SiteUserPermissions = {
  readonly __typename?: "SiteUserPermissions";
  readonly doorLockUnlock: Scalars["Boolean"];
  readonly groups: Scalars["Boolean"];
  readonly lockdown: Scalars["Boolean"];
  readonly lockdownReset: Scalars["Boolean"];
  readonly notifications: Scalars["Boolean"];
  readonly reports: Scalars["Boolean"];
  readonly rules: Scalars["Boolean"];
  readonly schedules: Scalars["Boolean"];
  readonly users: Scalars["Boolean"];
};

export type SiteVideoIntegrations = {
  readonly digitalWatchdogSpectrumEnabled: Scalars["Boolean"];
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly hanwhaWaveEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly hikvisionDoorbellEnabled: Scalars["Boolean"];
  readonly hikvisionNvrEnabled: Scalars["Boolean"];
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly securecomNvrEnabled: Scalars["Boolean"];
  readonly videoEnabled: Scalars["Boolean"];
};

export type SomeControlSystemsHaveTooManyDoorsError = Error & {
  readonly __typename?: "SomeControlSystemsHaveTooManyDoorsError";
  readonly controlSystemSerialNumbers: ReadonlyArray<Scalars["String"]>;
  readonly type?: Maybe<ErrorType>;
};

export type SomeDoorsDidNotGetScheduleError = Error & {
  readonly __typename?: "SomeDoorsDidNotGetScheduleError";
  readonly doorSchedule: SiteDoorSchedule;
  readonly type: ErrorType;
};

export type SortInput = {
  readonly keys: ReadonlyArray<Scalars["String"]>;
  readonly order?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export type SsoInput = {
  readonly callback?: InputMaybe<Scalars["String"]>;
  readonly client_id?: InputMaybe<Scalars["String"]>;
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly pkce_code?: InputMaybe<Scalars["String"]>;
};

export type StandardEvent = Event &
  Node & {
    readonly __typename?: "StandardEvent";
    readonly animalDetected?: Maybe<Scalars["Boolean"]>;
    readonly cameraNumber?: Maybe<Scalars["Int"]>;
    readonly category: SupportedEventTypeName;
    readonly createdAt: Scalars["DateTime"];
    readonly databaseId: Scalars["String"];
    readonly deviceNumber?: Maybe<Scalars["Int"]>;
    readonly eventAt: Scalars["DateTime"];
    readonly eventCorrelationId?: Maybe<Scalars["BigInt64"]>;
    readonly eventSource: EventSourceType;
    readonly externalActionNumber?: Maybe<Scalars["Int"]>;
    readonly id: Scalars["ID"];
    readonly includeClips?: Maybe<Scalars["Boolean"]>;
    readonly isDetectionWithoutPlayback?: Maybe<Scalars["Boolean"]>;
    readonly message: Scalars["String"];
    readonly motionDetected?: Maybe<Scalars["Boolean"]>;
    readonly objectDetected?: Maybe<Scalars["Boolean"]>;
    readonly packageDetected?: Maybe<Scalars["Boolean"]>;
    readonly panelId: Scalars["Int"];
    readonly panelTime: Scalars["String"];
    readonly personDetected?: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use photoUrls instead */
    readonly photo?: Maybe<Scalars["String"]>;
    readonly photoUrls?: Maybe<EventPhotoUrls>;
    readonly subcategory: SupportedEventSubcategoryName;
    readonly vehicleDetected?: Maybe<Scalars["Boolean"]>;
    readonly wealth?: Maybe<WealthAttributeTypes>;
  };

export type StandardEventPhotoArgs = {
  size?: InputMaybe<EventPhotoSize>;
};

export type StatusListDisplay = Node & {
  readonly __typename?: "StatusListDisplay";
  readonly auxiliary1ZoneKeypads: Scalars["String"];
  readonly auxiliary2ZoneKeypads: Scalars["String"];
  readonly burglaryZoneKeypads: Scalars["String"];
  readonly carbonMonoxideZoneKeypads: Scalars["String"];
  readonly commPathTrouble: CommPathTrouble;
  readonly emergencyZoneKeypads: Scalars["String"];
  readonly fireZoneKeypads: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly panicZoneKeypads: Scalars["String"];
  readonly supervisoryZoneKeypads: Scalars["String"];
  readonly supportsCarbonMonoxideZoneKeypads: Scalars["Boolean"];
  readonly systemTroubleStatusMonitors: Scalars["String"];
};

export type StatusListDisplayInput = {
  readonly auxiliary1ZoneKeypads: Scalars["String"];
  readonly auxiliary2ZoneKeypads: Scalars["String"];
  readonly burglaryZoneKeypads: Scalars["String"];
  readonly carbonMonoxideZoneKeypads: Scalars["String"];
  readonly commPathTrouble: CommPathTrouble;
  readonly emergencyZoneKeypads: Scalars["String"];
  readonly fireZoneKeypads: Scalars["String"];
  readonly panicZoneKeypads: Scalars["String"];
  readonly supervisoryZoneKeypads: Scalars["String"];
  readonly systemTroubleStatusMonitors: Scalars["String"];
};

export type StillWorkingError = Error & {
  readonly __typename?: "StillWorkingError";
  readonly type?: Maybe<ErrorType>;
};

export type StopDigitalWatchdogCameraStreamPayload = {
  readonly __typename?: "StopDigitalWatchdogCameraStreamPayload";
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly hlsUrl: Scalars["URL"];
  readonly token: Scalars["String"];
};

export type StopEagleEyeBridgeStreamPayload = {
  readonly __typename?: "StopEagleEyeBridgeStreamPayload";
  readonly hlsUrl: Scalars["URL"];
  readonly token: Scalars["String"];
  readonly videoChannel?: Maybe<EagleEyeBridgeVideoChannel>;
};

export type StopHikvisionNvrStreamPayload = {
  readonly __typename?: "StopHikvisionNvrStreamPayload";
  readonly hlsUrl: Scalars["URL"];
  readonly token: Scalars["String"];
  readonly videoChannel?: Maybe<HikvisionNvrVideoChannel>;
};

export type StopSecureComNvrStreamPayload = {
  readonly __typename?: "StopSecureComNvrStreamPayload";
  readonly hlsUrl: Scalars["URL"];
  readonly token: Scalars["String"];
  readonly videoChannel?: Maybe<SecureComNvrVideoChannel>;
};

export enum StreamTypeName {
  AAC = "AAC",
  DASH = "DASH",
  HLS = "HLS",
  MJPEG = "MJPEG",
  MP4 = "MP4",
  RTSP = "RTSP",
  TS = "TS",
  UNSUPPORTED = "UNSUPPORTED",
  WEB_RTC = "WEB_RTC",
}

/**
 * WARNING: Do not use subscriptions, they cause memory leaks and crashes in production see:
 * https://github.com/apollographql/graphql-subscriptions/issues/143
 * If you need subscription-like behavior, use a frontend polling model instead
 */
export type Subscription = {
  readonly __typename?: "Subscription";
  /** @deprecated Subscriptions have a memory leak. Use polling instead. */
  readonly metaGraphQLNetworkLogs: GraphQlLogInfo;
  readonly noop?: Maybe<Scalars["String"]>;
};

export type SupervisorPerson = Node &
  Person & {
    readonly __typename?: "SupervisorPerson";
    readonly appUser?: Maybe<SupervisorUser>;
    readonly appUsers: ReadonlyArray<User>;
    readonly emailAddress: Scalars["String"];
    readonly firstName: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly idpPersonStatus: IdpPersonStatus;
    readonly isMe: Scalars["Boolean"];
    readonly lastName: Scalars["String"];
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly visibleLogin?: Maybe<Scalars["String"]>;
  };

export enum SupervisorRole {
  ADMIN = "ADMIN",
  OPERATOR = "OPERATOR",
  TECHNICIAN = "TECHNICIAN",
}

export type SupervisorUser = Node &
  User & {
    readonly __typename?: "SupervisorUser";
    readonly DealerPersonnelCan: DealerPersonnelCan;
    readonly accessibleId: Scalars["Int"];
    readonly accessibleType: AccessibleType;
    readonly canUploadFiles: Scalars["Boolean"];
    readonly email: Scalars["EmailAddress"];
    readonly firstName: Scalars["String"];
    readonly hidden: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly lastName: Scalars["String"];
    readonly lastSignInAt?: Maybe<Scalars["DateTime"]>;
    readonly lockedAt?: Maybe<Scalars["DateTime"]>;
    readonly person: Person;
    readonly phoneNumber?: Maybe<Scalars["String"]>;
    readonly role: SupervisorRole;
    readonly ssoOnly?: Maybe<Scalars["Boolean"]>;
    readonly twoFactorSettings?: Maybe<TwoFactorSettings>;
  };

export type SupportedEventSubcategory = {
  readonly __typename?: "SupportedEventSubcategory";
  readonly areas: Scalars["Boolean"];
  readonly doorProppedZones: Scalars["Boolean"];
  readonly doors: Scalars["Boolean"];
  readonly name: SupportedEventSubcategoryName;
  readonly sensorActivityZones: Scalars["Boolean"];
  readonly userActions: Scalars["Boolean"];
  readonly users: Scalars["Boolean"];
  readonly zones: Scalars["Boolean"];
  readonly zwaveDevices: Scalars["Boolean"];
};

export enum SupportedEventSubcategoryName {
  /** DOOR_ACCESS */
  ACCESS_GRANTED = "ACCESS_GRANTED",
  AC_POWER_FAILURE = "AC_POWER_FAILURE",
  AC_POWER_RESTORED = "AC_POWER_RESTORED",
  ALARM = "ALARM",
  ALARM_CANCELLED = "ALARM_CANCELLED",
  ALARM_VERIFIED = "ALARM_VERIFIED",
  /** ARMING */
  ALL_AREAS_ARMED = "ALL_AREAS_ARMED",
  ALL_AREAS_DISARMED = "ALL_AREAS_DISARMED",
  ALL_OTHER_ZONE = "ALL_OTHER_ZONE",
  AMBUSH = "AMBUSH",
  /** OPEN_EYE_EVENT */
  APPEARING_ANALYTIC_STARTED = "APPEARING_ANALYTIC_STARTED",
  /** PROGRAMMING_CHANGE */
  AREA = "AREA",
  AREA_SCHEDULE = "AREA_SCHEDULE",
  ARMED_ALL = "ARMED_ALL",
  ARMED_AREA = "ARMED_AREA",
  ARMED_AWAY = "ARMED_AWAY",
  ARMED_HOME = "ARMED_HOME",
  ARMED_PERIMETER = "ARMED_PERIMETER",
  ARMED_SLEEP = "ARMED_SLEEP",
  ARMED_STAY = "ARMED_STAY",
  ARM_DISARM_INACTIVITY = "ARM_DISARM_INACTIVITY",
  AUDIO_DETECTION_ANALYTIC_STARTED = "AUDIO_DETECTION_ANALYTIC_STARTED",
  AUX_POWER_RESTORE = "AUX_POWER_RESTORE",
  AUX_POWER_TROUBLE = "AUX_POWER_TROUBLE",
  /** ALARMS */
  BURGLARY = "BURGLARY",
  CAMECT_CAMERA_OFFLINE = "CAMECT_CAMERA_OFFLINE",
  CAMECT_CAMERA_ONLINE = "CAMECT_CAMERA_ONLINE",
  /** CAMECT */
  CAMECT_OBJECT_DETECTED = "CAMECT_OBJECT_DETECTED",
  CAMECT_VIDEO_ACTION = "CAMECT_VIDEO_ACTION",
  CARBON = "CARBON",
  CHECKIN_RESTORED_CELL = "CHECKIN_RESTORED_CELL",
  CHECKIN_RESTORED_NETWORK = "CHECKIN_RESTORED_NETWORK",
  CLEARED = "CLEARED",
  COMM_TEST_FINAL_RESULT = "COMM_TEST_FINAL_RESULT",
  COMM_TEST_STATUS_UPDATE = "COMM_TEST_STATUS_UPDATE",
  CUSTOM_ACTION_ACTIVATED = "CUSTOM_ACTION_ACTIVATED",
  CUSTOM_ACTION_DEACTIVATED = "CUSTOM_ACTION_DEACTIVATED",
  /** SYSTEM_MESSAGE */
  DAILY_REPORT = "DAILY_REPORT",
  DC_POWER_RESTORE = "DC_POWER_RESTORE",
  DC_POWER_TROUBLE = "DC_POWER_TROUBLE",
  DEVICE = "DEVICE",
  /** X1_DEVICE_MESSAGE */
  DEVICE_MISSING = "DEVICE_MISSING",
  DEVICE_RESTORE = "DEVICE_RESTORE",
  DISARMED = "DISARMED",
  DOOR_FORCED_OPEN = "DOOR_FORCED_OPEN",
  DOOR_PROPPED = "DOOR_PROPPED",
  DOOR_SCHEDULE = "DOOR_SCHEDULE",
  EARLY_MORNING_AMBUSH = "EARLY_MORNING_AMBUSH",
  EARLY_TO_CLOSE = "EARLY_TO_CLOSE",
  EMERGENCY = "EMERGENCY",
  ENTERING_ANALYTIC_STARTED = "ENTERING_ANALYTIC_STARTED",
  EXITING_ANALYTIC_STARTED = "EXITING_ANALYTIC_STARTED",
  EXIT_ZONE_CLOSED = "EXIT_ZONE_CLOSED",
  /** SENSOR_ACTIVITY */
  EXIT_ZONE_OPEN = "EXIT_ZONE_OPEN",
  EXPLOSION_ANALYTIC_STARTED = "EXPLOSION_ANALYTIC_STARTED",
  FACE_DETECTION_ANALYTIC_STARTED = "FACE_DETECTION_ANALYTIC_STARTED",
  FAILED_TO_EXIT = "FAILED_TO_EXIT",
  FAVORITE = "FAVORITE",
  FAVORITE_SCHEDULE = "FAVORITE_SCHEDULE",
  FIRE = "FIRE",
  /** REMINDERS */
  FIRE_INSPECTION_COMPLETE = "FIRE_INSPECTION_COMPLETE",
  FIRE_INSPECTION_REMINDER = "FIRE_INSPECTION_REMINDER",
  /** GENERIC_VIDEO */
  GENERIC_VIDEO_CLIP_UPLOAD = "GENERIC_VIDEO_CLIP_UPLOAD",
  GLASS_BREAK_ANALYTIC_STARTED = "GLASS_BREAK_ANALYTIC_STARTED",
  GROUND_FAULT_RESTORE = "GROUND_FAULT_RESTORE",
  GROUND_FAULT_TROUBLE = "GROUND_FAULT_TROUBLE",
  GUNSHOT_ANALYTIC_STARTED = "GUNSHOT_ANALYTIC_STARTED",
  HOURLY_CELL_TOWER_INFO = "HOURLY_CELL_TOWER_INFO",
  IENSO_CAMERA_OFFLINE = "IENSO_CAMERA_OFFLINE",
  IENSO_CAMERA_ONLINE = "IENSO_CAMERA_ONLINE",
  /** IENSO */
  IENSO_OBJECT_DETECTED = "IENSO_OBJECT_DETECTED",
  IENSO_VIDEO_ACTION = "IENSO_VIDEO_ACTION",
  INACTIVE_CODE = "INACTIVE_CODE",
  /** LOCKDOWN */
  INITIATED = "INITIATED",
  INTRUSION_ANALYTIC_STARTED = "INTRUSION_ANALYTIC_STARTED",
  INVALID_AREA = "INVALID_AREA",
  INVALID_CODE = "INVALID_CODE",
  INVALID_LEVEL = "INVALID_LEVEL",
  INVALID_TIME = "INVALID_TIME",
  KEYFOB = "KEYFOB",
  /** KEYPAD */
  KEYPAD_EVENT = "KEYPAD_EVENT",
  LATE_TO_CLOSE = "LATE_TO_CLOSE",
  LATE_TO_OPEN = "LATE_TO_OPEN",
  /** ZWAVE_STATUS_MESSAGE */
  LOCK = "LOCK",
  LOCKDOWN = "LOCKDOWN",
  LOCKDOWN_RESET = "LOCKDOWN_RESET",
  LOCKED = "LOCKED",
  LOITERING_ANALYTIC_STARTED = "LOITERING_ANALYTIC_STARTED",
  LOW_BATTERY = "LOW_BATTERY",
  MALMOSET_MANUAL_RECORD = "MALMOSET_MANUAL_RECORD",
  MALMOSET_MOTION_DETECTED = "MALMOSET_MOTION_DETECTED",
  /** MALMOSET */
  MALMOSET_OBJECT_DETECTED = "MALMOSET_OBJECT_DETECTED",
  MISSED_CHECKIN_CELL = "MISSED_CHECKIN_CELL",
  MISSED_CHECKIN_NETWORK = "MISSED_CHECKIN_NETWORK",
  MODEM_REPORT = "MODEM_REPORT",
  NAC_RESTORE = "NAC_RESTORE",
  NAC_TROUBLE = "NAC_TROUBLE",
  OUTPUT = "OUTPUT",
  OUTPUT_GROUP = "OUTPUT_GROUP",
  OUTPUT_OPTIONS = "OUTPUT_OPTIONS",
  OUTPUT_SCHEDULE = "OUTPUT_SCHEDULE",
  OUTPUT_SET_TO_MOMENTARY = "OUTPUT_SET_TO_MOMENTARY",
  OUTPUT_SET_TO_PULSE = "OUTPUT_SET_TO_PULSE",
  OUTPUT_SET_TO_TEMPORAL_3 = "OUTPUT_SET_TO_TEMPORAL_3",
  OUTPUT_TURNED_OFF = "OUTPUT_TURNED_OFF",
  OUTPUT_TURNED_ON = "OUTPUT_TURNED_ON",
  /** PANEL */
  PANEL_RESTART = "PANEL_RESTART",
  PANIC = "PANIC",
  PASSING_ANALYTIC_STARTED = "PASSING_ANALYTIC_STARTED",
  PERMANENT_SCHEDULE = "PERMANENT_SCHEDULE",
  PERSON_DETECTION_ANALYTIC_STARTED = "PERSON_DETECTION_ANALYTIC_STARTED",
  PRIMARY_DEVICE = "PRIMARY_DEVICE",
  PROFILE = "PROFILE",
  REMOTE_FILE_TRANSFER_COMPLETE = "REMOTE_FILE_TRANSFER_COMPLETE",
  SCREAM_ANALYTIC_STARTED = "SCREAM_ANALYTIC_STARTED",
  SOME_AREAS_ARMED = "SOME_AREAS_ARMED",
  SOME_AREAS_DISARMED = "SOME_AREAS_DISARMED",
  STANDBY_BATTERY_RESTORED = "STANDBY_BATTERY_RESTORED",
  /** ENTRY_DELAY_START */
  START = "START",
  SUNELL_MANUAL_RECORD = "SUNELL_MANUAL_RECORD",
  SUNELL_MOTION_DETECTED = "SUNELL_MOTION_DETECTED",
  /** SUNELL */
  SUNELL_OBJECT_DETECTED = "SUNELL_OBJECT_DETECTED",
  SUNELL_RING = "SUNELL_RING",
  SUNELL_TAMPER = "SUNELL_TAMPER",
  SUPERVISORY = "SUPERVISORY",
  SWAP_IMEISIM = "SWAP_IMEISIM",
  SWITCH = "SWITCH",
  SYSTEM_AREA_INFORMATION = "SYSTEM_AREA_INFORMATION",
  SYSTEM_FIRMWARE_VERSION = "SYSTEM_FIRMWARE_VERSION",
  SYSTEM_INACTIVITY = "SYSTEM_INACTIVITY",
  SYSTEM_TEST = "SYSTEM_TEST",
  TAMPER = "TAMPER",
  TAMPER_ANALYTIC_STARTED = "TAMPER_ANALYTIC_STARTED",
  THERMOSTAT = "THERMOSTAT",
  TIME_SCHEDULE = "TIME_SCHEDULE",
  /** TRAFFIC_COUNT */
  TRAFFIC_COUNT = "TRAFFIC_COUNT",
  UNIVIEW_MANUAL_RECORD = "UNIVIEW_MANUAL_RECORD",
  UNIVIEW_MOTION_DETECTED = "UNIVIEW_MOTION_DETECTED",
  /** UNIVIEW */
  UNIVIEW_OBJECT_DETECTED = "UNIVIEW_OBJECT_DETECTED",
  /** UNKNOWN_EVENT_TYPE */
  UNKNOWN_EVENT_SUBCATEGORY = "UNKNOWN_EVENT_SUBCATEGORY",
  /** REAL_TIME_STATUS */
  UNLOCKED = "UNLOCKED",
  USER = "USER",
  /** USER_ACTION */
  USER_ACTION = "USER_ACTION",
  USER_INITIATED_CHECK_IN = "USER_INITIATED_CHECK_IN",
  USER_INITIATED_INACTIVITY = "USER_INITIATED_INACTIVITY",
  VEHICLE_DETECTION_ANALYTIC_STARTED = "VEHICLE_DETECTION_ANALYTIC_STARTED",
  WALK_TEST_WIRELESS_CHECK_IN = "WALK_TEST_WIRELESS_CHECK_IN",
  WALK_TEST_ZONE_TRIP = "WALK_TEST_ZONE_TRIP",
  /** ZONE_MESSAGE */
  ZONE_BATTERY = "ZONE_BATTERY",
  ZONE_BYPASS = "ZONE_BYPASS",
  ZONE_CLOSED = "ZONE_CLOSED",
  ZONE_DEVICE_TROUBLE = "ZONE_DEVICE_TROUBLE",
  ZONE_INACTIVITY = "ZONE_INACTIVITY",
  ZONE_INFORMATION = "ZONE_INFORMATION",
  ZONE_MISSING = "ZONE_MISSING",
  ZONE_OPENED = "ZONE_OPENED",
  ZONE_RESTORE = "ZONE_RESTORE",
  /** TROUBLES */
  ZWAVE_DEVICE_LOW_BATTERY = "ZWAVE_DEVICE_LOW_BATTERY",
  ZWAVE_OPTIMIZE_DEVICE_STATUS = "ZWAVE_OPTIMIZE_DEVICE_STATUS",
  ZWAVE_TEST_CHECK_IN = "ZWAVE_TEST_CHECK_IN",
  Z_WAVE_DEVICE = "Z_WAVE_DEVICE",
}

export type SupportedEventType = {
  readonly __typename?: "SupportedEventType";
  readonly name: SupportedEventTypeName;
  readonly subcategories: ReadonlyArray<SupportedEventSubcategory>;
};

export enum SupportedEventTypeName {
  ALARMS = "ALARMS",
  ARMING = "ARMING",
  CAMECT = "CAMECT",
  DOOR_ACCESS = "DOOR_ACCESS",
  DOOR_STATUS = "DOOR_STATUS",
  ENTRY_DELAY_START = "ENTRY_DELAY_START",
  GENERIC_VIDEO = "GENERIC_VIDEO",
  KEYPAD = "KEYPAD",
  LOCKDOWN = "LOCKDOWN",
  MALMOSET = "MALMOSET",
  OPEN_EYE_EVENT = "OPEN_EYE_EVENT",
  OUTPUT_STATUS = "OUTPUT_STATUS",
  PROGRAMMING_CHANGE = "PROGRAMMING_CHANGE",
  REAL_TIME_STATUS = "REAL_TIME_STATUS",
  REMINDERS = "REMINDERS",
  SENSOR_ACTIVITY = "SENSOR_ACTIVITY",
  SUNELL_DOORBELL = "SUNELL_DOORBELL",
  SYSTEM_MESSAGE = "SYSTEM_MESSAGE",
  TRAFFIC_COUNT = "TRAFFIC_COUNT",
  TROUBLES = "TROUBLES",
  UNIVIEW = "UNIVIEW",
  UNKNOWN_EVENT_TYPE = "UNKNOWN_EVENT_TYPE",
  USER_ACTION = "USER_ACTION",
  X1_DEVICE_MESSAGE = "X1_DEVICE_MESSAGE",
  ZONE_MESSAGE = "ZONE_MESSAGE",
  ZWAVE_STATUS_MESSAGE = "ZWAVE_STATUS_MESSAGE",
}

export type SupportedSiteEventType = {
  readonly __typename?: "SupportedSiteEventType";
  readonly name: SupportedEventTypeName;
  readonly subcategories: ReadonlyArray<SupportedEventSubcategory>;
};

export enum SwipeToArm {
  OFF = "OFF",
  ONE_SWIPE = "ONE_SWIPE",
  TWO_SWIPES = "TWO_SWIPES",
}

export type SyncBillingErrorResponse = {
  readonly __typename?: "SyncBillingErrorResponse";
  readonly error: SyncBillingResponseErrors;
};

export type SyncBillingResponse =
  | SyncBillingErrorResponse
  | SyncBillingSuccessResponse;

export enum SyncBillingResponseErrors {
  SYNC_FAILED = "SYNC_FAILED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
}

export type SyncBillingSuccessResponse = {
  readonly __typename?: "SyncBillingSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export enum SystemAction {
  ARMED = "ARMED",
  ARMED_ALL = "ARMED_ALL",
  ARMED_AWAY = "ARMED_AWAY",
  ARMED_HOME = "ARMED_HOME",
  ARMED_PERIMETER = "ARMED_PERIMETER",
  ARMED_SLEEP = "ARMED_SLEEP",
  BURGLARY_ALARM = "BURGLARY_ALARM",
  DISARMED = "DISARMED",
  ENTRY_DELAY = "ENTRY_DELAY",
  EXIT_DELAY_END = "EXIT_DELAY_END",
  EXIT_DELAY_START = "EXIT_DELAY_START",
  FIRE_ALARM = "FIRE_ALARM",
  NONE = "NONE",
  PANIC_ALARM = "PANIC_ALARM",
}

export type SystemAreaInformation = {
  readonly __typename?: "SystemAreaInformation";
  readonly anyBypass: Scalars["Boolean"];
  readonly areaSchedules: Scalars["Boolean"];
  readonly burglaryBellOutputNumber: Scalars["String"];
  readonly closingCheck: Scalars["Boolean"];
  readonly closingCode: Scalars["Boolean"];
  readonly exitDelay: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly morningAmbush: Scalars["Int"];
  readonly openClosingReports: Scalars["Boolean"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly supportsBurglaryBellOutput: Scalars["Boolean"];
  readonly supportsOpenClosingReports: Scalars["Boolean"];
};

export type SystemAreaInformationInput = {
  readonly anyBypass: Scalars["Boolean"];
  readonly areaSchedules: Scalars["Boolean"];
  readonly burglaryBellOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly closingCheck: Scalars["Boolean"];
  readonly closingCode: Scalars["Boolean"];
  readonly exitDelay: Scalars["Int"];
  readonly morningAmbush: Scalars["Int"];
  readonly openClosingReports?: InputMaybe<Scalars["Boolean"]>;
};

export type SystemDiagnostic = {
  readonly __typename?: "SystemDiagnostic";
  readonly brownOutReset: PanelResetInformation;
  readonly j16Reset: PanelResetInformation;
  readonly lockupReset: PanelResetInformation;
  readonly powerReset: PanelResetInformation;
  readonly systemReset: PanelResetInformation;
  readonly watchdogReset: PanelResetInformation;
};

export type SystemDiagnosticsPanel = {
  readonly __typename?: "SystemDiagnosticsPanel";
  readonly accountNumber?: Maybe<Scalars["Int"]>;
  readonly commType?: Maybe<Scalars["String"]>;
  readonly controlSystemId?: Maybe<Scalars["Int"]>;
  readonly controlSystemName?: Maybe<Scalars["String"]>;
  readonly customerId?: Maybe<Scalars["Int"]>;
  readonly dealerId?: Maybe<Scalars["Int"]>;
  readonly hardwareModel?: Maybe<Scalars["String"]>;
  readonly panelAccountNumber?: Maybe<Scalars["Int"]>;
  readonly panelArmingSystem?: Maybe<Scalars["String"]>;
  readonly panelCommAddress?: Maybe<Scalars["String"]>;
  readonly panelId?: Maybe<Scalars["Int"]>;
  readonly panelName?: Maybe<Scalars["String"]>;
  readonly panelSerialNumber?: Maybe<Scalars["String"]>;
  readonly panelSoftwareDate?: Maybe<Scalars["String"]>;
  readonly panelSoftwareVersion?: Maybe<Scalars["String"]>;
  readonly simIdentifier?: Maybe<Scalars["String"]>;
};

export type SystemDiagnosticsPanelJob = {
  readonly __typename?: "SystemDiagnosticsPanelJob";
  readonly completedAt?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly jobDesc?: Maybe<Scalars["String"]>;
  readonly jobId: Scalars["Int"];
  readonly jobMessage?: Maybe<Scalars["String"]>;
  readonly jobStatus?: Maybe<Scalars["String"]>;
  readonly schedulerJobType?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export type SystemDiagnosticsPanelJobDepth = {
  readonly __typename?: "SystemDiagnosticsPanelJobDepth";
  readonly queueDepth?: Maybe<Scalars["Int"]>;
};

export type SystemDiagnosticsPanelJobGroup = {
  readonly __typename?: "SystemDiagnosticsPanelJobGroup";
  readonly completedAt?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly groupClass?: Maybe<Scalars["String"]>;
  readonly groupDesc?: Maybe<Scalars["String"]>;
  readonly groupId: Scalars["Int"];
  readonly groupMessage?: Maybe<Scalars["String"]>;
  readonly groupStatus?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
};

export type SystemDiagnosticsPanelStatistics = {
  readonly __typename?: "SystemDiagnosticsPanelStatistics";
  readonly acVoltage?: Maybe<Scalars["Float"]>;
  readonly actualCount?: Maybe<Scalars["Int"]>;
  readonly cellRetries?: Maybe<Scalars["Int"]>;
  readonly cellRoaming?: Maybe<Scalars["Boolean"]>;
  readonly cellTowerId?: Maybe<Scalars["Int"]>;
  readonly connectionType?: Maybe<Scalars["String"]>;
  readonly currentCellSignal?: Maybe<Scalars["Int"]>;
  readonly dcVoltage?: Maybe<Scalars["Float"]>;
  readonly deviceType?: Maybe<Scalars["String"]>;
  readonly maxCount?: Maybe<Scalars["Int"]>;
  readonly networkRetries?: Maybe<Scalars["Int"]>;
  readonly newSimIdentifier?: Maybe<Scalars["String"]>;
  readonly originalSimIdentifier?: Maybe<Scalars["String"]>;
  readonly pathNumber?: Maybe<Scalars["Int"]>;
  readonly reportedAt: Scalars["String"];
  readonly statId?: Maybe<Scalars["Float"]>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly strongestCellSignal?: Maybe<Scalars["Int"]>;
  readonly weakestCellSignal?: Maybe<Scalars["Int"]>;
};

export enum SystemFeatureTableConcepts {
  ADVANCED_REPORTS = "ADVANCED_REPORTS",
  APP_ENABLED = "APP_ENABLED",
  BADGE_PRINTING = "BADGE_PRINTING",
  TRAFFIC_COUNT = "TRAFFIC_COUNT",
  VIDEO_VERIFICATION = "VIDEO_VERIFICATION",
  Z_WAVE = "Z_WAVE",
}

export type SystemHasUnconfirmedProgrammingErrorResponse = {
  readonly __typename?: "SystemHasUnconfirmedProgrammingErrorResponse";
  readonly error?: Maybe<SendProgrammingConfirmationErrors>;
};

export type SystemHasUnconfirmedProgrammingResponse =
  | SystemHasUnconfirmedProgrammingErrorResponse
  | SystemHasUnconfirmedProgrammingSuccessResponse;

export type SystemHasUnconfirmedProgrammingSuccessResponse = {
  readonly __typename?: "SystemHasUnconfirmedProgrammingSuccessResponse";
  readonly hasUnconfirmed?: Maybe<Scalars["Boolean"]>;
};

export type SystemOptions = {
  readonly crossZoneTime: Scalars["Int"];
  readonly crossZoneTimeMax: Scalars["Int"];
  readonly crossZoneTimeMin: Scalars["Int"];
  readonly hoursFromGMT: Scalars["Int"];
  readonly hoursFromGMTMax: Scalars["Int"];
  readonly hoursFromGMTMin: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly powerFailDelay: Scalars["Int"];
  readonly powerFailDelayMax: Scalars["Int"];
  readonly powerFailDelayMin: Scalars["Int"];
  readonly swingerBypassTrips: Scalars["Int"];
  readonly swingerBypassTripsMax: Scalars["Int"];
  readonly swingerBypassTripsMin: Scalars["Int"];
  readonly timeChange: AllowTimeChange;
};

export type SystemProfilesReportRow = {
  readonly __typename?: "SystemProfilesReportRow";
  readonly NumberOfUserCodes?: Maybe<Scalars["Int"]>;
  readonly ProfileName?: Maybe<Scalars["String"]>;
  readonly ProfileNumber?: Maybe<Scalars["Int"]>;
  readonly ProfileOptions?: Maybe<ReportProfileOptions>;
  readonly SystemName?: Maybe<Scalars["String"]>;
};

export type SystemReports = Node & {
  readonly __typename?: "SystemReports";
  readonly abortReports: Scalars["Boolean"];
  readonly accessKeypads: Scalars["String"];
  readonly ambushReports: Scalars["Boolean"];
  readonly bypassReports: Scalars["Boolean"];
  readonly codeChangeReports: Scalars["Boolean"];
  readonly earlyToClose: Scalars["Int"];
  readonly earlyToCloseMax: Scalars["Int"];
  readonly earlyToCloseMin: Scalars["Int"];
  readonly entryCheckinProtection: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly lateToOpen: Scalars["Int"];
  readonly lateToOpenMax: Scalars["Int"];
  readonly lateToOpenMin: Scalars["Int"];
  readonly openCloseEnable: Scalars["Boolean"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly scheduleChangeReports: Scalars["Boolean"];
  readonly sendStoredMessage: Scalars["Boolean"];
  readonly systemInformation: Scalars["Boolean"];
  readonly videoSystemReports: Scalars["Boolean"];
  readonly zoneRestoralReports: SystemReportsZoneRestoralReports;
};

export type SystemReportsInput = {
  readonly abortReports: Scalars["Boolean"];
  readonly accessKeypads: Scalars["String"];
  readonly ambushReports: Scalars["Boolean"];
  readonly bypassReports: Scalars["Boolean"];
  readonly codeChangeReports: Scalars["Boolean"];
  readonly earlyToClose: Scalars["Int"];
  readonly entryCheckinProtection: Scalars["Boolean"];
  readonly lateToOpen: Scalars["Int"];
  readonly openCloseEnable: Scalars["Boolean"];
  readonly scheduleChangeReports: Scalars["Boolean"];
  readonly sendStoredMessage: Scalars["Boolean"];
  readonly systemInformation: Scalars["Boolean"];
  readonly videoSystemReports: Scalars["Boolean"];
  readonly zoneRestoralReports: SystemReportsZoneRestoralReports;
};

export enum SystemReportsZoneRestoralReports {
  DISARM = "DISARM",
  NO = "NO",
  YES = "YES",
}

export type SystemStatuses = {
  readonly __typename?: "SystemStatuses";
  readonly hasAlarm: Scalars["Boolean"];
  readonly hasBatteryTrouble: Scalars["Boolean"];
  readonly hasSupervisoryAlert: Scalars["Boolean"];
  readonly hasTrouble: Scalars["Boolean"];
  readonly isAcNormal: Scalars["Boolean"];
};

export enum SystemType {
  ALL_PERIMETER = "ALL_PERIMETER",
  AREA = "AREA",
  HOME_SLEEP_AWAY = "HOME_SLEEP_AWAY",
  HOME_SLEEP_AWAY_GUEST = "HOME_SLEEP_AWAY_GUEST",
}

export type SystemUsersReportRow = {
  readonly __typename?: "SystemUsersReportRow";
  readonly accessAreas?: Maybe<Scalars["String"]>;
  readonly armDisarmAreas?: Maybe<Scalars["String"]>;
  readonly code?: Maybe<Scalars["String"]>;
  readonly externalNumber?: Maybe<Scalars["String"]>;
  readonly hardwareModel?: Maybe<Scalars["String"]>;
  readonly isActive?: Maybe<Scalars["Boolean"]>;
  readonly pin?: Maybe<Scalars["String"]>;
  readonly profiles?: Maybe<Scalars["String"]>;
  readonly tempExpiration?: Maybe<Scalars["String"]>;
  readonly tempStartDate?: Maybe<Scalars["String"]>;
  readonly temporary?: Maybe<Scalars["Boolean"]>;
  readonly type?: Maybe<Scalars["String"]>;
  readonly userLevel?: Maybe<Scalars["String"]>;
  readonly userName?: Maybe<Scalars["String"]>;
  readonly userNumber?: Maybe<Scalars["Int"]>;
};

export type TmSentryRemoteOptions = Node &
  RemoteOptions & {
    readonly __typename?: "TMSentryRemoteOptions";
    readonly alarmReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
    readonly appKey?: Maybe<Scalars["String"]>;
    readonly appKeyMaxLength: Scalars["Int"];
    readonly armedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly armedAnswerRingsMax: Scalars["Int"];
    readonly armedAnswerRingsMin: Scalars["Int"];
    readonly disarmedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly disarmedAnswerRingsMax: Scalars["Int"];
    readonly disarmedAnswerRingsMin: Scalars["Int"];
    readonly entreArmDisarmReports?: Maybe<Scalars["Boolean"]>;
    readonly entreBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly entreBackupIpv6Address?: Maybe<Scalars["String"]>;
    readonly entreCheckInMinutes?: Maybe<Scalars["Int"]>;
    readonly entreConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreDoorReports?: Maybe<Scalars["Boolean"]>;
    readonly entreIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreIpAddress?: Maybe<Scalars["String"]>;
    readonly entreIpv6?: Maybe<Scalars["Boolean"]>;
    readonly entreIpv6Address?: Maybe<Scalars["String"]>;
    readonly entreOutgoingPort?: Maybe<Scalars["String"]>;
    readonly entrePassphrase?: Maybe<Scalars["String"]>;
    readonly entreSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly entreUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly entreVideoReports?: Maybe<Scalars["Boolean"]>;
    readonly entreZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly id: Scalars["ID"];
    readonly networkProgrammingPort?: Maybe<Scalars["String"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly remoteDisarm: Scalars["Boolean"];
    readonly remoteKey: Scalars["String"];
    readonly remoteKeyMaxLength: Scalars["Int"];
    readonly serviceReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
    readonly validEntreCheckinMinutes?: Maybe<Scalars["String"]>;
  };

export type TmSentryRemoteOptionsInput = {
  readonly alarmReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
  readonly appKey?: InputMaybe<Scalars["String"]>;
  readonly armedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly disarmedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly entreArmDisarmReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreCheckInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly entreConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly entrePassphrase?: InputMaybe<Scalars["String"]>;
  readonly entreSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly networkProgrammingPort?: InputMaybe<Scalars["String"]>;
  readonly remoteDisarm: Scalars["Boolean"];
  readonly serviceReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
  readonly validEntreCheckinMinutes?: InputMaybe<Scalars["String"]>;
};

export type TmSentrySystemOptions = Node &
  SystemOptions & {
    readonly __typename?: "TMSentrySystemOptions";
    readonly closingCode: Scalars["Boolean"];
    readonly crossZoneTime: Scalars["Int"];
    readonly crossZoneTimeMax: Scalars["Int"];
    readonly crossZoneTimeMin: Scalars["Int"];
    readonly enableKeypadPanicKeys: Scalars["Boolean"];
    readonly entryDelay1: Scalars["Int"];
    readonly entryDelayMax: Scalars["Int"];
    readonly entryDelayMin: Scalars["Int"];
    readonly exitDelay: Scalars["Int"];
    readonly exitDelayMax: Scalars["Int"];
    readonly exitDelayMin: Scalars["Int"];
    readonly hoursFromGMT: Scalars["Int"];
    readonly hoursFromGMTMax: Scalars["Int"];
    readonly hoursFromGMTMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly observeDst?: Maybe<Scalars["Boolean"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly powerFailDelay: Scalars["Int"];
    readonly powerFailDelayMax: Scalars["Int"];
    readonly powerFailDelayMin: Scalars["Int"];
    readonly resetSwingerBypass: Scalars["Boolean"];
    readonly swingerBypassTrips: Scalars["Int"];
    readonly swingerBypassTripsMax: Scalars["Int"];
    readonly swingerBypassTripsMin: Scalars["Int"];
    readonly systemType: SystemType;
    readonly timeChange: AllowTimeChange;
    readonly useFalseAlarmQuestion: Scalars["Boolean"];
    readonly weatherZipCode: Scalars["String"];
    readonly wirelessAudibles?: Maybe<WirelessAudibles>;
  };

export type TmSentrySystemOptionsInput = {
  readonly closingCode?: InputMaybe<Scalars["Boolean"]>;
  readonly crossZoneTime?: InputMaybe<Scalars["Int"]>;
  readonly enableKeypadPanicKeys?: InputMaybe<Scalars["Boolean"]>;
  readonly entryDelay1?: InputMaybe<Scalars["Int"]>;
  readonly exitDelay?: InputMaybe<Scalars["Int"]>;
  readonly hoursFromGMT?: InputMaybe<Scalars["Int"]>;
  readonly observeDst?: InputMaybe<Scalars["Boolean"]>;
  readonly powerFailDelay?: InputMaybe<Scalars["Int"]>;
  readonly resetSwingerBypass?: InputMaybe<Scalars["Boolean"]>;
  readonly swingerBypassTrips?: InputMaybe<Scalars["Int"]>;
  readonly timeChange?: InputMaybe<AllowTimeChange>;
  readonly useFalseAlarmQuestion?: InputMaybe<Scalars["Boolean"]>;
  readonly weatherZipCode?: InputMaybe<Scalars["String"]>;
  readonly wirelessAudibles?: InputMaybe<WirelessAudibles>;
};

export type Tag = {
  readonly __typename?: "Tag";
  readonly billingDealerId?: Maybe<Scalars["Int"]>;
  readonly dealerId: Scalars["Int"];
  readonly description?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isFixed?: Maybe<Scalars["Boolean"]>;
  readonly label?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly value?: Maybe<Scalars["String"]>;
};

export type TagFieldValue = {
  readonly __typename?: "TagFieldValue";
  readonly tags: ReadonlyArray<Maybe<Tag>>;
};

export type TagInput = {
  readonly billingDealerId?: InputMaybe<Scalars["Int"]>;
  readonly dealerId: Scalars["Int"];
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly tagCustomRoles: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly tagCustomers: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly tagPanels: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly tagSites: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly tagUsers: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
};

export type TagRelations = {
  readonly __typename?: "TagRelations";
  readonly tagCustomRoles?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly tagCustomers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly tagPanels?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly tagSites?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
  readonly tagUsers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
};

export type TagRelationsCounts = {
  readonly __typename?: "TagRelationsCounts";
  readonly dealerTag: Tag;
  readonly tagCustomerCount: Scalars["Int"];
  readonly tagPanelCount: Scalars["Int"];
};

export type TakeCameraSnapshotErrorPayload = {
  readonly __typename?: "TakeCameraSnapshotErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type TakeCameraSnapshotPayload =
  | TakeCameraSnapshotErrorPayload
  | TakeCameraSnapshotSuccessPayload;

export type TakeCameraSnapshotSuccessPayload = {
  readonly __typename?: "TakeCameraSnapshotSuccessPayload";
  readonly image_url?: Maybe<Scalars["String"]>;
  readonly upload_successful?: Maybe<Scalars["Boolean"]>;
};

export type TakeSystemOffTestErrorResponse = {
  readonly __typename?: "TakeSystemOffTestErrorResponse";
  readonly error: Error;
};

export type TakeSystemOffTestResponse =
  | TakeSystemOffTestErrorResponse
  | TakeSystemOffTestSuccessResponse;

export type TakeSystemOffTestSuccessResponse = {
  readonly __typename?: "TakeSystemOffTestSuccessResponse";
  readonly integration: ControlSystemCentralStationAutomationIntegration;
};

export type TakeVarCameraSnapshotErrorPayload = {
  readonly __typename?: "TakeVarCameraSnapshotErrorPayload";
  readonly type?: Maybe<Scalars["String"]>;
};

export type TakeVarCameraSnapshotPayload =
  | TakeVarCameraSnapshotErrorPayload
  | TakeVarCameraSnapshotSuccessPayload;

export type TakeVarCameraSnapshotSuccessPayload = {
  readonly __typename?: "TakeVarCameraSnapshotSuccessPayload";
  readonly image_url?: Maybe<Scalars["String"]>;
  readonly upload_successful?: Maybe<Scalars["Boolean"]>;
};

export type TakeoverPanelGetZonesError = {
  readonly __typename?: "TakeoverPanelGetZonesError";
  readonly error: TakeoverPanelGetZonesResponseErrors;
};

export type TakeoverPanelGetZonesEventResult = {
  readonly __typename?: "TakeoverPanelGetZonesEventResult";
  readonly status: TakeoverPanelGetZonesEventStatus;
  readonly zones: Scalars["Int"];
};

export enum TakeoverPanelGetZonesEventStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NO_EVENT_AVAILABLE = "NO_EVENT_AVAILABLE",
  PROCESSING = "PROCESSING",
}

export type TakeoverPanelGetZonesResponse =
  | TakeoverPanelGetZonesError
  | TakeoverPanelGetZonesSuccess;

export enum TakeoverPanelGetZonesResponseErrors {
  FAILED_GET_ZONES = "FAILED_GET_ZONES",
}

export type TakeoverPanelGetZonesSuccess = {
  readonly __typename?: "TakeoverPanelGetZonesSuccess";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type TakeoverPanelSetupError = {
  readonly __typename?: "TakeoverPanelSetupError";
  readonly error: TakeoverPanelSetupResponseErrors;
};

export type TakeoverPanelSetupEventResult = {
  readonly __typename?: "TakeoverPanelSetupEventResult";
  readonly status: TakeoverPanelSetupEventStatus;
};

export enum TakeoverPanelSetupEventStatus {
  FAILED = "FAILED",
  NO_EVENT_AVAILABLE = "NO_EVENT_AVAILABLE",
  SUCCESS = "SUCCESS",
}

export type TakeoverPanelSetupResponse =
  | TakeoverPanelSetupError
  | TakeoverPanelSetupSuccess;

export enum TakeoverPanelSetupResponseErrors {
  FAILED_GET_ZONES = "FAILED_GET_ZONES",
  FAILED_SETUP = "FAILED_SETUP",
}

export type TakeoverPanelSetupSuccess = {
  readonly __typename?: "TakeoverPanelSetupSuccess";
  readonly controlSystem: ControlSystem;
};

export enum TakeoverPanelType {
  DSC = "DSC",
  ECP = "ECP",
}

export type TakeoverProgrammingTemplateConcepts = {
  readonly __typename?: "TakeoverProgrammingTemplateConcepts";
  readonly areaInformations?: Maybe<
    ReadonlyArray<Maybe<XtProgrammingTemplateAreaInformation>>
  >;
  readonly communication?: Maybe<XtProgrammingTemplateCommunication>;
  readonly lockoutCode?: Maybe<ProgrammingTemplateLockoutCode>;
  readonly networkOptions?: Maybe<ProgrammingTemplateNetworkOptions>;
  readonly outputOptions?: Maybe<ProgrammingTemplateOutputOptions>;
  readonly remoteOptions?: Maybe<XtProgrammingTemplateRemoteOptions>;
  readonly systemOptions?: Maybe<XtProgrammingTemplateSystemOptions>;
  readonly systemReports?: Maybe<ProgrammingTemplateSystemReports>;
  readonly zoneInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateZoneInformation>>
  >;
};

export type TakeoverProgrammingTemplateConceptsInput = {
  readonly areaInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XtProgrammingTemplateAreaInformationInput>>
  >;
  readonly communication?: InputMaybe<XtProgrammingTemplateCommunicationInput>;
  readonly lockoutCode?: InputMaybe<ProgrammingTemplateLockoutCodeInput>;
  readonly networkOptions?: InputMaybe<ProgrammingTemplateNetworkOptionsInput>;
  readonly outputOptions?: InputMaybe<ProgrammingTemplateOutputOptionsInput>;
  readonly remoteOptions?: InputMaybe<XtProgrammingTemplateRemoteOptionsInput>;
  readonly systemOptions?: InputMaybe<XtProgrammingTemplateSystemOptionsInput>;
  readonly systemReports?: InputMaybe<ProgrammingTemplateSystemReportsInput>;
  readonly zoneInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateZoneInformationInput>>
  >;
};

export type TakeoverProgrammingTemplateInput = {
  readonly concepts?: InputMaybe<TakeoverProgrammingTemplateConceptsInput>;
  readonly customerId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly hardwareModel: PanelHardwareModel;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly ratePlan?: InputMaybe<Scalars["String"]>;
  readonly receiverCommType?: InputMaybe<Scalars["String"]>;
};

export type TemplateFieldBadZonesOption = {
  readonly __typename?: "TemplateFieldBadZonesOption";
  readonly data?: Maybe<BadZonesOption>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldBadZonesOptionInput = {
  readonly data?: InputMaybe<BadZonesOption>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldBellActions = {
  readonly __typename?: "TemplateFieldBellActions";
  readonly data?: Maybe<BellActions>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldBellActionsInput = {
  readonly data?: InputMaybe<BellActions>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldBoolean = {
  readonly __typename?: "TemplateFieldBoolean";
  readonly data?: Maybe<Scalars["Boolean"]>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldBooleanInput = {
  readonly data?: InputMaybe<Scalars["Boolean"]>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCidFormat = {
  readonly __typename?: "TemplateFieldCIDFormat";
  readonly data?: Maybe<CaptureFormat>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCidFormatInput = {
  readonly data?: InputMaybe<CaptureFormat>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommPathTrouble = {
  readonly __typename?: "TemplateFieldCommPathTrouble";
  readonly data?: Maybe<CommPathTrouble>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommPathTroubleInput = {
  readonly data?: InputMaybe<CommPathTrouble>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationComType = {
  readonly __typename?: "TemplateFieldCommunicationComType";
  readonly data?: Maybe<CommunicationComType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationComTypeInput = {
  readonly data?: InputMaybe<CommunicationComType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathAlarmReports = {
  readonly __typename?: "TemplateFieldCommunicationPathAlarmReports";
  readonly data?: Maybe<CommunicationPathAlarmReports>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathAlarmReportsInput = {
  readonly data?: InputMaybe<CommunicationPathAlarmReports>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathCommType = {
  readonly __typename?: "TemplateFieldCommunicationPathCommType";
  readonly data?: Maybe<CommunicationPathCommType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathCommTypeInput = {
  readonly data?: InputMaybe<CommunicationPathCommType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathDayOfWeek = {
  readonly __typename?: "TemplateFieldCommunicationPathDayOfWeek";
  readonly data?: Maybe<CommunicationPathDayOfWeek>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathDayOfWeekInput = {
  readonly data?: InputMaybe<CommunicationPathDayOfWeek>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathDoorAccessReports = {
  readonly __typename?: "TemplateFieldCommunicationPathDoorAccessReports";
  readonly data?: Maybe<CommunicationPathDoorAccessReports>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathDoorAccessReportsInput = {
  readonly data?: InputMaybe<CommunicationPathDoorAccessReports>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathEncryptionScheme = {
  readonly __typename?: "TemplateFieldCommunicationPathEncryptionScheme";
  readonly data?: Maybe<CommunicationPathEncryptionScheme>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathEncryptionSchemeInput = {
  readonly data?: InputMaybe<CommunicationPathEncryptionScheme>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathProtocol = {
  readonly __typename?: "TemplateFieldCommunicationPathProtocol";
  readonly data?: Maybe<CommunicationPathProtocol>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathProtocolInput = {
  readonly data?: InputMaybe<CommunicationPathProtocol>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathSubstitutionCode = {
  readonly __typename?: "TemplateFieldCommunicationPathSubstitutionCode";
  readonly data?: Maybe<CommunicationPathSubstitutionCode>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathSubstitutionCodeInput = {
  readonly data?: InputMaybe<CommunicationPathSubstitutionCode>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathSupervisoryTroubleReports = {
  readonly __typename?: "TemplateFieldCommunicationPathSupervisoryTroubleReports";
  readonly data?: Maybe<CommunicationPathSupervisoryTroubleReports>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathSupervisoryTroubleReportsInput = {
  readonly data?: InputMaybe<CommunicationPathSupervisoryTroubleReports>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathTestFrequencyUnit = {
  readonly __typename?: "TemplateFieldCommunicationPathTestFrequencyUnit";
  readonly data?: Maybe<CommunicationPathTestFrequencyUnit>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathTestFrequencyUnitInput = {
  readonly data?: InputMaybe<CommunicationPathTestFrequencyUnit>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathTestReport = {
  readonly __typename?: "TemplateFieldCommunicationPathTestReport";
  readonly data?: Maybe<CommunicationPathTestReport>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathTestReportInput = {
  readonly data?: InputMaybe<CommunicationPathTestReport>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathType = {
  readonly __typename?: "TemplateFieldCommunicationPathType";
  readonly data?: Maybe<CommunicationPathType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathTypeInput = {
  readonly data?: InputMaybe<CommunicationPathType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathUseCheckIn = {
  readonly __typename?: "TemplateFieldCommunicationPathUseCheckIn";
  readonly data?: Maybe<CommunicationPathUseCheckIn>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldCommunicationPathUseCheckInInput = {
  readonly data?: InputMaybe<CommunicationPathUseCheckIn>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734CardOptions = {
  readonly __typename?: "TemplateFieldDevice734CardOptions";
  readonly data?: Maybe<Device734CardOptions>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734CardOptionsInput = {
  readonly data?: InputMaybe<Device734CardOptions>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734LedColors = {
  readonly __typename?: "TemplateFieldDevice734LedColors";
  readonly data?: Maybe<Device734LedColors>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734LedColorsInput = {
  readonly data?: InputMaybe<Device734LedColors>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734NoCommWithPanelRelayAction = {
  readonly __typename?: "TemplateFieldDevice734NoCommWithPanelRelayAction";
  readonly data?: Maybe<Device734NoCommWithPanelRelayAction>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734NoCommWithPanelRelayActionInput = {
  readonly data?: InputMaybe<Device734NoCommWithPanelRelayAction>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734ReaderProtocol = {
  readonly __typename?: "TemplateFieldDevice734ReaderProtocol";
  readonly data?: Maybe<Device734ReaderProtocol>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDevice734ReaderProtocolInput = {
  readonly data?: InputMaybe<Device734ReaderProtocol>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformation1100TWirelessFrequencyType = {
  readonly __typename?: "TemplateFieldDeviceInformation1100TWirelessFrequencyType";
  readonly data?: Maybe<DeviceInformation1100TWirelessFrequencyType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformation1100TWirelessFrequencyTypeInput = {
  readonly data?: InputMaybe<DeviceInformation1100TWirelessFrequencyType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationCommType = {
  readonly __typename?: "TemplateFieldDeviceInformationCommType";
  readonly data?: Maybe<DeviceInformationCommType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationCommTypeInput = {
  readonly data?: InputMaybe<DeviceInformationCommType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationType = {
  readonly __typename?: "TemplateFieldDeviceInformationType";
  readonly data?: Maybe<DeviceInformationType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationTypeInput = {
  readonly data?: InputMaybe<DeviceInformationType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationWirelessSupervisionTime = {
  readonly __typename?: "TemplateFieldDeviceInformationWirelessSupervisionTime";
  readonly data?: Maybe<DeviceInformationWirelessSupervisionTime>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDeviceInformationWirelessSupervisionTimeInput = {
  readonly data?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldDualAuthorityEnum = {
  readonly __typename?: "TemplateFieldDualAuthorityEnum";
  readonly data?: Maybe<DualAuthorityEnum>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldDualAuthorityEnumInput = {
  readonly data?: InputMaybe<DualAuthorityEnum>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldEolResistorValue = {
  readonly __typename?: "TemplateFieldEolResistorValue";
  readonly data?: Maybe<EolResistorValue>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldEolResistorValueInput = {
  readonly data?: InputMaybe<EolResistorValue>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldInspectionReminder = {
  readonly __typename?: "TemplateFieldInspectionReminder";
  readonly data?: Maybe<InspectionReminder>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldInspectionReminderInput = {
  readonly data?: InputMaybe<InspectionReminder>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldInt = {
  readonly __typename?: "TemplateFieldInt";
  readonly data?: Maybe<Scalars["Int"]>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldIntInput = {
  readonly data?: InputMaybe<Scalars["Int"]>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobButtonType = {
  readonly __typename?: "TemplateFieldKeyfobButtonType";
  readonly data?: Maybe<KeyfobButtonType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobButtonTypeInput = {
  readonly data?: InputMaybe<KeyfobButtonType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobNumberOfButtons = {
  readonly __typename?: "TemplateFieldKeyfobNumberOfButtons";
  readonly data?: Maybe<KeyfobNumberOfButtons>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobNumberOfButtonsInput = {
  readonly data?: InputMaybe<KeyfobNumberOfButtons>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobOutputAction = {
  readonly __typename?: "TemplateFieldKeyfobOutputAction";
  readonly data?: Maybe<KeyfobOutputAction>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobOutputActionInput = {
  readonly data?: InputMaybe<KeyfobOutputAction>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobPressTime = {
  readonly __typename?: "TemplateFieldKeyfobPressTime";
  readonly data?: Maybe<KeyfobPressTime>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobPressTimeInput = {
  readonly data?: InputMaybe<KeyfobPressTime>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobSupervisionTime = {
  readonly __typename?: "TemplateFieldKeyfobSupervisionTime";
  readonly data?: Maybe<KeyfobSupervisionTime>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeyfobSupervisionTimeInput = {
  readonly data?: InputMaybe<KeyfobSupervisionTime>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeypadArmedLed = {
  readonly __typename?: "TemplateFieldKeypadArmedLed";
  readonly data?: Maybe<KeypadArmedLed>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeypadArmedLedInput = {
  readonly data?: InputMaybe<KeypadArmedLed>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeypadInput = {
  readonly __typename?: "TemplateFieldKeypadInput";
  readonly data?: Maybe<KeypadInput>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldKeypadInputInput = {
  readonly data?: InputMaybe<KeypadInput>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldNacProtocol = {
  readonly __typename?: "TemplateFieldNacProtocol";
  readonly data?: Maybe<NacProtocols>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldNacProtocolInput = {
  readonly data?: InputMaybe<NacProtocols>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldNetworkOptionsWifiSecurity = {
  readonly __typename?: "TemplateFieldNetworkOptionsWifiSecurity";
  readonly data?: Maybe<NetworkOptionsWifiSecurity>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldNetworkOptionsWifiSecurityInput = {
  readonly data?: InputMaybe<NetworkOptionsWifiSecurity>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldOutputSupervision = {
  readonly __typename?: "TemplateFieldOutputSupervision";
  readonly data?: Maybe<OutputSupervision>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldOutputSupervisionInput = {
  readonly data?: InputMaybe<OutputSupervision>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldPanelProgrammingLanguage = {
  readonly __typename?: "TemplateFieldPanelProgrammingLanguage";
  readonly data?: Maybe<PanelProgrammingLanguage>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldPanelProgrammingLanguageInput = {
  readonly data?: InputMaybe<PanelProgrammingLanguage>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldProgrammingTemplateDevice734 = {
  readonly __typename?: "TemplateFieldProgrammingTemplateDevice734";
  readonly data?: Maybe<ProgrammingTemplateDevice734>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldProgrammingTemplateDevice734Input = {
  readonly data?: InputMaybe<ProgrammingTemplateDevice734Input>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldRemoteOptionsConnectionType = {
  readonly __typename?: "TemplateFieldRemoteOptionsConnectionType";
  readonly data?: Maybe<RemoteOptionsConnectionType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldRemoteOptionsConnectionTypeInput = {
  readonly data?: InputMaybe<RemoteOptionsConnectionType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldSendLocalChangesType = {
  readonly __typename?: "TemplateFieldSendLocalChangesType";
  readonly data?: Maybe<SendLocalChangesType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldSendLocalChangesTypeInput = {
  readonly data?: InputMaybe<SendLocalChangesType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldString = {
  readonly __typename?: "TemplateFieldString";
  readonly data?: Maybe<Scalars["String"]>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldStringInput = {
  readonly data?: InputMaybe<Scalars["String"]>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldSystemReportsZoneRestoralReports = {
  readonly __typename?: "TemplateFieldSystemReportsZoneRestoralReports";
  readonly data?: Maybe<SystemReportsZoneRestoralReports>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldSystemReportsZoneRestoralReportsInput = {
  readonly data?: InputMaybe<SystemReportsZoneRestoralReports>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldSystemType = {
  readonly __typename?: "TemplateFieldSystemType";
  readonly data?: Maybe<SystemType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldSystemTypeInput = {
  readonly data?: InputMaybe<SystemType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldTimeChange = {
  readonly __typename?: "TemplateFieldTimeChange";
  readonly data?: Maybe<AllowTimeChange>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldTimeChangeInput = {
  readonly data?: InputMaybe<AllowTimeChange>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldWirelessAudibles = {
  readonly __typename?: "TemplateFieldWirelessAudibles";
  readonly data?: Maybe<WirelessAudibles>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldWirelessAudiblesInput = {
  readonly data?: InputMaybe<WirelessAudibles>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldWirelessEncryption1100 = {
  readonly __typename?: "TemplateFieldWirelessEncryption1100";
  readonly data?: Maybe<WirelessEncryption1100>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldWirelessEncryption1100Input = {
  readonly data?: InputMaybe<WirelessEncryption1100>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneArmingStyle = {
  readonly __typename?: "TemplateFieldZoneArmingStyle";
  readonly data?: Maybe<ZoneArmingStyle>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneArmingStyleInput = {
  readonly data?: InputMaybe<ZoneArmingStyle>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneChimeSound = {
  readonly __typename?: "TemplateFieldZoneChimeSound";
  readonly data?: Maybe<ZoneChimeSound>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneChimeSoundInput = {
  readonly data?: InputMaybe<ZoneChimeSound>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneEntryDelayNumber = {
  readonly __typename?: "TemplateFieldZoneEntryDelayNumber";
  readonly data?: Maybe<ZoneEntryDelayNumber>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneEntryDelayNumberInput = {
  readonly data?: InputMaybe<ZoneEntryDelayNumber>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneMessage = {
  readonly __typename?: "TemplateFieldZoneMessage";
  readonly data?: Maybe<ZoneMessage>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneMessageInput = {
  readonly data?: InputMaybe<ZoneMessage>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneOutputAction = {
  readonly __typename?: "TemplateFieldZoneOutputAction";
  readonly data?: Maybe<ZoneOutputAction>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneOutputActionInput = {
  readonly data?: InputMaybe<ZoneOutputAction>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePetImmunity = {
  readonly __typename?: "TemplateFieldZonePetImmunity";
  readonly data?: Maybe<ZonePetImmunity>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePetImmunityInput = {
  readonly data?: InputMaybe<ZonePetImmunity>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePirPulseCount = {
  readonly __typename?: "TemplateFieldZonePirPulseCount";
  readonly data?: Maybe<ZonePirPulseCount>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePirPulseCountInput = {
  readonly data?: InputMaybe<ZonePirPulseCount>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePirSensitivity = {
  readonly __typename?: "TemplateFieldZonePirSensitivity";
  readonly data?: Maybe<ZonePirSensitivity>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZonePirSensitivityInput = {
  readonly data?: InputMaybe<ZonePirSensitivity>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneReceiverRoute = {
  readonly __typename?: "TemplateFieldZoneReceiverRoute";
  readonly data?: Maybe<ZoneReceiverRoute>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneReceiverRouteInput = {
  readonly data?: InputMaybe<ZoneReceiverRoute>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneSensorType = {
  readonly __typename?: "TemplateFieldZoneSensorType";
  readonly data?: Maybe<ZoneSensorType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneSensorTypeInput = {
  readonly data?: InputMaybe<ZoneSensorType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneSupervisionTime = {
  readonly __typename?: "TemplateFieldZoneSupervisionTime";
  readonly data?: Maybe<ZoneSupervisionTime>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneSupervisionTimeInput = {
  readonly data?: InputMaybe<ZoneSupervisionTime>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneTransmitterContact = {
  readonly __typename?: "TemplateFieldZoneTransmitterContact";
  readonly data?: Maybe<ZoneTransmitterContact>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneTransmitterContactInput = {
  readonly data?: InputMaybe<ZoneTransmitterContact>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneType = {
  readonly __typename?: "TemplateFieldZoneType";
  readonly data?: Maybe<ZoneType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateFieldZoneTypeInput = {
  readonly data?: InputMaybe<ZoneType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TemplateZoneRemoteZoneType = {
  readonly __typename?: "TemplateZoneRemoteZoneType";
  readonly data?: Maybe<ZoneRemoteZoneType>;
  readonly included?: Maybe<Scalars["Boolean"]>;
};

export type TemplateZoneRemoteZoneTypeInput = {
  readonly data?: InputMaybe<ZoneRemoteZoneType>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
};

export type TestCameraConnectionResponse =
  | CameraOfflineError
  | NotFoundError
  | SecureComCamera
  | UnauthorizedError;

export type TestSiteConnectionResponse =
  | ConnectionTimeoutError
  | TestSiteConnectionSuccessResponse
  | UnknownError;

export type TestSiteConnectionSuccessResponse = {
  readonly __typename?: "TestSiteConnectionSuccessResponse";
  readonly canConnectRightNow: Scalars["Boolean"];
};

export enum TimeZone {
  AFGHANISTAN_STANDARD_TIME = "AFGHANISTAN_STANDARD_TIME",
  ALASKAN_STANDARD_TIME = "ALASKAN_STANDARD_TIME",
  ALEUTIAN_STANDARD_TIME = "ALEUTIAN_STANDARD_TIME",
  ALTAI_STANDARD_TIME = "ALTAI_STANDARD_TIME",
  ARABIAN_STANDARD_TIME = "ARABIAN_STANDARD_TIME",
  ARABIC_STANDARD_TIME = "ARABIC_STANDARD_TIME",
  ARAB_STANDARD_TIME = "ARAB_STANDARD_TIME",
  ARGENTINA_STANDARD_TIME = "ARGENTINA_STANDARD_TIME",
  ASTRAKHAN_STANDARD_TIME = "ASTRAKHAN_STANDARD_TIME",
  ATLANTIC_STANDARD_TIME = "ATLANTIC_STANDARD_TIME",
  AUS_CENTRAL_STANDARD_TIME = "AUS_CENTRAL_STANDARD_TIME",
  AUS_CENTRAL_W_STANDARD_TIME = "AUS_CENTRAL_W_STANDARD_TIME",
  AUS_EASTERN_STANDARD_TIME = "AUS_EASTERN_STANDARD_TIME",
  AZERBAIJAN_STANDARD_TIME = "AZERBAIJAN_STANDARD_TIME",
  AZORES_STANDARD_TIME = "AZORES_STANDARD_TIME",
  BAHIA_STANDARD_TIME = "BAHIA_STANDARD_TIME",
  BANGLADESH_STANDARD_TIME = "BANGLADESH_STANDARD_TIME",
  BELARUS_STANDARD_TIME = "BELARUS_STANDARD_TIME",
  BOUGAINVILLE_STANDARD_TIME = "BOUGAINVILLE_STANDARD_TIME",
  CANADA_CENTRAL_STANDARD_TIME = "CANADA_CENTRAL_STANDARD_TIME",
  CAPE_VERDE_STANDARD_TIME = "CAPE_VERDE_STANDARD_TIME",
  CAUCASUS_STANDARD_TIME = "CAUCASUS_STANDARD_TIME",
  CENTRAL_AMERICA_STANDARD_TIME = "CENTRAL_AMERICA_STANDARD_TIME",
  CENTRAL_ASIA_STANDARD_TIME = "CENTRAL_ASIA_STANDARD_TIME",
  CENTRAL_BRAZILIAN_STANDARD_TIME = "CENTRAL_BRAZILIAN_STANDARD_TIME",
  CENTRAL_EUROPEAN_STANDARD_TIME = "CENTRAL_EUROPEAN_STANDARD_TIME",
  CENTRAL_EUROPE_STANDARD_TIME = "CENTRAL_EUROPE_STANDARD_TIME",
  CENTRAL_PACIFIC_STANDARD_TIME = "CENTRAL_PACIFIC_STANDARD_TIME",
  CENTRAL_STANDARD_TIME = "CENTRAL_STANDARD_TIME",
  CENTRAL_STANDARD_TIME_MEXICO = "CENTRAL_STANDARD_TIME_MEXICO",
  CEN_AUSTRALIA_STANDARD_TIME = "CEN_AUSTRALIA_STANDARD_TIME",
  CHATHAM_ISLANDS_STANDARD_TIME = "CHATHAM_ISLANDS_STANDARD_TIME",
  CHINA_STANDARD_TIME = "CHINA_STANDARD_TIME",
  CUBA_STANDARD_TIME = "CUBA_STANDARD_TIME",
  DATELINE_STANDARD_TIME = "DATELINE_STANDARD_TIME",
  EASTERN_STANDARD_TIME = "EASTERN_STANDARD_TIME",
  EASTERN_STANDARD_TIME_MEXICO = "EASTERN_STANDARD_TIME_MEXICO",
  EASTER_ISLAND_STANDARD_TIME = "EASTER_ISLAND_STANDARD_TIME",
  EGYPT_STANDARD_TIME = "EGYPT_STANDARD_TIME",
  EKATERINBURG_STANDARD_TIME = "EKATERINBURG_STANDARD_TIME",
  E_AFRICA_STANDARD_TIME = "E_AFRICA_STANDARD_TIME",
  E_AUSTRALIA_STANDARD_TIME = "E_AUSTRALIA_STANDARD_TIME",
  E_EUROPE_STANDARD_TIME = "E_EUROPE_STANDARD_TIME",
  E_SOUTH_AMERICA_STANDARD_TIME = "E_SOUTH_AMERICA_STANDARD_TIME",
  FIJI_STANDARD_TIME = "FIJI_STANDARD_TIME",
  FLE_STANDARD_TIME = "FLE_STANDARD_TIME",
  GEORGIAN_STANDARD_TIME = "GEORGIAN_STANDARD_TIME",
  GMT_STANDARD_TIME = "GMT_STANDARD_TIME",
  GREENLAND_STANDARD_TIME = "GREENLAND_STANDARD_TIME",
  GREENWICH_STANDARD_TIME = "GREENWICH_STANDARD_TIME",
  GTB_STANDARD_TIME = "GTB_STANDARD_TIME",
  HAITI_STANDARD_TIME = "HAITI_STANDARD_TIME",
  HAWAIIAN_STANDARD_TIME = "HAWAIIAN_STANDARD_TIME",
  INDIA_STANDARD_TIME = "INDIA_STANDARD_TIME",
  IRAN_STANDARD_TIME = "IRAN_STANDARD_TIME",
  ISRAEL_STANDARD_TIME = "ISRAEL_STANDARD_TIME",
  JORDAN_STANDARD_TIME = "JORDAN_STANDARD_TIME",
  KALININGRAD_STANDARD_TIME = "KALININGRAD_STANDARD_TIME",
  KAMCHATKA_STANDARD_TIME = "KAMCHATKA_STANDARD_TIME",
  KOREA_STANDARD_TIME = "KOREA_STANDARD_TIME",
  LIBYA_STANDARD_TIME = "LIBYA_STANDARD_TIME",
  LINE_ISLANDS_STANDARD_TIME = "LINE_ISLANDS_STANDARD_TIME",
  LORD_HOWE_STANDARD_TIME = "LORD_HOWE_STANDARD_TIME",
  MAGADAN_STANDARD_TIME = "MAGADAN_STANDARD_TIME",
  MAGALLANES_STANDARD_TIME = "MAGALLANES_STANDARD_TIME",
  MARQUESAS_STANDARD_TIME = "MARQUESAS_STANDARD_TIME",
  MAURITIUS_STANDARD_TIME = "MAURITIUS_STANDARD_TIME",
  MIDDLE_EAST_STANDARD_TIME = "MIDDLE_EAST_STANDARD_TIME",
  MID_ATLANTIC_STANDARD_TIME = "MID_ATLANTIC_STANDARD_TIME",
  MONTEVIDEO_STANDARD_TIME = "MONTEVIDEO_STANDARD_TIME",
  MOROCCO_STANDARD_TIME = "MOROCCO_STANDARD_TIME",
  MOUNTAIN_STANDARD_TIME = "MOUNTAIN_STANDARD_TIME",
  MOUNTAIN_STANDARD_TIME_MEXICO = "MOUNTAIN_STANDARD_TIME_MEXICO",
  MYANMAR_STANDARD_TIME = "MYANMAR_STANDARD_TIME",
  NAMIBIA_STANDARD_TIME = "NAMIBIA_STANDARD_TIME",
  NEPAL_STANDARD_TIME = "NEPAL_STANDARD_TIME",
  NEWFOUNDLAND_STANDARD_TIME = "NEWFOUNDLAND_STANDARD_TIME",
  NEW_ZEALAND_STANDARD_TIME = "NEW_ZEALAND_STANDARD_TIME",
  NORFOLK_STANDARD_TIME = "NORFOLK_STANDARD_TIME",
  NORTH_ASIA_EAST_STANDARD_TIME = "NORTH_ASIA_EAST_STANDARD_TIME",
  NORTH_ASIA_STANDARD_TIME = "NORTH_ASIA_STANDARD_TIME",
  NORTH_KOREA_STANDARD_TIME = "NORTH_KOREA_STANDARD_TIME",
  N_CENTRAL_ASIA_STANDARD_TIME = "N_CENTRAL_ASIA_STANDARD_TIME",
  OMSK_STANDARD_TIME = "OMSK_STANDARD_TIME",
  PACIFIC_SA_STANDARD_TIME = "PACIFIC_SA_STANDARD_TIME",
  PACIFIC_STANDARD_TIME = "PACIFIC_STANDARD_TIME",
  PACIFIC_STANDARD_TIME_MEXICO = "PACIFIC_STANDARD_TIME_MEXICO",
  PAKISTAN_STANDARD_TIME = "PAKISTAN_STANDARD_TIME",
  PARAGUAY_STANDARD_TIME = "PARAGUAY_STANDARD_TIME",
  QYZYLORDA_STANDARD_TIME = "QYZYLORDA_STANDARD_TIME",
  ROMANCE_STANDARD_TIME = "ROMANCE_STANDARD_TIME",
  RUSSIAN_STANDARD_TIME = "RUSSIAN_STANDARD_TIME",
  RUSSIA_TIME_ZONE_3 = "RUSSIA_TIME_ZONE_3",
  RUSSIA_TIME_ZONE_10 = "RUSSIA_TIME_ZONE_10",
  RUSSIA_TIME_ZONE_11 = "RUSSIA_TIME_ZONE_11",
  SAINT_PIERRE_STANDARD_TIME = "SAINT_PIERRE_STANDARD_TIME",
  SAKHALIN_STANDARD_TIME = "SAKHALIN_STANDARD_TIME",
  SAMOA_STANDARD_TIME = "SAMOA_STANDARD_TIME",
  SAO_TOME_STANDARD_TIME = "SAO_TOME_STANDARD_TIME",
  SARATOV_STANDARD_TIME = "SARATOV_STANDARD_TIME",
  SA_EASTERN_STANDARD_TIME = "SA_EASTERN_STANDARD_TIME",
  SA_PACIFIC_STANDARD_TIME = "SA_PACIFIC_STANDARD_TIME",
  SA_WESTERN_STANDARD_TIME = "SA_WESTERN_STANDARD_TIME",
  SE_ASIA_STANDARD_TIME = "SE_ASIA_STANDARD_TIME",
  SINGAPORE_STANDARD_TIME = "SINGAPORE_STANDARD_TIME",
  SOUTH_AFRICA_STANDARD_TIME = "SOUTH_AFRICA_STANDARD_TIME",
  SOUTH_SUDAN_STANDARD_TIME = "SOUTH_SUDAN_STANDARD_TIME",
  SRI_LANKA_STANDARD_TIME = "SRI_LANKA_STANDARD_TIME",
  SUDAN_STANDARD_TIME = "SUDAN_STANDARD_TIME",
  SYRIA_STANDARD_TIME = "SYRIA_STANDARD_TIME",
  TAIPEI_STANDARD_TIME = "TAIPEI_STANDARD_TIME",
  TASMANIA_STANDARD_TIME = "TASMANIA_STANDARD_TIME",
  TOCANTINS_STANDARD_TIME = "TOCANTINS_STANDARD_TIME",
  TOKYO_STANDARD_TIME = "TOKYO_STANDARD_TIME",
  TOMSK_STANDARD_TIME = "TOMSK_STANDARD_TIME",
  TONGA_STANDARD_TIME = "TONGA_STANDARD_TIME",
  TRANSBAIKAL_STANDARD_TIME = "TRANSBAIKAL_STANDARD_TIME",
  TURKEY_STANDARD_TIME = "TURKEY_STANDARD_TIME",
  TURKS_AND_CAICOS_STANDARD_TIME = "TURKS_AND_CAICOS_STANDARD_TIME",
  ULAANBAATAR_STANDARD_TIME = "ULAANBAATAR_STANDARD_TIME",
  US_EASTERN_STANDARD_TIME = "US_EASTERN_STANDARD_TIME",
  US_MOUNTAIN_STANDARD_TIME = "US_MOUNTAIN_STANDARD_TIME",
  UTC = "UTC",
  UTC_MINUS_02 = "UTC_MINUS_02",
  UTC_MINUS_08 = "UTC_MINUS_08",
  UTC_MINUS_09 = "UTC_MINUS_09",
  UTC_MINUS_11 = "UTC_MINUS_11",
  UTC_PLUS_12 = "UTC_PLUS_12",
  UTC_PLUS_13 = "UTC_PLUS_13",
  VENEZUELA_STANDARD_TIME = "VENEZUELA_STANDARD_TIME",
  VLADIVOSTOK_STANDARD_TIME = "VLADIVOSTOK_STANDARD_TIME",
  VOLGOGRAD_STANDARD_TIME = "VOLGOGRAD_STANDARD_TIME",
  WEST_ASIA_STANDARD_TIME = "WEST_ASIA_STANDARD_TIME",
  WEST_BANK_STANDARD_TIME = "WEST_BANK_STANDARD_TIME",
  WEST_PACIFIC_STANDARD_TIME = "WEST_PACIFIC_STANDARD_TIME",
  W_AUSTRALIA_STANDARD_TIME = "W_AUSTRALIA_STANDARD_TIME",
  W_CENTRAL_AFRICA_STANDARD_TIME = "W_CENTRAL_AFRICA_STANDARD_TIME",
  W_EUROPE_STANDARD_TIME = "W_EUROPE_STANDARD_TIME",
  W_MONGOLIA_STANDARD_TIME = "W_MONGOLIA_STANDARD_TIME",
  YAKUTSK_STANDARD_TIME = "YAKUTSK_STANDARD_TIME",
  YUKON_STANDARD_TIME = "YUKON_STANDARD_TIME",
}

export type ToggleProxErrorPayload = {
  readonly __typename?: "ToggleProxErrorPayload";
  readonly Error?: Maybe<Scalars["String"]>;
  readonly lowFrequency125kHzEnabled?: Maybe<Scalars["Boolean"]>;
};

export type ToggleProxInput = {
  readonly deviceNumbers?: InputMaybe<ReadonlyArray<Scalars["Int"]>>;
  readonly enable: Scalars["Boolean"];
  readonly readers?: InputMaybe<ReadonlyArray<OsdpReaderInput>>;
  readonly systemId: Scalars["ID"];
};

export type ToggleProxPayload =
  | ToggleProxErrorPayload
  | ToggleProxSuccessPayload;

export type ToggleProxSuccessPayload = {
  readonly __typename?: "ToggleProxSuccessPayload";
  readonly accepted: Scalars["Boolean"];
  readonly jobId: Scalars["String"];
  readonly lowFrequency125kHzEnabled?: Maybe<Scalars["Boolean"]>;
};

export type ToggleRedBlueLightErrorPayload = {
  readonly __typename?: "ToggleRedBlueLightErrorPayload";
  readonly error?: Maybe<Error>;
};

export type ToggleRedBlueLightPayload =
  | ToggleRedBlueLightErrorPayload
  | ToggleRedBlueLightSuccessPayload;

export type ToggleRedBlueLightSuccessPayload = {
  readonly __typename?: "ToggleRedBlueLightSuccessPayload";
  readonly status: Scalars["Boolean"];
};

export type ToggleWhiteLightErrorPayload = {
  readonly __typename?: "ToggleWhiteLightErrorPayload";
  readonly error?: Maybe<Error>;
};

export type ToggleWhiteLightPayload =
  | ToggleWhiteLightErrorPayload
  | ToggleWhiteLightSuccessPayload;

export type ToggleWhiteLightSuccessPayload = {
  readonly __typename?: "ToggleWhiteLightSuccessPayload";
  readonly status: Scalars["Boolean"];
};

export type TurnAllSystemOutputsOffErrorResponse = {
  readonly __typename?: "TurnAllSystemOutputsOffErrorResponse";
  readonly error: Error;
};

export type TurnAllSystemOutputsOffResponse =
  | TurnAllSystemOutputsOffErrorResponse
  | TurnAllSystemOutputsOffSuccessResponse;

export type TurnAllSystemOutputsOffSuccessResponse = {
  readonly __typename?: "TurnAllSystemOutputsOffSuccessResponse";
  readonly system: ControlSystem;
};

export type TurnAllSystemOutputsOnErrorResponse = {
  readonly __typename?: "TurnAllSystemOutputsOnErrorResponse";
  readonly error: Error;
};

export type TurnAllSystemOutputsOnResponse =
  | TurnAllSystemOutputsOnErrorResponse
  | TurnAllSystemOutputsOnSuccessResponse;

export type TurnAllSystemOutputsOnSuccessResponse = {
  readonly __typename?: "TurnAllSystemOutputsOnSuccessResponse";
  readonly system: ControlSystem;
};

export type TurnOutputOffErrorResponse = {
  readonly __typename?: "TurnOutputOffErrorResponse";
  readonly error: Error;
};

export type TurnOutputOffResponse =
  | TurnOutputOffErrorResponse
  | TurnOutputOffSuccessResponse;

export type TurnOutputOffSuccessResponse = {
  readonly __typename?: "TurnOutputOffSuccessResponse";
  readonly output: Output;
};

export type TurnOutputOnErrorResponse = {
  readonly __typename?: "TurnOutputOnErrorResponse";
  readonly error: Error;
};

export type TurnOutputOnResponse =
  | TurnOutputOnErrorResponse
  | TurnOutputOnSuccessResponse;

export type TurnOutputOnSuccessResponse = {
  readonly __typename?: "TurnOutputOnSuccessResponse";
  readonly output: Output;
};

export type TurnSecureComCameraLightOffPayload = {
  readonly __typename?: "TurnSecureComCameraLightOffPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type TurnSecureComCameraLightOnPayload = {
  readonly __typename?: "TurnSecureComCameraLightOnPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type TwoFactorInvalidCodeError = Error & {
  readonly __typename?: "TwoFactorInvalidCodeError";
  readonly type: ErrorType;
};

export type TwoFactorMaxAttemptsReachedError = Error & {
  readonly __typename?: "TwoFactorMaxAttemptsReachedError";
  readonly type: ErrorType;
};

export type TwoFactorSessionExpiredError = Error & {
  readonly __typename?: "TwoFactorSessionExpiredError";
  readonly type: ErrorType;
};

export type TwoFactorSessionFailureError = Error & {
  readonly __typename?: "TwoFactorSessionFailureError";
  readonly type: ErrorType;
};

export type TwoFactorSettings = Node & {
  readonly __typename?: "TwoFactorSettings";
  readonly enabled: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly requiredByCustomer: Scalars["Boolean"];
  readonly requiredByDealer: Scalars["Boolean"];
  readonly validationMethod: ValidationMethod;
};

export type UnableToProgram734Error = Error & {
  readonly __typename?: "UnableToProgram734Error";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedBypassArmError = Error & {
  readonly __typename?: "UnauthorizedBypassArmError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedDisarmError = Error & {
  readonly __typename?: "UnauthorizedDisarmError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedError = Error & {
  readonly __typename?: "UnauthorizedError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedForceArmError = Error & {
  readonly __typename?: "UnauthorizedForceArmError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedRefuseArmError = Error & {
  readonly __typename?: "UnauthorizedRefuseArmError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedUnscheduledDisarmError = Error & {
  readonly __typename?: "UnauthorizedUnscheduledDisarmError";
  readonly type?: Maybe<ErrorType>;
};

export type UnauthorizedZoneBypassError = Error & {
  readonly __typename?: "UnauthorizedZoneBypassError";
  readonly type?: Maybe<ErrorType>;
};

export type UnhideFromVarHubEnabledCamerasListErrorPayload = {
  readonly __typename?: "UnhideFromVarHubEnabledCamerasListErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type UnhideFromVarHubEnabledCamerasListInput = {
  readonly unhideCamectCameraId?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]>>
  >;
};

export type UnhideFromVarHubEnabledCamerasListPayload =
  | UnhideFromVarHubEnabledCamerasListErrorPayload
  | UnhideFromVarHubEnabledCamerasListSuccessPayload;

export type UnhideFromVarHubEnabledCamerasListSuccessPayload = {
  readonly __typename?: "UnhideFromVarHubEnabledCamerasListSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type UnknownError = Error & {
  readonly __typename?: "UnknownError";
  readonly type?: Maybe<ErrorType>;
};

export type UnlockDoorMutationFailedResponse = {
  readonly __typename?: "UnlockDoorMutationFailedResponse";
  readonly error: Error;
  readonly message: Scalars["String"];
};

export type UnlockDoorMutationResponse =
  | UnlockDoorMutationFailedResponse
  | UnlockDoorMutationSuccessResponse;

export type UnlockDoorMutationSuccessResponse = {
  readonly __typename?: "UnlockDoorMutationSuccessResponse";
  readonly door: Door;
};

export type UnlockSiteDoorResponse =
  | FailedToUnlockSiteDoorError
  | NotFoundError
  | SiteDoor;

export type UnlockZwaveLockFailedResponse = {
  readonly __typename?: "UnlockZwaveLockFailedResponse";
  readonly error: Error;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UnlockZwaveLockResponse =
  | UnlockZwaveLockFailedResponse
  | UnlockZwaveLockSuccessResponse;

export type UnlockZwaveLockSuccessResponse = {
  readonly __typename?: "UnlockZwaveLockSuccessResponse";
  readonly zwaveLock: ZwaveLock;
};

export type UnprogrammedFavorite = Node &
  OutputOption & {
    readonly __typename?: "UnprogrammedFavorite";
    readonly formattedNumber: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly number: Scalars["Int"];
  };

export type UnprogrammedOutput = Node &
  OutputOption & {
    readonly __typename?: "UnprogrammedOutput";
    readonly formattedNumber: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly number: Scalars["Int"];
  };

export type UnsupportedDeviceTypeError = Error & {
  readonly __typename?: "UnsupportedDeviceTypeError";
  readonly controlSystemSerialNumbers: ReadonlyArray<Scalars["String"]>;
  readonly type?: Maybe<ErrorType>;
};

export type UnusedZoneError = Error & {
  readonly __typename?: "UnusedZoneError";
  readonly type?: Maybe<ErrorType>;
};

export type UpdateAlarmZoneErrorPayload = {
  readonly __typename?: "UpdateAlarmZoneErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateAlarmZonePayload =
  | UpdateAlarmZoneErrorPayload
  | UpdateAlarmZoneSuccessPayload;

export type UpdateAlarmZoneSuccessPayload = {
  readonly __typename?: "UpdateAlarmZoneSuccessPayload";
  readonly zoneNumber?: Maybe<Scalars["Int"]>;
};

export type UpdateAutoEnrollDefaultsErrorResult = {
  readonly __typename?: "UpdateAutoEnrollDefaultsErrorResult";
  readonly error: AutoEnrollErrorType;
  readonly message: Scalars["String"];
};

export type UpdateAutoEnrollDefaultsInput = {
  readonly activateAtt: Scalars["Boolean"];
  readonly activateVerizon: Scalars["Boolean"];
  readonly dealerId: Scalars["ID"];
  readonly firstIpAddress: Scalars["String"];
  readonly firstIpPort?: InputMaybe<Scalars["Int"]>;
  readonly remoteKey: Scalars["String"];
  readonly secondIpAddress: Scalars["String"];
  readonly secondIpPort?: InputMaybe<Scalars["Int"]>;
};

export type UpdateAutoEnrollDefaultsResult =
  | UpdateAutoEnrollDefaultsErrorResult
  | UpdateAutoEnrollDefaultsSuccessResult;

export type UpdateAutoEnrollDefaultsSuccessResult = {
  readonly __typename?: "UpdateAutoEnrollDefaultsSuccessResult";
  readonly dealer: Dealer;
};

export type UpdateCardFormatDefaultError = Error & {
  readonly __typename?: "UpdateCardFormatDefaultError";
  readonly type?: Maybe<ErrorType>;
};

export type UpdateCentralStationGlobalPasscodesInput = {
  readonly accessLevel?: InputMaybe<Scalars["String"]>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDuress?: InputMaybe<Scalars["Boolean"]>;
  readonly passcode: Scalars["String"];
};

export type UpdateCentralStationGlobalPasscodesResponse =
  | MutateCentralStationGlobalPasscodesErrorResponse
  | MutateCentralStationGlobalPasscodesSuccessResponse;

export type UpdateClipErrorPayload = {
  readonly __typename?: "UpdateClipErrorPayload";
  readonly error?: Maybe<Error>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateClipPayload =
  | UpdateClipErrorPayload
  | UpdateClipSuccessPayload;

export type UpdateClipSuccessPayload = {
  readonly __typename?: "UpdateClipSuccessPayload";
  readonly camera: ScapiV3CameraDetails;
};

export type UpdateContactInput = {
  readonly emailAddress: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly lastName: Scalars["String"];
  readonly phoneNumber: Scalars["PhoneNumber"];
  readonly userId?: InputMaybe<Scalars["ID"]>;
};

export type UpdateContactPayload = {
  readonly __typename?: "UpdateContactPayload";
  readonly contact: Contact;
  readonly contactEdge: ContactEdge;
};

export type UpdateControlSystemGroupErrorResponse = {
  readonly __typename?: "UpdateControlSystemGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdateControlSystemGroupResponse =
  | UpdateControlSystemGroupErrorResponse
  | UpdateControlSystemGroupSuccessResponse;

export type UpdateControlSystemGroupSuccessResponse = {
  readonly __typename?: "UpdateControlSystemGroupSuccessResponse";
  readonly customer?: Maybe<Customer>;
  readonly groupId: Scalars["Int"];
};

export type UpdateDealerCentralStationAutomationIntegrationError =
  | InvalidCredentialsError
  | NotFoundError
  | UnknownError;

export type UpdateDealerCentralStationAutomationIntegrationErrorResponse = {
  readonly __typename?: "UpdateDealerCentralStationAutomationIntegrationErrorResponse";
  readonly error: UpdateDealerCentralStationAutomationIntegrationError;
};

export type UpdateDealerCentralStationAutomationIntegrationInput = {
  readonly centralStationName?: InputMaybe<Scalars["String"]>;
  readonly cmsDealerNumber?: InputMaybe<Scalars["String"]>;
  readonly emergencyContactsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly id: Scalars["ID"];
  readonly password?: InputMaybe<Scalars["String"]>;
  readonly systemTestsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly username?: InputMaybe<Scalars["String"]>;
};

export type UpdateDealerCentralStationAutomationIntegrationResponse =
  | UpdateDealerCentralStationAutomationIntegrationErrorResponse
  | UpdateDealerCentralStationAutomationIntegrationSuccessResponse;

export type UpdateDealerCentralStationAutomationIntegrationSuccessResponse = {
  readonly __typename?: "UpdateDealerCentralStationAutomationIntegrationSuccessResponse";
  readonly dealer: Dealer;
  readonly integration: CentralStationAutomationIntegration;
};

export type UpdateDigitalWatchdogCameraPayload = {
  readonly __typename?: "UpdateDigitalWatchdogCameraPayload";
  readonly digitalWatchdogCamera?: Maybe<DigitalWatchdogCamera>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type UpdateDoorbellFirmwareErrorPayload = {
  readonly __typename?: "UpdateDoorbellFirmwareErrorPayload";
  readonly error: ErrorType;
  readonly message: Scalars["String"];
};

export type UpdateDoorbellFirmwarePayload =
  | UpdateDoorbellFirmwareErrorPayload
  | UpdateDoorbellFirmwareSuccessPayload;

export type UpdateDoorbellFirmwareSuccessPayload = {
  readonly __typename?: "UpdateDoorbellFirmwareSuccessPayload";
  readonly videoDoorbell: VideoDoorbell;
};

export type UpdateEmergencyContactInput = {
  readonly authorityLevel?: InputMaybe<Scalars["ID"]>;
  readonly emailAddress?: InputMaybe<Scalars["String"]>;
  readonly firstName: Scalars["String"];
  readonly hasKey?: InputMaybe<Scalars["Boolean"]>;
  readonly lastName: Scalars["String"];
  readonly phoneNumber: Scalars["String"];
  readonly phoneType?: InputMaybe<Scalars["String"]>;
  readonly relationship?: InputMaybe<Scalars["String"]>;
  readonly shouldContactBeforeDispatch: Scalars["Boolean"];
  readonly verbalPasscode: Scalars["String"];
};

export type UpdateEmergencyContactsErrorResponse = {
  readonly __typename?: "UpdateEmergencyContactsErrorResponse";
  readonly error: Error;
};

export type UpdateEmergencyContactsResponse =
  | UpdateEmergencyContactsErrorResponse
  | UpdateEmergencyContactsSuccessResponse;

export type UpdateEmergencyContactsSuccessResponse = {
  readonly __typename?: "UpdateEmergencyContactsSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly integration: ControlSystemCentralStationAutomationIntegration;
};

export type UpdateFavoriteErrorResponse = {
  readonly __typename?: "UpdateFavoriteErrorResponse";
  readonly error?: Maybe<Error>;
};

export type UpdateFavoriteResponse =
  | UpdateFavoriteErrorResponse
  | UpdateFavoriteSuccessResponse;

export type UpdateFavoriteSuccessResponse = {
  readonly __typename?: "UpdateFavoriteSuccessResponse";
  readonly system: ControlSystem;
};

export type UpdateFeatureKeyError = {
  readonly __typename?: "UpdateFeatureKeyError";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly error: ErrorType;
};

export type UpdateFeatureKeyPayload =
  | UpdateFeatureKeyError
  | UpdateFeatureKeySuccessPayload;

export type UpdateFeatureKeySuccessPayload = {
  readonly __typename?: "UpdateFeatureKeySuccessPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type UpdateGlobalHolidayDateForMassPanelsErrorResponse = {
  readonly __typename?: "UpdateGlobalHolidayDateForMassPanelsErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: GlobalHolidayDatesErrors;
};

export type UpdateGlobalHolidayDateForMassPanelsInput = {
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["String"];
  readonly dealerId: Scalars["Int"];
  readonly description: Scalars["String"];
  readonly name: Scalars["String"];
  readonly panelAssociation: ReadonlyArray<InputMaybe<Scalars["Int"]>>;
  readonly scapiId: Scalars["Int"];
};

export type UpdateGlobalHolidayDateForMassPanelsResponse =
  | UpdateGlobalHolidayDateForMassPanelsErrorResponse
  | UpdateGlobalHolidayDateForMassPanelsSuccessResponse;

export type UpdateGlobalHolidayDateForMassPanelsSuccessResponse = {
  readonly __typename?: "UpdateGlobalHolidayDateForMassPanelsSuccessResponse";
  readonly dealer?: Maybe<Dealer>;
};

export type UpdateGlobalHolidayDateForSinglePanelErrorResponse = {
  readonly __typename?: "UpdateGlobalHolidayDateForSinglePanelErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: GlobalHolidayDatesErrors;
};

export type UpdateGlobalHolidayDateForSinglePanelInput = {
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["String"];
  readonly dealerId: Scalars["Int"];
  readonly description: Scalars["String"];
  readonly name: Scalars["String"];
  readonly panelId: Scalars["Int"];
  readonly scapiId: Scalars["Int"];
};

export type UpdateGlobalHolidayDateForSinglePanelResponse =
  | UpdateGlobalHolidayDateForSinglePanelErrorResponse
  | UpdateGlobalHolidayDateForSinglePanelSuccessResponse;

export type UpdateGlobalHolidayDateForSinglePanelSuccessResponse = {
  readonly __typename?: "UpdateGlobalHolidayDateForSinglePanelSuccessResponse";
  readonly dealer?: Maybe<Dealer>;
  readonly system?: Maybe<ControlSystem>;
};

export type UpdateGroupErrorResponse = {
  readonly __typename?: "UpdateGroupErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GroupsError;
};

export type UpdateGroupResponse =
  | UpdateGroupErrorResponse
  | UpdateGroupSuccessResponse;

export type UpdateGroupSuccessResponse = {
  readonly __typename?: "UpdateGroupSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type UpdateHolidayDateInput = {
  readonly class: HolidayDateClass;
  readonly date: Scalars["Date"];
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
};

export type UpdateHolidayDateResponse =
  | FailedToUpdateHolidayDateError
  | HolidayDateNotPushedToSomeX1sError
  | NotFoundError
  | SiteHolidayDateResponse;

export type UpdateHubSettingsImmixCamera = {
  readonly camName?: InputMaybe<Scalars["String"]>;
  readonly camectCamId?: InputMaybe<Scalars["String"]>;
  readonly deviceId?: InputMaybe<Scalars["Int"]>;
  readonly immixInput?: InputMaybe<Scalars["Int"]>;
};

export type UpdateIdpGroupsErrorResult = {
  readonly __typename?: "UpdateIdpGroupsErrorResult";
  readonly message: Scalars["String"];
};

export type UpdateIdpGroupsResult =
  | UpdateIdpGroupsErrorResult
  | UpdateIdpGroupsSuccessResult;

export type UpdateIdpGroupsSuccessResult = {
  readonly __typename?: "UpdateIdpGroupsSuccessResult";
  readonly success: Scalars["Boolean"];
};

export type UpdateMenuDisplayResponse =
  | SendMenuDisplayProgrammingErrorPayload
  | UpdateMenuDisplaySuccessResponse;

export type UpdateMenuDisplaySuccessResponse = {
  readonly __typename?: "UpdateMenuDisplaySuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type UpdateOutputOptionsInput = {
  readonly action: Scalars["String"];
  readonly option: Scalars["ID"];
  readonly systemId: Scalars["ID"];
};

export type UpdateOutputOptionsInputErrorResponse = {
  readonly __typename?: "UpdateOutputOptionsInputErrorResponse";
  readonly error?: Maybe<Error>;
};

export type UpdateOutputOptionsInputSuccessResponse = {
  readonly __typename?: "UpdateOutputOptionsInputSuccessResponse";
  readonly outputOptions: OutputOptions;
  readonly system: ControlSystem;
};

export type UpdateOutputOptionsResponse =
  | UpdateOutputOptionsInputErrorResponse
  | UpdateOutputOptionsInputSuccessResponse;

export type UpdatePanelHolidayDateErrorResponse = {
  readonly __typename?: "UpdatePanelHolidayDateErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: HolidayDatesErrors;
};

export type UpdatePanelHolidayDateInput = {
  readonly clazz: HolidayDateClass;
  readonly date: Scalars["String"];
  readonly description?: InputMaybe<Scalars["String"]>;
  readonly globalHolidayId?: InputMaybe<Scalars["Int"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly panelId: Scalars["Int"];
};

export type UpdatePanelHolidayDateResponse =
  | UpdatePanelHolidayDateErrorResponse
  | UpdatePanelHolidayDateSuccessResponse;

export type UpdatePanelHolidayDateSuccessResponse = {
  readonly __typename?: "UpdatePanelHolidayDateSuccessResponse";
  readonly controlSystem?: Maybe<ControlSystem>;
};

export type UpdatePanelIntegrationErrorPayload = {
  readonly __typename?: "UpdatePanelIntegrationErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type UpdatePanelIntegrationPayload =
  | UpdatePanelIntegrationErrorPayload
  | UpdatePanelIntegrationSuccessPayload;

export type UpdatePanelIntegrationSuccessPayload = {
  readonly __typename?: "UpdatePanelIntegrationSuccessPayload";
  readonly enabled?: Maybe<Scalars["Boolean"]>;
};

export type UpdatePanelModemFirmwareErrorResponse = {
  readonly __typename?: "UpdatePanelModemFirmwareErrorResponse";
  readonly error: UpdatePanelModemFirmwareErrors;
};

export enum UpdatePanelModemFirmwareErrors {
  FAILED_TO_UPDATE_MODEM = "FAILED_TO_UPDATE_MODEM",
  JOB_FAILED = "JOB_FAILED",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export type UpdatePanelModemFirmwareResponse =
  | UpdatePanelModemFirmwareErrorResponse
  | UpdatePanelModemFirmwareSuccessResponse;

export type UpdatePanelModemFirmwareSuccessResponse = {
  readonly __typename?: "UpdatePanelModemFirmwareSuccessResponse";
  readonly panel: Panel;
};

export type UpdatePanelPersonErrorResponse = {
  readonly __typename?: "UpdatePanelPersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdatePanelPersonResponse =
  | UpdatePanelPersonErrorResponse
  | UpdatePanelPersonSuccessResponse;

export type UpdatePanelPersonSuccessResponse = {
  readonly __typename?: "UpdatePanelPersonSuccessResponse";
  readonly person?: Maybe<PanelPerson>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type UpdatePcLogReportsErrorResponse = {
  readonly __typename?: "UpdatePcLogReportsErrorResponse";
  readonly errors: ReadonlyArray<SendError>;
};

export type UpdatePcLogReportsResponse =
  | UpdatePcLogReportsErrorResponse
  | UpdatePcLogReportsSuccessResponse;

export type UpdatePcLogReportsSuccessResponse = {
  readonly __typename?: "UpdatePcLogReportsSuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type UpdatePersonErrorResponse = {
  readonly __typename?: "UpdatePersonErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdatePersonResponse =
  | UpdatePersonErrorResponse
  | UpdatePersonSuccessResponse;

export type UpdatePersonSuccessResponse = {
  readonly __typename?: "UpdatePersonSuccessResponse";
  readonly personId?: Maybe<Scalars["ID"]>;
  readonly status?: Maybe<Scalars["String"]>;
  readonly system?: Maybe<ControlSystem>;
};

export type UpdateProfileErrorResponse = {
  readonly __typename?: "UpdateProfileErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdateProfileResponse =
  | UpdateProfileErrorResponse
  | UpdateProfileSuccessResponse;

export type UpdateProfileSuccessResponse = {
  readonly __typename?: "UpdateProfileSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type UpdateRuleInput = {
  readonly id: Scalars["ID"];
  readonly if: RuleTriggerInput;
  readonly name: Scalars["String"];
  readonly notifications: ReadonlyArray<RuleNotificationRecipientInput>;
  readonly schedule?: InputMaybe<RuleScheduleInput>;
  readonly then: RuleActionInput;
};

export type UpdateRuleResponse =
  | AlarmPanelIntegrationOutputSelectedError
  | FailedToUpdateRuleError
  | NotFoundError
  | Rule
  | RuleWouldCauseLoopError;

export type UpdateSavedReportResponse =
  | UnknownError
  | UpdateSavedReportSuccessPayload;

export type UpdateSavedReportSuccessPayload = {
  readonly __typename?: "UpdateSavedReportSuccessPayload";
  readonly savedReport: Report;
};

export type UpdateSecureComCameraErrorPayload = {
  readonly __typename?: "UpdateSecureComCameraErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateSecureComCameraFirmwareErrorPayload = {
  readonly __typename?: "UpdateSecureComCameraFirmwareErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateSecureComCameraFirmwarePayload =
  | UpdateSecureComCameraFirmwareErrorPayload
  | UpdateSecureComCameraFirmwareSuccessPayload;

export type UpdateSecureComCameraFirmwareSuccessPayload = {
  readonly __typename?: "UpdateSecureComCameraFirmwareSuccessPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
};

export type UpdateSecureComCameraPayload =
  | UpdateSecureComCameraErrorPayload
  | UpdateSecureComCameraSuccessPayload;

export type UpdateSecureComCameraSuccessPayload = {
  readonly __typename?: "UpdateSecureComCameraSuccessPayload";
  readonly secureComCamera?: Maybe<CameraAndDoorbell>;
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
};

export type UpdateSecureComDoorbellPayload = {
  readonly __typename?: "UpdateSecureComDoorbellPayload";
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly doorbell: SecureComDoorbell;
};

export type UpdateSecureComDoorbellResponse =
  | FailedToUpdateSecureComDoorbellError
  | NotFoundError
  | UpdateSecureComDoorbellPayload;

export type UpdateSiteCardFormatResponse =
  | NotFoundError
  | UpdateCardFormatDefaultError
  | UpdateSiteCardFormatSuccessResponse;

export type UpdateSiteCardFormatSuccessResponse = {
  readonly __typename?: "UpdateSiteCardFormatSuccessResponse";
  readonly cardFormat: CardFormat;
  readonly site?: Maybe<Site>;
};

export type UpdateSiteControlSystemDoorAlarmPanelInput = {
  readonly outputNumber: Scalars["Int"];
};

export type UpdateSiteControlSystemDoorResponse =
  | FailedToUpdateSiteDoorError
  | NotFoundError
  | SiteDoor;

export type UpdateSiteControlSystemInput = {
  /** null means no integration */
  readonly alarmPanelIntegration?: InputMaybe<UpdateSiteControlSystemDoorAlarmPanelInput>;
  readonly commType: ControlSystemCommType;
  readonly doors: ReadonlyArray<UpdateSiteControlSystemInputDoorInput>;
  readonly id: Scalars["ID"];
  readonly onboardOutput1?: InputMaybe<UpdateSiteOnboardOutputInput>;
  readonly onboardOutput2?: InputMaybe<UpdateSiteOnboardOutputInput>;
};

export type UpdateSiteControlSystemInputDoorInput = {
  readonly buzzer: Scalars["Boolean"];
  readonly doorForce: Scalars["Boolean"];
  readonly doorPropTime: Scalars["Int"];
  readonly doorSensor: Scalars["Boolean"];
  readonly fireExit: Scalars["Boolean"];
  readonly fireZone: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly includeInLockdown: Scalars["Boolean"];
  readonly led: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly osdpOrWiegand: OsdpOrWiegand;
  readonly requestToExit: Scalars["Boolean"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly unlockOnRex: Scalars["Boolean"];
};

export type UpdateSiteControlSystemOutputModuleError =
  | FailedToSaveOutputModuleError
  | FailedToSaveOutputsError
  | InvalidInputError
  | NotFoundError
  | UnknownError;

export type UpdateSiteControlSystemOutputModuleFailureResponse = {
  readonly __typename?: "UpdateSiteControlSystemOutputModuleFailureResponse";
  readonly error: UpdateSiteControlSystemOutputModuleError;
};

export type UpdateSiteControlSystemOutputModuleResponse =
  | UpdateSiteControlSystemOutputModuleFailureResponse
  | UpdateSiteControlSystemOutputModuleSuccessResponse;

export type UpdateSiteControlSystemOutputModuleSuccessResponse = {
  readonly __typename?: "UpdateSiteControlSystemOutputModuleSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly outputModule: SiteOutputModule;
};

export type UpdateSiteControlSystemResponse =
  | ControlSystemHasTooManyDoorsError
  | FailedToSaveOutputsError
  | FailedToUpdateControlSystemError
  | NotFoundError
  | UpdateSiteControlSystemSuccessResponse;

export type UpdateSiteControlSystemSuccessResponse = {
  readonly __typename?: "UpdateSiteControlSystemSuccessResponse";
  readonly controlSystem?: Maybe<SiteControlSystem>;
  readonly site?: Maybe<Site>;
};

export type UpdateSiteCredentialInput = {
  readonly active: Scalars["Boolean"];
  readonly deliveryTarget?: InputMaybe<Scalars["String"]>;
  readonly deliveryType?: InputMaybe<DigitalCardDeliveryType>;
  readonly externalNumber: Scalars["String"];
  readonly internalNumber?: InputMaybe<Scalars["String"]>;
  readonly isNew?: InputMaybe<Scalars["Boolean"]>;
  readonly temporary?: InputMaybe<SitePersonTemporaryInput>;
  readonly type?: InputMaybe<CredentialType>;
};

export type UpdateSiteDetailsFailedToSetSystemOptionsOnDoorsError = {
  readonly __typename?: "UpdateSiteDetailsFailedToSetSystemOptionsOnDoorsError";
  readonly totalFailures: Scalars["Int"];
};

export type UpdateSiteDetailsInput = {
  readonly address1: Scalars["String"];
  readonly address2: Scalars["String"];
  readonly armablePanelSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly badgePrintingEnabled: Scalars["Boolean"];
  readonly city: Scalars["String"];
  readonly country: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly nickname?: InputMaybe<Scalars["String"]>;
  readonly observesDaylightSavingsTime: Scalars["Boolean"];
  readonly postalCode: Scalars["String"];
  readonly showDoors: Scalars["Boolean"];
  readonly showElevators: Scalars["Boolean"];
  readonly showOutputs: Scalars["Boolean"];
  readonly showVideoServices: Scalars["Boolean"];
  readonly state: Scalars["String"];
  readonly timezoneOffset: Scalars["GMTOffset"];
};

export type UpdateSiteDetailsResponse =
  | InvalidInputError
  | InvalidSerialsError
  | NotFoundError
  | Site
  | UpdateSiteDetailsFailedToSetSystemOptionsOnDoorsError;

export type UpdateSiteDoorScheduleResponse =
  | FailedToUpdateScheduleError
  | NotFoundError
  | SiteDoorSchedule
  | SomeDoorsDidNotGetScheduleError;

export type UpdateSiteFirmwaresErrorPayload = {
  readonly __typename?: "UpdateSiteFirmwaresErrorPayload";
  readonly error: Error;
};

export type UpdateSiteFirmwaresPayload =
  | UpdateSiteFirmwaresErrorPayload
  | UpdateSiteFirmwaresSuccessPayload;

export type UpdateSiteFirmwaresSuccessPayload = {
  readonly __typename?: "UpdateSiteFirmwaresSuccessPayload";
  readonly site: Site;
};

export type UpdateSiteGroupInput = {
  readonly areas?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly armablePanelId?: InputMaybe<Scalars["String"]>;
  readonly authenticationType: X1Authorization;
  readonly disarmOnAccess: Scalars["Boolean"];
  readonly doors: ReadonlyArray<Scalars["ID"]>;
  readonly floors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly id: Scalars["ID"];
  readonly lockdownOverride: Scalars["Boolean"];
  readonly managerFirst?: InputMaybe<ManagerFirst>;
  readonly name: Scalars["String"];
  readonly swipeToArm: SwipeToArm;
  readonly times?: InputMaybe<ReadonlyArray<SiteGroupTimeInput>>;
};

export type UpdateSiteGroupResponse =
  | NotFoundError
  | UpdateSiteGroupSuccessResponse;

export type UpdateSiteGroupSuccessResponse = {
  readonly __typename?: "UpdateSiteGroupSuccessResponse";
  readonly group?: Maybe<SiteGroup>;
  readonly site?: Maybe<Site>;
};

export type UpdateSiteInput = {
  readonly address1?: InputMaybe<Scalars["String"]>;
  readonly address2?: InputMaybe<Scalars["String"]>;
  readonly cardFormats: ReadonlyArray<NewOrExistingCardFormatInput>;
  readonly city?: InputMaybe<Scalars["String"]>;
  readonly controlSystems?: InputMaybe<
    ReadonlyArray<UpdateSiteInputControlSystemInput>
  >;
  readonly country?: InputMaybe<Scalars["String"]>;
  readonly digitalWatchdogSpectrumEnabled: Scalars["Boolean"];
  readonly dmpDoorbellEnabled: Scalars["Boolean"];
  readonly eagleEyeEnabled: Scalars["Boolean"];
  readonly hikvisionDoorbellEnabled: Scalars["Boolean"];
  readonly hikvisionDoorbellTotal: Scalars["Int"];
  readonly hikvisionNvrEnabled: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly nickname?: InputMaybe<Scalars["String"]>;
  readonly observesDaylightSavingsTime?: InputMaybe<Scalars["Boolean"]>;
  readonly openEyeEnabled: Scalars["Boolean"];
  readonly postalCode?: InputMaybe<Scalars["String"]>;
  readonly securecomNvrEnabled: Scalars["Boolean"];
  readonly securecomVideoLevel: SecureComVideoLevel;
  readonly state?: InputMaybe<Scalars["String"]>;
  readonly timezoneOffset?: InputMaybe<Scalars["GMTOffset"]>;
  readonly videoEnabled: Scalars["Boolean"];
  readonly vueDoorbellsCount: Scalars["Int"];
  readonly vueDoorbellsEnabled: Scalars["Boolean"];
};

export type UpdateSiteInputControlSystemInput = {
  readonly doors?: InputMaybe<
    ReadonlyArray<UpdateSiteControlSystemInputDoorInput>
  >;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly serialNumber?: InputMaybe<Scalars["String"]>;
};

export type UpdateSiteOnboardOutputInput = {
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
};

export type UpdateSiteOutputInput = {
  readonly delete?: InputMaybe<Scalars["Boolean"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly relayNumber: Scalars["Int"];
};

export type UpdateSitePersonInput = {
  readonly data: DataInputForUpdatePerson;
  readonly requestMetaData: RequestMetaData;
  readonly siteId: Scalars["ID"];
  readonly title: Scalars["String"];
};

export type UpdateSitePersonResponse =
  | FailedToUpdateUserError
  | InvalidInputError
  | NotEnoughMobileCredentialsError
  | NotEnoughtDigitalCredentialsError
  | NotFoundError
  | UpdateSitePersonSuccessResponse;

export type UpdateSitePersonSuccessResponse = {
  readonly __typename?: "UpdateSitePersonSuccessResponse";
  readonly edge: SitePersonEdge;
  readonly person: CustomerPerson;
  readonly site: Site;
};

export type UpdateSiteReportInput = {
  readonly filters: SiteReportFiltersInput;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly schedule?: InputMaybe<SiteReportScheduleInput>;
};

export type UpdateSiteReportResponse =
  | NotFoundError
  | UpdateSiteReportSuccessPayload;

export type UpdateSiteReportSuccessPayload = {
  readonly __typename?: "UpdateSiteReportSuccessPayload";
  readonly report: SiteReport;
  readonly reportEdge: SiteReportEdge;
  readonly site?: Maybe<Site>;
};

export type UpdateSiteResponse =
  | FailedToAddControlSystemsError
  | InvalidSerialsError
  | NotFoundError
  | Site;

export type UpdateSiteScheduleInput = {
  readonly autoUnlockSuppress?: InputMaybe<Scalars["Boolean"]>;
  readonly doors: ReadonlyArray<Scalars["ID"]>;
  readonly endTime: Scalars["String"];
  readonly floors?: InputMaybe<ReadonlyArray<Scalars["ID"]>>;
  readonly friday: Scalars["Boolean"];
  readonly holidayA?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayB?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly holidayC?: InputMaybe<SiteHolidayDateScheduleInput>;
  readonly id: Scalars["ID"];
  readonly monday: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly saturday: Scalars["Boolean"];
  readonly startTime: Scalars["String"];
  readonly sunday: Scalars["Boolean"];
  readonly temporary?: InputMaybe<SiteDoorScheduleTempInput>;
  readonly thursday: Scalars["Boolean"];
  readonly tuesday: Scalars["Boolean"];
  readonly wednesday: Scalars["Boolean"];
};

export type UpdateSiteVideoIntegrationsResponse = NotFoundError | Site;

export type UpdateStatusListDisplayErrorResponse = {
  readonly __typename?: "UpdateStatusListDisplayErrorResponse";
  readonly errors: ReadonlyArray<SendError>;
};

export type UpdateStatusListDisplayResponse =
  | UpdateStatusListDisplayErrorResponse
  | UpdateStatusListDisplaySuccessResponse;

export type UpdateStatusListDisplaySuccessResponse = {
  readonly __typename?: "UpdateStatusListDisplaySuccessResponse";
  readonly controlSystem: ControlSystem;
};

export type UpdateUserCodeErrorResponse = {
  readonly __typename?: "UpdateUserCodeErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdateUserCodeResponse =
  | UpdateUserCodeErrorResponse
  | UpdateUserCodeSuccessResponse;

export type UpdateUserCodeSuccessResponse = {
  readonly __typename?: "UpdateUserCodeSuccessResponse";
  readonly status?: Maybe<Scalars["String"]>;
  readonly userCode?: Maybe<UserCode>;
};

export type UpdateVarHubCameraCredentialsErrorPayload = {
  readonly __typename?: "UpdateVarHubCameraCredentialsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type UpdateVarHubCameraCredentialsInput = {
  readonly camectCamId: Scalars["String"];
  readonly password: Scalars["String"];
  readonly username: Scalars["String"];
};

export type UpdateVarHubCameraCredentialsPayload =
  | UpdateVarHubCameraCredentialsErrorPayload
  | UpdateVarHubCameraCredentialsSuccessPayload;

export type UpdateVarHubCameraCredentialsSuccessPayload = {
  readonly __typename?: "UpdateVarHubCameraCredentialsSuccessPayload";
  readonly hubs: ReadonlyArray<VarHub>;
};

export type UpdateVarHubCameraErrorPayload = {
  readonly __typename?: "UpdateVarHubCameraErrorPayload";
  readonly error?: Maybe<Error>;
};

export type UpdateVarHubCameraInput = {
  readonly audioDeviceIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["ID"]>>
  >;
  readonly availableInVideoVerification?: InputMaybe<Scalars["Boolean"]>;
  readonly cameraDatabaseId: Scalars["Int"];
  readonly cameraDescription?: InputMaybe<Scalars["String"]>;
  readonly cameraName?: InputMaybe<Scalars["String"]>;
  readonly deWarp?: InputMaybe<Scalars["Boolean"]>;
  readonly detectionLines?: InputMaybe<
    ReadonlyArray<VarHubCameraDetectionLineInput>
  >;
  readonly detectionRegions?: InputMaybe<
    ReadonlyArray<VarHubCameraDetectionRegionInput>
  >;
  readonly id: Scalars["ID"];
  readonly ipAddress?: InputMaybe<Scalars["String"]>;
  readonly mediaProfile?: InputMaybe<MediaProfileInput>;
  readonly showInKeypad?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateVarHubCameraPayload =
  | UpdateVarHubCameraErrorPayload
  | UpdateVarHubCameraSuccessPayload;

export type UpdateVarHubCameraSuccessPayload = {
  readonly __typename?: "UpdateVarHubCameraSuccessPayload";
  readonly varHubCamera?: Maybe<VarConnectedCamera>;
};

export type UpdateVarHubErrorPayload = {
  readonly __typename?: "UpdateVarHubErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type UpdateVarHubInput = {
  readonly cameras?: InputMaybe<
    ReadonlyArray<InputMaybe<UpdateVarHubLoiteringCameraInput>>
  >;
  readonly disableAutoAddCameras?: InputMaybe<Scalars["Boolean"]>;
  readonly hubId: Scalars["String"];
  readonly hubName: Scalars["String"];
  readonly monitoringCenterAudioEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly panelIntegrationGatewayIpAddress?: InputMaybe<Scalars["String"]>;
  readonly panelIntegrationPanelDiscoveryEnabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  readonly panelIntegrationPanelIpAddress?: InputMaybe<Scalars["String"]>;
  readonly proFeatures?: InputMaybe<Scalars["Boolean"]>;
  readonly secondaryNetworkIP?: InputMaybe<Scalars["String"]>;
  readonly secondaryNetworkSubnetMask?: InputMaybe<Scalars["String"]>;
  readonly secondaryNetworkType?: InputMaybe<Scalars["String"]>;
  readonly systemId: Scalars["String"];
  readonly timeLocation?: InputMaybe<Scalars["String"]>;
};

export type UpdateVarHubLoiteringCameraInput = {
  readonly addedToDB?: InputMaybe<Scalars["Boolean"]>;
  readonly camectCamId?: InputMaybe<Scalars["String"]>;
  readonly cameraId?: InputMaybe<Scalars["Int"]>;
  readonly cameraName?: InputMaybe<Scalars["String"]>;
  readonly detectionLines?: InputMaybe<
    ReadonlyArray<InputMaybe<VarHubCameraDetectionLineInput>>
  >;
  readonly detectionRegions?: InputMaybe<
    ReadonlyArray<InputMaybe<VarHubCameraDetectionRegionInput>>
  >;
  readonly id: Scalars["ID"];
  readonly ipAddress?: InputMaybe<Scalars["String"]>;
};

export type UpdateVarHubPayload =
  | UpdateVarHubErrorPayload
  | UpdateVarHubSuccessPayload;

export type UpdateVarHubSettingsErrorPayload = {
  readonly __typename?: "UpdateVarHubSettingsErrorPayload";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type?: Maybe<Scalars["String"]>;
};

export type UpdateVarHubSettingsInput = {
  readonly deviceId?: InputMaybe<Scalars["Int"]>;
  readonly disableAutoAddCameras?: InputMaybe<Scalars["Boolean"]>;
  readonly immixCams?: InputMaybe<
    ReadonlyArray<InputMaybe<UpdateHubSettingsImmixCamera>>
  >;
  readonly immixEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly panelIntegrationGatewayIpAddress?: InputMaybe<Scalars["String"]>;
  readonly panelIntegrationPanelDiscoveryEnabled?: InputMaybe<
    Scalars["Boolean"]
  >;
  readonly panelIntegrationPanelIpAddress?: InputMaybe<Scalars["String"]>;
  readonly password?: InputMaybe<Scalars["String"]>;
  readonly recipientDomain?: InputMaybe<Scalars["String"]>;
  readonly sendAutoSuppression?: InputMaybe<Scalars["Boolean"]>;
  readonly smtpPort?: InputMaybe<Scalars["Int"]>;
  readonly smtpServer?: InputMaybe<Scalars["String"]>;
  readonly user?: InputMaybe<Scalars["String"]>;
};

export type UpdateVarHubSettingsPayload =
  | UpdateVarHubSettingsErrorPayload
  | UpdateVarHubSettingsSuccessPayload;

export type UpdateVarHubSettingsSuccessPayload = {
  readonly __typename?: "UpdateVarHubSettingsSuccessPayload";
  readonly status: Scalars["String"];
};

export type UpdateVarHubSuccessPayload = {
  readonly __typename?: "UpdateVarHubSuccessPayload";
  readonly status: Scalars["String"];
};

export type UpdateVarVideoActionErrorResponse = {
  readonly __typename?: "UpdateVarVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdateVarVideoActionInput = {
  readonly areaNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraId: Scalars["Int"];
  readonly deviceNumber?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly type: VarVideoActionType;
  readonly zoneNumber?: InputMaybe<Scalars["String"]>;
};

export type UpdateVarVideoActionResponse =
  | UpdateVarVideoActionErrorResponse
  | UpdateVarVideoActionSuccessResponse;

export type UpdateVarVideoActionSuccessResponse = {
  readonly __typename?: "UpdateVarVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
  readonly varVideoAction?: Maybe<VarVideoAction>;
};

export type UpdateVideoActionErrorResponse = {
  readonly __typename?: "UpdateVideoActionErrorResponse";
  readonly message?: Maybe<Scalars["String"]>;
  readonly type: GenericError;
};

export type UpdateVideoActionInput = {
  readonly areaNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraId: Scalars["Int"];
  readonly deviceNumber?: InputMaybe<Scalars["String"]>;
  readonly deviceType?: InputMaybe<VideoDeviceTypeName>;
  readonly groupId?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly type: VideoActionType;
  readonly zoneNumber?: InputMaybe<Scalars["String"]>;
};

export type UpdateVideoActionResponse =
  | UpdateVideoActionErrorResponse
  | UpdateVideoActionSuccessResponse;

export type UpdateVideoActionSuccessResponse = {
  readonly __typename?: "UpdateVideoActionSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type UpdateVideoDoorbellErrorPayload = {
  readonly __typename?: "UpdateVideoDoorbellErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateVideoDoorbellPayload =
  | UpdateVideoDoorbellErrorPayload
  | UpdateVideoDoorbellSuccessPayload;

export type UpdateVideoDoorbellSuccessPayload = {
  readonly __typename?: "UpdateVideoDoorbellSuccessPayload";
  readonly videoChannelEdge?: Maybe<ControlSystemVideoChannelEdge>;
  readonly videoDoorbell?: Maybe<VideoDoorbell>;
};

export type UpdateVueCameraErrorPayload = {
  readonly __typename?: "UpdateVueCameraErrorPayload";
  readonly error?: Maybe<ErrorType>;
  readonly message?: Maybe<Scalars["String"]>;
};

export type UpdateVueCameraPayload =
  | UpdateVueCameraErrorPayload
  | UpdateVueCameraSuccessPayload;

export type UpdateVueCameraSuccessPayload = {
  readonly __typename?: "UpdateVueCameraSuccessPayload";
  readonly secureComCamera?: Maybe<SecureComCamera>;
};

export type UpdateXfUserCodeInput = {
  readonly armOnly: Scalars["Boolean"];
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly temp: Scalars["Boolean"];
  readonly userLevel: UserCodeLevel;
};

export type UpdateXvAudioDeviceCredentialsErrorResponse = {
  readonly __typename?: "UpdateXvAudioDeviceCredentialsErrorResponse";
  readonly type: XvAudioDeviceResponseErrors;
};

export type UpdateXvAudioDeviceCredentialsInput = {
  readonly id: Scalars["ID"];
  readonly password?: InputMaybe<Scalars["String"]>;
  readonly username: Scalars["String"];
};

export type UpdateXvAudioDeviceCredentialsResponse =
  | UpdateXvAudioDeviceCredentialsErrorResponse
  | UpdateXvAudioDeviceCredentialsSuccessResponse;

export type UpdateXvAudioDeviceCredentialsSuccessResponse = {
  readonly __typename?: "UpdateXvAudioDeviceCredentialsSuccessResponse";
  readonly system?: Maybe<ControlSystem>;
};

export type UploadOsdpConfigErrorPayload = {
  readonly __typename?: "UploadOSDPConfigErrorPayload";
  readonly errors: ReadonlyArray<SendError>;
};

export type UploadOsdpConfigInput = {
  readonly base64ConfigFile: Scalars["String"];
  readonly deviceNumbers: Scalars["String"];
  readonly readers?: InputMaybe<ReadonlyArray<OsdpReaderInput>>;
  readonly systemId: Scalars["ID"];
};

export type UploadOsdpConfigPayload =
  | UploadOsdpConfigErrorPayload
  | UploadOsdpConfigSuccessPayload;

export type UploadOsdpConfigSuccessPayload = {
  readonly __typename?: "UploadOSDPConfigSuccessPayload";
  readonly controlSystem: ControlSystem;
  readonly jobId: Scalars["String"];
};

export type User = {
  readonly accessibleId: Scalars["Int"];
  readonly accessibleType: AccessibleType;
  readonly email: Scalars["EmailAddress"];
  readonly firstName: Scalars["String"];
  readonly hidden: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly lastName: Scalars["String"];
  readonly lastSignInAt?: Maybe<Scalars["DateTime"]>;
  readonly lockedAt?: Maybe<Scalars["DateTime"]>;
  readonly person: Person;
  readonly phoneNumber?: Maybe<Scalars["String"]>;
  readonly ssoOnly?: Maybe<Scalars["Boolean"]>;
  readonly twoFactorSettings?: Maybe<TwoFactorSettings>;
};

export type UserCode = {
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly credential: Credential;
  readonly credentialId: Scalars["String"];
  readonly expireTime?: Maybe<Scalars["DateTime"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly personId?: Maybe<Scalars["String"]>;
  readonly tempUser?: Maybe<Scalars["Boolean"]>;
};

export enum UserCodeAction {
  CREATE = "CREATE",
  DELETE = "DELETE",
  NONE = "NONE",
  UPDATE = "UPDATE",
}

export enum UserCodeImportMissingFieldNames {
  EMAIL = "EMAIL",
  FIRST_NAME = "FIRST_NAME",
  GROUP = "GROUP",
  GROUP_NAME = "GROUP_NAME",
  INTERNAL_NUMBER = "INTERNAL_NUMBER",
  LAST_NAME = "LAST_NAME",
}

export enum UserCodeLevel {
  MASTER = "MASTER",
  STANDARD = "STANDARD",
}

export enum UserContactType {
  PRIMARY = "PRIMARY",
  REGULAR = "REGULAR",
  SECONDARY = "SECONDARY",
}

export enum UserNotPushedToX1Reason {
  INTERNAL_NUMBER_ALREADY_TAKEN = "INTERNAL_NUMBER_ALREADY_TAKEN",
  UNKNOWN = "UNKNOWN",
}

export type UserNumberRange = {
  readonly __typename?: "UserNumberRange";
  readonly max: Scalars["Int"];
  readonly min: Scalars["Int"];
};

export type UserPermissions = Node & {
  readonly __typename?: "UserPermissions";
  readonly armingEnabled: Scalars["Boolean"];
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly id: Scalars["ID"];
  readonly multiPanelProfilesEnabled: Scalars["Boolean"];
  readonly multiPanelSchedulesEnabled: Scalars["Boolean"];
  readonly multiPanelUserCodesEnabled: Scalars["Boolean"];
  readonly remotePanicEmergencyEnabled: Scalars["Boolean"];
  readonly remotePanicFireEnabled: Scalars["Boolean"];
  readonly remotePanicPoliceEnabled: Scalars["Boolean"];
  readonly reportsEnabled: Scalars["Boolean"];
  readonly viewStoredUserCodes: Scalars["Boolean"];
};

export enum UserRole {
  ACCESS_ONLY = "ACCESS_ONLY",
  ADMIN = "ADMIN",
  STANDARD = "STANDARD",
}

export enum UserSaveStatus {
  DELETED = "DELETED",
  DELETING = "DELETING",
  ERROR = "ERROR",
  IDLE = "IDLE",
  LOADING = "LOADING",
  SAVED = "SAVED",
  SAVING = "SAVING",
}

export enum UsersAccessibleType {
  CUSTOMER = "CUSTOMER",
  DEALER = "DEALER",
  SUPERVISOR = "SUPERVISOR",
}

export type UsersAuthDataInput = {
  readonly accessibleId: Scalars["String"];
  readonly authToken: Scalars["String"];
};

export type VsCameraDetails = Node & {
  readonly __typename?: "VSCameraDetails";
  readonly ceilingMount?: Maybe<Scalars["Boolean"]>;
  readonly channelId?: Maybe<Scalars["Int"]>;
  readonly channelUuid?: Maybe<Scalars["String"]>;
  readonly createdAt?: Maybe<Scalars["String"]>;
  readonly eventInterval?: Maybe<Scalars["Int"]>;
  readonly eventsEnabled?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly moveable?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly number?: Maybe<Scalars["Int"]>;
  readonly recordOnAlarm?: Maybe<Scalars["Boolean"]>;
  readonly snapshotUrl?: Maybe<Scalars["String"]>;
  readonly streamQuality?: Maybe<Scalars["String"]>;
  readonly streamUrl?: Maybe<Scalars["String"]>;
  readonly updatedAt?: Maybe<Scalars["String"]>;
  readonly videoDeviceId?: Maybe<Scalars["Int"]>;
};

export type VvLocation = {
  readonly host: Scalars["String"];
  readonly port: Scalars["String"];
};

export type ValidateTwoFactorCodeError =
  | TwoFactorInvalidCodeError
  | TwoFactorMaxAttemptsReachedError
  | TwoFactorSessionExpiredError
  | TwoFactorSessionFailureError
  | UnknownError;

export type ValidateTwoFactorCodeErrorResponse = {
  readonly __typename?: "ValidateTwoFactorCodeErrorResponse";
  readonly error: ValidateTwoFactorCodeError;
};

export type ValidateTwoFactorCodePasswordChangeTokenResponse = {
  readonly __typename?: "ValidateTwoFactorCodePasswordChangeTokenResponse";
  readonly token: Scalars["String"];
};

export type ValidateTwoFactorCodeResponse =
  | ValidateTwoFactorCodeErrorResponse
  | ValidateTwoFactorCodePasswordChangeTokenResponse
  | ValidateTwoFactorCodeSuccessResponse
  | ValidateTwoFactorCodeSuccessResponseWithBearerToken;

export type ValidateTwoFactorCodeSuccessResponse = {
  readonly __typename?: "ValidateTwoFactorCodeSuccessResponse";
  readonly users: ReadonlyArray<AuthenticateUserPayload>;
};

export type ValidateTwoFactorCodeSuccessResponseUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type ValidateTwoFactorCodeSuccessResponseWithBearerToken = {
  readonly __typename?: "ValidateTwoFactorCodeSuccessResponseWithBearerToken";
  readonly users: ReadonlyArray<AuthenticatedV4UserPayload>;
};

export type ValidateTwoFactorCodeSuccessResponseWithBearerTokenUsersArgs = {
  accessibleType?: InputMaybe<ReadonlyArray<UsersAccessibleType>>;
};

export type ValidationError = Error & {
  readonly __typename?: "ValidationError";
  readonly type: ErrorType;
};

export enum ValidationMethod {
  EMAIL = "EMAIL",
  NONE = "NONE",
  SMS = "SMS",
}

export type VarConnectedCamera = Node & {
  readonly __typename?: "VarConnectedCamera";
  readonly adminPassword?: Maybe<Scalars["String"]>;
  readonly adminUserName?: Maybe<Scalars["String"]>;
  readonly availableInVideoVerification: Scalars["Boolean"];
  readonly availableMediaProfiles: ReadonlyArray<MediaProfile>;
  readonly camectCameraId: Scalars["String"];
  readonly camectHubId: Scalars["String"];
  readonly cameraDescription?: Maybe<Scalars["String"]>;
  readonly cameraName: Scalars["String"];
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly databaseCameraId: Scalars["Int"];
  readonly databaseHubId: Scalars["Int"];
  readonly deWarp: Scalars["Boolean"];
  readonly detectionLines: ReadonlyArray<VarHubCameraDetectionLine>;
  readonly detectionRegions: ReadonlyArray<VarHubCameraDetectionRegion>;
  readonly endBufferMs: Scalars["Int"];
  readonly height: Scalars["Int"];
  readonly hubId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly isStreaming: Scalars["Boolean"];
  readonly macAddress: Scalars["String"];
  readonly maxRegionX: Scalars["Int"];
  readonly maxRegionY: Scalars["Int"];
  readonly mediaProfile?: Maybe<MediaProfile>;
  readonly megapixels: Scalars["Int"];
  readonly minRegionX: Scalars["Int"];
  readonly minRegionY: Scalars["Int"];
  readonly playerAuthToken: Scalars["String"];
  readonly playerUrl: Scalars["String"];
  readonly rtspUrl?: Maybe<Scalars["String"]>;
  readonly showInKeypad: Scalars["Boolean"];
  readonly snapshot?: Maybe<Scalars["String"]>;
  readonly startBufferMs: Scalars["Int"];
  readonly timeLocation: Scalars["String"];
  readonly varHub?: Maybe<VarHub>;
  readonly width: Scalars["Int"];
};

export type VarHub = Node & {
  readonly __typename?: "VarHub";
  readonly aiModelVersion: Scalars["String"];
  readonly camectHubId: Scalars["String"];
  readonly cameras: ReadonlyArray<VarHubCamera>;
  readonly currentDiagnostics?: Maybe<VarHubCurrentDiagnostics>;
  readonly disableAutoAddCameras?: Maybe<Scalars["Boolean"]>;
  readonly hardwareModel: Scalars["String"];
  readonly hardwareModelDisplayName: Scalars["String"];
  readonly hubId: Scalars["Int"];
  readonly hubName: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly immixIntegrationEnabled: Scalars["Boolean"];
  readonly isOnline: Scalars["Boolean"];
  readonly isPanelConnected?: Maybe<Scalars["Boolean"]>;
  readonly lastUpdatedAt?: Maybe<Scalars["String"]>;
  readonly macAddress: Scalars["String"];
  readonly maxDetectionLines: Scalars["Int"];
  readonly maxDetectionRegions: Scalars["Int"];
  readonly megapixelThresholdCritical: Scalars["Boolean"];
  readonly megapixelThresholdWarning: Scalars["Boolean"];
  readonly monitoringCenterAudioEnabled: Scalars["Boolean"];
  readonly osVersion: Scalars["String"];
  readonly ownerEmail: Scalars["String"];
  readonly panelConnectionEnabled?: Maybe<Scalars["Boolean"]>;
  readonly panelConnectionStatus: VarHubPanelConnectionStatus;
  readonly panelIntegrationGatewayIpAddress: Scalars["String"];
  readonly panelIntegrationLastInbound: Scalars["String"];
  readonly panelIntegrationLastOutbound: Scalars["String"];
  readonly panelIntegrationPanelDiscoveryEnabled?: Maybe<Scalars["Boolean"]>;
  readonly panelIntegrationPanelIpAddress: Scalars["String"];
  readonly panelIntegrationSystemUptime: Scalars["String"];
  readonly panelIntegrationUptime: Scalars["String"];
  readonly panelIntegrationVersion: Scalars["String"];
  readonly privateIp: Scalars["String"];
  readonly proFeatures: Scalars["Boolean"];
  readonly recentDiagnostics?: Maybe<VarHubRecentDiagnostics>;
  readonly secondaryNetworkIP: Scalars["String"];
  readonly secondaryNetworkSubnetMask: Scalars["String"];
  readonly secondaryNetworkType: Scalars["String"];
  readonly softwareVersion: Scalars["String"];
  readonly supportedMegapixels: Scalars["Int"];
  readonly systemId: Scalars["Int"];
  readonly timeLocation: Scalars["String"];
  readonly unsupportedCodec: Scalars["Boolean"];
  readonly unsupportedFrameRate: Scalars["Boolean"];
};

export type VarHubCamera = Node & {
  readonly __typename?: "VarHubCamera";
  readonly addedToDB: Scalars["Boolean"];
  readonly adminPassword?: Maybe<Scalars["String"]>;
  readonly adminUserName?: Maybe<Scalars["String"]>;
  readonly camectCamId: Scalars["String"];
  readonly camectHubId: Scalars["String"];
  readonly cameraDescription?: Maybe<Scalars["String"]>;
  /** Camera id from database */
  readonly cameraId?: Maybe<Scalars["Int"]>;
  readonly cameraName: Scalars["String"];
  readonly connectedAudioDevices: ReadonlyArray<Maybe<XvAudioDevice>>;
  readonly detectionLines: ReadonlyArray<Maybe<VarHubCameraDetectionLine>>;
  readonly detectionRegions: ReadonlyArray<Maybe<VarHubCameraDetectionRegion>>;
  readonly framesPerSecond: Scalars["Int"];
  readonly height: Scalars["Int"];
  readonly hubId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly ipAddress: Scalars["String"];
  readonly isEnabled: Scalars["Boolean"];
  readonly isHidden: Scalars["Boolean"];
  readonly isScapiCamera: Scalars["Boolean"];
  readonly isStreaming: Scalars["Boolean"];
  readonly macAddress: Scalars["String"];
  readonly make?: Maybe<Scalars["String"]>;
  readonly manuallyAdded: Scalars["Boolean"];
  readonly megapixels: Scalars["Int"];
  readonly needsCredential: Scalars["Boolean"];
  /** Passed to the camect player to connect to stream, different from regular auth_token */
  readonly playerAuthToken: Scalars["String"];
  readonly playerUrl: Scalars["String"];
  readonly rtspUrl?: Maybe<Scalars["String"]>;
  readonly scapiCameraId?: Maybe<Scalars["Int"]>;
  readonly snapshot?: Maybe<Scalars["String"]>;
  readonly videoCodec: Scalars["String"];
  readonly width: Scalars["Int"];
};

export type VarHubCameraDetectionLine = Node & {
  readonly __typename?: "VarHubCameraDetectionLine";
  readonly audioTalkDownFilename?: Maybe<AudioTalkDownFilenameType>;
  readonly audioTalkDownRepeats?: Maybe<Scalars["Int"]>;
  readonly detectAnimals: Scalars["Boolean"];
  readonly detectPeople: Scalars["Boolean"];
  readonly detectVehicles: Scalars["Boolean"];
  readonly drawRegionOnAlerts: Scalars["Boolean"];
  readonly geometry: VarHubCameraLineGeometry;
  readonly id: Scalars["ID"];
  readonly movementDirection?: Maybe<DirectionOfTravel>;
  readonly name: Scalars["String"];
  readonly slotNumber?: Maybe<Scalars["Int"]>;
  readonly zone?: Maybe<Zone>;
};

export type VarHubCameraDetectionLineInput = {
  readonly audioTalkDownFilename?: InputMaybe<AudioTalkDownFilenameType>;
  readonly audioTalkDownRepeats?: InputMaybe<Scalars["Int"]>;
  readonly detectAnimals?: InputMaybe<Scalars["Boolean"]>;
  readonly detectPeople?: InputMaybe<Scalars["Boolean"]>;
  readonly detectVehicles?: InputMaybe<Scalars["Boolean"]>;
  readonly drawRegionOnAlerts?: InputMaybe<Scalars["Boolean"]>;
  readonly geometry?: InputMaybe<VarHubCameraLineGeometryInput>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly movementDirection?: InputMaybe<DirectionOfTravel>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly slotNumber?: InputMaybe<Scalars["Int"]>;
  readonly zone?: InputMaybe<VarHubCameraZoneInput>;
};

export type VarHubCameraDetectionRegion = Node & {
  readonly __typename?: "VarHubCameraDetectionRegion";
  readonly audioTalkDownFilename?: Maybe<AudioTalkDownFilenameType>;
  readonly audioTalkDownRepeats?: Maybe<Scalars["Int"]>;
  readonly detectAnimals: Scalars["Boolean"];
  readonly detectPeople: Scalars["Boolean"];
  readonly detectVehicles: Scalars["Boolean"];
  readonly drawRegionOnAlerts: Scalars["Boolean"];
  readonly geometry: VarHubCameraRegionGeometry;
  readonly id: Scalars["ID"];
  readonly lightTimeout?: Maybe<Scalars["Int"]>;
  readonly loiteringPersonSeconds?: Maybe<Scalars["Int"]>;
  readonly loiteringVehicleSeconds?: Maybe<Scalars["Int"]>;
  readonly movementDirection?: Maybe<DirectionOfTravel>;
  readonly name: Scalars["String"];
  readonly redBlueLights: Scalars["Boolean"];
  readonly slotNumber?: Maybe<Scalars["Int"]>;
  readonly whiteLights: Scalars["Boolean"];
  readonly zone?: Maybe<Zone>;
};

export type VarHubCameraDetectionRegionInput = {
  readonly audioTalkDownFilename?: InputMaybe<AudioTalkDownFilenameType>;
  readonly audioTalkDownRepeats?: InputMaybe<Scalars["Int"]>;
  readonly detectAnimals?: InputMaybe<Scalars["Boolean"]>;
  readonly detectPeople?: InputMaybe<Scalars["Boolean"]>;
  readonly detectVehicles?: InputMaybe<Scalars["Boolean"]>;
  readonly drawRegionOnAlerts?: InputMaybe<Scalars["Boolean"]>;
  readonly geometry?: InputMaybe<VarHubCameraRegionGeometryInput>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly lightTimeout?: InputMaybe<Scalars["Int"]>;
  readonly loiteringPersonSeconds?: InputMaybe<Scalars["Int"]>;
  readonly loiteringVehicleSeconds?: InputMaybe<Scalars["Int"]>;
  readonly movementDirection?: InputMaybe<DirectionOfTravel>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly redBlueLights?: InputMaybe<Scalars["Boolean"]>;
  readonly slotNumber?: InputMaybe<Scalars["Int"]>;
  readonly whiteLights?: InputMaybe<Scalars["Boolean"]>;
  readonly zone?: InputMaybe<VarHubCameraZoneInput>;
};

export type VarHubCameraLineGeometry = {
  readonly __typename?: "VarHubCameraLineGeometry";
  readonly coordinates: ReadonlyArray<ReadonlyArray<Scalars["Float"]>>;
  readonly type: GeoJsonType;
};

export type VarHubCameraLineGeometryInput = {
  readonly coordinates: ReadonlyArray<ReadonlyArray<Scalars["Float"]>>;
  readonly type: GeoJsonType;
};

export type VarHubCameraRegionGeometry = {
  readonly __typename?: "VarHubCameraRegionGeometry";
  readonly coordinates: ReadonlyArray<
    ReadonlyArray<ReadonlyArray<Scalars["Float"]>>
  >;
  readonly type: GeoJsonType;
};

export type VarHubCameraRegionGeometryInput = {
  readonly coordinates: ReadonlyArray<
    ReadonlyArray<ReadonlyArray<Scalars["Float"]>>
  >;
  readonly type: GeoJsonType;
};

export type VarHubCameraZoneInput = {
  readonly areaId?: InputMaybe<Scalars["ID"]>;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly number: Scalars["Int"];
};

export type VarHubCurrentDiagnostics = {
  readonly __typename?: "VarHubCurrentDiagnostics";
  readonly data?: Maybe<Scalars["String"]>;
};

export enum VarHubPanelConnectionStatus {
  CONNECTED = "CONNECTED",
  DISCONNECTED = "DISCONNECTED",
  PARTIAL = "PARTIAL",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
}

export type VarHubRecentDiagnostics = {
  readonly __typename?: "VarHubRecentDiagnostics";
  readonly data?: Maybe<Scalars["String"]>;
};

export type VarHubSettings = Node & {
  readonly __typename?: "VarHubSettings";
  readonly hubId?: Maybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly settings: VarHubSettingsData;
  readonly systemId?: Maybe<Scalars["Int"]>;
};

export type VarHubSettingsAlert = {
  readonly __typename?: "VarHubSettingsAlert";
  readonly disableAlert?: Maybe<Scalars["Boolean"]>;
  readonly disableAutoSuppression?: Maybe<Scalars["Boolean"]>;
  readonly disableMultiNotifications?: Maybe<Scalars["Boolean"]>;
  readonly disableObjectBox?: Maybe<Scalars["Boolean"]>;
  readonly disableSending?: Maybe<Scalars["Boolean"]>;
  readonly enableSensitiveMotion?: Maybe<Scalars["Boolean"]>;
  readonly interestingObject?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
  readonly monitoring?: Maybe<VarHubSettingsMonitoring>;
  readonly offlineAlertDelaySecs?: Maybe<Scalars["Int"]>;
};

export type VarHubSettingsData = {
  readonly __typename?: "VarHubSettingsData";
  readonly alertSettings?: Maybe<VarHubSettingsAlert>;
  readonly camectHubId?: Maybe<Scalars["String"]>;
  readonly hardwareModel?: Maybe<Scalars["Int"]>;
  readonly hubName?: Maybe<Scalars["String"]>;
  readonly streamingSettings?: Maybe<VarHubSettingsStreamingSettings>;
  readonly timeLocation?: Maybe<Scalars["String"]>;
};

export type VarHubSettingsImmix = {
  readonly __typename?: "VarHubSettingsImmix";
  readonly deviceId?: Maybe<Scalars["Int"]>;
  readonly immixCams?: Maybe<ReadonlyArray<Maybe<VarHubSettingsImmixCamera>>>;
  readonly password?: Maybe<Scalars["String"]>;
  readonly recipientDomain?: Maybe<Scalars["String"]>;
  readonly sendAutoSuppression?: Maybe<Scalars["Boolean"]>;
  readonly smtpPort?: Maybe<Scalars["Int"]>;
  readonly smtpServer?: Maybe<Scalars["String"]>;
  readonly user?: Maybe<Scalars["String"]>;
};

export type VarHubSettingsImmixCamera = {
  readonly __typename?: "VarHubSettingsImmixCamera";
  readonly camName?: Maybe<Scalars["String"]>;
  readonly camectCamId?: Maybe<Scalars["String"]>;
  readonly deviceId?: Maybe<Scalars["Int"]>;
  readonly immixInput?: Maybe<Scalars["Int"]>;
};

export type VarHubSettingsMonitoring = {
  readonly __typename?: "VarHubSettingsMonitoring";
  readonly immix?: Maybe<VarHubSettingsImmix>;
};

export type VarHubSettingsStreamingSettings = {
  readonly __typename?: "VarHubSettingsStreamingSettings";
  readonly enableAudio?: Maybe<Scalars["Boolean"]>;
  readonly maxFootageLifeSecs?: Maybe<Scalars["Int"]>;
  readonly saveAudio?: Maybe<Scalars["Boolean"]>;
};

/** @deprecated (reason: "Replaced with VideoAction") */
export type VarVideoAction = Node & {
  readonly __typename?: "VarVideoAction";
  readonly areaNumber?: Maybe<Scalars["String"]>;
  readonly cameraId: Scalars["String"];
  readonly deviceNumber?: Maybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly type: VarVideoActionType;
  readonly zoneNumber?: Maybe<Scalars["String"]>;
};

export enum VarVideoActionType {
  ACCESS_DENIED = "ACCESS_DENIED",
  ACCESS_GRANTED = "ACCESS_GRANTED",
  ALARM = "ALARM",
  ARMED = "ARMED",
  DISARMED = "DISARMED",
  DOOR_OPENED = "DOOR_OPENED",
  DOOR_PROPPED = "DOOR_PROPPED",
  ZONE_BYPASSED = "ZONE_BYPASSED",
}

export type Vernacular = {
  readonly __typename?: "Vernacular";
  readonly dealerId: Scalars["Int"];
  readonly id: Scalars["ID"];
  readonly original: Scalars["String"];
  readonly replacement: Scalars["String"];
  readonly scapiId: Scalars["Int"];
};

export type VernacularApiResponses = {
  readonly __typename?: "VernacularApiResponses";
  readonly errorMessage?: Maybe<Scalars["String"]>;
  readonly original: Scalars["String"];
  readonly result: Scalars["String"];
};

export type VernacularSuperMutationErrorResponse = {
  readonly __typename?: "VernacularSuperMutationErrorResponse";
  readonly errorMessage: Scalars["String"];
  readonly type: VernacularsErrors;
};

export type VernacularSuperMutationInputs = {
  readonly crudType: CrudType;
  readonly original: Scalars["String"];
  readonly replacement: Scalars["String"];
  readonly vernacularId: Scalars["Int"];
};

export type VernacularSuperMutationResponse =
  | VernacularSuperMutationErrorResponse
  | VernacularSuperMutationSuccessResponse;

export type VernacularSuperMutationSuccessResponse = {
  readonly __typename?: "VernacularSuperMutationSuccessResponse";
  readonly apiResponses: ReadonlyArray<VernacularApiResponses>;
  readonly dealer: Dealer;
};

export enum VernacularsErrors {
  ALL_FAILED = "ALL_FAILED",
  BAD_INPUT = "BAD_INPUT",
  BAD_PARAMS = "BAD_PARAMS",
  BAD_REQUEST = "BAD_REQUEST",
  CONFLICT = "CONFLICT",
  NO_CONTROL_SYSTEM = "NO_CONTROL_SYSTEM",
  NO_DEALER = "NO_DEALER",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN = "UNKNOWN",
}

export type VideoAction = {
  readonly cameraType?: Maybe<VideoActionCameraType>;
  readonly id: Scalars["ID"];
};

export enum VideoActionCameraType {
  DEALER_API = "DEALER_API",
  XV_API = "XV_API",
}

export enum VideoActionType {
  ACCESS_DENIED = "ACCESS_DENIED",
  ACCESS_GRANTED = "ACCESS_GRANTED",
  ALARM = "ALARM",
  ARMED = "ARMED",
  DISARMED = "DISARMED",
  DOOR_OPENED = "DOOR_OPENED",
  DOOR_PROPPED = "DOOR_PROPPED",
  ZONE_BYPASSED = "ZONE_BYPASSED",
}

export type VideoActionsResolveTypes = DealerApiVideoAction | XvApiVideoAction;

export type VideoChannel =
  | DigitalWatchdogCamera
  | EagleEyeBridgeVideoChannel
  | HanwhaNvrVideoChannel
  | HikvisionNvrVideoChannel
  | OpenEyeNvrVideoChannel
  | SecureComCamera
  | SecureComNvrVideoChannel
  | VideoDoorbell;

export enum VideoChannelNetworkStatus {
  ACTIVE = "ACTIVE",
  INACCESSIBLE = "INACCESSIBLE",
}

export type VideoClipData = {
  readonly __typename?: "VideoClipData";
  readonly video_clips?: Maybe<ReadonlyArray<Maybe<Scalars["String"]>>>;
};

export type VideoDevice = {
  readonly deviceType: VideoDeviceType;
  readonly id: Scalars["ID"];
};

export enum VideoDeviceSettingConfirmation {
  API_ERROR = "API_ERROR",
  CONFIRMATION_ERROR = "CONFIRMATION_ERROR",
  CONFIRMED = "CONFIRMED",
  PENDING = "PENDING",
  SENT = "SENT",
  TIMEOUT = "TIMEOUT",
}

export enum VideoDeviceStatus {
  ACTIVATING = "ACTIVATING",
  ACTIVE = "ACTIVE",
  ERROR = "ERROR",
  INACCESSIBLE = "INACCESSIBLE",
}

export enum VideoDeviceType {
  BRIDGE = "BRIDGE",
  CAMERA = "CAMERA",
  DOORBELL = "DOORBELL",
  DVR = "DVR",
  NVR = "NVR",
}

export enum VideoDeviceTypeName {
  CAMECT_XV_24 = "CAMECT_XV_24",
  DW_CAMERA = "DW_CAMERA",
  DW_NVR = "DW_NVR",
  EAGLE_EYE_BRIDGE = "EAGLE_EYE_BRIDGE",
  HANWHA_NVR = "HANWHA_NVR",
  HIKVISION_DOORBELL = "HIKVISION_DOORBELL",
  HIKVISION_NVR = "HIKVISION_NVR",
  OPEN_EYE_NVR = "OPEN_EYE_NVR",
  SECURECOM_CAMERA = "SECURECOM_CAMERA",
  SECURECOM_DVR = "SECURECOM_DVR",
  SECURECOM_NVR = "SECURECOM_NVR",
  SERCOMM_CAMERA = "SERCOMM_CAMERA",
  STOCK_HIKVISION_NVR = "STOCK_HIKVISION_NVR",
  SUNELL_DOORBELL = "SUNELL_DOORBELL",
  UNIVIEW_V6000 = "UNIVIEW_V6000",
  UNKNOWN = "UNKNOWN",
  VUE_CAMERA = "VUE_CAMERA",
  XC_MDOME_1 = "XC_MDOME_1",
}

export type VideoDoorbell = Node &
  VideoDevice & {
    readonly __typename?: "VideoDoorbell";
    readonly accessControlDoor?: Maybe<Scalars["String"]>;
    readonly accessControlDoorDetails?: Maybe<Door>;
    readonly adminPassword?: Maybe<Scalars["String"]>;
    readonly adminUsername?: Maybe<Scalars["String"]>;
    readonly allowCustomerEdit: Scalars["Boolean"];
    readonly analyticalDetectionLines: AnalyticalDetectionLines;
    readonly analyticalDetectionRegions: AnalyticalDetectionRegions;
    readonly awsCredentials?: Maybe<AwsCredentials>;
    readonly ceilingMount: Scalars["Boolean"];
    readonly channelId: Scalars["Int"];
    readonly chime: DoorbellChime;
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly databaseCameraId: Scalars["Int"];
    readonly daylightSaving: Scalars["Boolean"];
    readonly detectTamper: Scalars["Boolean"];
    readonly deviceType: VideoDeviceType;
    /** Configuration for if a camera should record a clip if it detects motion */
    readonly eventsEnabled: CameraEventsEnabled;
    readonly firmwareUpdateAvailable: Scalars["Boolean"];
    readonly firmwareUpdateStatus: Scalars["String"];
    readonly firmwareVersion?: Maybe<Scalars["String"]>;
    readonly formFactor?: Maybe<Scalars["String"]>;
    readonly generation: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly imageSize?: Maybe<Scalars["String"]>;
    readonly includeInVerification: Scalars["Boolean"];
    readonly integration: Scalars["String"];
    readonly ipAddress?: Maybe<Scalars["String"]>;
    readonly isAxis: Scalars["Boolean"];
    readonly isOnline: Scalars["Boolean"];
    readonly isUpdating: Scalars["Boolean"];
    readonly keypadVisible: Scalars["Boolean"];
    readonly lastCheckIn?: Maybe<Scalars["String"]>;
    readonly macAddress: Scalars["String"];
    readonly manufacturer: Scalars["String"];
    readonly maxAnalyticalDetectionLines: Scalars["Int"];
    readonly maxAnalyticalDetectionRegionPoints: Scalars["Int"];
    readonly maxAnalyticalDetectionRegions: Scalars["Int"];
    readonly maxMotionDetectionRegions: Scalars["Int"];
    readonly microphoneLevel: Scalars["Int"];
    readonly minAnalyticalDetectionRegionPoints: Scalars["Int"];
    readonly model: Scalars["String"];
    /** Configuration where the camera detects motion in its field of view and triggers a clip recording */
    readonly motionDetectionRegions: MotionDetectionRegions;
    readonly motionSensitivity?: Maybe<Scalars["Int"]>;
    readonly name: Scalars["String"];
    readonly networkReady?: Maybe<Scalars["Boolean"]>;
    readonly networkStatus: VideoChannelNetworkStatus;
    /** Configuration for if a camera should record a clip when the panel goes into alarm */
    readonly recordOnAlarm: Scalars["Boolean"];
    readonly scapiFirmwareUpdateStatus?: Maybe<Scalars["String"]>;
    readonly sdCardStatus?: Maybe<Scalars["String"]>;
    readonly serialNumber?: Maybe<Scalars["String"]>;
    readonly settingConfirmation?: Maybe<VideoDeviceSettingConfirmation>;
    /** The most recent still shot of the camera's view */
    readonly snapshot?: Maybe<Scalars["URL"]>;
    readonly speakerSupported: Scalars["Boolean"];
    readonly speakerVolume: Scalars["Int"];
    readonly status: VideoDeviceStatus;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly timeZone: Scalars["String"];
    readonly timeZones: ReadonlyArray<Scalars["String"]>;
    readonly videoAnalyticsEnabled: Scalars["Boolean"];
    readonly videoAnalyticsSupported: Scalars["Boolean"];
    readonly videoQuality: Scalars["String"];
    readonly wirelessSignalStrength?: Maybe<Scalars["Int"]>;
  };

export type VideoDoorbellInput = {
  readonly accessControlDoor?: InputMaybe<Scalars["String"]>;
  readonly allowCustomerEdit?: InputMaybe<Scalars["Boolean"]>;
  readonly analyticalDetectionLines?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionLineInput>
  >;
  readonly analyticalDetectionRegions?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionRegionInput>
  >;
  readonly ceilingMount?: InputMaybe<Scalars["Boolean"]>;
  readonly chime?: InputMaybe<DoorbellChime>;
  readonly daylightSaving?: InputMaybe<Scalars["Boolean"]>;
  readonly detectTamper?: InputMaybe<Scalars["Boolean"]>;
  readonly eventsEnabled?: InputMaybe<CameraEventsEnabled>;
  readonly id: Scalars["ID"];
  readonly includeInVerification?: InputMaybe<Scalars["Boolean"]>;
  readonly keypadVisible?: InputMaybe<Scalars["Boolean"]>;
  readonly microphoneLevel?: InputMaybe<Scalars["Int"]>;
  readonly motionDetectionRegions?: InputMaybe<
    ReadonlyArray<MotionDetectionRegionInput>
  >;
  readonly motionSensitivity: Scalars["Int"];
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly recordOnAlarm?: InputMaybe<Scalars["Boolean"]>;
  readonly speakerVolume?: InputMaybe<Scalars["Int"]>;
  readonly timeZone?: InputMaybe<Scalars["String"]>;
  readonly videoAnalyticsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly videoQuality?: InputMaybe<Scalars["String"]>;
};

export enum VideoFirmwareUpdateStatus {
  DOWNLOADING_UPDATE = "DOWNLOADING_UPDATE",
  FAILED = "FAILED",
  NEEDS_UPDATE = "NEEDS_UPDATE",
  NONE = "NONE",
  REBOOTING = "REBOOTING",
  TIMEOUT = "TIMEOUT",
  TRANSFERRING_UPDATE = "TRANSFERRING_UPDATE",
  UPDATING = "UPDATING",
  UP_TO_DATE = "UP_TO_DATE",
}

export type VkSystemUserList = Node & {
  readonly __typename?: "VkSystemUserList";
  readonly credentialId?: Maybe<Scalars["Int"]>;
  readonly credentialTypes?: Maybe<
    ReadonlyArray<Maybe<ReadableCredentialType>>
  >;
  readonly databaseId: Scalars["String"];
  readonly firstName: Scalars["String"];
  readonly id: Scalars["ID"];
  readonly lastName: Scalars["String"];
  readonly personId?: Maybe<Scalars["Int"]>;
  readonly photoUrl?: Maybe<Scalars["String"]>;
  readonly userCodeId?: Maybe<Scalars["Int"]>;
  readonly userCodeNumbers?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]>>>;
};

export type VkSystemUserListConnection = {
  readonly __typename?: "VkSystemUserListConnection";
  readonly edges: ReadonlyArray<VkSystemUserListEdge>;
  readonly nodes: ReadonlyArray<VkSystemUserList>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"];
};

export type VkSystemUserListEdge = {
  readonly __typename?: "VkSystemUserListEdge";
  readonly cursor?: Maybe<Scalars["ID"]>;
  readonly node?: Maybe<VkSystemUserList>;
};

export enum VoltageStatus {
  BAD = "BAD",
  GOOD = "GOOD",
  NA = "NA",
}

/** In most cases, it is more efficient to get stream details from vsCameraByDatabaseId rather than the allCameras object. See SingleCamera. */
export type VsCamera = AllCameras &
  Node & {
    readonly __typename?: "VsCamera";
    readonly cameraName?: Maybe<Scalars["String"]>;
    readonly cameraStreamUrl?: Maybe<Scalars["String"]>;
    readonly databaseCameraId?: Maybe<Scalars["Int"]>;
    readonly databaseDeviceId?: Maybe<Scalars["Int"]>;
    readonly deviceAuthToken?: Maybe<Scalars["String"]>;
    readonly deviceManufacturer?: Maybe<Scalars["String"]>;
    readonly deviceModel?: Maybe<Scalars["String"]>;
    readonly deviceTimeZone?: Maybe<Scalars["String"]>;
    readonly deviceType?: Maybe<Scalars["String"]>;
    readonly generation?: Maybe<Scalars["String"]>;
    readonly hasRedBlueLights: Scalars["Boolean"];
    readonly hasWhiteLights: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isAxis: Scalars["Boolean"];
    readonly redBlueLightsOn: Scalars["Boolean"];
    readonly snapshotUrl?: Maybe<Scalars["String"]>;
    readonly streamType?: Maybe<StreamTypeName>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly supportsTalkdown: Scalars["Boolean"];
    readonly whiteLightsOn: Scalars["Boolean"];
  };

export type VueCameraInput = {
  readonly alarmvisionDeviceRecordNumber?: InputMaybe<Scalars["Int"]>;
  readonly alarmvisionEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly allowCustomerEdit?: InputMaybe<Scalars["Boolean"]>;
  readonly analyticalDetectionLines?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionLineInput>
  >;
  readonly analyticalDetectionRegions?: InputMaybe<
    ReadonlyArray<AnalyticalDetectionRegionInput>
  >;
  readonly audioEnabled: Scalars["Boolean"];
  readonly audioOutEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly ceilingMount?: InputMaybe<Scalars["Boolean"]>;
  readonly daylightSaving?: InputMaybe<Scalars["Boolean"]>;
  readonly eventsEnabled?: InputMaybe<CameraEventsEnabled>;
  readonly firmwareUpdateProgress?: InputMaybe<Scalars["Int"]>;
  readonly id: Scalars["ID"];
  readonly includeInVerification?: InputMaybe<Scalars["Boolean"]>;
  readonly keypadVisible?: InputMaybe<Scalars["Boolean"]>;
  readonly microphoneLevel?: InputMaybe<Scalars["Int"]>;
  readonly motionDetectionRegions?: InputMaybe<
    ReadonlyArray<MotionDetectionRegionInput>
  >;
  readonly motionSensitivity: Scalars["Int"];
  readonly name?: InputMaybe<Scalars["String"]>;
  readonly panelIp?: InputMaybe<Scalars["String"]>;
  readonly recordOnAlarm?: InputMaybe<Scalars["Boolean"]>;
  readonly speakerVolume?: InputMaybe<Scalars["Int"]>;
  readonly stitchingDistance?: InputMaybe<Scalars["Int"]>;
  readonly timeZone?: InputMaybe<Scalars["String"]>;
  readonly videoAnalyticsEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly videoQuality?: InputMaybe<Scalars["String"]>;
  readonly wsDiscovery?: InputMaybe<Scalars["Boolean"]>;
};

export type WalletCredentialSummary = Node & {
  readonly __typename?: "WalletCredentialSummary";
  readonly activeDigitalCardCount: Scalars["Int"];
  readonly id: Scalars["ID"];
};

export type WealthAttributeTypes = {
  readonly __typename?: "WealthAttributeTypes";
  readonly camectCameraId?: Maybe<Scalars["String"]>;
  readonly camectHubId?: Maybe<Scalars["String"]>;
  readonly cameraName?: Maybe<Scalars["String"]>;
  readonly cameraTimezone?: Maybe<Scalars["String"]>;
  readonly dst?: Maybe<Scalars["Boolean"]>;
  readonly endTsMs?: Maybe<Scalars["String"]>;
  readonly eventStreamUrl?: Maybe<Scalars["String"]>;
  readonly eventWebRtcUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use photoUrls instead */
  readonly imageUrl?: Maybe<Scalars["String"]>;
  /** For XV, use eventAt with offset from cameraTimezone instead */
  readonly startTsMs?: Maybe<Scalars["String"]>;
  /** @deprecated Use eventAt with offset from cameraTimezone instead */
  readonly timestampMs?: Maybe<Scalars["String"]>;
  readonly videoUrl?: Maybe<Scalars["String"]>;
};

export type WebRtcDetails = {
  readonly __typename?: "WebRTCDetails";
  readonly highResDomainName: Scalars["String"];
  readonly highResRemoteId: Scalars["String"];
  readonly highResUrl?: Maybe<Scalars["String"]>;
  readonly isICEPort: Scalars["Boolean"];
  readonly isSecureWebsocket: Scalars["Boolean"];
  readonly lowResDomainName: Scalars["String"];
  readonly lowResRemoteId: Scalars["String"];
  readonly lowResUrl?: Maybe<Scalars["String"]>;
  readonly port: Scalars["String"];
  readonly transportProtocol: WebRtcTransportProtocol;
};

export type WebRtcEventDetails = {
  readonly __typename?: "WebRTCEventDetails";
  readonly hdDomainName: Scalars["String"];
  readonly hdRemoteId: Scalars["String"];
  readonly icePort: Scalars["Boolean"];
  readonly port: Scalars["Int"];
  readonly secureWebsocket: Scalars["Boolean"];
  readonly tcpWebSocketUrl: Scalars["String"];
  readonly transportProtocol: Scalars["String"];
  readonly udpWebSocketUrl: Scalars["String"];
};

export type WebRtcScapiCamera = AllCameras &
  Node & {
    readonly __typename?: "WebRTCScapiCamera";
    readonly cameraName?: Maybe<Scalars["String"]>;
    readonly cameraStreamUrl?: Maybe<Scalars["String"]>;
    readonly databaseCameraId?: Maybe<Scalars["Int"]>;
    readonly databaseDeviceId?: Maybe<Scalars["Int"]>;
    readonly deviceAuthToken?: Maybe<Scalars["String"]>;
    readonly deviceManufacturer?: Maybe<Scalars["String"]>;
    readonly deviceModel?: Maybe<Scalars["String"]>;
    readonly deviceTimeZone?: Maybe<Scalars["String"]>;
    readonly deviceType?: Maybe<Scalars["String"]>;
    readonly generation?: Maybe<Scalars["String"]>;
    readonly hasRedBlueLights: Scalars["Boolean"];
    readonly hasWhiteLights: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isAxis: Scalars["Boolean"];
    readonly isPanTilt: Scalars["Boolean"];
    readonly isV4000Series: Scalars["Boolean"];
    readonly isV5000Series: Scalars["Boolean"];
    readonly isV6000Series: Scalars["Boolean"];
    readonly isVue: Scalars["Boolean"];
    readonly isVueFisheye: Scalars["Boolean"];
    readonly redBlueLightsOn: Scalars["Boolean"];
    readonly snapshotUrl?: Maybe<Scalars["String"]>;
    readonly streamType?: Maybe<StreamTypeName>;
    readonly supportsAnalyticalDetectionLines?: Maybe<Scalars["Boolean"]>;
    readonly supportsPtzZoom: Scalars["Boolean"];
    readonly supportsStitchingDistance: Scalars["Boolean"];
    readonly supportsTalkdown: Scalars["Boolean"];
    readonly webRTCDetails?: Maybe<WebRtcDetails>;
    readonly whiteLightsOn: Scalars["Boolean"];
  };

export enum WebRtcTransportProtocol {
  TCP = "TCP",
  UDP = "UDP",
  UNKNOWN = "UNKNOWN",
}

export enum WirelessAudibles {
  ANY = "ANY",
  DAY = "DAY",
  MIN = "MIN",
}

export enum WirelessEncryption1100 {
  ALL = "ALL",
  BOTH = "BOTH",
  NONE = "NONE",
}

export type WsDiscoveryOnDemandProbeErrorResponsePayload = {
  readonly __typename?: "WsDiscoveryOnDemandProbeErrorResponsePayload";
  readonly message: Scalars["String"];
  readonly type: Scalars["String"];
};

export type WsDiscoveryOnDemandProbeResponsePayload =
  | WsDiscoveryOnDemandProbeErrorResponsePayload
  | WsDiscoveryOnDemandProbeSuccessResponsePayload;

export type WsDiscoveryOnDemandProbeSuccessResponsePayload = {
  readonly __typename?: "WsDiscoveryOnDemandProbeSuccessResponsePayload";
  readonly error: Scalars["String"];
  readonly result: Scalars["String"];
  readonly success: Scalars["Boolean"];
};

export enum X1Authorization {
  CARD = "CARD",
  CARD_PLUS_PIN = "CARD_PLUS_PIN",
  DUAL_AUTHORITY = "DUAL_AUTHORITY",
}

export enum X1Type {
  X1 = "X1",
  X8 = "X8",
}

export type X1TypeFoundResponse = {
  readonly __typename?: "X1TypeFoundResponse";
  readonly x1Type: X1Type;
};

export type X1TypeResponse = NotFoundError | X1TypeFoundResponse;

export type XfAppUserInput = {
  readonly email: Scalars["String"];
  readonly role?: InputMaybe<UserRole>;
};

export type XfCredentialInput = {
  readonly credentialType?: InputMaybe<CredentialType>;
  readonly id: Scalars["String"];
};

export type XfDeviceInformation = DeviceInformation &
  Node & {
    readonly __typename?: "XfDeviceInformation";
    readonly axNumber: Scalars["String"];
    readonly deviceCommunicationMethod: DeviceInformationCommType;
    readonly deviceType: DeviceInformationType;
    readonly door: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isNew: Scalars["Boolean"];
    readonly lxNumber: Scalars["String"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly serialNumber: Scalars["String"];
    readonly supervisionTime?: Maybe<DeviceInformationWirelessSupervisionTime>;
    readonly tipe: Scalars["String"];
    readonly tracked: Scalars["Boolean"];
  };

export type XfDeviceInformationInput = {
  readonly axNumber: Scalars["String"];
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly hasChanges: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
};

export type XfDeviceInput = {
  readonly axNumber: Scalars["String"];
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
};

export type XfPersonInput = {
  readonly appUser?: InputMaybe<XfAppUserInput>;
  readonly credentials: ReadonlyArray<XfCredentialInput>;
  readonly email?: InputMaybe<Scalars["String"]>;
  readonly firstName: Scalars["String"];
  readonly hasAppUser: Scalars["Boolean"];
  readonly lastName?: InputMaybe<Scalars["String"]>;
  readonly note?: InputMaybe<Scalars["String"]>;
  readonly phoneNumber?: InputMaybe<Scalars["String"]>;
  readonly photoUrl?: InputMaybe<Scalars["String"]>;
};

export type XfProgrammingTemplateCommunicationPath = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XfProgrammingTemplateCommunicationPath";
    readonly apn?: Maybe<TemplateFieldString>;
    readonly apn2?: Maybe<TemplateFieldString>;
    readonly checkInMinutes?: Maybe<TemplateFieldInt>;
    readonly commType?: Maybe<TemplateFieldCommunicationPathCommType>;
    readonly duplicateAlarms?: Maybe<TemplateFieldBoolean>;
    readonly failTestHours?: Maybe<TemplateFieldInt>;
    readonly failTime?: Maybe<TemplateFieldInt>;
    readonly firstPhone?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly number: Scalars["Int"];
    readonly protocol?: Maybe<TemplateFieldCommunicationPathProtocol>;
    readonly receiverPort?: Maybe<TemplateFieldString>;
    readonly remoteIP?: Maybe<TemplateFieldString>;
    readonly retryTime?: Maybe<TemplateFieldInt>;
    readonly secondPhone?: Maybe<TemplateFieldString>;
    readonly sendPath?: Maybe<TemplateFieldBoolean>;
    readonly systemInformation?: Maybe<TemplateFieldBoolean>;
    readonly testReport?: Maybe<TemplateFieldCommunicationPathTestReport>;
    readonly testTime?: Maybe<TemplateFieldString>;
    readonly type?: Maybe<TemplateFieldCommunicationPathType>;
    readonly useCheckIn?: Maybe<TemplateFieldCommunicationPathUseCheckIn>;
  };

export type XfProgrammingTemplateCommunicationPathInput = {
  readonly apn?: InputMaybe<TemplateFieldStringInput>;
  readonly apn2?: InputMaybe<TemplateFieldStringInput>;
  readonly checkInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly commType?: InputMaybe<TemplateFieldCommunicationPathCommTypeInput>;
  readonly duplicateAlarms?: InputMaybe<TemplateFieldBooleanInput>;
  readonly failTestHours?: InputMaybe<TemplateFieldIntInput>;
  readonly failTime?: InputMaybe<TemplateFieldIntInput>;
  readonly firstPhone?: InputMaybe<TemplateFieldStringInput>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["Int"];
  readonly protocol?: InputMaybe<TemplateFieldCommunicationPathProtocolInput>;
  readonly receiverPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteIP?: InputMaybe<TemplateFieldStringInput>;
  readonly retryTime?: InputMaybe<TemplateFieldIntInput>;
  readonly secondPhone?: InputMaybe<TemplateFieldStringInput>;
  readonly sendPath?: InputMaybe<TemplateFieldBooleanInput>;
  readonly systemInformation?: InputMaybe<TemplateFieldBooleanInput>;
  readonly testReport?: InputMaybe<TemplateFieldCommunicationPathTestReportInput>;
  readonly testTime?: InputMaybe<TemplateFieldStringInput>;
  readonly type?: InputMaybe<TemplateFieldCommunicationPathTypeInput>;
  readonly useCheckIn?: InputMaybe<TemplateFieldCommunicationPathUseCheckInInput>;
};

export type XfProgrammingTemplateConcepts = {
  readonly __typename?: "XfProgrammingTemplateConcepts";
  readonly bellOptions?: Maybe<ProgrammingTemplateBellOptions>;
  readonly communication?: Maybe<
    ReadonlyArray<Maybe<XfProgrammingTemplateCommunicationPath>>
  >;
  readonly deviceInformations?: Maybe<
    ReadonlyArray<Maybe<XfProgrammingTemplateDeviceInformation>>
  >;
  readonly lockoutCode?: Maybe<ProgrammingTemplateLockoutCode>;
  readonly networkOptions?: Maybe<ProgrammingTemplateNetworkOptions>;
  readonly outputGroups?: Maybe<
    ReadonlyArray<Maybe<XfProgrammingTemplateOutputGroup>>
  >;
  readonly outputInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateOutputInformation>>
  >;
  readonly outputOptions?: Maybe<ProgrammingTemplateOutputOptions>;
  readonly remoteOptions?: Maybe<XfProgrammingTemplateRemoteOptions>;
  readonly systemOptions?: Maybe<XfProgrammingTemplateSystemOptions>;
  readonly systemReports?: Maybe<ProgrammingTemplateSystemReports>;
  readonly zoneInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateZoneInformation>>
  >;
};

export type XfProgrammingTemplateConceptsInput = {
  readonly bellOptions?: InputMaybe<ProgrammingTemplateBellOptionsInput>;
  readonly communication?: InputMaybe<
    ReadonlyArray<InputMaybe<XfProgrammingTemplateCommunicationPathInput>>
  >;
  readonly deviceInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XfProgrammingTemplateDeviceInformationInput>>
  >;
  readonly lockoutCode?: InputMaybe<ProgrammingTemplateLockoutCodeInput>;
  readonly networkOptions?: InputMaybe<ProgrammingTemplateNetworkOptionsInput>;
  readonly outputGroups?: InputMaybe<
    ReadonlyArray<InputMaybe<XfProgrammingTemplateOutputGroupInput>>
  >;
  readonly outputInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateOutputInformationInput>>
  >;
  readonly outputOptions?: InputMaybe<ProgrammingTemplateOutputOptionsInput>;
  readonly remoteOptions?: InputMaybe<XfProgrammingTemplateRemoteOptionsInput>;
  readonly systemOptions?: InputMaybe<XfProgrammingTemplateSystemOptionsInput>;
  readonly systemReports?: InputMaybe<ProgrammingTemplateSystemReportsInput>;
  readonly zoneInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateZoneInformationInput>>
  >;
};

export type XfProgrammingTemplateDeviceInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XfProgrammingTemplateDeviceInformation";
    readonly axNumber?: Maybe<TemplateFieldString>;
    readonly deviceCommunicationMethod?: Maybe<TemplateFieldDeviceInformationCommType>;
    readonly deviceType?: Maybe<TemplateFieldDeviceInformationType>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lxNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
  };

export type XfProgrammingTemplateDeviceInformationInput = {
  readonly axNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly deviceCommunicationMethod?: InputMaybe<TemplateFieldDeviceInformationCommTypeInput>;
  readonly deviceType?: InputMaybe<TemplateFieldDeviceInformationTypeInput>;
  readonly included: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
};

export type XfProgrammingTemplateInput = {
  readonly concepts?: InputMaybe<XfProgrammingTemplateConceptsInput>;
  readonly customerId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly hardwareModel: PanelHardwareModel;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly ratePlan?: InputMaybe<Scalars["String"]>;
  readonly receiverCommType?: InputMaybe<Scalars["String"]>;
};

export type XfProgrammingTemplateOutputGroup = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XfProgrammingTemplateOutputGroup";
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly outputNumber1?: Maybe<TemplateFieldString>;
    readonly outputNumber2?: Maybe<TemplateFieldString>;
    readonly outputNumber3?: Maybe<TemplateFieldString>;
    readonly outputNumber4?: Maybe<TemplateFieldString>;
    readonly outputNumber5?: Maybe<TemplateFieldString>;
    readonly outputNumber6?: Maybe<TemplateFieldString>;
    readonly outputNumber7?: Maybe<TemplateFieldString>;
    readonly outputNumber8?: Maybe<TemplateFieldString>;
  };

export type XfProgrammingTemplateOutputGroupInput = {
  readonly included: Scalars["Boolean"];
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly outputNumber1?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber2?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber3?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber4?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber5?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber6?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber7?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber8?: InputMaybe<TemplateFieldStringInput>;
};

export type XfProgrammingTemplateRemoteOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XfProgrammingTemplateRemoteOptions";
    readonly appKey?: Maybe<TemplateFieldString>;
    readonly entreBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly entreCheckInMinutes?: Maybe<TemplateFieldInt>;
    readonly entreConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreIpAddress?: Maybe<TemplateFieldString>;
    readonly entreOutgoingPort?: Maybe<TemplateFieldString>;
    readonly entrePassphrase?: Maybe<TemplateFieldString>;
    readonly entreSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly entreUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly entreZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly firstApn?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly integratorBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorOutgoingPort?: Maybe<TemplateFieldString>;
    readonly integratorPassphrase?: Maybe<TemplateFieldString>;
    readonly integratorSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly networkProgrammingPort?: Maybe<TemplateFieldString>;
    readonly remoteKey?: Maybe<TemplateFieldString>;
    readonly validEntreCheckinMinutes?: Maybe<TemplateFieldString>;
  };

export type XfProgrammingTemplateRemoteOptionsInput = {
  readonly appKey?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreCheckInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly entreConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entrePassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly entreSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly firstApn?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly integratorBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly networkProgrammingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteKey?: InputMaybe<TemplateFieldStringInput>;
  readonly validEntreCheckinMinutes?: InputMaybe<TemplateFieldStringInput>;
};

export type XfProgrammingTemplateSystemOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XfProgrammingTemplateSystemOptions";
    readonly crossZoneTime?: Maybe<TemplateFieldInt>;
    readonly detectJam?: Maybe<TemplateFieldBoolean>;
    readonly hoursFromGMT?: Maybe<TemplateFieldInt>;
    readonly houseCode?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly inspectionReminder?: Maybe<TemplateFieldInspectionReminder>;
    readonly latchedSupervisoryZones?: Maybe<TemplateFieldBoolean>;
    readonly observeDst?: Maybe<TemplateFieldBoolean>;
    readonly powerFailDelay?: Maybe<TemplateFieldInt>;
    readonly primaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly secondaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly swingerBypassTrips?: Maybe<TemplateFieldInt>;
    readonly timeChange?: Maybe<TemplateFieldTimeChange>;
    readonly wirelessAudibles?: Maybe<TemplateFieldWirelessAudibles>;
    readonly wirelessEncryption1100?: Maybe<TemplateFieldWirelessEncryption1100>;
    readonly wirelessEncryption1100Passphrase?: Maybe<TemplateFieldString>;
    readonly zoneRetardDelay?: Maybe<TemplateFieldInt>;
  };

export type XfProgrammingTemplateSystemOptionsInput = {
  readonly crossZoneTime?: InputMaybe<TemplateFieldIntInput>;
  readonly detectJam?: InputMaybe<TemplateFieldBooleanInput>;
  readonly hoursFromGMT?: InputMaybe<TemplateFieldIntInput>;
  readonly houseCode?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly inspectionReminder?: InputMaybe<TemplateFieldInspectionReminderInput>;
  readonly latchedSupervisoryZones?: InputMaybe<TemplateFieldBooleanInput>;
  readonly observeDst?: InputMaybe<TemplateFieldBooleanInput>;
  readonly powerFailDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly primaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly primaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly secondaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly secondaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly swingerBypassTrips?: InputMaybe<TemplateFieldIntInput>;
  readonly timeChange?: InputMaybe<TemplateFieldTimeChangeInput>;
  readonly wirelessAudibles?: InputMaybe<TemplateFieldWirelessAudiblesInput>;
  readonly wirelessEncryption1100?: InputMaybe<TemplateFieldWirelessEncryption1100Input>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly zoneRetardDelay?: InputMaybe<TemplateFieldIntInput>;
};

export type XfRemoteOptions = Node &
  RemoteOptions & {
    readonly __typename?: "XfRemoteOptions";
    readonly appKey?: Maybe<Scalars["String"]>;
    readonly appKeyMaxLength: Scalars["Int"];
    readonly entreBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly entreCheckInMinutes?: Maybe<Scalars["Int"]>;
    readonly entreConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreIpAddress?: Maybe<Scalars["String"]>;
    readonly entreOutgoingPort?: Maybe<Scalars["String"]>;
    readonly entrePassphrase?: Maybe<Scalars["String"]>;
    readonly entreSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly entreUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly entreZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly firstApn?: Maybe<Scalars["String"]>;
    readonly id: Scalars["ID"];
    readonly integratorBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorOutgoingPort?: Maybe<Scalars["String"]>;
    readonly integratorPassphrase?: Maybe<Scalars["String"]>;
    readonly integratorSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly networkProgrammingPort?: Maybe<Scalars["String"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly remoteKey: Scalars["String"];
    readonly remoteKeyMaxLength: Scalars["Int"];
    readonly validEntreCheckinMinutes?: Maybe<Scalars["String"]>;
  };

export type XfRemoteOptionsInput = {
  readonly appKey?: InputMaybe<Scalars["String"]>;
  readonly entreBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreCheckInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly entreConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly entrePassphrase?: InputMaybe<Scalars["String"]>;
  readonly entreSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly firstApn?: InputMaybe<Scalars["String"]>;
  readonly integratorBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorPassphrase?: InputMaybe<Scalars["String"]>;
  readonly integratorSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly networkProgrammingPort?: InputMaybe<Scalars["String"]>;
  readonly validEntreCheckinMinutes?: InputMaybe<Scalars["String"]>;
};

export type XfSystemOptions = Node &
  SystemOptions & {
    readonly __typename?: "XfSystemOptions";
    readonly crossZoneTime: Scalars["Int"];
    readonly crossZoneTimeMax: Scalars["Int"];
    readonly crossZoneTimeMin: Scalars["Int"];
    readonly detectJam: Scalars["Boolean"];
    readonly hoursFromGMT: Scalars["Int"];
    readonly hoursFromGMTMax: Scalars["Int"];
    readonly hoursFromGMTMin: Scalars["Int"];
    readonly houseCode: Scalars["String"];
    readonly houseCodeMax: Scalars["Int"];
    readonly houseCodeMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly inspectionReminder?: Maybe<InspectionReminder>;
    readonly latchedSupervisoryZones: Scalars["Boolean"];
    readonly observeDst?: Maybe<Scalars["Boolean"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly powerFailDelay: Scalars["Int"];
    readonly powerFailDelayMax: Scalars["Int"];
    readonly powerFailDelayMin: Scalars["Int"];
    readonly primaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly secondaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly swingerBypassTrips: Scalars["Int"];
    readonly swingerBypassTripsMax: Scalars["Int"];
    readonly swingerBypassTripsMin: Scalars["Int"];
    readonly timeChange: AllowTimeChange;
    readonly wirelessAudibles?: Maybe<WirelessAudibles>;
    readonly wirelessEncryption1100: WirelessEncryption1100;
    readonly wirelessEncryption1100Passphrase: Scalars["String"];
    readonly zoneRetardDelay: Scalars["Int"];
    readonly zoneRetardDelayMax: Scalars["Int"];
    readonly zoneRetardDelayMin?: Maybe<Scalars["Int"]>;
  };

export type XfSystemOptionsInput = {
  readonly crossZoneTime?: InputMaybe<Scalars["Int"]>;
  readonly detectJam?: InputMaybe<Scalars["Boolean"]>;
  readonly displayTime?: InputMaybe<Scalars["Boolean"]>;
  readonly hoursFromGMT?: InputMaybe<Scalars["Int"]>;
  readonly houseCode?: InputMaybe<Scalars["String"]>;
  readonly inspectionReminder?: InputMaybe<InspectionReminder>;
  readonly latchedSupervisoryZones?: InputMaybe<Scalars["Boolean"]>;
  readonly observeDst?: InputMaybe<Scalars["Boolean"]>;
  readonly powerFailDelay?: InputMaybe<Scalars["Int"]>;
  readonly primaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly primaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly secondaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly secondaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly swingerBypassTrips?: InputMaybe<Scalars["Int"]>;
  readonly timeChange?: InputMaybe<AllowTimeChange>;
  readonly wirelessAudibles?: InputMaybe<WirelessAudibles>;
  readonly wirelessEncryption1100?: InputMaybe<WirelessEncryption1100>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<Scalars["String"]>;
  readonly zoneRetardDelay?: InputMaybe<Scalars["Int"]>;
};

export type XfUserCode = Node &
  UserCode & {
    readonly __typename?: "XfUserCode";
    readonly armOnly?: Maybe<Scalars["Boolean"]>;
    readonly code?: Maybe<Scalars["String"]>;
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly credential: Credential;
    readonly credentialId: Scalars["String"];
    readonly expireTime?: Maybe<Scalars["DateTime"]>;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly personId?: Maybe<Scalars["String"]>;
    readonly tempUser?: Maybe<Scalars["Boolean"]>;
    readonly userLevel?: Maybe<UserCodeLevel>;
  };

export type XfUserCodeInput = {
  readonly action: UserCodeAction;
  readonly armOnly: Scalars["Boolean"];
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly credType?: InputMaybe<ReadableCredentialType>;
  readonly customerId?: InputMaybe<Scalars["String"]>;
  readonly hasAppUser?: InputMaybe<Scalars["Boolean"]>;
  readonly isFromInvalidCodeEvent?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly personEmail?: InputMaybe<Scalars["String"]>;
  readonly personId?: InputMaybe<Scalars["String"]>;
  readonly temp: Scalars["Boolean"];
  readonly userLevel: UserCodeLevel;
};

export type XrArea = Area &
  Node & {
    readonly __typename?: "XrArea";
    readonly accountNumber: Scalars["String"];
    readonly armFirstArea: Scalars["Boolean"];
    readonly armedOutputNumber: Scalars["String"];
    readonly armedStatus: AreaArmedStatusEnum;
    readonly arming: Scalars["Boolean"];
    readonly autoArmEnabled: Scalars["Boolean"];
    readonly autoDisarmEnabled: Scalars["Boolean"];
    readonly badZonesOption: BadZonesOption;
    readonly bankSafeVault: Scalars["Boolean"];
    readonly burglaryBellOutputNumber: Scalars["String"];
    readonly cardPlusPin?: Maybe<Scalars["Boolean"]>;
    readonly commonArea: Scalars["Boolean"];
    readonly disarming: Scalars["Boolean"];
    readonly dualAuthority?: Maybe<DualAuthorityEnum>;
    readonly hasChanges: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isArmable: Scalars["Boolean"];
    readonly isDisarmable: Scalars["Boolean"];
    readonly isInAlarm: Scalars["Boolean"];
    readonly isNew: Scalars["Boolean"];
    readonly lateArmDelay: Scalars["Int"];
    readonly lateOutputNumber: Scalars["String"];
    readonly maxNameLength: Scalars["Int"];
    readonly maxNumber: Scalars["Int"];
    readonly minNumber: Scalars["Int"];
    readonly name: Scalars["String"];
    readonly number: Scalars["String"];
    readonly numberWithName?: Maybe<Scalars["String"]>;
    readonly openClosingReports: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly twoManRule?: Maybe<Scalars["Boolean"]>;
  };

export type XrAreaInput = {
  readonly accountNumber: Scalars["String"];
  readonly armFirstArea: Scalars["Boolean"];
  readonly armedOutputNumber: Scalars["String"];
  readonly autoArmEnabled: Scalars["Boolean"];
  readonly autoDisarmEnabled: Scalars["Boolean"];
  readonly badZonesOption: BadZonesOption;
  readonly bankSafeVault: Scalars["Boolean"];
  readonly burglaryBellOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly cardPlusPin?: InputMaybe<Scalars["Boolean"]>;
  readonly commonArea: Scalars["Boolean"];
  readonly dualAuthority?: InputMaybe<DualAuthorityEnum>;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lateArmDelay: Scalars["Int"];
  readonly lateOutputNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly openClosingReports?: InputMaybe<Scalars["Boolean"]>;
  readonly twoManRule?: InputMaybe<Scalars["Boolean"]>;
};

export type XrDeviceInformation = DeviceInformation &
  Node & {
    readonly __typename?: "XrDeviceInformation";
    readonly accessAreas: Scalars["String"];
    readonly autoForceArm: Scalars["Boolean"];
    readonly axNumber: Scalars["String"];
    readonly cameraDeviceManufacturer?: Maybe<DeviceInformationCameraDeviceManufacturer>;
    readonly cameraSerialNumber?: Maybe<Scalars["String"]>;
    readonly device734?: Maybe<Device734>;
    readonly deviceCommunicationMethod: DeviceInformationCommType;
    readonly deviceType: DeviceInformationType;
    readonly displayAreas: Scalars["String"];
    readonly door: Scalars["Boolean"];
    readonly doorForceMessages: Scalars["Boolean"];
    readonly doorRealTimeStatusMessages: Scalars["Boolean"];
    readonly egressAreas: Scalars["String"];
    readonly encrypted: Scalars["Boolean"];
    readonly fireExit: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isNew: Scalars["Boolean"];
    readonly lxNumber: Scalars["String"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly osdpReaderDetails?: Maybe<OsdpReaderDetails>;
    readonly osdpReaderProgrammingStatus?: Maybe<OsdpReaderProgrammingStatus>;
    readonly osdpReaderStatusTime: Scalars["Int"];
    readonly overrideScheduleWhenArmed: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly pinDisarm?: Maybe<Scalars["Boolean"]>;
    readonly privateDoor: Scalars["Boolean"];
    readonly publicDoor: Scalars["Boolean"];
    readonly remoteProgram734: Scalars["Boolean"];
    readonly serialNumber: Scalars["String"];
    readonly strikeDelay: Scalars["Int"];
    readonly strikeTime: Scalars["Int"];
    readonly supervisionTime?: Maybe<DeviceInformationWirelessSupervisionTime>;
    readonly tipe: Scalars["String"];
    readonly tracked: Scalars["Boolean"];
    readonly triggerOutputGroupWithAccess: Scalars["Boolean"];
    readonly wirelessTranslator1100t: Scalars["Boolean"];
    readonly wirelessTranslator1100tFrequency: DeviceInformation1100TWirelessFrequencyType;
  };

export type XrDeviceInformationOsdpReaderDetailsArgs = {
  address?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["Int"]>;
};

export type XrDeviceInformationInput = {
  readonly accessAreas?: InputMaybe<Scalars["String"]>;
  readonly autoForceArm: Scalars["Boolean"];
  readonly axNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraDeviceManufacturer?: InputMaybe<DeviceInformationCameraDeviceManufacturer>;
  readonly cameraSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly device734?: InputMaybe<Device734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly displayAreas?: InputMaybe<Scalars["String"]>;
  readonly doorForceMessages: Scalars["Boolean"];
  readonly doorRealTimeStatusMessages: Scalars["Boolean"];
  readonly egressAreas?: InputMaybe<Scalars["String"]>;
  readonly encrypted?: InputMaybe<Scalars["Boolean"]>;
  readonly fireExit: Scalars["Boolean"];
  readonly hasChanges: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed: Scalars["Boolean"];
  readonly pinDisarm?: InputMaybe<Scalars["Boolean"]>;
  readonly privateDoor?: InputMaybe<Scalars["Boolean"]>;
  readonly publicDoor: Scalars["Boolean"];
  readonly remoteProgram734: Scalars["Boolean"];
  readonly serialNumber: Scalars["String"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly triggerOutputGroupWithAccess: Scalars["Boolean"];
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency?: InputMaybe<DeviceInformation1100TWirelessFrequencyType>;
};

export type XrDeviceInput = {
  readonly accessAreas?: InputMaybe<Scalars["String"]>;
  readonly autoForceArm: Scalars["Boolean"];
  readonly axNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraDeviceManufacturer?: InputMaybe<DeviceInformationCameraDeviceManufacturer>;
  readonly cameraSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly device734?: InputMaybe<Device734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly displayAreas?: InputMaybe<Scalars["String"]>;
  readonly doorForceMessages: Scalars["Boolean"];
  readonly doorRealTimeStatusMessages: Scalars["Boolean"];
  readonly egressAreas?: InputMaybe<Scalars["String"]>;
  readonly encrypted?: InputMaybe<Scalars["Boolean"]>;
  readonly fireExit: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed: Scalars["Boolean"];
  readonly pinDisarm?: InputMaybe<Scalars["Boolean"]>;
  readonly privateDoor?: InputMaybe<Scalars["Boolean"]>;
  readonly publicDoor: Scalars["Boolean"];
  readonly remoteProgram734: Scalars["Boolean"];
  readonly serialNumber: Scalars["String"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly triggerOutputGroupWithAccess: Scalars["Boolean"];
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency?: InputMaybe<DeviceInformation1100TWirelessFrequencyType>;
};

export type XrProgrammingTemplateAreaInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateAreaInformation";
    readonly armFirstArea?: Maybe<TemplateFieldBoolean>;
    readonly armedOutputNumber?: Maybe<TemplateFieldString>;
    readonly autoArmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly autoDisarmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly badZonesOption?: Maybe<TemplateFieldBadZonesOption>;
    readonly bankSafeVault?: Maybe<TemplateFieldBoolean>;
    readonly burglaryBellOutputNumber?: Maybe<TemplateFieldString>;
    readonly cardPlusPin?: Maybe<TemplateFieldBoolean>;
    readonly commonArea?: Maybe<TemplateFieldBoolean>;
    readonly dualAuthority?: Maybe<TemplateFieldDualAuthorityEnum>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lateArmDelay?: Maybe<TemplateFieldInt>;
    readonly lateOutputNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly openClosingReports?: Maybe<TemplateFieldBoolean>;
  };

export type XrProgrammingTemplateAreaInformationInput = {
  readonly armFirstArea?: InputMaybe<TemplateFieldBooleanInput>;
  readonly armedOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly autoArmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly autoDisarmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly badZonesOption?: InputMaybe<TemplateFieldBadZonesOptionInput>;
  readonly bankSafeVault?: InputMaybe<TemplateFieldBooleanInput>;
  readonly burglaryBellOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly cardPlusPin?: InputMaybe<TemplateFieldBooleanInput>;
  readonly commonArea?: InputMaybe<TemplateFieldBooleanInput>;
  readonly dualAuthority?: InputMaybe<TemplateFieldDualAuthorityEnumInput>;
  readonly included: Scalars["Boolean"];
  readonly lateArmDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly lateOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly openClosingReports?: InputMaybe<TemplateFieldBooleanInput>;
};

export type XrProgrammingTemplateCardFormat = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateCardFormat";
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly requireSiteCode?: Maybe<TemplateFieldBoolean>;
    readonly siteCode1?: Maybe<TemplateFieldInt>;
    readonly siteCode2?: Maybe<TemplateFieldInt>;
    readonly siteCode3?: Maybe<TemplateFieldInt>;
    readonly siteCode4?: Maybe<TemplateFieldInt>;
    readonly siteCode5?: Maybe<TemplateFieldInt>;
    readonly siteCode6?: Maybe<TemplateFieldInt>;
    readonly siteCode7?: Maybe<TemplateFieldInt>;
    readonly siteCode8?: Maybe<TemplateFieldInt>;
    readonly siteCodeLength?: Maybe<TemplateFieldInt>;
    readonly siteCodePosition?: Maybe<TemplateFieldInt>;
    readonly type?: Maybe<TemplateFieldInt>;
    readonly userCodeDigits?: Maybe<TemplateFieldInt>;
    readonly userCodeLength?: Maybe<TemplateFieldInt>;
    readonly userCodePosition?: Maybe<TemplateFieldInt>;
    readonly wiegandLength?: Maybe<TemplateFieldInt>;
  };

export type XrProgrammingTemplateCardFormatInput = {
  readonly included: Scalars["Boolean"];
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly requireSiteCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly siteCode1?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode2?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode3?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode4?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode5?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode6?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode7?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCode8?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCodeLength?: InputMaybe<TemplateFieldIntInput>;
  readonly siteCodePosition?: InputMaybe<TemplateFieldIntInput>;
  readonly type?: InputMaybe<TemplateFieldIntInput>;
  readonly userCodeDigits?: InputMaybe<TemplateFieldIntInput>;
  readonly userCodeLength?: InputMaybe<TemplateFieldIntInput>;
  readonly userCodePosition?: InputMaybe<TemplateFieldIntInput>;
  readonly wiegandLength?: InputMaybe<TemplateFieldIntInput>;
};

export type XrProgrammingTemplateCommunicationPath = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateCommunicationPath";
    readonly alarmReports?: Maybe<TemplateFieldCommunicationPathAlarmReports>;
    readonly alarmSwitchover?: Maybe<TemplateFieldInt>;
    readonly apn?: Maybe<TemplateFieldString>;
    readonly apn2?: Maybe<TemplateFieldString>;
    readonly checkInMinutes?: Maybe<TemplateFieldInt>;
    readonly commType?: Maybe<TemplateFieldCommunicationPathCommType>;
    readonly communicationsUrl?: Maybe<TemplateFieldString>;
    readonly doorAccessReports?: Maybe<TemplateFieldCommunicationPathDoorAccessReports>;
    readonly duplicateAlarms?: Maybe<TemplateFieldBoolean>;
    readonly encryptionEnabled?: Maybe<TemplateFieldBoolean>;
    readonly encryptionScheme?: Maybe<TemplateFieldCommunicationPathEncryptionScheme>;
    readonly failTestHours?: Maybe<TemplateFieldInt>;
    readonly failTime?: Maybe<TemplateFieldInt>;
    readonly firstPhone?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly number: Scalars["Int"];
    readonly openCloseUserReports?: Maybe<TemplateFieldBoolean>;
    readonly panicTest?: Maybe<TemplateFieldBoolean>;
    readonly protocol?: Maybe<TemplateFieldCommunicationPathProtocol>;
    readonly receiverPort?: Maybe<TemplateFieldString>;
    readonly remoteIP?: Maybe<TemplateFieldString>;
    readonly remoteIPv6?: Maybe<TemplateFieldString>;
    readonly retryTime?: Maybe<TemplateFieldInt>;
    readonly secondLinePrefixFor893A?: Maybe<TemplateFieldString>;
    readonly secondPhone?: Maybe<TemplateFieldString>;
    readonly sendFail?: Maybe<TemplateFieldBoolean>;
    readonly sendPath?: Maybe<TemplateFieldBoolean>;
    readonly substitutionCode?: Maybe<TemplateFieldCommunicationPathSubstitutionCode>;
    readonly supervisoryTroubleReports?: Maybe<TemplateFieldCommunicationPathSupervisoryTroubleReports>;
    readonly testDayOfWeek?: Maybe<TemplateFieldCommunicationPathDayOfWeek>;
    readonly testFrequencyNumber?: Maybe<TemplateFieldInt>;
    readonly testFrequencyUnit?: Maybe<TemplateFieldCommunicationPathTestFrequencyUnit>;
    readonly testReport?: Maybe<TemplateFieldCommunicationPathTestReport>;
    readonly testTime?: Maybe<TemplateFieldString>;
    readonly transmissionDelay?: Maybe<TemplateFieldInt>;
    readonly type?: Maybe<TemplateFieldCommunicationPathType>;
    readonly use893A?: Maybe<TemplateFieldBoolean>;
    readonly useCheckIn?: Maybe<TemplateFieldCommunicationPathUseCheckIn>;
    readonly useCommUrl?: Maybe<TemplateFieldBoolean>;
    readonly useIPv6?: Maybe<TemplateFieldBoolean>;
  };

export type XrProgrammingTemplateCommunicationPathInput = {
  readonly alarmReports?: InputMaybe<TemplateFieldCommunicationPathAlarmReportsInput>;
  readonly alarmSwitchover?: InputMaybe<TemplateFieldIntInput>;
  readonly apn?: InputMaybe<TemplateFieldStringInput>;
  readonly apn2?: InputMaybe<TemplateFieldStringInput>;
  readonly checkInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly commType?: InputMaybe<TemplateFieldCommunicationPathCommTypeInput>;
  readonly communicationsUrl?: InputMaybe<TemplateFieldStringInput>;
  readonly doorAccessReports?: InputMaybe<TemplateFieldCommunicationPathDoorAccessReportsInput>;
  readonly duplicateAlarms?: InputMaybe<TemplateFieldBooleanInput>;
  readonly encryptionEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly encryptionScheme?: InputMaybe<TemplateFieldCommunicationPathEncryptionSchemeInput>;
  readonly failTestHours?: InputMaybe<TemplateFieldIntInput>;
  readonly failTime?: InputMaybe<TemplateFieldIntInput>;
  readonly firstPhone?: InputMaybe<TemplateFieldStringInput>;
  readonly included?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["Int"];
  readonly openCloseUserReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly panicTest?: InputMaybe<TemplateFieldBooleanInput>;
  readonly protocol?: InputMaybe<TemplateFieldCommunicationPathProtocolInput>;
  readonly receiverPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteIP?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteIPv6?: InputMaybe<TemplateFieldStringInput>;
  readonly retryTime?: InputMaybe<TemplateFieldIntInput>;
  readonly secondLinePrefixFor893A?: InputMaybe<TemplateFieldStringInput>;
  readonly secondPhone?: InputMaybe<TemplateFieldStringInput>;
  readonly sendFail?: InputMaybe<TemplateFieldBooleanInput>;
  readonly sendPath?: InputMaybe<TemplateFieldBooleanInput>;
  readonly substitutionCode?: InputMaybe<TemplateFieldCommunicationPathSubstitutionCodeInput>;
  readonly supervisoryTroubleReports?: InputMaybe<TemplateFieldCommunicationPathSupervisoryTroubleReportsInput>;
  readonly testDayOfWeek?: InputMaybe<TemplateFieldCommunicationPathDayOfWeekInput>;
  readonly testFrequencyNumber?: InputMaybe<TemplateFieldIntInput>;
  readonly testFrequencyUnit?: InputMaybe<TemplateFieldCommunicationPathTestFrequencyUnitInput>;
  readonly testReport?: InputMaybe<TemplateFieldCommunicationPathTestReportInput>;
  readonly testTime?: InputMaybe<TemplateFieldStringInput>;
  readonly transmissionDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly type?: InputMaybe<TemplateFieldCommunicationPathTypeInput>;
  readonly use893A?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useCheckIn?: InputMaybe<TemplateFieldCommunicationPathUseCheckInInput>;
  readonly useCommUrl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useIPv6?: InputMaybe<TemplateFieldBooleanInput>;
};

export type XrProgrammingTemplateConcepts = {
  readonly __typename?: "XrProgrammingTemplateConcepts";
  readonly areaInformations?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateAreaInformation>>
  >;
  readonly bellOptions?: Maybe<ProgrammingTemplateBellOptions>;
  readonly cardFormats?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateCardFormat>>
  >;
  readonly communication?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateCommunicationPath>>
  >;
  readonly deviceInformations?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateDeviceInformation>>
  >;
  readonly keyfobs?: Maybe<ReadonlyArray<Maybe<ProgrammingTemplateKeyfob>>>;
  readonly lockoutCode?: Maybe<ProgrammingTemplateLockoutCode>;
  readonly menuDisplay?: Maybe<XrProgrammingTemplateMenuDisplay>;
  readonly networkOptions?: Maybe<ProgrammingTemplateNetworkOptions>;
  readonly outputGroups?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateOutputGroup>>
  >;
  readonly outputInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateOutputInformation>>
  >;
  readonly outputOptions?: Maybe<ProgrammingTemplateOutputOptions>;
  readonly pcLogReports?: Maybe<XrProgrammingTemplatePcLogReports>;
  readonly remoteOptions?: Maybe<XrProgrammingTemplateRemoteOptions>;
  readonly securityGrade?: Maybe<ProgrammingTemplateSecurityGrade>;
  readonly statusListDisplay?: Maybe<XrProgrammingTemplateStatusListDisplay>;
  readonly systemAreaInformation?: Maybe<XrProgrammingTemplateSystemAreaInformation>;
  readonly systemOptions?: Maybe<XrProgrammingTemplateSystemOptions>;
  readonly systemReports?: Maybe<ProgrammingTemplateSystemReports>;
  readonly zoneInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateZoneInformation>>
  >;
};

export type XrProgrammingTemplateConceptsInput = {
  readonly areaInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateAreaInformationInput>>
  >;
  readonly bellOptions?: InputMaybe<ProgrammingTemplateBellOptionsInput>;
  readonly cardFormats?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateCardFormatInput>>
  >;
  readonly communication?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateCommunicationPathInput>>
  >;
  readonly deviceInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateDeviceInformationInput>>
  >;
  readonly keyfobs?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateKeyfobInput>>
  >;
  readonly lockoutCode?: InputMaybe<ProgrammingTemplateLockoutCodeInput>;
  readonly menuDisplay?: InputMaybe<XrProgrammingTemplateMenuDisplayInput>;
  readonly networkOptions?: InputMaybe<ProgrammingTemplateNetworkOptionsInput>;
  readonly outputGroups?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateOutputGroupInput>>
  >;
  readonly outputInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateOutputInformationInput>>
  >;
  readonly outputOptions?: InputMaybe<ProgrammingTemplateOutputOptionsInput>;
  readonly pcLogReports?: InputMaybe<XrProgrammingTemplatePcLogReportsInput>;
  readonly remoteOptions?: InputMaybe<XrProgrammingTemplateRemoteOptionsInput>;
  readonly securityGrade?: InputMaybe<ProgrammingTemplateSecurityGradeInput>;
  readonly statusListDisplay?: InputMaybe<XrProgrammingTemplateStatusListDisplayInput>;
  readonly systemAreaInformation?: InputMaybe<XrProgrammingTemplateSystemAreaInformationInput>;
  readonly systemOptions?: InputMaybe<XrProgrammingTemplateSystemOptionsInput>;
  readonly systemReports?: InputMaybe<ProgrammingTemplateSystemReportsInput>;
  readonly zoneInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateZoneInformationInput>>
  >;
};

export type XrProgrammingTemplateDeviceInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateDeviceInformation";
    readonly accessAreas?: Maybe<TemplateFieldString>;
    readonly autoForceArm?: Maybe<TemplateFieldBoolean>;
    readonly axNumber?: Maybe<TemplateFieldString>;
    readonly device734?: Maybe<TemplateFieldProgrammingTemplateDevice734>;
    readonly deviceCommunicationMethod?: Maybe<TemplateFieldDeviceInformationCommType>;
    readonly deviceType?: Maybe<TemplateFieldDeviceInformationType>;
    readonly displayAreas?: Maybe<TemplateFieldString>;
    readonly doorForceMessages?: Maybe<TemplateFieldBoolean>;
    readonly doorRealTimeStatusMessages?: Maybe<TemplateFieldBoolean>;
    readonly egressAreas?: Maybe<TemplateFieldString>;
    readonly encrypted?: Maybe<TemplateFieldBoolean>;
    readonly fireExit?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lxNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly overrideScheduleWhenArmed?: Maybe<TemplateFieldBoolean>;
    readonly privateDoor?: Maybe<TemplateFieldBoolean>;
    readonly publicDoor?: Maybe<TemplateFieldBoolean>;
    readonly remoteProgram734?: Maybe<TemplateFieldBoolean>;
    readonly strikeDelay?: Maybe<TemplateFieldInt>;
    readonly strikeTime?: Maybe<TemplateFieldInt>;
    readonly supervisionTime?: Maybe<TemplateFieldDeviceInformationWirelessSupervisionTime>;
    readonly triggerOutputGroupWithAccess?: Maybe<TemplateFieldBoolean>;
    readonly wirelessTranslator1100t?: Maybe<TemplateFieldBoolean>;
    readonly wirelessTranslator1100tFrequency?: Maybe<TemplateFieldDeviceInformation1100TWirelessFrequencyType>;
  };

export type XrProgrammingTemplateDeviceInformationInput = {
  readonly accessAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly autoForceArm?: InputMaybe<TemplateFieldBooleanInput>;
  readonly axNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly device734?: InputMaybe<TemplateFieldProgrammingTemplateDevice734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<TemplateFieldDeviceInformationCommTypeInput>;
  readonly deviceType?: InputMaybe<TemplateFieldDeviceInformationTypeInput>;
  readonly displayAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly doorForceMessages?: InputMaybe<TemplateFieldBooleanInput>;
  readonly doorRealTimeStatusMessages?: InputMaybe<TemplateFieldBooleanInput>;
  readonly egressAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly encrypted?: InputMaybe<TemplateFieldBooleanInput>;
  readonly fireExit?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed?: InputMaybe<TemplateFieldBooleanInput>;
  readonly privateDoor?: InputMaybe<TemplateFieldBooleanInput>;
  readonly publicDoor?: InputMaybe<TemplateFieldBooleanInput>;
  readonly remoteProgram734?: InputMaybe<TemplateFieldBooleanInput>;
  readonly strikeDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly strikeTime?: InputMaybe<TemplateFieldIntInput>;
  readonly supervisionTime?: InputMaybe<TemplateFieldDeviceInformationWirelessSupervisionTimeInput>;
  readonly triggerOutputGroupWithAccess?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessTranslator1100t?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessTranslator1100tFrequency?: InputMaybe<TemplateFieldDeviceInformation1100TWirelessFrequencyTypeInput>;
};

export type XrProgrammingTemplateInput = {
  readonly concepts?: InputMaybe<XrProgrammingTemplateConceptsInput>;
  readonly customerId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly hardwareModel: PanelHardwareModel;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly ratePlan?: InputMaybe<Scalars["String"]>;
  readonly receiverCommType?: InputMaybe<Scalars["String"]>;
};

export type XrProgrammingTemplateMenuDisplay = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateMenuDisplay";
    readonly armDisarmDisplayKeypads?: Maybe<TemplateFieldString>;
    readonly armedStatusDisplayKeypads?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly timeDisplayKeypads?: Maybe<TemplateFieldString>;
  };

export type XrProgrammingTemplateMenuDisplayInput = {
  readonly armDisarmDisplayKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly armedStatusDisplayKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly timeDisplayKeypads?: InputMaybe<TemplateFieldStringInput>;
};

export type XrProgrammingTemplateOutputGroup = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateOutputGroup";
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly outputNumber1?: Maybe<TemplateFieldString>;
    readonly outputNumber2?: Maybe<TemplateFieldString>;
    readonly outputNumber3?: Maybe<TemplateFieldString>;
    readonly outputNumber4?: Maybe<TemplateFieldString>;
    readonly outputNumber5?: Maybe<TemplateFieldString>;
    readonly outputNumber6?: Maybe<TemplateFieldString>;
    readonly outputNumber7?: Maybe<TemplateFieldString>;
    readonly outputNumber8?: Maybe<TemplateFieldString>;
  };

export type XrProgrammingTemplateOutputGroupInput = {
  readonly included: Scalars["Boolean"];
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly outputNumber1?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber2?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber3?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber4?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber5?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber6?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber7?: InputMaybe<TemplateFieldStringInput>;
  readonly outputNumber8?: InputMaybe<TemplateFieldStringInput>;
};

export type XrProgrammingTemplatePcLogReports = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplatePcLogReports";
    readonly armDisarmReportsEnabled?: Maybe<TemplateFieldBoolean>;
    readonly doorAccessReportsEnabled?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly logRealTimeStatusEnabled?: Maybe<TemplateFieldBoolean>;
    readonly networkIpAddress?: Maybe<TemplateFieldString>;
    readonly networkPort?: Maybe<TemplateFieldString>;
    readonly supervisoryReportsEnabled?: Maybe<TemplateFieldBoolean>;
    readonly url?: Maybe<TemplateFieldString>;
    readonly useUrl?: Maybe<TemplateFieldBoolean>;
    readonly userCommandReportsEnabled?: Maybe<TemplateFieldBoolean>;
    readonly zonesReportsEnabled?: Maybe<TemplateFieldBoolean>;
  };

export type XrProgrammingTemplatePcLogReportsInput = {
  readonly armDisarmReportsEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly doorAccessReportsEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly logRealTimeStatusEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly networkIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly networkPort?: InputMaybe<TemplateFieldStringInput>;
  readonly supervisoryReportsEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly url?: InputMaybe<TemplateFieldStringInput>;
  readonly useUrl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly userCommandReportsEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly zonesReportsEnabled?: InputMaybe<TemplateFieldBooleanInput>;
};

export type XrProgrammingTemplateRemoteOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateRemoteOptions";
    readonly alarmReceiverAuthorization?: Maybe<TemplateFieldBoolean>;
    readonly allowCellularRemoteProgramming?: Maybe<TemplateFieldBoolean>;
    readonly allowNetworkRemote?: Maybe<TemplateFieldBoolean>;
    readonly appKey?: Maybe<TemplateFieldString>;
    readonly armedAnswerRings?: Maybe<TemplateFieldInt>;
    readonly disarmedAnswerRings?: Maybe<TemplateFieldInt>;
    readonly entreArmDisarmReports?: Maybe<TemplateFieldBoolean>;
    readonly entreBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly entreBackupIpv6Address?: Maybe<TemplateFieldString>;
    readonly entreBackupUrl?: Maybe<TemplateFieldString>;
    readonly entreCheckInMinutes?: Maybe<TemplateFieldInt>;
    readonly entreConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreDoorReports?: Maybe<TemplateFieldBoolean>;
    readonly entreIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreIpAddress?: Maybe<TemplateFieldString>;
    readonly entreIpv6?: Maybe<TemplateFieldBoolean>;
    readonly entreIpv6Address?: Maybe<TemplateFieldString>;
    readonly entreOutgoingPort?: Maybe<TemplateFieldString>;
    readonly entrePassphrase?: Maybe<TemplateFieldString>;
    readonly entreSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly entreUrl?: Maybe<TemplateFieldString>;
    readonly entreUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly entreVideoReports?: Maybe<TemplateFieldBoolean>;
    readonly entreZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly firstApn?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly integratorArmDisarmReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorBackupUrl?: Maybe<TemplateFieldString>;
    readonly integratorCheckInMinutes?: Maybe<TemplateFieldInt>;
    readonly integratorConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorDoorReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorOutgoingPort?: Maybe<TemplateFieldString>;
    readonly integratorPassphrase?: Maybe<TemplateFieldString>;
    readonly integratorSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorUrl?: Maybe<TemplateFieldString>;
    readonly integratorUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorVideoReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly networkProgrammingPort?: Maybe<TemplateFieldString>;
    readonly pcModem?: Maybe<TemplateFieldBoolean>;
    readonly remoteChangesIpAddress?: Maybe<TemplateFieldString>;
    readonly remoteChangesPhoneNumber?: Maybe<TemplateFieldString>;
    readonly remoteChangesPort?: Maybe<TemplateFieldString>;
    readonly remoteDisarm?: Maybe<TemplateFieldBoolean>;
    readonly remoteKey?: Maybe<TemplateFieldString>;
    readonly secondApn?: Maybe<TemplateFieldString>;
    readonly sendLocalChanges?: Maybe<TemplateFieldSendLocalChangesType>;
    readonly serviceReceiverAuthorization?: Maybe<TemplateFieldBoolean>;
    readonly useEntreUrl?: Maybe<TemplateFieldBoolean>;
    readonly useIntegratorUrl?: Maybe<TemplateFieldBoolean>;
    readonly validEntreCheckinMinutes?: Maybe<TemplateFieldString>;
  };

export type XrProgrammingTemplateRemoteOptionsInput = {
  readonly alarmReceiverAuthorization?: InputMaybe<TemplateFieldBooleanInput>;
  readonly allowCellularRemoteProgramming?: InputMaybe<TemplateFieldBooleanInput>;
  readonly allowNetworkRemote?: InputMaybe<TemplateFieldBooleanInput>;
  readonly appKey?: InputMaybe<TemplateFieldStringInput>;
  readonly armedAnswerRings?: InputMaybe<TemplateFieldIntInput>;
  readonly disarmedAnswerRings?: InputMaybe<TemplateFieldIntInput>;
  readonly entreArmDisarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupIpv6Address?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupUrl?: InputMaybe<TemplateFieldStringInput>;
  readonly entreCheckInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly entreConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreDoorReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreIpv6?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreIpv6Address?: InputMaybe<TemplateFieldStringInput>;
  readonly entreOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entrePassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly entreSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreUrl?: InputMaybe<TemplateFieldStringInput>;
  readonly entreUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreVideoReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly firstApn?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly integratorArmDisarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorBackupUrl?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorCheckInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly integratorConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorDoorReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorUrl?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorVideoReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly networkProgrammingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly pcModem?: InputMaybe<TemplateFieldBooleanInput>;
  readonly remoteChangesIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteChangesPhoneNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteChangesPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteDisarm?: InputMaybe<TemplateFieldBooleanInput>;
  readonly remoteKey?: InputMaybe<TemplateFieldStringInput>;
  readonly secondApn?: InputMaybe<TemplateFieldStringInput>;
  readonly sendLocalChanges?: InputMaybe<TemplateFieldSendLocalChangesTypeInput>;
  readonly serviceReceiverAuthorization?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useEntreUrl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useIntegratorUrl?: InputMaybe<TemplateFieldBooleanInput>;
  readonly validEntreCheckinMinutes?: InputMaybe<TemplateFieldStringInput>;
};

export type XrProgrammingTemplateStatusListDisplay = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateStatusListDisplay";
    readonly auxiliary1ZoneKeypads?: Maybe<TemplateFieldString>;
    readonly auxiliary2ZoneKeypads?: Maybe<TemplateFieldString>;
    readonly burglaryZoneKeypads?: Maybe<TemplateFieldString>;
    readonly carbonMonoxideZoneKeypads?: Maybe<TemplateFieldString>;
    readonly commPathTrouble?: Maybe<TemplateFieldCommPathTrouble>;
    readonly emergencyZoneKeypads?: Maybe<TemplateFieldString>;
    readonly fireZoneKeypads?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly panicZoneKeypads?: Maybe<TemplateFieldString>;
    readonly supervisoryZoneKeypads?: Maybe<TemplateFieldString>;
    readonly systemTroubleStatusMonitors?: Maybe<TemplateFieldString>;
  };

export type XrProgrammingTemplateStatusListDisplayInput = {
  readonly auxiliary1ZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly auxiliary2ZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly burglaryZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly carbonMonoxideZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly commPathTrouble?: InputMaybe<TemplateFieldCommPathTroubleInput>;
  readonly emergencyZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly fireZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly panicZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly supervisoryZoneKeypads?: InputMaybe<TemplateFieldStringInput>;
  readonly systemTroubleStatusMonitors?: InputMaybe<TemplateFieldStringInput>;
};

export type XrProgrammingTemplateSystemAreaInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateSystemAreaInformation";
    readonly anyBypass?: Maybe<TemplateFieldBoolean>;
    readonly areaSchedules?: Maybe<TemplateFieldBoolean>;
    readonly closingCheck?: Maybe<TemplateFieldBoolean>;
    readonly closingCode?: Maybe<TemplateFieldBoolean>;
    readonly exitDelay?: Maybe<TemplateFieldInt>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly morningAmbush?: Maybe<TemplateFieldInt>;
  };

export type XrProgrammingTemplateSystemAreaInformationInput = {
  readonly anyBypass?: InputMaybe<TemplateFieldBooleanInput>;
  readonly areaSchedules?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCheck?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly exitDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly included: Scalars["Boolean"];
  readonly morningAmbush?: InputMaybe<TemplateFieldIntInput>;
};

export type XrProgrammingTemplateSystemOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XrProgrammingTemplateSystemOptions";
    readonly allowOwnUserCodeChange?: Maybe<TemplateFieldBoolean>;
    readonly armDisarmActivityDays?: Maybe<TemplateFieldInt>;
    readonly bypassLimit?: Maybe<TemplateFieldInt>;
    readonly captureFormat?: Maybe<TemplateFieldCidFormat>;
    readonly celsius?: Maybe<TemplateFieldBoolean>;
    readonly closingCheck?: Maybe<TemplateFieldBoolean>;
    readonly closingCode?: Maybe<TemplateFieldBoolean>;
    readonly closingWait?: Maybe<TemplateFieldBoolean>;
    readonly crossZoneTime?: Maybe<TemplateFieldInt>;
    readonly detectJam?: Maybe<TemplateFieldBoolean>;
    readonly displayTime?: Maybe<TemplateFieldBoolean>;
    readonly enableKeypadPanicKeys?: Maybe<TemplateFieldBoolean>;
    readonly enhancedZoneTest?: Maybe<TemplateFieldBoolean>;
    readonly entryDelay1?: Maybe<TemplateFieldInt>;
    readonly entryDelay2?: Maybe<TemplateFieldInt>;
    readonly entryDelay3?: Maybe<TemplateFieldInt>;
    readonly entryDelay4?: Maybe<TemplateFieldInt>;
    readonly eolResistorValue?: Maybe<TemplateFieldEolResistorValue>;
    readonly exitDelay?: Maybe<TemplateFieldInt>;
    readonly holdupConfirmationTime?: Maybe<TemplateFieldInt>;
    readonly hoursFromGMT?: Maybe<TemplateFieldInt>;
    readonly houseCode?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly instantArming?: Maybe<TemplateFieldBoolean>;
    readonly intruderConfirmationTime?: Maybe<TemplateFieldInt>;
    readonly iso2CountryCode?: Maybe<TemplateFieldString>;
    readonly keypadArmedLed?: Maybe<TemplateFieldKeypadArmedLed>;
    readonly latchedSupervisoryZones?: Maybe<TemplateFieldBoolean>;
    readonly observeDst?: Maybe<TemplateFieldBoolean>;
    readonly occupiedPremises?: Maybe<TemplateFieldBoolean>;
    readonly panicSupervision?: Maybe<TemplateFieldBoolean>;
    readonly powerFailDelay?: Maybe<TemplateFieldInt>;
    readonly primaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly resetSwingerBypass?: Maybe<TemplateFieldBoolean>;
    readonly secondaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly send16CharacterNames?: Maybe<TemplateFieldBoolean>;
    readonly swingerBypassTrips?: Maybe<TemplateFieldInt>;
    readonly systemType?: Maybe<TemplateFieldSystemType>;
    readonly timeChange?: Maybe<TemplateFieldTimeChange>;
    readonly useBuiltIn1100Wireless?: Maybe<TemplateFieldBoolean>;
    readonly useFalseAlarmQuestion?: Maybe<TemplateFieldBoolean>;
    readonly weatherPostalCode?: Maybe<TemplateFieldString>;
    readonly weatherZipCode?: Maybe<TemplateFieldString>;
    readonly wirelessAudibles?: Maybe<TemplateFieldWirelessAudibles>;
    readonly wirelessEncryption1100?: Maybe<TemplateFieldWirelessEncryption1100>;
    readonly wirelessEncryption1100Passphrase?: Maybe<TemplateFieldString>;
    readonly zoneActivityHours?: Maybe<TemplateFieldInt>;
    readonly zoneRetardDelay?: Maybe<TemplateFieldInt>;
  };

export type XrProgrammingTemplateSystemOptionsInput = {
  readonly allowOwnUserCodeChange?: InputMaybe<TemplateFieldBooleanInput>;
  readonly armDisarmActivityDays?: InputMaybe<TemplateFieldIntInput>;
  readonly bypassLimit?: InputMaybe<TemplateFieldIntInput>;
  readonly captureFormat?: InputMaybe<TemplateFieldCidFormatInput>;
  readonly celsius?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCheck?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingWait?: InputMaybe<TemplateFieldBooleanInput>;
  readonly crossZoneTime?: InputMaybe<TemplateFieldIntInput>;
  readonly detectJam?: InputMaybe<TemplateFieldBooleanInput>;
  readonly displayTime?: InputMaybe<TemplateFieldBooleanInput>;
  readonly enableKeypadPanicKeys?: InputMaybe<TemplateFieldBooleanInput>;
  readonly enhancedZoneTest?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entryDelay1?: InputMaybe<TemplateFieldIntInput>;
  readonly entryDelay2?: InputMaybe<TemplateFieldIntInput>;
  readonly entryDelay3?: InputMaybe<TemplateFieldIntInput>;
  readonly entryDelay4?: InputMaybe<TemplateFieldIntInput>;
  readonly eolResistorValue?: InputMaybe<TemplateFieldEolResistorValueInput>;
  readonly exitDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly holdupConfirmationTime?: InputMaybe<TemplateFieldIntInput>;
  readonly hoursFromGMT?: InputMaybe<TemplateFieldIntInput>;
  readonly houseCode?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly instantArming?: InputMaybe<TemplateFieldBooleanInput>;
  readonly intruderConfirmationTime?: InputMaybe<TemplateFieldIntInput>;
  readonly iso2CountryCode?: InputMaybe<TemplateFieldStringInput>;
  readonly keypadArmedLed?: InputMaybe<TemplateFieldKeypadArmedLedInput>;
  readonly latchedSupervisoryZones?: InputMaybe<TemplateFieldBooleanInput>;
  readonly observeDst?: InputMaybe<TemplateFieldBooleanInput>;
  readonly occupiedPremises?: InputMaybe<TemplateFieldBooleanInput>;
  readonly panicSupervision?: InputMaybe<TemplateFieldBooleanInput>;
  readonly powerFailDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly primaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly primaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly resetSwingerBypass?: InputMaybe<TemplateFieldBooleanInput>;
  readonly secondaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly secondaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly send16CharacterNames?: InputMaybe<TemplateFieldBooleanInput>;
  readonly swingerBypassTrips?: InputMaybe<TemplateFieldIntInput>;
  readonly systemType?: InputMaybe<TemplateFieldSystemTypeInput>;
  readonly timeChange?: InputMaybe<TemplateFieldTimeChangeInput>;
  readonly useBuiltIn1100Wireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useFalseAlarmQuestion?: InputMaybe<TemplateFieldBooleanInput>;
  readonly weatherPostalCode?: InputMaybe<TemplateFieldStringInput>;
  readonly weatherZipCode?: InputMaybe<TemplateFieldStringInput>;
  readonly wirelessAudibles?: InputMaybe<TemplateFieldWirelessAudiblesInput>;
  readonly wirelessEncryption1100?: InputMaybe<TemplateFieldWirelessEncryption1100Input>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly zoneActivityHours?: InputMaybe<TemplateFieldIntInput>;
  readonly zoneRetardDelay?: InputMaybe<TemplateFieldIntInput>;
};

export type XrRemoteOptions = Node &
  RemoteOptions & {
    readonly __typename?: "XrRemoteOptions";
    readonly alarmReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
    readonly allowCellularRemoteProgramming?: Maybe<Scalars["Boolean"]>;
    readonly allowNetworkRemote?: Maybe<Scalars["Boolean"]>;
    readonly appKey?: Maybe<Scalars["String"]>;
    readonly appKeyMaxLength: Scalars["Int"];
    readonly armedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly armedAnswerRingsMax: Scalars["Int"];
    readonly armedAnswerRingsMin: Scalars["Int"];
    readonly disarmedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly disarmedAnswerRingsMax: Scalars["Int"];
    readonly disarmedAnswerRingsMin: Scalars["Int"];
    readonly entreArmDisarmReports?: Maybe<Scalars["Boolean"]>;
    readonly entreBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly entreBackupIpv6Address?: Maybe<Scalars["String"]>;
    readonly entreBackupUrl?: Maybe<Scalars["String"]>;
    readonly entreCheckInMinutes?: Maybe<Scalars["Int"]>;
    readonly entreConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly entreDoorReports?: Maybe<Scalars["Boolean"]>;
    readonly entreIncomingPort?: Maybe<Scalars["String"]>;
    readonly entreIpAddress?: Maybe<Scalars["String"]>;
    readonly entreIpv6?: Maybe<Scalars["Boolean"]>;
    readonly entreIpv6Address?: Maybe<Scalars["String"]>;
    readonly entreOutgoingPort?: Maybe<Scalars["String"]>;
    readonly entrePassphrase?: Maybe<Scalars["String"]>;
    readonly entreSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly entreUrl?: Maybe<Scalars["String"]>;
    readonly entreUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly entreVideoReports?: Maybe<Scalars["Boolean"]>;
    readonly entreZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly firstApn?: Maybe<Scalars["String"]>;
    readonly id: Scalars["ID"];
    readonly integratorArmDisarmReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorBackupUrl?: Maybe<Scalars["String"]>;
    readonly integratorCheckInMinutes?: Maybe<Scalars["Int"]>;
    readonly integratorConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorDoorReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorOutgoingPort?: Maybe<Scalars["String"]>;
    readonly integratorPassphrase?: Maybe<Scalars["String"]>;
    readonly integratorSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorUrl?: Maybe<Scalars["String"]>;
    readonly integratorUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorVideoReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly networkProgrammingPort?: Maybe<Scalars["String"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly pcModem?: Maybe<Scalars["Boolean"]>;
    readonly remoteChangesIpAddress?: Maybe<Scalars["String"]>;
    readonly remoteChangesPhoneNumber?: Maybe<Scalars["String"]>;
    readonly remoteChangesPort?: Maybe<Scalars["String"]>;
    readonly remoteDisarm: Scalars["Boolean"];
    readonly remoteKey: Scalars["String"];
    readonly remoteKeyMaxLength: Scalars["Int"];
    readonly secondApn?: Maybe<Scalars["String"]>;
    readonly sendLocalChanges?: Maybe<SendLocalChangesType>;
    readonly serviceReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
    readonly useEntreBackupUrl?: Maybe<Scalars["Boolean"]>;
    readonly useEntreUrl?: Maybe<Scalars["Boolean"]>;
    readonly useIntegratorBackupUrl?: Maybe<Scalars["Boolean"]>;
    readonly useIntegratorUrl?: Maybe<Scalars["Boolean"]>;
    readonly validEntreCheckinMinutes?: Maybe<Scalars["String"]>;
  };

export type XrRemoteOptionsInput = {
  readonly alarmReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
  readonly allowCellularRemoteProgramming?: InputMaybe<Scalars["Boolean"]>;
  readonly allowNetworkRemote?: InputMaybe<Scalars["Boolean"]>;
  readonly appKey?: InputMaybe<Scalars["String"]>;
  readonly armedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly disarmedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly entreArmDisarmReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreBackupIpv6Address?: InputMaybe<Scalars["String"]>;
  readonly entreBackupUrl?: InputMaybe<Scalars["String"]>;
  readonly entreCheckInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly entreConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly entreDoorReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly entreIpAddress?: InputMaybe<Scalars["String"]>;
  readonly entreIpv6?: InputMaybe<Scalars["Boolean"]>;
  readonly entreIpv6Address?: InputMaybe<Scalars["String"]>;
  readonly entreOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly entrePassphrase?: InputMaybe<Scalars["String"]>;
  readonly entreSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreUrl?: InputMaybe<Scalars["String"]>;
  readonly entreUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreVideoReports?: InputMaybe<Scalars["Boolean"]>;
  readonly entreZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly firstApn?: InputMaybe<Scalars["String"]>;
  readonly integratorArmDisarmReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorBackupUrl?: InputMaybe<Scalars["String"]>;
  readonly integratorCheckInMinutes?: InputMaybe<Scalars["Int"]>;
  readonly integratorConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorDoorReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorPassphrase?: InputMaybe<Scalars["String"]>;
  readonly integratorSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorUrl?: InputMaybe<Scalars["String"]>;
  readonly integratorUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorVideoReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly networkProgrammingPort?: InputMaybe<Scalars["String"]>;
  readonly pcModem?: InputMaybe<Scalars["Boolean"]>;
  readonly remoteChangesIpAddress?: InputMaybe<Scalars["String"]>;
  readonly remoteChangesPhoneNumber?: InputMaybe<Scalars["String"]>;
  readonly remoteChangesPort?: InputMaybe<Scalars["String"]>;
  readonly remoteDisarm?: InputMaybe<Scalars["Boolean"]>;
  readonly secondApn?: InputMaybe<Scalars["String"]>;
  readonly sendLocalChanges?: InputMaybe<SendLocalChangesType>;
  readonly serviceReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
  readonly useEntreUrl?: InputMaybe<Scalars["Boolean"]>;
  readonly useIntegratorUrl?: InputMaybe<Scalars["Boolean"]>;
  readonly validEntreCheckinMinutes?: InputMaybe<Scalars["String"]>;
};

export type XrSystemOptions = Node &
  SystemOptions & {
    readonly __typename?: "XrSystemOptions";
    readonly allowOwnUserCodeChange: Scalars["Boolean"];
    readonly armDisarmActivityDays: Scalars["Int"];
    readonly armDisarmActivityDaysMax: Scalars["Int"];
    readonly armDisarmActivityDaysMin: Scalars["Int"];
    readonly bypassLimit: Scalars["Int"];
    readonly bypassLimitMax: Scalars["Int"];
    readonly bypassLimitMin: Scalars["Int"];
    readonly celsius: Scalars["Boolean"];
    readonly closingCheck: Scalars["Boolean"];
    readonly closingCode: Scalars["Boolean"];
    readonly closingWait: Scalars["Boolean"];
    readonly crossZoneTime: Scalars["Int"];
    readonly crossZoneTimeMax: Scalars["Int"];
    readonly crossZoneTimeMin: Scalars["Int"];
    readonly detectJam: Scalars["Boolean"];
    readonly displayTime: Scalars["Boolean"];
    readonly enableKeypadPanicKeys: Scalars["Boolean"];
    readonly enhancedZoneTest: Scalars["Boolean"];
    readonly entryDelay1: Scalars["Int"];
    readonly entryDelay2: Scalars["Int"];
    readonly entryDelay3: Scalars["Int"];
    readonly entryDelay4: Scalars["Int"];
    readonly entryDelayMax: Scalars["Int"];
    readonly entryDelayMin: Scalars["Int"];
    readonly eolResistorValue: EolResistorValue;
    readonly exitDelay: Scalars["Int"];
    readonly exitDelayMax: Scalars["Int"];
    readonly exitDelayMin: Scalars["Int"];
    readonly holdupConfirmationTime?: Maybe<Scalars["Int"]>;
    readonly hoursFromGMT: Scalars["Int"];
    readonly hoursFromGMTMax: Scalars["Int"];
    readonly hoursFromGMTMin: Scalars["Int"];
    readonly houseCode: Scalars["String"];
    readonly houseCodeMax: Scalars["Int"];
    readonly houseCodeMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly inactiveUserCodeAudit: Scalars["Int"];
    readonly inactiveUserCodeAuditMax: Scalars["Int"];
    readonly inactiveUserCodeAuditMin: Scalars["Int"];
    readonly instantArming: Scalars["Boolean"];
    readonly intruderConfirmationTime?: Maybe<Scalars["Int"]>;
    readonly iso2CountryCode: Scalars["String"];
    readonly keypadArmedLed: KeypadArmedLed;
    readonly latchedSupervisoryZones: Scalars["Boolean"];
    readonly observeDst?: Maybe<Scalars["Boolean"]>;
    readonly occupiedPremises: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly panicSupervision: Scalars["Boolean"];
    readonly powerFailDelay: Scalars["Int"];
    readonly powerFailDelayMax: Scalars["Int"];
    readonly powerFailDelayMin: Scalars["Int"];
    readonly primaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly resetSwingerBypass: Scalars["Boolean"];
    readonly secondaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly send16CharacterNames: Scalars["Boolean"];
    readonly supportsCelsius: Scalars["Boolean"];
    readonly supportsEolResistorField: Scalars["Boolean"];
    readonly supportsInactiveUserCodeAudit: Scalars["Boolean"];
    readonly supportsWirelessEncryption: Scalars["Boolean"];
    readonly supportsZoneActivityHours: Scalars["Boolean"];
    readonly swingerBypassTrips: Scalars["Int"];
    readonly swingerBypassTripsMax: Scalars["Int"];
    readonly swingerBypassTripsMin: Scalars["Int"];
    readonly systemType: SystemType;
    readonly timeChange: AllowTimeChange;
    readonly useBuiltIn1100Wireless: Scalars["Boolean"];
    readonly useFalseAlarmQuestion: Scalars["Boolean"];
    readonly weatherPostalCode: Scalars["String"];
    readonly weatherZipCode: Scalars["String"];
    readonly wirelessAudibles?: Maybe<WirelessAudibles>;
    readonly wirelessEncryption1100: WirelessEncryption1100;
    readonly wirelessEncryption1100Passphrase: Scalars["String"];
    readonly zoneActivityHours: Scalars["Int"];
    readonly zoneActivityHoursMax: Scalars["Int"];
    readonly zoneActivityHoursMin: Scalars["Int"];
    readonly zoneRetardDelay: Scalars["Int"];
    readonly zoneRetardDelayMax: Scalars["Int"];
    readonly zoneRetardDelayMin?: Maybe<Scalars["Int"]>;
  };

export type XrSystemOptionsInput = {
  readonly allowOwnUserCodeChange?: InputMaybe<Scalars["Boolean"]>;
  readonly armDisarmActivityDays?: InputMaybe<Scalars["Int"]>;
  readonly bypassLimit?: InputMaybe<Scalars["Int"]>;
  readonly celsius?: InputMaybe<Scalars["Boolean"]>;
  readonly closingCheck?: InputMaybe<Scalars["Boolean"]>;
  readonly closingCode?: InputMaybe<Scalars["Boolean"]>;
  readonly closingWait?: InputMaybe<Scalars["Boolean"]>;
  readonly crossZoneTime?: InputMaybe<Scalars["Int"]>;
  readonly detectJam?: InputMaybe<Scalars["Boolean"]>;
  readonly displayTime?: InputMaybe<Scalars["Boolean"]>;
  readonly enableKeypadPanicKeys?: InputMaybe<Scalars["Boolean"]>;
  readonly enhancedZoneTest?: InputMaybe<Scalars["Boolean"]>;
  readonly entryDelay1?: InputMaybe<Scalars["Int"]>;
  readonly entryDelay2?: InputMaybe<Scalars["Int"]>;
  readonly entryDelay3?: InputMaybe<Scalars["Int"]>;
  readonly entryDelay4?: InputMaybe<Scalars["Int"]>;
  readonly eolResistorValue?: InputMaybe<EolResistorValue>;
  readonly exitDelay?: InputMaybe<Scalars["Int"]>;
  readonly holdupConfirmationTime?: InputMaybe<Scalars["Int"]>;
  readonly hoursFromGMT?: InputMaybe<Scalars["Int"]>;
  readonly houseCode?: InputMaybe<Scalars["String"]>;
  readonly inactiveUserCodeAudit?: InputMaybe<Scalars["Int"]>;
  readonly instantArming?: InputMaybe<Scalars["Boolean"]>;
  readonly intruderConfirmationTime?: InputMaybe<Scalars["Int"]>;
  readonly iso2CountryCode?: InputMaybe<Scalars["String"]>;
  readonly keypadArmedLed?: InputMaybe<KeypadArmedLed>;
  readonly latchedSupervisoryZones?: InputMaybe<Scalars["Boolean"]>;
  readonly observeDst?: InputMaybe<Scalars["Boolean"]>;
  readonly occupiedPremises?: InputMaybe<Scalars["Boolean"]>;
  readonly panicSupervision?: InputMaybe<Scalars["Boolean"]>;
  readonly powerFailDelay?: InputMaybe<Scalars["Int"]>;
  readonly primaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly primaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly resetSwingerBypass?: InputMaybe<Scalars["Boolean"]>;
  readonly secondaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly secondaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly send16CharacterNames?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsCelsius?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsEolResistorField?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsInactiveUserCodeAudit?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsWirelessEncryption?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsZoneActivityHours?: InputMaybe<Scalars["Boolean"]>;
  readonly swingerBypassTrips?: InputMaybe<Scalars["Int"]>;
  readonly systemType?: InputMaybe<SystemType>;
  readonly timeChange?: InputMaybe<AllowTimeChange>;
  readonly useBuiltIn1100Wireless?: InputMaybe<Scalars["Boolean"]>;
  readonly useFalseAlarmQuestion?: InputMaybe<Scalars["Boolean"]>;
  readonly weatherPostalCode?: InputMaybe<Scalars["String"]>;
  readonly weatherZipCode?: InputMaybe<Scalars["String"]>;
  readonly wirelessAudibles?: InputMaybe<WirelessAudibles>;
  readonly wirelessEncryption1100?: InputMaybe<WirelessEncryption1100>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<Scalars["String"]>;
  readonly zoneActivityHours?: InputMaybe<Scalars["Int"]>;
  readonly zoneRetardDelay?: InputMaybe<Scalars["Int"]>;
};

export type XrUserCode = Node &
  UserCode & {
    readonly __typename?: "XrUserCode";
    readonly active?: Maybe<Scalars["Boolean"]>;
    readonly code?: Maybe<Scalars["String"]>;
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly credential: Credential;
    readonly credentialId: Scalars["String"];
    readonly expireTime?: Maybe<Scalars["DateTime"]>;
    readonly hasLegacyTempUser: Scalars["Boolean"];
    readonly hasSendToLocks: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly personId?: Maybe<Scalars["String"]>;
    readonly sendToLocks?: Maybe<Scalars["Boolean"]>;
    readonly startDate?: Maybe<Scalars["Date"]>;
    readonly tempDate?: Maybe<Scalars["Date"]>;
    readonly tempUser?: Maybe<Scalars["Boolean"]>;
  };

export type XrUserCodeInput = {
  readonly action: UserCodeAction;
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly credType?: InputMaybe<ReadableCredentialType>;
  readonly customerId?: InputMaybe<Scalars["String"]>;
  readonly deliveryTarget?: InputMaybe<Scalars["String"]>;
  readonly deliveryType?: InputMaybe<DigitalCardDeliveryType>;
  readonly hasAppUser?: InputMaybe<Scalars["Boolean"]>;
  readonly isActive: Scalars["Boolean"];
  readonly isFromInvalidCodeEvent?: InputMaybe<Scalars["Boolean"]>;
  readonly isTemporary: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly personEmail?: InputMaybe<Scalars["String"]>;
  readonly personId?: InputMaybe<Scalars["String"]>;
  readonly profiles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]>>>;
  readonly sendToLocks?: InputMaybe<Scalars["Boolean"]>;
  readonly tempEndDate?: InputMaybe<Scalars["String"]>;
  readonly tempStartDate?: InputMaybe<Scalars["String"]>;
  readonly userPin?: InputMaybe<Scalars["String"]>;
};

export type Xt75Area = Area &
  Node & {
    readonly __typename?: "Xt75Area";
    readonly armedOutputNumber: Scalars["String"];
    readonly armedStatus: AreaArmedStatusEnum;
    readonly arming: Scalars["Boolean"];
    readonly autoArmEnabled: Scalars["Boolean"];
    readonly autoDisarmEnabled: Scalars["Boolean"];
    readonly badZonesOption: BadZonesOption;
    readonly burglaryBellOutputNumber: Scalars["String"];
    readonly disarming: Scalars["Boolean"];
    readonly hasChanges: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isArmable: Scalars["Boolean"];
    readonly isDisarmable: Scalars["Boolean"];
    readonly isInAlarm: Scalars["Boolean"];
    readonly isNew: Scalars["Boolean"];
    readonly lateArmDelay: Scalars["Int"];
    readonly lateOutputNumber: Scalars["String"];
    readonly maxNameLength: Scalars["Int"];
    readonly maxNumber: Scalars["Int"];
    readonly minNumber: Scalars["Int"];
    readonly name: Scalars["String"];
    readonly number: Scalars["String"];
    readonly numberWithName?: Maybe<Scalars["String"]>;
    readonly openClosingReports: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  };

export type Xt75AreaInput = {
  readonly armedOutputNumber: Scalars["String"];
  readonly autoArmEnabled: Scalars["Boolean"];
  readonly autoDisarmEnabled: Scalars["Boolean"];
  readonly badZonesOption: BadZonesOption;
  readonly burglaryBellOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lateArmDelay: Scalars["Int"];
  readonly lateOutputNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly number: Scalars["String"];
  readonly openClosingReports?: InputMaybe<Scalars["Boolean"]>;
};

export type Xt75DeviceInformation = DeviceInformation &
  Node & {
    readonly __typename?: "Xt75DeviceInformation";
    readonly autoForceArm: Scalars["Boolean"];
    readonly axNumber: Scalars["String"];
    readonly cameraDeviceManufacturer?: Maybe<DeviceInformationCameraDeviceManufacturer>;
    readonly cameraSerialNumber?: Maybe<Scalars["String"]>;
    readonly device734?: Maybe<Device734>;
    readonly deviceCommunicationMethod: DeviceInformationCommType;
    readonly deviceType: DeviceInformationType;
    readonly displayAreas: Scalars["String"];
    readonly door: Scalars["Boolean"];
    readonly doorForceMessages: Scalars["Boolean"];
    readonly doorRealTimeStatusMessages: Scalars["Boolean"];
    readonly fireExit: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isNew: Scalars["Boolean"];
    readonly lxNumber: Scalars["String"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly osdpReaderDetails?: Maybe<OsdpReaderDetails>;
    readonly osdpReaderProgrammingStatus?: Maybe<OsdpReaderProgrammingStatus>;
    readonly osdpReaderStatusTime: Scalars["Int"];
    readonly overrideScheduleWhenArmed: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly publicDoor: Scalars["Boolean"];
    readonly remoteProgram734: Scalars["Boolean"];
    readonly serialNumber: Scalars["String"];
    readonly strikeDelay: Scalars["Int"];
    readonly strikeTime: Scalars["Int"];
    readonly supervisionTime?: Maybe<DeviceInformationWirelessSupervisionTime>;
    readonly tipe: Scalars["String"];
    readonly tracked: Scalars["Boolean"];
    readonly wirelessTranslator1100t: Scalars["Boolean"];
    readonly wirelessTranslator1100tFrequency: DeviceInformation1100TWirelessFrequencyType;
  };

export type Xt75DeviceInformationOsdpReaderDetailsArgs = {
  address?: InputMaybe<Scalars["String"]>;
  index?: InputMaybe<Scalars["Int"]>;
};

export type Xt75DeviceInformationInput = {
  readonly axNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraDeviceManufacturer?: InputMaybe<DeviceInformationCameraDeviceManufacturer>;
  readonly cameraSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly device734?: InputMaybe<Device734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly displayAreas?: InputMaybe<Scalars["String"]>;
  readonly doorForceMessages: Scalars["Boolean"];
  readonly doorRealTimeStatusMessages: Scalars["Boolean"];
  readonly encrypted?: InputMaybe<Scalars["Boolean"]>;
  readonly fireExit: Scalars["Boolean"];
  readonly hasChanges: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed: Scalars["Boolean"];
  readonly publicDoor: Scalars["Boolean"];
  readonly remoteProgram734: Scalars["Boolean"];
  readonly serialNumber: Scalars["String"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency?: InputMaybe<DeviceInformation1100TWirelessFrequencyType>;
};

export type Xt75DeviceInput = {
  readonly axNumber?: InputMaybe<Scalars["String"]>;
  readonly cameraDeviceManufacturer?: InputMaybe<DeviceInformationCameraDeviceManufacturer>;
  readonly cameraSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly device734?: InputMaybe<Device734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<DeviceInformationCommType>;
  readonly deviceType: DeviceInformationType;
  readonly displayAreas?: InputMaybe<Scalars["String"]>;
  readonly doorForceMessages: Scalars["Boolean"];
  readonly doorRealTimeStatusMessages: Scalars["Boolean"];
  readonly encrypted?: InputMaybe<Scalars["Boolean"]>;
  readonly fireExit: Scalars["Boolean"];
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<Scalars["String"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed: Scalars["Boolean"];
  readonly publicDoor: Scalars["Boolean"];
  readonly remoteProgram734: Scalars["Boolean"];
  readonly serialNumber: Scalars["String"];
  readonly strikeDelay: Scalars["Int"];
  readonly strikeTime: Scalars["Int"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency?: InputMaybe<DeviceInformation1100TWirelessFrequencyType>;
};

export type Xt75ProgrammingTemplateAreaInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "Xt75ProgrammingTemplateAreaInformation";
    readonly armedOutputNumber?: Maybe<TemplateFieldString>;
    readonly autoArmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly autoDisarmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly badZonesOption?: Maybe<TemplateFieldBadZonesOption>;
    readonly burglaryBellOutputNumber?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lateArmDelay?: Maybe<TemplateFieldInt>;
    readonly lateOutputNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly openClosingReports?: Maybe<TemplateFieldBoolean>;
  };

export type Xt75ProgrammingTemplateAreaInformationInput = {
  readonly armedOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly autoArmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly autoDisarmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly badZonesOption?: InputMaybe<TemplateFieldBadZonesOptionInput>;
  readonly burglaryBellOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly lateArmDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly lateOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly openClosingReports?: InputMaybe<TemplateFieldBooleanInput>;
};

export type Xt75ProgrammingTemplateConcepts = {
  readonly __typename?: "Xt75ProgrammingTemplateConcepts";
  readonly areaInformations?: Maybe<
    ReadonlyArray<Maybe<Xt75ProgrammingTemplateAreaInformation>>
  >;
  readonly bellOptions?: Maybe<ProgrammingTemplateBellOptions>;
  readonly cardFormats?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateCardFormat>>
  >;
  readonly communication?: Maybe<
    ReadonlyArray<Maybe<XrProgrammingTemplateCommunicationPath>>
  >;
  readonly deviceInformations?: Maybe<
    ReadonlyArray<Maybe<Xt75ProgrammingTemplateDeviceInformation>>
  >;
  readonly keyfobs?: Maybe<ReadonlyArray<Maybe<ProgrammingTemplateKeyfob>>>;
  readonly lockoutCode?: Maybe<ProgrammingTemplateLockoutCode>;
  readonly networkOptions?: Maybe<ProgrammingTemplateNetworkOptions>;
  readonly outputInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateOutputInformation>>
  >;
  readonly outputOptions?: Maybe<ProgrammingTemplateOutputOptions>;
  readonly remoteOptions?: Maybe<Xt75ProgrammingTemplateRemoteOptions>;
  readonly systemAreaInformation?: Maybe<Xt75ProgrammingTemplateSystemAreaInformation>;
  readonly systemOptions?: Maybe<Xt75ProgrammingTemplateSystemOptions>;
  readonly systemReports?: Maybe<ProgrammingTemplateSystemReports>;
  readonly zoneInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateZoneInformation>>
  >;
};

export type Xt75ProgrammingTemplateConceptsInput = {
  readonly areaInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<Xt75ProgrammingTemplateAreaInformationInput>>
  >;
  readonly bellOptions?: InputMaybe<ProgrammingTemplateBellOptionsInput>;
  readonly cardFormats?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateCardFormatInput>>
  >;
  readonly communication?: InputMaybe<
    ReadonlyArray<InputMaybe<XrProgrammingTemplateCommunicationPathInput>>
  >;
  readonly deviceInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<Xt75ProgrammingTemplateDeviceInformationInput>>
  >;
  readonly keyfobs?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateKeyfobInput>>
  >;
  readonly lockoutCode?: InputMaybe<ProgrammingTemplateLockoutCodeInput>;
  readonly networkOptions?: InputMaybe<ProgrammingTemplateNetworkOptionsInput>;
  readonly outputInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateOutputInformationInput>>
  >;
  readonly outputOptions?: InputMaybe<ProgrammingTemplateOutputOptionsInput>;
  readonly remoteOptions?: InputMaybe<Xt75ProgrammingTemplateRemoteOptionsInput>;
  readonly systemAreaInformation?: InputMaybe<Xt75ProgrammingTemplateSystemAreaInformationInput>;
  readonly systemOptions?: InputMaybe<Xt75ProgrammingTemplateSystemOptionsInput>;
  readonly systemReports?: InputMaybe<ProgrammingTemplateSystemReportsInput>;
  readonly zoneInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateZoneInformationInput>>
  >;
};

export type Xt75ProgrammingTemplateDeviceInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "Xt75ProgrammingTemplateDeviceInformation";
    readonly axNumber?: Maybe<TemplateFieldString>;
    readonly device734?: Maybe<TemplateFieldProgrammingTemplateDevice734>;
    readonly deviceCommunicationMethod?: Maybe<TemplateFieldDeviceInformationCommType>;
    readonly deviceType?: Maybe<TemplateFieldDeviceInformationType>;
    readonly displayAreas?: Maybe<TemplateFieldString>;
    readonly doorForceMessages?: Maybe<TemplateFieldBoolean>;
    readonly doorRealTimeStatusMessages?: Maybe<TemplateFieldBoolean>;
    readonly fireExit?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lxNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
    readonly overrideScheduleWhenArmed?: Maybe<TemplateFieldBoolean>;
    readonly publicDoor?: Maybe<TemplateFieldBoolean>;
    readonly remoteProgram734?: Maybe<TemplateFieldBoolean>;
    readonly strikeDelay?: Maybe<TemplateFieldInt>;
    readonly strikeTime?: Maybe<TemplateFieldInt>;
    readonly supervisionTime?: Maybe<TemplateFieldDeviceInformationWirelessSupervisionTime>;
    readonly wirelessTranslator1100t?: Maybe<TemplateFieldBoolean>;
    readonly wirelessTranslator1100tFrequency?: Maybe<TemplateFieldDeviceInformation1100TWirelessFrequencyType>;
  };

export type Xt75ProgrammingTemplateDeviceInformationInput = {
  readonly axNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly device734?: InputMaybe<TemplateFieldProgrammingTemplateDevice734Input>;
  readonly deviceCommunicationMethod?: InputMaybe<TemplateFieldDeviceInformationCommTypeInput>;
  readonly deviceType?: InputMaybe<TemplateFieldDeviceInformationTypeInput>;
  readonly displayAreas?: InputMaybe<TemplateFieldStringInput>;
  readonly doorForceMessages?: InputMaybe<TemplateFieldBooleanInput>;
  readonly doorRealTimeStatusMessages?: InputMaybe<TemplateFieldBooleanInput>;
  readonly fireExit?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
  readonly overrideScheduleWhenArmed?: InputMaybe<TemplateFieldBooleanInput>;
  readonly publicDoor?: InputMaybe<TemplateFieldBooleanInput>;
  readonly remoteProgram734?: InputMaybe<TemplateFieldBooleanInput>;
  readonly strikeDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly strikeTime?: InputMaybe<TemplateFieldIntInput>;
  readonly supervisionTime?: InputMaybe<TemplateFieldDeviceInformationWirelessSupervisionTimeInput>;
  readonly wirelessTranslator1100t?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessTranslator1100tFrequency?: InputMaybe<TemplateFieldDeviceInformation1100TWirelessFrequencyTypeInput>;
};

export type Xt75ProgrammingTemplateInput = {
  readonly concepts?: InputMaybe<Xt75ProgrammingTemplateConceptsInput>;
  readonly customerId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly hardwareModel: PanelHardwareModel;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly ratePlan?: InputMaybe<Scalars["String"]>;
  readonly receiverCommType?: InputMaybe<Scalars["String"]>;
};

export type Xt75ProgrammingTemplateRemoteOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "Xt75ProgrammingTemplateRemoteOptions";
    readonly appKey?: Maybe<TemplateFieldString>;
    readonly firstApn?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly integratorArmDisarmReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly integratorDoorReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorIncomingPort?: Maybe<TemplateFieldString>;
    readonly integratorIpAddress?: Maybe<TemplateFieldString>;
    readonly integratorOutgoingPort?: Maybe<TemplateFieldString>;
    readonly integratorPassphrase?: Maybe<TemplateFieldString>;
    readonly integratorSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorVideoReports?: Maybe<TemplateFieldBoolean>;
    readonly integratorZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly networkProgrammingPort?: Maybe<TemplateFieldString>;
    readonly remoteDisarm?: Maybe<TemplateFieldBoolean>;
  };

export type Xt75ProgrammingTemplateRemoteOptionsInput = {
  readonly appKey?: InputMaybe<TemplateFieldStringInput>;
  readonly firstApn?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly integratorArmDisarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly integratorDoorReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorPassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly integratorSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorVideoReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly integratorZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly networkProgrammingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteDisarm?: InputMaybe<TemplateFieldBooleanInput>;
};

export type Xt75ProgrammingTemplateSystemAreaInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "Xt75ProgrammingTemplateSystemAreaInformation";
    readonly anyBypass?: Maybe<TemplateFieldBoolean>;
    readonly areaSchedules?: Maybe<TemplateFieldBoolean>;
    readonly burglaryBellOutputNumber?: Maybe<TemplateFieldString>;
    readonly closingCheck?: Maybe<TemplateFieldBoolean>;
    readonly closingCode?: Maybe<TemplateFieldBoolean>;
    readonly exitDelay?: Maybe<TemplateFieldInt>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly openClosingReports?: Maybe<TemplateFieldBoolean>;
  };

export type Xt75ProgrammingTemplateSystemAreaInformationInput = {
  readonly anyBypass?: InputMaybe<TemplateFieldBooleanInput>;
  readonly areaSchedules?: InputMaybe<TemplateFieldBooleanInput>;
  readonly burglaryBellOutputNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly closingCheck?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly exitDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly included: Scalars["Boolean"];
  readonly openClosingReports?: InputMaybe<TemplateFieldBooleanInput>;
};

export type Xt75ProgrammingTemplateSystemOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "Xt75ProgrammingTemplateSystemOptions";
    readonly bypassLimit?: Maybe<TemplateFieldInt>;
    readonly celsius?: Maybe<TemplateFieldBoolean>;
    readonly closingWait?: Maybe<TemplateFieldBoolean>;
    readonly crossZoneTime?: Maybe<TemplateFieldInt>;
    readonly detectJam?: Maybe<TemplateFieldBoolean>;
    readonly displayTime?: Maybe<TemplateFieldBoolean>;
    readonly enableKeypadPanicKeys?: Maybe<TemplateFieldBoolean>;
    readonly entryDelay1?: Maybe<TemplateFieldInt>;
    readonly entryDelay2?: Maybe<TemplateFieldInt>;
    readonly eolResistorValue?: Maybe<TemplateFieldEolResistorValue>;
    readonly hoursFromGMT?: Maybe<TemplateFieldInt>;
    readonly houseCode?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly instantArming?: Maybe<TemplateFieldBoolean>;
    readonly keypadArmedLed?: Maybe<TemplateFieldKeypadArmedLed>;
    readonly latchedSupervisoryZones?: Maybe<TemplateFieldBoolean>;
    readonly observeDst?: Maybe<TemplateFieldBoolean>;
    readonly occupiedPremises?: Maybe<TemplateFieldBoolean>;
    readonly panicSupervision?: Maybe<TemplateFieldBoolean>;
    readonly powerFailDelay?: Maybe<TemplateFieldInt>;
    readonly resetSwingerBypass?: Maybe<TemplateFieldBoolean>;
    readonly swingerBypassTrips?: Maybe<TemplateFieldInt>;
    readonly systemType?: Maybe<TemplateFieldSystemType>;
    readonly timeChange?: Maybe<TemplateFieldTimeChange>;
    readonly useBuiltIn1100Wireless?: Maybe<TemplateFieldBoolean>;
    readonly useFalseAlarmQuestion?: Maybe<TemplateFieldBoolean>;
    readonly weatherPostalCode?: Maybe<TemplateFieldString>;
    readonly weatherZipCode?: Maybe<TemplateFieldString>;
    readonly wirelessAudibles?: Maybe<TemplateFieldWirelessAudibles>;
    readonly wirelessEncryption1100?: Maybe<TemplateFieldWirelessEncryption1100>;
    readonly wirelessEncryption1100Passphrase?: Maybe<TemplateFieldString>;
    readonly zoneActivityHours?: Maybe<TemplateFieldInt>;
  };

export type Xt75ProgrammingTemplateSystemOptionsInput = {
  readonly bypassLimit?: InputMaybe<TemplateFieldIntInput>;
  readonly celsius?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingWait?: InputMaybe<TemplateFieldBooleanInput>;
  readonly crossZoneTime?: InputMaybe<TemplateFieldIntInput>;
  readonly detectJam?: InputMaybe<TemplateFieldBooleanInput>;
  readonly displayTime?: InputMaybe<TemplateFieldBooleanInput>;
  readonly enableKeypadPanicKeys?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entryDelay1?: InputMaybe<TemplateFieldIntInput>;
  readonly entryDelay2?: InputMaybe<TemplateFieldIntInput>;
  readonly eolResistorValue?: InputMaybe<TemplateFieldEolResistorValueInput>;
  readonly hoursFromGMT?: InputMaybe<TemplateFieldIntInput>;
  readonly houseCode?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly instantArming?: InputMaybe<TemplateFieldBooleanInput>;
  readonly keypadArmedLed?: InputMaybe<TemplateFieldKeypadArmedLedInput>;
  readonly latchedSupervisoryZones?: InputMaybe<TemplateFieldBooleanInput>;
  readonly observeDst?: InputMaybe<TemplateFieldBooleanInput>;
  readonly occupiedPremises?: InputMaybe<TemplateFieldBooleanInput>;
  readonly panicSupervision?: InputMaybe<TemplateFieldBooleanInput>;
  readonly powerFailDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly resetSwingerBypass?: InputMaybe<TemplateFieldBooleanInput>;
  readonly swingerBypassTrips?: InputMaybe<TemplateFieldIntInput>;
  readonly systemType?: InputMaybe<TemplateFieldSystemTypeInput>;
  readonly timeChange?: InputMaybe<TemplateFieldTimeChangeInput>;
  readonly useBuiltIn1100Wireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useFalseAlarmQuestion?: InputMaybe<TemplateFieldBooleanInput>;
  readonly weatherPostalCode?: InputMaybe<TemplateFieldStringInput>;
  readonly weatherZipCode?: InputMaybe<TemplateFieldStringInput>;
  readonly wirelessAudibles?: InputMaybe<TemplateFieldWirelessAudiblesInput>;
  readonly wirelessEncryption1100?: InputMaybe<TemplateFieldWirelessEncryption1100Input>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly zoneActivityHours?: InputMaybe<TemplateFieldIntInput>;
};

export type Xt75RemoteOptions = Node &
  RemoteOptions & {
    readonly __typename?: "Xt75RemoteOptions";
    readonly appKey?: Maybe<Scalars["String"]>;
    readonly appKeyMaxLength: Scalars["Int"];
    readonly firstApn?: Maybe<Scalars["String"]>;
    readonly id: Scalars["ID"];
    readonly integratorArmDisarmReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorBackupConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorBackupIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorBackupIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorConnection?: Maybe<RemoteOptionsConnectionType>;
    readonly integratorDoorReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorIncomingPort?: Maybe<Scalars["String"]>;
    readonly integratorIpAddress?: Maybe<Scalars["String"]>;
    readonly integratorOutgoingPort?: Maybe<Scalars["String"]>;
    readonly integratorPassphrase?: Maybe<Scalars["String"]>;
    readonly integratorSupervisoryReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorUserCommandReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorVideoReports?: Maybe<Scalars["Boolean"]>;
    readonly integratorZoneReports?: Maybe<Scalars["Boolean"]>;
    readonly networkProgrammingPort?: Maybe<Scalars["String"]>;
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly remoteDisarm: Scalars["Boolean"];
    readonly remoteKey: Scalars["String"];
    readonly remoteKeyMaxLength: Scalars["Int"];
  };

export type Xt75RemoteOptionsInput = {
  readonly appKey?: InputMaybe<Scalars["String"]>;
  readonly firstApn?: InputMaybe<Scalars["String"]>;
  readonly integratorArmDisarmReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorBackupConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorBackupIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorBackupIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorConnection?: InputMaybe<RemoteOptionsConnectionType>;
  readonly integratorDoorReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorIncomingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorIpAddress?: InputMaybe<Scalars["String"]>;
  readonly integratorOutgoingPort?: InputMaybe<Scalars["String"]>;
  readonly integratorPassphrase?: InputMaybe<Scalars["String"]>;
  readonly integratorSupervisoryReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorUserCommandReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorVideoReports?: InputMaybe<Scalars["Boolean"]>;
  readonly integratorZoneReports?: InputMaybe<Scalars["Boolean"]>;
  readonly networkProgrammingPort?: InputMaybe<Scalars["String"]>;
  readonly remoteDisarm: Scalars["Boolean"];
};

export type Xt75SystemOptions = Node &
  SystemOptions & {
    readonly __typename?: "Xt75SystemOptions";
    readonly bypassLimit: Scalars["Int"];
    readonly bypassLimitMax: Scalars["Int"];
    readonly bypassLimitMin: Scalars["Int"];
    readonly celsius: Scalars["Boolean"];
    readonly closingWait: Scalars["Boolean"];
    readonly crossZoneTime: Scalars["Int"];
    readonly crossZoneTimeMax: Scalars["Int"];
    readonly crossZoneTimeMin: Scalars["Int"];
    readonly detectJam: Scalars["Boolean"];
    readonly enableKeypadPanicKeys: Scalars["Boolean"];
    readonly entryDelay1: Scalars["Int"];
    readonly entryDelay2: Scalars["Int"];
    readonly entryDelayMax: Scalars["Int"];
    readonly entryDelayMin: Scalars["Int"];
    readonly hoursFromGMT: Scalars["Int"];
    readonly hoursFromGMTMax: Scalars["Int"];
    readonly hoursFromGMTMin: Scalars["Int"];
    readonly houseCode: Scalars["String"];
    readonly houseCodeMax: Scalars["Int"];
    readonly houseCodeMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly instantArming: Scalars["Boolean"];
    readonly keypadArmedLed: KeypadArmedLed;
    readonly latchedSupervisoryZones: Scalars["Boolean"];
    readonly observeDst?: Maybe<Scalars["Boolean"]>;
    readonly occupiedPremises: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly panicSupervision: Scalars["Boolean"];
    readonly powerFailDelay: Scalars["Int"];
    readonly powerFailDelayMax: Scalars["Int"];
    readonly powerFailDelayMin: Scalars["Int"];
    readonly primaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly resetSwingerBypass: Scalars["Boolean"];
    readonly secondaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly supportsCelsius: Scalars["Boolean"];
    readonly supportsEolResistorField: Scalars["Boolean"];
    readonly supportsInactiveUserCodeAudit?: Maybe<Scalars["Boolean"]>;
    readonly supportsWirelessEncryption: Scalars["Boolean"];
    readonly supportsZoneActivityHours: Scalars["Boolean"];
    readonly swingerBypassTrips: Scalars["Int"];
    readonly swingerBypassTripsMax: Scalars["Int"];
    readonly swingerBypassTripsMin: Scalars["Int"];
    readonly systemType: SystemType;
    readonly timeChange: AllowTimeChange;
    readonly useBuiltIn1100Wireless: Scalars["Boolean"];
    readonly useFalseAlarmQuestion: Scalars["Boolean"];
    readonly weatherPostalCode: Scalars["String"];
    readonly weatherZipCode: Scalars["String"];
    readonly wirelessAudibles?: Maybe<WirelessAudibles>;
    readonly wirelessEncryption1100: WirelessEncryption1100;
    readonly wirelessEncryption1100Passphrase: Scalars["String"];
    readonly zoneActivityHours: Scalars["Int"];
    readonly zoneActivityHoursMax: Scalars["Int"];
    readonly zoneActivityHoursMin: Scalars["Int"];
  };

export type Xt75SystemOptionsInput = {
  readonly bypassLimit?: InputMaybe<Scalars["Int"]>;
  readonly celsius?: InputMaybe<Scalars["Boolean"]>;
  readonly closingWait?: InputMaybe<Scalars["Boolean"]>;
  readonly crossZoneTime?: InputMaybe<Scalars["Int"]>;
  readonly detectJam?: InputMaybe<Scalars["Boolean"]>;
  readonly enableKeypadPanicKeys?: InputMaybe<Scalars["Boolean"]>;
  readonly entryDelay1?: InputMaybe<Scalars["Int"]>;
  readonly entryDelay2?: InputMaybe<Scalars["Int"]>;
  readonly hoursFromGMT?: InputMaybe<Scalars["Int"]>;
  readonly houseCode?: InputMaybe<Scalars["String"]>;
  readonly instantArming?: InputMaybe<Scalars["Boolean"]>;
  readonly keypadArmedLed?: InputMaybe<KeypadArmedLed>;
  readonly latchedSupervisoryZones?: InputMaybe<Scalars["Boolean"]>;
  readonly observeDst?: InputMaybe<Scalars["Boolean"]>;
  readonly occupiedPremises?: InputMaybe<Scalars["Boolean"]>;
  readonly panicSupervision?: InputMaybe<Scalars["Boolean"]>;
  readonly powerFailDelay?: InputMaybe<Scalars["Int"]>;
  readonly primaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly primaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly resetSwingerBypass?: InputMaybe<Scalars["Boolean"]>;
  readonly secondaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly secondaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly supportsEolResistorField?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsWirelessEncryption?: InputMaybe<Scalars["Boolean"]>;
  readonly supportsZoneActivityHours?: InputMaybe<Scalars["Boolean"]>;
  readonly swingerBypassTrips?: InputMaybe<Scalars["Int"]>;
  readonly systemType?: InputMaybe<SystemType>;
  readonly timeChange?: InputMaybe<AllowTimeChange>;
  readonly useBuiltIn1100Wireless?: InputMaybe<Scalars["Boolean"]>;
  readonly useFalseAlarmQuestion?: InputMaybe<Scalars["Boolean"]>;
  readonly weatherPostalCode?: InputMaybe<Scalars["String"]>;
  readonly weatherZipCode?: InputMaybe<Scalars["String"]>;
  readonly wirelessAudibles?: InputMaybe<WirelessAudibles>;
  readonly wirelessEncryption1100?: InputMaybe<WirelessEncryption1100>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<Scalars["String"]>;
  readonly zoneActivityHours?: InputMaybe<Scalars["Int"]>;
};

export type Xt75UserCode = Node &
  UserCode & {
    readonly __typename?: "Xt75UserCode";
    readonly active?: Maybe<Scalars["Boolean"]>;
    readonly code?: Maybe<Scalars["String"]>;
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly credential: Credential;
    readonly credentialId: Scalars["String"];
    readonly expireTime?: Maybe<Scalars["DateTime"]>;
    readonly hasLegacyTempUser: Scalars["Boolean"];
    readonly hasSendToLocks: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly personId?: Maybe<Scalars["String"]>;
    readonly sendToLocks?: Maybe<Scalars["Boolean"]>;
    readonly startDate?: Maybe<Scalars["Date"]>;
    readonly tempDate?: Maybe<Scalars["Date"]>;
    readonly tempUser?: Maybe<Scalars["Boolean"]>;
  };

export type Xt75UserCodeInput = {
  readonly action: UserCodeAction;
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly credType?: InputMaybe<ReadableCredentialType>;
  readonly customerId?: InputMaybe<Scalars["String"]>;
  readonly deliveryTarget?: InputMaybe<Scalars["String"]>;
  readonly deliveryType?: InputMaybe<DigitalCardDeliveryType>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]>>>;
  readonly hasAppUser?: InputMaybe<Scalars["Boolean"]>;
  readonly isActive: Scalars["Boolean"];
  readonly isFromInvalidCodeEvent?: InputMaybe<Scalars["Boolean"]>;
  readonly isTemporary: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly personEmail?: InputMaybe<Scalars["String"]>;
  readonly personId?: InputMaybe<Scalars["String"]>;
  readonly sendToLocks?: InputMaybe<Scalars["Boolean"]>;
  readonly tempEndDate?: InputMaybe<Scalars["String"]>;
  readonly tempStartDate?: InputMaybe<Scalars["String"]>;
};

export type XtDeviceInformation = DeviceInformation &
  Node & {
    readonly __typename?: "XtDeviceInformation";
    readonly axNumber: Scalars["String"];
    readonly door: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly isNew: Scalars["Boolean"];
    readonly lxNumber: Scalars["String"];
    readonly name: Scalars["String"];
    readonly network: Scalars["Boolean"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly serialNumber: Scalars["String"];
    readonly supervisionTime?: Maybe<DeviceInformationWirelessSupervisionTime>;
    readonly tipe: Scalars["String"];
    readonly tracked: Scalars["Boolean"];
    readonly wireless: Scalars["Boolean"];
    readonly wirelessTranslator1100t: Scalars["Boolean"];
    readonly wirelessTranslator1100tFrequency: DeviceInformation1100TWirelessFrequencyType;
  };

export type XtDeviceInformationInput = {
  readonly axNumber: Scalars["String"];
  readonly door: Scalars["Boolean"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly network: Scalars["Boolean"];
  readonly number: Scalars["Int"];
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly wireless: Scalars["Boolean"];
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency: DeviceInformation1100TWirelessFrequencyType;
};

export type XtDeviceInput = {
  readonly axNumber: Scalars["String"];
  readonly door: Scalars["Boolean"];
  readonly id: Scalars["String"];
  readonly isNew: Scalars["Boolean"];
  readonly lxNumber: Scalars["String"];
  readonly name: Scalars["String"];
  readonly network: Scalars["Boolean"];
  readonly number: Scalars["Int"];
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime?: InputMaybe<DeviceInformationWirelessSupervisionTime>;
  readonly wireless: Scalars["Boolean"];
  readonly wirelessTranslator1100t: Scalars["Boolean"];
  readonly wirelessTranslator1100tFrequency: DeviceInformation1100TWirelessFrequencyType;
};

export type XtProgrammingTemplateAreaInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XtProgrammingTemplateAreaInformation";
    readonly autoArmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly autoDisarmEnabled?: Maybe<TemplateFieldBoolean>;
    readonly badZonesOption?: Maybe<TemplateFieldBadZonesOption>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly name?: Maybe<TemplateFieldString>;
    readonly number: Scalars["Int"];
  };

export type XtProgrammingTemplateAreaInformationInput = {
  readonly autoArmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly autoDisarmEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly badZonesOption?: InputMaybe<TemplateFieldBadZonesOptionInput>;
  readonly included: Scalars["Boolean"];
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly number: Scalars["Int"];
};

export type XtProgrammingTemplateCommunication = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XtProgrammingTemplateCommunication";
    readonly backupCell?: Maybe<TemplateFieldBoolean>;
    readonly backupCheckinMinutes?: Maybe<TemplateFieldInt>;
    readonly backupDialer?: Maybe<TemplateFieldBoolean>;
    readonly backupFailTimeMinutes?: Maybe<TemplateFieldInt>;
    readonly cellApn1?: Maybe<TemplateFieldString>;
    readonly cellApn2?: Maybe<TemplateFieldString>;
    readonly cellTestDays?: Maybe<TemplateFieldInt>;
    readonly checkInMinutes?: Maybe<TemplateFieldInt>;
    readonly comType?: Maybe<TemplateFieldCommunicationComType>;
    readonly dialerTestDays?: Maybe<TemplateFieldInt>;
    readonly encryptionEnabled?: Maybe<TemplateFieldBoolean>;
    readonly failTime?: Maybe<TemplateFieldInt>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly netTrouble?: Maybe<TemplateFieldBoolean>;
    readonly networkTestDays?: Maybe<TemplateFieldInt>;
    readonly receiver1AlarmReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver1Ip?: Maybe<TemplateFieldString>;
    readonly receiver1Ip2?: Maybe<TemplateFieldString>;
    readonly receiver1OpenCloseUserReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver1Port?: Maybe<TemplateFieldString>;
    readonly receiver1Port2?: Maybe<TemplateFieldString>;
    readonly receiver1PrimaryPhoneNumber?: Maybe<TemplateFieldString>;
    readonly receiver1SecondaryPhoneNumber?: Maybe<TemplateFieldString>;
    readonly receiver1SupervisoryTroubleReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver1TestReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver2AlarmReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver2Backup?: Maybe<TemplateFieldBoolean>;
    readonly receiver2Ip?: Maybe<TemplateFieldString>;
    readonly receiver2Ip2?: Maybe<TemplateFieldString>;
    readonly receiver2OpenCloseUserReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver2Port?: Maybe<TemplateFieldString>;
    readonly receiver2Port2?: Maybe<TemplateFieldString>;
    readonly receiver2PrimaryPhoneNumber?: Maybe<TemplateFieldString>;
    readonly receiver2SecondaryPhoneNumber?: Maybe<TemplateFieldString>;
    readonly receiver2SupervisoryTroubleReports?: Maybe<TemplateFieldBoolean>;
    readonly receiver2TestReports?: Maybe<TemplateFieldBoolean>;
    readonly testTime?: Maybe<TemplateFieldString>;
    readonly transmissionDelay?: Maybe<TemplateFieldInt>;
  };

export type XtProgrammingTemplateCommunicationInput = {
  readonly backupCell?: InputMaybe<TemplateFieldBooleanInput>;
  readonly backupCheckinMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly backupDialer?: InputMaybe<TemplateFieldBooleanInput>;
  readonly backupFailTimeMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly cellApn1?: InputMaybe<TemplateFieldStringInput>;
  readonly cellApn2?: InputMaybe<TemplateFieldStringInput>;
  readonly cellTestDays?: InputMaybe<TemplateFieldIntInput>;
  readonly checkInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly comType?: InputMaybe<TemplateFieldCommunicationComTypeInput>;
  readonly dialerTestDays?: InputMaybe<TemplateFieldIntInput>;
  readonly encryptionEnabled?: InputMaybe<TemplateFieldBooleanInput>;
  readonly failTime?: InputMaybe<TemplateFieldIntInput>;
  readonly included: Scalars["Boolean"];
  readonly netTrouble?: InputMaybe<TemplateFieldBooleanInput>;
  readonly networkTestDays?: InputMaybe<TemplateFieldIntInput>;
  readonly receiver1AlarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver1Ip?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1Ip2?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1OpenCloseUserReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver1Port?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1Port2?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1PrimaryPhoneNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1SecondaryPhoneNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver1SupervisoryTroubleReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver1TestReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver2AlarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver2Backup?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver2Ip?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2Ip2?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2OpenCloseUserReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver2Port?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2Port2?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2PrimaryPhoneNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2SecondaryPhoneNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly receiver2SupervisoryTroubleReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly receiver2TestReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly testTime?: InputMaybe<TemplateFieldStringInput>;
  readonly transmissionDelay?: InputMaybe<TemplateFieldIntInput>;
};

export type XtProgrammingTemplateConcepts = {
  readonly __typename?: "XtProgrammingTemplateConcepts";
  readonly areaInformations?: Maybe<
    ReadonlyArray<Maybe<XtProgrammingTemplateAreaInformation>>
  >;
  readonly bellOptions?: Maybe<ProgrammingTemplateBellOptions>;
  readonly communication?: Maybe<XtProgrammingTemplateCommunication>;
  readonly deviceInformations?: Maybe<
    ReadonlyArray<Maybe<XtProgrammingTemplateDeviceInformation>>
  >;
  readonly keyfobs?: Maybe<ReadonlyArray<Maybe<ProgrammingTemplateKeyfob>>>;
  readonly lockoutCode?: Maybe<ProgrammingTemplateLockoutCode>;
  readonly networkOptions?: Maybe<ProgrammingTemplateNetworkOptions>;
  readonly outputInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateOutputInformation>>
  >;
  readonly outputOptions?: Maybe<ProgrammingTemplateOutputOptions>;
  readonly remoteOptions?: Maybe<XtProgrammingTemplateRemoteOptions>;
  readonly securityGrade?: Maybe<ProgrammingTemplateSecurityGrade>;
  readonly systemOptions?: Maybe<XtProgrammingTemplateSystemOptions>;
  readonly systemReports?: Maybe<ProgrammingTemplateSystemReports>;
  readonly zoneInformations?: Maybe<
    ReadonlyArray<Maybe<ProgrammingTemplateZoneInformation>>
  >;
};

export type XtProgrammingTemplateConceptsInput = {
  readonly areaInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XtProgrammingTemplateAreaInformationInput>>
  >;
  readonly bellOptions?: InputMaybe<ProgrammingTemplateBellOptionsInput>;
  readonly communication?: InputMaybe<XtProgrammingTemplateCommunicationInput>;
  readonly deviceInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<XtProgrammingTemplateDeviceInformationInput>>
  >;
  readonly keyfobs?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateKeyfobInput>>
  >;
  readonly lockoutCode?: InputMaybe<ProgrammingTemplateLockoutCodeInput>;
  readonly networkOptions?: InputMaybe<ProgrammingTemplateNetworkOptionsInput>;
  readonly outputInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateOutputInformationInput>>
  >;
  readonly outputOptions?: InputMaybe<ProgrammingTemplateOutputOptionsInput>;
  readonly remoteOptions?: InputMaybe<XtProgrammingTemplateRemoteOptionsInput>;
  readonly securityGrade?: InputMaybe<ProgrammingTemplateSecurityGradeInput>;
  readonly systemOptions?: InputMaybe<XtProgrammingTemplateSystemOptionsInput>;
  readonly systemReports?: InputMaybe<ProgrammingTemplateSystemReportsInput>;
  readonly zoneInformations?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgrammingTemplateZoneInformationInput>>
  >;
};

export type XtProgrammingTemplateDeviceInformation = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XtProgrammingTemplateDeviceInformation";
    readonly axNumber?: Maybe<TemplateFieldString>;
    readonly door?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly lxNumber?: Maybe<TemplateFieldString>;
    readonly name?: Maybe<TemplateFieldString>;
    readonly network?: Maybe<TemplateFieldBoolean>;
    readonly number: Scalars["Int"];
    readonly supervisionTime?: Maybe<TemplateFieldDeviceInformationWirelessSupervisionTime>;
    readonly wireless?: Maybe<TemplateFieldBoolean>;
    readonly wirelessTranslator1100t?: Maybe<TemplateFieldBoolean>;
    readonly wirelessTranslator1100tFrequency?: Maybe<TemplateFieldDeviceInformation1100TWirelessFrequencyType>;
  };

export type XtProgrammingTemplateDeviceInformationInput = {
  readonly axNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly door?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly lxNumber?: InputMaybe<TemplateFieldStringInput>;
  readonly name?: InputMaybe<TemplateFieldStringInput>;
  readonly network?: InputMaybe<TemplateFieldBooleanInput>;
  readonly number: Scalars["Int"];
  readonly supervisionTime?: InputMaybe<TemplateFieldDeviceInformationWirelessSupervisionTimeInput>;
  readonly wireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessTranslator1100t?: InputMaybe<TemplateFieldBooleanInput>;
  readonly wirelessTranslator1100tFrequency?: InputMaybe<TemplateFieldDeviceInformation1100TWirelessFrequencyTypeInput>;
};

export type XtProgrammingTemplateInput = {
  readonly concepts?: InputMaybe<XtProgrammingTemplateConceptsInput>;
  readonly customerId?: InputMaybe<Scalars["ID"]>;
  readonly dealerId: Scalars["ID"];
  readonly hardwareModel: PanelHardwareModel;
  readonly id?: InputMaybe<Scalars["ID"]>;
  readonly isDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly ratePlan?: InputMaybe<Scalars["String"]>;
  readonly receiverCommType?: InputMaybe<Scalars["String"]>;
};

export type XtProgrammingTemplateRemoteOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XtProgrammingTemplateRemoteOptions";
    readonly alarmReceiverAuthorization?: Maybe<TemplateFieldBoolean>;
    readonly appKey?: Maybe<TemplateFieldString>;
    readonly armedAnswerRings?: Maybe<TemplateFieldInt>;
    readonly disarmedAnswerRings?: Maybe<TemplateFieldInt>;
    readonly entreArmDisarmReports?: Maybe<TemplateFieldBoolean>;
    readonly entreBackupConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreBackupIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreBackupIpAddress?: Maybe<TemplateFieldString>;
    readonly entreCheckInMinutes?: Maybe<TemplateFieldInt>;
    readonly entreConnection?: Maybe<TemplateFieldRemoteOptionsConnectionType>;
    readonly entreIncomingPort?: Maybe<TemplateFieldString>;
    readonly entreIpAddress?: Maybe<TemplateFieldString>;
    readonly entreOutgoingPort?: Maybe<TemplateFieldString>;
    readonly entrePassphrase?: Maybe<TemplateFieldString>;
    readonly entreSupervisoryReports?: Maybe<TemplateFieldBoolean>;
    readonly entreUserCommandReports?: Maybe<TemplateFieldBoolean>;
    readonly entreZoneReports?: Maybe<TemplateFieldBoolean>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly networkProgrammingPort?: Maybe<TemplateFieldString>;
    readonly remoteDisarm?: Maybe<TemplateFieldBoolean>;
    readonly serviceReceiverAuthorization?: Maybe<TemplateFieldBoolean>;
    readonly validEntreCheckinMinutes?: Maybe<TemplateFieldString>;
  };

export type XtProgrammingTemplateRemoteOptionsInput = {
  readonly alarmReceiverAuthorization?: InputMaybe<TemplateFieldBooleanInput>;
  readonly appKey?: InputMaybe<TemplateFieldStringInput>;
  readonly armedAnswerRings?: InputMaybe<TemplateFieldIntInput>;
  readonly disarmedAnswerRings?: InputMaybe<TemplateFieldIntInput>;
  readonly entreArmDisarmReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreBackupConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreBackupIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreBackupIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreCheckInMinutes?: InputMaybe<TemplateFieldIntInput>;
  readonly entreConnection?: InputMaybe<TemplateFieldRemoteOptionsConnectionTypeInput>;
  readonly entreIncomingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entreIpAddress?: InputMaybe<TemplateFieldStringInput>;
  readonly entreOutgoingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly entrePassphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly entreSupervisoryReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreUserCommandReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entreZoneReports?: InputMaybe<TemplateFieldBooleanInput>;
  readonly included: Scalars["Boolean"];
  readonly networkProgrammingPort?: InputMaybe<TemplateFieldStringInput>;
  readonly remoteDisarm?: InputMaybe<TemplateFieldBooleanInput>;
  readonly serviceReceiverAuthorization?: InputMaybe<TemplateFieldBooleanInput>;
  readonly validEntreCheckinMinutes?: InputMaybe<TemplateFieldStringInput>;
};

export type XtProgrammingTemplateSystemOptions = Node &
  ProgrammingTemplateConcept & {
    readonly __typename?: "XtProgrammingTemplateSystemOptions";
    readonly armDisarmActivityDays?: Maybe<TemplateFieldInt>;
    readonly captureFormat?: Maybe<TemplateFieldCidFormat>;
    readonly celsius?: Maybe<TemplateFieldBoolean>;
    readonly closingCheck?: Maybe<TemplateFieldBoolean>;
    readonly closingCode?: Maybe<TemplateFieldBoolean>;
    readonly crossZoneTime?: Maybe<TemplateFieldInt>;
    readonly detectJam?: Maybe<TemplateFieldBoolean>;
    readonly displayTime?: Maybe<TemplateFieldBoolean>;
    readonly ecpPartition?: Maybe<TemplateFieldInt>;
    readonly enableKeypadPanicKeys?: Maybe<TemplateFieldBoolean>;
    readonly entryDelay1?: Maybe<TemplateFieldInt>;
    readonly entryDelay2?: Maybe<TemplateFieldInt>;
    readonly eolResistorValue?: Maybe<TemplateFieldEolResistorValue>;
    readonly exitDelay?: Maybe<TemplateFieldInt>;
    readonly hoursFromGMT?: Maybe<TemplateFieldInt>;
    readonly houseCode?: Maybe<TemplateFieldString>;
    readonly id: Scalars["ID"];
    readonly included: Scalars["Boolean"];
    readonly iso2CountryCode?: Maybe<TemplateFieldString>;
    readonly keypadInput?: Maybe<TemplateFieldKeypadInput>;
    readonly observeDst?: Maybe<TemplateFieldBoolean>;
    readonly occupiedPremises?: Maybe<TemplateFieldBoolean>;
    readonly powerFailDelay?: Maybe<TemplateFieldInt>;
    readonly primaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly resetSwingerBypass?: Maybe<TemplateFieldBoolean>;
    readonly secondaryProgrammingLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<TemplateFieldPanelProgrammingLanguage>;
    readonly swingerBypassTrips?: Maybe<TemplateFieldInt>;
    readonly systemType?: Maybe<TemplateFieldSystemType>;
    readonly timeChange?: Maybe<TemplateFieldTimeChange>;
    readonly useBuiltIn1100Wireless?: Maybe<TemplateFieldBoolean>;
    readonly useFalseAlarmQuestion?: Maybe<TemplateFieldBoolean>;
    readonly weatherPostalCode?: Maybe<TemplateFieldString>;
    readonly weatherZipCode?: Maybe<TemplateFieldString>;
    readonly wirelessAudibles?: Maybe<TemplateFieldWirelessAudibles>;
    readonly wirelessEncryption1100?: Maybe<TemplateFieldWirelessEncryption1100>;
    readonly wirelessEncryption1100Passphrase?: Maybe<TemplateFieldString>;
    readonly zoneActivityHours?: Maybe<TemplateFieldInt>;
  };

export type XtProgrammingTemplateSystemOptionsInput = {
  readonly armDisarmActivityDays?: InputMaybe<TemplateFieldIntInput>;
  readonly captureFormat?: InputMaybe<TemplateFieldCidFormatInput>;
  readonly celsius?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCheck?: InputMaybe<TemplateFieldBooleanInput>;
  readonly closingCode?: InputMaybe<TemplateFieldBooleanInput>;
  readonly crossZoneTime?: InputMaybe<TemplateFieldIntInput>;
  readonly detectJam?: InputMaybe<TemplateFieldBooleanInput>;
  readonly displayTime?: InputMaybe<TemplateFieldBooleanInput>;
  readonly ecpPartition?: InputMaybe<TemplateFieldIntInput>;
  readonly enableKeypadPanicKeys?: InputMaybe<TemplateFieldBooleanInput>;
  readonly entryDelay1?: InputMaybe<TemplateFieldIntInput>;
  readonly entryDelay2?: InputMaybe<TemplateFieldIntInput>;
  readonly eolResistorValue?: InputMaybe<TemplateFieldEolResistorValueInput>;
  readonly exitDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly hoursFromGMT?: InputMaybe<TemplateFieldIntInput>;
  readonly houseCode?: InputMaybe<TemplateFieldStringInput>;
  readonly included: Scalars["Boolean"];
  readonly iso2CountryCode?: InputMaybe<TemplateFieldStringInput>;
  readonly keypadInput?: InputMaybe<TemplateFieldKeypadInputInput>;
  readonly observeDst?: InputMaybe<TemplateFieldBooleanInput>;
  readonly occupiedPremises?: InputMaybe<TemplateFieldBooleanInput>;
  readonly powerFailDelay?: InputMaybe<TemplateFieldIntInput>;
  readonly primaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly primaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly resetSwingerBypass?: InputMaybe<TemplateFieldBooleanInput>;
  readonly secondaryProgrammingLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly secondaryUserLanguage?: InputMaybe<TemplateFieldPanelProgrammingLanguageInput>;
  readonly swingerBypassTrips?: InputMaybe<TemplateFieldIntInput>;
  readonly systemType?: InputMaybe<TemplateFieldSystemTypeInput>;
  readonly timeChange?: InputMaybe<TemplateFieldTimeChangeInput>;
  readonly useBuiltIn1100Wireless?: InputMaybe<TemplateFieldBooleanInput>;
  readonly useFalseAlarmQuestion?: InputMaybe<TemplateFieldBooleanInput>;
  readonly weatherPostalCode?: InputMaybe<TemplateFieldStringInput>;
  readonly weatherZipCode?: InputMaybe<TemplateFieldStringInput>;
  readonly wirelessAudibles?: InputMaybe<TemplateFieldWirelessAudiblesInput>;
  readonly wirelessEncryption1100?: InputMaybe<TemplateFieldWirelessEncryption1100Input>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<TemplateFieldStringInput>;
  readonly zoneActivityHours?: InputMaybe<TemplateFieldIntInput>;
};

export type XtRemoteOptions = Node &
  RemoteOptions & {
    readonly __typename?: "XtRemoteOptions";
    readonly alarmReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
    readonly appKey?: Maybe<Scalars["String"]>;
    readonly appKeyMaxLength: Scalars["Int"];
    readonly armedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly armedAnswerRingsMax: Scalars["Int"];
    readonly armedAnswerRingsMin: Scalars["Int"];
    readonly disarmedAnswerRings?: Maybe<Scalars["Int"]>;
    readonly disarmedAnswerRingsMax: Scalars["Int"];
    readonly disarmedAnswerRingsMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly remoteDisarm: Scalars["Boolean"];
    readonly remoteKey: Scalars["String"];
    readonly remoteKeyMaxLength: Scalars["Int"];
    readonly serviceReceiverAuthorization?: Maybe<Scalars["Boolean"]>;
  };

export type XtRemoteOptionsInput = {
  readonly alarmReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
  readonly appKey?: InputMaybe<Scalars["String"]>;
  readonly armedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly disarmedAnswerRings?: InputMaybe<Scalars["String"]>;
  readonly remoteDisarm: Scalars["Boolean"];
  readonly serviceReceiverAuthorization?: InputMaybe<Scalars["Boolean"]>;
};

export type XtSystemOptions = Node &
  SystemOptions & {
    readonly __typename?: "XtSystemOptions";
    readonly armDisarmActivityDays: Scalars["Int"];
    readonly armDisarmActivityDaysMax: Scalars["Int"];
    readonly armDisarmActivityDaysMin: Scalars["Int"];
    readonly captureFormat?: Maybe<CaptureFormat>;
    readonly celsius: Scalars["Boolean"];
    readonly closingCheck: Scalars["Boolean"];
    readonly closingCode: Scalars["Boolean"];
    readonly crossZoneTime: Scalars["Int"];
    readonly crossZoneTimeMax: Scalars["Int"];
    readonly crossZoneTimeMin: Scalars["Int"];
    readonly detectJam: Scalars["Boolean"];
    readonly displayTime: Scalars["Boolean"];
    readonly ecpPartition?: Maybe<Scalars["Int"]>;
    readonly enableKeypadPanicKeys: Scalars["Boolean"];
    readonly entryDelay1: Scalars["Int"];
    readonly entryDelay2: Scalars["Int"];
    readonly entryDelayMax: Scalars["Int"];
    readonly entryDelayMin: Scalars["Int"];
    readonly eolResistorValue: EolResistorValue;
    readonly exitDelay: Scalars["Int"];
    readonly exitDelayMax: Scalars["Int"];
    readonly exitDelayMin: Scalars["Int"];
    readonly hoursFromGMT: Scalars["Int"];
    readonly hoursFromGMTMax: Scalars["Int"];
    readonly hoursFromGMTMin: Scalars["Int"];
    readonly houseCode: Scalars["String"];
    readonly houseCodeMax: Scalars["Int"];
    readonly houseCodeMin: Scalars["Int"];
    readonly id: Scalars["ID"];
    readonly iso2CountryCode: Scalars["String"];
    readonly keypadInput?: Maybe<KeypadInput>;
    readonly observeDst?: Maybe<Scalars["Boolean"]>;
    readonly occupiedPremises: Scalars["Boolean"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly powerFailDelay: Scalars["Int"];
    readonly powerFailDelayMax: Scalars["Int"];
    readonly powerFailDelayMin: Scalars["Int"];
    readonly primaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly primaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly resetSwingerBypass: Scalars["Boolean"];
    readonly secondaryProgrammingLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly secondaryUserLanguage?: Maybe<PanelProgrammingLanguage>;
    readonly supportsEolResistorField: Scalars["Boolean"];
    readonly swingerBypassTrips: Scalars["Int"];
    readonly swingerBypassTripsMax: Scalars["Int"];
    readonly swingerBypassTripsMin: Scalars["Int"];
    readonly systemType: SystemType;
    readonly timeChange: AllowTimeChange;
    readonly useBuiltIn1100Wireless: Scalars["Boolean"];
    readonly useFalseAlarmQuestion: Scalars["Boolean"];
    readonly weatherPostalCode: Scalars["String"];
    readonly weatherZipCode: Scalars["String"];
    readonly wirelessAudibles?: Maybe<WirelessAudibles>;
    readonly wirelessEncryption1100: WirelessEncryption1100;
    readonly wirelessEncryption1100Passphrase: Scalars["String"];
    readonly zoneActivityHours: Scalars["Int"];
    readonly zoneActivityHoursMax: Scalars["Int"];
    readonly zoneActivityHoursMin: Scalars["Int"];
  };

export type XtSystemOptionsInput = {
  readonly armDisarmActivityDays?: InputMaybe<Scalars["Int"]>;
  readonly captureFormat?: InputMaybe<CaptureFormat>;
  readonly celsius?: InputMaybe<Scalars["Boolean"]>;
  readonly closingCheck?: InputMaybe<Scalars["Boolean"]>;
  readonly closingCode?: InputMaybe<Scalars["Boolean"]>;
  readonly crossZoneTime?: InputMaybe<Scalars["Int"]>;
  readonly detectJam?: InputMaybe<Scalars["Boolean"]>;
  readonly displayTime?: InputMaybe<Scalars["Boolean"]>;
  readonly ecpPartition?: InputMaybe<Scalars["Int"]>;
  readonly enableKeypadPanicKeys?: InputMaybe<Scalars["Boolean"]>;
  readonly entryDelay1?: InputMaybe<Scalars["Int"]>;
  readonly entryDelay2?: InputMaybe<Scalars["Int"]>;
  readonly eolResistorValue?: InputMaybe<EolResistorValue>;
  readonly exitDelay?: InputMaybe<Scalars["Int"]>;
  readonly hoursFromGMT?: InputMaybe<Scalars["Int"]>;
  readonly houseCode?: InputMaybe<Scalars["String"]>;
  readonly iso2CountryCode?: InputMaybe<Scalars["String"]>;
  readonly keypadInput?: InputMaybe<KeypadInput>;
  readonly observeDst?: InputMaybe<Scalars["Boolean"]>;
  readonly occupiedPremises?: InputMaybe<Scalars["Boolean"]>;
  readonly powerFailDelay?: InputMaybe<Scalars["Int"]>;
  readonly primaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly primaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly resetSwingerBypass?: InputMaybe<Scalars["Boolean"]>;
  readonly secondaryProgrammingLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly secondaryUserLanguage?: InputMaybe<PanelProgrammingLanguage>;
  readonly swingerBypassTrips?: InputMaybe<Scalars["Int"]>;
  readonly systemType?: InputMaybe<SystemType>;
  readonly timeChange?: InputMaybe<AllowTimeChange>;
  readonly useBuiltIn1100Wireless?: InputMaybe<Scalars["Boolean"]>;
  readonly useFalseAlarmQuestion?: InputMaybe<Scalars["Boolean"]>;
  readonly weatherPostalCode?: InputMaybe<Scalars["String"]>;
  readonly weatherZipCode?: InputMaybe<Scalars["String"]>;
  readonly wirelessAudibles?: InputMaybe<WirelessAudibles>;
  readonly wirelessEncryption1100?: InputMaybe<WirelessEncryption1100>;
  readonly wirelessEncryption1100Passphrase?: InputMaybe<Scalars["String"]>;
  readonly zoneActivityHours?: InputMaybe<Scalars["Int"]>;
};

export type XtUserCode = Node &
  UserCode & {
    readonly __typename?: "XtUserCode";
    readonly active?: Maybe<Scalars["Boolean"]>;
    readonly armOnly?: Maybe<Scalars["Boolean"]>;
    readonly controlSystem?: Maybe<ControlSystem>;
    readonly credential: Credential;
    readonly credentialId: Scalars["String"];
    readonly expireTime?: Maybe<Scalars["DateTime"]>;
    readonly hasSendToLocks: Scalars["Boolean"];
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
    readonly personId?: Maybe<Scalars["String"]>;
    readonly sendToLocks?: Maybe<Scalars["Boolean"]>;
    readonly tempUser?: Maybe<Scalars["Boolean"]>;
    readonly userLevel?: Maybe<UserCodeLevel>;
  };

export type XtUserCodeInput = {
  readonly action: UserCodeAction;
  readonly areas?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]>>>;
  readonly armOnly?: InputMaybe<Scalars["Boolean"]>;
  readonly code?: InputMaybe<Scalars["String"]>;
  readonly credType?: InputMaybe<ReadableCredentialType>;
  readonly credentialId?: InputMaybe<Scalars["String"]>;
  readonly customerId?: InputMaybe<Scalars["String"]>;
  readonly deliveryTarget?: InputMaybe<Scalars["String"]>;
  readonly deliveryType?: InputMaybe<DigitalCardDeliveryType>;
  readonly expireTime?: InputMaybe<Scalars["DateTime"]>;
  readonly hasAppUser?: InputMaybe<Scalars["Boolean"]>;
  readonly inactiveUserAuditDays?: InputMaybe<Scalars["String"]>;
  readonly isActive: Scalars["Boolean"];
  readonly isFromInvalidCodeEvent?: InputMaybe<Scalars["Boolean"]>;
  readonly isTemporary?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
  readonly personEmail?: InputMaybe<Scalars["String"]>;
  readonly personId?: InputMaybe<Scalars["String"]>;
  readonly sendToLocks?: InputMaybe<Scalars["Boolean"]>;
  readonly userLevel?: InputMaybe<UserCodeLevel>;
};

export type XvApiVideoAction = Node &
  VideoAction & {
    readonly __typename?: "XvApiVideoAction";
    readonly areaNumber?: Maybe<Scalars["String"]>;
    readonly cameraId: Scalars["String"];
    readonly cameraType?: Maybe<VideoActionCameraType>;
    readonly deviceNumber?: Maybe<Scalars["String"]>;
    readonly groupId?: Maybe<Scalars["String"]>;
    readonly id: Scalars["ID"];
    readonly name?: Maybe<Scalars["String"]>;
    readonly type: VideoActionType;
    readonly zoneNumber?: Maybe<Scalars["String"]>;
  };

export type XvAudioDevice = Node & {
  readonly __typename?: "XvAudioDevice";
  readonly connectedCameras: ReadonlyArray<Maybe<XvAudioDeviceConnectedCamera>>;
  readonly databaseId: Scalars["String"];
  readonly deviceType: XvAudioDeviceType;
  readonly id: Scalars["ID"];
  readonly ipAddress: Scalars["String"];
  readonly isSiteWide?: Maybe<Scalars["Boolean"]>;
  readonly name?: Maybe<Scalars["String"]>;
  readonly password?: Maybe<Scalars["String"]>;
  readonly strobeTimeSeconds?: Maybe<Scalars["Int"]>;
  readonly useUdp?: Maybe<Scalars["Boolean"]>;
  readonly username?: Maybe<Scalars["String"]>;
};

export type XvAudioDeviceConnectedCamera = {
  readonly __typename?: "XvAudioDeviceConnectedCamera";
  readonly databaseId?: Maybe<Scalars["String"]>;
  readonly name?: Maybe<Scalars["String"]>;
};

export enum XvAudioDeviceResponseErrors {
  FAILED_TO_ADD_AUDIO_DEVICE = "FAILED_TO_ADD_AUDIO_DEVICE",
  FAILED_TO_COMPLETE_ADDING = "FAILED_TO_COMPLETE_ADDING",
  FAILED_TO_COMPLETE_DELETING_CAMERA_AUDIO_DEVICE = "FAILED_TO_COMPLETE_DELETING_CAMERA_AUDIO_DEVICE",
  FAILED_TO_COMPLETE_REFRESHING = "FAILED_TO_COMPLETE_REFRESHING",
  FAILED_TO_COMPLETE_RENAMING = "FAILED_TO_COMPLETE_RENAMING",
  FAILED_TO_COMPLETE_UPDATING_CAMERA_AUDIO_DEVICES = "FAILED_TO_COMPLETE_UPDATING_CAMERA_AUDIO_DEVICES",
  FAILED_TO_COMPLETE_UPDATING_CREDENTIALS = "FAILED_TO_COMPLETE_UPDATING_CREDENTIALS",
  FAILED_TO_DELETE_AUDIO_DEVICE = "FAILED_TO_DELETE_AUDIO_DEVICE",
  FAILED_TO_DELETE_CAMERA_AUDIO_DEVICE = "FAILED_TO_DELETE_CAMERA_AUDIO_DEVICE",
  FAILED_TO_REFRESH_AUDIO_DEVICES = "FAILED_TO_REFRESH_AUDIO_DEVICES",
  FAILED_TO_RENAME_AUDIO_DEVICE = "FAILED_TO_RENAME_AUDIO_DEVICE",
  FAILED_TO_UPDATE_AUDIO_DEVICE_CREDENTIALS = "FAILED_TO_UPDATE_AUDIO_DEVICE_CREDENTIALS",
  FAILED_TO_UPDATE_CAMERA_AUDIO_DEVICES = "FAILED_TO_UPDATE_CAMERA_AUDIO_DEVICES",
  SYSTEM_NOT_FOUND = "SYSTEM_NOT_FOUND",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export enum XvAudioDeviceType {
  ACTIONICS = "ACTIONICS",
  AXIS = "AXIS",
  ONVIF = "ONVIF",
  UNKNOWN = "UNKNOWN",
}

export type Zone = Node & {
  readonly __typename?: "Zone";
  readonly area?: Maybe<Area>;
  readonly armedAreasForArmingZone: Scalars["String"];
  readonly armedOpenActionMessage?: Maybe<ZoneMessage>;
  readonly armedOpenOutputAction?: Maybe<ZoneOutputAction>;
  readonly armedOpenOutputNumber: Scalars["String"];
  readonly armedShortActionMessage?: Maybe<ZoneMessage>;
  readonly armedShortOutputAction?: Maybe<ZoneOutputAction>;
  readonly armedShortOutputNumber: Scalars["String"];
  readonly armingStyle?: Maybe<ZoneArmingStyle>;
  readonly canBypass: Scalars["Boolean"];
  readonly chimeSound?: Maybe<ZoneChimeSound>;
  readonly competitorWireless?: Maybe<Scalars["Boolean"]>;
  readonly contactNumber?: Maybe<ZoneTransmitterContact>;
  readonly controlSystem?: Maybe<ControlSystem>;
  readonly crossZoneEnabled: Scalars["Boolean"];
  readonly disarmedOpenActionMessage?: Maybe<ZoneMessage>;
  readonly disarmedOpenOutputAction?: Maybe<ZoneOutputAction>;
  readonly disarmedOpenOutputNumber?: Maybe<Scalars["String"]>;
  readonly disarmedShortActionMessage?: Maybe<ZoneMessage>;
  readonly disarmedShortOutputAction?: Maybe<ZoneOutputAction>;
  readonly disarmedShortOutputNumber: Scalars["String"];
  readonly entryDelayNumber?: Maybe<ZoneEntryDelayNumber>;
  readonly expanderSerialNumber?: Maybe<Scalars["String"]>;
  readonly fastResponseEnabled: Scalars["Boolean"];
  readonly fireBellOutputNumber?: Maybe<Scalars["String"]>;
  readonly firePanelSlaveInput: Scalars["Boolean"];
  readonly followArea?: Maybe<Area>;
  readonly id: Scalars["ID"];
  readonly is24HrZone: Scalars["Boolean"];
  readonly isECP: Scalars["Boolean"];
  readonly isFaulted: Scalars["Boolean"];
  readonly isNew: Scalars["Boolean"];
  readonly location?: Maybe<Scalars["String"]>;
  readonly lockdownEnabled: Scalars["Boolean"];
  readonly name: Scalars["String"];
  readonly normallyClosed?: Maybe<Scalars["Boolean"]>;
  readonly number: Scalars["String"];
  readonly numberOfEols?: Maybe<ZoneNumberOfEols>;
  readonly panelConfirmation?: Maybe<PanelConfirmationEnum>;
  readonly presignalKeypads?: Maybe<Scalars["String"]>;
  readonly prewarnKeypads: Scalars["String"];
  readonly priorityZone: Scalars["Boolean"];
  readonly realTimeStatusEnabled: Scalars["Boolean"];
  readonly receiverRouting?: Maybe<ZoneReceiverRoute>;
  readonly refreshedStatus?: Maybe<ZoneStatus>;
  readonly remoteZoneType?: Maybe<ZoneRemoteZoneType>;
  readonly reportWithAccountNumberForArea?: Maybe<Area>;
  readonly retardDelayEnabled: Scalars["Boolean"];
  readonly sensorType: ZoneSensorType;
  readonly serialNumber: Scalars["String"];
  readonly status?: Maybe<ZoneStatus>;
  readonly supervisionTime?: Maybe<ZoneSupervisionTime>;
  readonly swingerBypassEnabled: Scalars["Boolean"];
  /** @deprecated Use 'numberOfEols' instead to support the MASKING option */
  readonly tamperEnabled?: Maybe<Scalars["Boolean"]>;
  readonly trafficCountEnabled: Scalars["Boolean"];
  readonly twoButtonPanic?: Maybe<Scalars["Boolean"]>;
  readonly type: ZoneType;
  readonly wireless: Scalars["Boolean"];
  readonly wirelessContactNormallyOpen: Scalars["Boolean"];
  readonly wirelessDisarmDisableEnabled: Scalars["Boolean"];
  readonly wirelessLedEnabled: Scalars["Boolean"];
  readonly wirelessPetImmunity: ZonePetImmunity;
  readonly wirelessPetImmunityEnabledSerialRangeMax: Scalars["Int"];
  readonly wirelessPetImmunityEnabledSerialRangeMin: Scalars["Int"];
  readonly wirelessPirPulseCount?: Maybe<ZonePirPulseCount>;
  readonly wirelessPirPulseCountEnabledSerialRangeMax: Scalars["Int"];
  readonly wirelessPirPulseCountEnabledSerialRangeMin: Scalars["Int"];
  readonly wirelessPirSensitivity?: Maybe<ZonePirSensitivity>;
  readonly wirelessPirSensitivityEnabledSerialRangeMax: Scalars["Int"];
  readonly wirelessPirSensitivityEnabledSerialRangeMin: Scalars["Int"];
  readonly zoneAuditDays: Scalars["String"];
};

export enum ZoneArmingStyle {
  ARM = "ARM",
  DISARM = "DISARM",
  MAINTAIN = "MAINTAIN",
  NONE = "NONE",
  STEP = "STEP",
  TOGGLE = "TOGGLE",
}

export enum ZoneChimeSound {
  ASCEND = "ASCEND",
  DESCEND = "DESCEND",
  DOORBELL = "DOORBELL",
  NONE = "NONE",
  OFF = "OFF",
}

export enum ZoneEntryDelayNumber {
  FOUR = "FOUR",
  ONE = "ONE",
  THREE = "THREE",
  TWO = "TWO",
}

export type ZoneInformationInput = {
  readonly area: Scalars["String"];
  readonly armedAreasForArmingZone: Scalars["String"];
  readonly armedOpenActionMessage: ZoneMessage;
  readonly armedOpenOutputAction: ZoneOutputAction;
  readonly armedOpenOutputNumber: Scalars["String"];
  readonly armedShortActionMessage: ZoneMessage;
  readonly armedShortOutputAction: ZoneOutputAction;
  readonly armedShortOutputNumber: Scalars["String"];
  readonly armingStyle?: InputMaybe<ZoneArmingStyle>;
  readonly chimeSound?: InputMaybe<ZoneChimeSound>;
  readonly competitorWireless?: InputMaybe<Scalars["Boolean"]>;
  readonly contactNumber?: InputMaybe<ZoneTransmitterContact>;
  readonly crossZoneEnabled: Scalars["Boolean"];
  readonly disarmedOpenActionMessage: ZoneMessage;
  readonly disarmedOpenOutputAction: ZoneOutputAction;
  readonly disarmedOpenOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly disarmedShortActionMessage: ZoneMessage;
  readonly disarmedShortOutputAction: ZoneOutputAction;
  readonly disarmedShortOutputNumber: Scalars["String"];
  readonly entryDelayNumber: ZoneEntryDelayNumber;
  readonly expanderSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly fastResponseEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly fireBellOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly firePanelSlaveInput?: InputMaybe<Scalars["Boolean"]>;
  readonly followArea?: InputMaybe<Scalars["String"]>;
  readonly isNew: Scalars["Boolean"];
  readonly keyfobZone?: InputMaybe<Scalars["Boolean"]>;
  readonly location?: InputMaybe<Scalars["String"]>;
  readonly lockdownEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly normallyClosed?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["String"];
  readonly numberOfEols?: InputMaybe<ZoneNumberOfEols>;
  readonly presignalKeypads?: InputMaybe<Scalars["String"]>;
  readonly prewarnKeypads: Scalars["String"];
  readonly priorityZone: Scalars["Boolean"];
  readonly realTimeStatusEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly receiverRouting?: InputMaybe<ZoneReceiverRoute>;
  readonly remoteZoneType?: InputMaybe<ZoneRemoteZoneType>;
  readonly reportWithAccountNumberForArea?: InputMaybe<Scalars["String"]>;
  readonly retardDelayEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly sensorType?: InputMaybe<ZoneSensorType>;
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime: ZoneSupervisionTime;
  readonly swingerBypassEnabled: Scalars["Boolean"];
  readonly tamperEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly trafficCountEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly twoButtonPanic?: InputMaybe<Scalars["Boolean"]>;
  readonly type: ZoneType;
  readonly wireless: Scalars["Boolean"];
  readonly wirelessContactNormallyOpen?: InputMaybe<Scalars["Boolean"]>;
  readonly wirelessDisarmDisableEnabled: Scalars["Boolean"];
  readonly wirelessLedEnabled: Scalars["Boolean"];
  readonly wirelessPetImmunity?: InputMaybe<ZonePetImmunity>;
  readonly wirelessPirPulseCount?: InputMaybe<ZonePirPulseCount>;
  readonly wirelessPirSensitivity?: InputMaybe<ZonePirSensitivity>;
  readonly zoneAuditDays?: InputMaybe<Scalars["String"]>;
};

export enum ZoneMessage {
  ALARM = "ALARM",
  CANCEL_AMBUSH = "CANCEL_AMBUSH",
  DOOR_PROPPED_OPEN = "DOOR_PROPPED_OPEN",
  LOCAL = "LOCAL",
  NONE = "NONE",
  SENSOR_RESET = "SENSOR_RESET",
  TROUBLE = "TROUBLE",
}

export type ZoneMonitorNakError = Error & {
  readonly __typename?: "ZoneMonitorNakError";
  readonly type?: Maybe<ErrorType>;
};

export enum ZoneNumberOfEols {
  NONE = "NONE",
  ONE = "ONE",
  THREE = "THREE",
  TWO = "TWO",
}

export enum ZoneOutputAction {
  FOLLOW = "FOLLOW",
  MOMENTARY = "MOMENTARY",
  NONE = "NONE",
  PULSE = "PULSE",
  STEADY = "STEADY",
}

export enum ZonePetImmunity {
  NONE = "NONE",
  OFF = "OFF",
  ON = "ON",
}

export enum ZonePirPulseCount {
  FOUR = "FOUR",
  NONE = "NONE",
  TWO = "TWO",
}

export enum ZonePirSensitivity {
  HIGH = "HIGH",
  LOW = "LOW",
  NONE = "NONE",
}

export type ZoneProgrammingInput = {
  readonly area: Scalars["String"];
  readonly armedAreasForArmingZone: Scalars["String"];
  readonly armedOpenActionMessage: ZoneMessage;
  readonly armedOpenOutputAction: ZoneOutputAction;
  readonly armedOpenOutputNumber: Scalars["String"];
  readonly armedShortActionMessage: ZoneMessage;
  readonly armedShortOutputAction: ZoneOutputAction;
  readonly armedShortOutputNumber: Scalars["String"];
  readonly armingStyle?: InputMaybe<ZoneArmingStyle>;
  readonly chimeSound?: InputMaybe<ZoneChimeSound>;
  readonly competitorWireless?: InputMaybe<Scalars["Boolean"]>;
  readonly contactNumber?: InputMaybe<ZoneTransmitterContact>;
  readonly crossZoneEnabled: Scalars["Boolean"];
  readonly disarmedOpenActionMessage: ZoneMessage;
  readonly disarmedOpenOutputAction: ZoneOutputAction;
  readonly disarmedOpenOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly disarmedShortActionMessage: ZoneMessage;
  readonly disarmedShortOutputAction: ZoneOutputAction;
  readonly disarmedShortOutputNumber: Scalars["String"];
  readonly entryDelayNumber: ZoneEntryDelayNumber;
  readonly expanderSerialNumber?: InputMaybe<Scalars["String"]>;
  readonly fastResponseEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly fireBellOutputNumber?: InputMaybe<Scalars["String"]>;
  readonly firePanelSlaveInput?: InputMaybe<Scalars["Boolean"]>;
  readonly followArea?: InputMaybe<Scalars["String"]>;
  readonly id: Scalars["ID"];
  readonly isNew: Scalars["Boolean"];
  readonly keyfobZone?: InputMaybe<Scalars["Boolean"]>;
  readonly location?: InputMaybe<Scalars["String"]>;
  readonly lockdownEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly name: Scalars["String"];
  readonly normallyClosed?: InputMaybe<Scalars["Boolean"]>;
  readonly number: Scalars["String"];
  readonly numberOfEols?: InputMaybe<ZoneNumberOfEols>;
  readonly presignalKeypads?: InputMaybe<Scalars["String"]>;
  readonly prewarnKeypads: Scalars["String"];
  readonly priorityZone: Scalars["Boolean"];
  readonly realTimeStatusEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly receiverRouting?: InputMaybe<ZoneReceiverRoute>;
  readonly remoteZoneType?: InputMaybe<ZoneRemoteZoneType>;
  readonly reportWithAccountNumberForArea?: InputMaybe<Scalars["String"]>;
  readonly retardDelayEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly sensorType?: InputMaybe<ZoneSensorType>;
  readonly serialNumber: Scalars["String"];
  readonly supervisionTime: ZoneSupervisionTime;
  readonly swingerBypassEnabled: Scalars["Boolean"];
  readonly tamperEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly trafficCountEnabled?: InputMaybe<Scalars["Boolean"]>;
  readonly twoButtonPanic?: InputMaybe<Scalars["Boolean"]>;
  readonly type: ZoneType;
  readonly wireless: Scalars["Boolean"];
  readonly wirelessContactNormallyOpen?: InputMaybe<Scalars["Boolean"]>;
  readonly wirelessDisarmDisableEnabled: Scalars["Boolean"];
  readonly wirelessLedEnabled: Scalars["Boolean"];
  readonly wirelessPetImmunity?: InputMaybe<ZonePetImmunity>;
  readonly wirelessPirPulseCount?: InputMaybe<ZonePirPulseCount>;
  readonly wirelessPirSensitivity?: InputMaybe<ZonePirSensitivity>;
  readonly zoneAuditDays?: InputMaybe<Scalars["String"]>;
};

export enum ZoneReceiverRoute {
  BOTH_RECEIVERS = "BOTH_RECEIVERS",
  NONE = "NONE",
  NORMAL = "NORMAL",
  RECEIVER_ONE_ONLY = "RECEIVER_ONE_ONLY",
  RECEIVER_TWO_ONLY = "RECEIVER_TWO_ONLY",
}

export enum ZoneRemoteZoneType {
  LOCAL = "LOCAL",
  REMOTE = "REMOTE",
}

export enum ZoneSensorType {
  GLASSBREAK = "GLASSBREAK",
  HOLD_UP = "HOLD_UP",
  PIR_OR_RECESSED_DOOR = "PIR_OR_RECESSED_DOOR",
  REPEATER = "REPEATER",
  SMOKE = "SMOKE",
  UNIVERSAL_TRANSMITTER = "UNIVERSAL_TRANSMITTER",
  UNKNOWN_DEVICE = "UNKNOWN_DEVICE",
  WIRELESS_FOUR_ZONE_EXPANDER = "WIRELESS_FOUR_ZONE_EXPANDER",
  WIRELESS_PIR = "WIRELESS_PIR",
}

export enum ZoneStatus {
  BYPASSED = "BYPASSED",
  DEFAULT = "DEFAULT",
  LOW_BATTERY = "LOW_BATTERY",
  MISSING = "MISSING",
  NORMAL = "NORMAL",
  OPEN = "OPEN",
  SHORT = "SHORT",
  UNKNOWN = "UNKNOWN",
}

export enum ZoneSupervisionTime {
  NONE = "NONE",
  _3_MIN = "_3_MIN",
  _60_MIN = "_60_MIN",
  _240_MIN = "_240_MIN",
  _720_MIN = "_720_MIN",
  _1440_MIN = "_1440_MIN",
}

export enum ZoneTransmitterContact {
  CONTACT_3 = "CONTACT_3",
  CONTACT_4 = "CONTACT_4",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export enum ZoneType {
  ARMING = "ARMING",
  AUXILIARY_1 = "AUXILIARY_1",
  AUXILIARY_2 = "AUXILIARY_2",
  BLANK = "BLANK",
  CARBON_MONOXIDE = "CARBON_MONOXIDE",
  DAY = "DAY",
  DOORBELL = "DOORBELL",
  EMERGENCY = "EMERGENCY",
  EXIT = "EXIT",
  FINAL_EXIT = "FINAL_EXIT",
  FIRE = "FIRE",
  FIRE_VERIFY = "FIRE_VERIFY",
  HOLDUP = "HOLDUP",
  INSTANT = "INSTANT",
  NIGHT = "NIGHT",
  PANIC = "PANIC",
  SUPERVISORY = "SUPERVISORY",
  TAMPER = "TAMPER",
  UNKNOWN = "UNKNOWN",
}

export enum ZoneWirelessCheckinTime {
  NONE = "NONE",
  _10_SEC = "_10_SEC",
  _30_SEC = "_30_SEC",
  _60_SEC = "_60_SEC",
}

export type ZwaveAppliance = Node &
  ZwaveNode & {
    readonly __typename?: "ZwaveAppliance";
    readonly cacheStatus: ZwaveCacheStatus;
    readonly changingName: Scalars["Boolean"];
    readonly currentLevel: Scalars["Int"];
    readonly currentName: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly isDimmer: Scalars["Boolean"];
    readonly level: Scalars["Int"];
    readonly metered: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly nodeSubtype: ZwaveLightApplianceNodeSubtype;
    readonly nodeType: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly on: Scalars["Boolean"];
    readonly settingLevel: Scalars["Boolean"];
  };

export type ZwaveBarrierOperator = Node &
  ZwaveNode & {
    readonly __typename?: "ZwaveBarrierOperator";
    readonly cacheStatus: ZwaveCacheStatus;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly status: ZwaveBarrierOperatorStatus;
  };

export enum ZwaveBarrierOperatorStatus {
  CLOSED = "CLOSED",
  CLOSING = "CLOSING",
  OPEN = "OPEN",
  OPENING = "OPENING",
  STOPPED = "STOPPED",
  UNKNOWN = "UNKNOWN",
}

export enum ZwaveCacheStatus {
  CACHED = "CACHED",
  ERROR = "ERROR",
  PENDING = "PENDING",
}

export type ZwaveLight = Node &
  ZwaveNode & {
    readonly __typename?: "ZwaveLight";
    readonly cacheStatus: ZwaveCacheStatus;
    readonly changingName: Scalars["Boolean"];
    readonly currentLevel: Scalars["Int"];
    readonly currentName: Scalars["String"];
    readonly id: Scalars["ID"];
    readonly isDimmer: Scalars["Boolean"];
    readonly level: Scalars["Int"];
    readonly metered: Scalars["Boolean"];
    readonly name: Scalars["String"];
    readonly nodeSubtype: ZwaveLightApplianceNodeSubtype;
    readonly nodeType: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly on: Scalars["Boolean"];
    readonly settingLevel: Scalars["Boolean"];
  };

export enum ZwaveLightApplianceNodeSubtype {
  BINARY = "BINARY",
  MULTILEVEL = "MULTILEVEL",
}

export type ZwaveLock = Node &
  ZwaveNode & {
    readonly __typename?: "ZwaveLock";
    readonly batteryLevel?: Maybe<Scalars["Int"]>;
    readonly cacheStatus: ZwaveCacheStatus;
    readonly id: Scalars["ID"];
    readonly name: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly status: ZwaveLockStatus;
  };

export enum ZwaveLockStatus {
  LOCKED = "LOCKED",
  UNKNOWN = "UNKNOWN",
  UNLOCKED = "UNLOCKED",
}

export type ZwaveNode = {
  readonly id: Scalars["ID"];
  readonly name: Scalars["String"];
  readonly number: Scalars["Int"];
};

export enum ZwaveNodeStage {
  COMPLETE = "COMPLETE",
  DEVICE_FOUND = "DEVICE_FOUND",
  ERROR = "ERROR",
  INACTIVE = "INACTIVE",
  LISTENING = "LISTENING",
  WAITING_TO_LISTEN = "WAITING_TO_LISTEN",
}

export enum ZwaveNodesTypes {
  ANY = "ANY",
  APPLIANCE = "APPLIANCE",
  BARRIER_OPERATOR = "BARRIER_OPERATOR",
  LIGHT = "LIGHT",
  LOCK = "LOCK",
  THERMOSTAT = "THERMOSTAT",
}

export type ZwaveThermostat = Node &
  ZwaveNode & {
    readonly __typename?: "ZwaveThermostat";
    readonly batteryLevel: Scalars["String"];
    readonly cacheStatus: ZwaveCacheStatus;
    readonly changingName: Scalars["Boolean"];
    readonly currentName: Scalars["String"];
    readonly currentTemperature: Scalars["String"];
    readonly fanMode: ZwaveThermostatFanMode;
    readonly id: Scalars["ID"];
    readonly mode: ZwaveThermostatMode;
    readonly name: Scalars["String"];
    readonly nodeSubtype: Scalars["String"];
    readonly nodeType: Scalars["String"];
    readonly number: Scalars["Int"];
    readonly setpointCooling: Scalars["String"];
    readonly setpointHeating: Scalars["String"];
    readonly settingCoolPoint?: Maybe<Scalars["Boolean"]>;
    readonly settingFanMode?: Maybe<Scalars["Boolean"]>;
    readonly settingHeatPoint?: Maybe<Scalars["Boolean"]>;
    readonly settingMode?: Maybe<Scalars["Boolean"]>;
  };

export enum ZwaveThermostatFanMode {
  AUTO = "AUTO",
  ON = "ON",
}

export enum ZwaveThermostatMode {
  AUTO = "AUTO",
  COOL = "COOL",
  HEAT = "HEAT",
  OFF = "OFF",
}
